var nz = Object.create;
var ki = Object.defineProperty;
var oz = Object.getOwnPropertyDescriptor;
var iz = Object.getOwnPropertyNames;
var sz = Object.getPrototypeOf, az = Object.prototype.hasOwnProperty;
var o = (e, t) => ki(e, "name", { value: t, configurable: !0 }), Di = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy <
"u" ? new Proxy(e, {
  get: (t, r) => (typeof require < "u" ? require : t)[r]
}) : e)(function(e) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + e + '" is not supported');
});
var lz = (e, t) => () => (e && (t = e(e = 0)), t);
var v = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), ft = (e, t) => {
  for (var r in t)
    ki(e, r, { get: t[r], enumerable: !0 });
}, cx = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let i of iz(t))
      !az.call(e, i) && i !== r && ki(e, i, { get: () => t[i], enumerable: !(n = oz(t, i)) || n.enumerable });
  return e;
};
var De = (e, t, r) => (r = e != null ? nz(sz(e)) : {}, cx(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? ki(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), uz = (e) => cx(ki({}, "__esModule", { value: !0 }), e);

// ../node_modules/@ngard/tiny-isequal/index.js
var rC = v((Dg) => {
  Object.defineProperty(Dg, "__esModule", { value: !0 }), Dg.isEqual = /* @__PURE__ */ function() {
    var e = Object.prototype.toString, t = Object.getPrototypeOf, r = Object.getOwnPropertySymbols ? function(n) {
      return Object.keys(n).concat(Object.getOwnPropertySymbols(n));
    } : Object.keys;
    return function(n, i) {
      return (/* @__PURE__ */ o(function s(a, l, u) {
        var c, d, p, y = e.call(a), f = e.call(l);
        if (a === l) return !0;
        if (a == null || l == null) return !1;
        if (u.indexOf(a) > -1 && u.indexOf(l) > -1) return !0;
        if (u.push(a, l), y != f || (c = r(a), d = r(l), c.length != d.length || c.some(function(m) {
          return !s(a[m], l[m], u);
        }))) return !1;
        switch (y.slice(8, -1)) {
          case "Symbol":
            return a.valueOf() == l.valueOf();
          case "Date":
          case "Number":
            return +a == +l || +a != +a && +l != +l;
          case "RegExp":
          case "Function":
          case "String":
          case "Boolean":
            return "" + a == "" + l;
          case "Set":
          case "Map":
            c = a.entries(), d = l.entries();
            do
              if (!s((p = c.next()).value, d.next().value, u)) return !1;
            while (!p.done);
            return !0;
          case "ArrayBuffer":
            a = new Uint8Array(a), l = new Uint8Array(l);
          case "DataView":
            a = new Uint8Array(a.buffer), l = new Uint8Array(l.buffer);
          case "Float32Array":
          case "Float64Array":
          case "Int8Array":
          case "Int16Array":
          case "Int32Array":
          case "Uint8Array":
          case "Uint16Array":
          case "Uint32Array":
          case "Uint8ClampedArray":
          case "Arguments":
          case "Array":
            if (a.length != l.length) return !1;
            for (p = 0; p < a.length; p++) if ((p in a || p in l) && (p in a != p in l || !s(a[p], l[p], u))) return !1;
            return !0;
          case "Object":
            return s(t(a), t(l), u);
          default:
            return !1;
        }
      }, "n"))(n, i, []);
    };
  }();
});

// (disabled):../node_modules/util/util.js
var HC = v(() => {
});

// ../node_modules/min-indent/index.js
var M0 = v((LAe, I0) => {
  "use strict";
  I0.exports = (e) => {
    let t = e.match(/^[ \t]*(?=\S)/gm);
    return t ? t.reduce((r, n) => Math.min(r, n.length), 1 / 0) : 0;
  };
});

// ../node_modules/strip-indent/index.js
var j0 = v((FAe, N0) => {
  "use strict";
  var p9 = M0();
  N0.exports = (e) => {
    let t = p9(e);
    if (t === 0)
      return e;
    let r = new RegExp(`^[ \\t]{${t}}`, "gm");
    return e.replace(r, "");
  };
});

// ../node_modules/indent-string/index.js
var F0 = v((kAe, L0) => {
  "use strict";
  L0.exports = (e, t = 1, r) => {
    if (r = {
      indent: " ",
      includeEmptyLines: !1,
      ...r
    }, typeof e != "string")
      throw new TypeError(
        `Expected \`input\` to be a \`string\`, got \`${typeof e}\``
      );
    if (typeof t != "number")
      throw new TypeError(
        `Expected \`count\` to be a \`number\`, got \`${typeof t}\``
      );
    if (typeof r.indent != "string")
      throw new TypeError(
        `Expected \`options.indent\` to be a \`string\`, got \`${typeof r.indent}\``
      );
    if (t === 0)
      return e;
    let n = r.includeEmptyLines ? /^/gm : /^(?!\s*$)/gm;
    return e.replace(n, r.indent.repeat(t));
  };
});

// ../node_modules/redent/index.js
var AE = v((DAe, k0) => {
  "use strict";
  var f9 = j0(), m9 = F0();
  k0.exports = (e, t = 0, r) => m9(f9(e), t, r);
});

// ../node_modules/aria-query/lib/util/iteratorProxy.js
var dA = v((ou) => {
  "use strict";
  Object.defineProperty(ou, "__esModule", {
    value: !0
  });
  ou.default = void 0;
  function K9() {
    var e = this, t = 0, r = {
      "@@iterator": /* @__PURE__ */ o(function() {
        return r;
      }, "iterator"),
      next: /* @__PURE__ */ o(function() {
        if (t < e.length) {
          var i = e[t];
          return t = t + 1, {
            done: !1,
            value: i
          };
        } else
          return {
            done: !0
          };
      }, "next")
    };
    return r;
  }
  o(K9, "iteratorProxy");
  var wOe = ou.default = K9;
});

// ../node_modules/aria-query/lib/util/iterationDecorator.js
var Bo = v((DE) => {
  "use strict";
  Object.defineProperty(DE, "__esModule", {
    value: !0
  });
  DE.default = Z9;
  var X9 = J9(dA());
  function J9(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(J9, "_interopRequireDefault");
  function kE(e) {
    "@babel/helpers - typeof";
    return kE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, kE(e);
  }
  o(kE, "_typeof");
  function Z9(e, t) {
    return typeof Symbol == "function" && kE(Symbol.iterator) === "symbol" && Object.defineProperty(e, Symbol.iterator, {
      value: X9.default.bind(t)
    }), e;
  }
  o(Z9, "iterationDecorator");
});

// ../node_modules/aria-query/lib/ariaPropsMap.js
var fA = v((iu) => {
  "use strict";
  Object.defineProperty(iu, "__esModule", {
    value: !0
  });
  iu.default = void 0;
  var Q9 = eK(Bo());
  function eK(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(eK, "_interopRequireDefault");
  function $E(e, t) {
    return oK(e) || nK(e, t) || rK(e, t) || tK();
  }
  o($E, "_slicedToArray");
  function tK() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(tK, "_nonIterableRest");
  function rK(e, t) {
    if (e) {
      if (typeof e == "string") return pA(e, t);
      var r = {}.toString.call(e).slice(8, -1);
      return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.
      test(r) ? pA(e, t) : void 0;
    }
  }
  o(rK, "_unsupportedIterableToArray");
  function pA(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  o(pA, "_arrayLikeToArray");
  function nK(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, s, a, l = [], u = !0, c = !1;
      try {
        if (s = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          u = !1;
        } else for (; !(u = (n = s.call(r)).done) && (l.push(n.value), l.length !== t); u = !0) ;
      } catch (d) {
        c = !0, i = d;
      } finally {
        try {
          if (!u && r.return != null && (a = r.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw i;
        }
      }
      return l;
    }
  }
  o(nK, "_iterableToArrayLimit");
  function oK(e) {
    if (Array.isArray(e)) return e;
  }
  o(oK, "_arrayWithHoles");
  var Uo = [["aria-activedescendant", {
    type: "id"
  }], ["aria-atomic", {
    type: "boolean"
  }], ["aria-autocomplete", {
    type: "token",
    values: ["inline", "list", "both", "none"]
  }], ["aria-braillelabel", {
    type: "string"
  }], ["aria-brailleroledescription", {
    type: "string"
  }], ["aria-busy", {
    type: "boolean"
  }], ["aria-checked", {
    type: "tristate"
  }], ["aria-colcount", {
    type: "integer"
  }], ["aria-colindex", {
    type: "integer"
  }], ["aria-colspan", {
    type: "integer"
  }], ["aria-controls", {
    type: "idlist"
  }], ["aria-current", {
    type: "token",
    values: ["page", "step", "location", "date", "time", !0, !1]
  }], ["aria-describedby", {
    type: "idlist"
  }], ["aria-description", {
    type: "string"
  }], ["aria-details", {
    type: "id"
  }], ["aria-disabled", {
    type: "boolean"
  }], ["aria-dropeffect", {
    type: "tokenlist",
    values: ["copy", "execute", "link", "move", "none", "popup"]
  }], ["aria-errormessage", {
    type: "id"
  }], ["aria-expanded", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-flowto", {
    type: "idlist"
  }], ["aria-grabbed", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-haspopup", {
    type: "token",
    values: [!1, !0, "menu", "listbox", "tree", "grid", "dialog"]
  }], ["aria-hidden", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-invalid", {
    type: "token",
    values: ["grammar", !1, "spelling", !0]
  }], ["aria-keyshortcuts", {
    type: "string"
  }], ["aria-label", {
    type: "string"
  }], ["aria-labelledby", {
    type: "idlist"
  }], ["aria-level", {
    type: "integer"
  }], ["aria-live", {
    type: "token",
    values: ["assertive", "off", "polite"]
  }], ["aria-modal", {
    type: "boolean"
  }], ["aria-multiline", {
    type: "boolean"
  }], ["aria-multiselectable", {
    type: "boolean"
  }], ["aria-orientation", {
    type: "token",
    values: ["vertical", "undefined", "horizontal"]
  }], ["aria-owns", {
    type: "idlist"
  }], ["aria-placeholder", {
    type: "string"
  }], ["aria-posinset", {
    type: "integer"
  }], ["aria-pressed", {
    type: "tristate"
  }], ["aria-readonly", {
    type: "boolean"
  }], ["aria-relevant", {
    type: "tokenlist",
    values: ["additions", "all", "removals", "text"]
  }], ["aria-required", {
    type: "boolean"
  }], ["aria-roledescription", {
    type: "string"
  }], ["aria-rowcount", {
    type: "integer"
  }], ["aria-rowindex", {
    type: "integer"
  }], ["aria-rowspan", {
    type: "integer"
  }], ["aria-selected", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-setsize", {
    type: "integer"
  }], ["aria-sort", {
    type: "token",
    values: ["ascending", "descending", "none", "other"]
  }], ["aria-valuemax", {
    type: "number"
  }], ["aria-valuemin", {
    type: "number"
  }], ["aria-valuenow", {
    type: "number"
  }], ["aria-valuetext", {
    type: "string"
  }]], BE = {
    entries: /* @__PURE__ */ o(function() {
      return Uo;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = 0, i = Uo; n < i.length; n++) {
        var s = $E(i[n], 2), a = s[0], l = s[1];
        t.call(r, l, a, Uo);
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = Uo.filter(function(n) {
        return n[0] === t;
      })[0];
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!BE.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return Uo.map(function(t) {
        var r = $E(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return Uo.map(function(t) {
        var r = $E(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, AOe = iu.default = (0, Q9.default)(BE, BE.entries());
});

// ../node_modules/aria-query/lib/domMap.js
var hA = v((su) => {
  "use strict";
  Object.defineProperty(su, "__esModule", {
    value: !0
  });
  su.default = void 0;
  var iK = sK(Bo());
  function sK(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(sK, "_interopRequireDefault");
  function UE(e, t) {
    return cK(e) || uK(e, t) || lK(e, t) || aK();
  }
  o(UE, "_slicedToArray");
  function aK() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(aK, "_nonIterableRest");
  function lK(e, t) {
    if (e) {
      if (typeof e == "string") return mA(e, t);
      var r = {}.toString.call(e).slice(8, -1);
      return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.
      test(r) ? mA(e, t) : void 0;
    }
  }
  o(lK, "_unsupportedIterableToArray");
  function mA(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  o(mA, "_arrayLikeToArray");
  function uK(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, s, a, l = [], u = !0, c = !1;
      try {
        if (s = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          u = !1;
        } else for (; !(u = (n = s.call(r)).done) && (l.push(n.value), l.length !== t); u = !0) ;
      } catch (d) {
        c = !0, i = d;
      } finally {
        try {
          if (!u && r.return != null && (a = r.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw i;
        }
      }
      return l;
    }
  }
  o(uK, "_iterableToArrayLimit");
  function cK(e) {
    if (Array.isArray(e)) return e;
  }
  o(cK, "_arrayWithHoles");
  var Ho = [["a", {
    reserved: !1
  }], ["abbr", {
    reserved: !1
  }], ["acronym", {
    reserved: !1
  }], ["address", {
    reserved: !1
  }], ["applet", {
    reserved: !1
  }], ["area", {
    reserved: !1
  }], ["article", {
    reserved: !1
  }], ["aside", {
    reserved: !1
  }], ["audio", {
    reserved: !1
  }], ["b", {
    reserved: !1
  }], ["base", {
    reserved: !0
  }], ["bdi", {
    reserved: !1
  }], ["bdo", {
    reserved: !1
  }], ["big", {
    reserved: !1
  }], ["blink", {
    reserved: !1
  }], ["blockquote", {
    reserved: !1
  }], ["body", {
    reserved: !1
  }], ["br", {
    reserved: !1
  }], ["button", {
    reserved: !1
  }], ["canvas", {
    reserved: !1
  }], ["caption", {
    reserved: !1
  }], ["center", {
    reserved: !1
  }], ["cite", {
    reserved: !1
  }], ["code", {
    reserved: !1
  }], ["col", {
    reserved: !0
  }], ["colgroup", {
    reserved: !0
  }], ["content", {
    reserved: !1
  }], ["data", {
    reserved: !1
  }], ["datalist", {
    reserved: !1
  }], ["dd", {
    reserved: !1
  }], ["del", {
    reserved: !1
  }], ["details", {
    reserved: !1
  }], ["dfn", {
    reserved: !1
  }], ["dialog", {
    reserved: !1
  }], ["dir", {
    reserved: !1
  }], ["div", {
    reserved: !1
  }], ["dl", {
    reserved: !1
  }], ["dt", {
    reserved: !1
  }], ["em", {
    reserved: !1
  }], ["embed", {
    reserved: !1
  }], ["fieldset", {
    reserved: !1
  }], ["figcaption", {
    reserved: !1
  }], ["figure", {
    reserved: !1
  }], ["font", {
    reserved: !1
  }], ["footer", {
    reserved: !1
  }], ["form", {
    reserved: !1
  }], ["frame", {
    reserved: !1
  }], ["frameset", {
    reserved: !1
  }], ["h1", {
    reserved: !1
  }], ["h2", {
    reserved: !1
  }], ["h3", {
    reserved: !1
  }], ["h4", {
    reserved: !1
  }], ["h5", {
    reserved: !1
  }], ["h6", {
    reserved: !1
  }], ["head", {
    reserved: !0
  }], ["header", {
    reserved: !1
  }], ["hgroup", {
    reserved: !1
  }], ["hr", {
    reserved: !1
  }], ["html", {
    reserved: !0
  }], ["i", {
    reserved: !1
  }], ["iframe", {
    reserved: !1
  }], ["img", {
    reserved: !1
  }], ["input", {
    reserved: !1
  }], ["ins", {
    reserved: !1
  }], ["kbd", {
    reserved: !1
  }], ["keygen", {
    reserved: !1
  }], ["label", {
    reserved: !1
  }], ["legend", {
    reserved: !1
  }], ["li", {
    reserved: !1
  }], ["link", {
    reserved: !0
  }], ["main", {
    reserved: !1
  }], ["map", {
    reserved: !1
  }], ["mark", {
    reserved: !1
  }], ["marquee", {
    reserved: !1
  }], ["menu", {
    reserved: !1
  }], ["menuitem", {
    reserved: !1
  }], ["meta", {
    reserved: !0
  }], ["meter", {
    reserved: !1
  }], ["nav", {
    reserved: !1
  }], ["noembed", {
    reserved: !0
  }], ["noscript", {
    reserved: !0
  }], ["object", {
    reserved: !1
  }], ["ol", {
    reserved: !1
  }], ["optgroup", {
    reserved: !1
  }], ["option", {
    reserved: !1
  }], ["output", {
    reserved: !1
  }], ["p", {
    reserved: !1
  }], ["param", {
    reserved: !0
  }], ["picture", {
    reserved: !0
  }], ["pre", {
    reserved: !1
  }], ["progress", {
    reserved: !1
  }], ["q", {
    reserved: !1
  }], ["rp", {
    reserved: !1
  }], ["rt", {
    reserved: !1
  }], ["rtc", {
    reserved: !1
  }], ["ruby", {
    reserved: !1
  }], ["s", {
    reserved: !1
  }], ["samp", {
    reserved: !1
  }], ["script", {
    reserved: !0
  }], ["section", {
    reserved: !1
  }], ["select", {
    reserved: !1
  }], ["small", {
    reserved: !1
  }], ["source", {
    reserved: !0
  }], ["spacer", {
    reserved: !1
  }], ["span", {
    reserved: !1
  }], ["strike", {
    reserved: !1
  }], ["strong", {
    reserved: !1
  }], ["style", {
    reserved: !0
  }], ["sub", {
    reserved: !1
  }], ["summary", {
    reserved: !1
  }], ["sup", {
    reserved: !1
  }], ["table", {
    reserved: !1
  }], ["tbody", {
    reserved: !1
  }], ["td", {
    reserved: !1
  }], ["textarea", {
    reserved: !1
  }], ["tfoot", {
    reserved: !1
  }], ["th", {
    reserved: !1
  }], ["thead", {
    reserved: !1
  }], ["time", {
    reserved: !1
  }], ["title", {
    reserved: !0
  }], ["tr", {
    reserved: !1
  }], ["track", {
    reserved: !0
  }], ["tt", {
    reserved: !1
  }], ["u", {
    reserved: !1
  }], ["ul", {
    reserved: !1
  }], ["var", {
    reserved: !1
  }], ["video", {
    reserved: !1
  }], ["wbr", {
    reserved: !1
  }], ["xmp", {
    reserved: !1
  }]], HE = {
    entries: /* @__PURE__ */ o(function() {
      return Ho;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = 0, i = Ho; n < i.length; n++) {
        var s = UE(i[n], 2), a = s[0], l = s[1];
        t.call(r, l, a, Ho);
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = Ho.filter(function(n) {
        return n[0] === t;
      })[0];
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!HE.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return Ho.map(function(t) {
        var r = UE(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return Ho.map(function(t) {
        var r = UE(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, IOe = su.default = (0, iK.default)(HE, HE.entries());
});

// ../node_modules/aria-query/lib/etc/roles/abstract/commandRole.js
var yA = v((au) => {
  "use strict";
  Object.defineProperty(au, "__esModule", {
    value: !0
  });
  au.default = void 0;
  var dK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, jOe = au.default = dK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/compositeRole.js
var bA = v((lu) => {
  "use strict";
  Object.defineProperty(lu, "__esModule", {
    value: !0
  });
  lu.default = void 0;
  var pK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, FOe = lu.default = pK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/inputRole.js
var gA = v((uu) => {
  "use strict";
  Object.defineProperty(uu, "__esModule", {
    value: !0
  });
  uu.default = void 0;
  var fK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null
    },
    relatedConcepts: [{
      concept: {
        name: "input"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, DOe = uu.default = fK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/landmarkRole.js
var vA = v((cu) => {
  "use strict";
  Object.defineProperty(cu, "__esModule", {
    value: !0
  });
  cu.default = void 0;
  var mK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, BOe = cu.default = mK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/rangeRole.js
var EA = v((du) => {
  "use strict";
  Object.defineProperty(du, "__esModule", {
    value: !0
  });
  du.default = void 0;
  var hK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuemax": null,
      "aria-valuemin": null,
      "aria-valuenow": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, HOe = du.default = hK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/roletypeRole.js
var TA = v((pu) => {
  "use strict";
  Object.defineProperty(pu, "__esModule", {
    value: !0
  });
  pu.default = void 0;
  var yK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {
      "aria-atomic": null,
      "aria-busy": null,
      "aria-controls": null,
      "aria-current": null,
      "aria-describedby": null,
      "aria-details": null,
      "aria-dropeffect": null,
      "aria-flowto": null,
      "aria-grabbed": null,
      "aria-hidden": null,
      "aria-keyshortcuts": null,
      "aria-label": null,
      "aria-labelledby": null,
      "aria-live": null,
      "aria-owns": null,
      "aria-relevant": null,
      "aria-roledescription": null
    },
    relatedConcepts: [{
      concept: {
        name: "role"
      },
      module: "XHTML"
    }, {
      concept: {
        name: "type"
      },
      module: "Dublin Core"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  }, zOe = pu.default = yK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/sectionRole.js
var _A = v((fu) => {
  "use strict";
  Object.defineProperty(fu, "__esModule", {
    value: !0
  });
  fu.default = void 0;
  var bK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "frontmatter"
      },
      module: "DTB"
    }, {
      concept: {
        name: "level"
      },
      module: "DTB"
    }, {
      concept: {
        name: "level"
      },
      module: "SMIL"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, YOe = fu.default = bK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/sectionheadRole.js
var RA = v((mu) => {
  "use strict";
  Object.defineProperty(mu, "__esModule", {
    value: !0
  });
  mu.default = void 0;
  var gK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, KOe = mu.default = gK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/selectRole.js
var wA = v((hu) => {
  "use strict";
  Object.defineProperty(hu, "__esModule", {
    value: !0
  });
  hu.default = void 0;
  var vK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "group"]]
  }, JOe = hu.default = vK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/structureRole.js
var SA = v((yu) => {
  "use strict";
  Object.defineProperty(yu, "__esModule", {
    value: !0
  });
  yu.default = void 0;
  var EK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, QOe = yu.default = EK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/widgetRole.js
var xA = v((bu) => {
  "use strict";
  Object.defineProperty(bu, "__esModule", {
    value: !0
  });
  bu.default = void 0;
  var TK = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, t1e = bu.default = TK;
});

// ../node_modules/aria-query/lib/etc/roles/abstract/windowRole.js
var CA = v((gu) => {
  "use strict";
  Object.defineProperty(gu, "__esModule", {
    value: !0
  });
  gu.default = void 0;
  var _K = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-modal": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, n1e = gu.default = _K;
});

// ../node_modules/aria-query/lib/etc/roles/ariaAbstractRoles.js
var PA = v((vu) => {
  "use strict";
  Object.defineProperty(vu, "__esModule", {
    value: !0
  });
  vu.default = void 0;
  var RK = jt(yA()), wK = jt(bA()), SK = jt(gA()), xK = jt(vA()), CK = jt(EA()), PK = jt(TA()), AK = jt(_A()), OK = jt(RA()), qK = jt(wA()),
  IK = jt(SA()), MK = jt(xA()), NK = jt(CA());
  function jt(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(jt, "_interopRequireDefault");
  var jK = [["command", RK.default], ["composite", wK.default], ["input", SK.default], ["landmark", xK.default], ["range", CK.default], ["ro\
letype", PK.default], ["section", AK.default], ["sectionhead", OK.default], ["select", qK.default], ["structure", IK.default], ["widget", MK.
  default], ["window", NK.default]], i1e = vu.default = jK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/alertRole.js
var AA = v((Eu) => {
  "use strict";
  Object.defineProperty(Eu, "__esModule", {
    value: !0
  });
  Eu.default = void 0;
  var LK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-atomic": "true",
      "aria-live": "assertive"
    },
    relatedConcepts: [{
      concept: {
        name: "alert"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, l1e = Eu.default = LK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/alertdialogRole.js
var OA = v((Tu) => {
  "use strict";
  Object.defineProperty(Tu, "__esModule", {
    value: !0
  });
  Tu.default = void 0;
  var FK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "alert"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "alert"], ["roletype", "window", "dialog"]]
  }, c1e = Tu.default = FK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/applicationRole.js
var qA = v((_u) => {
  "use strict";
  Object.defineProperty(_u, "__esModule", {
    value: !0
  });
  _u.default = void 0;
  var kK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "Device Independence Delivery Unit"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, p1e = _u.default = kK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/articleRole.js
var IA = v((Ru) => {
  "use strict";
  Object.defineProperty(Ru, "__esModule", {
    value: !0
  });
  Ru.default = void 0;
  var DK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "article"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "document"]]
  }, m1e = Ru.default = DK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/bannerRole.js
var MA = v((wu) => {
  "use strict";
  Object.defineProperty(wu, "__esModule", {
    value: !0
  });
  wu.default = void 0;
  var $K = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element"],
        name: "header"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, y1e = wu.default = $K;
});

// ../node_modules/aria-query/lib/etc/roles/literal/blockquoteRole.js
var NA = v((Su) => {
  "use strict";
  Object.defineProperty(Su, "__esModule", {
    value: !0
  });
  Su.default = void 0;
  var BK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "blockquote"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, g1e = Su.default = BK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/buttonRole.js
var jA = v((xu) => {
  "use strict";
  Object.defineProperty(xu, "__esModule", {
    value: !0
  });
  xu.default = void 0;
  var UK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-pressed": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "button"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "image"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "reset"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "submit"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "button"
      },
      module: "HTML"
    }, {
      concept: {
        name: "trigger"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, E1e = xu.default = UK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/captionRole.js
var LA = v((Cu) => {
  "use strict";
  Object.defineProperty(Cu, "__esModule", {
    value: !0
  });
  Cu.default = void 0;
  var HK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "caption"
      },
      module: "HTML"
    }],
    requireContextRole: ["figure", "grid", "table"],
    requiredContextRole: ["figure", "grid", "table"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, _1e = Cu.default = HK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/cellRole.js
var FA = v((Pu) => {
  "use strict";
  Object.defineProperty(Pu, "__esModule", {
    value: !0
  });
  Pu.default = void 0;
  var VK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-colindex": null,
      "aria-colspan": null,
      "aria-rowindex": null,
      "aria-rowspan": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["ancestor table element has table role"],
        name: "td"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, w1e = Pu.default = VK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/checkboxRole.js
var kA = v((Au) => {
  "use strict";
  Object.defineProperty(Au, "__esModule", {
    value: !0
  });
  Au.default = void 0;
  var zK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "checkbox"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "option"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input"]]
  }, x1e = Au.default = zK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/codeRole.js
var DA = v((Ou) => {
  "use strict";
  Object.defineProperty(Ou, "__esModule", {
    value: !0
  });
  Ou.default = void 0;
  var GK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "code"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, P1e = Ou.default = GK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/columnheaderRole.js
var $A = v((qu) => {
  "use strict";
  Object.defineProperty(qu, "__esModule", {
    value: !0
  });
  qu.default = void 0;
  var YK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-sort": null
    },
    relatedConcepts: [{
      concept: {
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "col"
        }],
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "colgroup"
        }],
        name: "th"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widge\
t", "gridcell"], ["roletype", "structure", "sectionhead"]]
  }, O1e = qu.default = YK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/comboboxRole.js
var BA = v((Iu) => {
  "use strict";
  Object.defineProperty(Iu, "__esModule", {
    value: !0
  });
  Iu.default = void 0;
  var WK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-autocomplete": null,
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-expanded": "false",
      "aria-haspopup": "listbox"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "email"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "search"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "tel"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "text"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "multiple"
        }, {
          constraints: ["undefined"],
          name: "size"
        }],
        constraints: ["the multiple attribute is not set and the size attribute does not have a value greater than 1"],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-controls": null,
      "aria-expanded": "false"
    },
    superClass: [["roletype", "widget", "input"]]
  }, I1e = Iu.default = WK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/complementaryRole.js
var UA = v((Mu) => {
  "use strict";
  Object.defineProperty(Mu, "__esModule", {
    value: !0
  });
  Mu.default = void 0;
  var KK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element", "scoped to the main element"],
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        constraints: ["scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        constraints: ["scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "aside"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, N1e = Mu.default = KK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/contentinfoRole.js
var HA = v((Nu) => {
  "use strict";
  Object.defineProperty(Nu, "__esModule", {
    value: !0
  });
  Nu.default = void 0;
  var XK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element"],
        name: "footer"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, L1e = Nu.default = XK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/definitionRole.js
var VA = v((ju) => {
  "use strict";
  Object.defineProperty(ju, "__esModule", {
    value: !0
  });
  ju.default = void 0;
  var JK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dd"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, k1e = ju.default = JK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/deletionRole.js
var zA = v((Lu) => {
  "use strict";
  Object.defineProperty(Lu, "__esModule", {
    value: !0
  });
  Lu.default = void 0;
  var ZK = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "del"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, $1e = Lu.default = ZK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/dialogRole.js
var GA = v((Fu) => {
  "use strict";
  Object.defineProperty(Fu, "__esModule", {
    value: !0
  });
  Fu.default = void 0;
  var QK = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dialog"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "window"]]
  }, U1e = Fu.default = QK;
});

// ../node_modules/aria-query/lib/etc/roles/literal/directoryRole.js
var YA = v((ku) => {
  "use strict";
  Object.defineProperty(ku, "__esModule", {
    value: !0
  });
  ku.default = void 0;
  var e7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      module: "DAISY Guide"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "list"]]
  }, V1e = ku.default = e7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/documentRole.js
var WA = v((Du) => {
  "use strict";
  Object.defineProperty(Du, "__esModule", {
    value: !0
  });
  Du.default = void 0;
  var t7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "Device Independence Delivery Unit"
      }
    }, {
      concept: {
        name: "html"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, G1e = Du.default = t7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/emphasisRole.js
var KA = v(($u) => {
  "use strict";
  Object.defineProperty($u, "__esModule", {
    value: !0
  });
  $u.default = void 0;
  var r7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "em"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, W1e = $u.default = r7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/feedRole.js
var XA = v((Bu) => {
  "use strict";
  Object.defineProperty(Bu, "__esModule", {
    value: !0
  });
  Bu.default = void 0;
  var n7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["article"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "list"]]
  }, X1e = Bu.default = n7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/figureRole.js
var JA = v((Uu) => {
  "use strict";
  Object.defineProperty(Uu, "__esModule", {
    value: !0
  });
  Uu.default = void 0;
  var o7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "figure"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Z1e = Uu.default = o7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/formRole.js
var ZA = v((Hu) => {
  "use strict";
  Object.defineProperty(Hu, "__esModule", {
    value: !0
  });
  Hu.default = void 0;
  var i7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        name: "form"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        name: "form"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "name"
        }],
        name: "form"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, eqe = Hu.default = i7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/genericRole.js
var QA = v((Vu) => {
  "use strict";
  Object.defineProperty(Vu, "__esModule", {
    value: !0
  });
  Vu.default = void 0;
  var s7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "a"
      },
      module: "HTML"
    }, {
      concept: {
        name: "area"
      },
      module: "HTML"
    }, {
      concept: {
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        name: "b"
      },
      module: "HTML"
    }, {
      concept: {
        name: "bdo"
      },
      module: "HTML"
    }, {
      concept: {
        name: "body"
      },
      module: "HTML"
    }, {
      concept: {
        name: "data"
      },
      module: "HTML"
    }, {
      concept: {
        name: "div"
      },
      module: "HTML"
    }, {
      concept: {
        constraints: ["scoped to the main element", "scoped to a sectioning content element", "scoped to a sectioning root element other tha\
n body"],
        name: "footer"
      },
      module: "HTML"
    }, {
      concept: {
        constraints: ["scoped to the main element", "scoped to a sectioning content element", "scoped to a sectioning root element other tha\
n body"],
        name: "header"
      },
      module: "HTML"
    }, {
      concept: {
        name: "hgroup"
      },
      module: "HTML"
    }, {
      concept: {
        name: "i"
      },
      module: "HTML"
    }, {
      concept: {
        name: "pre"
      },
      module: "HTML"
    }, {
      concept: {
        name: "q"
      },
      module: "HTML"
    }, {
      concept: {
        name: "samp"
      },
      module: "HTML"
    }, {
      concept: {
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        name: "small"
      },
      module: "HTML"
    }, {
      concept: {
        name: "span"
      },
      module: "HTML"
    }, {
      concept: {
        name: "u"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, rqe = Vu.default = s7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/gridRole.js
var eO = v((zu) => {
  "use strict";
  Object.defineProperty(zu, "__esModule", {
    value: !0
  });
  zu.default = void 0;
  var a7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-multiselectable": null,
      "aria-readonly": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "table"]]
  }, oqe = zu.default = a7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/gridcellRole.js
var tO = v((Gu) => {
  "use strict";
  Object.defineProperty(Gu, "__esModule", {
    value: !0
  });
  Gu.default = void 0;
  var l7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-selected": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["ancestor table element has grid role", "ancestor table element has treegrid role"],
        name: "td"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "widget"]]
  }, sqe = Gu.default = l7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/groupRole.js
var rO = v((Yu) => {
  "use strict";
  Object.defineProperty(Yu, "__esModule", {
    value: !0
  });
  Yu.default = void 0;
  var u7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null
    },
    relatedConcepts: [{
      concept: {
        name: "details"
      },
      module: "HTML"
    }, {
      concept: {
        name: "fieldset"
      },
      module: "HTML"
    }, {
      concept: {
        name: "optgroup"
      },
      module: "HTML"
    }, {
      concept: {
        name: "address"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, lqe = Yu.default = u7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/headingRole.js
var nO = v((Wu) => {
  "use strict";
  Object.defineProperty(Wu, "__esModule", {
    value: !0
  });
  Wu.default = void 0;
  var c7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-level": "2"
    },
    relatedConcepts: [{
      concept: {
        name: "h1"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h2"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h3"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h4"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h5"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h6"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-level": "2"
    },
    superClass: [["roletype", "structure", "sectionhead"]]
  }, cqe = Wu.default = c7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/imgRole.js
var oO = v((Ku) => {
  "use strict";
  Object.defineProperty(Ku, "__esModule", {
    value: !0
  });
  Ku.default = void 0;
  var d7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "alt"
        }],
        name: "img"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "alt"
        }],
        name: "img"
      },
      module: "HTML"
    }, {
      concept: {
        name: "imggroup"
      },
      module: "DTB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, pqe = Ku.default = d7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/insertionRole.js
var iO = v((Xu) => {
  "use strict";
  Object.defineProperty(Xu, "__esModule", {
    value: !0
  });
  Xu.default = void 0;
  var p7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "ins"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, mqe = Xu.default = p7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/linkRole.js
var sO = v((Ju) => {
  "use strict";
  Object.defineProperty(Ju, "__esModule", {
    value: !0
  });
  Ju.default = void 0;
  var f7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "href"
        }],
        name: "a"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "href"
        }],
        name: "area"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, yqe = Ju.default = f7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/listRole.js
var aO = v((Zu) => {
  "use strict";
  Object.defineProperty(Zu, "__esModule", {
    value: !0
  });
  Zu.default = void 0;
  var m7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menu"
      },
      module: "HTML"
    }, {
      concept: {
        name: "ol"
      },
      module: "HTML"
    }, {
      concept: {
        name: "ul"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["listitem"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, gqe = Zu.default = m7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/listboxRole.js
var lO = v((Qu) => {
  "use strict";
  Object.defineProperty(Qu, "__esModule", {
    value: !0
  });
  Qu.default = void 0;
  var h7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-invalid": null,
      "aria-multiselectable": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-orientation": "vertical"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: [">1"],
          name: "size"
        }],
        constraints: ["the size attribute value is greater than 1"],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "multiple"
        }],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        name: "datalist"
      },
      module: "HTML"
    }, {
      concept: {
        name: "list"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["option", "group"], ["option"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, Eqe = Qu.default = h7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/listitemRole.js
var uO = v((ec) => {
  "use strict";
  Object.defineProperty(ec, "__esModule", {
    value: !0
  });
  ec.default = void 0;
  var y7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-level": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["direct descendant of ol", "direct descendant of ul", "direct descendant of menu"],
        name: "li"
      },
      module: "HTML"
    }, {
      concept: {
        name: "item"
      },
      module: "XForms"
    }],
    requireContextRole: ["directory", "list"],
    requiredContextRole: ["directory", "list"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, _qe = ec.default = y7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/logRole.js
var cO = v((tc) => {
  "use strict";
  Object.defineProperty(tc, "__esModule", {
    value: !0
  });
  tc.default = void 0;
  var b7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-live": "polite"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, wqe = tc.default = b7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/mainRole.js
var dO = v((rc) => {
  "use strict";
  Object.defineProperty(rc, "__esModule", {
    value: !0
  });
  rc.default = void 0;
  var g7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "main"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, xqe = rc.default = g7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/markRole.js
var pO = v((nc) => {
  "use strict";
  Object.defineProperty(nc, "__esModule", {
    value: !0
  });
  nc.default = void 0;
  var v7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: [],
    props: {
      "aria-braillelabel": null,
      "aria-brailleroledescription": null,
      "aria-description": null
    },
    relatedConcepts: [{
      concept: {
        name: "mark"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Pqe = nc.default = v7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/marqueeRole.js
var fO = v((oc) => {
  "use strict";
  Object.defineProperty(oc, "__esModule", {
    value: !0
  });
  oc.default = void 0;
  var E7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Oqe = oc.default = E7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/mathRole.js
var mO = v((ic) => {
  "use strict";
  Object.defineProperty(ic, "__esModule", {
    value: !0
  });
  ic.default = void 0;
  var T7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "math"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Iqe = ic.default = T7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/menuRole.js
var hO = v((sc) => {
  "use strict";
  Object.defineProperty(sc, "__esModule", {
    value: !0
  });
  sc.default = void 0;
  var _7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "vertical"
    },
    relatedConcepts: [{
      concept: {
        name: "MENU"
      },
      module: "JAPI"
    }, {
      concept: {
        name: "list"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }, {
      concept: {
        name: "sidebar"
      },
      module: "DTB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckb\
ox"], ["menuitemradio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, Nqe = sc.default = _7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/menubarRole.js
var yO = v((ac) => {
  "use strict";
  Object.defineProperty(ac, "__esModule", {
    value: !0
  });
  ac.default = void 0;
  var R7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      concept: {
        name: "toolbar"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckb\
ox"], ["menuitemradio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select", "menu"], ["roletype", "structure", "section", "group", "select", "menu"]]
  }, Lqe = ac.default = R7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/menuitemRole.js
var bO = v((lc) => {
  "use strict";
  Object.defineProperty(lc, "__esModule", {
    value: !0
  });
  lc.default = void 0;
  var w7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "MENU_ITEM"
      },
      module: "JAPI"
    }, {
      concept: {
        name: "listitem"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "option"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, kqe = lc.default = w7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/menuitemcheckboxRole.js
var gO = v((uc) => {
  "use strict";
  Object.defineProperty(uc, "__esModule", {
    value: !0
  });
  uc.default = void 0;
  var S7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menuitem"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox"], ["roletype", "widget", "command", "menuitem"]]
  }, $qe = uc.default = S7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/menuitemradioRole.js
var vO = v((cc) => {
  "use strict";
  Object.defineProperty(cc, "__esModule", {
    value: !0
  });
  cc.default = void 0;
  var x7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menuitem"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox", "menuitemcheckbox"], ["roletype", "widget", "command", "menuitem", "menuitemche\
ckbox"], ["roletype", "widget", "input", "radio"]]
  }, Uqe = cc.default = x7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/meterRole.js
var EO = v((dc) => {
  "use strict";
  Object.defineProperty(dc, "__esModule", {
    value: !0
  });
  dc.default = void 0;
  var C7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuetext": null,
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [{
      concept: {
        name: "meter"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-valuenow": null
    },
    superClass: [["roletype", "structure", "range"]]
  }, Vqe = dc.default = C7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/navigationRole.js
var TO = v((pc) => {
  "use strict";
  Object.defineProperty(pc, "__esModule", {
    value: !0
  });
  pc.default = void 0;
  var P7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "nav"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Gqe = pc.default = P7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/noneRole.js
var _O = v((fc) => {
  "use strict";
  Object.defineProperty(fc, "__esModule", {
    value: !0
  });
  fc.default = void 0;
  var A7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  }, Wqe = fc.default = A7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/noteRole.js
var RO = v((mc) => {
  "use strict";
  Object.defineProperty(mc, "__esModule", {
    value: !0
  });
  mc.default = void 0;
  var O7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Xqe = mc.default = O7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/optionRole.js
var wO = v((hc) => {
  "use strict";
  Object.defineProperty(hc, "__esModule", {
    value: !0
  });
  hc.default = void 0;
  var q7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-posinset": null,
      "aria-setsize": null,
      "aria-selected": "false"
    },
    relatedConcepts: [{
      concept: {
        name: "item"
      },
      module: "XForms"
    }, {
      concept: {
        name: "listitem"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "option"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-selected": "false"
    },
    superClass: [["roletype", "widget", "input"]]
  }, Zqe = hc.default = q7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/paragraphRole.js
var SO = v((yc) => {
  "use strict";
  Object.defineProperty(yc, "__esModule", {
    value: !0
  });
  yc.default = void 0;
  var I7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "p"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, eIe = yc.default = I7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/presentationRole.js
var xO = v((bc) => {
  "use strict";
  Object.defineProperty(bc, "__esModule", {
    value: !0
  });
  bc.default = void 0;
  var M7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "alt",
          value: ""
        }],
        name: "img"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, rIe = bc.default = M7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/progressbarRole.js
var CO = v((gc) => {
  "use strict";
  Object.defineProperty(gc, "__esModule", {
    value: !0
  });
  gc.default = void 0;
  var N7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuetext": null
    },
    relatedConcepts: [{
      concept: {
        name: "progress"
      },
      module: "HTML"
    }, {
      concept: {
        name: "status"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
  }, oIe = gc.default = N7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/radioRole.js
var PO = v((vc) => {
  "use strict";
  Object.defineProperty(vc, "__esModule", {
    value: !0
  });
  vc.default = void 0;
  var j7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "radio"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input"]]
  }, sIe = vc.default = j7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/radiogroupRole.js
var AO = v((Ec) => {
  "use strict";
  Object.defineProperty(Ec, "__esModule", {
    value: !0
  });
  Ec.default = void 0;
  var L7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        name: "list"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["radio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, lIe = Ec.default = L7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/regionRole.js
var OO = v((Tc) => {
  "use strict";
  Object.defineProperty(Tc, "__esModule", {
    value: !0
  });
  Tc.default = void 0;
  var F7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        name: "Device Independence Glossart perceivable unit"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, cIe = Tc.default = F7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/rowRole.js
var qO = v((_c) => {
  "use strict";
  Object.defineProperty(_c, "__esModule", {
    value: !0
  });
  _c.default = void 0;
  var k7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-colindex": null,
      "aria-expanded": null,
      "aria-level": null,
      "aria-posinset": null,
      "aria-rowindex": null,
      "aria-selected": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "tr"
      },
      module: "HTML"
    }],
    requireContextRole: ["grid", "rowgroup", "table", "treegrid"],
    requiredContextRole: ["grid", "rowgroup", "table", "treegrid"],
    requiredOwnedElements: [["cell"], ["columnheader"], ["gridcell"], ["rowheader"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"], ["roletype", "widget"]]
  }, pIe = _c.default = k7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/rowgroupRole.js
var IO = v((Rc) => {
  "use strict";
  Object.defineProperty(Rc, "__esModule", {
    value: !0
  });
  Rc.default = void 0;
  var D7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "tbody"
      },
      module: "HTML"
    }, {
      concept: {
        name: "tfoot"
      },
      module: "HTML"
    }, {
      concept: {
        name: "thead"
      },
      module: "HTML"
    }],
    requireContextRole: ["grid", "table", "treegrid"],
    requiredContextRole: ["grid", "table", "treegrid"],
    requiredOwnedElements: [["row"]],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, mIe = Rc.default = D7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/rowheaderRole.js
var MO = v((wc) => {
  "use strict";
  Object.defineProperty(wc, "__esModule", {
    value: !0
  });
  wc.default = void 0;
  var $7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-sort": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "scope",
          value: "row"
        }],
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "rowgroup"
        }],
        name: "th"
      },
      module: "HTML"
    }],
    requireContextRole: ["row", "rowgroup"],
    requiredContextRole: ["row", "rowgroup"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widge\
t", "gridcell"], ["roletype", "structure", "sectionhead"]]
  }, yIe = wc.default = $7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/scrollbarRole.js
var NO = v((Sc) => {
  "use strict";
  Object.defineProperty(Sc, "__esModule", {
    value: !0
  });
  Sc.default = void 0;
  var B7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-valuetext": null,
      "aria-orientation": "vertical",
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-controls": null,
      "aria-valuenow": null
    },
    superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
  }, gIe = Sc.default = B7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/searchRole.js
var jO = v((xc) => {
  "use strict";
  Object.defineProperty(xc, "__esModule", {
    value: !0
  });
  xc.default = void 0;
  var U7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, EIe = xc.default = U7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/searchboxRole.js
var LO = v((Cc) => {
  "use strict";
  Object.defineProperty(Cc, "__esModule", {
    value: !0
  });
  Cc.default = void 0;
  var H7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "search"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "input", "textbox"]]
  }, _Ie = Cc.default = H7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/separatorRole.js
var FO = v((Pc) => {
  "use strict";
  Object.defineProperty(Pc, "__esModule", {
    value: !0
  });
  Pc.default = void 0;
  var V7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-orientation": "horizontal",
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": null,
      "aria-valuetext": null
    },
    relatedConcepts: [{
      concept: {
        name: "hr"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, wIe = Pc.default = V7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/sliderRole.js
var kO = v((Ac) => {
  "use strict";
  Object.defineProperty(Ac, "__esModule", {
    value: !0
  });
  Ac.default = void 0;
  var z7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-valuetext": null,
      "aria-orientation": "horizontal",
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "range"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-valuenow": null
    },
    superClass: [["roletype", "widget", "input"], ["roletype", "structure", "range"]]
  }, xIe = Ac.default = z7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/spinbuttonRole.js
var DO = v((Oc) => {
  "use strict";
  Object.defineProperty(Oc, "__esModule", {
    value: !0
  });
  Oc.default = void 0;
  var G7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-valuetext": null,
      "aria-valuenow": "0"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "number"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "widget", "input"], ["roletype", "structure", "range"]]
  }, PIe = Oc.default = G7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/statusRole.js
var $O = v((qc) => {
  "use strict";
  Object.defineProperty(qc, "__esModule", {
    value: !0
  });
  qc.default = void 0;
  var Y7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-atomic": "true",
      "aria-live": "polite"
    },
    relatedConcepts: [{
      concept: {
        name: "output"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, OIe = qc.default = Y7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/strongRole.js
var BO = v((Ic) => {
  "use strict";
  Object.defineProperty(Ic, "__esModule", {
    value: !0
  });
  Ic.default = void 0;
  var W7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "strong"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, IIe = Ic.default = W7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/subscriptRole.js
var UO = v((Mc) => {
  "use strict";
  Object.defineProperty(Mc, "__esModule", {
    value: !0
  });
  Mc.default = void 0;
  var K7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "sub"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, NIe = Mc.default = K7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/superscriptRole.js
var HO = v((Nc) => {
  "use strict";
  Object.defineProperty(Nc, "__esModule", {
    value: !0
  });
  Nc.default = void 0;
  var X7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "sup"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, LIe = Nc.default = X7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/switchRole.js
var VO = v((jc) => {
  "use strict";
  Object.defineProperty(jc, "__esModule", {
    value: !0
  });
  jc.default = void 0;
  var J7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "button"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox"]]
  }, kIe = jc.default = J7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/tabRole.js
var zO = v((Lc) => {
  "use strict";
  Object.defineProperty(Lc, "__esModule", {
    value: !0
  });
  Lc.default = void 0;
  var Z7 = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-posinset": null,
      "aria-setsize": null,
      "aria-selected": "false"
    },
    relatedConcepts: [],
    requireContextRole: ["tablist"],
    requiredContextRole: ["tablist"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "sectionhead"], ["roletype", "widget"]]
  }, $Ie = Lc.default = Z7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/tableRole.js
var GO = v((Fc) => {
  "use strict";
  Object.defineProperty(Fc, "__esModule", {
    value: !0
  });
  Fc.default = void 0;
  var Q7 = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-colcount": null,
      "aria-rowcount": null
    },
    relatedConcepts: [{
      concept: {
        name: "table"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, UIe = Fc.default = Q7;
});

// ../node_modules/aria-query/lib/etc/roles/literal/tablistRole.js
var YO = v((kc) => {
  "use strict";
  Object.defineProperty(kc, "__esModule", {
    value: !0
  });
  kc.default = void 0;
  var eX = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-level": null,
      "aria-multiselectable": null,
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      module: "DAISY",
      concept: {
        name: "guide"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["tab"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"]]
  }, VIe = kc.default = eX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/tabpanelRole.js
var WO = v((Dc) => {
  "use strict";
  Object.defineProperty(Dc, "__esModule", {
    value: !0
  });
  Dc.default = void 0;
  var tX = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, GIe = Dc.default = tX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/termRole.js
var KO = v(($c) => {
  "use strict";
  Object.defineProperty($c, "__esModule", {
    value: !0
  });
  $c.default = void 0;
  var rX = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dfn"
      },
      module: "HTML"
    }, {
      concept: {
        name: "dt"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, WIe = $c.default = rX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/textboxRole.js
var XO = v((Bc) => {
  "use strict";
  Object.defineProperty(Bc, "__esModule", {
    value: !0
  });
  Bc.default = void 0;
  var nX = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-autocomplete": null,
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-multiline": null,
      "aria-placeholder": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "type"
        }, {
          constraints: ["undefined"],
          name: "list"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "email"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "tel"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "text"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "input"
      },
      module: "XForms"
    }, {
      concept: {
        name: "textarea"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "input"]]
  }, XIe = Bc.default = nX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/timeRole.js
var JO = v((Uc) => {
  "use strict";
  Object.defineProperty(Uc, "__esModule", {
    value: !0
  });
  Uc.default = void 0;
  var oX = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "time"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, ZIe = Uc.default = oX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/timerRole.js
var ZO = v((Hc) => {
  "use strict";
  Object.defineProperty(Hc, "__esModule", {
    value: !0
  });
  Hc.default = void 0;
  var iX = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "status"]]
  }, eMe = Hc.default = iX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/toolbarRole.js
var QO = v((Vc) => {
  "use strict";
  Object.defineProperty(Vc, "__esModule", {
    value: !0
  });
  Vc.default = void 0;
  var sX = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      concept: {
        name: "menubar"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"]]
  }, rMe = Vc.default = sX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/tooltipRole.js
var e1 = v((zc) => {
  "use strict";
  Object.defineProperty(zc, "__esModule", {
    value: !0
  });
  zc.default = void 0;
  var aX = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, oMe = zc.default = aX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/treeRole.js
var t1 = v((Gc) => {
  "use strict";
  Object.defineProperty(Gc, "__esModule", {
    value: !0
  });
  Gc.default = void 0;
  var lX = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-multiselectable": null,
      "aria-required": null,
      "aria-orientation": "vertical"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["treeitem", "group"], ["treeitem"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, sMe = Gc.default = lX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/treegridRole.js
var r1 = v((Yc) => {
  "use strict";
  Object.defineProperty(Yc, "__esModule", {
    value: !0
  });
  Yc.default = void 0;
  var uX = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "grid"], ["roletype", "structure", "section", "table", "grid"], ["roletype", "widget", "\
composite", "select", "tree"], ["roletype", "structure", "section", "group", "select", "tree"]]
  }, lMe = Yc.default = uX;
});

// ../node_modules/aria-query/lib/etc/roles/literal/treeitemRole.js
var n1 = v((Wc) => {
  "use strict";
  Object.defineProperty(Wc, "__esModule", {
    value: !0
  });
  Wc.default = void 0;
  var cX = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-expanded": null,
      "aria-haspopup": null
    },
    relatedConcepts: [],
    requireContextRole: ["group", "tree"],
    requiredContextRole: ["group", "tree"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-selected": null
    },
    superClass: [["roletype", "structure", "section", "listitem"], ["roletype", "widget", "input", "option"]]
  }, cMe = Wc.default = cX;
});

// ../node_modules/aria-query/lib/etc/roles/ariaLiteralRoles.js
var o1 = v((Kc) => {
  "use strict";
  Object.defineProperty(Kc, "__esModule", {
    value: !0
  });
  Kc.default = void 0;
  var dX = U(AA()), pX = U(OA()), fX = U(qA()), mX = U(IA()), hX = U(MA()), yX = U(NA()), bX = U(jA()), gX = U(LA()), vX = U(FA()), EX = U(kA()),
  TX = U(DA()), _X = U($A()), RX = U(BA()), wX = U(UA()), SX = U(HA()), xX = U(VA()), CX = U(zA()), PX = U(GA()), AX = U(YA()), OX = U(WA()),
  qX = U(KA()), IX = U(XA()), MX = U(JA()), NX = U(ZA()), jX = U(QA()), LX = U(eO()), FX = U(tO()), kX = U(rO()), DX = U(nO()), $X = U(oO()),
  BX = U(iO()), UX = U(sO()), HX = U(aO()), VX = U(lO()), zX = U(uO()), GX = U(cO()), YX = U(dO()), WX = U(pO()), KX = U(fO()), XX = U(mO()),
  JX = U(hO()), ZX = U(yO()), QX = U(bO()), eJ = U(gO()), tJ = U(vO()), rJ = U(EO()), nJ = U(TO()), oJ = U(_O()), iJ = U(RO()), sJ = U(wO()),
  aJ = U(SO()), lJ = U(xO()), uJ = U(CO()), cJ = U(PO()), dJ = U(AO()), pJ = U(OO()), fJ = U(qO()), mJ = U(IO()), hJ = U(MO()), yJ = U(NO()),
  bJ = U(jO()), gJ = U(LO()), vJ = U(FO()), EJ = U(kO()), TJ = U(DO()), _J = U($O()), RJ = U(BO()), wJ = U(UO()), SJ = U(HO()), xJ = U(VO()),
  CJ = U(zO()), PJ = U(GO()), AJ = U(YO()), OJ = U(WO()), qJ = U(KO()), IJ = U(XO()), MJ = U(JO()), NJ = U(ZO()), jJ = U(QO()), LJ = U(e1()),
  FJ = U(t1()), kJ = U(r1()), DJ = U(n1());
  function U(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(U, "_interopRequireDefault");
  var $J = [["alert", dX.default], ["alertdialog", pX.default], ["application", fX.default], ["article", mX.default], ["banner", hX.default],
  ["blockquote", yX.default], ["button", bX.default], ["caption", gX.default], ["cell", vX.default], ["checkbox", EX.default], ["code", TX.default],
  ["columnheader", _X.default], ["combobox", RX.default], ["complementary", wX.default], ["contentinfo", SX.default], ["definition", xX.default],
  ["deletion", CX.default], ["dialog", PX.default], ["directory", AX.default], ["document", OX.default], ["emphasis", qX.default], ["feed", IX.
  default], ["figure", MX.default], ["form", NX.default], ["generic", jX.default], ["grid", LX.default], ["gridcell", FX.default], ["group",
  kX.default], ["heading", DX.default], ["img", $X.default], ["insertion", BX.default], ["link", UX.default], ["list", HX.default], ["listbo\
x", VX.default], ["listitem", zX.default], ["log", GX.default], ["main", YX.default], ["mark", WX.default], ["marquee", KX.default], ["math",
  XX.default], ["menu", JX.default], ["menubar", ZX.default], ["menuitem", QX.default], ["menuitemcheckbox", eJ.default], ["menuitemradio", tJ.
  default], ["meter", rJ.default], ["navigation", nJ.default], ["none", oJ.default], ["note", iJ.default], ["option", sJ.default], ["paragra\
ph", aJ.default], ["presentation", lJ.default], ["progressbar", uJ.default], ["radio", cJ.default], ["radiogroup", dJ.default], ["region", pJ.
  default], ["row", fJ.default], ["rowgroup", mJ.default], ["rowheader", hJ.default], ["scrollbar", yJ.default], ["search", bJ.default], ["s\
earchbox", gJ.default], ["separator", vJ.default], ["slider", EJ.default], ["spinbutton", TJ.default], ["status", _J.default], ["strong", RJ.
  default], ["subscript", wJ.default], ["superscript", SJ.default], ["switch", xJ.default], ["tab", CJ.default], ["table", PJ.default], ["ta\
blist", AJ.default], ["tabpanel", OJ.default], ["term", qJ.default], ["textbox", IJ.default], ["time", MJ.default], ["timer", NJ.default], [
  "toolbar", jJ.default], ["tooltip", LJ.default], ["tree", FJ.default], ["treegrid", kJ.default], ["treeitem", DJ.default]], pMe = Kc.default =
  $J;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docAbstractRole.js
var i1 = v((Xc) => {
  "use strict";
  Object.defineProperty(Xc, "__esModule", {
    value: !0
  });
  Xc.default = void 0;
  var BJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "abstract [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, hMe = Xc.default = BJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docAcknowledgmentsRole.js
var s1 = v((Jc) => {
  "use strict";
  Object.defineProperty(Jc, "__esModule", {
    value: !0
  });
  Jc.default = void 0;
  var UJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "acknowledgments [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, bMe = Jc.default = UJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docAfterwordRole.js
var a1 = v((Zc) => {
  "use strict";
  Object.defineProperty(Zc, "__esModule", {
    value: !0
  });
  Zc.default = void 0;
  var HJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "afterword [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, vMe = Zc.default = HJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docAppendixRole.js
var l1 = v((Qc) => {
  "use strict";
  Object.defineProperty(Qc, "__esModule", {
    value: !0
  });
  Qc.default = void 0;
  var VJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "appendix [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, TMe = Qc.default = VJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docBacklinkRole.js
var u1 = v((ed) => {
  "use strict";
  Object.defineProperty(ed, "__esModule", {
    value: !0
  });
  ed.default = void 0;
  var zJ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "referrer [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, RMe = ed.default = zJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docBiblioentryRole.js
var c1 = v((td) => {
  "use strict";
  Object.defineProperty(td, "__esModule", {
    value: !0
  });
  td.default = void 0;
  var GJ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "EPUB biblioentry [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: ["doc-bibliography"],
    requiredContextRole: ["doc-bibliography"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "listitem"]]
  }, SMe = td.default = GJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docBibliographyRole.js
var d1 = v((rd) => {
  "use strict";
  Object.defineProperty(rd, "__esModule", {
    value: !0
  });
  rd.default = void 0;
  var YJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "bibliography [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["doc-biblioentry"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, CMe = rd.default = YJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docBibliorefRole.js
var p1 = v((nd) => {
  "use strict";
  Object.defineProperty(nd, "__esModule", {
    value: !0
  });
  nd.default = void 0;
  var WJ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "biblioref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, AMe = nd.default = WJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docChapterRole.js
var f1 = v((od) => {
  "use strict";
  Object.defineProperty(od, "__esModule", {
    value: !0
  });
  od.default = void 0;
  var KJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "chapter [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, qMe = od.default = KJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docColophonRole.js
var m1 = v((id) => {
  "use strict";
  Object.defineProperty(id, "__esModule", {
    value: !0
  });
  id.default = void 0;
  var XJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "colophon [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, MMe = id.default = XJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docConclusionRole.js
var h1 = v((sd) => {
  "use strict";
  Object.defineProperty(sd, "__esModule", {
    value: !0
  });
  sd.default = void 0;
  var JJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "conclusion [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, jMe = sd.default = JJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docCoverRole.js
var y1 = v((ad) => {
  "use strict";
  Object.defineProperty(ad, "__esModule", {
    value: !0
  });
  ad.default = void 0;
  var ZJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "cover [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "img"]]
  }, FMe = ad.default = ZJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docCreditRole.js
var b1 = v((ld) => {
  "use strict";
  Object.defineProperty(ld, "__esModule", {
    value: !0
  });
  ld.default = void 0;
  var QJ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "credit [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, DMe = ld.default = QJ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docCreditsRole.js
var g1 = v((ud) => {
  "use strict";
  Object.defineProperty(ud, "__esModule", {
    value: !0
  });
  ud.default = void 0;
  var eZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "credits [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, BMe = ud.default = eZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docDedicationRole.js
var v1 = v((cd) => {
  "use strict";
  Object.defineProperty(cd, "__esModule", {
    value: !0
  });
  cd.default = void 0;
  var tZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "dedication [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, HMe = cd.default = tZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docEndnoteRole.js
var E1 = v((dd) => {
  "use strict";
  Object.defineProperty(dd, "__esModule", {
    value: !0
  });
  dd.default = void 0;
  var rZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "rearnote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: ["doc-endnotes"],
    requiredContextRole: ["doc-endnotes"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "listitem"]]
  }, zMe = dd.default = rZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docEndnotesRole.js
var T1 = v((pd) => {
  "use strict";
  Object.defineProperty(pd, "__esModule", {
    value: !0
  });
  pd.default = void 0;
  var nZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "rearnotes [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["doc-endnote"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, YMe = pd.default = nZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docEpigraphRole.js
var _1 = v((fd) => {
  "use strict";
  Object.defineProperty(fd, "__esModule", {
    value: !0
  });
  fd.default = void 0;
  var oZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "epigraph [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, KMe = fd.default = oZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docEpilogueRole.js
var R1 = v((md) => {
  "use strict";
  Object.defineProperty(md, "__esModule", {
    value: !0
  });
  md.default = void 0;
  var iZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "epilogue [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, JMe = md.default = iZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docErrataRole.js
var w1 = v((hd) => {
  "use strict";
  Object.defineProperty(hd, "__esModule", {
    value: !0
  });
  hd.default = void 0;
  var sZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "errata [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, QMe = hd.default = sZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docExampleRole.js
var S1 = v((yd) => {
  "use strict";
  Object.defineProperty(yd, "__esModule", {
    value: !0
  });
  yd.default = void 0;
  var aZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, tNe = yd.default = aZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docFootnoteRole.js
var x1 = v((bd) => {
  "use strict";
  Object.defineProperty(bd, "__esModule", {
    value: !0
  });
  bd.default = void 0;
  var lZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "footnote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, nNe = bd.default = lZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docForewordRole.js
var C1 = v((gd) => {
  "use strict";
  Object.defineProperty(gd, "__esModule", {
    value: !0
  });
  gd.default = void 0;
  var uZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "foreword [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, iNe = gd.default = uZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docGlossaryRole.js
var P1 = v((vd) => {
  "use strict";
  Object.defineProperty(vd, "__esModule", {
    value: !0
  });
  vd.default = void 0;
  var cZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "glossary [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["definition"], ["term"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, aNe = vd.default = cZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docGlossrefRole.js
var A1 = v((Ed) => {
  "use strict";
  Object.defineProperty(Ed, "__esModule", {
    value: !0
  });
  Ed.default = void 0;
  var dZ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "glossref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, uNe = Ed.default = dZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docIndexRole.js
var O1 = v((Td) => {
  "use strict";
  Object.defineProperty(Td, "__esModule", {
    value: !0
  });
  Td.default = void 0;
  var pZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "index [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, dNe = Td.default = pZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docIntroductionRole.js
var q1 = v((_d) => {
  "use strict";
  Object.defineProperty(_d, "__esModule", {
    value: !0
  });
  _d.default = void 0;
  var fZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "introduction [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, fNe = _d.default = fZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docNoterefRole.js
var I1 = v((Rd) => {
  "use strict";
  Object.defineProperty(Rd, "__esModule", {
    value: !0
  });
  Rd.default = void 0;
  var mZ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "noteref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, hNe = Rd.default = mZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docNoticeRole.js
var M1 = v((wd) => {
  "use strict";
  Object.defineProperty(wd, "__esModule", {
    value: !0
  });
  wd.default = void 0;
  var hZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "notice [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "note"]]
  }, bNe = wd.default = hZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPagebreakRole.js
var N1 = v((Sd) => {
  "use strict";
  Object.defineProperty(Sd, "__esModule", {
    value: !0
  });
  Sd.default = void 0;
  var yZ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "pagebreak [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "separator"]]
  }, vNe = Sd.default = yZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPagefooterRole.js
var j1 = v((xd) => {
  "use strict";
  Object.defineProperty(xd, "__esModule", {
    value: !0
  });
  xd.default = void 0;
  var bZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: [],
    props: {
      "aria-braillelabel": null,
      "aria-brailleroledescription": null,
      "aria-description": null,
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, TNe = xd.default = bZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPageheaderRole.js
var L1 = v((Cd) => {
  "use strict";
  Object.defineProperty(Cd, "__esModule", {
    value: !0
  });
  Cd.default = void 0;
  var gZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: [],
    props: {
      "aria-braillelabel": null,
      "aria-brailleroledescription": null,
      "aria-description": null,
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, RNe = Cd.default = gZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPagelistRole.js
var F1 = v((Pd) => {
  "use strict";
  Object.defineProperty(Pd, "__esModule", {
    value: !0
  });
  Pd.default = void 0;
  var vZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "page-list [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, SNe = Pd.default = vZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPartRole.js
var k1 = v((Ad) => {
  "use strict";
  Object.defineProperty(Ad, "__esModule", {
    value: !0
  });
  Ad.default = void 0;
  var EZ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "part [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, CNe = Ad.default = EZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPrefaceRole.js
var D1 = v((Od) => {
  "use strict";
  Object.defineProperty(Od, "__esModule", {
    value: !0
  });
  Od.default = void 0;
  var TZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "preface [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, ANe = Od.default = TZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPrologueRole.js
var $1 = v((qd) => {
  "use strict";
  Object.defineProperty(qd, "__esModule", {
    value: !0
  });
  qd.default = void 0;
  var _Z = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "prologue [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, qNe = qd.default = _Z;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docPullquoteRole.js
var B1 = v((Id) => {
  "use strict";
  Object.defineProperty(Id, "__esModule", {
    value: !0
  });
  Id.default = void 0;
  var RZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "pullquote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["none"]]
  }, MNe = Id.default = RZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docQnaRole.js
var U1 = v((Md) => {
  "use strict";
  Object.defineProperty(Md, "__esModule", {
    value: !0
  });
  Md.default = void 0;
  var wZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "qna [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, jNe = Md.default = wZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docSubtitleRole.js
var H1 = v((Nd) => {
  "use strict";
  Object.defineProperty(Nd, "__esModule", {
    value: !0
  });
  Nd.default = void 0;
  var SZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "subtitle [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "sectionhead"]]
  }, FNe = Nd.default = SZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docTipRole.js
var V1 = v((jd) => {
  "use strict";
  Object.defineProperty(jd, "__esModule", {
    value: !0
  });
  jd.default = void 0;
  var xZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "help [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "note"]]
  }, DNe = jd.default = xZ;
});

// ../node_modules/aria-query/lib/etc/roles/dpub/docTocRole.js
var z1 = v((Ld) => {
  "use strict";
  Object.defineProperty(Ld, "__esModule", {
    value: !0
  });
  Ld.default = void 0;
  var CZ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "toc [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, BNe = Ld.default = CZ;
});

// ../node_modules/aria-query/lib/etc/roles/ariaDpubRoles.js
var G1 = v((Fd) => {
  "use strict";
  Object.defineProperty(Fd, "__esModule", {
    value: !0
  });
  Fd.default = void 0;
  var PZ = oe(i1()), AZ = oe(s1()), OZ = oe(a1()), qZ = oe(l1()), IZ = oe(u1()), MZ = oe(c1()), NZ = oe(d1()), jZ = oe(p1()), LZ = oe(f1()),
  FZ = oe(m1()), kZ = oe(h1()), DZ = oe(y1()), $Z = oe(b1()), BZ = oe(g1()), UZ = oe(v1()), HZ = oe(E1()), VZ = oe(T1()), zZ = oe(_1()), GZ = oe(
  R1()), YZ = oe(w1()), WZ = oe(S1()), KZ = oe(x1()), XZ = oe(C1()), JZ = oe(P1()), ZZ = oe(A1()), QZ = oe(O1()), eQ = oe(q1()), tQ = oe(I1()),
  rQ = oe(M1()), nQ = oe(N1()), oQ = oe(j1()), iQ = oe(L1()), sQ = oe(F1()), aQ = oe(k1()), lQ = oe(D1()), uQ = oe($1()), cQ = oe(B1()), dQ = oe(
  U1()), pQ = oe(H1()), fQ = oe(V1()), mQ = oe(z1());
  function oe(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(oe, "_interopRequireDefault");
  var hQ = [["doc-abstract", PZ.default], ["doc-acknowledgments", AZ.default], ["doc-afterword", OZ.default], ["doc-appendix", qZ.default], [
  "doc-backlink", IZ.default], ["doc-biblioentry", MZ.default], ["doc-bibliography", NZ.default], ["doc-biblioref", jZ.default], ["doc-chapt\
er", LZ.default], ["doc-colophon", FZ.default], ["doc-conclusion", kZ.default], ["doc-cover", DZ.default], ["doc-credit", $Z.default], ["doc\
-credits", BZ.default], ["doc-dedication", UZ.default], ["doc-endnote", HZ.default], ["doc-endnotes", VZ.default], ["doc-epigraph", zZ.default],
  ["doc-epilogue", GZ.default], ["doc-errata", YZ.default], ["doc-example", WZ.default], ["doc-footnote", KZ.default], ["doc-foreword", XZ.default],
  ["doc-glossary", JZ.default], ["doc-glossref", ZZ.default], ["doc-index", QZ.default], ["doc-introduction", eQ.default], ["doc-noteref", tQ.
  default], ["doc-notice", rQ.default], ["doc-pagebreak", nQ.default], ["doc-pagefooter", oQ.default], ["doc-pageheader", iQ.default], ["doc\
-pagelist", sQ.default], ["doc-part", aQ.default], ["doc-preface", lQ.default], ["doc-prologue", uQ.default], ["doc-pullquote", cQ.default],
  ["doc-qna", dQ.default], ["doc-subtitle", pQ.default], ["doc-tip", fQ.default], ["doc-toc", mQ.default]], HNe = Fd.default = hQ;
});

// ../node_modules/aria-query/lib/etc/roles/graphics/graphicsDocumentRole.js
var Y1 = v((kd) => {
  "use strict";
  Object.defineProperty(kd, "__esModule", {
    value: !0
  });
  kd.default = void 0;
  var yQ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      module: "GRAPHICS",
      concept: {
        name: "graphics-object"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "img"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "article"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "document"]]
  }, GNe = kd.default = yQ;
});

// ../node_modules/aria-query/lib/etc/roles/graphics/graphicsObjectRole.js
var W1 = v((Dd) => {
  "use strict";
  Object.defineProperty(Dd, "__esModule", {
    value: !0
  });
  Dd.default = void 0;
  var bQ = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      module: "GRAPHICS",
      concept: {
        name: "graphics-document"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "group"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "img"
      }
    }, {
      module: "GRAPHICS",
      concept: {
        name: "graphics-symbol"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"]]
  }, WNe = Dd.default = bQ;
});

// ../node_modules/aria-query/lib/etc/roles/graphics/graphicsSymbolRole.js
var K1 = v(($d) => {
  "use strict";
  Object.defineProperty($d, "__esModule", {
    value: !0
  });
  $d.default = void 0;
  var gQ = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "img"]]
  }, XNe = $d.default = gQ;
});

// ../node_modules/aria-query/lib/etc/roles/ariaGraphicsRoles.js
var X1 = v((Bd) => {
  "use strict";
  Object.defineProperty(Bd, "__esModule", {
    value: !0
  });
  Bd.default = void 0;
  var vQ = VE(Y1()), EQ = VE(W1()), TQ = VE(K1());
  function VE(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(VE, "_interopRequireDefault");
  var _Q = [["graphics-document", vQ.default], ["graphics-object", EQ.default], ["graphics-symbol", TQ.default]], ZNe = Bd.default = _Q;
});

// ../node_modules/aria-query/lib/rolesMap.js
var Hd = v((Ud) => {
  "use strict";
  Object.defineProperty(Ud, "__esModule", {
    value: !0
  });
  Ud.default = void 0;
  var RQ = Ss(PA()), wQ = Ss(o1()), SQ = Ss(G1()), xQ = Ss(X1()), CQ = Ss(Bo());
  function Ss(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(Ss, "_interopRequireDefault");
  function zE(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = Z1(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s, a = !0, l = !1;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return a = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      l = !0, s = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        a || r.return == null || r.return();
      } finally {
        if (l) throw s;
      }
    }, "f") };
  }
  o(zE, "_createForOfIteratorHelper");
  function ws(e, t) {
    return OQ(e) || AQ(e, t) || Z1(e, t) || PQ();
  }
  o(ws, "_slicedToArray");
  function PQ() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(PQ, "_nonIterableRest");
  function Z1(e, t) {
    if (e) {
      if (typeof e == "string") return J1(e, t);
      var r = {}.toString.call(e).slice(8, -1);
      return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.
      test(r) ? J1(e, t) : void 0;
    }
  }
  o(Z1, "_unsupportedIterableToArray");
  function J1(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  o(J1, "_arrayLikeToArray");
  function AQ(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, s, a, l = [], u = !0, c = !1;
      try {
        if (s = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          u = !1;
        } else for (; !(u = (n = s.call(r)).done) && (l.push(n.value), l.length !== t); u = !0) ;
      } catch (d) {
        c = !0, i = d;
      } finally {
        try {
          if (!u && r.return != null && (a = r.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw i;
        }
      }
      return l;
    }
  }
  o(AQ, "_iterableToArrayLimit");
  function OQ(e) {
    if (Array.isArray(e)) return e;
  }
  o(OQ, "_arrayWithHoles");
  var Gr = [].concat(RQ.default, wQ.default, SQ.default, xQ.default);
  Gr.forEach(function(e) {
    var t = ws(e, 2), r = t[1], n = zE(r.superClass), i;
    try {
      for (n.s(); !(i = n.n()).done; ) {
        var s = i.value, a = zE(s), l;
        try {
          var u = /* @__PURE__ */ o(function() {
            var d = l.value, p = Gr.filter(function(b) {
              var g = ws(b, 1), T = g[0];
              return T === d;
            })[0];
            if (p)
              for (var y = p[1], f = 0, m = Object.keys(y.props); f < m.length; f++) {
                var h = m[f];
                Object.prototype.hasOwnProperty.call(r.props, h) || (r.props[h] = y.props[h]);
              }
          }, "_loop");
          for (a.s(); !(l = a.n()).done; )
            u();
        } catch (c) {
          a.e(c);
        } finally {
          a.f();
        }
      }
    } catch (c) {
      n.e(c);
    } finally {
      n.f();
    }
  });
  var GE = {
    entries: /* @__PURE__ */ o(function() {
      return Gr;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = zE(Gr), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var s = ws(i.value, 2), a = s[0], l = s[1];
          t.call(r, l, a, Gr);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = Gr.filter(function(n) {
        return n[0] === t;
      })[0];
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!GE.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return Gr.map(function(t) {
        var r = ws(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return Gr.map(function(t) {
        var r = ws(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, tje = Ud.default = (0, CQ.default)(GE, GE.entries());
});

// ../node_modules/aria-query/lib/elementRoleMap.js
var iq = v((Wd) => {
  "use strict";
  Object.defineProperty(Wd, "__esModule", {
    value: !0
  });
  Wd.default = void 0;
  var qQ = nq(Bo()), rq = nq(Hd());
  function nq(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(nq, "_interopRequireDefault");
  function YE(e, t) {
    return jQ(e) || NQ(e, t) || MQ(e, t) || IQ();
  }
  o(YE, "_slicedToArray");
  function IQ() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(IQ, "_nonIterableRest");
  function MQ(e, t) {
    if (e) {
      if (typeof e == "string") return Q1(e, t);
      var r = {}.toString.call(e).slice(8, -1);
      return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.
      test(r) ? Q1(e, t) : void 0;
    }
  }
  o(MQ, "_unsupportedIterableToArray");
  function Q1(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  o(Q1, "_arrayLikeToArray");
  function NQ(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, s, a, l = [], u = !0, c = !1;
      try {
        if (s = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          u = !1;
        } else for (; !(u = (n = s.call(r)).done) && (l.push(n.value), l.length !== t); u = !0) ;
      } catch (d) {
        c = !0, i = d;
      } finally {
        try {
          if (!u && r.return != null && (a = r.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw i;
        }
      }
      return l;
    }
  }
  o(NQ, "_iterableToArrayLimit");
  function jQ(e) {
    if (Array.isArray(e)) return e;
  }
  o(jQ, "_arrayWithHoles");
  var Yr = [], eq = rq.default.keys();
  for (Vd = 0; Vd < eq.length; Vd++)
    if (zd = eq[Vd], Gd = rq.default.get(zd), Gd)
      for (WE = [].concat(Gd.baseConcepts, Gd.relatedConcepts), tq = /* @__PURE__ */ o(function() {
        var t = WE[Yd];
        if (t.module === "HTML") {
          var r = t.concept;
          if (r) {
            var n = Yr.filter(function(l) {
              return LQ(l[0], r);
            })[0], i;
            n ? i = n[1] : i = [];
            for (var s = !0, a = 0; a < i.length; a++)
              if (i[a] === zd) {
                s = !1;
                break;
              }
            s && i.push(zd), n || Yr.push([r, i]);
          }
        }
      }, "_loop"), Yd = 0; Yd < WE.length; Yd++)
        tq();
  var zd, Gd, WE, tq, Yd, Vd, KE = {
    entries: /* @__PURE__ */ o(function() {
      return Yr;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = 0, i = Yr; n < i.length; n++) {
        var s = YE(i[n], 2), a = s[0], l = s[1];
        t.call(r, l, a, Yr);
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = Yr.filter(function(n) {
        return t.name === n[0].name && oq(t.attributes, n[0].attributes);
      })[0];
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!KE.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return Yr.map(function(t) {
        var r = YE(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return Yr.map(function(t) {
        var r = YE(t, 2), n = r[1];
        return n;
      });
    }, "values")
  };
  function LQ(e, t) {
    return e.name === t.name && FQ(e.constraints, t.constraints) && oq(e.attributes, t.attributes);
  }
  o(LQ, "ariaRoleRelationConceptEquals");
  function FQ(e, t) {
    if (e === void 0 && t !== void 0 || e !== void 0 && t === void 0)
      return !1;
    if (e !== void 0 && t !== void 0) {
      if (e.length !== t.length)
        return !1;
      for (var r = 0; r < e.length; r++)
        if (e[r] !== t[r])
          return !1;
    }
    return !0;
  }
  o(FQ, "ariaRoleRelationConstraintsEquals");
  function oq(e, t) {
    if (e === void 0 && t !== void 0 || e !== void 0 && t === void 0)
      return !1;
    if (e !== void 0 && t !== void 0) {
      if (e.length !== t.length)
        return !1;
      for (var r = 0; r < e.length; r++) {
        if (e[r].name !== t[r].name || e[r].value !== t[r].value || e[r].constraints === void 0 && t[r].constraints !== void 0 || e[r].constraints !==
        void 0 && t[r].constraints === void 0)
          return !1;
        if (e[r].constraints !== void 0 && t[r].constraints !== void 0) {
          if (e[r].constraints.length !== t[r].constraints.length)
            return !1;
          for (var n = 0; n < e[r].constraints.length; n++)
            if (e[r].constraints[n] !== t[r].constraints[n])
              return !1;
        }
      }
    }
    return !0;
  }
  o(oq, "ariaRoleRelationConceptAttributeEquals");
  var oje = Wd.default = (0, qQ.default)(KE, KE.entries());
});

// ../node_modules/aria-query/lib/roleElementMap.js
var cq = v((Qd) => {
  "use strict";
  Object.defineProperty(Qd, "__esModule", {
    value: !0
  });
  Qd.default = void 0;
  var kQ = uq(Bo()), lq = uq(Hd());
  function uq(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(uq, "_interopRequireDefault");
  function XE(e, t) {
    return UQ(e) || BQ(e, t) || $Q(e, t) || DQ();
  }
  o(XE, "_slicedToArray");
  function DQ() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(DQ, "_nonIterableRest");
  function $Q(e, t) {
    if (e) {
      if (typeof e == "string") return sq(e, t);
      var r = {}.toString.call(e).slice(8, -1);
      return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.
      test(r) ? sq(e, t) : void 0;
    }
  }
  o($Q, "_unsupportedIterableToArray");
  function sq(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  o(sq, "_arrayLikeToArray");
  function BQ(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, s, a, l = [], u = !0, c = !1;
      try {
        if (s = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          u = !1;
        } else for (; !(u = (n = s.call(r)).done) && (l.push(n.value), l.length !== t); u = !0) ;
      } catch (d) {
        c = !0, i = d;
      } finally {
        try {
          if (!u && r.return != null && (a = r.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw i;
        }
      }
      return l;
    }
  }
  o(BQ, "_iterableToArrayLimit");
  function UQ(e) {
    if (Array.isArray(e)) return e;
  }
  o(UQ, "_arrayWithHoles");
  var Mn = [], aq = lq.default.keys();
  for (Kd = 0; Kd < aq.length; Kd++)
    if (JE = aq[Kd], Xd = lq.default.get(JE), Jd = [], Xd) {
      for (ZE = [].concat(Xd.baseConcepts, Xd.relatedConcepts), Zd = 0; Zd < ZE.length; Zd++)
        QE = ZE[Zd], QE.module === "HTML" && (eT = QE.concept, eT != null && Jd.push(eT));
      Jd.length > 0 && Mn.push([JE, Jd]);
    }
  var JE, Xd, Jd, ZE, QE, eT, Zd, Kd, tT = {
    entries: /* @__PURE__ */ o(function() {
      return Mn;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = 0, i = Mn; n < i.length; n++) {
        var s = XE(i[n], 2), a = s[0], l = s[1];
        t.call(r, l, a, Mn);
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = Mn.filter(function(n) {
        return n[0] === t;
      })[0];
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!tT.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return Mn.map(function(t) {
        var r = XE(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return Mn.map(function(t) {
        var r = XE(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, aje = Qd.default = (0, kQ.default)(tT, tT.entries());
});

// ../node_modules/aria-query/lib/index.js
var rT = v((Lt) => {
  "use strict";
  Object.defineProperty(Lt, "__esModule", {
    value: !0
  });
  Lt.roles = Lt.roleElements = Lt.elementRoles = Lt.dom = Lt.aria = void 0;
  var HQ = xs(fA()), VQ = xs(hA()), zQ = xs(Hd()), GQ = xs(iq()), YQ = xs(cq());
  function xs(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(xs, "_interopRequireDefault");
  var cje = Lt.aria = HQ.default, dje = Lt.dom = VQ.default, pje = Lt.roles = zQ.default, fje = Lt.elementRoles = GQ.default, mje = Lt.roleElements =
  YQ.default;
});

// ../node_modules/color-name/index.js
var pq = v((bje, dq) => {
  "use strict";
  dq.exports = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  };
});

// ../node_modules/color-convert/conversions.js
var nT = v((gje, mq) => {
  var Cs = pq(), fq = {};
  for (let e of Object.keys(Cs))
    fq[Cs[e]] = e;
  var K = {
    rgb: { channels: 3, labels: "rgb" },
    hsl: { channels: 3, labels: "hsl" },
    hsv: { channels: 3, labels: "hsv" },
    hwb: { channels: 3, labels: "hwb" },
    cmyk: { channels: 4, labels: "cmyk" },
    xyz: { channels: 3, labels: "xyz" },
    lab: { channels: 3, labels: "lab" },
    lch: { channels: 3, labels: "lch" },
    hex: { channels: 1, labels: ["hex"] },
    keyword: { channels: 1, labels: ["keyword"] },
    ansi16: { channels: 1, labels: ["ansi16"] },
    ansi256: { channels: 1, labels: ["ansi256"] },
    hcg: { channels: 3, labels: ["h", "c", "g"] },
    apple: { channels: 3, labels: ["r16", "g16", "b16"] },
    gray: { channels: 1, labels: ["gray"] }
  };
  mq.exports = K;
  for (let e of Object.keys(K)) {
    if (!("channels" in K[e]))
      throw new Error("missing channels property: " + e);
    if (!("labels" in K[e]))
      throw new Error("missing channel labels property: " + e);
    if (K[e].labels.length !== K[e].channels)
      throw new Error("channel and label counts mismatch: " + e);
    let { channels: t, labels: r } = K[e];
    delete K[e].channels, delete K[e].labels, Object.defineProperty(K[e], "channels", { value: t }), Object.defineProperty(K[e], "labels", {
    value: r });
  }
  K.rgb.hsl = function(e) {
    let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.min(t, r, n), s = Math.max(t, r, n), a = s - i, l, u;
    s === i ? l = 0 : t === s ? l = (r - n) / a : r === s ? l = 2 + (n - t) / a : n === s && (l = 4 + (t - r) / a), l = Math.min(l * 60, 360),
    l < 0 && (l += 360);
    let c = (i + s) / 2;
    return s === i ? u = 0 : c <= 0.5 ? u = a / (s + i) : u = a / (2 - s - i), [l, u * 100, c * 100];
  };
  K.rgb.hsv = function(e) {
    let t, r, n, i, s, a = e[0] / 255, l = e[1] / 255, u = e[2] / 255, c = Math.max(a, l, u), d = c - Math.min(a, l, u), p = /* @__PURE__ */ o(
    function(y) {
      return (c - y) / 6 / d + 1 / 2;
    }, "diffc");
    return d === 0 ? (i = 0, s = 0) : (s = d / c, t = p(a), r = p(l), n = p(u), a === c ? i = n - r : l === c ? i = 1 / 3 + t - n : u === c &&
    (i = 2 / 3 + r - t), i < 0 ? i += 1 : i > 1 && (i -= 1)), [
      i * 360,
      s * 100,
      c * 100
    ];
  };
  K.rgb.hwb = function(e) {
    let t = e[0], r = e[1], n = e[2], i = K.rgb.hsl(e)[0], s = 1 / 255 * Math.min(t, Math.min(r, n));
    return n = 1 - 1 / 255 * Math.max(t, Math.max(r, n)), [i, s * 100, n * 100];
  };
  K.rgb.cmyk = function(e) {
    let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.min(1 - t, 1 - r, 1 - n), s = (1 - t - i) / (1 - i) || 0, a = (1 - r - i) /
    (1 - i) || 0, l = (1 - n - i) / (1 - i) || 0;
    return [s * 100, a * 100, l * 100, i * 100];
  };
  function WQ(e, t) {
    return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2 + (e[2] - t[2]) ** 2;
  }
  o(WQ, "comparativeDistance");
  K.rgb.keyword = function(e) {
    let t = fq[e];
    if (t)
      return t;
    let r = 1 / 0, n;
    for (let i of Object.keys(Cs)) {
      let s = Cs[i], a = WQ(e, s);
      a < r && (r = a, n = i);
    }
    return n;
  };
  K.keyword.rgb = function(e) {
    return Cs[e];
  };
  K.rgb.xyz = function(e) {
    let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255;
    t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92, n = n > 0.04045 ?
    ((n + 0.055) / 1.055) ** 2.4 : n / 12.92;
    let i = t * 0.4124 + r * 0.3576 + n * 0.1805, s = t * 0.2126 + r * 0.7152 + n * 0.0722, a = t * 0.0193 + r * 0.1192 + n * 0.9505;
    return [i * 100, s * 100, a * 100];
  };
  K.rgb.lab = function(e) {
    let t = K.rgb.xyz(e), r = t[0], n = t[1], i = t[2];
    r /= 95.047, n /= 100, i /= 108.883, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n +
    16 / 116, i = i > 8856e-6 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
    let s = 116 * n - 16, a = 500 * (r - n), l = 200 * (n - i);
    return [s, a, l];
  };
  K.hsl.rgb = function(e) {
    let t = e[0] / 360, r = e[1] / 100, n = e[2] / 100, i, s, a;
    if (r === 0)
      return a = n * 255, [a, a, a];
    n < 0.5 ? i = n * (1 + r) : i = n + r - n * r;
    let l = 2 * n - i, u = [0, 0, 0];
    for (let c = 0; c < 3; c++)
      s = t + 1 / 3 * -(c - 1), s < 0 && s++, s > 1 && s--, 6 * s < 1 ? a = l + (i - l) * 6 * s : 2 * s < 1 ? a = i : 3 * s < 2 ? a = l + (i -
      l) * (2 / 3 - s) * 6 : a = l, u[c] = a * 255;
    return u;
  };
  K.hsl.hsv = function(e) {
    let t = e[0], r = e[1] / 100, n = e[2] / 100, i = r, s = Math.max(n, 0.01);
    n *= 2, r *= n <= 1 ? n : 2 - n, i *= s <= 1 ? s : 2 - s;
    let a = (n + r) / 2, l = n === 0 ? 2 * i / (s + i) : 2 * r / (n + r);
    return [t, l * 100, a * 100];
  };
  K.hsv.rgb = function(e) {
    let t = e[0] / 60, r = e[1] / 100, n = e[2] / 100, i = Math.floor(t) % 6, s = t - Math.floor(t), a = 255 * n * (1 - r), l = 255 * n * (1 -
    r * s), u = 255 * n * (1 - r * (1 - s));
    switch (n *= 255, i) {
      case 0:
        return [n, u, a];
      case 1:
        return [l, n, a];
      case 2:
        return [a, n, u];
      case 3:
        return [a, l, n];
      case 4:
        return [u, a, n];
      case 5:
        return [n, a, l];
    }
  };
  K.hsv.hsl = function(e) {
    let t = e[0], r = e[1] / 100, n = e[2] / 100, i = Math.max(n, 0.01), s, a;
    a = (2 - r) * n;
    let l = (2 - r) * i;
    return s = r * i, s /= l <= 1 ? l : 2 - l, s = s || 0, a /= 2, [t, s * 100, a * 100];
  };
  K.hwb.rgb = function(e) {
    let t = e[0] / 360, r = e[1] / 100, n = e[2] / 100, i = r + n, s;
    i > 1 && (r /= i, n /= i);
    let a = Math.floor(6 * t), l = 1 - n;
    s = 6 * t - a, (a & 1) !== 0 && (s = 1 - s);
    let u = r + s * (l - r), c, d, p;
    switch (a) {
      default:
      case 6:
      case 0:
        c = l, d = u, p = r;
        break;
      case 1:
        c = u, d = l, p = r;
        break;
      case 2:
        c = r, d = l, p = u;
        break;
      case 3:
        c = r, d = u, p = l;
        break;
      case 4:
        c = u, d = r, p = l;
        break;
      case 5:
        c = l, d = r, p = u;
        break;
    }
    return [c * 255, d * 255, p * 255];
  };
  K.cmyk.rgb = function(e) {
    let t = e[0] / 100, r = e[1] / 100, n = e[2] / 100, i = e[3] / 100, s = 1 - Math.min(1, t * (1 - i) + i), a = 1 - Math.min(1, r * (1 - i) +
    i), l = 1 - Math.min(1, n * (1 - i) + i);
    return [s * 255, a * 255, l * 255];
  };
  K.xyz.rgb = function(e) {
    let t = e[0] / 100, r = e[1] / 100, n = e[2] / 100, i, s, a;
    return i = t * 3.2406 + r * -1.5372 + n * -0.4986, s = t * -0.9689 + r * 1.8758 + n * 0.0415, a = t * 0.0557 + r * -0.204 + n * 1.057, i =
    i > 31308e-7 ? 1.055 * i ** (1 / 2.4) - 0.055 : i * 12.92, s = s > 31308e-7 ? 1.055 * s ** (1 / 2.4) - 0.055 : s * 12.92, a = a > 31308e-7 ?
    1.055 * a ** (1 / 2.4) - 0.055 : a * 12.92, i = Math.min(Math.max(0, i), 1), s = Math.min(Math.max(0, s), 1), a = Math.min(Math.max(0, a),
    1), [i * 255, s * 255, a * 255];
  };
  K.xyz.lab = function(e) {
    let t = e[0], r = e[1], n = e[2];
    t /= 95.047, r /= 100, n /= 108.883, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r +
    16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116;
    let i = 116 * r - 16, s = 500 * (t - r), a = 200 * (r - n);
    return [i, s, a];
  };
  K.lab.xyz = function(e) {
    let t = e[0], r = e[1], n = e[2], i, s, a;
    s = (t + 16) / 116, i = r / 500 + s, a = s - n / 200;
    let l = s ** 3, u = i ** 3, c = a ** 3;
    return s = l > 8856e-6 ? l : (s - 16 / 116) / 7.787, i = u > 8856e-6 ? u : (i - 16 / 116) / 7.787, a = c > 8856e-6 ? c : (a - 16 / 116) /
    7.787, i *= 95.047, s *= 100, a *= 108.883, [i, s, a];
  };
  K.lab.lch = function(e) {
    let t = e[0], r = e[1], n = e[2], i;
    i = Math.atan2(n, r) * 360 / 2 / Math.PI, i < 0 && (i += 360);
    let a = Math.sqrt(r * r + n * n);
    return [t, a, i];
  };
  K.lch.lab = function(e) {
    let t = e[0], r = e[1], i = e[2] / 360 * 2 * Math.PI, s = r * Math.cos(i), a = r * Math.sin(i);
    return [t, s, a];
  };
  K.rgb.ansi16 = function(e, t = null) {
    let [r, n, i] = e, s = t === null ? K.rgb.hsv(e)[2] : t;
    if (s = Math.round(s / 50), s === 0)
      return 30;
    let a = 30 + (Math.round(i / 255) << 2 | Math.round(n / 255) << 1 | Math.round(r / 255));
    return s === 2 && (a += 60), a;
  };
  K.hsv.ansi16 = function(e) {
    return K.rgb.ansi16(K.hsv.rgb(e), e[2]);
  };
  K.rgb.ansi256 = function(e) {
    let t = e[0], r = e[1], n = e[2];
    return t === r && r === n ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.
    round(r / 255 * 5) + Math.round(n / 255 * 5);
  };
  K.ansi16.rgb = function(e) {
    let t = e % 10;
    if (t === 0 || t === 7)
      return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
    let r = (~~(e > 50) + 1) * 0.5, n = (t & 1) * r * 255, i = (t >> 1 & 1) * r * 255, s = (t >> 2 & 1) * r * 255;
    return [n, i, s];
  };
  K.ansi256.rgb = function(e) {
    if (e >= 232) {
      let s = (e - 232) * 10 + 8;
      return [s, s, s];
    }
    e -= 16;
    let t, r = Math.floor(e / 36) / 5 * 255, n = Math.floor((t = e % 36) / 6) / 5 * 255, i = t % 6 / 5 * 255;
    return [r, n, i];
  };
  K.rgb.hex = function(e) {
    let r = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
    return "000000".substring(r.length) + r;
  };
  K.hex.rgb = function(e) {
    let t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!t)
      return [0, 0, 0];
    let r = t[0];
    t[0].length === 3 && (r = r.split("").map((l) => l + l).join(""));
    let n = parseInt(r, 16), i = n >> 16 & 255, s = n >> 8 & 255, a = n & 255;
    return [i, s, a];
  };
  K.rgb.hcg = function(e) {
    let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.max(Math.max(t, r), n), s = Math.min(Math.min(t, r), n), a = i - s, l, u;
    return a < 1 ? l = s / (1 - a) : l = 0, a <= 0 ? u = 0 : i === t ? u = (r - n) / a % 6 : i === r ? u = 2 + (n - t) / a : u = 4 + (t - r) /
    a, u /= 6, u %= 1, [u * 360, a * 100, l * 100];
  };
  K.hsl.hcg = function(e) {
    let t = e[1] / 100, r = e[2] / 100, n = r < 0.5 ? 2 * t * r : 2 * t * (1 - r), i = 0;
    return n < 1 && (i = (r - 0.5 * n) / (1 - n)), [e[0], n * 100, i * 100];
  };
  K.hsv.hcg = function(e) {
    let t = e[1] / 100, r = e[2] / 100, n = t * r, i = 0;
    return n < 1 && (i = (r - n) / (1 - n)), [e[0], n * 100, i * 100];
  };
  K.hcg.rgb = function(e) {
    let t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
    if (r === 0)
      return [n * 255, n * 255, n * 255];
    let i = [0, 0, 0], s = t % 1 * 6, a = s % 1, l = 1 - a, u = 0;
    switch (Math.floor(s)) {
      case 0:
        i[0] = 1, i[1] = a, i[2] = 0;
        break;
      case 1:
        i[0] = l, i[1] = 1, i[2] = 0;
        break;
      case 2:
        i[0] = 0, i[1] = 1, i[2] = a;
        break;
      case 3:
        i[0] = 0, i[1] = l, i[2] = 1;
        break;
      case 4:
        i[0] = a, i[1] = 0, i[2] = 1;
        break;
      default:
        i[0] = 1, i[1] = 0, i[2] = l;
    }
    return u = (1 - r) * n, [
      (r * i[0] + u) * 255,
      (r * i[1] + u) * 255,
      (r * i[2] + u) * 255
    ];
  };
  K.hcg.hsv = function(e) {
    let t = e[1] / 100, r = e[2] / 100, n = t + r * (1 - t), i = 0;
    return n > 0 && (i = t / n), [e[0], i * 100, n * 100];
  };
  K.hcg.hsl = function(e) {
    let t = e[1] / 100, n = e[2] / 100 * (1 - t) + 0.5 * t, i = 0;
    return n > 0 && n < 0.5 ? i = t / (2 * n) : n >= 0.5 && n < 1 && (i = t / (2 * (1 - n))), [e[0], i * 100, n * 100];
  };
  K.hcg.hwb = function(e) {
    let t = e[1] / 100, r = e[2] / 100, n = t + r * (1 - t);
    return [e[0], (n - t) * 100, (1 - n) * 100];
  };
  K.hwb.hcg = function(e) {
    let t = e[1] / 100, n = 1 - e[2] / 100, i = n - t, s = 0;
    return i < 1 && (s = (n - i) / (1 - i)), [e[0], i * 100, s * 100];
  };
  K.apple.rgb = function(e) {
    return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
  };
  K.rgb.apple = function(e) {
    return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
  };
  K.gray.rgb = function(e) {
    return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
  };
  K.gray.hsl = function(e) {
    return [0, 0, e[0]];
  };
  K.gray.hsv = K.gray.hsl;
  K.gray.hwb = function(e) {
    return [0, 100, e[0]];
  };
  K.gray.cmyk = function(e) {
    return [0, 0, 0, e[0]];
  };
  K.gray.lab = function(e) {
    return [e[0], 0, 0];
  };
  K.gray.hex = function(e) {
    let t = Math.round(e[0] / 100 * 255) & 255, n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
    return "000000".substring(n.length) + n;
  };
  K.rgb.gray = function(e) {
    return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
  };
});

// ../node_modules/color-convert/route.js
var yq = v((Eje, hq) => {
  var ep = nT();
  function KQ() {
    let e = {}, t = Object.keys(ep);
    for (let r = t.length, n = 0; n < r; n++)
      e[t[n]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
      };
    return e;
  }
  o(KQ, "buildGraph");
  function XQ(e) {
    let t = KQ(), r = [e];
    for (t[e].distance = 0; r.length; ) {
      let n = r.pop(), i = Object.keys(ep[n]);
      for (let s = i.length, a = 0; a < s; a++) {
        let l = i[a], u = t[l];
        u.distance === -1 && (u.distance = t[n].distance + 1, u.parent = n, r.unshift(l));
      }
    }
    return t;
  }
  o(XQ, "deriveBFS");
  function JQ(e, t) {
    return function(r) {
      return t(e(r));
    };
  }
  o(JQ, "link");
  function ZQ(e, t) {
    let r = [t[e].parent, e], n = ep[t[e].parent][e], i = t[e].parent;
    for (; t[i].parent; )
      r.unshift(t[i].parent), n = JQ(ep[t[i].parent][i], n), i = t[i].parent;
    return n.conversion = r, n;
  }
  o(ZQ, "wrapConversion");
  hq.exports = function(e) {
    let t = XQ(e), r = {}, n = Object.keys(t);
    for (let i = n.length, s = 0; s < i; s++) {
      let a = n[s];
      t[a].parent !== null && (r[a] = ZQ(a, t));
    }
    return r;
  };
});

// ../node_modules/color-convert/index.js
var gq = v((_je, bq) => {
  var oT = nT(), QQ = yq(), Vo = {}, eee = Object.keys(oT);
  function tee(e) {
    let t = /* @__PURE__ */ o(function(...r) {
      let n = r[0];
      return n == null ? n : (n.length > 1 && (r = n), e(r));
    }, "wrappedFn");
    return "conversion" in e && (t.conversion = e.conversion), t;
  }
  o(tee, "wrapRaw");
  function ree(e) {
    let t = /* @__PURE__ */ o(function(...r) {
      let n = r[0];
      if (n == null)
        return n;
      n.length > 1 && (r = n);
      let i = e(r);
      if (typeof i == "object")
        for (let s = i.length, a = 0; a < s; a++)
          i[a] = Math.round(i[a]);
      return i;
    }, "wrappedFn");
    return "conversion" in e && (t.conversion = e.conversion), t;
  }
  o(ree, "wrapRounded");
  eee.forEach((e) => {
    Vo[e] = {}, Object.defineProperty(Vo[e], "channels", { value: oT[e].channels }), Object.defineProperty(Vo[e], "labels", { value: oT[e].labels });
    let t = QQ(e);
    Object.keys(t).forEach((n) => {
      let i = t[n];
      Vo[e][n] = ree(i), Vo[e][n].raw = tee(i);
    });
  });
  bq.exports = Vo;
});

// ../node_modules/ansi-styles/index.js
var wq = v((wje, Rq) => {
  "use strict";
  var vq = /* @__PURE__ */ o((e, t) => (...r) => `\x1B[${e(...r) + t}m`, "wrapAnsi16"), Eq = /* @__PURE__ */ o((e, t) => (...r) => {
    let n = e(...r);
    return `\x1B[${38 + t};5;${n}m`;
  }, "wrapAnsi256"), Tq = /* @__PURE__ */ o((e, t) => (...r) => {
    let n = e(...r);
    return `\x1B[${38 + t};2;${n[0]};${n[1]};${n[2]}m`;
  }, "wrapAnsi16m"), tp = /* @__PURE__ */ o((e) => e, "ansi2ansi"), _q = /* @__PURE__ */ o((e, t, r) => [e, t, r], "rgb2rgb"), zo = /* @__PURE__ */ o(
  (e, t, r) => {
    Object.defineProperty(e, t, {
      get: /* @__PURE__ */ o(() => {
        let n = r();
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0
        }), n;
      }, "get"),
      enumerable: !0,
      configurable: !0
    });
  }, "setLazyProperty"), iT, Go = /* @__PURE__ */ o((e, t, r, n) => {
    iT === void 0 && (iT = gq());
    let i = n ? 10 : 0, s = {};
    for (let [a, l] of Object.entries(iT)) {
      let u = a === "ansi16" ? "ansi" : a;
      a === t ? s[u] = e(r, i) : typeof l == "object" && (s[u] = e(l[t], i));
    }
    return s;
  }, "makeDynamicStyles");
  function nee() {
    let e = /* @__PURE__ */ new Map(), t = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    t.color.gray = t.color.blackBright, t.bgColor.bgGray = t.bgColor.bgBlackBright, t.color.grey = t.color.blackBright, t.bgColor.bgGrey = t.
    bgColor.bgBlackBright;
    for (let [r, n] of Object.entries(t)) {
      for (let [i, s] of Object.entries(n))
        t[i] = {
          open: `\x1B[${s[0]}m`,
          close: `\x1B[${s[1]}m`
        }, n[i] = t[i], e.set(s[0], s[1]);
      Object.defineProperty(t, r, {
        value: n,
        enumerable: !1
      });
    }
    return Object.defineProperty(t, "codes", {
      value: e,
      enumerable: !1
    }), t.color.close = "\x1B[39m", t.bgColor.close = "\x1B[49m", zo(t.color, "ansi", () => Go(vq, "ansi16", tp, !1)), zo(t.color, "ansi256",
    () => Go(Eq, "ansi256", tp, !1)), zo(t.color, "ansi16m", () => Go(Tq, "rgb", _q, !1)), zo(t.bgColor, "ansi", () => Go(vq, "ansi16", tp, !0)),
    zo(t.bgColor, "ansi256", () => Go(Eq, "ansi256", tp, !0)), zo(t.bgColor, "ansi16m", () => Go(Tq, "rgb", _q, !0)), t;
  }
  o(nee, "assembleStyles");
  Object.defineProperty(Rq, "exports", {
    enumerable: !0,
    get: nee
  });
});

// ../node_modules/supports-color/browser.js
var xq = v((xje, Sq) => {
  "use strict";
  Sq.exports = {
    stdout: !1,
    stderr: !1
  };
});

// ../node_modules/@testing-library/jest-dom/node_modules/chalk/source/util.js
var Pq = v((Cje, Cq) => {
  "use strict";
  var oee = /* @__PURE__ */ o((e, t, r) => {
    let n = e.indexOf(t);
    if (n === -1)
      return e;
    let i = t.length, s = 0, a = "";
    do
      a += e.substr(s, n - s) + t + r, s = n + i, n = e.indexOf(t, s);
    while (n !== -1);
    return a += e.substr(s), a;
  }, "stringReplaceAll"), iee = /* @__PURE__ */ o((e, t, r, n) => {
    let i = 0, s = "";
    do {
      let a = e[n - 1] === "\r";
      s += e.substr(i, (a ? n - 1 : n) - i) + t + (a ? `\r
` : `
`) + r, i = n + 1, n = e.indexOf(`
`, i);
    } while (n !== -1);
    return s += e.substr(i), s;
  }, "stringEncaseCRLFWithFirstIndex");
  Cq.exports = {
    stringReplaceAll: oee,
    stringEncaseCRLFWithFirstIndex: iee
  };
});

// ../node_modules/@testing-library/jest-dom/node_modules/chalk/source/templates.js
var Mq = v((Aje, Iq) => {
  "use strict";
  var see = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
  Aq = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g, aee = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/, lee = /\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.)|([^\\])/gi,
  uee = /* @__PURE__ */ new Map([
    ["n", `
`],
    ["r", "\r"],
    ["t", "	"],
    ["b", "\b"],
    ["f", "\f"],
    ["v", "\v"],
    ["0", "\0"],
    ["\\", "\\"],
    ["e", "\x1B"],
    ["a", "\x07"]
  ]);
  function qq(e) {
    let t = e[0] === "u", r = e[1] === "{";
    return t && !r && e.length === 5 || e[0] === "x" && e.length === 3 ? String.fromCharCode(parseInt(e.slice(1), 16)) : t && r ? String.fromCodePoint(
    parseInt(e.slice(2, -1), 16)) : uee.get(e) || e;
  }
  o(qq, "unescape");
  function cee(e, t) {
    let r = [], n = t.trim().split(/\s*,\s*/g), i;
    for (let s of n) {
      let a = Number(s);
      if (!Number.isNaN(a))
        r.push(a);
      else if (i = s.match(aee))
        r.push(i[2].replace(lee, (l, u, c) => u ? qq(u) : c));
      else
        throw new Error(`Invalid Chalk template style argument: ${s} (in style '${e}')`);
    }
    return r;
  }
  o(cee, "parseArguments");
  function dee(e) {
    Aq.lastIndex = 0;
    let t = [], r;
    for (; (r = Aq.exec(e)) !== null; ) {
      let n = r[1];
      if (r[2]) {
        let i = cee(n, r[2]);
        t.push([n].concat(i));
      } else
        t.push([n]);
    }
    return t;
  }
  o(dee, "parseStyle");
  function Oq(e, t) {
    let r = {};
    for (let i of t)
      for (let s of i.styles)
        r[s[0]] = i.inverse ? null : s.slice(1);
    let n = e;
    for (let [i, s] of Object.entries(r))
      if (Array.isArray(s)) {
        if (!(i in n))
          throw new Error(`Unknown Chalk style: ${i}`);
        n = s.length > 0 ? n[i](...s) : n[i];
      }
    return n;
  }
  o(Oq, "buildStyle");
  Iq.exports = (e, t) => {
    let r = [], n = [], i = [];
    if (t.replace(see, (s, a, l, u, c, d) => {
      if (a)
        i.push(qq(a));
      else if (u) {
        let p = i.join("");
        i = [], n.push(r.length === 0 ? p : Oq(e, r)(p)), r.push({ inverse: l, styles: dee(u) });
      } else if (c) {
        if (r.length === 0)
          throw new Error("Found extraneous } in Chalk template literal");
        n.push(Oq(e, r)(i.join(""))), i = [], r.pop();
      } else
        i.push(d);
    }), n.push(i.join("")), r.length > 0) {
      let s = `Chalk template literal is missing ${r.length} closing bracket${r.length === 1 ? "" : "s"} (\`}\`)`;
      throw new Error(s);
    }
    return n.join("");
  };
});

// ../node_modules/@testing-library/jest-dom/node_modules/chalk/source/index.js
var pT = v((qje, Fq) => {
  "use strict";
  var Ps = wq(), { stdout: aT, stderr: lT } = xq(), {
    stringReplaceAll: pee,
    stringEncaseCRLFWithFirstIndex: fee
  } = Pq(), Nq = [
    "ansi",
    "ansi",
    "ansi256",
    "ansi16m"
  ], Yo = /* @__PURE__ */ Object.create(null), mee = /* @__PURE__ */ o((e, t = {}) => {
    if (t.level > 3 || t.level < 0)
      throw new Error("The `level` option should be an integer from 0 to 3");
    let r = aT ? aT.level : 0;
    e.level = t.level === void 0 ? r : t.level;
  }, "applyOptions"), dT = class dT {
    constructor(t) {
      return jq(t);
    }
  };
  o(dT, "ChalkClass");
  var uT = dT, jq = /* @__PURE__ */ o((e) => {
    let t = {};
    return mee(t, e), t.template = (...r) => bee(t.template, ...r), Object.setPrototypeOf(t, rp.prototype), Object.setPrototypeOf(t.template,
    t), t.template.constructor = () => {
      throw new Error("`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.");
    }, t.template.Instance = uT, t.template;
  }, "chalkFactory");
  function rp(e) {
    return jq(e);
  }
  o(rp, "Chalk");
  for (let [e, t] of Object.entries(Ps))
    Yo[e] = {
      get() {
        let r = np(this, cT(t.open, t.close, this._styler), this._isEmpty);
        return Object.defineProperty(this, e, { value: r }), r;
      }
    };
  Yo.visible = {
    get() {
      let e = np(this, this._styler, !0);
      return Object.defineProperty(this, "visible", { value: e }), e;
    }
  };
  var Lq = ["rgb", "hex", "keyword", "hsl", "hsv", "hwb", "ansi", "ansi256"];
  for (let e of Lq)
    Yo[e] = {
      get() {
        let { level: t } = this;
        return function(...r) {
          let n = cT(Ps.color[Nq[t]][e](...r), Ps.color.close, this._styler);
          return np(this, n, this._isEmpty);
        };
      }
    };
  for (let e of Lq) {
    let t = "bg" + e[0].toUpperCase() + e.slice(1);
    Yo[t] = {
      get() {
        let { level: r } = this;
        return function(...n) {
          let i = cT(Ps.bgColor[Nq[r]][e](...n), Ps.bgColor.close, this._styler);
          return np(this, i, this._isEmpty);
        };
      }
    };
  }
  var hee = Object.defineProperties(() => {
  }, {
    ...Yo,
    level: {
      enumerable: !0,
      get() {
        return this._generator.level;
      },
      set(e) {
        this._generator.level = e;
      }
    }
  }), cT = /* @__PURE__ */ o((e, t, r) => {
    let n, i;
    return r === void 0 ? (n = e, i = t) : (n = r.openAll + e, i = t + r.closeAll), {
      open: e,
      close: t,
      openAll: n,
      closeAll: i,
      parent: r
    };
  }, "createStyler"), np = /* @__PURE__ */ o((e, t, r) => {
    let n = /* @__PURE__ */ o((...i) => yee(n, i.length === 1 ? "" + i[0] : i.join(" ")), "builder");
    return n.__proto__ = hee, n._generator = e, n._styler = t, n._isEmpty = r, n;
  }, "createBuilder"), yee = /* @__PURE__ */ o((e, t) => {
    if (e.level <= 0 || !t)
      return e._isEmpty ? "" : t;
    let r = e._styler;
    if (r === void 0)
      return t;
    let { openAll: n, closeAll: i } = r;
    if (t.indexOf("\x1B") !== -1)
      for (; r !== void 0; )
        t = pee(t, r.close, r.open), r = r.parent;
    let s = t.indexOf(`
`);
    return s !== -1 && (t = fee(t, i, n, s)), n + t + i;
  }, "applyStyle"), sT, bee = /* @__PURE__ */ o((e, ...t) => {
    let [r] = t;
    if (!Array.isArray(r))
      return t.join(" ");
    let n = t.slice(1), i = [r.raw[0]];
    for (let s = 1; s < r.length; s++)
      i.push(
        String(n[s - 1]).replace(/[{}\\]/g, "\\$&"),
        String(r.raw[s])
      );
    return sT === void 0 && (sT = Mq()), sT(e, i.join(""));
  }, "chalkTag");
  Object.defineProperties(rp.prototype, Yo);
  var As = rp();
  As.supportsColor = aT;
  As.stderr = rp({ level: lT ? lT.level : 0 });
  As.stderr.supportsColor = lT;
  As.Level = {
    None: 0,
    Basic: 1,
    Ansi256: 2,
    TrueColor: 3,
    0: "None",
    1: "Basic",
    2: "Ansi256",
    3: "TrueColor"
  };
  Fq.exports = As;
});

// ../node_modules/lodash/_listCacheClear.js
var Dq = v((Mje, kq) => {
  function gee() {
    this.__data__ = [], this.size = 0;
  }
  o(gee, "listCacheClear");
  kq.exports = gee;
});

// ../node_modules/lodash/eq.js
var fT = v((jje, $q) => {
  function vee(e, t) {
    return e === t || e !== e && t !== t;
  }
  o(vee, "eq");
  $q.exports = vee;
});

// ../node_modules/lodash/_assocIndexOf.js
var Os = v((Fje, Bq) => {
  var Eee = fT();
  function Tee(e, t) {
    for (var r = e.length; r--; )
      if (Eee(e[r][0], t))
        return r;
    return -1;
  }
  o(Tee, "assocIndexOf");
  Bq.exports = Tee;
});

// ../node_modules/lodash/_listCacheDelete.js
var Hq = v((Dje, Uq) => {
  var _ee = Os(), Ree = Array.prototype, wee = Ree.splice;
  function See(e) {
    var t = this.__data__, r = _ee(t, e);
    if (r < 0)
      return !1;
    var n = t.length - 1;
    return r == n ? t.pop() : wee.call(t, r, 1), --this.size, !0;
  }
  o(See, "listCacheDelete");
  Uq.exports = See;
});

// ../node_modules/lodash/_listCacheGet.js
var zq = v((Bje, Vq) => {
  var xee = Os();
  function Cee(e) {
    var t = this.__data__, r = xee(t, e);
    return r < 0 ? void 0 : t[r][1];
  }
  o(Cee, "listCacheGet");
  Vq.exports = Cee;
});

// ../node_modules/lodash/_listCacheHas.js
var Yq = v((Hje, Gq) => {
  var Pee = Os();
  function Aee(e) {
    return Pee(this.__data__, e) > -1;
  }
  o(Aee, "listCacheHas");
  Gq.exports = Aee;
});

// ../node_modules/lodash/_listCacheSet.js
var Kq = v((zje, Wq) => {
  var Oee = Os();
  function qee(e, t) {
    var r = this.__data__, n = Oee(r, e);
    return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
  }
  o(qee, "listCacheSet");
  Wq.exports = qee;
});

// ../node_modules/lodash/_ListCache.js
var qs = v((Yje, Xq) => {
  var Iee = Dq(), Mee = Hq(), Nee = zq(), jee = Yq(), Lee = Kq();
  function Wo(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.clear(); ++t < r; ) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }
  o(Wo, "ListCache");
  Wo.prototype.clear = Iee;
  Wo.prototype.delete = Mee;
  Wo.prototype.get = Nee;
  Wo.prototype.has = jee;
  Wo.prototype.set = Lee;
  Xq.exports = Wo;
});

// ../node_modules/lodash/_stackClear.js
var Zq = v((Kje, Jq) => {
  var Fee = qs();
  function kee() {
    this.__data__ = new Fee(), this.size = 0;
  }
  o(kee, "stackClear");
  Jq.exports = kee;
});

// ../node_modules/lodash/_stackDelete.js
var eI = v((Jje, Qq) => {
  function Dee(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
  }
  o(Dee, "stackDelete");
  Qq.exports = Dee;
});

// ../node_modules/lodash/_stackGet.js
var rI = v((Qje, tI) => {
  function $ee(e) {
    return this.__data__.get(e);
  }
  o($ee, "stackGet");
  tI.exports = $ee;
});

// ../node_modules/lodash/_stackHas.js
var oI = v((tLe, nI) => {
  function Bee(e) {
    return this.__data__.has(e);
  }
  o(Bee, "stackHas");
  nI.exports = Bee;
});

// ../node_modules/lodash/_freeGlobal.js
var mT = v((nLe, iI) => {
  var Uee = typeof global == "object" && global && global.Object === Object && global;
  iI.exports = Uee;
});

// ../node_modules/lodash/_root.js
var pr = v((oLe, sI) => {
  var Hee = mT(), Vee = typeof self == "object" && self && self.Object === Object && self, zee = Hee || Vee || Function("return this")();
  sI.exports = zee;
});

// ../node_modules/lodash/_Symbol.js
var op = v((iLe, aI) => {
  var Gee = pr(), Yee = Gee.Symbol;
  aI.exports = Yee;
});

// ../node_modules/lodash/_getRawTag.js
var dI = v((sLe, cI) => {
  var lI = op(), uI = Object.prototype, Wee = uI.hasOwnProperty, Kee = uI.toString, Is = lI ? lI.toStringTag : void 0;
  function Xee(e) {
    var t = Wee.call(e, Is), r = e[Is];
    try {
      e[Is] = void 0;
      var n = !0;
    } catch {
    }
    var i = Kee.call(e);
    return n && (t ? e[Is] = r : delete e[Is]), i;
  }
  o(Xee, "getRawTag");
  cI.exports = Xee;
});

// ../node_modules/lodash/_objectToString.js
var fI = v((lLe, pI) => {
  var Jee = Object.prototype, Zee = Jee.toString;
  function Qee(e) {
    return Zee.call(e);
  }
  o(Qee, "objectToString");
  pI.exports = Qee;
});

// ../node_modules/lodash/_baseGetTag.js
var Ms = v((cLe, yI) => {
  var mI = op(), ete = dI(), tte = fI(), rte = "[object Null]", nte = "[object Undefined]", hI = mI ? mI.toStringTag : void 0;
  function ote(e) {
    return e == null ? e === void 0 ? nte : rte : hI && hI in Object(e) ? ete(e) : tte(e);
  }
  o(ote, "baseGetTag");
  yI.exports = ote;
});

// ../node_modules/lodash/isObject.js
var hT = v((pLe, bI) => {
  function ite(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  o(ite, "isObject");
  bI.exports = ite;
});

// ../node_modules/lodash/isFunction.js
var yT = v((mLe, gI) => {
  var ste = Ms(), ate = hT(), lte = "[object AsyncFunction]", ute = "[object Function]", cte = "[object GeneratorFunction]", dte = "[object \
Proxy]";
  function pte(e) {
    if (!ate(e))
      return !1;
    var t = ste(e);
    return t == ute || t == cte || t == lte || t == dte;
  }
  o(pte, "isFunction");
  gI.exports = pte;
});

// ../node_modules/lodash/_coreJsData.js
var EI = v((yLe, vI) => {
  var fte = pr(), mte = fte["__core-js_shared__"];
  vI.exports = mte;
});

// ../node_modules/lodash/_isMasked.js
var RI = v((bLe, _I) => {
  var bT = EI(), TI = function() {
    var e = /[^.]+$/.exec(bT && bT.keys && bT.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }();
  function hte(e) {
    return !!TI && TI in e;
  }
  o(hte, "isMasked");
  _I.exports = hte;
});

// ../node_modules/lodash/_toSource.js
var gT = v((vLe, wI) => {
  var yte = Function.prototype, bte = yte.toString;
  function gte(e) {
    if (e != null) {
      try {
        return bte.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  o(gte, "toSource");
  wI.exports = gte;
});

// ../node_modules/lodash/_baseIsNative.js
var xI = v((TLe, SI) => {
  var vte = yT(), Ete = RI(), Tte = hT(), _te = gT(), Rte = /[\\^$.*+?()[\]{}|]/g, wte = /^\[object .+?Constructor\]$/, Ste = Function.prototype,
  xte = Object.prototype, Cte = Ste.toString, Pte = xte.hasOwnProperty, Ate = RegExp(
    "^" + Cte.call(Pte).replace(Rte, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function Ote(e) {
    if (!Tte(e) || Ete(e))
      return !1;
    var t = vte(e) ? Ate : wte;
    return t.test(_te(e));
  }
  o(Ote, "baseIsNative");
  SI.exports = Ote;
});

// ../node_modules/lodash/_getValue.js
var PI = v((RLe, CI) => {
  function qte(e, t) {
    return e?.[t];
  }
  o(qte, "getValue");
  CI.exports = qte;
});

// ../node_modules/lodash/_getNative.js
var Nn = v((SLe, AI) => {
  var Ite = xI(), Mte = PI();
  function Nte(e, t) {
    var r = Mte(e, t);
    return Ite(r) ? r : void 0;
  }
  o(Nte, "getNative");
  AI.exports = Nte;
});

// ../node_modules/lodash/_Map.js
var ip = v((CLe, OI) => {
  var jte = Nn(), Lte = pr(), Fte = jte(Lte, "Map");
  OI.exports = Fte;
});

// ../node_modules/lodash/_nativeCreate.js
var Ns = v((PLe, qI) => {
  var kte = Nn(), Dte = kte(Object, "create");
  qI.exports = Dte;
});

// ../node_modules/lodash/_hashClear.js
var NI = v((ALe, MI) => {
  var II = Ns();
  function $te() {
    this.__data__ = II ? II(null) : {}, this.size = 0;
  }
  o($te, "hashClear");
  MI.exports = $te;
});

// ../node_modules/lodash/_hashDelete.js
var LI = v((qLe, jI) => {
  function Bte(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  o(Bte, "hashDelete");
  jI.exports = Bte;
});

// ../node_modules/lodash/_hashGet.js
var kI = v((MLe, FI) => {
  var Ute = Ns(), Hte = "__lodash_hash_undefined__", Vte = Object.prototype, zte = Vte.hasOwnProperty;
  function Gte(e) {
    var t = this.__data__;
    if (Ute) {
      var r = t[e];
      return r === Hte ? void 0 : r;
    }
    return zte.call(t, e) ? t[e] : void 0;
  }
  o(Gte, "hashGet");
  FI.exports = Gte;
});

// ../node_modules/lodash/_hashHas.js
var $I = v((jLe, DI) => {
  var Yte = Ns(), Wte = Object.prototype, Kte = Wte.hasOwnProperty;
  function Xte(e) {
    var t = this.__data__;
    return Yte ? t[e] !== void 0 : Kte.call(t, e);
  }
  o(Xte, "hashHas");
  DI.exports = Xte;
});

// ../node_modules/lodash/_hashSet.js
var UI = v((FLe, BI) => {
  var Jte = Ns(), Zte = "__lodash_hash_undefined__";
  function Qte(e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = Jte && t === void 0 ? Zte : t, this;
  }
  o(Qte, "hashSet");
  BI.exports = Qte;
});

// ../node_modules/lodash/_Hash.js
var VI = v((DLe, HI) => {
  var ere = NI(), tre = LI(), rre = kI(), nre = $I(), ore = UI();
  function Ko(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.clear(); ++t < r; ) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }
  o(Ko, "Hash");
  Ko.prototype.clear = ere;
  Ko.prototype.delete = tre;
  Ko.prototype.get = rre;
  Ko.prototype.has = nre;
  Ko.prototype.set = ore;
  HI.exports = Ko;
});

// ../node_modules/lodash/_mapCacheClear.js
var YI = v((BLe, GI) => {
  var zI = VI(), ire = qs(), sre = ip();
  function are() {
    this.size = 0, this.__data__ = {
      hash: new zI(),
      map: new (sre || ire)(),
      string: new zI()
    };
  }
  o(are, "mapCacheClear");
  GI.exports = are;
});

// ../node_modules/lodash/_isKeyable.js
var KI = v((HLe, WI) => {
  function lre(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  o(lre, "isKeyable");
  WI.exports = lre;
});

// ../node_modules/lodash/_getMapData.js
var js = v((zLe, XI) => {
  var ure = KI();
  function cre(e, t) {
    var r = e.__data__;
    return ure(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
  }
  o(cre, "getMapData");
  XI.exports = cre;
});

// ../node_modules/lodash/_mapCacheDelete.js
var ZI = v((YLe, JI) => {
  var dre = js();
  function pre(e) {
    var t = dre(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  }
  o(pre, "mapCacheDelete");
  JI.exports = pre;
});

// ../node_modules/lodash/_mapCacheGet.js
var eM = v((KLe, QI) => {
  var fre = js();
  function mre(e) {
    return fre(this, e).get(e);
  }
  o(mre, "mapCacheGet");
  QI.exports = mre;
});

// ../node_modules/lodash/_mapCacheHas.js
var rM = v((JLe, tM) => {
  var hre = js();
  function yre(e) {
    return hre(this, e).has(e);
  }
  o(yre, "mapCacheHas");
  tM.exports = yre;
});

// ../node_modules/lodash/_mapCacheSet.js
var oM = v((QLe, nM) => {
  var bre = js();
  function gre(e, t) {
    var r = bre(this, e), n = r.size;
    return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
  }
  o(gre, "mapCacheSet");
  nM.exports = gre;
});

// ../node_modules/lodash/_MapCache.js
var vT = v((tFe, iM) => {
  var vre = YI(), Ere = ZI(), Tre = eM(), _re = rM(), Rre = oM();
  function Xo(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.clear(); ++t < r; ) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }
  o(Xo, "MapCache");
  Xo.prototype.clear = vre;
  Xo.prototype.delete = Ere;
  Xo.prototype.get = Tre;
  Xo.prototype.has = _re;
  Xo.prototype.set = Rre;
  iM.exports = Xo;
});

// ../node_modules/lodash/_stackSet.js
var aM = v((nFe, sM) => {
  var wre = qs(), Sre = ip(), xre = vT(), Cre = 200;
  function Pre(e, t) {
    var r = this.__data__;
    if (r instanceof wre) {
      var n = r.__data__;
      if (!Sre || n.length < Cre - 1)
        return n.push([e, t]), this.size = ++r.size, this;
      r = this.__data__ = new xre(n);
    }
    return r.set(e, t), this.size = r.size, this;
  }
  o(Pre, "stackSet");
  sM.exports = Pre;
});

// ../node_modules/lodash/_Stack.js
var uM = v((iFe, lM) => {
  var Are = qs(), Ore = Zq(), qre = eI(), Ire = rI(), Mre = oI(), Nre = aM();
  function Jo(e) {
    var t = this.__data__ = new Are(e);
    this.size = t.size;
  }
  o(Jo, "Stack");
  Jo.prototype.clear = Ore;
  Jo.prototype.delete = qre;
  Jo.prototype.get = Ire;
  Jo.prototype.has = Mre;
  Jo.prototype.set = Nre;
  lM.exports = Jo;
});

// ../node_modules/lodash/_setCacheAdd.js
var dM = v((aFe, cM) => {
  var jre = "__lodash_hash_undefined__";
  function Lre(e) {
    return this.__data__.set(e, jre), this;
  }
  o(Lre, "setCacheAdd");
  cM.exports = Lre;
});

// ../node_modules/lodash/_setCacheHas.js
var fM = v((uFe, pM) => {
  function Fre(e) {
    return this.__data__.has(e);
  }
  o(Fre, "setCacheHas");
  pM.exports = Fre;
});

// ../node_modules/lodash/_SetCache.js
var hM = v((dFe, mM) => {
  var kre = vT(), Dre = dM(), $re = fM();
  function sp(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.__data__ = new kre(); ++t < r; )
      this.add(e[t]);
  }
  o(sp, "SetCache");
  sp.prototype.add = sp.prototype.push = Dre;
  sp.prototype.has = $re;
  mM.exports = sp;
});

// ../node_modules/lodash/_arraySome.js
var bM = v((fFe, yM) => {
  function Bre(e, t) {
    for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
      if (t(e[r], r, e))
        return !0;
    return !1;
  }
  o(Bre, "arraySome");
  yM.exports = Bre;
});

// ../node_modules/lodash/_cacheHas.js
var vM = v((hFe, gM) => {
  function Ure(e, t) {
    return e.has(t);
  }
  o(Ure, "cacheHas");
  gM.exports = Ure;
});

// ../node_modules/lodash/_equalArrays.js
var ET = v((bFe, EM) => {
  var Hre = hM(), Vre = bM(), zre = vM(), Gre = 1, Yre = 2;
  function Wre(e, t, r, n, i, s) {
    var a = r & Gre, l = e.length, u = t.length;
    if (l != u && !(a && u > l))
      return !1;
    var c = s.get(e), d = s.get(t);
    if (c && d)
      return c == t && d == e;
    var p = -1, y = !0, f = r & Yre ? new Hre() : void 0;
    for (s.set(e, t), s.set(t, e); ++p < l; ) {
      var m = e[p], h = t[p];
      if (n)
        var b = a ? n(h, m, p, t, e, s) : n(m, h, p, e, t, s);
      if (b !== void 0) {
        if (b)
          continue;
        y = !1;
        break;
      }
      if (f) {
        if (!Vre(t, function(g, T) {
          if (!zre(f, T) && (m === g || i(m, g, r, n, s)))
            return f.push(T);
        })) {
          y = !1;
          break;
        }
      } else if (!(m === h || i(m, h, r, n, s))) {
        y = !1;
        break;
      }
    }
    return s.delete(e), s.delete(t), y;
  }
  o(Wre, "equalArrays");
  EM.exports = Wre;
});

// ../node_modules/lodash/_Uint8Array.js
var _M = v((vFe, TM) => {
  var Kre = pr(), Xre = Kre.Uint8Array;
  TM.exports = Xre;
});

// ../node_modules/lodash/_mapToArray.js
var wM = v((EFe, RM) => {
  function Jre(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(n, i) {
      r[++t] = [i, n];
    }), r;
  }
  o(Jre, "mapToArray");
  RM.exports = Jre;
});

// ../node_modules/lodash/_setToArray.js
var xM = v((_Fe, SM) => {
  function Zre(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(n) {
      r[++t] = n;
    }), r;
  }
  o(Zre, "setToArray");
  SM.exports = Zre;
});

// ../node_modules/lodash/_equalByTag.js
var qM = v((wFe, OM) => {
  var CM = op(), PM = _M(), Qre = fT(), ene = ET(), tne = wM(), rne = xM(), nne = 1, one = 2, ine = "[object Boolean]", sne = "[object Date]",
  ane = "[object Error]", lne = "[object Map]", une = "[object Number]", cne = "[object RegExp]", dne = "[object Set]", pne = "[object Strin\
g]", fne = "[object Symbol]", mne = "[object ArrayBuffer]", hne = "[object DataView]", AM = CM ? CM.prototype : void 0, TT = AM ? AM.valueOf :
  void 0;
  function yne(e, t, r, n, i, s, a) {
    switch (r) {
      case hne:
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
          return !1;
        e = e.buffer, t = t.buffer;
      case mne:
        return !(e.byteLength != t.byteLength || !s(new PM(e), new PM(t)));
      case ine:
      case sne:
      case une:
        return Qre(+e, +t);
      case ane:
        return e.name == t.name && e.message == t.message;
      case cne:
      case pne:
        return e == t + "";
      case lne:
        var l = tne;
      case dne:
        var u = n & nne;
        if (l || (l = rne), e.size != t.size && !u)
          return !1;
        var c = a.get(e);
        if (c)
          return c == t;
        n |= one, a.set(e, t);
        var d = ene(l(e), l(t), n, i, s, a);
        return a.delete(e), d;
      case fne:
        if (TT)
          return TT.call(e) == TT.call(t);
    }
    return !1;
  }
  o(yne, "equalByTag");
  OM.exports = yne;
});

// ../node_modules/lodash/_arrayPush.js
var MM = v((xFe, IM) => {
  function bne(e, t) {
    for (var r = -1, n = t.length, i = e.length; ++r < n; )
      e[i + r] = t[r];
    return e;
  }
  o(bne, "arrayPush");
  IM.exports = bne;
});

// ../node_modules/lodash/isArray.js
var ap = v((PFe, NM) => {
  var gne = Array.isArray;
  NM.exports = gne;
});

// ../node_modules/lodash/_baseGetAllKeys.js
var LM = v((AFe, jM) => {
  var vne = MM(), Ene = ap();
  function Tne(e, t, r) {
    var n = t(e);
    return Ene(e) ? n : vne(n, r(e));
  }
  o(Tne, "baseGetAllKeys");
  jM.exports = Tne;
});

// ../node_modules/lodash/_arrayFilter.js
var kM = v((qFe, FM) => {
  function _ne(e, t) {
    for (var r = -1, n = e == null ? 0 : e.length, i = 0, s = []; ++r < n; ) {
      var a = e[r];
      t(a, r, e) && (s[i++] = a);
    }
    return s;
  }
  o(_ne, "arrayFilter");
  FM.exports = _ne;
});

// ../node_modules/lodash/stubArray.js
var $M = v((MFe, DM) => {
  function Rne() {
    return [];
  }
  o(Rne, "stubArray");
  DM.exports = Rne;
});

// ../node_modules/lodash/_getSymbols.js
var HM = v((jFe, UM) => {
  var wne = kM(), Sne = $M(), xne = Object.prototype, Cne = xne.propertyIsEnumerable, BM = Object.getOwnPropertySymbols, Pne = BM ? function(e) {
    return e == null ? [] : (e = Object(e), wne(BM(e), function(t) {
      return Cne.call(e, t);
    }));
  } : Sne;
  UM.exports = Pne;
});

// ../node_modules/lodash/_baseTimes.js
var zM = v((LFe, VM) => {
  function Ane(e, t) {
    for (var r = -1, n = Array(e); ++r < e; )
      n[r] = t(r);
    return n;
  }
  o(Ane, "baseTimes");
  VM.exports = Ane;
});

// ../node_modules/lodash/isObjectLike.js
var Ls = v((kFe, GM) => {
  function One(e) {
    return e != null && typeof e == "object";
  }
  o(One, "isObjectLike");
  GM.exports = One;
});

// ../node_modules/lodash/_baseIsArguments.js
var WM = v(($Fe, YM) => {
  var qne = Ms(), Ine = Ls(), Mne = "[object Arguments]";
  function Nne(e) {
    return Ine(e) && qne(e) == Mne;
  }
  o(Nne, "baseIsArguments");
  YM.exports = Nne;
});

// ../node_modules/lodash/isArguments.js
var ZM = v((UFe, JM) => {
  var KM = WM(), jne = Ls(), XM = Object.prototype, Lne = XM.hasOwnProperty, Fne = XM.propertyIsEnumerable, kne = KM(/* @__PURE__ */ function() {
    return arguments;
  }()) ? KM : function(e) {
    return jne(e) && Lne.call(e, "callee") && !Fne.call(e, "callee");
  };
  JM.exports = kne;
});

// ../node_modules/lodash/stubFalse.js
var eN = v((HFe, QM) => {
  function Dne() {
    return !1;
  }
  o(Dne, "stubFalse");
  QM.exports = Dne;
});

// ../node_modules/lodash/isBuffer.js
var _T = v((Fs, Zo) => {
  var $ne = pr(), Bne = eN(), nN = typeof Fs == "object" && Fs && !Fs.nodeType && Fs, tN = nN && typeof Zo == "object" && Zo && !Zo.nodeType &&
  Zo, Une = tN && tN.exports === nN, rN = Une ? $ne.Buffer : void 0, Hne = rN ? rN.isBuffer : void 0, Vne = Hne || Bne;
  Zo.exports = Vne;
});

// ../node_modules/lodash/_isIndex.js
var iN = v((zFe, oN) => {
  var zne = 9007199254740991, Gne = /^(?:0|[1-9]\d*)$/;
  function Yne(e, t) {
    var r = typeof e;
    return t = t ?? zne, !!t && (r == "number" || r != "symbol" && Gne.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  o(Yne, "isIndex");
  oN.exports = Yne;
});

// ../node_modules/lodash/isLength.js
var RT = v((YFe, sN) => {
  var Wne = 9007199254740991;
  function Kne(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Wne;
  }
  o(Kne, "isLength");
  sN.exports = Kne;
});

// ../node_modules/lodash/_baseIsTypedArray.js
var lN = v((KFe, aN) => {
  var Xne = Ms(), Jne = RT(), Zne = Ls(), Qne = "[object Arguments]", eoe = "[object Array]", toe = "[object Boolean]", roe = "[object Date]",
  noe = "[object Error]", ooe = "[object Function]", ioe = "[object Map]", soe = "[object Number]", aoe = "[object Object]", loe = "[object \
RegExp]", uoe = "[object Set]", coe = "[object String]", doe = "[object WeakMap]", poe = "[object ArrayBuffer]", foe = "[object DataView]", moe = "\
[object Float32Array]", hoe = "[object Float64Array]", yoe = "[object Int8Array]", boe = "[object Int16Array]", goe = "[object Int32Array]",
  voe = "[object Uint8Array]", Eoe = "[object Uint8ClampedArray]", Toe = "[object Uint16Array]", _oe = "[object Uint32Array]", Ae = {};
  Ae[moe] = Ae[hoe] = Ae[yoe] = Ae[boe] = Ae[goe] = Ae[voe] = Ae[Eoe] = Ae[Toe] = Ae[_oe] = !0;
  Ae[Qne] = Ae[eoe] = Ae[poe] = Ae[toe] = Ae[foe] = Ae[roe] = Ae[noe] = Ae[ooe] = Ae[ioe] = Ae[soe] = Ae[aoe] = Ae[loe] = Ae[uoe] = Ae[coe] =
  Ae[doe] = !1;
  function Roe(e) {
    return Zne(e) && Jne(e.length) && !!Ae[Xne(e)];
  }
  o(Roe, "baseIsTypedArray");
  aN.exports = Roe;
});

// ../node_modules/lodash/_baseUnary.js
var cN = v((JFe, uN) => {
  function woe(e) {
    return function(t) {
      return e(t);
    };
  }
  o(woe, "baseUnary");
  uN.exports = woe;
});

// ../node_modules/lodash/_nodeUtil.js
var pN = v((ks, Qo) => {
  var Soe = mT(), dN = typeof ks == "object" && ks && !ks.nodeType && ks, Ds = dN && typeof Qo == "object" && Qo && !Qo.nodeType && Qo, xoe = Ds &&
  Ds.exports === dN, wT = xoe && Soe.process, Coe = function() {
    try {
      var e = Ds && Ds.require && Ds.require("util").types;
      return e || wT && wT.binding && wT.binding("util");
    } catch {
    }
  }();
  Qo.exports = Coe;
});

// ../node_modules/lodash/isTypedArray.js
var ST = v((QFe, hN) => {
  var Poe = lN(), Aoe = cN(), fN = pN(), mN = fN && fN.isTypedArray, Ooe = mN ? Aoe(mN) : Poe;
  hN.exports = Ooe;
});

// ../node_modules/lodash/_arrayLikeKeys.js
var bN = v((eke, yN) => {
  var qoe = zM(), Ioe = ZM(), Moe = ap(), Noe = _T(), joe = iN(), Loe = ST(), Foe = Object.prototype, koe = Foe.hasOwnProperty;
  function Doe(e, t) {
    var r = Moe(e), n = !r && Ioe(e), i = !r && !n && Noe(e), s = !r && !n && !i && Loe(e), a = r || n || i || s, l = a ? qoe(e.length, String) :
    [], u = l.length;
    for (var c in e)
      (t || koe.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
      (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
      joe(c, u))) && l.push(c);
    return l;
  }
  o(Doe, "arrayLikeKeys");
  yN.exports = Doe;
});

// ../node_modules/lodash/_isPrototype.js
var vN = v((rke, gN) => {
  var $oe = Object.prototype;
  function Boe(e) {
    var t = e && e.constructor, r = typeof t == "function" && t.prototype || $oe;
    return e === r;
  }
  o(Boe, "isPrototype");
  gN.exports = Boe;
});

// ../node_modules/lodash/_overArg.js
var TN = v((oke, EN) => {
  function Uoe(e, t) {
    return function(r) {
      return e(t(r));
    };
  }
  o(Uoe, "overArg");
  EN.exports = Uoe;
});

// ../node_modules/lodash/_nativeKeys.js
var RN = v((ske, _N) => {
  var Hoe = TN(), Voe = Hoe(Object.keys, Object);
  _N.exports = Voe;
});

// ../node_modules/lodash/_baseKeys.js
var SN = v((ake, wN) => {
  var zoe = vN(), Goe = RN(), Yoe = Object.prototype, Woe = Yoe.hasOwnProperty;
  function Koe(e) {
    if (!zoe(e))
      return Goe(e);
    var t = [];
    for (var r in Object(e))
      Woe.call(e, r) && r != "constructor" && t.push(r);
    return t;
  }
  o(Koe, "baseKeys");
  wN.exports = Koe;
});

// ../node_modules/lodash/isArrayLike.js
var CN = v((uke, xN) => {
  var Xoe = yT(), Joe = RT();
  function Zoe(e) {
    return e != null && Joe(e.length) && !Xoe(e);
  }
  o(Zoe, "isArrayLike");
  xN.exports = Zoe;
});

// ../node_modules/lodash/keys.js
var AN = v((dke, PN) => {
  var Qoe = bN(), eie = SN(), tie = CN();
  function rie(e) {
    return tie(e) ? Qoe(e) : eie(e);
  }
  o(rie, "keys");
  PN.exports = rie;
});

// ../node_modules/lodash/_getAllKeys.js
var qN = v((fke, ON) => {
  var nie = LM(), oie = HM(), iie = AN();
  function sie(e) {
    return nie(e, iie, oie);
  }
  o(sie, "getAllKeys");
  ON.exports = sie;
});

// ../node_modules/lodash/_equalObjects.js
var NN = v((hke, MN) => {
  var IN = qN(), aie = 1, lie = Object.prototype, uie = lie.hasOwnProperty;
  function cie(e, t, r, n, i, s) {
    var a = r & aie, l = IN(e), u = l.length, c = IN(t), d = c.length;
    if (u != d && !a)
      return !1;
    for (var p = u; p--; ) {
      var y = l[p];
      if (!(a ? y in t : uie.call(t, y)))
        return !1;
    }
    var f = s.get(e), m = s.get(t);
    if (f && m)
      return f == t && m == e;
    var h = !0;
    s.set(e, t), s.set(t, e);
    for (var b = a; ++p < u; ) {
      y = l[p];
      var g = e[y], T = t[y];
      if (n)
        var _ = a ? n(T, g, y, t, e, s) : n(g, T, y, e, t, s);
      if (!(_ === void 0 ? g === T || i(g, T, r, n, s) : _)) {
        h = !1;
        break;
      }
      b || (b = y == "constructor");
    }
    if (h && !b) {
      var E = e.constructor, R = t.constructor;
      E != R && "constructor" in e && "constructor" in t && !(typeof E == "function" && E instanceof E && typeof R == "function" && R instanceof
      R) && (h = !1);
    }
    return s.delete(e), s.delete(t), h;
  }
  o(cie, "equalObjects");
  MN.exports = cie;
});

// ../node_modules/lodash/_DataView.js
var LN = v((bke, jN) => {
  var die = Nn(), pie = pr(), fie = die(pie, "DataView");
  jN.exports = fie;
});

// ../node_modules/lodash/_Promise.js
var kN = v((gke, FN) => {
  var mie = Nn(), hie = pr(), yie = mie(hie, "Promise");
  FN.exports = yie;
});

// ../node_modules/lodash/_Set.js
var $N = v((vke, DN) => {
  var bie = Nn(), gie = pr(), vie = bie(gie, "Set");
  DN.exports = vie;
});

// ../node_modules/lodash/_WeakMap.js
var UN = v((Eke, BN) => {
  var Eie = Nn(), Tie = pr(), _ie = Eie(Tie, "WeakMap");
  BN.exports = _ie;
});

// ../node_modules/lodash/_getTag.js
var XN = v((Tke, KN) => {
  var xT = LN(), CT = ip(), PT = kN(), AT = $N(), OT = UN(), WN = Ms(), ei = gT(), HN = "[object Map]", Rie = "[object Object]", VN = "[obje\
ct Promise]", zN = "[object Set]", GN = "[object WeakMap]", YN = "[object DataView]", wie = ei(xT), Sie = ei(CT), xie = ei(PT), Cie = ei(AT),
  Pie = ei(OT), jn = WN;
  (xT && jn(new xT(new ArrayBuffer(1))) != YN || CT && jn(new CT()) != HN || PT && jn(PT.resolve()) != VN || AT && jn(new AT()) != zN || OT &&
  jn(new OT()) != GN) && (jn = /* @__PURE__ */ o(function(e) {
    var t = WN(e), r = t == Rie ? e.constructor : void 0, n = r ? ei(r) : "";
    if (n)
      switch (n) {
        case wie:
          return YN;
        case Sie:
          return HN;
        case xie:
          return VN;
        case Cie:
          return zN;
        case Pie:
          return GN;
      }
    return t;
  }, "getTag"));
  KN.exports = jn;
});

// ../node_modules/lodash/_baseIsEqualDeep.js
var oj = v((Rke, nj) => {
  var qT = uM(), Aie = ET(), Oie = qM(), qie = NN(), JN = XN(), ZN = ap(), QN = _T(), Iie = ST(), Mie = 1, ej = "[object Arguments]", tj = "\
[object Array]", lp = "[object Object]", Nie = Object.prototype, rj = Nie.hasOwnProperty;
  function jie(e, t, r, n, i, s) {
    var a = ZN(e), l = ZN(t), u = a ? tj : JN(e), c = l ? tj : JN(t);
    u = u == ej ? lp : u, c = c == ej ? lp : c;
    var d = u == lp, p = c == lp, y = u == c;
    if (y && QN(e)) {
      if (!QN(t))
        return !1;
      a = !0, d = !1;
    }
    if (y && !d)
      return s || (s = new qT()), a || Iie(e) ? Aie(e, t, r, n, i, s) : Oie(e, t, u, r, n, i, s);
    if (!(r & Mie)) {
      var f = d && rj.call(e, "__wrapped__"), m = p && rj.call(t, "__wrapped__");
      if (f || m) {
        var h = f ? e.value() : e, b = m ? t.value() : t;
        return s || (s = new qT()), i(h, b, r, n, s);
      }
    }
    return y ? (s || (s = new qT()), qie(e, t, r, n, i, s)) : !1;
  }
  o(jie, "baseIsEqualDeep");
  nj.exports = jie;
});

// ../node_modules/lodash/_baseIsEqual.js
var lj = v((Ske, aj) => {
  var Lie = oj(), ij = Ls();
  function sj(e, t, r, n, i) {
    return e === t ? !0 : e == null || t == null || !ij(e) && !ij(t) ? e !== e && t !== t : Lie(e, t, r, n, sj, i);
  }
  o(sj, "baseIsEqual");
  aj.exports = sj;
});

// ../node_modules/lodash/isEqualWith.js
var IT = v((Cke, uj) => {
  var Fie = lj();
  function kie(e, t, r) {
    r = typeof r == "function" ? r : void 0;
    var n = r ? r(e, t) : void 0;
    return n === void 0 ? Fie(e, t, void 0, r) : !!n;
  }
  o(kie, "isEqualWith");
  uj.exports = kie;
});

// ../node_modules/css.escape/css.escape.js
var NT = v((MT, cj) => {
  (function(e, t) {
    typeof MT == "object" ? cj.exports = t(e) : typeof define == "function" && define.amd ? define([], t.bind(e, e)) : t(e);
  })(typeof global < "u" ? global : MT, function(e) {
    if (e.CSS && e.CSS.escape)
      return e.CSS.escape;
    var t = /* @__PURE__ */ o(function(r) {
      if (arguments.length == 0)
        throw new TypeError("`CSS.escape` requires an argument.");
      for (var n = String(r), i = n.length, s = -1, a, l = "", u = n.charCodeAt(0); ++s < i; ) {
        if (a = n.charCodeAt(s), a == 0) {
          l += "\uFFFD";
          continue;
        }
        if (
          // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
          // U+007F, […]
          a >= 1 && a <= 31 || a == 127 || // If the character is the first character and is in the range [0-9]
          // (U+0030 to U+0039), […]
          s == 0 && a >= 48 && a <= 57 || // If the character is the second character and is in the range [0-9]
          // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
          s == 1 && a >= 48 && a <= 57 && u == 45
        ) {
          l += "\\" + a.toString(16) + " ";
          continue;
        }
        if (
          // If the character is the first character and is a `-` (U+002D), and
          // there is no second character, […]
          s == 0 && i == 1 && a == 45
        ) {
          l += "\\" + n.charAt(s);
          continue;
        }
        if (a >= 128 || a == 45 || a == 95 || a >= 48 && a <= 57 || a >= 65 && a <= 90 || a >= 97 && a <= 122) {
          l += n.charAt(s);
          continue;
        }
        l += "\\" + n.charAt(s);
      }
      return l;
    }, "cssEscape");
    return e.CSS || (e.CSS = {}), e.CSS.escape = t, t;
  });
});

// ../node_modules/pretty-format/node_modules/ansi-styles/index.js
var pR = v((XDe, mF) => {
  "use strict";
  var pF = /* @__PURE__ */ o((e = 0) => (t) => `\x1B[${38 + e};5;${t}m`, "wrapAnsi256"), fF = /* @__PURE__ */ o((e = 0) => (t, r, n) => `\x1B[${38 +
  e};2;${t};${r};${n}m`, "wrapAnsi16m");
  function vue() {
    let e = /* @__PURE__ */ new Map(), t = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        overline: [53, 55],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    t.color.gray = t.color.blackBright, t.bgColor.bgGray = t.bgColor.bgBlackBright, t.color.grey = t.color.blackBright, t.bgColor.bgGrey = t.
    bgColor.bgBlackBright;
    for (let [r, n] of Object.entries(t)) {
      for (let [i, s] of Object.entries(n))
        t[i] = {
          open: `\x1B[${s[0]}m`,
          close: `\x1B[${s[1]}m`
        }, n[i] = t[i], e.set(s[0], s[1]);
      Object.defineProperty(t, r, {
        value: n,
        enumerable: !1
      });
    }
    return Object.defineProperty(t, "codes", {
      value: e,
      enumerable: !1
    }), t.color.close = "\x1B[39m", t.bgColor.close = "\x1B[49m", t.color.ansi256 = pF(), t.color.ansi16m = fF(), t.bgColor.ansi256 = pF(10),
    t.bgColor.ansi16m = fF(10), Object.defineProperties(t, {
      rgbToAnsi256: {
        value: /* @__PURE__ */ o((r, n, i) => r === n && n === i ? r < 8 ? 16 : r > 248 ? 231 : Math.round((r - 8) / 247 * 24) + 232 : 16 + 36 *
        Math.round(r / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(i / 255 * 5), "value"),
        enumerable: !1
      },
      hexToRgb: {
        value: /* @__PURE__ */ o((r) => {
          let n = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(r.toString(16));
          if (!n)
            return [0, 0, 0];
          let { colorString: i } = n.groups;
          i.length === 3 && (i = i.split("").map((a) => a + a).join(""));
          let s = Number.parseInt(i, 16);
          return [
            s >> 16 & 255,
            s >> 8 & 255,
            s & 255
          ];
        }, "value"),
        enumerable: !1
      },
      hexToAnsi256: {
        value: /* @__PURE__ */ o((r) => t.rgbToAnsi256(...t.hexToRgb(r)), "value"),
        enumerable: !1
      }
    }), t;
  }
  o(vue, "assembleStyles");
  Object.defineProperty(mF, "exports", {
    enumerable: !0,
    get: vue
  });
});

// ../node_modules/pretty-format/build/collections.js
var Zs = v((di) => {
  "use strict";
  Object.defineProperty(di, "__esModule", {
    value: !0
  });
  di.printIteratorEntries = Tue;
  di.printIteratorValues = _ue;
  di.printListItems = Rue;
  di.printObjectProperties = wue;
  var Eue = /* @__PURE__ */ o((e, t) => {
    let r = Object.keys(e).sort(t);
    return Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach((n) => {
      Object.getOwnPropertyDescriptor(e, n).enumerable && r.push(n);
    }), r;
  }, "getKeysOfEnumerableProperties");
  function Tue(e, t, r, n, i, s, a = ": ") {
    let l = "", u = e.next();
    if (!u.done) {
      l += t.spacingOuter;
      let c = r + t.indent;
      for (; !u.done; ) {
        let d = s(
          u.value[0],
          t,
          c,
          n,
          i
        ), p = s(
          u.value[1],
          t,
          c,
          n,
          i
        );
        l += c + d + a + p, u = e.next(), u.done ? t.min || (l += ",") : l += "," + t.spacingInner;
      }
      l += t.spacingOuter + r;
    }
    return l;
  }
  o(Tue, "printIteratorEntries");
  function _ue(e, t, r, n, i, s) {
    let a = "", l = e.next();
    if (!l.done) {
      a += t.spacingOuter;
      let u = r + t.indent;
      for (; !l.done; )
        a += u + s(l.value, t, u, n, i), l = e.next(), l.done ? t.min || (a += ",") : a += "," + t.spacingInner;
      a += t.spacingOuter + r;
    }
    return a;
  }
  o(_ue, "printIteratorValues");
  function Rue(e, t, r, n, i, s) {
    let a = "";
    if (e.length) {
      a += t.spacingOuter;
      let l = r + t.indent;
      for (let u = 0; u < e.length; u++)
        a += l, u in e && (a += s(e[u], t, l, n, i)), u < e.length - 1 ? a += "," + t.spacingInner : t.min || (a += ",");
      a += t.spacingOuter + r;
    }
    return a;
  }
  o(Rue, "printListItems");
  function wue(e, t, r, n, i, s) {
    let a = "", l = Eue(e, t.compareKeys);
    if (l.length) {
      a += t.spacingOuter;
      let u = r + t.indent;
      for (let c = 0; c < l.length; c++) {
        let d = l[c], p = s(d, t, u, n, i), y = s(e[d], t, u, n, i);
        a += u + p + ": " + y, c < l.length - 1 ? a += "," + t.spacingInner : t.min || (a += ",");
      }
      a += t.spacingOuter + r;
    }
    return a;
  }
  o(wue, "printObjectProperties");
});

// ../node_modules/pretty-format/build/plugins/AsymmetricMatcher.js
var gF = v((Zr) => {
  "use strict";
  Object.defineProperty(Zr, "__esModule", {
    value: !0
  });
  Zr.test = Zr.serialize = Zr.default = void 0;
  var hF = Zs(), Yp = function() {
    return typeof globalThis < "u" ? globalThis : typeof Yp < "u" ? Yp : typeof self < "u" ? self : typeof window < "u" ? window : Function(
    "return this")();
  }(), fR = Yp["jest-symbol-do-not-touch"] || Yp.Symbol, Sue = typeof fR == "function" && fR.for ? fR.for("jest.asymmetricMatcher") : 1267621,
  Gp = " ", yF = /* @__PURE__ */ o((e, t, r, n, i, s) => {
    let a = e.toString();
    return a === "ArrayContaining" || a === "ArrayNotContaining" ? ++n > t.maxDepth ? "[" + a + "]" : a + Gp + "[" + (0, hF.printListItems)(
      e.sample,
      t,
      r,
      n,
      i,
      s
    ) + "]" : a === "ObjectContaining" || a === "ObjectNotContaining" ? ++n > t.maxDepth ? "[" + a + "]" : a + Gp + "{" + (0, hF.printObjectProperties)(
      e.sample,
      t,
      r,
      n,
      i,
      s
    ) + "}" : a === "StringMatching" || a === "StringNotMatching" || a === "StringContaining" || a === "StringNotContaining" ? a + Gp + s(e.
    sample, t, r, n, i) : e.toAsymmetricMatcher();
  }, "serialize");
  Zr.serialize = yF;
  var bF = /* @__PURE__ */ o((e) => e && e.$$typeof === Sue, "test");
  Zr.test = bF;
  var xue = {
    serialize: yF,
    test: bF
  }, Cue = xue;
  Zr.default = Cue;
});

// ../node_modules/pretty-format/node_modules/ansi-regex/index.js
var EF = v((r$e, vF) => {
  "use strict";
  vF.exports = ({ onlyFirst: e = !1 } = {}) => {
    let t = [
      "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
      "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
    ].join("|");
    return new RegExp(t, e ? void 0 : "g");
  };
});

// ../node_modules/pretty-format/build/plugins/ConvertAnsi.js
var SF = v((Qr) => {
  "use strict";
  Object.defineProperty(Qr, "__esModule", {
    value: !0
  });
  Qr.test = Qr.serialize = Qr.default = void 0;
  var TF = _F(EF()), xe = _F(pR());
  function _F(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(_F, "_interopRequireDefault");
  var Pue = /* @__PURE__ */ o((e) => e.replace((0, TF.default)(), (t) => {
    switch (t) {
      case xe.default.red.close:
      case xe.default.green.close:
      case xe.default.cyan.close:
      case xe.default.gray.close:
      case xe.default.white.close:
      case xe.default.yellow.close:
      case xe.default.bgRed.close:
      case xe.default.bgGreen.close:
      case xe.default.bgYellow.close:
      case xe.default.inverse.close:
      case xe.default.dim.close:
      case xe.default.bold.close:
      case xe.default.reset.open:
      case xe.default.reset.close:
        return "</>";
      case xe.default.red.open:
        return "<red>";
      case xe.default.green.open:
        return "<green>";
      case xe.default.cyan.open:
        return "<cyan>";
      case xe.default.gray.open:
        return "<gray>";
      case xe.default.white.open:
        return "<white>";
      case xe.default.yellow.open:
        return "<yellow>";
      case xe.default.bgRed.open:
        return "<bgRed>";
      case xe.default.bgGreen.open:
        return "<bgGreen>";
      case xe.default.bgYellow.open:
        return "<bgYellow>";
      case xe.default.inverse.open:
        return "<inverse>";
      case xe.default.dim.open:
        return "<dim>";
      case xe.default.bold.open:
        return "<bold>";
      default:
        return "";
    }
  }), "toHumanReadableAnsi"), RF = /* @__PURE__ */ o((e) => typeof e == "string" && !!e.match((0, TF.default)()), "test");
  Qr.test = RF;
  var wF = /* @__PURE__ */ o((e, t, r, n, i, s) => s(Pue(e), t, r, n, i), "serialize");
  Qr.serialize = wF;
  var Aue = {
    serialize: wF,
    test: RF
  }, Oue = Aue;
  Qr.default = Oue;
});

// ../node_modules/pretty-format/build/plugins/DOMCollection.js
var OF = v((en) => {
  "use strict";
  Object.defineProperty(en, "__esModule", {
    value: !0
  });
  en.test = en.serialize = en.default = void 0;
  var xF = Zs(), que = " ", CF = ["DOMStringMap", "NamedNodeMap"], Iue = /^(HTML\w*Collection|NodeList)$/, Mue = /* @__PURE__ */ o((e) => CF.
  indexOf(e) !== -1 || Iue.test(e), "testName"), PF = /* @__PURE__ */ o((e) => e && e.constructor && !!e.constructor.name && Mue(e.constructor.
  name), "test");
  en.test = PF;
  var Nue = /* @__PURE__ */ o((e) => e.constructor.name === "NamedNodeMap", "isNamedNodeMap"), AF = /* @__PURE__ */ o((e, t, r, n, i, s) => {
    let a = e.constructor.name;
    return ++n > t.maxDepth ? "[" + a + "]" : (t.min ? "" : a + que) + (CF.indexOf(a) !== -1 ? "{" + (0, xF.printObjectProperties)(
      Nue(e) ? Array.from(e).reduce((l, u) => (l[u.name] = u.value, l), {}) : { ...e },
      t,
      r,
      n,
      i,
      s
    ) + "}" : "[" + (0, xF.printListItems)(
      Array.from(e),
      t,
      r,
      n,
      i,
      s
    ) + "]");
  }, "serialize");
  en.serialize = AF;
  var jue = {
    serialize: AF,
    test: PF
  }, Lue = jue;
  en.default = Lue;
});

// ../node_modules/pretty-format/build/plugins/lib/escapeHTML.js
var qF = v((mR) => {
  "use strict";
  Object.defineProperty(mR, "__esModule", {
    value: !0
  });
  mR.default = Fue;
  function Fue(e) {
    return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  o(Fue, "escapeHTML");
});

// ../node_modules/pretty-format/build/plugins/lib/markup.js
var Wp = v((Et) => {
  "use strict";
  Object.defineProperty(Et, "__esModule", {
    value: !0
  });
  Et.printText = Et.printProps = Et.printElementAsLeaf = Et.printElement = Et.printComment = Et.printChildren = void 0;
  var IF = kue(qF());
  function kue(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(kue, "_interopRequireDefault");
  var Due = /* @__PURE__ */ o((e, t, r, n, i, s, a) => {
    let l = n + r.indent, u = r.colors;
    return e.map((c) => {
      let d = t[c], p = a(d, r, l, i, s);
      return typeof d != "string" && (p.indexOf(`
`) !== -1 && (p = r.spacingOuter + l + p + r.spacingOuter + n), p = "{" + p + "}"), r.spacingInner + n + u.prop.open + c + u.prop.close + "=" +
      u.value.open + p + u.value.close;
    }).join("");
  }, "printProps");
  Et.printProps = Due;
  var $ue = /* @__PURE__ */ o((e, t, r, n, i, s) => e.map(
    (a) => t.spacingOuter + r + (typeof a == "string" ? MF(a, t) : s(a, t, r, n, i))
  ).join(""), "printChildren");
  Et.printChildren = $ue;
  var MF = /* @__PURE__ */ o((e, t) => {
    let r = t.colors.content;
    return r.open + (0, IF.default)(e) + r.close;
  }, "printText");
  Et.printText = MF;
  var Bue = /* @__PURE__ */ o((e, t) => {
    let r = t.colors.comment;
    return r.open + "<!--" + (0, IF.default)(e) + "-->" + r.close;
  }, "printComment");
  Et.printComment = Bue;
  var Uue = /* @__PURE__ */ o((e, t, r, n, i) => {
    let s = n.colors.tag;
    return s.open + "<" + e + (t && s.close + t + n.spacingOuter + i + s.open) + (r ? ">" + s.close + r + n.spacingOuter + i + s.open + "</" +
    e : (t && !n.min ? "" : " ") + "/") + ">" + s.close;
  }, "printElement");
  Et.printElement = Uue;
  var Hue = /* @__PURE__ */ o((e, t) => {
    let r = t.colors.tag;
    return r.open + "<" + e + r.close + " \u2026" + r.open + " />" + r.close;
  }, "printElementAsLeaf");
  Et.printElementAsLeaf = Hue;
});

// ../node_modules/pretty-format/build/plugins/DOMElement.js
var DF = v((tn) => {
  "use strict";
  Object.defineProperty(tn, "__esModule", {
    value: !0
  });
  tn.test = tn.serialize = tn.default = void 0;
  var pi = Wp(), Vue = 1, NF = 3, jF = 8, LF = 11, zue = /^((HTML|SVG)\w*)?Element$/, Gue = /* @__PURE__ */ o((e) => {
    try {
      return typeof e.hasAttribute == "function" && e.hasAttribute("is");
    } catch {
      return !1;
    }
  }, "testHasAttribute"), Yue = /* @__PURE__ */ o((e) => {
    let t = e.constructor.name, { nodeType: r, tagName: n } = e, i = typeof n == "string" && n.includes("-") || Gue(e);
    return r === Vue && (zue.test(t) || i) || r === NF && t === "Text" || r === jF && t === "Comment" || r === LF && t === "DocumentFragment";
  }, "testNode"), FF = /* @__PURE__ */ o((e) => {
    var t;
    return (e == null || (t = e.constructor) === null || t === void 0 ? void 0 : t.name) && Yue(e);
  }, "test");
  tn.test = FF;
  function Wue(e) {
    return e.nodeType === NF;
  }
  o(Wue, "nodeIsText");
  function Kue(e) {
    return e.nodeType === jF;
  }
  o(Kue, "nodeIsComment");
  function hR(e) {
    return e.nodeType === LF;
  }
  o(hR, "nodeIsFragment");
  var kF = /* @__PURE__ */ o((e, t, r, n, i, s) => {
    if (Wue(e))
      return (0, pi.printText)(e.data, t);
    if (Kue(e))
      return (0, pi.printComment)(e.data, t);
    let a = hR(e) ? "DocumentFragment" : e.tagName.toLowerCase();
    return ++n > t.maxDepth ? (0, pi.printElementAsLeaf)(a, t) : (0, pi.printElement)(
      a,
      (0, pi.printProps)(
        hR(e) ? [] : Array.from(e.attributes).map((l) => l.name).sort(),
        hR(e) ? {} : Array.from(e.attributes).reduce((l, u) => (l[u.name] = u.value, l), {}),
        t,
        r + t.indent,
        n,
        i,
        s
      ),
      (0, pi.printChildren)(
        Array.prototype.slice.call(e.childNodes || e.children),
        t,
        r + t.indent,
        n,
        i,
        s
      ),
      t,
      r
    );
  }, "serialize");
  tn.serialize = kF;
  var Xue = {
    serialize: kF,
    test: FF
  }, Jue = Xue;
  tn.default = Jue;
});

// ../node_modules/pretty-format/build/plugins/Immutable.js
var VF = v((rn) => {
  "use strict";
  Object.defineProperty(rn, "__esModule", {
    value: !0
  });
  rn.test = rn.serialize = rn.default = void 0;
  var Qs = Zs(), Zue = "@@__IMMUTABLE_ITERABLE__@@", Que = "@@__IMMUTABLE_LIST__@@", ece = "@@__IMMUTABLE_KEYED__@@", tce = "@@__IMMUTABLE_M\
AP__@@", $F = "@@__IMMUTABLE_ORDERED__@@", rce = "@@__IMMUTABLE_RECORD__@@", nce = "@@__IMMUTABLE_SEQ__@@", oce = "@@__IMMUTABLE_SET__@@", ice = "\
@@__IMMUTABLE_STACK__@@", fi = /* @__PURE__ */ o((e) => "Immutable." + e, "getImmutableName"), Kp = /* @__PURE__ */ o((e) => "[" + e + "]", "\
printAsLeaf"), ea = " ", BF = "\u2026", sce = /* @__PURE__ */ o((e, t, r, n, i, s, a) => ++n > t.maxDepth ? Kp(fi(a)) : fi(a) + ea + "{" + (0, Qs.
  printIteratorEntries)(
    e.entries(),
    t,
    r,
    n,
    i,
    s
  ) + "}", "printImmutableEntries");
  function ace(e) {
    let t = 0;
    return {
      next() {
        if (t < e._keys.length) {
          let r = e._keys[t++];
          return {
            done: !1,
            value: [r, e.get(r)]
          };
        }
        return {
          done: !0,
          value: void 0
        };
      }
    };
  }
  o(ace, "getRecordEntries");
  var lce = /* @__PURE__ */ o((e, t, r, n, i, s) => {
    let a = fi(e._name || "Record");
    return ++n > t.maxDepth ? Kp(a) : a + ea + "{" + (0, Qs.printIteratorEntries)(
      ace(e),
      t,
      r,
      n,
      i,
      s
    ) + "}";
  }, "printImmutableRecord"), uce = /* @__PURE__ */ o((e, t, r, n, i, s) => {
    let a = fi("Seq");
    return ++n > t.maxDepth ? Kp(a) : e[ece] ? a + ea + "{" + // from Immutable collection of entries or from ECMAScript object
    (e._iter || e._object ? (0, Qs.printIteratorEntries)(
      e.entries(),
      t,
      r,
      n,
      i,
      s
    ) : BF) + "}" : a + ea + "[" + (e._iter || // from Immutable collection of values
    e._array || // from ECMAScript array
    e._collection || // from ECMAScript collection in immutable v4
    e._iterable ? (0, Qs.printIteratorValues)(
      e.values(),
      t,
      r,
      n,
      i,
      s
    ) : BF) + "]";
  }, "printImmutableSeq"), yR = /* @__PURE__ */ o((e, t, r, n, i, s, a) => ++n > t.maxDepth ? Kp(fi(a)) : fi(a) + ea + "[" + (0, Qs.printIteratorValues)(
    e.values(),
    t,
    r,
    n,
    i,
    s
  ) + "]", "printImmutableValues"), UF = /* @__PURE__ */ o((e, t, r, n, i, s) => e[tce] ? sce(
    e,
    t,
    r,
    n,
    i,
    s,
    e[$F] ? "OrderedMap" : "Map"
  ) : e[Que] ? yR(
    e,
    t,
    r,
    n,
    i,
    s,
    "List"
  ) : e[oce] ? yR(
    e,
    t,
    r,
    n,
    i,
    s,
    e[$F] ? "OrderedSet" : "Set"
  ) : e[ice] ? yR(
    e,
    t,
    r,
    n,
    i,
    s,
    "Stack"
  ) : e[nce] ? uce(e, t, r, n, i, s) : lce(e, t, r, n, i, s), "serialize");
  rn.serialize = UF;
  var HF = /* @__PURE__ */ o((e) => e && (e[Zue] === !0 || e[rce] === !0), "test");
  rn.test = HF;
  var cce = {
    serialize: UF,
    test: HF
  }, dce = cce;
  rn.default = dce;
});

// ../node_modules/pretty-format/node_modules/react-is/cjs/react-is.production.min.js
var XF = v((Se) => {
  "use strict";
  var Xp = 60103, Jp = 60106, ta = 60107, ra = 60108, na = 60114, oa = 60109, ia = 60110, sa = 60112, aa = 60113, bR = 60120, la = 60115, ua = 60116,
  zF = 60121, GF = 60122, YF = 60117, WF = 60129, KF = 60131;
  typeof Symbol == "function" && Symbol.for && (Xe = Symbol.for, Xp = Xe("react.element"), Jp = Xe("react.portal"), ta = Xe("react.fragment"),
  ra = Xe("react.strict_mode"), na = Xe("react.profiler"), oa = Xe("react.provider"), ia = Xe("react.context"), sa = Xe("react.forward_ref"),
  aa = Xe("react.suspense"), bR = Xe("react.suspense_list"), la = Xe("react.memo"), ua = Xe("react.lazy"), zF = Xe("react.block"), GF = Xe("\
react.server.block"), YF = Xe("react.fundamental"), WF = Xe("react.debug_trace_mode"), KF = Xe("react.legacy_hidden"));
  var Xe;
  function Zt(e) {
    if (typeof e == "object" && e !== null) {
      var t = e.$$typeof;
      switch (t) {
        case Xp:
          switch (e = e.type, e) {
            case ta:
            case na:
            case ra:
            case aa:
            case bR:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case ia:
                case sa:
                case ua:
                case la:
                case oa:
                  return e;
                default:
                  return t;
              }
          }
        case Jp:
          return t;
      }
    }
  }
  o(Zt, "y");
  var pce = oa, fce = Xp, mce = sa, hce = ta, yce = ua, bce = la, gce = Jp, vce = na, Ece = ra, Tce = aa;
  Se.ContextConsumer = ia;
  Se.ContextProvider = pce;
  Se.Element = fce;
  Se.ForwardRef = mce;
  Se.Fragment = hce;
  Se.Lazy = yce;
  Se.Memo = bce;
  Se.Portal = gce;
  Se.Profiler = vce;
  Se.StrictMode = Ece;
  Se.Suspense = Tce;
  Se.isAsyncMode = function() {
    return !1;
  };
  Se.isConcurrentMode = function() {
    return !1;
  };
  Se.isContextConsumer = function(e) {
    return Zt(e) === ia;
  };
  Se.isContextProvider = function(e) {
    return Zt(e) === oa;
  };
  Se.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === Xp;
  };
  Se.isForwardRef = function(e) {
    return Zt(e) === sa;
  };
  Se.isFragment = function(e) {
    return Zt(e) === ta;
  };
  Se.isLazy = function(e) {
    return Zt(e) === ua;
  };
  Se.isMemo = function(e) {
    return Zt(e) === la;
  };
  Se.isPortal = function(e) {
    return Zt(e) === Jp;
  };
  Se.isProfiler = function(e) {
    return Zt(e) === na;
  };
  Se.isStrictMode = function(e) {
    return Zt(e) === ra;
  };
  Se.isSuspense = function(e) {
    return Zt(e) === aa;
  };
  Se.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === ta || e === na || e === WF || e === ra || e === aa || e === bR || e === KF ||
    typeof e == "object" && e !== null && (e.$$typeof === ua || e.$$typeof === la || e.$$typeof === oa || e.$$typeof === ia || e.$$typeof ===
    sa || e.$$typeof === YF || e.$$typeof === zF || e[0] === GF);
  };
  Se.typeOf = Zt;
});

// ../node_modules/pretty-format/node_modules/react-is/index.js
var ZF = v((b$e, JF) => {
  "use strict";
  JF.exports = XF();
});

// ../node_modules/pretty-format/build/plugins/ReactElement.js
var ok = v((nn) => {
  "use strict";
  Object.defineProperty(nn, "__esModule", {
    value: !0
  });
  nn.test = nn.serialize = nn.default = void 0;
  var Dn = _ce(ZF()), Zp = Wp();
  function ek(e) {
    if (typeof WeakMap != "function") return null;
    var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
    return (ek = /* @__PURE__ */ o(function(n) {
      return n ? r : t;
    }, "_getRequireWildcardCache"))(e);
  }
  o(ek, "_getRequireWildcardCache");
  function _ce(e, t) {
    if (!t && e && e.__esModule)
      return e;
    if (e === null || typeof e != "object" && typeof e != "function")
      return { default: e };
    var r = ek(t);
    if (r && r.has(e))
      return r.get(e);
    var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var s in e)
      if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(e, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = e[s];
      }
    return n.default = e, r && r.set(e, n), n;
  }
  o(_ce, "_interopRequireWildcard");
  var tk = /* @__PURE__ */ o((e, t = []) => (Array.isArray(e) ? e.forEach((r) => {
    tk(r, t);
  }) : e != null && e !== !1 && t.push(e), t), "getChildren"), QF = /* @__PURE__ */ o((e) => {
    let t = e.type;
    if (typeof t == "string")
      return t;
    if (typeof t == "function")
      return t.displayName || t.name || "Unknown";
    if (Dn.isFragment(e))
      return "React.Fragment";
    if (Dn.isSuspense(e))
      return "React.Suspense";
    if (typeof t == "object" && t !== null) {
      if (Dn.isContextProvider(e))
        return "Context.Provider";
      if (Dn.isContextConsumer(e))
        return "Context.Consumer";
      if (Dn.isForwardRef(e)) {
        if (t.displayName)
          return t.displayName;
        let r = t.render.displayName || t.render.name || "";
        return r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef";
      }
      if (Dn.isMemo(e)) {
        let r = t.displayName || t.type.displayName || t.type.name || "";
        return r !== "" ? "Memo(" + r + ")" : "Memo";
      }
    }
    return "UNDEFINED";
  }, "getType"), Rce = /* @__PURE__ */ o((e) => {
    let { props: t } = e;
    return Object.keys(t).filter((r) => r !== "children" && t[r] !== void 0).sort();
  }, "getPropKeys"), rk = /* @__PURE__ */ o((e, t, r, n, i, s) => ++n > t.maxDepth ? (0, Zp.printElementAsLeaf)(QF(e), t) : (0, Zp.printElement)(
    QF(e),
    (0, Zp.printProps)(
      Rce(e),
      e.props,
      t,
      r + t.indent,
      n,
      i,
      s
    ),
    (0, Zp.printChildren)(
      tk(e.props.children),
      t,
      r + t.indent,
      n,
      i,
      s
    ),
    t,
    r
  ), "serialize");
  nn.serialize = rk;
  var nk = /* @__PURE__ */ o((e) => e != null && Dn.isElement(e), "test");
  nn.test = nk;
  var wce = {
    serialize: rk,
    test: nk
  }, Sce = wce;
  nn.default = Sce;
});

// ../node_modules/pretty-format/build/plugins/ReactTestComponent.js
var ak = v((on) => {
  "use strict";
  Object.defineProperty(on, "__esModule", {
    value: !0
  });
  on.test = on.serialize = on.default = void 0;
  var Qp = Wp(), ef = function() {
    return typeof globalThis < "u" ? globalThis : typeof ef < "u" ? ef : typeof self < "u" ? self : typeof window < "u" ? window : Function(
    "return this")();
  }(), gR = ef["jest-symbol-do-not-touch"] || ef.Symbol, xce = typeof gR == "function" && gR.for ? gR.for("react.test.json") : 245830487, Cce = /* @__PURE__ */ o(
  (e) => {
    let { props: t } = e;
    return t ? Object.keys(t).filter((r) => t[r] !== void 0).sort() : [];
  }, "getPropKeys"), ik = /* @__PURE__ */ o((e, t, r, n, i, s) => ++n > t.maxDepth ? (0, Qp.printElementAsLeaf)(e.type, t) : (0, Qp.printElement)(
    e.type,
    e.props ? (0, Qp.printProps)(
      Cce(e),
      e.props,
      t,
      r + t.indent,
      n,
      i,
      s
    ) : "",
    e.children ? (0, Qp.printChildren)(
      e.children,
      t,
      r + t.indent,
      n,
      i,
      s
    ) : "",
    t,
    r
  ), "serialize");
  on.serialize = ik;
  var sk = /* @__PURE__ */ o((e) => e && e.$$typeof === xce, "test");
  on.test = sk;
  var Pce = {
    serialize: ik,
    test: sk
  }, Ace = Pce;
  on.default = Ace;
});

// ../node_modules/pretty-format/build/index.js
var Rk = v((wr) => {
  "use strict";
  Object.defineProperty(wr, "__esModule", {
    value: !0
  });
  wr.default = wr.DEFAULT_OPTIONS = void 0;
  wr.format = _k;
  wr.plugins = void 0;
  var Oce = an(pR()), ca = Zs(), qce = an(
    gF()
  ), Ice = an(SF()), Mce = an(OF()), Nce = an(DF()), jce = an(VF()), Lce = an(ok()), Fce = an(
    ak()
  );
  function an(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(an, "_interopRequireDefault");
  var fk = Object.prototype.toString, kce = Date.prototype.toISOString, Dce = Error.prototype.toString, lk = RegExp.prototype.toString, vR = /* @__PURE__ */ o(
  (e) => typeof e.constructor == "function" && e.constructor.name || "Object", "getConstructorName"), $ce = /* @__PURE__ */ o((e) => typeof window <
  "u" && e === window, "isWindow"), Bce = /^Symbol\((.*)\)(.*)$/, Uce = /\n/gi, TR = class TR extends Error {
    constructor(t, r) {
      super(t), this.stack = r, this.name = this.constructor.name;
    }
  };
  o(TR, "PrettyFormatPluginError");
  var tf = TR;
  function Hce(e) {
    return e === "[object Array]" || e === "[object ArrayBuffer]" || e === "[object DataView]" || e === "[object Float32Array]" || e === "[o\
bject Float64Array]" || e === "[object Int8Array]" || e === "[object Int16Array]" || e === "[object Int32Array]" || e === "[object Uint8Arra\
y]" || e === "[object Uint8ClampedArray]" || e === "[object Uint16Array]" || e === "[object Uint32Array]";
  }
  o(Hce, "isToStringedArrayType");
  function Vce(e) {
    return Object.is(e, -0) ? "-0" : String(e);
  }
  o(Vce, "printNumber");
  function zce(e) {
    return `${e}n`;
  }
  o(zce, "printBigInt");
  function uk(e, t) {
    return t ? "[Function " + (e.name || "anonymous") + "]" : "[Function]";
  }
  o(uk, "printFunction");
  function ck(e) {
    return String(e).replace(Bce, "Symbol($1)");
  }
  o(ck, "printSymbol");
  function dk(e) {
    return "[" + Dce.call(e) + "]";
  }
  o(dk, "printError");
  function mk(e, t, r, n) {
    if (e === !0 || e === !1)
      return "" + e;
    if (e === void 0)
      return "undefined";
    if (e === null)
      return "null";
    let i = typeof e;
    if (i === "number")
      return Vce(e);
    if (i === "bigint")
      return zce(e);
    if (i === "string")
      return n ? '"' + e.replace(/"|\\/g, "\\$&") + '"' : '"' + e + '"';
    if (i === "function")
      return uk(e, t);
    if (i === "symbol")
      return ck(e);
    let s = fk.call(e);
    return s === "[object WeakMap]" ? "WeakMap {}" : s === "[object WeakSet]" ? "WeakSet {}" : s === "[object Function]" || s === "[object G\
eneratorFunction]" ? uk(e, t) : s === "[object Symbol]" ? ck(e) : s === "[object Date]" ? isNaN(+e) ? "Date { NaN }" : kce.call(e) : s === "\
[object Error]" ? dk(e) : s === "[object RegExp]" ? r ? lk.call(e).replace(/[\\^$*+?.()|[\]{}]/g, "\\$&") : lk.call(e) : e instanceof Error ?
    dk(e) : null;
  }
  o(mk, "printBasicValue");
  function hk(e, t, r, n, i, s) {
    if (i.indexOf(e) !== -1)
      return "[Circular]";
    i = i.slice(), i.push(e);
    let a = ++n > t.maxDepth, l = t.min;
    if (t.callToJSON && !a && e.toJSON && typeof e.toJSON == "function" && !s)
      return sn(e.toJSON(), t, r, n, i, !0);
    let u = fk.call(e);
    return u === "[object Arguments]" ? a ? "[Arguments]" : (l ? "" : "Arguments ") + "[" + (0, ca.printListItems)(
      e,
      t,
      r,
      n,
      i,
      sn
    ) + "]" : Hce(u) ? a ? "[" + e.constructor.name + "]" : (l || !t.printBasicPrototype && e.constructor.name === "Array" ? "" : e.constructor.
    name + " ") + "[" + (0, ca.printListItems)(
      e,
      t,
      r,
      n,
      i,
      sn
    ) + "]" : u === "[object Map]" ? a ? "[Map]" : "Map {" + (0, ca.printIteratorEntries)(
      e.entries(),
      t,
      r,
      n,
      i,
      sn,
      " => "
    ) + "}" : u === "[object Set]" ? a ? "[Set]" : "Set {" + (0, ca.printIteratorValues)(
      e.values(),
      t,
      r,
      n,
      i,
      sn
    ) + "}" : a || $ce(e) ? "[" + vR(e) + "]" : (l || !t.printBasicPrototype && vR(e) === "Object" ? "" : vR(e) + " ") + "{" + (0, ca.printObjectProperties)(
      e,
      t,
      r,
      n,
      i,
      sn
    ) + "}";
  }
  o(hk, "printComplexValue");
  function Gce(e) {
    return e.serialize != null;
  }
  o(Gce, "isNewPlugin");
  function yk(e, t, r, n, i, s) {
    let a;
    try {
      a = Gce(e) ? e.serialize(t, r, n, i, s, sn) : e.print(
        t,
        (l) => sn(l, r, n, i, s),
        (l) => {
          let u = n + r.indent;
          return u + l.replace(Uce, `
` + u);
        },
        {
          edgeSpacing: r.spacingOuter,
          min: r.min,
          spacing: r.spacingInner
        },
        r.colors
      );
    } catch (l) {
      throw new tf(l.message, l.stack);
    }
    if (typeof a != "string")
      throw new Error(
        `pretty-format: Plugin must return type "string" but instead returned "${typeof a}".`
      );
    return a;
  }
  o(yk, "printPlugin");
  function bk(e, t) {
    for (let r = 0; r < e.length; r++)
      try {
        if (e[r].test(t))
          return e[r];
      } catch (n) {
        throw new tf(n.message, n.stack);
      }
    return null;
  }
  o(bk, "findPlugin");
  function sn(e, t, r, n, i, s) {
    let a = bk(t.plugins, e);
    if (a !== null)
      return yk(a, e, t, r, n, i);
    let l = mk(
      e,
      t.printFunctionName,
      t.escapeRegex,
      t.escapeString
    );
    return l !== null ? l : hk(
      e,
      t,
      r,
      n,
      i,
      s
    );
  }
  o(sn, "printer");
  var ER = {
    comment: "gray",
    content: "reset",
    prop: "yellow",
    tag: "cyan",
    value: "green"
  }, gk = Object.keys(ER), Qt = {
    callToJSON: !0,
    compareKeys: void 0,
    escapeRegex: !1,
    escapeString: !0,
    highlight: !1,
    indent: 2,
    maxDepth: 1 / 0,
    min: !1,
    plugins: [],
    printBasicPrototype: !0,
    printFunctionName: !0,
    theme: ER
  };
  wr.DEFAULT_OPTIONS = Qt;
  function Yce(e) {
    if (Object.keys(e).forEach((t) => {
      if (!Qt.hasOwnProperty(t))
        throw new Error(`pretty-format: Unknown option "${t}".`);
    }), e.min && e.indent !== void 0 && e.indent !== 0)
      throw new Error(
        'pretty-format: Options "min" and "indent" cannot be used together.'
      );
    if (e.theme !== void 0) {
      if (e.theme === null)
        throw new Error('pretty-format: Option "theme" must not be null.');
      if (typeof e.theme != "object")
        throw new Error(
          `pretty-format: Option "theme" must be of type "object" but instead received "${typeof e.theme}".`
        );
    }
  }
  o(Yce, "validateOptions");
  var Wce = /* @__PURE__ */ o((e) => gk.reduce((t, r) => {
    let n = e.theme && e.theme[r] !== void 0 ? e.theme[r] : ER[r], i = n && Oce.default[n];
    if (i && typeof i.close == "string" && typeof i.open == "string")
      t[r] = i;
    else
      throw new Error(
        `pretty-format: Option "theme" has a key "${r}" whose value "${n}" is undefined in ansi-styles.`
      );
    return t;
  }, /* @__PURE__ */ Object.create(null)), "getColorsHighlight"), Kce = /* @__PURE__ */ o(() => gk.reduce((e, t) => (e[t] = {
    close: "",
    open: ""
  }, e), /* @__PURE__ */ Object.create(null)), "getColorsEmpty"), vk = /* @__PURE__ */ o((e) => e && e.printFunctionName !== void 0 ? e.printFunctionName :
  Qt.printFunctionName, "getPrintFunctionName"), Ek = /* @__PURE__ */ o((e) => e && e.escapeRegex !== void 0 ? e.escapeRegex : Qt.escapeRegex,
  "getEscapeRegex"), Tk = /* @__PURE__ */ o((e) => e && e.escapeString !== void 0 ? e.escapeString : Qt.escapeString, "getEscapeString"), pk = /* @__PURE__ */ o(
  (e) => {
    var t;
    return {
      callToJSON: e && e.callToJSON !== void 0 ? e.callToJSON : Qt.callToJSON,
      colors: e && e.highlight ? Wce(e) : Kce(),
      compareKeys: e && typeof e.compareKeys == "function" ? e.compareKeys : Qt.compareKeys,
      escapeRegex: Ek(e),
      escapeString: Tk(e),
      indent: e && e.min ? "" : Xce(
        e && e.indent !== void 0 ? e.indent : Qt.indent
      ),
      maxDepth: e && e.maxDepth !== void 0 ? e.maxDepth : Qt.maxDepth,
      min: e && e.min !== void 0 ? e.min : Qt.min,
      plugins: e && e.plugins !== void 0 ? e.plugins : Qt.plugins,
      printBasicPrototype: (t = e?.printBasicPrototype) !== null && t !== void 0 ? t : !0,
      printFunctionName: vk(e),
      spacingInner: e && e.min ? " " : `
`,
      spacingOuter: e && e.min ? "" : `
`
    };
  }, "getConfig");
  function Xce(e) {
    return new Array(e + 1).join(" ");
  }
  o(Xce, "createIndent");
  function _k(e, t) {
    if (t && (Yce(t), t.plugins)) {
      let n = bk(t.plugins, e);
      if (n !== null)
        return yk(n, e, pk(t), "", 0, []);
    }
    let r = mk(
      e,
      vk(t),
      Ek(t),
      Tk(t)
    );
    return r !== null ? r : hk(e, pk(t), "", 0, []);
  }
  o(_k, "format");
  var Jce = {
    AsymmetricMatcher: qce.default,
    ConvertAnsi: Ice.default,
    DOMCollection: Mce.default,
    DOMElement: Nce.default,
    Immutable: jce.default,
    ReactElement: Lce.default,
    ReactTestComponent: Fce.default
  };
  wr.plugins = Jce;
  var Zce = _k;
  wr.default = Zce;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/util/iteratorProxy.js
var Gk = v((sf) => {
  "use strict";
  Object.defineProperty(sf, "__esModule", {
    value: !0
  });
  sf.default = void 0;
  function Ode() {
    var e = this, t = 0, r = {
      "@@iterator": /* @__PURE__ */ o(function() {
        return r;
      }, "iterator"),
      next: /* @__PURE__ */ o(function() {
        if (t < e.length) {
          var i = e[t];
          return t = t + 1, {
            done: !1,
            value: i
          };
        } else
          return {
            done: !0
          };
      }, "next")
    };
    return r;
  }
  o(Ode, "iteratorProxy");
  var qde = Ode;
  sf.default = qde;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/util/iterationDecorator.js
var hi = v((wR) => {
  "use strict";
  Object.defineProperty(wR, "__esModule", {
    value: !0
  });
  wR.default = Nde;
  var Ide = Mde(Gk());
  function Mde(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(Mde, "_interopRequireDefault");
  function RR(e) {
    "@babel/helpers - typeof";
    return RR = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, RR(e);
  }
  o(RR, "_typeof");
  function Nde(e, t) {
    return typeof Symbol == "function" && RR(Symbol.iterator) === "symbol" && Object.defineProperty(e, Symbol.iterator, {
      value: Ide.default.bind(t)
    }), e;
  }
  o(Nde, "iterationDecorator");
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/ariaPropsMap.js
var Kk = v((af) => {
  "use strict";
  Object.defineProperty(af, "__esModule", {
    value: !0
  });
  af.default = void 0;
  var jde = Lde(hi());
  function Lde(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(Lde, "_interopRequireDefault");
  function SR(e, t) {
    return Dde(e) || kde(e, t) || Wk(e, t) || Fde();
  }
  o(SR, "_slicedToArray");
  function Fde() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(Fde, "_nonIterableRest");
  function kde(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n = [], i = !0, s = !1, a, l;
      try {
        for (r = r.call(e); !(i = (a = r.next()).done) && (n.push(a.value), !(t && n.length === t)); i = !0)
          ;
      } catch (u) {
        s = !0, l = u;
      } finally {
        try {
          !i && r.return != null && r.return();
        } finally {
          if (s) throw l;
        }
      }
      return n;
    }
  }
  o(kde, "_iterableToArrayLimit");
  function Dde(e) {
    if (Array.isArray(e)) return e;
  }
  o(Dde, "_arrayWithHoles");
  function $de(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = Wk(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = !0, a = !1, l;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return s = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      a = !0, l = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }, "f") };
  }
  o($de, "_createForOfIteratorHelper");
  function Wk(e, t) {
    if (e) {
      if (typeof e == "string") return Yk(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yk(e, t);
    }
  }
  o(Wk, "_unsupportedIterableToArray");
  function Yk(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  o(Yk, "_arrayLikeToArray");
  var yi = [["aria-activedescendant", {
    type: "id"
  }], ["aria-atomic", {
    type: "boolean"
  }], ["aria-autocomplete", {
    type: "token",
    values: ["inline", "list", "both", "none"]
  }], ["aria-braillelabel", {
    type: "string"
  }], ["aria-brailleroledescription", {
    type: "string"
  }], ["aria-busy", {
    type: "boolean"
  }], ["aria-checked", {
    type: "tristate"
  }], ["aria-colcount", {
    type: "integer"
  }], ["aria-colindex", {
    type: "integer"
  }], ["aria-colspan", {
    type: "integer"
  }], ["aria-controls", {
    type: "idlist"
  }], ["aria-current", {
    type: "token",
    values: ["page", "step", "location", "date", "time", !0, !1]
  }], ["aria-describedby", {
    type: "idlist"
  }], ["aria-description", {
    type: "string"
  }], ["aria-details", {
    type: "id"
  }], ["aria-disabled", {
    type: "boolean"
  }], ["aria-dropeffect", {
    type: "tokenlist",
    values: ["copy", "execute", "link", "move", "none", "popup"]
  }], ["aria-errormessage", {
    type: "id"
  }], ["aria-expanded", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-flowto", {
    type: "idlist"
  }], ["aria-grabbed", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-haspopup", {
    type: "token",
    values: [!1, !0, "menu", "listbox", "tree", "grid", "dialog"]
  }], ["aria-hidden", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-invalid", {
    type: "token",
    values: ["grammar", !1, "spelling", !0]
  }], ["aria-keyshortcuts", {
    type: "string"
  }], ["aria-label", {
    type: "string"
  }], ["aria-labelledby", {
    type: "idlist"
  }], ["aria-level", {
    type: "integer"
  }], ["aria-live", {
    type: "token",
    values: ["assertive", "off", "polite"]
  }], ["aria-modal", {
    type: "boolean"
  }], ["aria-multiline", {
    type: "boolean"
  }], ["aria-multiselectable", {
    type: "boolean"
  }], ["aria-orientation", {
    type: "token",
    values: ["vertical", "undefined", "horizontal"]
  }], ["aria-owns", {
    type: "idlist"
  }], ["aria-placeholder", {
    type: "string"
  }], ["aria-posinset", {
    type: "integer"
  }], ["aria-pressed", {
    type: "tristate"
  }], ["aria-readonly", {
    type: "boolean"
  }], ["aria-relevant", {
    type: "tokenlist",
    values: ["additions", "all", "removals", "text"]
  }], ["aria-required", {
    type: "boolean"
  }], ["aria-roledescription", {
    type: "string"
  }], ["aria-rowcount", {
    type: "integer"
  }], ["aria-rowindex", {
    type: "integer"
  }], ["aria-rowspan", {
    type: "integer"
  }], ["aria-selected", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-setsize", {
    type: "integer"
  }], ["aria-sort", {
    type: "token",
    values: ["ascending", "descending", "none", "other"]
  }], ["aria-valuemax", {
    type: "number"
  }], ["aria-valuemin", {
    type: "number"
  }], ["aria-valuenow", {
    type: "number"
  }], ["aria-valuetext", {
    type: "string"
  }]], xR = {
    entries: /* @__PURE__ */ o(function() {
      return yi;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = $de(yi), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var s = SR(i.value, 2), a = s[0], l = s[1];
          t.call(r, l, a, yi);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = yi.find(function(n) {
        return n[0] === t;
      });
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!xR.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return yi.map(function(t) {
        var r = SR(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return yi.map(function(t) {
        var r = SR(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, Bde = (0, jde.default)(xR, xR.entries());
  af.default = Bde;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/domMap.js
var Zk = v((lf) => {
  "use strict";
  Object.defineProperty(lf, "__esModule", {
    value: !0
  });
  lf.default = void 0;
  var Ude = Hde(hi());
  function Hde(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(Hde, "_interopRequireDefault");
  function CR(e, t) {
    return Gde(e) || zde(e, t) || Jk(e, t) || Vde();
  }
  o(CR, "_slicedToArray");
  function Vde() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(Vde, "_nonIterableRest");
  function zde(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n = [], i = !0, s = !1, a, l;
      try {
        for (r = r.call(e); !(i = (a = r.next()).done) && (n.push(a.value), !(t && n.length === t)); i = !0)
          ;
      } catch (u) {
        s = !0, l = u;
      } finally {
        try {
          !i && r.return != null && r.return();
        } finally {
          if (s) throw l;
        }
      }
      return n;
    }
  }
  o(zde, "_iterableToArrayLimit");
  function Gde(e) {
    if (Array.isArray(e)) return e;
  }
  o(Gde, "_arrayWithHoles");
  function Yde(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = Jk(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = !0, a = !1, l;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return s = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      a = !0, l = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }, "f") };
  }
  o(Yde, "_createForOfIteratorHelper");
  function Jk(e, t) {
    if (e) {
      if (typeof e == "string") return Xk(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Xk(e, t);
    }
  }
  o(Jk, "_unsupportedIterableToArray");
  function Xk(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  o(Xk, "_arrayLikeToArray");
  var bi = [["a", {
    reserved: !1
  }], ["abbr", {
    reserved: !1
  }], ["acronym", {
    reserved: !1
  }], ["address", {
    reserved: !1
  }], ["applet", {
    reserved: !1
  }], ["area", {
    reserved: !1
  }], ["article", {
    reserved: !1
  }], ["aside", {
    reserved: !1
  }], ["audio", {
    reserved: !1
  }], ["b", {
    reserved: !1
  }], ["base", {
    reserved: !0
  }], ["bdi", {
    reserved: !1
  }], ["bdo", {
    reserved: !1
  }], ["big", {
    reserved: !1
  }], ["blink", {
    reserved: !1
  }], ["blockquote", {
    reserved: !1
  }], ["body", {
    reserved: !1
  }], ["br", {
    reserved: !1
  }], ["button", {
    reserved: !1
  }], ["canvas", {
    reserved: !1
  }], ["caption", {
    reserved: !1
  }], ["center", {
    reserved: !1
  }], ["cite", {
    reserved: !1
  }], ["code", {
    reserved: !1
  }], ["col", {
    reserved: !0
  }], ["colgroup", {
    reserved: !0
  }], ["content", {
    reserved: !1
  }], ["data", {
    reserved: !1
  }], ["datalist", {
    reserved: !1
  }], ["dd", {
    reserved: !1
  }], ["del", {
    reserved: !1
  }], ["details", {
    reserved: !1
  }], ["dfn", {
    reserved: !1
  }], ["dialog", {
    reserved: !1
  }], ["dir", {
    reserved: !1
  }], ["div", {
    reserved: !1
  }], ["dl", {
    reserved: !1
  }], ["dt", {
    reserved: !1
  }], ["em", {
    reserved: !1
  }], ["embed", {
    reserved: !1
  }], ["fieldset", {
    reserved: !1
  }], ["figcaption", {
    reserved: !1
  }], ["figure", {
    reserved: !1
  }], ["font", {
    reserved: !1
  }], ["footer", {
    reserved: !1
  }], ["form", {
    reserved: !1
  }], ["frame", {
    reserved: !1
  }], ["frameset", {
    reserved: !1
  }], ["h1", {
    reserved: !1
  }], ["h2", {
    reserved: !1
  }], ["h3", {
    reserved: !1
  }], ["h4", {
    reserved: !1
  }], ["h5", {
    reserved: !1
  }], ["h6", {
    reserved: !1
  }], ["head", {
    reserved: !0
  }], ["header", {
    reserved: !1
  }], ["hgroup", {
    reserved: !1
  }], ["hr", {
    reserved: !1
  }], ["html", {
    reserved: !0
  }], ["i", {
    reserved: !1
  }], ["iframe", {
    reserved: !1
  }], ["img", {
    reserved: !1
  }], ["input", {
    reserved: !1
  }], ["ins", {
    reserved: !1
  }], ["kbd", {
    reserved: !1
  }], ["keygen", {
    reserved: !1
  }], ["label", {
    reserved: !1
  }], ["legend", {
    reserved: !1
  }], ["li", {
    reserved: !1
  }], ["link", {
    reserved: !0
  }], ["main", {
    reserved: !1
  }], ["map", {
    reserved: !1
  }], ["mark", {
    reserved: !1
  }], ["marquee", {
    reserved: !1
  }], ["menu", {
    reserved: !1
  }], ["menuitem", {
    reserved: !1
  }], ["meta", {
    reserved: !0
  }], ["meter", {
    reserved: !1
  }], ["nav", {
    reserved: !1
  }], ["noembed", {
    reserved: !0
  }], ["noscript", {
    reserved: !0
  }], ["object", {
    reserved: !1
  }], ["ol", {
    reserved: !1
  }], ["optgroup", {
    reserved: !1
  }], ["option", {
    reserved: !1
  }], ["output", {
    reserved: !1
  }], ["p", {
    reserved: !1
  }], ["param", {
    reserved: !0
  }], ["picture", {
    reserved: !0
  }], ["pre", {
    reserved: !1
  }], ["progress", {
    reserved: !1
  }], ["q", {
    reserved: !1
  }], ["rp", {
    reserved: !1
  }], ["rt", {
    reserved: !1
  }], ["rtc", {
    reserved: !1
  }], ["ruby", {
    reserved: !1
  }], ["s", {
    reserved: !1
  }], ["samp", {
    reserved: !1
  }], ["script", {
    reserved: !0
  }], ["section", {
    reserved: !1
  }], ["select", {
    reserved: !1
  }], ["small", {
    reserved: !1
  }], ["source", {
    reserved: !0
  }], ["spacer", {
    reserved: !1
  }], ["span", {
    reserved: !1
  }], ["strike", {
    reserved: !1
  }], ["strong", {
    reserved: !1
  }], ["style", {
    reserved: !0
  }], ["sub", {
    reserved: !1
  }], ["summary", {
    reserved: !1
  }], ["sup", {
    reserved: !1
  }], ["table", {
    reserved: !1
  }], ["tbody", {
    reserved: !1
  }], ["td", {
    reserved: !1
  }], ["textarea", {
    reserved: !1
  }], ["tfoot", {
    reserved: !1
  }], ["th", {
    reserved: !1
  }], ["thead", {
    reserved: !1
  }], ["time", {
    reserved: !1
  }], ["title", {
    reserved: !0
  }], ["tr", {
    reserved: !1
  }], ["track", {
    reserved: !0
  }], ["tt", {
    reserved: !1
  }], ["u", {
    reserved: !1
  }], ["ul", {
    reserved: !1
  }], ["var", {
    reserved: !1
  }], ["video", {
    reserved: !1
  }], ["wbr", {
    reserved: !1
  }], ["xmp", {
    reserved: !1
  }]], PR = {
    entries: /* @__PURE__ */ o(function() {
      return bi;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = Yde(bi), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var s = CR(i.value, 2), a = s[0], l = s[1];
          t.call(r, l, a, bi);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = bi.find(function(n) {
        return n[0] === t;
      });
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!PR.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return bi.map(function(t) {
        var r = CR(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return bi.map(function(t) {
        var r = CR(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, Wde = (0, Ude.default)(PR, PR.entries());
  lf.default = Wde;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/commandRole.js
var Qk = v((uf) => {
  "use strict";
  Object.defineProperty(uf, "__esModule", {
    value: !0
  });
  uf.default = void 0;
  var Kde = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, Xde = Kde;
  uf.default = Xde;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/compositeRole.js
var eD = v((cf) => {
  "use strict";
  Object.defineProperty(cf, "__esModule", {
    value: !0
  });
  cf.default = void 0;
  var Jde = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, Zde = Jde;
  cf.default = Zde;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/inputRole.js
var tD = v((df) => {
  "use strict";
  Object.defineProperty(df, "__esModule", {
    value: !0
  });
  df.default = void 0;
  var Qde = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null
    },
    relatedConcepts: [{
      concept: {
        name: "input"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, epe = Qde;
  df.default = epe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/landmarkRole.js
var rD = v((pf) => {
  "use strict";
  Object.defineProperty(pf, "__esModule", {
    value: !0
  });
  pf.default = void 0;
  var tpe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, rpe = tpe;
  pf.default = rpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/rangeRole.js
var nD = v((ff) => {
  "use strict";
  Object.defineProperty(ff, "__esModule", {
    value: !0
  });
  ff.default = void 0;
  var npe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuemax": null,
      "aria-valuemin": null,
      "aria-valuenow": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, ope = npe;
  ff.default = ope;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/roletypeRole.js
var oD = v((mf) => {
  "use strict";
  Object.defineProperty(mf, "__esModule", {
    value: !0
  });
  mf.default = void 0;
  var ipe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {
      "aria-atomic": null,
      "aria-busy": null,
      "aria-controls": null,
      "aria-current": null,
      "aria-describedby": null,
      "aria-details": null,
      "aria-dropeffect": null,
      "aria-flowto": null,
      "aria-grabbed": null,
      "aria-hidden": null,
      "aria-keyshortcuts": null,
      "aria-label": null,
      "aria-labelledby": null,
      "aria-live": null,
      "aria-owns": null,
      "aria-relevant": null,
      "aria-roledescription": null
    },
    relatedConcepts: [{
      concept: {
        name: "role"
      },
      module: "XHTML"
    }, {
      concept: {
        name: "type"
      },
      module: "Dublin Core"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  }, spe = ipe;
  mf.default = spe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/sectionRole.js
var iD = v((hf) => {
  "use strict";
  Object.defineProperty(hf, "__esModule", {
    value: !0
  });
  hf.default = void 0;
  var ape = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "frontmatter"
      },
      module: "DTB"
    }, {
      concept: {
        name: "level"
      },
      module: "DTB"
    }, {
      concept: {
        name: "level"
      },
      module: "SMIL"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, lpe = ape;
  hf.default = lpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/sectionheadRole.js
var sD = v((yf) => {
  "use strict";
  Object.defineProperty(yf, "__esModule", {
    value: !0
  });
  yf.default = void 0;
  var upe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, cpe = upe;
  yf.default = cpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/selectRole.js
var aD = v((bf) => {
  "use strict";
  Object.defineProperty(bf, "__esModule", {
    value: !0
  });
  bf.default = void 0;
  var dpe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "group"]]
  }, ppe = dpe;
  bf.default = ppe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/structureRole.js
var lD = v((gf) => {
  "use strict";
  Object.defineProperty(gf, "__esModule", {
    value: !0
  });
  gf.default = void 0;
  var fpe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, mpe = fpe;
  gf.default = mpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/widgetRole.js
var uD = v((vf) => {
  "use strict";
  Object.defineProperty(vf, "__esModule", {
    value: !0
  });
  vf.default = void 0;
  var hpe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, ype = hpe;
  vf.default = ype;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/abstract/windowRole.js
var cD = v((Ef) => {
  "use strict";
  Object.defineProperty(Ef, "__esModule", {
    value: !0
  });
  Ef.default = void 0;
  var bpe = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-modal": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, gpe = bpe;
  Ef.default = gpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/ariaAbstractRoles.js
var dD = v((Tf) => {
  "use strict";
  Object.defineProperty(Tf, "__esModule", {
    value: !0
  });
  Tf.default = void 0;
  var vpe = Dt(Qk()), Epe = Dt(eD()), Tpe = Dt(tD()), _pe = Dt(rD()), Rpe = Dt(nD()), wpe = Dt(oD()), Spe = Dt(iD()), xpe = Dt(sD()), Cpe = Dt(
  aD()), Ppe = Dt(lD()), Ape = Dt(uD()), Ope = Dt(cD());
  function Dt(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(Dt, "_interopRequireDefault");
  var qpe = [["command", vpe.default], ["composite", Epe.default], ["input", Tpe.default], ["landmark", _pe.default], ["range", Rpe.default],
  ["roletype", wpe.default], ["section", Spe.default], ["sectionhead", xpe.default], ["select", Cpe.default], ["structure", Ppe.default], ["\
widget", Ape.default], ["window", Ope.default]], Ipe = qpe;
  Tf.default = Ipe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/alertRole.js
var pD = v((_f) => {
  "use strict";
  Object.defineProperty(_f, "__esModule", {
    value: !0
  });
  _f.default = void 0;
  var Mpe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-atomic": "true",
      "aria-live": "assertive"
    },
    relatedConcepts: [{
      concept: {
        name: "alert"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Npe = Mpe;
  _f.default = Npe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/alertdialogRole.js
var fD = v((Rf) => {
  "use strict";
  Object.defineProperty(Rf, "__esModule", {
    value: !0
  });
  Rf.default = void 0;
  var jpe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "alert"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "alert"], ["roletype", "window", "dialog"]]
  }, Lpe = jpe;
  Rf.default = Lpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/applicationRole.js
var mD = v((wf) => {
  "use strict";
  Object.defineProperty(wf, "__esModule", {
    value: !0
  });
  wf.default = void 0;
  var Fpe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "Device Independence Delivery Unit"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, kpe = Fpe;
  wf.default = kpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/articleRole.js
var hD = v((Sf) => {
  "use strict";
  Object.defineProperty(Sf, "__esModule", {
    value: !0
  });
  Sf.default = void 0;
  var Dpe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "article"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "document"]]
  }, $pe = Dpe;
  Sf.default = $pe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/bannerRole.js
var yD = v((xf) => {
  "use strict";
  Object.defineProperty(xf, "__esModule", {
    value: !0
  });
  xf.default = void 0;
  var Bpe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element"],
        name: "header"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Upe = Bpe;
  xf.default = Upe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/blockquoteRole.js
var bD = v((Cf) => {
  "use strict";
  Object.defineProperty(Cf, "__esModule", {
    value: !0
  });
  Cf.default = void 0;
  var Hpe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "blockquote"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Vpe = Hpe;
  Cf.default = Vpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/buttonRole.js
var gD = v((Pf) => {
  "use strict";
  Object.defineProperty(Pf, "__esModule", {
    value: !0
  });
  Pf.default = void 0;
  var zpe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-pressed": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "button"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "image"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "reset"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "submit"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "button"
      },
      module: "HTML"
    }, {
      concept: {
        name: "trigger"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, Gpe = zpe;
  Pf.default = Gpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/captionRole.js
var vD = v((Af) => {
  "use strict";
  Object.defineProperty(Af, "__esModule", {
    value: !0
  });
  Af.default = void 0;
  var Ype = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "caption"
      },
      module: "HTML"
    }],
    requireContextRole: ["figure", "grid", "table"],
    requiredContextRole: ["figure", "grid", "table"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Wpe = Ype;
  Af.default = Wpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/cellRole.js
var ED = v((Of) => {
  "use strict";
  Object.defineProperty(Of, "__esModule", {
    value: !0
  });
  Of.default = void 0;
  var Kpe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-colindex": null,
      "aria-colspan": null,
      "aria-rowindex": null,
      "aria-rowspan": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["ancestor table element has table role"],
        name: "td"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Xpe = Kpe;
  Of.default = Xpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/checkboxRole.js
var TD = v((qf) => {
  "use strict";
  Object.defineProperty(qf, "__esModule", {
    value: !0
  });
  qf.default = void 0;
  var Jpe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "checkbox"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "option"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input"]]
  }, Zpe = Jpe;
  qf.default = Zpe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/codeRole.js
var _D = v((If) => {
  "use strict";
  Object.defineProperty(If, "__esModule", {
    value: !0
  });
  If.default = void 0;
  var Qpe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "code"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, efe = Qpe;
  If.default = efe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/columnheaderRole.js
var RD = v((Mf) => {
  "use strict";
  Object.defineProperty(Mf, "__esModule", {
    value: !0
  });
  Mf.default = void 0;
  var tfe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-sort": null
    },
    relatedConcepts: [{
      concept: {
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "col"
        }],
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "colgroup"
        }],
        name: "th"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widge\
t", "gridcell"], ["roletype", "structure", "sectionhead"]]
  }, rfe = tfe;
  Mf.default = rfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/comboboxRole.js
var wD = v((Nf) => {
  "use strict";
  Object.defineProperty(Nf, "__esModule", {
    value: !0
  });
  Nf.default = void 0;
  var nfe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-autocomplete": null,
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-expanded": "false",
      "aria-haspopup": "listbox"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "email"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "search"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "tel"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "text"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "multiple"
        }, {
          constraints: ["undefined"],
          name: "size"
        }],
        constraints: ["the multiple attribute is not set and the size attribute does not have a value greater than 1"],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-controls": null,
      "aria-expanded": "false"
    },
    superClass: [["roletype", "widget", "input"]]
  }, ofe = nfe;
  Nf.default = ofe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/complementaryRole.js
var SD = v((jf) => {
  "use strict";
  Object.defineProperty(jf, "__esModule", {
    value: !0
  });
  jf.default = void 0;
  var ife = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        constraints: ["scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        constraints: ["scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "aside"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, sfe = ife;
  jf.default = sfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/contentinfoRole.js
var xD = v((Lf) => {
  "use strict";
  Object.defineProperty(Lf, "__esModule", {
    value: !0
  });
  Lf.default = void 0;
  var afe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element"],
        name: "footer"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, lfe = afe;
  Lf.default = lfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/definitionRole.js
var CD = v((Ff) => {
  "use strict";
  Object.defineProperty(Ff, "__esModule", {
    value: !0
  });
  Ff.default = void 0;
  var ufe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dd"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, cfe = ufe;
  Ff.default = cfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/deletionRole.js
var PD = v((kf) => {
  "use strict";
  Object.defineProperty(kf, "__esModule", {
    value: !0
  });
  kf.default = void 0;
  var dfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "del"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, pfe = dfe;
  kf.default = pfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/dialogRole.js
var AD = v((Df) => {
  "use strict";
  Object.defineProperty(Df, "__esModule", {
    value: !0
  });
  Df.default = void 0;
  var ffe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dialog"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "window"]]
  }, mfe = ffe;
  Df.default = mfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/directoryRole.js
var OD = v(($f) => {
  "use strict";
  Object.defineProperty($f, "__esModule", {
    value: !0
  });
  $f.default = void 0;
  var hfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      module: "DAISY Guide"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "list"]]
  }, yfe = hfe;
  $f.default = yfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/documentRole.js
var qD = v((Bf) => {
  "use strict";
  Object.defineProperty(Bf, "__esModule", {
    value: !0
  });
  Bf.default = void 0;
  var bfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "Device Independence Delivery Unit"
      }
    }, {
      concept: {
        name: "html"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, gfe = bfe;
  Bf.default = gfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/emphasisRole.js
var ID = v((Uf) => {
  "use strict";
  Object.defineProperty(Uf, "__esModule", {
    value: !0
  });
  Uf.default = void 0;
  var vfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "em"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Efe = vfe;
  Uf.default = Efe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/feedRole.js
var MD = v((Hf) => {
  "use strict";
  Object.defineProperty(Hf, "__esModule", {
    value: !0
  });
  Hf.default = void 0;
  var Tfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["article"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "list"]]
  }, _fe = Tfe;
  Hf.default = _fe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/figureRole.js
var ND = v((Vf) => {
  "use strict";
  Object.defineProperty(Vf, "__esModule", {
    value: !0
  });
  Vf.default = void 0;
  var Rfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "figure"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, wfe = Rfe;
  Vf.default = wfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/formRole.js
var jD = v((zf) => {
  "use strict";
  Object.defineProperty(zf, "__esModule", {
    value: !0
  });
  zf.default = void 0;
  var Sfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        name: "form"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        name: "form"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "name"
        }],
        name: "form"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, xfe = Sfe;
  zf.default = xfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/genericRole.js
var LD = v((Gf) => {
  "use strict";
  Object.defineProperty(Gf, "__esModule", {
    value: !0
  });
  Gf.default = void 0;
  var Cfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "a"
      },
      module: "HTML"
    }, {
      concept: {
        name: "area"
      },
      module: "HTML"
    }, {
      concept: {
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        name: "b"
      },
      module: "HTML"
    }, {
      concept: {
        name: "bdo"
      },
      module: "HTML"
    }, {
      concept: {
        name: "body"
      },
      module: "HTML"
    }, {
      concept: {
        name: "data"
      },
      module: "HTML"
    }, {
      concept: {
        name: "div"
      },
      module: "HTML"
    }, {
      concept: {
        constraints: ["scoped to the main element", "scoped to a sectioning content element", "scoped to a sectioning root element other tha\
n body"],
        name: "footer"
      },
      module: "HTML"
    }, {
      concept: {
        constraints: ["scoped to the main element", "scoped to a sectioning content element", "scoped to a sectioning root element other tha\
n body"],
        name: "header"
      },
      module: "HTML"
    }, {
      concept: {
        name: "hgroup"
      },
      module: "HTML"
    }, {
      concept: {
        name: "i"
      },
      module: "HTML"
    }, {
      concept: {
        name: "pre"
      },
      module: "HTML"
    }, {
      concept: {
        name: "q"
      },
      module: "HTML"
    }, {
      concept: {
        name: "samp"
      },
      module: "HTML"
    }, {
      concept: {
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        name: "small"
      },
      module: "HTML"
    }, {
      concept: {
        name: "span"
      },
      module: "HTML"
    }, {
      concept: {
        name: "u"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, Pfe = Cfe;
  Gf.default = Pfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/gridRole.js
var FD = v((Yf) => {
  "use strict";
  Object.defineProperty(Yf, "__esModule", {
    value: !0
  });
  Yf.default = void 0;
  var Afe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-multiselectable": null,
      "aria-readonly": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "table"]]
  }, Ofe = Afe;
  Yf.default = Ofe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/gridcellRole.js
var kD = v((Wf) => {
  "use strict";
  Object.defineProperty(Wf, "__esModule", {
    value: !0
  });
  Wf.default = void 0;
  var qfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-selected": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["ancestor table element has grid role", "ancestor table element has treegrid role"],
        name: "td"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "widget"]]
  }, Ife = qfe;
  Wf.default = Ife;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/groupRole.js
var DD = v((Kf) => {
  "use strict";
  Object.defineProperty(Kf, "__esModule", {
    value: !0
  });
  Kf.default = void 0;
  var Mfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null
    },
    relatedConcepts: [{
      concept: {
        name: "details"
      },
      module: "HTML"
    }, {
      concept: {
        name: "fieldset"
      },
      module: "HTML"
    }, {
      concept: {
        name: "optgroup"
      },
      module: "HTML"
    }, {
      concept: {
        name: "address"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Nfe = Mfe;
  Kf.default = Nfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/headingRole.js
var $D = v((Xf) => {
  "use strict";
  Object.defineProperty(Xf, "__esModule", {
    value: !0
  });
  Xf.default = void 0;
  var jfe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-level": "2"
    },
    relatedConcepts: [{
      concept: {
        name: "h1"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h2"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h3"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h4"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h5"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h6"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-level": "2"
    },
    superClass: [["roletype", "structure", "sectionhead"]]
  }, Lfe = jfe;
  Xf.default = Lfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/imgRole.js
var BD = v((Jf) => {
  "use strict";
  Object.defineProperty(Jf, "__esModule", {
    value: !0
  });
  Jf.default = void 0;
  var Ffe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "alt"
        }],
        name: "img"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "alt"
        }],
        name: "img"
      },
      module: "HTML"
    }, {
      concept: {
        name: "imggroup"
      },
      module: "DTB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, kfe = Ffe;
  Jf.default = kfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/insertionRole.js
var UD = v((Zf) => {
  "use strict";
  Object.defineProperty(Zf, "__esModule", {
    value: !0
  });
  Zf.default = void 0;
  var Dfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "ins"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, $fe = Dfe;
  Zf.default = $fe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/linkRole.js
var HD = v((Qf) => {
  "use strict";
  Object.defineProperty(Qf, "__esModule", {
    value: !0
  });
  Qf.default = void 0;
  var Bfe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "href"
        }],
        name: "a"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "href"
        }],
        name: "area"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, Ufe = Bfe;
  Qf.default = Ufe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/listRole.js
var VD = v((em) => {
  "use strict";
  Object.defineProperty(em, "__esModule", {
    value: !0
  });
  em.default = void 0;
  var Hfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menu"
      },
      module: "HTML"
    }, {
      concept: {
        name: "ol"
      },
      module: "HTML"
    }, {
      concept: {
        name: "ul"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["listitem"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Vfe = Hfe;
  em.default = Vfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/listboxRole.js
var zD = v((tm) => {
  "use strict";
  Object.defineProperty(tm, "__esModule", {
    value: !0
  });
  tm.default = void 0;
  var zfe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-invalid": null,
      "aria-multiselectable": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-orientation": "vertical"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: [">1"],
          name: "size"
        }],
        constraints: ["the size attribute value is greater than 1"],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "multiple"
        }],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        name: "datalist"
      },
      module: "HTML"
    }, {
      concept: {
        name: "list"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["option", "group"], ["option"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, Gfe = zfe;
  tm.default = Gfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/listitemRole.js
var GD = v((rm) => {
  "use strict";
  Object.defineProperty(rm, "__esModule", {
    value: !0
  });
  rm.default = void 0;
  var Yfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-level": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["direct descendant of ol", "direct descendant of ul", "direct descendant of menu"],
        name: "li"
      },
      module: "HTML"
    }, {
      concept: {
        name: "item"
      },
      module: "XForms"
    }],
    requireContextRole: ["directory", "list"],
    requiredContextRole: ["directory", "list"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Wfe = Yfe;
  rm.default = Wfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/logRole.js
var YD = v((nm) => {
  "use strict";
  Object.defineProperty(nm, "__esModule", {
    value: !0
  });
  nm.default = void 0;
  var Kfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-live": "polite"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Xfe = Kfe;
  nm.default = Xfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/mainRole.js
var WD = v((om) => {
  "use strict";
  Object.defineProperty(om, "__esModule", {
    value: !0
  });
  om.default = void 0;
  var Jfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "main"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Zfe = Jfe;
  om.default = Zfe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/markRole.js
var KD = v((im) => {
  "use strict";
  Object.defineProperty(im, "__esModule", {
    value: !0
  });
  im.default = void 0;
  var Qfe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: [],
    props: {
      "aria-braillelabel": null,
      "aria-brailleroledescription": null,
      "aria-description": null
    },
    relatedConcepts: [{
      concept: {
        name: "mark"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, eme = Qfe;
  im.default = eme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/marqueeRole.js
var XD = v((sm) => {
  "use strict";
  Object.defineProperty(sm, "__esModule", {
    value: !0
  });
  sm.default = void 0;
  var tme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, rme = tme;
  sm.default = rme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/mathRole.js
var JD = v((am) => {
  "use strict";
  Object.defineProperty(am, "__esModule", {
    value: !0
  });
  am.default = void 0;
  var nme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "math"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, ome = nme;
  am.default = ome;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/menuRole.js
var ZD = v((lm) => {
  "use strict";
  Object.defineProperty(lm, "__esModule", {
    value: !0
  });
  lm.default = void 0;
  var ime = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "vertical"
    },
    relatedConcepts: [{
      concept: {
        name: "MENU"
      },
      module: "JAPI"
    }, {
      concept: {
        name: "list"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }, {
      concept: {
        name: "sidebar"
      },
      module: "DTB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckb\
ox"], ["menuitemradio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, sme = ime;
  lm.default = sme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/menubarRole.js
var QD = v((um) => {
  "use strict";
  Object.defineProperty(um, "__esModule", {
    value: !0
  });
  um.default = void 0;
  var ame = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      concept: {
        name: "toolbar"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckb\
ox"], ["menuitemradio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select", "menu"], ["roletype", "structure", "section", "group", "select", "menu"]]
  }, lme = ame;
  um.default = lme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/menuitemRole.js
var e$ = v((cm) => {
  "use strict";
  Object.defineProperty(cm, "__esModule", {
    value: !0
  });
  cm.default = void 0;
  var ume = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "MENU_ITEM"
      },
      module: "JAPI"
    }, {
      concept: {
        name: "listitem"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "option"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, cme = ume;
  cm.default = cme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/menuitemcheckboxRole.js
var t$ = v((dm) => {
  "use strict";
  Object.defineProperty(dm, "__esModule", {
    value: !0
  });
  dm.default = void 0;
  var dme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menuitem"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox"], ["roletype", "widget", "command", "menuitem"]]
  }, pme = dme;
  dm.default = pme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/menuitemradioRole.js
var r$ = v((pm) => {
  "use strict";
  Object.defineProperty(pm, "__esModule", {
    value: !0
  });
  pm.default = void 0;
  var fme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menuitem"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox", "menuitemcheckbox"], ["roletype", "widget", "command", "menuitem", "menuitemche\
ckbox"], ["roletype", "widget", "input", "radio"]]
  }, mme = fme;
  pm.default = mme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/meterRole.js
var n$ = v((fm) => {
  "use strict";
  Object.defineProperty(fm, "__esModule", {
    value: !0
  });
  fm.default = void 0;
  var hme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuetext": null,
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [{
      concept: {
        name: "meter"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-valuenow": null
    },
    superClass: [["roletype", "structure", "range"]]
  }, yme = hme;
  fm.default = yme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/navigationRole.js
var o$ = v((mm) => {
  "use strict";
  Object.defineProperty(mm, "__esModule", {
    value: !0
  });
  mm.default = void 0;
  var bme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "nav"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, gme = bme;
  mm.default = gme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/noneRole.js
var i$ = v((hm) => {
  "use strict";
  Object.defineProperty(hm, "__esModule", {
    value: !0
  });
  hm.default = void 0;
  var vme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  }, Eme = vme;
  hm.default = Eme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/noteRole.js
var s$ = v((ym) => {
  "use strict";
  Object.defineProperty(ym, "__esModule", {
    value: !0
  });
  ym.default = void 0;
  var Tme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, _me = Tme;
  ym.default = _me;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/optionRole.js
var a$ = v((bm) => {
  "use strict";
  Object.defineProperty(bm, "__esModule", {
    value: !0
  });
  bm.default = void 0;
  var Rme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-posinset": null,
      "aria-setsize": null,
      "aria-selected": "false"
    },
    relatedConcepts: [{
      concept: {
        name: "item"
      },
      module: "XForms"
    }, {
      concept: {
        name: "listitem"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "option"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-selected": "false"
    },
    superClass: [["roletype", "widget", "input"]]
  }, wme = Rme;
  bm.default = wme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/paragraphRole.js
var l$ = v((gm) => {
  "use strict";
  Object.defineProperty(gm, "__esModule", {
    value: !0
  });
  gm.default = void 0;
  var Sme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "p"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, xme = Sme;
  gm.default = xme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/presentationRole.js
var u$ = v((vm) => {
  "use strict";
  Object.defineProperty(vm, "__esModule", {
    value: !0
  });
  vm.default = void 0;
  var Cme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "alt",
          value: ""
        }],
        name: "img"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, Pme = Cme;
  vm.default = Pme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/progressbarRole.js
var c$ = v((Em) => {
  "use strict";
  Object.defineProperty(Em, "__esModule", {
    value: !0
  });
  Em.default = void 0;
  var Ame = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuetext": null
    },
    relatedConcepts: [{
      concept: {
        name: "progress"
      },
      module: "HTML"
    }, {
      concept: {
        name: "status"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
  }, Ome = Ame;
  Em.default = Ome;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/radioRole.js
var d$ = v((Tm) => {
  "use strict";
  Object.defineProperty(Tm, "__esModule", {
    value: !0
  });
  Tm.default = void 0;
  var qme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "radio"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input"]]
  }, Ime = qme;
  Tm.default = Ime;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/radiogroupRole.js
var p$ = v((_m) => {
  "use strict";
  Object.defineProperty(_m, "__esModule", {
    value: !0
  });
  _m.default = void 0;
  var Mme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        name: "list"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["radio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, Nme = Mme;
  _m.default = Nme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/regionRole.js
var f$ = v((Rm) => {
  "use strict";
  Object.defineProperty(Rm, "__esModule", {
    value: !0
  });
  Rm.default = void 0;
  var jme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        name: "Device Independence Glossart perceivable unit"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Lme = jme;
  Rm.default = Lme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/rowRole.js
var m$ = v((wm) => {
  "use strict";
  Object.defineProperty(wm, "__esModule", {
    value: !0
  });
  wm.default = void 0;
  var Fme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-colindex": null,
      "aria-expanded": null,
      "aria-level": null,
      "aria-posinset": null,
      "aria-rowindex": null,
      "aria-selected": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "tr"
      },
      module: "HTML"
    }],
    requireContextRole: ["grid", "rowgroup", "table", "treegrid"],
    requiredContextRole: ["grid", "rowgroup", "table", "treegrid"],
    requiredOwnedElements: [["cell"], ["columnheader"], ["gridcell"], ["rowheader"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"], ["roletype", "widget"]]
  }, kme = Fme;
  wm.default = kme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/rowgroupRole.js
var h$ = v((Sm) => {
  "use strict";
  Object.defineProperty(Sm, "__esModule", {
    value: !0
  });
  Sm.default = void 0;
  var Dme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "tbody"
      },
      module: "HTML"
    }, {
      concept: {
        name: "tfoot"
      },
      module: "HTML"
    }, {
      concept: {
        name: "thead"
      },
      module: "HTML"
    }],
    requireContextRole: ["grid", "table", "treegrid"],
    requiredContextRole: ["grid", "table", "treegrid"],
    requiredOwnedElements: [["row"]],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, $me = Dme;
  Sm.default = $me;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/rowheaderRole.js
var y$ = v((xm) => {
  "use strict";
  Object.defineProperty(xm, "__esModule", {
    value: !0
  });
  xm.default = void 0;
  var Bme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-sort": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "scope",
          value: "row"
        }],
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "rowgroup"
        }],
        name: "th"
      },
      module: "HTML"
    }],
    requireContextRole: ["row", "rowgroup"],
    requiredContextRole: ["row", "rowgroup"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widge\
t", "gridcell"], ["roletype", "structure", "sectionhead"]]
  }, Ume = Bme;
  xm.default = Ume;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/scrollbarRole.js
var b$ = v((Cm) => {
  "use strict";
  Object.defineProperty(Cm, "__esModule", {
    value: !0
  });
  Cm.default = void 0;
  var Hme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-valuetext": null,
      "aria-orientation": "vertical",
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-controls": null,
      "aria-valuenow": null
    },
    superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
  }, Vme = Hme;
  Cm.default = Vme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/searchRole.js
var g$ = v((Pm) => {
  "use strict";
  Object.defineProperty(Pm, "__esModule", {
    value: !0
  });
  Pm.default = void 0;
  var zme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Gme = zme;
  Pm.default = Gme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/searchboxRole.js
var v$ = v((Am) => {
  "use strict";
  Object.defineProperty(Am, "__esModule", {
    value: !0
  });
  Am.default = void 0;
  var Yme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "search"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "input", "textbox"]]
  }, Wme = Yme;
  Am.default = Wme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/separatorRole.js
var E$ = v((Om) => {
  "use strict";
  Object.defineProperty(Om, "__esModule", {
    value: !0
  });
  Om.default = void 0;
  var Kme = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-orientation": "horizontal",
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": null,
      "aria-valuetext": null
    },
    relatedConcepts: [{
      concept: {
        name: "hr"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, Xme = Kme;
  Om.default = Xme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/sliderRole.js
var T$ = v((qm) => {
  "use strict";
  Object.defineProperty(qm, "__esModule", {
    value: !0
  });
  qm.default = void 0;
  var Jme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-valuetext": null,
      "aria-orientation": "horizontal",
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "range"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-valuenow": null
    },
    superClass: [["roletype", "widget", "input"], ["roletype", "structure", "range"]]
  }, Zme = Jme;
  qm.default = Zme;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/spinbuttonRole.js
var _$ = v((Im) => {
  "use strict";
  Object.defineProperty(Im, "__esModule", {
    value: !0
  });
  Im.default = void 0;
  var Qme = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-valuetext": null,
      "aria-valuenow": "0"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "number"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "widget", "input"], ["roletype", "structure", "range"]]
  }, ehe = Qme;
  Im.default = ehe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/statusRole.js
var R$ = v((Mm) => {
  "use strict";
  Object.defineProperty(Mm, "__esModule", {
    value: !0
  });
  Mm.default = void 0;
  var the = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-atomic": "true",
      "aria-live": "polite"
    },
    relatedConcepts: [{
      concept: {
        name: "output"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, rhe = the;
  Mm.default = rhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/strongRole.js
var w$ = v((Nm) => {
  "use strict";
  Object.defineProperty(Nm, "__esModule", {
    value: !0
  });
  Nm.default = void 0;
  var nhe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "strong"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, ohe = nhe;
  Nm.default = ohe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/subscriptRole.js
var S$ = v((jm) => {
  "use strict";
  Object.defineProperty(jm, "__esModule", {
    value: !0
  });
  jm.default = void 0;
  var ihe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "sub"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, she = ihe;
  jm.default = she;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/superscriptRole.js
var x$ = v((Lm) => {
  "use strict";
  Object.defineProperty(Lm, "__esModule", {
    value: !0
  });
  Lm.default = void 0;
  var ahe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "sup"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, lhe = ahe;
  Lm.default = lhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/switchRole.js
var C$ = v((Fm) => {
  "use strict";
  Object.defineProperty(Fm, "__esModule", {
    value: !0
  });
  Fm.default = void 0;
  var uhe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "button"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox"]]
  }, che = uhe;
  Fm.default = che;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/tabRole.js
var P$ = v((km) => {
  "use strict";
  Object.defineProperty(km, "__esModule", {
    value: !0
  });
  km.default = void 0;
  var dhe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-posinset": null,
      "aria-setsize": null,
      "aria-selected": "false"
    },
    relatedConcepts: [],
    requireContextRole: ["tablist"],
    requiredContextRole: ["tablist"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "sectionhead"], ["roletype", "widget"]]
  }, phe = dhe;
  km.default = phe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/tableRole.js
var A$ = v((Dm) => {
  "use strict";
  Object.defineProperty(Dm, "__esModule", {
    value: !0
  });
  Dm.default = void 0;
  var fhe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-colcount": null,
      "aria-rowcount": null
    },
    relatedConcepts: [{
      concept: {
        name: "table"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, mhe = fhe;
  Dm.default = mhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/tablistRole.js
var O$ = v(($m) => {
  "use strict";
  Object.defineProperty($m, "__esModule", {
    value: !0
  });
  $m.default = void 0;
  var hhe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-level": null,
      "aria-multiselectable": null,
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      module: "DAISY",
      concept: {
        name: "guide"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["tab"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"]]
  }, yhe = hhe;
  $m.default = yhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/tabpanelRole.js
var q$ = v((Bm) => {
  "use strict";
  Object.defineProperty(Bm, "__esModule", {
    value: !0
  });
  Bm.default = void 0;
  var bhe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, ghe = bhe;
  Bm.default = ghe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/termRole.js
var I$ = v((Um) => {
  "use strict";
  Object.defineProperty(Um, "__esModule", {
    value: !0
  });
  Um.default = void 0;
  var vhe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dfn"
      },
      module: "HTML"
    }, {
      concept: {
        name: "dt"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Ehe = vhe;
  Um.default = Ehe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/textboxRole.js
var M$ = v((Hm) => {
  "use strict";
  Object.defineProperty(Hm, "__esModule", {
    value: !0
  });
  Hm.default = void 0;
  var The = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-autocomplete": null,
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-multiline": null,
      "aria-placeholder": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "type"
        }, {
          constraints: ["undefined"],
          name: "list"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "email"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "tel"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "text"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "input"
      },
      module: "XForms"
    }, {
      concept: {
        name: "textarea"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "input"]]
  }, _he = The;
  Hm.default = _he;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/timeRole.js
var N$ = v((Vm) => {
  "use strict";
  Object.defineProperty(Vm, "__esModule", {
    value: !0
  });
  Vm.default = void 0;
  var Rhe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "time"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, whe = Rhe;
  Vm.default = whe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/timerRole.js
var j$ = v((zm) => {
  "use strict";
  Object.defineProperty(zm, "__esModule", {
    value: !0
  });
  zm.default = void 0;
  var She = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "status"]]
  }, xhe = She;
  zm.default = xhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/toolbarRole.js
var L$ = v((Gm) => {
  "use strict";
  Object.defineProperty(Gm, "__esModule", {
    value: !0
  });
  Gm.default = void 0;
  var Che = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      concept: {
        name: "menubar"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"]]
  }, Phe = Che;
  Gm.default = Phe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/tooltipRole.js
var F$ = v((Ym) => {
  "use strict";
  Object.defineProperty(Ym, "__esModule", {
    value: !0
  });
  Ym.default = void 0;
  var Ahe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Ohe = Ahe;
  Ym.default = Ohe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/treeRole.js
var k$ = v((Wm) => {
  "use strict";
  Object.defineProperty(Wm, "__esModule", {
    value: !0
  });
  Wm.default = void 0;
  var qhe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-multiselectable": null,
      "aria-required": null,
      "aria-orientation": "vertical"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["treeitem", "group"], ["treeitem"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, Ihe = qhe;
  Wm.default = Ihe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/treegridRole.js
var D$ = v((Km) => {
  "use strict";
  Object.defineProperty(Km, "__esModule", {
    value: !0
  });
  Km.default = void 0;
  var Mhe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "grid"], ["roletype", "structure", "section", "table", "grid"], ["roletype", "widget", "\
composite", "select", "tree"], ["roletype", "structure", "section", "group", "select", "tree"]]
  }, Nhe = Mhe;
  Km.default = Nhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/literal/treeitemRole.js
var $$ = v((Xm) => {
  "use strict";
  Object.defineProperty(Xm, "__esModule", {
    value: !0
  });
  Xm.default = void 0;
  var jhe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-expanded": null,
      "aria-haspopup": null
    },
    relatedConcepts: [],
    requireContextRole: ["group", "tree"],
    requiredContextRole: ["group", "tree"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-selected": null
    },
    superClass: [["roletype", "structure", "section", "listitem"], ["roletype", "widget", "input", "option"]]
  }, Lhe = jhe;
  Xm.default = Lhe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/ariaLiteralRoles.js
var B$ = v((Jm) => {
  "use strict";
  Object.defineProperty(Jm, "__esModule", {
    value: !0
  });
  Jm.default = void 0;
  var Fhe = H(pD()), khe = H(fD()), Dhe = H(mD()), $he = H(hD()), Bhe = H(yD()), Uhe = H(bD()), Hhe = H(gD()), Vhe = H(vD()), zhe = H(ED()),
  Ghe = H(TD()), Yhe = H(_D()), Whe = H(RD()), Khe = H(wD()), Xhe = H(SD()), Jhe = H(xD()), Zhe = H(CD()), Qhe = H(PD()), eye = H(AD()), tye = H(
  OD()), rye = H(qD()), nye = H(ID()), oye = H(MD()), iye = H(ND()), sye = H(jD()), aye = H(LD()), lye = H(FD()), uye = H(kD()), cye = H(DD()),
  dye = H($D()), pye = H(BD()), fye = H(UD()), mye = H(HD()), hye = H(VD()), yye = H(zD()), bye = H(GD()), gye = H(YD()), vye = H(WD()), Eye = H(
  KD()), Tye = H(XD()), _ye = H(JD()), Rye = H(ZD()), wye = H(QD()), Sye = H(e$()), xye = H(t$()), Cye = H(r$()), Pye = H(n$()), Aye = H(o$()),
  Oye = H(i$()), qye = H(s$()), Iye = H(a$()), Mye = H(l$()), Nye = H(u$()), jye = H(c$()), Lye = H(d$()), Fye = H(p$()), kye = H(f$()), Dye = H(
  m$()), $ye = H(h$()), Bye = H(y$()), Uye = H(b$()), Hye = H(g$()), Vye = H(v$()), zye = H(E$()), Gye = H(T$()), Yye = H(_$()), Wye = H(R$()),
  Kye = H(w$()), Xye = H(S$()), Jye = H(x$()), Zye = H(C$()), Qye = H(P$()), ebe = H(A$()), tbe = H(O$()), rbe = H(q$()), nbe = H(I$()), obe = H(
  M$()), ibe = H(N$()), sbe = H(j$()), abe = H(L$()), lbe = H(F$()), ube = H(k$()), cbe = H(D$()), dbe = H($$());
  function H(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(H, "_interopRequireDefault");
  var pbe = [["alert", Fhe.default], ["alertdialog", khe.default], ["application", Dhe.default], ["article", $he.default], ["banner", Bhe.default],
  ["blockquote", Uhe.default], ["button", Hhe.default], ["caption", Vhe.default], ["cell", zhe.default], ["checkbox", Ghe.default], ["code",
  Yhe.default], ["columnheader", Whe.default], ["combobox", Khe.default], ["complementary", Xhe.default], ["contentinfo", Jhe.default], ["de\
finition", Zhe.default], ["deletion", Qhe.default], ["dialog", eye.default], ["directory", tye.default], ["document", rye.default], ["emphas\
is", nye.default], ["feed", oye.default], ["figure", iye.default], ["form", sye.default], ["generic", aye.default], ["grid", lye.default], [
  "gridcell", uye.default], ["group", cye.default], ["heading", dye.default], ["img", pye.default], ["insertion", fye.default], ["link", mye.
  default], ["list", hye.default], ["listbox", yye.default], ["listitem", bye.default], ["log", gye.default], ["main", vye.default], ["mark",
  Eye.default], ["marquee", Tye.default], ["math", _ye.default], ["menu", Rye.default], ["menubar", wye.default], ["menuitem", Sye.default],
  ["menuitemcheckbox", xye.default], ["menuitemradio", Cye.default], ["meter", Pye.default], ["navigation", Aye.default], ["none", Oye.default],
  ["note", qye.default], ["option", Iye.default], ["paragraph", Mye.default], ["presentation", Nye.default], ["progressbar", jye.default], [
  "radio", Lye.default], ["radiogroup", Fye.default], ["region", kye.default], ["row", Dye.default], ["rowgroup", $ye.default], ["rowheader",
  Bye.default], ["scrollbar", Uye.default], ["search", Hye.default], ["searchbox", Vye.default], ["separator", zye.default], ["slider", Gye.
  default], ["spinbutton", Yye.default], ["status", Wye.default], ["strong", Kye.default], ["subscript", Xye.default], ["superscript", Jye.default],
  ["switch", Zye.default], ["tab", Qye.default], ["table", ebe.default], ["tablist", tbe.default], ["tabpanel", rbe.default], ["term", nbe.default],
  ["textbox", obe.default], ["time", ibe.default], ["timer", sbe.default], ["toolbar", abe.default], ["tooltip", lbe.default], ["tree", ube.
  default], ["treegrid", cbe.default], ["treeitem", dbe.default]], fbe = pbe;
  Jm.default = fbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docAbstractRole.js
var U$ = v((Zm) => {
  "use strict";
  Object.defineProperty(Zm, "__esModule", {
    value: !0
  });
  Zm.default = void 0;
  var mbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "abstract [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, hbe = mbe;
  Zm.default = hbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docAcknowledgmentsRole.js
var H$ = v((Qm) => {
  "use strict";
  Object.defineProperty(Qm, "__esModule", {
    value: !0
  });
  Qm.default = void 0;
  var ybe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "acknowledgments [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, bbe = ybe;
  Qm.default = bbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docAfterwordRole.js
var V$ = v((eh) => {
  "use strict";
  Object.defineProperty(eh, "__esModule", {
    value: !0
  });
  eh.default = void 0;
  var gbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "afterword [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, vbe = gbe;
  eh.default = vbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docAppendixRole.js
var z$ = v((th) => {
  "use strict";
  Object.defineProperty(th, "__esModule", {
    value: !0
  });
  th.default = void 0;
  var Ebe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "appendix [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Tbe = Ebe;
  th.default = Tbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docBacklinkRole.js
var G$ = v((rh) => {
  "use strict";
  Object.defineProperty(rh, "__esModule", {
    value: !0
  });
  rh.default = void 0;
  var _be = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "referrer [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, Rbe = _be;
  rh.default = Rbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docBiblioentryRole.js
var Y$ = v((nh) => {
  "use strict";
  Object.defineProperty(nh, "__esModule", {
    value: !0
  });
  nh.default = void 0;
  var wbe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "EPUB biblioentry [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: ["doc-bibliography"],
    requiredContextRole: ["doc-bibliography"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "listitem"]]
  }, Sbe = wbe;
  nh.default = Sbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docBibliographyRole.js
var W$ = v((oh) => {
  "use strict";
  Object.defineProperty(oh, "__esModule", {
    value: !0
  });
  oh.default = void 0;
  var xbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "bibliography [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["doc-biblioentry"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Cbe = xbe;
  oh.default = Cbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docBibliorefRole.js
var K$ = v((ih) => {
  "use strict";
  Object.defineProperty(ih, "__esModule", {
    value: !0
  });
  ih.default = void 0;
  var Pbe = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "biblioref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, Abe = Pbe;
  ih.default = Abe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docChapterRole.js
var X$ = v((sh) => {
  "use strict";
  Object.defineProperty(sh, "__esModule", {
    value: !0
  });
  sh.default = void 0;
  var Obe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "chapter [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, qbe = Obe;
  sh.default = qbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docColophonRole.js
var J$ = v((ah) => {
  "use strict";
  Object.defineProperty(ah, "__esModule", {
    value: !0
  });
  ah.default = void 0;
  var Ibe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "colophon [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Mbe = Ibe;
  ah.default = Mbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docConclusionRole.js
var Z$ = v((lh) => {
  "use strict";
  Object.defineProperty(lh, "__esModule", {
    value: !0
  });
  lh.default = void 0;
  var Nbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "conclusion [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, jbe = Nbe;
  lh.default = jbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docCoverRole.js
var Q$ = v((uh) => {
  "use strict";
  Object.defineProperty(uh, "__esModule", {
    value: !0
  });
  uh.default = void 0;
  var Lbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "cover [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "img"]]
  }, Fbe = Lbe;
  uh.default = Fbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docCreditRole.js
var eB = v((ch) => {
  "use strict";
  Object.defineProperty(ch, "__esModule", {
    value: !0
  });
  ch.default = void 0;
  var kbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "credit [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Dbe = kbe;
  ch.default = Dbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docCreditsRole.js
var tB = v((dh) => {
  "use strict";
  Object.defineProperty(dh, "__esModule", {
    value: !0
  });
  dh.default = void 0;
  var $be = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "credits [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Bbe = $be;
  dh.default = Bbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docDedicationRole.js
var rB = v((ph) => {
  "use strict";
  Object.defineProperty(ph, "__esModule", {
    value: !0
  });
  ph.default = void 0;
  var Ube = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "dedication [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Hbe = Ube;
  ph.default = Hbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docEndnoteRole.js
var nB = v((fh) => {
  "use strict";
  Object.defineProperty(fh, "__esModule", {
    value: !0
  });
  fh.default = void 0;
  var Vbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "rearnote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: ["doc-endnotes"],
    requiredContextRole: ["doc-endnotes"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "listitem"]]
  }, zbe = Vbe;
  fh.default = zbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docEndnotesRole.js
var oB = v((mh) => {
  "use strict";
  Object.defineProperty(mh, "__esModule", {
    value: !0
  });
  mh.default = void 0;
  var Gbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "rearnotes [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["doc-endnote"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Ybe = Gbe;
  mh.default = Ybe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docEpigraphRole.js
var iB = v((hh) => {
  "use strict";
  Object.defineProperty(hh, "__esModule", {
    value: !0
  });
  hh.default = void 0;
  var Wbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "epigraph [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, Kbe = Wbe;
  hh.default = Kbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docEpilogueRole.js
var sB = v((yh) => {
  "use strict";
  Object.defineProperty(yh, "__esModule", {
    value: !0
  });
  yh.default = void 0;
  var Xbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "epilogue [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Jbe = Xbe;
  yh.default = Jbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docErrataRole.js
var aB = v((bh) => {
  "use strict";
  Object.defineProperty(bh, "__esModule", {
    value: !0
  });
  bh.default = void 0;
  var Zbe = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "errata [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Qbe = Zbe;
  bh.default = Qbe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docExampleRole.js
var lB = v((gh) => {
  "use strict";
  Object.defineProperty(gh, "__esModule", {
    value: !0
  });
  gh.default = void 0;
  var ege = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, tge = ege;
  gh.default = tge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docFootnoteRole.js
var uB = v((vh) => {
  "use strict";
  Object.defineProperty(vh, "__esModule", {
    value: !0
  });
  vh.default = void 0;
  var rge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "footnote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, nge = rge;
  vh.default = nge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docForewordRole.js
var cB = v((Eh) => {
  "use strict";
  Object.defineProperty(Eh, "__esModule", {
    value: !0
  });
  Eh.default = void 0;
  var oge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "foreword [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, ige = oge;
  Eh.default = ige;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docGlossaryRole.js
var dB = v((Th) => {
  "use strict";
  Object.defineProperty(Th, "__esModule", {
    value: !0
  });
  Th.default = void 0;
  var sge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "glossary [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["definition"], ["term"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, age = sge;
  Th.default = age;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docGlossrefRole.js
var pB = v((_h) => {
  "use strict";
  Object.defineProperty(_h, "__esModule", {
    value: !0
  });
  _h.default = void 0;
  var lge = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "glossref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, uge = lge;
  _h.default = uge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docIndexRole.js
var fB = v((Rh) => {
  "use strict";
  Object.defineProperty(Rh, "__esModule", {
    value: !0
  });
  Rh.default = void 0;
  var cge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "index [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, dge = cge;
  Rh.default = dge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docIntroductionRole.js
var mB = v((wh) => {
  "use strict";
  Object.defineProperty(wh, "__esModule", {
    value: !0
  });
  wh.default = void 0;
  var pge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "introduction [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, fge = pge;
  wh.default = fge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docNoterefRole.js
var hB = v((Sh) => {
  "use strict";
  Object.defineProperty(Sh, "__esModule", {
    value: !0
  });
  Sh.default = void 0;
  var mge = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "noteref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, hge = mge;
  Sh.default = hge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docNoticeRole.js
var yB = v((xh) => {
  "use strict";
  Object.defineProperty(xh, "__esModule", {
    value: !0
  });
  xh.default = void 0;
  var yge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "notice [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "note"]]
  }, bge = yge;
  xh.default = bge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docPagebreakRole.js
var bB = v((Ch) => {
  "use strict";
  Object.defineProperty(Ch, "__esModule", {
    value: !0
  });
  Ch.default = void 0;
  var gge = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "pagebreak [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "separator"]]
  }, vge = gge;
  Ch.default = vge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docPagelistRole.js
var gB = v((Ph) => {
  "use strict";
  Object.defineProperty(Ph, "__esModule", {
    value: !0
  });
  Ph.default = void 0;
  var Ege = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "page-list [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, Tge = Ege;
  Ph.default = Tge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docPartRole.js
var vB = v((Ah) => {
  "use strict";
  Object.defineProperty(Ah, "__esModule", {
    value: !0
  });
  Ah.default = void 0;
  var _ge = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "part [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Rge = _ge;
  Ah.default = Rge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docPrefaceRole.js
var EB = v((Oh) => {
  "use strict";
  Object.defineProperty(Oh, "__esModule", {
    value: !0
  });
  Oh.default = void 0;
  var wge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "preface [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Sge = wge;
  Oh.default = Sge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docPrologueRole.js
var TB = v((qh) => {
  "use strict";
  Object.defineProperty(qh, "__esModule", {
    value: !0
  });
  qh.default = void 0;
  var xge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "prologue [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, Cge = xge;
  qh.default = Cge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docPullquoteRole.js
var _B = v((Ih) => {
  "use strict";
  Object.defineProperty(Ih, "__esModule", {
    value: !0
  });
  Ih.default = void 0;
  var Pge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "pullquote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["none"]]
  }, Age = Pge;
  Ih.default = Age;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docQnaRole.js
var RB = v((Mh) => {
  "use strict";
  Object.defineProperty(Mh, "__esModule", {
    value: !0
  });
  Mh.default = void 0;
  var Oge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "qna [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, qge = Oge;
  Mh.default = qge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docSubtitleRole.js
var wB = v((Nh) => {
  "use strict";
  Object.defineProperty(Nh, "__esModule", {
    value: !0
  });
  Nh.default = void 0;
  var Ige = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "subtitle [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "sectionhead"]]
  }, Mge = Ige;
  Nh.default = Mge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docTipRole.js
var SB = v((jh) => {
  "use strict";
  Object.defineProperty(jh, "__esModule", {
    value: !0
  });
  jh.default = void 0;
  var Nge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "help [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "note"]]
  }, jge = Nge;
  jh.default = jge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/dpub/docTocRole.js
var xB = v((Lh) => {
  "use strict";
  Object.defineProperty(Lh, "__esModule", {
    value: !0
  });
  Lh.default = void 0;
  var Lge = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "toc [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, Fge = Lge;
  Lh.default = Fge;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/ariaDpubRoles.js
var CB = v((Fh) => {
  "use strict";
  Object.defineProperty(Fh, "__esModule", {
    value: !0
  });
  Fh.default = void 0;
  var kge = ie(U$()), Dge = ie(H$()), $ge = ie(V$()), Bge = ie(z$()), Uge = ie(G$()), Hge = ie(Y$()), Vge = ie(W$()), zge = ie(K$()), Gge = ie(
  X$()), Yge = ie(J$()), Wge = ie(Z$()), Kge = ie(Q$()), Xge = ie(eB()), Jge = ie(tB()), Zge = ie(rB()), Qge = ie(nB()), eve = ie(oB()), tve = ie(
  iB()), rve = ie(sB()), nve = ie(aB()), ove = ie(lB()), ive = ie(uB()), sve = ie(cB()), ave = ie(dB()), lve = ie(pB()), uve = ie(fB()), cve = ie(
  mB()), dve = ie(hB()), pve = ie(yB()), fve = ie(bB()), mve = ie(gB()), hve = ie(vB()), yve = ie(EB()), bve = ie(TB()), gve = ie(_B()), vve = ie(
  RB()), Eve = ie(wB()), Tve = ie(SB()), _ve = ie(xB());
  function ie(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(ie, "_interopRequireDefault");
  var Rve = [["doc-abstract", kge.default], ["doc-acknowledgments", Dge.default], ["doc-afterword", $ge.default], ["doc-appendix", Bge.default],
  ["doc-backlink", Uge.default], ["doc-biblioentry", Hge.default], ["doc-bibliography", Vge.default], ["doc-biblioref", zge.default], ["doc-\
chapter", Gge.default], ["doc-colophon", Yge.default], ["doc-conclusion", Wge.default], ["doc-cover", Kge.default], ["doc-credit", Xge.default],
  ["doc-credits", Jge.default], ["doc-dedication", Zge.default], ["doc-endnote", Qge.default], ["doc-endnotes", eve.default], ["doc-epigraph",
  tve.default], ["doc-epilogue", rve.default], ["doc-errata", nve.default], ["doc-example", ove.default], ["doc-footnote", ive.default], ["d\
oc-foreword", sve.default], ["doc-glossary", ave.default], ["doc-glossref", lve.default], ["doc-index", uve.default], ["doc-introduction", cve.
  default], ["doc-noteref", dve.default], ["doc-notice", pve.default], ["doc-pagebreak", fve.default], ["doc-pagelist", mve.default], ["doc-\
part", hve.default], ["doc-preface", yve.default], ["doc-prologue", bve.default], ["doc-pullquote", gve.default], ["doc-qna", vve.default], [
  "doc-subtitle", Eve.default], ["doc-tip", Tve.default], ["doc-toc", _ve.default]], wve = Rve;
  Fh.default = wve;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/graphics/graphicsDocumentRole.js
var PB = v((kh) => {
  "use strict";
  Object.defineProperty(kh, "__esModule", {
    value: !0
  });
  kh.default = void 0;
  var Sve = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      module: "GRAPHICS",
      concept: {
        name: "graphics-object"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "img"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "article"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "document"]]
  }, xve = Sve;
  kh.default = xve;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/graphics/graphicsObjectRole.js
var AB = v((Dh) => {
  "use strict";
  Object.defineProperty(Dh, "__esModule", {
    value: !0
  });
  Dh.default = void 0;
  var Cve = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      module: "GRAPHICS",
      concept: {
        name: "graphics-document"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "group"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "img"
      }
    }, {
      module: "GRAPHICS",
      concept: {
        name: "graphics-symbol"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"]]
  }, Pve = Cve;
  Dh.default = Pve;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/graphics/graphicsSymbolRole.js
var OB = v(($h) => {
  "use strict";
  Object.defineProperty($h, "__esModule", {
    value: !0
  });
  $h.default = void 0;
  var Ave = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "img"]]
  }, Ove = Ave;
  $h.default = Ove;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/etc/roles/ariaGraphicsRoles.js
var qB = v((Bh) => {
  "use strict";
  Object.defineProperty(Bh, "__esModule", {
    value: !0
  });
  Bh.default = void 0;
  var qve = AR(PB()), Ive = AR(AB()), Mve = AR(OB());
  function AR(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(AR, "_interopRequireDefault");
  var Nve = [["graphics-document", qve.default], ["graphics-object", Ive.default], ["graphics-symbol", Mve.default]], jve = Nve;
  Bh.default = jve;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/rolesMap.js
var Hh = v((Uh) => {
  "use strict";
  Object.defineProperty(Uh, "__esModule", {
    value: !0
  });
  Uh.default = void 0;
  var Lve = ya(dD()), Fve = ya(B$()), kve = ya(CB()), Dve = ya(qB()), $ve = ya(hi());
  function ya(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(ya, "_interopRequireDefault");
  function Bve(e, t, r) {
    return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  o(Bve, "_defineProperty");
  function OR(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = MB(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = !0, a = !1, l;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return s = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      a = !0, l = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }, "f") };
  }
  o(OR, "_createForOfIteratorHelper");
  function ha(e, t) {
    return Vve(e) || Hve(e, t) || MB(e, t) || Uve();
  }
  o(ha, "_slicedToArray");
  function Uve() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(Uve, "_nonIterableRest");
  function MB(e, t) {
    if (e) {
      if (typeof e == "string") return IB(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return IB(e, t);
    }
  }
  o(MB, "_unsupportedIterableToArray");
  function IB(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  o(IB, "_arrayLikeToArray");
  function Hve(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n = [], i = !0, s = !1, a, l;
      try {
        for (r = r.call(e); !(i = (a = r.next()).done) && (n.push(a.value), !(t && n.length === t)); i = !0)
          ;
      } catch (u) {
        s = !0, l = u;
      } finally {
        try {
          !i && r.return != null && r.return();
        } finally {
          if (s) throw l;
        }
      }
      return n;
    }
  }
  o(Hve, "_iterableToArrayLimit");
  function Vve(e) {
    if (Array.isArray(e)) return e;
  }
  o(Vve, "_arrayWithHoles");
  var ln = [].concat(Lve.default, Fve.default, kve.default, Dve.default);
  ln.forEach(function(e) {
    var t = ha(e, 2), r = t[1], n = OR(r.superClass), i;
    try {
      for (n.s(); !(i = n.n()).done; ) {
        var s = i.value, a = OR(s), l;
        try {
          var u = /* @__PURE__ */ o(function() {
            var d = l.value, p = ln.find(function(b) {
              var g = ha(b, 1), T = g[0];
              return T === d;
            });
            if (p)
              for (var y = p[1], f = 0, m = Object.keys(y.props); f < m.length; f++) {
                var h = m[f];
                Object.prototype.hasOwnProperty.call(r.props, h) || Object.assign(r.props, Bve({}, h, y.props[h]));
              }
          }, "_loop");
          for (a.s(); !(l = a.n()).done; )
            u();
        } catch (c) {
          a.e(c);
        } finally {
          a.f();
        }
      }
    } catch (c) {
      n.e(c);
    } finally {
      n.f();
    }
  });
  var qR = {
    entries: /* @__PURE__ */ o(function() {
      return ln;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = OR(ln), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var s = ha(i.value, 2), a = s[0], l = s[1];
          t.call(r, l, a, ln);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = ln.find(function(n) {
        return n[0] === t;
      });
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!qR.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return ln.map(function(t) {
        var r = ha(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return ln.map(function(t) {
        var r = ha(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, zve = (0, $ve.default)(qR, qR.entries());
  Uh.default = zve;
});

// ../node_modules/dequal/lite/index.mjs
var jB = {};
ft(jB, {
  dequal: () => IR
});
function IR(e, t) {
  var r, n;
  if (e === t) return !0;
  if (e && t && (r = e.constructor) === t.constructor) {
    if (r === Date) return e.getTime() === t.getTime();
    if (r === RegExp) return e.toString() === t.toString();
    if (r === Array) {
      if ((n = e.length) === t.length)
        for (; n-- && IR(e[n], t[n]); ) ;
      return n === -1;
    }
    if (!r || typeof e == "object") {
      n = 0;
      for (r in e)
        if (NB.call(e, r) && ++n && !NB.call(t, r) || !(r in t) || !IR(e[r], t[r])) return !1;
      return Object.keys(t).length === n;
    }
  }
  return e !== e && t !== t;
}
var NB, LB = lz(() => {
  NB = Object.prototype.hasOwnProperty;
  o(IR, "dequal");
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/elementRoleMap.js
var HB = v((Wh) => {
  "use strict";
  Object.defineProperty(Wh, "__esModule", {
    value: !0
  });
  Wh.default = void 0;
  var DB = (LB(), uz(jB)), Gve = BB(hi()), $B = BB(Hh());
  function BB(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(BB, "_interopRequireDefault");
  function MR(e, t) {
    return Kve(e) || Wve(e, t) || UB(e, t) || Yve();
  }
  o(MR, "_slicedToArray");
  function Yve() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(Yve, "_nonIterableRest");
  function Wve(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n = [], i = !0, s = !1, a, l;
      try {
        for (r = r.call(e); !(i = (a = r.next()).done) && (n.push(a.value), !(t && n.length === t)); i = !0)
          ;
      } catch (u) {
        s = !0, l = u;
      } finally {
        try {
          !i && r.return != null && r.return();
        } finally {
          if (s) throw l;
        }
      }
      return n;
    }
  }
  o(Wve, "_iterableToArrayLimit");
  function Kve(e) {
    if (Array.isArray(e)) return e;
  }
  o(Kve, "_arrayWithHoles");
  function Xve(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = UB(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = !0, a = !1, l;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return s = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      a = !0, l = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }, "f") };
  }
  o(Xve, "_createForOfIteratorHelper");
  function UB(e, t) {
    if (e) {
      if (typeof e == "string") return FB(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return FB(e, t);
    }
  }
  o(UB, "_unsupportedIterableToArray");
  function FB(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  o(FB, "_arrayLikeToArray");
  var un = [], kB = $B.default.keys();
  for (Vh = 0; Vh < kB.length; Vh++)
    if (zh = kB[Vh], Gh = $B.default.get(zh), Gh)
      for (NR = [].concat(Gh.baseConcepts, Gh.relatedConcepts), Yh = 0; Yh < NR.length; Yh++)
        jR = NR[Yh], jR.module === "HTML" && function() {
          var e = jR.concept;
          if (e) {
            var t = un.find(function(s) {
              return (0, DB.dequal)(s, e);
            }), r;
            t ? r = t[1] : r = [];
            for (var n = !0, i = 0; i < r.length; i++)
              if (r[i] === zh) {
                n = !1;
                break;
              }
            n && r.push(zh), un.push([e, r]);
          }
        }();
  var zh, Gh, NR, jR, Yh, Vh, LR = {
    entries: /* @__PURE__ */ o(function() {
      return un;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = Xve(un), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var s = MR(i.value, 2), a = s[0], l = s[1];
          t.call(r, l, a, un);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = un.find(function(n) {
        return t.name === n[0].name && (0, DB.dequal)(t.attributes, n[0].attributes);
      });
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!LR.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return un.map(function(t) {
        var r = MR(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return un.map(function(t) {
        var r = MR(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, Jve = (0, Gve.default)(LR, LR.entries());
  Wh.default = Jve;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/roleElementMap.js
var KB = v((Qh) => {
  "use strict";
  Object.defineProperty(Qh, "__esModule", {
    value: !0
  });
  Qh.default = void 0;
  var Zve = YB(hi()), GB = YB(Hh());
  function YB(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(YB, "_interopRequireDefault");
  function FR(e, t) {
    return tEe(e) || eEe(e, t) || WB(e, t) || Qve();
  }
  o(FR, "_slicedToArray");
  function Qve() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  o(Qve, "_nonIterableRest");
  function eEe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n = [], i = !0, s = !1, a, l;
      try {
        for (r = r.call(e); !(i = (a = r.next()).done) && (n.push(a.value), !(t && n.length === t)); i = !0)
          ;
      } catch (u) {
        s = !0, l = u;
      } finally {
        try {
          !i && r.return != null && r.return();
        } finally {
          if (s) throw l;
        }
      }
      return n;
    }
  }
  o(eEe, "_iterableToArrayLimit");
  function tEe(e) {
    if (Array.isArray(e)) return e;
  }
  o(tEe, "_arrayWithHoles");
  function rEe(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = WB(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = !0, a = !1, l;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return s = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      a = !0, l = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }, "f") };
  }
  o(rEe, "_createForOfIteratorHelper");
  function WB(e, t) {
    if (e) {
      if (typeof e == "string") return VB(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return VB(e, t);
    }
  }
  o(WB, "_unsupportedIterableToArray");
  function VB(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  o(VB, "_arrayLikeToArray");
  var $n = [], zB = GB.default.keys();
  for (Kh = 0; Kh < zB.length; Kh++)
    if (kR = zB[Kh], Xh = GB.default.get(kR), Jh = [], Xh) {
      for (DR = [].concat(Xh.baseConcepts, Xh.relatedConcepts), Zh = 0; Zh < DR.length; Zh++)
        $R = DR[Zh], $R.module === "HTML" && (BR = $R.concept, BR != null && Jh.push(BR));
      Jh.length > 0 && $n.push([kR, Jh]);
    }
  var kR, Xh, Jh, DR, $R, BR, Zh, Kh, UR = {
    entries: /* @__PURE__ */ o(function() {
      return $n;
    }, "entries"),
    forEach: /* @__PURE__ */ o(function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = rEe($n), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var s = FR(i.value, 2), a = s[0], l = s[1];
          t.call(r, l, a, $n);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }, "forEach"),
    get: /* @__PURE__ */ o(function(t) {
      var r = $n.find(function(n) {
        return n[0] === t;
      });
      return r && r[1];
    }, "get"),
    has: /* @__PURE__ */ o(function(t) {
      return !!UR.get(t);
    }, "has"),
    keys: /* @__PURE__ */ o(function() {
      return $n.map(function(t) {
        var r = FR(t, 1), n = r[0];
        return n;
      });
    }, "keys"),
    values: /* @__PURE__ */ o(function() {
      return $n.map(function(t) {
        var r = FR(t, 2), n = r[1];
        return n;
      });
    }, "values")
  }, nEe = (0, Zve.default)(UR, UR.entries());
  Qh.default = nEe;
});

// ../node_modules/@testing-library/dom/node_modules/aria-query/lib/index.js
var XB = v(($t) => {
  "use strict";
  Object.defineProperty($t, "__esModule", {
    value: !0
  });
  $t.roles = $t.roleElements = $t.elementRoles = $t.dom = $t.aria = void 0;
  var oEe = ba(Kk()), iEe = ba(Zk()), sEe = ba(Hh()), aEe = ba(HB()), lEe = ba(KB());
  function ba(e) {
    return e && e.__esModule ? e : { default: e };
  }
  o(ba, "_interopRequireDefault");
  var uEe = oEe.default;
  $t.aria = uEe;
  var cEe = iEe.default;
  $t.dom = cEe;
  var dEe = sEe.default;
  $t.roles = dEe;
  var pEe = aEe.default;
  $t.elementRoles = pEe;
  var fEe = lEe.default;
  $t.roleElements = fEe;
});

// ../node_modules/lz-string/libs/lz-string.js
var JB = v((eHe, ey) => {
  var HR = function() {
    var e = String.fromCharCode, t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabc\
defghijklmnopqrstuvwxyz0123456789+-$", n = {};
    function i(a, l) {
      if (!n[a]) {
        n[a] = {};
        for (var u = 0; u < a.length; u++)
          n[a][a.charAt(u)] = u;
      }
      return n[a][l];
    }
    o(i, "getBaseValue");
    var s = {
      compressToBase64: /* @__PURE__ */ o(function(a) {
        if (a == null) return "";
        var l = s._compress(a, 6, function(u) {
          return t.charAt(u);
        });
        switch (l.length % 4) {
          // To produce valid Base64
          default:
          // When could this happen ?
          case 0:
            return l;
          case 1:
            return l + "===";
          case 2:
            return l + "==";
          case 3:
            return l + "=";
        }
      }, "compressToBase64"),
      decompressFromBase64: /* @__PURE__ */ o(function(a) {
        return a == null ? "" : a == "" ? null : s._decompress(a.length, 32, function(l) {
          return i(t, a.charAt(l));
        });
      }, "decompressFromBase64"),
      compressToUTF16: /* @__PURE__ */ o(function(a) {
        return a == null ? "" : s._compress(a, 15, function(l) {
          return e(l + 32);
        }) + " ";
      }, "compressToUTF16"),
      decompressFromUTF16: /* @__PURE__ */ o(function(a) {
        return a == null ? "" : a == "" ? null : s._decompress(a.length, 16384, function(l) {
          return a.charCodeAt(l) - 32;
        });
      }, "decompressFromUTF16"),
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: /* @__PURE__ */ o(function(a) {
        for (var l = s.compress(a), u = new Uint8Array(l.length * 2), c = 0, d = l.length; c < d; c++) {
          var p = l.charCodeAt(c);
          u[c * 2] = p >>> 8, u[c * 2 + 1] = p % 256;
        }
        return u;
      }, "compressToUint8Array"),
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: /* @__PURE__ */ o(function(a) {
        if (a == null)
          return s.decompress(a);
        for (var l = new Array(a.length / 2), u = 0, c = l.length; u < c; u++)
          l[u] = a[u * 2] * 256 + a[u * 2 + 1];
        var d = [];
        return l.forEach(function(p) {
          d.push(e(p));
        }), s.decompress(d.join(""));
      }, "decompressFromUint8Array"),
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: /* @__PURE__ */ o(function(a) {
        return a == null ? "" : s._compress(a, 6, function(l) {
          return r.charAt(l);
        });
      }, "compressToEncodedURIComponent"),
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: /* @__PURE__ */ o(function(a) {
        return a == null ? "" : a == "" ? null : (a = a.replace(/ /g, "+"), s._decompress(a.length, 32, function(l) {
          return i(r, a.charAt(l));
        }));
      }, "decompressFromEncodedURIComponent"),
      compress: /* @__PURE__ */ o(function(a) {
        return s._compress(a, 16, function(l) {
          return e(l);
        });
      }, "compress"),
      _compress: /* @__PURE__ */ o(function(a, l, u) {
        if (a == null) return "";
        var c, d, p = {}, y = {}, f = "", m = "", h = "", b = 2, g = 3, T = 2, _ = [], E = 0, R = 0, C;
        for (C = 0; C < a.length; C += 1)
          if (f = a.charAt(C), Object.prototype.hasOwnProperty.call(p, f) || (p[f] = g++, y[f] = !0), m = h + f, Object.prototype.hasOwnProperty.
          call(p, m))
            h = m;
          else {
            if (Object.prototype.hasOwnProperty.call(y, h)) {
              if (h.charCodeAt(0) < 256) {
                for (c = 0; c < T; c++)
                  E = E << 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++;
                for (d = h.charCodeAt(0), c = 0; c < 8; c++)
                  E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
              } else {
                for (d = 1, c = 0; c < T; c++)
                  E = E << 1 | d, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = 0;
                for (d = h.charCodeAt(0), c = 0; c < 16; c++)
                  E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
              }
              b--, b == 0 && (b = Math.pow(2, T), T++), delete y[h];
            } else
              for (d = p[h], c = 0; c < T; c++)
                E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
            b--, b == 0 && (b = Math.pow(2, T), T++), p[m] = g++, h = String(f);
          }
        if (h !== "") {
          if (Object.prototype.hasOwnProperty.call(y, h)) {
            if (h.charCodeAt(0) < 256) {
              for (c = 0; c < T; c++)
                E = E << 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++;
              for (d = h.charCodeAt(0), c = 0; c < 8; c++)
                E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
            } else {
              for (d = 1, c = 0; c < T; c++)
                E = E << 1 | d, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = 0;
              for (d = h.charCodeAt(0), c = 0; c < 16; c++)
                E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
            }
            b--, b == 0 && (b = Math.pow(2, T), T++), delete y[h];
          } else
            for (d = p[h], c = 0; c < T; c++)
              E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
          b--, b == 0 && (b = Math.pow(2, T), T++);
        }
        for (d = 2, c = 0; c < T; c++)
          E = E << 1 | d & 1, R == l - 1 ? (R = 0, _.push(u(E)), E = 0) : R++, d = d >> 1;
        for (; ; )
          if (E = E << 1, R == l - 1) {
            _.push(u(E));
            break;
          } else R++;
        return _.join("");
      }, "_compress"),
      decompress: /* @__PURE__ */ o(function(a) {
        return a == null ? "" : a == "" ? null : s._decompress(a.length, 32768, function(l) {
          return a.charCodeAt(l);
        });
      }, "decompress"),
      _decompress: /* @__PURE__ */ o(function(a, l, u) {
        var c = [], d, p = 4, y = 4, f = 3, m = "", h = [], b, g, T, _, E, R, C, w = { val: u(0), position: l, index: 1 };
        for (b = 0; b < 3; b += 1)
          c[b] = b;
        for (T = 0, E = Math.pow(2, 2), R = 1; R != E; )
          _ = w.val & w.position, w.position >>= 1, w.position == 0 && (w.position = l, w.val = u(w.index++)), T |= (_ > 0 ? 1 : 0) * R, R <<=
          1;
        switch (d = T) {
          case 0:
            for (T = 0, E = Math.pow(2, 8), R = 1; R != E; )
              _ = w.val & w.position, w.position >>= 1, w.position == 0 && (w.position = l, w.val = u(w.index++)), T |= (_ > 0 ? 1 : 0) * R,
              R <<= 1;
            C = e(T);
            break;
          case 1:
            for (T = 0, E = Math.pow(2, 16), R = 1; R != E; )
              _ = w.val & w.position, w.position >>= 1, w.position == 0 && (w.position = l, w.val = u(w.index++)), T |= (_ > 0 ? 1 : 0) * R,
              R <<= 1;
            C = e(T);
            break;
          case 2:
            return "";
        }
        for (c[3] = C, g = C, h.push(C); ; ) {
          if (w.index > a)
            return "";
          for (T = 0, E = Math.pow(2, f), R = 1; R != E; )
            _ = w.val & w.position, w.position >>= 1, w.position == 0 && (w.position = l, w.val = u(w.index++)), T |= (_ > 0 ? 1 : 0) * R, R <<=
            1;
          switch (C = T) {
            case 0:
              for (T = 0, E = Math.pow(2, 8), R = 1; R != E; )
                _ = w.val & w.position, w.position >>= 1, w.position == 0 && (w.position = l, w.val = u(w.index++)), T |= (_ > 0 ? 1 : 0) * R,
                R <<= 1;
              c[y++] = e(T), C = y - 1, p--;
              break;
            case 1:
              for (T = 0, E = Math.pow(2, 16), R = 1; R != E; )
                _ = w.val & w.position, w.position >>= 1, w.position == 0 && (w.position = l, w.val = u(w.index++)), T |= (_ > 0 ? 1 : 0) * R,
                R <<= 1;
              c[y++] = e(T), C = y - 1, p--;
              break;
            case 2:
              return h.join("");
          }
          if (p == 0 && (p = Math.pow(2, f), f++), c[C])
            m = c[C];
          else if (C === y)
            m = g + g.charAt(0);
          else
            return null;
          h.push(m), c[y++] = g + m.charAt(0), p--, g = m, p == 0 && (p = Math.pow(2, f), f++);
        }
      }, "_decompress")
    };
    return s;
  }();
  typeof define == "function" && define.amd ? define(function() {
    return HR;
  }) : typeof ey < "u" && ey != null ? ey.exports = HR : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("\
LZString", function() {
    return HR;
  });
});

// ../node_modules/memoizerific/memoizerific.js
var bS = v((S3, yS) => {
  (function(e) {
    if (typeof S3 == "object" && typeof yS < "u")
      yS.exports = e();
    else if (typeof define == "function" && define.amd)
      define([], e);
    else {
      var t;
      typeof window < "u" ? t = window : typeof global < "u" ? t = global : typeof self < "u" ? t = self : t = this, t.memoizerific = e();
    }
  })(function() {
    var e, t, r;
    return (/* @__PURE__ */ o(function n(i, s, a) {
      function l(d, p) {
        if (!s[d]) {
          if (!i[d]) {
            var y = typeof Di == "function" && Di;
            if (!p && y) return y(d, !0);
            if (u) return u(d, !0);
            var f = new Error("Cannot find module '" + d + "'");
            throw f.code = "MODULE_NOT_FOUND", f;
          }
          var m = s[d] = { exports: {} };
          i[d][0].call(m.exports, function(h) {
            var b = i[d][1][h];
            return l(b || h);
          }, m, m.exports, n, i, s, a);
        }
        return s[d].exports;
      }
      o(l, "s");
      for (var u = typeof Di == "function" && Di, c = 0; c < a.length; c++) l(a[c]);
      return l;
    }, "e"))({ 1: [function(n, i, s) {
      i.exports = function(a) {
        if (typeof Map != "function" || a) {
          var l = n("./similar");
          return new l();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(n, i, s) {
      function a() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      o(a, "Similar"), a.prototype.get = function(l) {
        var u;
        if (this.lastItem && this.isEqual(this.lastItem.key, l))
          return this.lastItem.val;
        if (u = this.indexOf(l), u >= 0)
          return this.lastItem = this.list[u], this.list[u].val;
      }, a.prototype.set = function(l, u) {
        var c;
        return this.lastItem && this.isEqual(this.lastItem.key, l) ? (this.lastItem.val = u, this) : (c = this.indexOf(l), c >= 0 ? (this.lastItem =
        this.list[c], this.list[c].val = u, this) : (this.lastItem = { key: l, val: u }, this.list.push(this.lastItem), this.size++, this));
      }, a.prototype.delete = function(l) {
        var u;
        if (this.lastItem && this.isEqual(this.lastItem.key, l) && (this.lastItem = void 0), u = this.indexOf(l), u >= 0)
          return this.size--, this.list.splice(u, 1)[0];
      }, a.prototype.has = function(l) {
        var u;
        return this.lastItem && this.isEqual(this.lastItem.key, l) ? !0 : (u = this.indexOf(l), u >= 0 ? (this.lastItem = this.list[u], !0) :
        !1);
      }, a.prototype.forEach = function(l, u) {
        var c;
        for (c = 0; c < this.size; c++)
          l.call(u || this, this.list[c].val, this.list[c].key, this);
      }, a.prototype.indexOf = function(l) {
        var u;
        for (u = 0; u < this.size; u++)
          if (this.isEqual(this.list[u].key, l))
            return u;
        return -1;
      }, a.prototype.isEqual = function(l, u) {
        return l === u || l !== l && u !== u;
      }, i.exports = a;
    }, {}], 3: [function(n, i, s) {
      var a = n("map-or-similar");
      i.exports = function(d) {
        var p = new a(!1), y = [];
        return function(f) {
          var m = /* @__PURE__ */ o(function() {
            var h = p, b, g, T = arguments.length - 1, _ = Array(T + 1), E = !0, R;
            if ((m.numArgs || m.numArgs === 0) && m.numArgs !== T + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (R = 0; R < T; R++) {
              if (_[R] = {
                cacheItem: h,
                arg: arguments[R]
              }, h.has(arguments[R])) {
                h = h.get(arguments[R]);
                continue;
              }
              E = !1, b = new a(!1), h.set(arguments[R], b), h = b;
            }
            return E && (h.has(arguments[T]) ? g = h.get(arguments[T]) : E = !1), E || (g = f.apply(null, arguments), h.set(arguments[T], g)),
            d > 0 && (_[T] = {
              cacheItem: h,
              arg: arguments[T]
            }, E ? l(y, _) : y.push(_), y.length > d && u(y.shift())), m.wasMemoized = E, m.numArgs = T + 1, g;
          }, "memoizerific");
          return m.limit = d, m.wasMemoized = !1, m.cache = p, m.lru = y, m;
        };
      };
      function l(d, p) {
        var y = d.length, f = p.length, m, h, b;
        for (h = 0; h < y; h++) {
          for (m = !0, b = 0; b < f; b++)
            if (!c(d[h][b].arg, p[b].arg)) {
              m = !1;
              break;
            }
          if (m)
            break;
        }
        d.push(d.splice(h, 1)[0]);
      }
      o(l, "moveToMostRecentLru");
      function u(d) {
        var p = d.length, y = d[p - 1], f, m;
        for (y.cacheItem.delete(y.arg), m = p - 2; m >= 0 && (y = d[m], f = y.cacheItem.get(y.arg), !f || !f.size); m--)
          y.cacheItem.delete(y.arg);
      }
      o(u, "removeCachedResult");
      function c(d, p) {
        return d === p || d !== d && p !== p;
      }
      o(c, "isEqual");
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
});

// ../node_modules/picoquery/lib/string-util.js
var $S = v((DS) => {
  "use strict";
  Object.defineProperty(DS, "__esModule", { value: !0 });
  DS.encodeString = hSe;
  var yr = Array.from({ length: 256 }, (e, t) => "%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase()), mSe = new Int8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0
  ]);
  function hSe(e) {
    let t = e.length;
    if (t === 0)
      return "";
    let r = "", n = 0, i = 0;
    e: for (; i < t; i++) {
      let s = e.charCodeAt(i);
      for (; s < 128; ) {
        if (mSe[s] !== 1 && (n < i && (r += e.slice(n, i)), n = i + 1, r += yr[s]), ++i === t)
          break e;
        s = e.charCodeAt(i);
      }
      if (n < i && (r += e.slice(n, i)), s < 2048) {
        n = i + 1, r += yr[192 | s >> 6] + yr[128 | s & 63];
        continue;
      }
      if (s < 55296 || s >= 57344) {
        n = i + 1, r += yr[224 | s >> 12] + yr[128 | s >> 6 & 63] + yr[128 | s & 63];
        continue;
      }
      if (++i, i >= t)
        throw new Error("URI malformed");
      let a = e.charCodeAt(i) & 1023;
      n = i + 1, s = 65536 + ((s & 1023) << 10 | a), r += yr[240 | s >> 18] + yr[128 | s >> 12 & 63] + yr[128 | s >> 6 & 63] + yr[128 | s & 63];
    }
    return n === 0 ? e : n < t ? r + e.slice(n) : r;
  }
  o(hSe, "encodeString");
});

// ../node_modules/picoquery/lib/shared.js
var Qy = v((br) => {
  "use strict";
  Object.defineProperty(br, "__esModule", { value: !0 });
  br.defaultOptions = br.defaultShouldSerializeObject = br.defaultValueSerializer = void 0;
  var BS = $S(), ySe = /* @__PURE__ */ o((e) => {
    switch (typeof e) {
      case "string":
        return (0, BS.encodeString)(e);
      case "bigint":
      case "boolean":
        return "" + e;
      case "number":
        if (Number.isFinite(e))
          return e < 1e21 ? "" + e : (0, BS.encodeString)("" + e);
        break;
    }
    return e instanceof Date ? (0, BS.encodeString)(e.toISOString()) : "";
  }, "defaultValueSerializer");
  br.defaultValueSerializer = ySe;
  var bSe = /* @__PURE__ */ o((e) => e instanceof Date, "defaultShouldSerializeObject");
  br.defaultShouldSerializeObject = bSe;
  var X3 = /* @__PURE__ */ o((e) => e, "identityFunc");
  br.defaultOptions = {
    nesting: !0,
    nestingSyntax: "dot",
    arrayRepeat: !1,
    arrayRepeatSyntax: "repeat",
    delimiter: 38,
    valueDeserializer: X3,
    valueSerializer: br.defaultValueSerializer,
    keyDeserializer: X3,
    shouldSerializeObject: br.defaultShouldSerializeObject
  };
});

// ../node_modules/picoquery/lib/object-util.js
var US = v((eb) => {
  "use strict";
  Object.defineProperty(eb, "__esModule", { value: !0 });
  eb.getDeepObject = ESe;
  eb.stringifyObject = J3;
  var co = Qy(), gSe = $S();
  function vSe(e) {
    return e === "__proto__" || e === "constructor" || e === "prototype";
  }
  o(vSe, "isPrototypeKey");
  function ESe(e, t, r, n, i) {
    if (vSe(t))
      return e;
    let s = e[t];
    return typeof s == "object" && s !== null ? s : !n && (i || typeof r == "number" || typeof r == "string" && r * 0 === 0 && r.indexOf(".") ===
    -1) ? e[t] = [] : e[t] = {};
  }
  o(ESe, "getDeepObject");
  var TSe = 20, _Se = "[]", RSe = "[", wSe = "]", SSe = ".";
  function J3(e, t, r = 0, n, i) {
    let { nestingSyntax: s = co.defaultOptions.nestingSyntax, arrayRepeat: a = co.defaultOptions.arrayRepeat, arrayRepeatSyntax: l = co.defaultOptions.
    arrayRepeatSyntax, nesting: u = co.defaultOptions.nesting, delimiter: c = co.defaultOptions.delimiter, valueSerializer: d = co.defaultOptions.
    valueSerializer, shouldSerializeObject: p = co.defaultOptions.shouldSerializeObject } = t, y = typeof c == "number" ? String.fromCharCode(
    c) : c, f = i === !0 && a, m = s === "dot" || s === "js" && !i;
    if (r > TSe)
      return "";
    let h = "", b = !0, g = !1;
    for (let T in e) {
      let _ = e[T], E;
      n ? (E = n, f ? l === "bracket" && (E += _Se) : m ? (E += SSe, E += T) : (E += RSe, E += T, E += wSe)) : E = T, b || (h += y), typeof _ ==
      "object" && _ !== null && !p(_) ? (g = _.pop !== void 0, (u || a && g) && (h += J3(_, t, r + 1, E, g))) : (h += (0, gSe.encodeString)(
      E), h += "=", h += d(_, T)), b && (b = !1);
    }
    return h;
  }
  o(J3, "stringifyObject");
});

// ../node_modules/fast-decode-uri-component/index.js
var tV = v((qXe, eV) => {
  "use strict";
  var Z3 = 12, xSe = 0, HS = [
    // The first part of the table maps bytes to character to a transition.
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    8,
    7,
    7,
    10,
    9,
    9,
    9,
    11,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    // The second part of the table maps a state to a new state when adding a
    // transition.
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    12,
    0,
    0,
    0,
    0,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    0,
    12,
    12,
    12,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    48,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    // The third part maps the current transition to a mask that needs to apply
    // to the byte.
    127,
    63,
    63,
    63,
    0,
    31,
    15,
    15,
    15,
    7,
    7,
    7
  ];
  function CSe(e) {
    var t = e.indexOf("%");
    if (t === -1) return e;
    for (var r = e.length, n = "", i = 0, s = 0, a = t, l = Z3; t > -1 && t < r; ) {
      var u = Q3(e[t + 1], 4), c = Q3(e[t + 2], 0), d = u | c, p = HS[d];
      if (l = HS[256 + l + p], s = s << 6 | d & HS[364 + p], l === Z3)
        n += e.slice(i, a), n += s <= 65535 ? String.fromCharCode(s) : String.fromCharCode(
          55232 + (s >> 10),
          56320 + (s & 1023)
        ), s = 0, i = t + 3, t = a = e.indexOf("%", i);
      else {
        if (l === xSe)
          return null;
        if (t += 3, t < r && e.charCodeAt(t) === 37) continue;
        return null;
      }
    }
    return n + e.slice(i);
  }
  o(CSe, "decodeURIComponent");
  var PSe = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    A: 10,
    b: 11,
    B: 11,
    c: 12,
    C: 12,
    d: 13,
    D: 13,
    e: 14,
    E: 14,
    f: 15,
    F: 15
  };
  function Q3(e, t) {
    var r = PSe[e];
    return r === void 0 ? 255 : r << t;
  }
  o(Q3, "hexCodeToInt");
  eV.exports = CSe;
});

// ../node_modules/picoquery/lib/parse.js
var iV = v((Lr) => {
  "use strict";
  var ASe = Lr && Lr.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(Lr, "__esModule", { value: !0 });
  Lr.numberValueDeserializer = Lr.numberKeyDeserializer = void 0;
  Lr.parse = ISe;
  var tb = US(), po = Qy(), rV = ASe(tV()), OSe = /* @__PURE__ */ o((e) => {
    let t = Number(e);
    return Number.isNaN(t) ? e : t;
  }, "numberKeyDeserializer");
  Lr.numberKeyDeserializer = OSe;
  var qSe = /* @__PURE__ */ o((e) => {
    let t = Number(e);
    return Number.isNaN(t) ? e : t;
  }, "numberValueDeserializer");
  Lr.numberValueDeserializer = qSe;
  var nV = /\+/g, oV = /* @__PURE__ */ o(function() {
  }, "Empty");
  oV.prototype = /* @__PURE__ */ Object.create(null);
  function rb(e, t, r, n, i) {
    let s = e.substring(t, r);
    return n && (s = s.replace(nV, " ")), i && (s = (0, rV.default)(s) || s), s;
  }
  o(rb, "computeKeySlice");
  function ISe(e, t) {
    let { valueDeserializer: r = po.defaultOptions.valueDeserializer, keyDeserializer: n = po.defaultOptions.keyDeserializer, arrayRepeatSyntax: i = po.
    defaultOptions.arrayRepeatSyntax, nesting: s = po.defaultOptions.nesting, arrayRepeat: a = po.defaultOptions.arrayRepeat, nestingSyntax: l = po.
    defaultOptions.nestingSyntax, delimiter: u = po.defaultOptions.delimiter } = t ?? {}, c = typeof u == "string" ? u.charCodeAt(0) : u, d = l ===
    "js", p = new oV();
    if (typeof e != "string")
      return p;
    let y = e.length, f = "", m = -1, h = -1, b = -1, g = p, T, _ = "", E = "", R = !1, C = !1, w = !1, P = !1, O = !1, D = !1, A = !1, L = 0,
    B = -1, N = -1, $ = -1;
    for (let M = 0; M < y + 1; M++) {
      if (L = M !== y ? e.charCodeAt(M) : c, L === c) {
        if (A = h > m, A || (h = M), b !== h - 1 && (E = rb(e, b + 1, B > -1 ? B : h, w, R), _ = n(E), T !== void 0 && (g = (0, tb.getDeepObject)(
        g, T, _, d && O, d && D))), A || _ !== "") {
          A && (f = e.slice(h + 1, M), P && (f = f.replace(nV, " ")), C && (f = (0, rV.default)(f) || f));
          let V = r(f, _);
          if (a) {
            let G = g[_];
            G === void 0 ? B > -1 ? g[_] = [V] : g[_] = V : G.pop ? G.push(V) : g[_] = [G, V];
          } else
            g[_] = V;
        }
        f = "", m = M, h = M, R = !1, C = !1, w = !1, P = !1, O = !1, D = !1, B = -1, b = M, g = p, T = void 0, _ = "";
      } else L === 93 ? (a && i === "bracket" && $ === 91 && (B = N), s && (l === "index" || d) && h <= m && (b !== N && (E = rb(e, b + 1, M,
      w, R), _ = n(E), T !== void 0 && (g = (0, tb.getDeepObject)(g, T, _, void 0, d)), T = _, w = !1, R = !1), b = M, D = !0, O = !1)) : L ===
      46 ? s && (l === "dot" || d) && h <= m && (b !== N && (E = rb(e, b + 1, M, w, R), _ = n(E), T !== void 0 && (g = (0, tb.getDeepObject)(
      g, T, _, d)), T = _, w = !1, R = !1), O = !0, D = !1, b = M) : L === 91 ? s && (l === "index" || d) && h <= m && (b !== N && (E = rb(e,
      b + 1, M, w, R), _ = n(E), d && T !== void 0 && (g = (0, tb.getDeepObject)(g, T, _, d)), T = _, w = !1, R = !1, O = !1, D = !0), b = M) :
      L === 61 ? h <= m ? h = M : C = !0 : L === 43 ? h > m ? P = !0 : w = !0 : L === 37 && (h > m ? C = !0 : R = !0);
      N = M, $ = L;
    }
    return p;
  }
  o(ISe, "parse");
});

// ../node_modules/picoquery/lib/stringify.js
var sV = v((VS) => {
  "use strict";
  Object.defineProperty(VS, "__esModule", { value: !0 });
  VS.stringify = NSe;
  var MSe = US();
  function NSe(e, t) {
    if (e === null || typeof e != "object")
      return "";
    let r = t ?? {};
    return (0, MSe.stringifyObject)(e, r);
  }
  o(NSe, "stringify");
});

// ../node_modules/picoquery/lib/main.js
var nb = v((ar) => {
  "use strict";
  var jSe = ar && ar.__createBinding || (Object.create ? function(e, t, r, n) {
    n === void 0 && (n = r);
    var i = Object.getOwnPropertyDescriptor(t, r);
    (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: /* @__PURE__ */ o(function() {
      return t[r];
    }, "get") }), Object.defineProperty(e, n, i);
  } : function(e, t, r, n) {
    n === void 0 && (n = r), e[n] = t[r];
  }), LSe = ar && ar.__exportStar || function(e, t) {
    for (var r in e) r !== "default" && !Object.prototype.hasOwnProperty.call(t, r) && jSe(t, e, r);
  };
  Object.defineProperty(ar, "__esModule", { value: !0 });
  ar.stringify = ar.parse = void 0;
  var FSe = iV();
  Object.defineProperty(ar, "parse", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return FSe.parse;
  }, "get") });
  var kSe = sV();
  Object.defineProperty(ar, "stringify", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return kSe.stringify;
  }, "get") });
  LSe(Qy(), ar);
});

// ../node_modules/entities/lib/maps/entities.json
var WS = v((WXe, zSe) => {
  zSe.exports = { Aacute: "\xC1", aacute: "\xE1", Abreve: "\u0102", abreve: "\u0103", ac: "\u223E", acd: "\u223F", acE: "\u223E\u0333", Acirc: "\
\xC2", acirc: "\xE2", acute: "\xB4", Acy: "\u0410", acy: "\u0430", AElig: "\xC6", aelig: "\xE6", af: "\u2061", Afr: "\u{1D504}", afr: "\u{1D51E}",
  Agrave: "\xC0", agrave: "\xE0", alefsym: "\u2135", aleph: "\u2135", Alpha: "\u0391", alpha: "\u03B1", Amacr: "\u0100", amacr: "\u0101", amalg: "\
\u2A3F", amp: "&", AMP: "&", andand: "\u2A55", And: "\u2A53", and: "\u2227", andd: "\u2A5C", andslope: "\u2A58", andv: "\u2A5A", ang: "\u2220",
  ange: "\u29A4", angle: "\u2220", angmsdaa: "\u29A8", angmsdab: "\u29A9", angmsdac: "\u29AA", angmsdad: "\u29AB", angmsdae: "\u29AC", angmsdaf: "\
\u29AD", angmsdag: "\u29AE", angmsdah: "\u29AF", angmsd: "\u2221", angrt: "\u221F", angrtvb: "\u22BE", angrtvbd: "\u299D", angsph: "\u2222",
  angst: "\xC5", angzarr: "\u237C", Aogon: "\u0104", aogon: "\u0105", Aopf: "\u{1D538}", aopf: "\u{1D552}", apacir: "\u2A6F", ap: "\u2248", apE: "\
\u2A70", ape: "\u224A", apid: "\u224B", apos: "'", ApplyFunction: "\u2061", approx: "\u2248", approxeq: "\u224A", Aring: "\xC5", aring: "\xE5",
  Ascr: "\u{1D49C}", ascr: "\u{1D4B6}", Assign: "\u2254", ast: "*", asymp: "\u2248", asympeq: "\u224D", Atilde: "\xC3", atilde: "\xE3", Auml: "\
\xC4", auml: "\xE4", awconint: "\u2233", awint: "\u2A11", backcong: "\u224C", backepsilon: "\u03F6", backprime: "\u2035", backsim: "\u223D",
  backsimeq: "\u22CD", Backslash: "\u2216", Barv: "\u2AE7", barvee: "\u22BD", barwed: "\u2305", Barwed: "\u2306", barwedge: "\u2305", bbrk: "\
\u23B5", bbrktbrk: "\u23B6", bcong: "\u224C", Bcy: "\u0411", bcy: "\u0431", bdquo: "\u201E", becaus: "\u2235", because: "\u2235", Because: "\
\u2235", bemptyv: "\u29B0", bepsi: "\u03F6", bernou: "\u212C", Bernoullis: "\u212C", Beta: "\u0392", beta: "\u03B2", beth: "\u2136", between: "\
\u226C", Bfr: "\u{1D505}", bfr: "\u{1D51F}", bigcap: "\u22C2", bigcirc: "\u25EF", bigcup: "\u22C3", bigodot: "\u2A00", bigoplus: "\u2A01", bigotimes: "\
\u2A02", bigsqcup: "\u2A06", bigstar: "\u2605", bigtriangledown: "\u25BD", bigtriangleup: "\u25B3", biguplus: "\u2A04", bigvee: "\u22C1", bigwedge: "\
\u22C0", bkarow: "\u290D", blacklozenge: "\u29EB", blacksquare: "\u25AA", blacktriangle: "\u25B4", blacktriangledown: "\u25BE", blacktriangleleft: "\
\u25C2", blacktriangleright: "\u25B8", blank: "\u2423", blk12: "\u2592", blk14: "\u2591", blk34: "\u2593", block: "\u2588", bne: "=\u20E5", bnequiv: "\
\u2261\u20E5", bNot: "\u2AED", bnot: "\u2310", Bopf: "\u{1D539}", bopf: "\u{1D553}", bot: "\u22A5", bottom: "\u22A5", bowtie: "\u22C8", boxbox: "\
\u29C9", boxdl: "\u2510", boxdL: "\u2555", boxDl: "\u2556", boxDL: "\u2557", boxdr: "\u250C", boxdR: "\u2552", boxDr: "\u2553", boxDR: "\u2554",
  boxh: "\u2500", boxH: "\u2550", boxhd: "\u252C", boxHd: "\u2564", boxhD: "\u2565", boxHD: "\u2566", boxhu: "\u2534", boxHu: "\u2567", boxhU: "\
\u2568", boxHU: "\u2569", boxminus: "\u229F", boxplus: "\u229E", boxtimes: "\u22A0", boxul: "\u2518", boxuL: "\u255B", boxUl: "\u255C", boxUL: "\
\u255D", boxur: "\u2514", boxuR: "\u2558", boxUr: "\u2559", boxUR: "\u255A", boxv: "\u2502", boxV: "\u2551", boxvh: "\u253C", boxvH: "\u256A",
  boxVh: "\u256B", boxVH: "\u256C", boxvl: "\u2524", boxvL: "\u2561", boxVl: "\u2562", boxVL: "\u2563", boxvr: "\u251C", boxvR: "\u255E", boxVr: "\
\u255F", boxVR: "\u2560", bprime: "\u2035", breve: "\u02D8", Breve: "\u02D8", brvbar: "\xA6", bscr: "\u{1D4B7}", Bscr: "\u212C", bsemi: "\u204F",
  bsim: "\u223D", bsime: "\u22CD", bsolb: "\u29C5", bsol: "\\", bsolhsub: "\u27C8", bull: "\u2022", bullet: "\u2022", bump: "\u224E", bumpE: "\
\u2AAE", bumpe: "\u224F", Bumpeq: "\u224E", bumpeq: "\u224F", Cacute: "\u0106", cacute: "\u0107", capand: "\u2A44", capbrcup: "\u2A49", capcap: "\
\u2A4B", cap: "\u2229", Cap: "\u22D2", capcup: "\u2A47", capdot: "\u2A40", CapitalDifferentialD: "\u2145", caps: "\u2229\uFE00", caret: "\u2041",
  caron: "\u02C7", Cayleys: "\u212D", ccaps: "\u2A4D", Ccaron: "\u010C", ccaron: "\u010D", Ccedil: "\xC7", ccedil: "\xE7", Ccirc: "\u0108", ccirc: "\
\u0109", Cconint: "\u2230", ccups: "\u2A4C", ccupssm: "\u2A50", Cdot: "\u010A", cdot: "\u010B", cedil: "\xB8", Cedilla: "\xB8", cemptyv: "\u29B2",
  cent: "\xA2", centerdot: "\xB7", CenterDot: "\xB7", cfr: "\u{1D520}", Cfr: "\u212D", CHcy: "\u0427", chcy: "\u0447", check: "\u2713", checkmark: "\
\u2713", Chi: "\u03A7", chi: "\u03C7", circ: "\u02C6", circeq: "\u2257", circlearrowleft: "\u21BA", circlearrowright: "\u21BB", circledast: "\
\u229B", circledcirc: "\u229A", circleddash: "\u229D", CircleDot: "\u2299", circledR: "\xAE", circledS: "\u24C8", CircleMinus: "\u2296", CirclePlus: "\
\u2295", CircleTimes: "\u2297", cir: "\u25CB", cirE: "\u29C3", cire: "\u2257", cirfnint: "\u2A10", cirmid: "\u2AEF", cirscir: "\u29C2", ClockwiseContourIntegral: "\
\u2232", CloseCurlyDoubleQuote: "\u201D", CloseCurlyQuote: "\u2019", clubs: "\u2663", clubsuit: "\u2663", colon: ":", Colon: "\u2237", Colone: "\
\u2A74", colone: "\u2254", coloneq: "\u2254", comma: ",", commat: "@", comp: "\u2201", compfn: "\u2218", complement: "\u2201", complexes: "\u2102",
  cong: "\u2245", congdot: "\u2A6D", Congruent: "\u2261", conint: "\u222E", Conint: "\u222F", ContourIntegral: "\u222E", copf: "\u{1D554}", Copf: "\
\u2102", coprod: "\u2210", Coproduct: "\u2210", copy: "\xA9", COPY: "\xA9", copysr: "\u2117", CounterClockwiseContourIntegral: "\u2233", crarr: "\
\u21B5", cross: "\u2717", Cross: "\u2A2F", Cscr: "\u{1D49E}", cscr: "\u{1D4B8}", csub: "\u2ACF", csube: "\u2AD1", csup: "\u2AD0", csupe: "\u2AD2",
  ctdot: "\u22EF", cudarrl: "\u2938", cudarrr: "\u2935", cuepr: "\u22DE", cuesc: "\u22DF", cularr: "\u21B6", cularrp: "\u293D", cupbrcap: "\u2A48",
  cupcap: "\u2A46", CupCap: "\u224D", cup: "\u222A", Cup: "\u22D3", cupcup: "\u2A4A", cupdot: "\u228D", cupor: "\u2A45", cups: "\u222A\uFE00",
  curarr: "\u21B7", curarrm: "\u293C", curlyeqprec: "\u22DE", curlyeqsucc: "\u22DF", curlyvee: "\u22CE", curlywedge: "\u22CF", curren: "\xA4",
  curvearrowleft: "\u21B6", curvearrowright: "\u21B7", cuvee: "\u22CE", cuwed: "\u22CF", cwconint: "\u2232", cwint: "\u2231", cylcty: "\u232D",
  dagger: "\u2020", Dagger: "\u2021", daleth: "\u2138", darr: "\u2193", Darr: "\u21A1", dArr: "\u21D3", dash: "\u2010", Dashv: "\u2AE4", dashv: "\
\u22A3", dbkarow: "\u290F", dblac: "\u02DD", Dcaron: "\u010E", dcaron: "\u010F", Dcy: "\u0414", dcy: "\u0434", ddagger: "\u2021", ddarr: "\u21CA",
  DD: "\u2145", dd: "\u2146", DDotrahd: "\u2911", ddotseq: "\u2A77", deg: "\xB0", Del: "\u2207", Delta: "\u0394", delta: "\u03B4", demptyv: "\
\u29B1", dfisht: "\u297F", Dfr: "\u{1D507}", dfr: "\u{1D521}", dHar: "\u2965", dharl: "\u21C3", dharr: "\u21C2", DiacriticalAcute: "\xB4", DiacriticalDot: "\
\u02D9", DiacriticalDoubleAcute: "\u02DD", DiacriticalGrave: "`", DiacriticalTilde: "\u02DC", diam: "\u22C4", diamond: "\u22C4", Diamond: "\u22C4",
  diamondsuit: "\u2666", diams: "\u2666", die: "\xA8", DifferentialD: "\u2146", digamma: "\u03DD", disin: "\u22F2", div: "\xF7", divide: "\xF7",
  divideontimes: "\u22C7", divonx: "\u22C7", DJcy: "\u0402", djcy: "\u0452", dlcorn: "\u231E", dlcrop: "\u230D", dollar: "$", Dopf: "\u{1D53B}",
  dopf: "\u{1D555}", Dot: "\xA8", dot: "\u02D9", DotDot: "\u20DC", doteq: "\u2250", doteqdot: "\u2251", DotEqual: "\u2250", dotminus: "\u2238",
  dotplus: "\u2214", dotsquare: "\u22A1", doublebarwedge: "\u2306", DoubleContourIntegral: "\u222F", DoubleDot: "\xA8", DoubleDownArrow: "\u21D3",
  DoubleLeftArrow: "\u21D0", DoubleLeftRightArrow: "\u21D4", DoubleLeftTee: "\u2AE4", DoubleLongLeftArrow: "\u27F8", DoubleLongLeftRightArrow: "\
\u27FA", DoubleLongRightArrow: "\u27F9", DoubleRightArrow: "\u21D2", DoubleRightTee: "\u22A8", DoubleUpArrow: "\u21D1", DoubleUpDownArrow: "\
\u21D5", DoubleVerticalBar: "\u2225", DownArrowBar: "\u2913", downarrow: "\u2193", DownArrow: "\u2193", Downarrow: "\u21D3", DownArrowUpArrow: "\
\u21F5", DownBreve: "\u0311", downdownarrows: "\u21CA", downharpoonleft: "\u21C3", downharpoonright: "\u21C2", DownLeftRightVector: "\u2950",
  DownLeftTeeVector: "\u295E", DownLeftVectorBar: "\u2956", DownLeftVector: "\u21BD", DownRightTeeVector: "\u295F", DownRightVectorBar: "\u2957",
  DownRightVector: "\u21C1", DownTeeArrow: "\u21A7", DownTee: "\u22A4", drbkarow: "\u2910", drcorn: "\u231F", drcrop: "\u230C", Dscr: "\u{1D49F}",
  dscr: "\u{1D4B9}", DScy: "\u0405", dscy: "\u0455", dsol: "\u29F6", Dstrok: "\u0110", dstrok: "\u0111", dtdot: "\u22F1", dtri: "\u25BF", dtrif: "\
\u25BE", duarr: "\u21F5", duhar: "\u296F", dwangle: "\u29A6", DZcy: "\u040F", dzcy: "\u045F", dzigrarr: "\u27FF", Eacute: "\xC9", eacute: "\xE9",
  easter: "\u2A6E", Ecaron: "\u011A", ecaron: "\u011B", Ecirc: "\xCA", ecirc: "\xEA", ecir: "\u2256", ecolon: "\u2255", Ecy: "\u042D", ecy: "\
\u044D", eDDot: "\u2A77", Edot: "\u0116", edot: "\u0117", eDot: "\u2251", ee: "\u2147", efDot: "\u2252", Efr: "\u{1D508}", efr: "\u{1D522}",
  eg: "\u2A9A", Egrave: "\xC8", egrave: "\xE8", egs: "\u2A96", egsdot: "\u2A98", el: "\u2A99", Element: "\u2208", elinters: "\u23E7", ell: "\
\u2113", els: "\u2A95", elsdot: "\u2A97", Emacr: "\u0112", emacr: "\u0113", empty: "\u2205", emptyset: "\u2205", EmptySmallSquare: "\u25FB",
  emptyv: "\u2205", EmptyVerySmallSquare: "\u25AB", emsp13: "\u2004", emsp14: "\u2005", emsp: "\u2003", ENG: "\u014A", eng: "\u014B", ensp: "\
\u2002", Eogon: "\u0118", eogon: "\u0119", Eopf: "\u{1D53C}", eopf: "\u{1D556}", epar: "\u22D5", eparsl: "\u29E3", eplus: "\u2A71", epsi: "\u03B5",
  Epsilon: "\u0395", epsilon: "\u03B5", epsiv: "\u03F5", eqcirc: "\u2256", eqcolon: "\u2255", eqsim: "\u2242", eqslantgtr: "\u2A96", eqslantless: "\
\u2A95", Equal: "\u2A75", equals: "=", EqualTilde: "\u2242", equest: "\u225F", Equilibrium: "\u21CC", equiv: "\u2261", equivDD: "\u2A78", eqvparsl: "\
\u29E5", erarr: "\u2971", erDot: "\u2253", escr: "\u212F", Escr: "\u2130", esdot: "\u2250", Esim: "\u2A73", esim: "\u2242", Eta: "\u0397", eta: "\
\u03B7", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", euro: "\u20AC", excl: "!", exist: "\u2203", Exists: "\u2203", expectation: "\u2130",
  exponentiale: "\u2147", ExponentialE: "\u2147", fallingdotseq: "\u2252", Fcy: "\u0424", fcy: "\u0444", female: "\u2640", ffilig: "\uFB03",
  fflig: "\uFB00", ffllig: "\uFB04", Ffr: "\u{1D509}", ffr: "\u{1D523}", filig: "\uFB01", FilledSmallSquare: "\u25FC", FilledVerySmallSquare: "\
\u25AA", fjlig: "fj", flat: "\u266D", fllig: "\uFB02", fltns: "\u25B1", fnof: "\u0192", Fopf: "\u{1D53D}", fopf: "\u{1D557}", forall: "\u2200",
  ForAll: "\u2200", fork: "\u22D4", forkv: "\u2AD9", Fouriertrf: "\u2131", fpartint: "\u2A0D", frac12: "\xBD", frac13: "\u2153", frac14: "\xBC",
  frac15: "\u2155", frac16: "\u2159", frac18: "\u215B", frac23: "\u2154", frac25: "\u2156", frac34: "\xBE", frac35: "\u2157", frac38: "\u215C",
  frac45: "\u2158", frac56: "\u215A", frac58: "\u215D", frac78: "\u215E", frasl: "\u2044", frown: "\u2322", fscr: "\u{1D4BB}", Fscr: "\u2131",
  gacute: "\u01F5", Gamma: "\u0393", gamma: "\u03B3", Gammad: "\u03DC", gammad: "\u03DD", gap: "\u2A86", Gbreve: "\u011E", gbreve: "\u011F",
  Gcedil: "\u0122", Gcirc: "\u011C", gcirc: "\u011D", Gcy: "\u0413", gcy: "\u0433", Gdot: "\u0120", gdot: "\u0121", ge: "\u2265", gE: "\u2267",
  gEl: "\u2A8C", gel: "\u22DB", geq: "\u2265", geqq: "\u2267", geqslant: "\u2A7E", gescc: "\u2AA9", ges: "\u2A7E", gesdot: "\u2A80", gesdoto: "\
\u2A82", gesdotol: "\u2A84", gesl: "\u22DB\uFE00", gesles: "\u2A94", Gfr: "\u{1D50A}", gfr: "\u{1D524}", gg: "\u226B", Gg: "\u22D9", ggg: "\u22D9",
  gimel: "\u2137", GJcy: "\u0403", gjcy: "\u0453", gla: "\u2AA5", gl: "\u2277", glE: "\u2A92", glj: "\u2AA4", gnap: "\u2A8A", gnapprox: "\u2A8A",
  gne: "\u2A88", gnE: "\u2269", gneq: "\u2A88", gneqq: "\u2269", gnsim: "\u22E7", Gopf: "\u{1D53E}", gopf: "\u{1D558}", grave: "`", GreaterEqual: "\
\u2265", GreaterEqualLess: "\u22DB", GreaterFullEqual: "\u2267", GreaterGreater: "\u2AA2", GreaterLess: "\u2277", GreaterSlantEqual: "\u2A7E",
  GreaterTilde: "\u2273", Gscr: "\u{1D4A2}", gscr: "\u210A", gsim: "\u2273", gsime: "\u2A8E", gsiml: "\u2A90", gtcc: "\u2AA7", gtcir: "\u2A7A",
  gt: ">", GT: ">", Gt: "\u226B", gtdot: "\u22D7", gtlPar: "\u2995", gtquest: "\u2A7C", gtrapprox: "\u2A86", gtrarr: "\u2978", gtrdot: "\u22D7",
  gtreqless: "\u22DB", gtreqqless: "\u2A8C", gtrless: "\u2277", gtrsim: "\u2273", gvertneqq: "\u2269\uFE00", gvnE: "\u2269\uFE00", Hacek: "\u02C7",
  hairsp: "\u200A", half: "\xBD", hamilt: "\u210B", HARDcy: "\u042A", hardcy: "\u044A", harrcir: "\u2948", harr: "\u2194", hArr: "\u21D4", harrw: "\
\u21AD", Hat: "^", hbar: "\u210F", Hcirc: "\u0124", hcirc: "\u0125", hearts: "\u2665", heartsuit: "\u2665", hellip: "\u2026", hercon: "\u22B9",
  hfr: "\u{1D525}", Hfr: "\u210C", HilbertSpace: "\u210B", hksearow: "\u2925", hkswarow: "\u2926", hoarr: "\u21FF", homtht: "\u223B", hookleftarrow: "\
\u21A9", hookrightarrow: "\u21AA", hopf: "\u{1D559}", Hopf: "\u210D", horbar: "\u2015", HorizontalLine: "\u2500", hscr: "\u{1D4BD}", Hscr: "\
\u210B", hslash: "\u210F", Hstrok: "\u0126", hstrok: "\u0127", HumpDownHump: "\u224E", HumpEqual: "\u224F", hybull: "\u2043", hyphen: "\u2010",
  Iacute: "\xCD", iacute: "\xED", ic: "\u2063", Icirc: "\xCE", icirc: "\xEE", Icy: "\u0418", icy: "\u0438", Idot: "\u0130", IEcy: "\u0415", iecy: "\
\u0435", iexcl: "\xA1", iff: "\u21D4", ifr: "\u{1D526}", Ifr: "\u2111", Igrave: "\xCC", igrave: "\xEC", ii: "\u2148", iiiint: "\u2A0C", iiint: "\
\u222D", iinfin: "\u29DC", iiota: "\u2129", IJlig: "\u0132", ijlig: "\u0133", Imacr: "\u012A", imacr: "\u012B", image: "\u2111", ImaginaryI: "\
\u2148", imagline: "\u2110", imagpart: "\u2111", imath: "\u0131", Im: "\u2111", imof: "\u22B7", imped: "\u01B5", Implies: "\u21D2", incare: "\
\u2105", in: "\u2208", infin: "\u221E", infintie: "\u29DD", inodot: "\u0131", intcal: "\u22BA", int: "\u222B", Int: "\u222C", integers: "\u2124",
  Integral: "\u222B", intercal: "\u22BA", Intersection: "\u22C2", intlarhk: "\u2A17", intprod: "\u2A3C", InvisibleComma: "\u2063", InvisibleTimes: "\
\u2062", IOcy: "\u0401", iocy: "\u0451", Iogon: "\u012E", iogon: "\u012F", Iopf: "\u{1D540}", iopf: "\u{1D55A}", Iota: "\u0399", iota: "\u03B9",
  iprod: "\u2A3C", iquest: "\xBF", iscr: "\u{1D4BE}", Iscr: "\u2110", isin: "\u2208", isindot: "\u22F5", isinE: "\u22F9", isins: "\u22F4", isinsv: "\
\u22F3", isinv: "\u2208", it: "\u2062", Itilde: "\u0128", itilde: "\u0129", Iukcy: "\u0406", iukcy: "\u0456", Iuml: "\xCF", iuml: "\xEF", Jcirc: "\
\u0134", jcirc: "\u0135", Jcy: "\u0419", jcy: "\u0439", Jfr: "\u{1D50D}", jfr: "\u{1D527}", jmath: "\u0237", Jopf: "\u{1D541}", jopf: "\u{1D55B}",
  Jscr: "\u{1D4A5}", jscr: "\u{1D4BF}", Jsercy: "\u0408", jsercy: "\u0458", Jukcy: "\u0404", jukcy: "\u0454", Kappa: "\u039A", kappa: "\u03BA",
  kappav: "\u03F0", Kcedil: "\u0136", kcedil: "\u0137", Kcy: "\u041A", kcy: "\u043A", Kfr: "\u{1D50E}", kfr: "\u{1D528}", kgreen: "\u0138", KHcy: "\
\u0425", khcy: "\u0445", KJcy: "\u040C", kjcy: "\u045C", Kopf: "\u{1D542}", kopf: "\u{1D55C}", Kscr: "\u{1D4A6}", kscr: "\u{1D4C0}", lAarr: "\
\u21DA", Lacute: "\u0139", lacute: "\u013A", laemptyv: "\u29B4", lagran: "\u2112", Lambda: "\u039B", lambda: "\u03BB", lang: "\u27E8", Lang: "\
\u27EA", langd: "\u2991", langle: "\u27E8", lap: "\u2A85", Laplacetrf: "\u2112", laquo: "\xAB", larrb: "\u21E4", larrbfs: "\u291F", larr: "\u2190",
  Larr: "\u219E", lArr: "\u21D0", larrfs: "\u291D", larrhk: "\u21A9", larrlp: "\u21AB", larrpl: "\u2939", larrsim: "\u2973", larrtl: "\u21A2",
  latail: "\u2919", lAtail: "\u291B", lat: "\u2AAB", late: "\u2AAD", lates: "\u2AAD\uFE00", lbarr: "\u290C", lBarr: "\u290E", lbbrk: "\u2772",
  lbrace: "{", lbrack: "[", lbrke: "\u298B", lbrksld: "\u298F", lbrkslu: "\u298D", Lcaron: "\u013D", lcaron: "\u013E", Lcedil: "\u013B", lcedil: "\
\u013C", lceil: "\u2308", lcub: "{", Lcy: "\u041B", lcy: "\u043B", ldca: "\u2936", ldquo: "\u201C", ldquor: "\u201E", ldrdhar: "\u2967", ldrushar: "\
\u294B", ldsh: "\u21B2", le: "\u2264", lE: "\u2266", LeftAngleBracket: "\u27E8", LeftArrowBar: "\u21E4", leftarrow: "\u2190", LeftArrow: "\u2190",
  Leftarrow: "\u21D0", LeftArrowRightArrow: "\u21C6", leftarrowtail: "\u21A2", LeftCeiling: "\u2308", LeftDoubleBracket: "\u27E6", LeftDownTeeVector: "\
\u2961", LeftDownVectorBar: "\u2959", LeftDownVector: "\u21C3", LeftFloor: "\u230A", leftharpoondown: "\u21BD", leftharpoonup: "\u21BC", leftleftarrows: "\
\u21C7", leftrightarrow: "\u2194", LeftRightArrow: "\u2194", Leftrightarrow: "\u21D4", leftrightarrows: "\u21C6", leftrightharpoons: "\u21CB",
  leftrightsquigarrow: "\u21AD", LeftRightVector: "\u294E", LeftTeeArrow: "\u21A4", LeftTee: "\u22A3", LeftTeeVector: "\u295A", leftthreetimes: "\
\u22CB", LeftTriangleBar: "\u29CF", LeftTriangle: "\u22B2", LeftTriangleEqual: "\u22B4", LeftUpDownVector: "\u2951", LeftUpTeeVector: "\u2960",
  LeftUpVectorBar: "\u2958", LeftUpVector: "\u21BF", LeftVectorBar: "\u2952", LeftVector: "\u21BC", lEg: "\u2A8B", leg: "\u22DA", leq: "\u2264",
  leqq: "\u2266", leqslant: "\u2A7D", lescc: "\u2AA8", les: "\u2A7D", lesdot: "\u2A7F", lesdoto: "\u2A81", lesdotor: "\u2A83", lesg: "\u22DA\uFE00",
  lesges: "\u2A93", lessapprox: "\u2A85", lessdot: "\u22D6", lesseqgtr: "\u22DA", lesseqqgtr: "\u2A8B", LessEqualGreater: "\u22DA", LessFullEqual: "\
\u2266", LessGreater: "\u2276", lessgtr: "\u2276", LessLess: "\u2AA1", lesssim: "\u2272", LessSlantEqual: "\u2A7D", LessTilde: "\u2272", lfisht: "\
\u297C", lfloor: "\u230A", Lfr: "\u{1D50F}", lfr: "\u{1D529}", lg: "\u2276", lgE: "\u2A91", lHar: "\u2962", lhard: "\u21BD", lharu: "\u21BC",
  lharul: "\u296A", lhblk: "\u2584", LJcy: "\u0409", ljcy: "\u0459", llarr: "\u21C7", ll: "\u226A", Ll: "\u22D8", llcorner: "\u231E", Lleftarrow: "\
\u21DA", llhard: "\u296B", lltri: "\u25FA", Lmidot: "\u013F", lmidot: "\u0140", lmoustache: "\u23B0", lmoust: "\u23B0", lnap: "\u2A89", lnapprox: "\
\u2A89", lne: "\u2A87", lnE: "\u2268", lneq: "\u2A87", lneqq: "\u2268", lnsim: "\u22E6", loang: "\u27EC", loarr: "\u21FD", lobrk: "\u27E6", longleftarrow: "\
\u27F5", LongLeftArrow: "\u27F5", Longleftarrow: "\u27F8", longleftrightarrow: "\u27F7", LongLeftRightArrow: "\u27F7", Longleftrightarrow: "\
\u27FA", longmapsto: "\u27FC", longrightarrow: "\u27F6", LongRightArrow: "\u27F6", Longrightarrow: "\u27F9", looparrowleft: "\u21AB", looparrowright: "\
\u21AC", lopar: "\u2985", Lopf: "\u{1D543}", lopf: "\u{1D55D}", loplus: "\u2A2D", lotimes: "\u2A34", lowast: "\u2217", lowbar: "_", LowerLeftArrow: "\
\u2199", LowerRightArrow: "\u2198", loz: "\u25CA", lozenge: "\u25CA", lozf: "\u29EB", lpar: "(", lparlt: "\u2993", lrarr: "\u21C6", lrcorner: "\
\u231F", lrhar: "\u21CB", lrhard: "\u296D", lrm: "\u200E", lrtri: "\u22BF", lsaquo: "\u2039", lscr: "\u{1D4C1}", Lscr: "\u2112", lsh: "\u21B0",
  Lsh: "\u21B0", lsim: "\u2272", lsime: "\u2A8D", lsimg: "\u2A8F", lsqb: "[", lsquo: "\u2018", lsquor: "\u201A", Lstrok: "\u0141", lstrok: "\
\u0142", ltcc: "\u2AA6", ltcir: "\u2A79", lt: "<", LT: "<", Lt: "\u226A", ltdot: "\u22D6", lthree: "\u22CB", ltimes: "\u22C9", ltlarr: "\u2976",
  ltquest: "\u2A7B", ltri: "\u25C3", ltrie: "\u22B4", ltrif: "\u25C2", ltrPar: "\u2996", lurdshar: "\u294A", luruhar: "\u2966", lvertneqq: "\
\u2268\uFE00", lvnE: "\u2268\uFE00", macr: "\xAF", male: "\u2642", malt: "\u2720", maltese: "\u2720", Map: "\u2905", map: "\u21A6", mapsto: "\
\u21A6", mapstodown: "\u21A7", mapstoleft: "\u21A4", mapstoup: "\u21A5", marker: "\u25AE", mcomma: "\u2A29", Mcy: "\u041C", mcy: "\u043C", mdash: "\
\u2014", mDDot: "\u223A", measuredangle: "\u2221", MediumSpace: "\u205F", Mellintrf: "\u2133", Mfr: "\u{1D510}", mfr: "\u{1D52A}", mho: "\u2127",
  micro: "\xB5", midast: "*", midcir: "\u2AF0", mid: "\u2223", middot: "\xB7", minusb: "\u229F", minus: "\u2212", minusd: "\u2238", minusdu: "\
\u2A2A", MinusPlus: "\u2213", mlcp: "\u2ADB", mldr: "\u2026", mnplus: "\u2213", models: "\u22A7", Mopf: "\u{1D544}", mopf: "\u{1D55E}", mp: "\
\u2213", mscr: "\u{1D4C2}", Mscr: "\u2133", mstpos: "\u223E", Mu: "\u039C", mu: "\u03BC", multimap: "\u22B8", mumap: "\u22B8", nabla: "\u2207",
  Nacute: "\u0143", nacute: "\u0144", nang: "\u2220\u20D2", nap: "\u2249", napE: "\u2A70\u0338", napid: "\u224B\u0338", napos: "\u0149", napprox: "\
\u2249", natural: "\u266E", naturals: "\u2115", natur: "\u266E", nbsp: "\xA0", nbump: "\u224E\u0338", nbumpe: "\u224F\u0338", ncap: "\u2A43",
  Ncaron: "\u0147", ncaron: "\u0148", Ncedil: "\u0145", ncedil: "\u0146", ncong: "\u2247", ncongdot: "\u2A6D\u0338", ncup: "\u2A42", Ncy: "\u041D",
  ncy: "\u043D", ndash: "\u2013", nearhk: "\u2924", nearr: "\u2197", neArr: "\u21D7", nearrow: "\u2197", ne: "\u2260", nedot: "\u2250\u0338",
  NegativeMediumSpace: "\u200B", NegativeThickSpace: "\u200B", NegativeThinSpace: "\u200B", NegativeVeryThinSpace: "\u200B", nequiv: "\u2262",
  nesear: "\u2928", nesim: "\u2242\u0338", NestedGreaterGreater: "\u226B", NestedLessLess: "\u226A", NewLine: `
`, nexist: "\u2204", nexists: "\u2204", Nfr: "\u{1D511}", nfr: "\u{1D52B}", ngE: "\u2267\u0338", nge: "\u2271", ngeq: "\u2271", ngeqq: "\u2267\u0338",
  ngeqslant: "\u2A7E\u0338", nges: "\u2A7E\u0338", nGg: "\u22D9\u0338", ngsim: "\u2275", nGt: "\u226B\u20D2", ngt: "\u226F", ngtr: "\u226F",
  nGtv: "\u226B\u0338", nharr: "\u21AE", nhArr: "\u21CE", nhpar: "\u2AF2", ni: "\u220B", nis: "\u22FC", nisd: "\u22FA", niv: "\u220B", NJcy: "\
\u040A", njcy: "\u045A", nlarr: "\u219A", nlArr: "\u21CD", nldr: "\u2025", nlE: "\u2266\u0338", nle: "\u2270", nleftarrow: "\u219A", nLeftarrow: "\
\u21CD", nleftrightarrow: "\u21AE", nLeftrightarrow: "\u21CE", nleq: "\u2270", nleqq: "\u2266\u0338", nleqslant: "\u2A7D\u0338", nles: "\u2A7D\u0338",
  nless: "\u226E", nLl: "\u22D8\u0338", nlsim: "\u2274", nLt: "\u226A\u20D2", nlt: "\u226E", nltri: "\u22EA", nltrie: "\u22EC", nLtv: "\u226A\u0338",
  nmid: "\u2224", NoBreak: "\u2060", NonBreakingSpace: "\xA0", nopf: "\u{1D55F}", Nopf: "\u2115", Not: "\u2AEC", not: "\xAC", NotCongruent: "\
\u2262", NotCupCap: "\u226D", NotDoubleVerticalBar: "\u2226", NotElement: "\u2209", NotEqual: "\u2260", NotEqualTilde: "\u2242\u0338", NotExists: "\
\u2204", NotGreater: "\u226F", NotGreaterEqual: "\u2271", NotGreaterFullEqual: "\u2267\u0338", NotGreaterGreater: "\u226B\u0338", NotGreaterLess: "\
\u2279", NotGreaterSlantEqual: "\u2A7E\u0338", NotGreaterTilde: "\u2275", NotHumpDownHump: "\u224E\u0338", NotHumpEqual: "\u224F\u0338", notin: "\
\u2209", notindot: "\u22F5\u0338", notinE: "\u22F9\u0338", notinva: "\u2209", notinvb: "\u22F7", notinvc: "\u22F6", NotLeftTriangleBar: "\u29CF\u0338",
  NotLeftTriangle: "\u22EA", NotLeftTriangleEqual: "\u22EC", NotLess: "\u226E", NotLessEqual: "\u2270", NotLessGreater: "\u2278", NotLessLess: "\
\u226A\u0338", NotLessSlantEqual: "\u2A7D\u0338", NotLessTilde: "\u2274", NotNestedGreaterGreater: "\u2AA2\u0338", NotNestedLessLess: "\u2AA1\u0338",
  notni: "\u220C", notniva: "\u220C", notnivb: "\u22FE", notnivc: "\u22FD", NotPrecedes: "\u2280", NotPrecedesEqual: "\u2AAF\u0338", NotPrecedesSlantEqual: "\
\u22E0", NotReverseElement: "\u220C", NotRightTriangleBar: "\u29D0\u0338", NotRightTriangle: "\u22EB", NotRightTriangleEqual: "\u22ED", NotSquareSubset: "\
\u228F\u0338", NotSquareSubsetEqual: "\u22E2", NotSquareSuperset: "\u2290\u0338", NotSquareSupersetEqual: "\u22E3", NotSubset: "\u2282\u20D2",
  NotSubsetEqual: "\u2288", NotSucceeds: "\u2281", NotSucceedsEqual: "\u2AB0\u0338", NotSucceedsSlantEqual: "\u22E1", NotSucceedsTilde: "\u227F\u0338",
  NotSuperset: "\u2283\u20D2", NotSupersetEqual: "\u2289", NotTilde: "\u2241", NotTildeEqual: "\u2244", NotTildeFullEqual: "\u2247", NotTildeTilde: "\
\u2249", NotVerticalBar: "\u2224", nparallel: "\u2226", npar: "\u2226", nparsl: "\u2AFD\u20E5", npart: "\u2202\u0338", npolint: "\u2A14", npr: "\
\u2280", nprcue: "\u22E0", nprec: "\u2280", npreceq: "\u2AAF\u0338", npre: "\u2AAF\u0338", nrarrc: "\u2933\u0338", nrarr: "\u219B", nrArr: "\
\u21CF", nrarrw: "\u219D\u0338", nrightarrow: "\u219B", nRightarrow: "\u21CF", nrtri: "\u22EB", nrtrie: "\u22ED", nsc: "\u2281", nsccue: "\u22E1",
  nsce: "\u2AB0\u0338", Nscr: "\u{1D4A9}", nscr: "\u{1D4C3}", nshortmid: "\u2224", nshortparallel: "\u2226", nsim: "\u2241", nsime: "\u2244",
  nsimeq: "\u2244", nsmid: "\u2224", nspar: "\u2226", nsqsube: "\u22E2", nsqsupe: "\u22E3", nsub: "\u2284", nsubE: "\u2AC5\u0338", nsube: "\u2288",
  nsubset: "\u2282\u20D2", nsubseteq: "\u2288", nsubseteqq: "\u2AC5\u0338", nsucc: "\u2281", nsucceq: "\u2AB0\u0338", nsup: "\u2285", nsupE: "\
\u2AC6\u0338", nsupe: "\u2289", nsupset: "\u2283\u20D2", nsupseteq: "\u2289", nsupseteqq: "\u2AC6\u0338", ntgl: "\u2279", Ntilde: "\xD1", ntilde: "\
\xF1", ntlg: "\u2278", ntriangleleft: "\u22EA", ntrianglelefteq: "\u22EC", ntriangleright: "\u22EB", ntrianglerighteq: "\u22ED", Nu: "\u039D",
  nu: "\u03BD", num: "#", numero: "\u2116", numsp: "\u2007", nvap: "\u224D\u20D2", nvdash: "\u22AC", nvDash: "\u22AD", nVdash: "\u22AE", nVDash: "\
\u22AF", nvge: "\u2265\u20D2", nvgt: ">\u20D2", nvHarr: "\u2904", nvinfin: "\u29DE", nvlArr: "\u2902", nvle: "\u2264\u20D2", nvlt: "<\u20D2",
  nvltrie: "\u22B4\u20D2", nvrArr: "\u2903", nvrtrie: "\u22B5\u20D2", nvsim: "\u223C\u20D2", nwarhk: "\u2923", nwarr: "\u2196", nwArr: "\u21D6",
  nwarrow: "\u2196", nwnear: "\u2927", Oacute: "\xD3", oacute: "\xF3", oast: "\u229B", Ocirc: "\xD4", ocirc: "\xF4", ocir: "\u229A", Ocy: "\u041E",
  ocy: "\u043E", odash: "\u229D", Odblac: "\u0150", odblac: "\u0151", odiv: "\u2A38", odot: "\u2299", odsold: "\u29BC", OElig: "\u0152", oelig: "\
\u0153", ofcir: "\u29BF", Ofr: "\u{1D512}", ofr: "\u{1D52C}", ogon: "\u02DB", Ograve: "\xD2", ograve: "\xF2", ogt: "\u29C1", ohbar: "\u29B5",
  ohm: "\u03A9", oint: "\u222E", olarr: "\u21BA", olcir: "\u29BE", olcross: "\u29BB", oline: "\u203E", olt: "\u29C0", Omacr: "\u014C", omacr: "\
\u014D", Omega: "\u03A9", omega: "\u03C9", Omicron: "\u039F", omicron: "\u03BF", omid: "\u29B6", ominus: "\u2296", Oopf: "\u{1D546}", oopf: "\
\u{1D560}", opar: "\u29B7", OpenCurlyDoubleQuote: "\u201C", OpenCurlyQuote: "\u2018", operp: "\u29B9", oplus: "\u2295", orarr: "\u21BB", Or: "\
\u2A54", or: "\u2228", ord: "\u2A5D", order: "\u2134", orderof: "\u2134", ordf: "\xAA", ordm: "\xBA", origof: "\u22B6", oror: "\u2A56", orslope: "\
\u2A57", orv: "\u2A5B", oS: "\u24C8", Oscr: "\u{1D4AA}", oscr: "\u2134", Oslash: "\xD8", oslash: "\xF8", osol: "\u2298", Otilde: "\xD5", otilde: "\
\xF5", otimesas: "\u2A36", Otimes: "\u2A37", otimes: "\u2297", Ouml: "\xD6", ouml: "\xF6", ovbar: "\u233D", OverBar: "\u203E", OverBrace: "\u23DE",
  OverBracket: "\u23B4", OverParenthesis: "\u23DC", para: "\xB6", parallel: "\u2225", par: "\u2225", parsim: "\u2AF3", parsl: "\u2AFD", part: "\
\u2202", PartialD: "\u2202", Pcy: "\u041F", pcy: "\u043F", percnt: "%", period: ".", permil: "\u2030", perp: "\u22A5", pertenk: "\u2031", Pfr: "\
\u{1D513}", pfr: "\u{1D52D}", Phi: "\u03A6", phi: "\u03C6", phiv: "\u03D5", phmmat: "\u2133", phone: "\u260E", Pi: "\u03A0", pi: "\u03C0", pitchfork: "\
\u22D4", piv: "\u03D6", planck: "\u210F", planckh: "\u210E", plankv: "\u210F", plusacir: "\u2A23", plusb: "\u229E", pluscir: "\u2A22", plus: "\
+", plusdo: "\u2214", plusdu: "\u2A25", pluse: "\u2A72", PlusMinus: "\xB1", plusmn: "\xB1", plussim: "\u2A26", plustwo: "\u2A27", pm: "\xB1",
  Poincareplane: "\u210C", pointint: "\u2A15", popf: "\u{1D561}", Popf: "\u2119", pound: "\xA3", prap: "\u2AB7", Pr: "\u2ABB", pr: "\u227A",
  prcue: "\u227C", precapprox: "\u2AB7", prec: "\u227A", preccurlyeq: "\u227C", Precedes: "\u227A", PrecedesEqual: "\u2AAF", PrecedesSlantEqual: "\
\u227C", PrecedesTilde: "\u227E", preceq: "\u2AAF", precnapprox: "\u2AB9", precneqq: "\u2AB5", precnsim: "\u22E8", pre: "\u2AAF", prE: "\u2AB3",
  precsim: "\u227E", prime: "\u2032", Prime: "\u2033", primes: "\u2119", prnap: "\u2AB9", prnE: "\u2AB5", prnsim: "\u22E8", prod: "\u220F", Product: "\
\u220F", profalar: "\u232E", profline: "\u2312", profsurf: "\u2313", prop: "\u221D", Proportional: "\u221D", Proportion: "\u2237", propto: "\
\u221D", prsim: "\u227E", prurel: "\u22B0", Pscr: "\u{1D4AB}", pscr: "\u{1D4C5}", Psi: "\u03A8", psi: "\u03C8", puncsp: "\u2008", Qfr: "\u{1D514}",
  qfr: "\u{1D52E}", qint: "\u2A0C", qopf: "\u{1D562}", Qopf: "\u211A", qprime: "\u2057", Qscr: "\u{1D4AC}", qscr: "\u{1D4C6}", quaternions: "\
\u210D", quatint: "\u2A16", quest: "?", questeq: "\u225F", quot: '"', QUOT: '"', rAarr: "\u21DB", race: "\u223D\u0331", Racute: "\u0154", racute: "\
\u0155", radic: "\u221A", raemptyv: "\u29B3", rang: "\u27E9", Rang: "\u27EB", rangd: "\u2992", range: "\u29A5", rangle: "\u27E9", raquo: "\xBB",
  rarrap: "\u2975", rarrb: "\u21E5", rarrbfs: "\u2920", rarrc: "\u2933", rarr: "\u2192", Rarr: "\u21A0", rArr: "\u21D2", rarrfs: "\u291E", rarrhk: "\
\u21AA", rarrlp: "\u21AC", rarrpl: "\u2945", rarrsim: "\u2974", Rarrtl: "\u2916", rarrtl: "\u21A3", rarrw: "\u219D", ratail: "\u291A", rAtail: "\
\u291C", ratio: "\u2236", rationals: "\u211A", rbarr: "\u290D", rBarr: "\u290F", RBarr: "\u2910", rbbrk: "\u2773", rbrace: "}", rbrack: "]",
  rbrke: "\u298C", rbrksld: "\u298E", rbrkslu: "\u2990", Rcaron: "\u0158", rcaron: "\u0159", Rcedil: "\u0156", rcedil: "\u0157", rceil: "\u2309",
  rcub: "}", Rcy: "\u0420", rcy: "\u0440", rdca: "\u2937", rdldhar: "\u2969", rdquo: "\u201D", rdquor: "\u201D", rdsh: "\u21B3", real: "\u211C",
  realine: "\u211B", realpart: "\u211C", reals: "\u211D", Re: "\u211C", rect: "\u25AD", reg: "\xAE", REG: "\xAE", ReverseElement: "\u220B", ReverseEquilibrium: "\
\u21CB", ReverseUpEquilibrium: "\u296F", rfisht: "\u297D", rfloor: "\u230B", rfr: "\u{1D52F}", Rfr: "\u211C", rHar: "\u2964", rhard: "\u21C1",
  rharu: "\u21C0", rharul: "\u296C", Rho: "\u03A1", rho: "\u03C1", rhov: "\u03F1", RightAngleBracket: "\u27E9", RightArrowBar: "\u21E5", rightarrow: "\
\u2192", RightArrow: "\u2192", Rightarrow: "\u21D2", RightArrowLeftArrow: "\u21C4", rightarrowtail: "\u21A3", RightCeiling: "\u2309", RightDoubleBracket: "\
\u27E7", RightDownTeeVector: "\u295D", RightDownVectorBar: "\u2955", RightDownVector: "\u21C2", RightFloor: "\u230B", rightharpoondown: "\u21C1",
  rightharpoonup: "\u21C0", rightleftarrows: "\u21C4", rightleftharpoons: "\u21CC", rightrightarrows: "\u21C9", rightsquigarrow: "\u219D", RightTeeArrow: "\
\u21A6", RightTee: "\u22A2", RightTeeVector: "\u295B", rightthreetimes: "\u22CC", RightTriangleBar: "\u29D0", RightTriangle: "\u22B3", RightTriangleEqual: "\
\u22B5", RightUpDownVector: "\u294F", RightUpTeeVector: "\u295C", RightUpVectorBar: "\u2954", RightUpVector: "\u21BE", RightVectorBar: "\u2953",
  RightVector: "\u21C0", ring: "\u02DA", risingdotseq: "\u2253", rlarr: "\u21C4", rlhar: "\u21CC", rlm: "\u200F", rmoustache: "\u23B1", rmoust: "\
\u23B1", rnmid: "\u2AEE", roang: "\u27ED", roarr: "\u21FE", robrk: "\u27E7", ropar: "\u2986", ropf: "\u{1D563}", Ropf: "\u211D", roplus: "\u2A2E",
  rotimes: "\u2A35", RoundImplies: "\u2970", rpar: ")", rpargt: "\u2994", rppolint: "\u2A12", rrarr: "\u21C9", Rrightarrow: "\u21DB", rsaquo: "\
\u203A", rscr: "\u{1D4C7}", Rscr: "\u211B", rsh: "\u21B1", Rsh: "\u21B1", rsqb: "]", rsquo: "\u2019", rsquor: "\u2019", rthree: "\u22CC", rtimes: "\
\u22CA", rtri: "\u25B9", rtrie: "\u22B5", rtrif: "\u25B8", rtriltri: "\u29CE", RuleDelayed: "\u29F4", ruluhar: "\u2968", rx: "\u211E", Sacute: "\
\u015A", sacute: "\u015B", sbquo: "\u201A", scap: "\u2AB8", Scaron: "\u0160", scaron: "\u0161", Sc: "\u2ABC", sc: "\u227B", sccue: "\u227D",
  sce: "\u2AB0", scE: "\u2AB4", Scedil: "\u015E", scedil: "\u015F", Scirc: "\u015C", scirc: "\u015D", scnap: "\u2ABA", scnE: "\u2AB6", scnsim: "\
\u22E9", scpolint: "\u2A13", scsim: "\u227F", Scy: "\u0421", scy: "\u0441", sdotb: "\u22A1", sdot: "\u22C5", sdote: "\u2A66", searhk: "\u2925",
  searr: "\u2198", seArr: "\u21D8", searrow: "\u2198", sect: "\xA7", semi: ";", seswar: "\u2929", setminus: "\u2216", setmn: "\u2216", sext: "\
\u2736", Sfr: "\u{1D516}", sfr: "\u{1D530}", sfrown: "\u2322", sharp: "\u266F", SHCHcy: "\u0429", shchcy: "\u0449", SHcy: "\u0428", shcy: "\u0448",
  ShortDownArrow: "\u2193", ShortLeftArrow: "\u2190", shortmid: "\u2223", shortparallel: "\u2225", ShortRightArrow: "\u2192", ShortUpArrow: "\
\u2191", shy: "\xAD", Sigma: "\u03A3", sigma: "\u03C3", sigmaf: "\u03C2", sigmav: "\u03C2", sim: "\u223C", simdot: "\u2A6A", sime: "\u2243",
  simeq: "\u2243", simg: "\u2A9E", simgE: "\u2AA0", siml: "\u2A9D", simlE: "\u2A9F", simne: "\u2246", simplus: "\u2A24", simrarr: "\u2972", slarr: "\
\u2190", SmallCircle: "\u2218", smallsetminus: "\u2216", smashp: "\u2A33", smeparsl: "\u29E4", smid: "\u2223", smile: "\u2323", smt: "\u2AAA",
  smte: "\u2AAC", smtes: "\u2AAC\uFE00", SOFTcy: "\u042C", softcy: "\u044C", solbar: "\u233F", solb: "\u29C4", sol: "/", Sopf: "\u{1D54A}", sopf: "\
\u{1D564}", spades: "\u2660", spadesuit: "\u2660", spar: "\u2225", sqcap: "\u2293", sqcaps: "\u2293\uFE00", sqcup: "\u2294", sqcups: "\u2294\uFE00",
  Sqrt: "\u221A", sqsub: "\u228F", sqsube: "\u2291", sqsubset: "\u228F", sqsubseteq: "\u2291", sqsup: "\u2290", sqsupe: "\u2292", sqsupset: "\
\u2290", sqsupseteq: "\u2292", square: "\u25A1", Square: "\u25A1", SquareIntersection: "\u2293", SquareSubset: "\u228F", SquareSubsetEqual: "\
\u2291", SquareSuperset: "\u2290", SquareSupersetEqual: "\u2292", SquareUnion: "\u2294", squarf: "\u25AA", squ: "\u25A1", squf: "\u25AA", srarr: "\
\u2192", Sscr: "\u{1D4AE}", sscr: "\u{1D4C8}", ssetmn: "\u2216", ssmile: "\u2323", sstarf: "\u22C6", Star: "\u22C6", star: "\u2606", starf: "\
\u2605", straightepsilon: "\u03F5", straightphi: "\u03D5", strns: "\xAF", sub: "\u2282", Sub: "\u22D0", subdot: "\u2ABD", subE: "\u2AC5", sube: "\
\u2286", subedot: "\u2AC3", submult: "\u2AC1", subnE: "\u2ACB", subne: "\u228A", subplus: "\u2ABF", subrarr: "\u2979", subset: "\u2282", Subset: "\
\u22D0", subseteq: "\u2286", subseteqq: "\u2AC5", SubsetEqual: "\u2286", subsetneq: "\u228A", subsetneqq: "\u2ACB", subsim: "\u2AC7", subsub: "\
\u2AD5", subsup: "\u2AD3", succapprox: "\u2AB8", succ: "\u227B", succcurlyeq: "\u227D", Succeeds: "\u227B", SucceedsEqual: "\u2AB0", SucceedsSlantEqual: "\
\u227D", SucceedsTilde: "\u227F", succeq: "\u2AB0", succnapprox: "\u2ABA", succneqq: "\u2AB6", succnsim: "\u22E9", succsim: "\u227F", SuchThat: "\
\u220B", sum: "\u2211", Sum: "\u2211", sung: "\u266A", sup1: "\xB9", sup2: "\xB2", sup3: "\xB3", sup: "\u2283", Sup: "\u22D1", supdot: "\u2ABE",
  supdsub: "\u2AD8", supE: "\u2AC6", supe: "\u2287", supedot: "\u2AC4", Superset: "\u2283", SupersetEqual: "\u2287", suphsol: "\u27C9", suphsub: "\
\u2AD7", suplarr: "\u297B", supmult: "\u2AC2", supnE: "\u2ACC", supne: "\u228B", supplus: "\u2AC0", supset: "\u2283", Supset: "\u22D1", supseteq: "\
\u2287", supseteqq: "\u2AC6", supsetneq: "\u228B", supsetneqq: "\u2ACC", supsim: "\u2AC8", supsub: "\u2AD4", supsup: "\u2AD6", swarhk: "\u2926",
  swarr: "\u2199", swArr: "\u21D9", swarrow: "\u2199", swnwar: "\u292A", szlig: "\xDF", Tab: "	", target: "\u2316", Tau: "\u03A4", tau: "\u03C4",
  tbrk: "\u23B4", Tcaron: "\u0164", tcaron: "\u0165", Tcedil: "\u0162", tcedil: "\u0163", Tcy: "\u0422", tcy: "\u0442", tdot: "\u20DB", telrec: "\
\u2315", Tfr: "\u{1D517}", tfr: "\u{1D531}", there4: "\u2234", therefore: "\u2234", Therefore: "\u2234", Theta: "\u0398", theta: "\u03B8", thetasym: "\
\u03D1", thetav: "\u03D1", thickapprox: "\u2248", thicksim: "\u223C", ThickSpace: "\u205F\u200A", ThinSpace: "\u2009", thinsp: "\u2009", thkap: "\
\u2248", thksim: "\u223C", THORN: "\xDE", thorn: "\xFE", tilde: "\u02DC", Tilde: "\u223C", TildeEqual: "\u2243", TildeFullEqual: "\u2245", TildeTilde: "\
\u2248", timesbar: "\u2A31", timesb: "\u22A0", times: "\xD7", timesd: "\u2A30", tint: "\u222D", toea: "\u2928", topbot: "\u2336", topcir: "\u2AF1",
  top: "\u22A4", Topf: "\u{1D54B}", topf: "\u{1D565}", topfork: "\u2ADA", tosa: "\u2929", tprime: "\u2034", trade: "\u2122", TRADE: "\u2122",
  triangle: "\u25B5", triangledown: "\u25BF", triangleleft: "\u25C3", trianglelefteq: "\u22B4", triangleq: "\u225C", triangleright: "\u25B9",
  trianglerighteq: "\u22B5", tridot: "\u25EC", trie: "\u225C", triminus: "\u2A3A", TripleDot: "\u20DB", triplus: "\u2A39", trisb: "\u29CD", tritime: "\
\u2A3B", trpezium: "\u23E2", Tscr: "\u{1D4AF}", tscr: "\u{1D4C9}", TScy: "\u0426", tscy: "\u0446", TSHcy: "\u040B", tshcy: "\u045B", Tstrok: "\
\u0166", tstrok: "\u0167", twixt: "\u226C", twoheadleftarrow: "\u219E", twoheadrightarrow: "\u21A0", Uacute: "\xDA", uacute: "\xFA", uarr: "\
\u2191", Uarr: "\u219F", uArr: "\u21D1", Uarrocir: "\u2949", Ubrcy: "\u040E", ubrcy: "\u045E", Ubreve: "\u016C", ubreve: "\u016D", Ucirc: "\xDB",
  ucirc: "\xFB", Ucy: "\u0423", ucy: "\u0443", udarr: "\u21C5", Udblac: "\u0170", udblac: "\u0171", udhar: "\u296E", ufisht: "\u297E", Ufr: "\
\u{1D518}", ufr: "\u{1D532}", Ugrave: "\xD9", ugrave: "\xF9", uHar: "\u2963", uharl: "\u21BF", uharr: "\u21BE", uhblk: "\u2580", ulcorn: "\u231C",
  ulcorner: "\u231C", ulcrop: "\u230F", ultri: "\u25F8", Umacr: "\u016A", umacr: "\u016B", uml: "\xA8", UnderBar: "_", UnderBrace: "\u23DF",
  UnderBracket: "\u23B5", UnderParenthesis: "\u23DD", Union: "\u22C3", UnionPlus: "\u228E", Uogon: "\u0172", uogon: "\u0173", Uopf: "\u{1D54C}",
  uopf: "\u{1D566}", UpArrowBar: "\u2912", uparrow: "\u2191", UpArrow: "\u2191", Uparrow: "\u21D1", UpArrowDownArrow: "\u21C5", updownarrow: "\
\u2195", UpDownArrow: "\u2195", Updownarrow: "\u21D5", UpEquilibrium: "\u296E", upharpoonleft: "\u21BF", upharpoonright: "\u21BE", uplus: "\u228E",
  UpperLeftArrow: "\u2196", UpperRightArrow: "\u2197", upsi: "\u03C5", Upsi: "\u03D2", upsih: "\u03D2", Upsilon: "\u03A5", upsilon: "\u03C5",
  UpTeeArrow: "\u21A5", UpTee: "\u22A5", upuparrows: "\u21C8", urcorn: "\u231D", urcorner: "\u231D", urcrop: "\u230E", Uring: "\u016E", uring: "\
\u016F", urtri: "\u25F9", Uscr: "\u{1D4B0}", uscr: "\u{1D4CA}", utdot: "\u22F0", Utilde: "\u0168", utilde: "\u0169", utri: "\u25B5", utrif: "\
\u25B4", uuarr: "\u21C8", Uuml: "\xDC", uuml: "\xFC", uwangle: "\u29A7", vangrt: "\u299C", varepsilon: "\u03F5", varkappa: "\u03F0", varnothing: "\
\u2205", varphi: "\u03D5", varpi: "\u03D6", varpropto: "\u221D", varr: "\u2195", vArr: "\u21D5", varrho: "\u03F1", varsigma: "\u03C2", varsubsetneq: "\
\u228A\uFE00", varsubsetneqq: "\u2ACB\uFE00", varsupsetneq: "\u228B\uFE00", varsupsetneqq: "\u2ACC\uFE00", vartheta: "\u03D1", vartriangleleft: "\
\u22B2", vartriangleright: "\u22B3", vBar: "\u2AE8", Vbar: "\u2AEB", vBarv: "\u2AE9", Vcy: "\u0412", vcy: "\u0432", vdash: "\u22A2", vDash: "\
\u22A8", Vdash: "\u22A9", VDash: "\u22AB", Vdashl: "\u2AE6", veebar: "\u22BB", vee: "\u2228", Vee: "\u22C1", veeeq: "\u225A", vellip: "\u22EE",
  verbar: "|", Verbar: "\u2016", vert: "|", Vert: "\u2016", VerticalBar: "\u2223", VerticalLine: "|", VerticalSeparator: "\u2758", VerticalTilde: "\
\u2240", VeryThinSpace: "\u200A", Vfr: "\u{1D519}", vfr: "\u{1D533}", vltri: "\u22B2", vnsub: "\u2282\u20D2", vnsup: "\u2283\u20D2", Vopf: "\
\u{1D54D}", vopf: "\u{1D567}", vprop: "\u221D", vrtri: "\u22B3", Vscr: "\u{1D4B1}", vscr: "\u{1D4CB}", vsubnE: "\u2ACB\uFE00", vsubne: "\u228A\uFE00",
  vsupnE: "\u2ACC\uFE00", vsupne: "\u228B\uFE00", Vvdash: "\u22AA", vzigzag: "\u299A", Wcirc: "\u0174", wcirc: "\u0175", wedbar: "\u2A5F", wedge: "\
\u2227", Wedge: "\u22C0", wedgeq: "\u2259", weierp: "\u2118", Wfr: "\u{1D51A}", wfr: "\u{1D534}", Wopf: "\u{1D54E}", wopf: "\u{1D568}", wp: "\
\u2118", wr: "\u2240", wreath: "\u2240", Wscr: "\u{1D4B2}", wscr: "\u{1D4CC}", xcap: "\u22C2", xcirc: "\u25EF", xcup: "\u22C3", xdtri: "\u25BD",
  Xfr: "\u{1D51B}", xfr: "\u{1D535}", xharr: "\u27F7", xhArr: "\u27FA", Xi: "\u039E", xi: "\u03BE", xlarr: "\u27F5", xlArr: "\u27F8", xmap: "\
\u27FC", xnis: "\u22FB", xodot: "\u2A00", Xopf: "\u{1D54F}", xopf: "\u{1D569}", xoplus: "\u2A01", xotime: "\u2A02", xrarr: "\u27F6", xrArr: "\
\u27F9", Xscr: "\u{1D4B3}", xscr: "\u{1D4CD}", xsqcup: "\u2A06", xuplus: "\u2A04", xutri: "\u25B3", xvee: "\u22C1", xwedge: "\u22C0", Yacute: "\
\xDD", yacute: "\xFD", YAcy: "\u042F", yacy: "\u044F", Ycirc: "\u0176", ycirc: "\u0177", Ycy: "\u042B", ycy: "\u044B", yen: "\xA5", Yfr: "\u{1D51C}",
  yfr: "\u{1D536}", YIcy: "\u0407", yicy: "\u0457", Yopf: "\u{1D550}", yopf: "\u{1D56A}", Yscr: "\u{1D4B4}", yscr: "\u{1D4CE}", YUcy: "\u042E",
  yucy: "\u044E", yuml: "\xFF", Yuml: "\u0178", Zacute: "\u0179", zacute: "\u017A", Zcaron: "\u017D", zcaron: "\u017E", Zcy: "\u0417", zcy: "\
\u0437", Zdot: "\u017B", zdot: "\u017C", zeetrf: "\u2128", ZeroWidthSpace: "\u200B", Zeta: "\u0396", zeta: "\u03B6", zfr: "\u{1D537}", Zfr: "\
\u2128", ZHcy: "\u0416", zhcy: "\u0436", zigrarr: "\u21DD", zopf: "\u{1D56B}", Zopf: "\u2124", Zscr: "\u{1D4B5}", zscr: "\u{1D4CF}", zwj: "\u200D",
  zwnj: "\u200C" };
});

// ../node_modules/entities/lib/maps/legacy.json
var fV = v((KXe, GSe) => {
  GSe.exports = { Aacute: "\xC1", aacute: "\xE1", Acirc: "\xC2", acirc: "\xE2", acute: "\xB4", AElig: "\xC6", aelig: "\xE6", Agrave: "\xC0",
  agrave: "\xE0", amp: "&", AMP: "&", Aring: "\xC5", aring: "\xE5", Atilde: "\xC3", atilde: "\xE3", Auml: "\xC4", auml: "\xE4", brvbar: "\xA6",
  Ccedil: "\xC7", ccedil: "\xE7", cedil: "\xB8", cent: "\xA2", copy: "\xA9", COPY: "\xA9", curren: "\xA4", deg: "\xB0", divide: "\xF7", Eacute: "\
\xC9", eacute: "\xE9", Ecirc: "\xCA", ecirc: "\xEA", Egrave: "\xC8", egrave: "\xE8", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", frac12: "\
\xBD", frac14: "\xBC", frac34: "\xBE", gt: ">", GT: ">", Iacute: "\xCD", iacute: "\xED", Icirc: "\xCE", icirc: "\xEE", iexcl: "\xA1", Igrave: "\
\xCC", igrave: "\xEC", iquest: "\xBF", Iuml: "\xCF", iuml: "\xEF", laquo: "\xAB", lt: "<", LT: "<", macr: "\xAF", micro: "\xB5", middot: "\xB7",
  nbsp: "\xA0", not: "\xAC", Ntilde: "\xD1", ntilde: "\xF1", Oacute: "\xD3", oacute: "\xF3", Ocirc: "\xD4", ocirc: "\xF4", Ograve: "\xD2", ograve: "\
\xF2", ordf: "\xAA", ordm: "\xBA", Oslash: "\xD8", oslash: "\xF8", Otilde: "\xD5", otilde: "\xF5", Ouml: "\xD6", ouml: "\xF6", para: "\xB6",
  plusmn: "\xB1", pound: "\xA3", quot: '"', QUOT: '"', raquo: "\xBB", reg: "\xAE", REG: "\xAE", sect: "\xA7", shy: "\xAD", sup1: "\xB9", sup2: "\
\xB2", sup3: "\xB3", szlig: "\xDF", THORN: "\xDE", thorn: "\xFE", times: "\xD7", Uacute: "\xDA", uacute: "\xFA", Ucirc: "\xDB", ucirc: "\xFB",
  Ugrave: "\xD9", ugrave: "\xF9", uml: "\xA8", Uuml: "\xDC", uuml: "\xFC", Yacute: "\xDD", yacute: "\xFD", yen: "\xA5", yuml: "\xFF" };
});

// ../node_modules/entities/lib/maps/xml.json
var KS = v((XXe, YSe) => {
  YSe.exports = { amp: "&", apos: "'", gt: ">", lt: "<", quot: '"' };
});

// ../node_modules/entities/lib/maps/decode.json
var mV = v((JXe, WSe) => {
  WSe.exports = { "0": 65533, "128": 8364, "130": 8218, "131": 402, "132": 8222, "133": 8230, "134": 8224, "135": 8225, "136": 710, "137": 8240,
  "138": 352, "139": 8249, "140": 338, "142": 381, "145": 8216, "146": 8217, "147": 8220, "148": 8221, "149": 8226, "150": 8211, "151": 8212,
  "152": 732, "153": 8482, "154": 353, "155": 8250, "156": 339, "158": 382, "159": 376 };
});

// ../node_modules/entities/lib/decode_codepoint.js
var yV = v((Xa) => {
  "use strict";
  var KSe = Xa && Xa.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(Xa, "__esModule", { value: !0 });
  var hV = KSe(mV()), XSe = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(e) {
      var t = "";
      return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e),
      t;
    }
  );
  function JSe(e) {
    return e >= 55296 && e <= 57343 || e > 1114111 ? "\uFFFD" : (e in hV.default && (e = hV.default[e]), XSe(e));
  }
  o(JSe, "decodeCodePoint");
  Xa.default = JSe;
});

// ../node_modules/entities/lib/decode.js
var JS = v((gr) => {
  "use strict";
  var ob = gr && gr.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(gr, "__esModule", { value: !0 });
  gr.decodeHTML = gr.decodeHTMLStrict = gr.decodeXML = void 0;
  var XS = ob(WS()), ZSe = ob(fV()), QSe = ob(KS()), bV = ob(yV()), exe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  gr.decodeXML = vV(QSe.default);
  gr.decodeHTMLStrict = vV(XS.default);
  function vV(e) {
    var t = EV(e);
    return function(r) {
      return String(r).replace(exe, t);
    };
  }
  o(vV, "getStrictDecoder");
  var gV = /* @__PURE__ */ o(function(e, t) {
    return e < t ? 1 : -1;
  }, "sorter");
  gr.decodeHTML = function() {
    for (var e = Object.keys(ZSe.default).sort(gV), t = Object.keys(XS.default).sort(gV), r = 0, n = 0; r < t.length; r++)
      e[n] === t[r] ? (t[r] += ";?", n++) : t[r] += ";";
    var i = new RegExp("&(?:" + t.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), s = EV(XS.default);
    function a(l) {
      return l.substr(-1) !== ";" && (l += ";"), s(l);
    }
    return o(a, "replacer"), function(l) {
      return String(l).replace(i, a);
    };
  }();
  function EV(e) {
    return /* @__PURE__ */ o(function(r) {
      if (r.charAt(1) === "#") {
        var n = r.charAt(2);
        return n === "X" || n === "x" ? bV.default(parseInt(r.substr(3), 16)) : bV.default(parseInt(r.substr(2), 10));
      }
      return e[r.slice(1, -1)] || r;
    }, "replace");
  }
  o(EV, "getReplacer");
});

// ../node_modules/entities/lib/encode.js
var QS = v((Rt) => {
  "use strict";
  var TV = Rt && Rt.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(Rt, "__esModule", { value: !0 });
  Rt.escapeUTF8 = Rt.escape = Rt.encodeNonAsciiHTML = Rt.encodeHTML = Rt.encodeXML = void 0;
  var txe = TV(KS()), _V = wV(txe.default), RV = SV(_V);
  Rt.encodeXML = PV(_V);
  var rxe = TV(WS()), ZS = wV(rxe.default), nxe = SV(ZS);
  Rt.encodeHTML = ixe(ZS, nxe);
  Rt.encodeNonAsciiHTML = PV(ZS);
  function wV(e) {
    return Object.keys(e).sort().reduce(function(t, r) {
      return t[e[r]] = "&" + r + ";", t;
    }, {});
  }
  o(wV, "getInverseObj");
  function SV(e) {
    for (var t = [], r = [], n = 0, i = Object.keys(e); n < i.length; n++) {
      var s = i[n];
      s.length === 1 ? t.push("\\" + s) : r.push(s);
    }
    t.sort();
    for (var a = 0; a < t.length - 1; a++) {
      for (var l = a; l < t.length - 1 && t[l].charCodeAt(1) + 1 === t[l + 1].charCodeAt(1); )
        l += 1;
      var u = 1 + l - a;
      u < 3 || t.splice(a, u, t[a] + "-" + t[l]);
    }
    return r.unshift("[" + t.join("") + "]"), new RegExp(r.join("|"), "g");
  }
  o(SV, "getInverseReplacer");
  var xV = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g,
  oxe = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      function(e) {
        return e.codePointAt(0);
      }
    ) : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(e) {
        return (e.charCodeAt(0) - 55296) * 1024 + e.charCodeAt(1) - 56320 + 65536;
      }
    )
  );
  function ib(e) {
    return "&#x" + (e.length > 1 ? oxe(e) : e.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  o(ib, "singleCharReplacer");
  function ixe(e, t) {
    return function(r) {
      return r.replace(t, function(n) {
        return e[n];
      }).replace(xV, ib);
    };
  }
  o(ixe, "getInverse");
  var CV = new RegExp(RV.source + "|" + xV.source, "g");
  function sxe(e) {
    return e.replace(CV, ib);
  }
  o(sxe, "escape");
  Rt.escape = sxe;
  function axe(e) {
    return e.replace(RV, ib);
  }
  o(axe, "escapeUTF8");
  Rt.escapeUTF8 = axe;
  function PV(e) {
    return function(t) {
      return t.replace(CV, function(r) {
        return e[r] || ib(r);
      });
    };
  }
  o(PV, "getASCIIEncoder");
});

// ../node_modules/entities/lib/index.js
var OV = v((se) => {
  "use strict";
  Object.defineProperty(se, "__esModule", { value: !0 });
  se.decodeXMLStrict = se.decodeHTML5Strict = se.decodeHTML4Strict = se.decodeHTML5 = se.decodeHTML4 = se.decodeHTMLStrict = se.decodeHTML =
  se.decodeXML = se.encodeHTML5 = se.encodeHTML4 = se.escapeUTF8 = se.escape = se.encodeNonAsciiHTML = se.encodeHTML = se.encodeXML = se.encode =
  se.decodeStrict = se.decode = void 0;
  var sb = JS(), AV = QS();
  function lxe(e, t) {
    return (!t || t <= 0 ? sb.decodeXML : sb.decodeHTML)(e);
  }
  o(lxe, "decode");
  se.decode = lxe;
  function uxe(e, t) {
    return (!t || t <= 0 ? sb.decodeXML : sb.decodeHTMLStrict)(e);
  }
  o(uxe, "decodeStrict");
  se.decodeStrict = uxe;
  function cxe(e, t) {
    return (!t || t <= 0 ? AV.encodeXML : AV.encodeHTML)(e);
  }
  o(cxe, "encode");
  se.encode = cxe;
  var mo = QS();
  Object.defineProperty(se, "encodeXML", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.encodeXML;
  }, "get") });
  Object.defineProperty(se, "encodeHTML", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.encodeHTML;
  }, "get") });
  Object.defineProperty(se, "encodeNonAsciiHTML", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.encodeNonAsciiHTML;
  }, "get") });
  Object.defineProperty(se, "escape", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.escape;
  }, "get") });
  Object.defineProperty(se, "escapeUTF8", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.escapeUTF8;
  }, "get") });
  Object.defineProperty(se, "encodeHTML4", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.encodeHTML;
  }, "get") });
  Object.defineProperty(se, "encodeHTML5", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return mo.encodeHTML;
  }, "get") });
  var Rn = JS();
  Object.defineProperty(se, "decodeXML", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeXML;
  }, "get") });
  Object.defineProperty(se, "decodeHTML", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeHTML;
  }, "get") });
  Object.defineProperty(se, "decodeHTMLStrict", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeHTMLStrict;
  }, "get") });
  Object.defineProperty(se, "decodeHTML4", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeHTML;
  }, "get") });
  Object.defineProperty(se, "decodeHTML5", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeHTML;
  }, "get") });
  Object.defineProperty(se, "decodeHTML4Strict", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeHTMLStrict;
  }, "get") });
  Object.defineProperty(se, "decodeHTML5Strict", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeHTMLStrict;
  }, "get") });
  Object.defineProperty(se, "decodeXMLStrict", { enumerable: !0, get: /* @__PURE__ */ o(function() {
    return Rn.decodeXML;
  }, "get") });
});

// ../node_modules/ansi-to-html/lib/ansi_to_html.js
var BV = v((sJe, $V) => {
  "use strict";
  function dxe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  o(dxe, "_classCallCheck");
  function qV(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  o(qV, "_defineProperties");
  function pxe(e, t, r) {
    return t && qV(e.prototype, t), r && qV(e, r), e;
  }
  o(pxe, "_createClass");
  function FV(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = fxe(e)) || t && e && typeof e.length == "number") {
        r && (e = r);
        var n = 0, i = /* @__PURE__ */ o(function() {
        }, "F");
        return { s: i, n: /* @__PURE__ */ o(function() {
          return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        }, "n"), e: /* @__PURE__ */ o(function(c) {
          throw c;
        }, "e"), f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = !0, a = !1, l;
    return { s: /* @__PURE__ */ o(function() {
      r = r.call(e);
    }, "s"), n: /* @__PURE__ */ o(function() {
      var c = r.next();
      return s = c.done, c;
    }, "n"), e: /* @__PURE__ */ o(function(c) {
      a = !0, l = c;
    }, "e"), f: /* @__PURE__ */ o(function() {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }, "f") };
  }
  o(FV, "_createForOfIteratorHelper");
  function fxe(e, t) {
    if (e) {
      if (typeof e == "string") return IV(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return IV(e, t);
    }
  }
  o(fxe, "_unsupportedIterableToArray");
  function IV(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  o(IV, "_arrayLikeToArray");
  var mxe = OV(), MV = {
    fg: "#FFF",
    bg: "#000",
    newline: !1,
    escapeXML: !1,
    stream: !1,
    colors: hxe()
  };
  function hxe() {
    var e = {
      0: "#000",
      1: "#A00",
      2: "#0A0",
      3: "#A50",
      4: "#00A",
      5: "#A0A",
      6: "#0AA",
      7: "#AAA",
      8: "#555",
      9: "#F55",
      10: "#5F5",
      11: "#FF5",
      12: "#55F",
      13: "#F5F",
      14: "#5FF",
      15: "#FFF"
    };
    return ab(0, 5).forEach(function(t) {
      ab(0, 5).forEach(function(r) {
        ab(0, 5).forEach(function(n) {
          return yxe(t, r, n, e);
        });
      });
    }), ab(0, 23).forEach(function(t) {
      var r = t + 232, n = kV(t * 10 + 8);
      e[r] = "#" + n + n + n;
    }), e;
  }
  o(hxe, "getDefaultColors");
  function yxe(e, t, r, n) {
    var i = 16 + e * 36 + t * 6 + r, s = e > 0 ? e * 40 + 55 : 0, a = t > 0 ? t * 40 + 55 : 0, l = r > 0 ? r * 40 + 55 : 0;
    n[i] = bxe([s, a, l]);
  }
  o(yxe, "setStyleColor");
  function kV(e) {
    for (var t = e.toString(16); t.length < 2; )
      t = "0" + t;
    return t;
  }
  o(kV, "toHexString");
  function bxe(e) {
    var t = [], r = FV(e), n;
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i = n.value;
        t.push(kV(i));
      }
    } catch (s) {
      r.e(s);
    } finally {
      r.f();
    }
    return "#" + t.join("");
  }
  o(bxe, "toColorHexString");
  function NV(e, t, r, n) {
    var i;
    return t === "text" ? i = Txe(r, n) : t === "display" ? i = vxe(e, r, n) : t === "xterm256Foreground" ? i = ub(e, n.colors[r]) : t === "\
xterm256Background" ? i = cb(e, n.colors[r]) : t === "rgb" && (i = gxe(e, r)), i;
  }
  o(NV, "generateOutput");
  function gxe(e, t) {
    t = t.substring(2).slice(0, -1);
    var r = +t.substr(0, 2), n = t.substring(5).split(";"), i = n.map(function(s) {
      return ("0" + Number(s).toString(16)).substr(-2);
    }).join("");
    return lb(e, (r === 38 ? "color:#" : "background-color:#") + i);
  }
  o(gxe, "handleRgb");
  function vxe(e, t, r) {
    t = parseInt(t, 10);
    var n = {
      "-1": /* @__PURE__ */ o(function() {
        return "<br/>";
      }, "_"),
      0: /* @__PURE__ */ o(function() {
        return e.length && DV(e);
      }, "_"),
      1: /* @__PURE__ */ o(function() {
        return wn(e, "b");
      }, "_"),
      3: /* @__PURE__ */ o(function() {
        return wn(e, "i");
      }, "_"),
      4: /* @__PURE__ */ o(function() {
        return wn(e, "u");
      }, "_"),
      8: /* @__PURE__ */ o(function() {
        return lb(e, "display:none");
      }, "_"),
      9: /* @__PURE__ */ o(function() {
        return wn(e, "strike");
      }, "_"),
      22: /* @__PURE__ */ o(function() {
        return lb(e, "font-weight:normal;text-decoration:none;font-style:normal");
      }, "_"),
      23: /* @__PURE__ */ o(function() {
        return LV(e, "i");
      }, "_"),
      24: /* @__PURE__ */ o(function() {
        return LV(e, "u");
      }, "_"),
      39: /* @__PURE__ */ o(function() {
        return ub(e, r.fg);
      }, "_"),
      49: /* @__PURE__ */ o(function() {
        return cb(e, r.bg);
      }, "_"),
      53: /* @__PURE__ */ o(function() {
        return lb(e, "text-decoration:overline");
      }, "_")
    }, i;
    return n[t] ? i = n[t]() : 4 < t && t < 7 ? i = wn(e, "blink") : 29 < t && t < 38 ? i = ub(e, r.colors[t - 30]) : 39 < t && t < 48 ? i =
    cb(e, r.colors[t - 40]) : 89 < t && t < 98 ? i = ub(e, r.colors[8 + (t - 90)]) : 99 < t && t < 108 && (i = cb(e, r.colors[8 + (t - 100)])),
    i;
  }
  o(vxe, "handleDisplay");
  function DV(e) {
    var t = e.slice(0);
    return e.length = 0, t.reverse().map(function(r) {
      return "</" + r + ">";
    }).join("");
  }
  o(DV, "resetStyles");
  function ab(e, t) {
    for (var r = [], n = e; n <= t; n++)
      r.push(n);
    return r;
  }
  o(ab, "range");
  function Exe(e) {
    return function(t) {
      return (e === null || t.category !== e) && e !== "all";
    };
  }
  o(Exe, "notCategory");
  function jV(e) {
    e = parseInt(e, 10);
    var t = null;
    return e === 0 ? t = "all" : e === 1 ? t = "bold" : 2 < e && e < 5 ? t = "underline" : 4 < e && e < 7 ? t = "blink" : e === 8 ? t = "hid\
e" : e === 9 ? t = "strike" : 29 < e && e < 38 || e === 39 || 89 < e && e < 98 ? t = "foreground-color" : (39 < e && e < 48 || e === 49 || 99 <
    e && e < 108) && (t = "background-color"), t;
  }
  o(jV, "categoryForCode");
  function Txe(e, t) {
    return t.escapeXML ? mxe.encodeXML(e) : e;
  }
  o(Txe, "pushText");
  function wn(e, t, r) {
    return r || (r = ""), e.push(t), "<".concat(t).concat(r ? ' style="'.concat(r, '"') : "", ">");
  }
  o(wn, "pushTag");
  function lb(e, t) {
    return wn(e, "span", t);
  }
  o(lb, "pushStyle");
  function ub(e, t) {
    return wn(e, "span", "color:" + t);
  }
  o(ub, "pushForegroundColor");
  function cb(e, t) {
    return wn(e, "span", "background-color:" + t);
  }
  o(cb, "pushBackgroundColor");
  function LV(e, t) {
    var r;
    if (e.slice(-1)[0] === t && (r = e.pop()), r)
      return "</" + t + ">";
  }
  o(LV, "closeTag");
  function _xe(e, t, r) {
    var n = !1, i = 3;
    function s() {
      return "";
    }
    o(s, "remove");
    function a(R, C) {
      return r("xterm256Foreground", C), "";
    }
    o(a, "removeXterm256Foreground");
    function l(R, C) {
      return r("xterm256Background", C), "";
    }
    o(l, "removeXterm256Background");
    function u(R) {
      return t.newline ? r("display", -1) : r("text", R), "";
    }
    o(u, "newline");
    function c(R, C) {
      n = !0, C.trim().length === 0 && (C = "0"), C = C.trimRight(";").split(";");
      var w = FV(C), P;
      try {
        for (w.s(); !(P = w.n()).done; ) {
          var O = P.value;
          r("display", O);
        }
      } catch (D) {
        w.e(D);
      } finally {
        w.f();
      }
      return "";
    }
    o(c, "ansiMess");
    function d(R) {
      return r("text", R), "";
    }
    o(d, "realText");
    function p(R) {
      return r("rgb", R), "";
    }
    o(p, "rgb");
    var y = [{
      pattern: /^\x08+/,
      sub: s
    }, {
      pattern: /^\x1b\[[012]?K/,
      sub: s
    }, {
      pattern: /^\x1b\[\(B/,
      sub: s
    }, {
      pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/,
      sub: p
    }, {
      pattern: /^\x1b\[38;5;(\d+)m/,
      sub: a
    }, {
      pattern: /^\x1b\[48;5;(\d+)m/,
      sub: l
    }, {
      pattern: /^\n/,
      sub: u
    }, {
      pattern: /^\r+\n/,
      sub: u
    }, {
      pattern: /^\r/,
      sub: u
    }, {
      pattern: /^\x1b\[((?:\d{1,3};?)+|)m/,
      sub: c
    }, {
      // CSI n J
      // ED - Erase in Display Clears part of the screen.
      // If n is 0 (or missing), clear from cursor to end of screen.
      // If n is 1, clear from cursor to beginning of the screen.
      // If n is 2, clear entire screen (and moves cursor to upper left on DOS ANSI.SYS).
      // If n is 3, clear entire screen and delete all lines saved in the scrollback buffer
      //   (this feature was added for xterm and is supported by other terminal applications).
      pattern: /^\x1b\[\d?J/,
      sub: s
    }, {
      // CSI n ; m f
      // HVP - Horizontal Vertical Position Same as CUP
      pattern: /^\x1b\[\d{0,3};\d{0,3}f/,
      sub: s
    }, {
      // catch-all for CSI sequences?
      pattern: /^\x1b\[?[\d;]{0,3}/,
      sub: s
    }, {
      /**
       * extracts real text - not containing:
       * - `\x1b' - ESC - escape (Ascii 27)
       * - '\x08' - BS - backspace (Ascii 8)
       * - `\n` - Newline - linefeed (LF) (ascii 10)
       * - `\r` - Windows Carriage Return (CR)
       */
      pattern: /^(([^\x1b\x08\r\n])+)/,
      sub: d
    }];
    function f(R, C) {
      C > i && n || (n = !1, e = e.replace(R.pattern, R.sub));
    }
    o(f, "process");
    var m = [], h = e, b = h.length;
    e: for (; b > 0; ) {
      for (var g = 0, T = 0, _ = y.length; T < _; g = ++T) {
        var E = y[g];
        if (f(E, g), e.length !== b) {
          b = e.length;
          continue e;
        }
      }
      if (e.length === b)
        break;
      m.push(0), b = e.length;
    }
    return m;
  }
  o(_xe, "tokenize");
  function Rxe(e, t, r) {
    return t !== "text" && (e = e.filter(Exe(jV(r))), e.push({
      token: t,
      data: r,
      category: jV(r)
    })), e;
  }
  o(Rxe, "updateStickyStack");
  var wxe = /* @__PURE__ */ function() {
    function e(t) {
      dxe(this, e), t = t || {}, t.colors && (t.colors = Object.assign({}, MV.colors, t.colors)), this.options = Object.assign({}, MV, t), this.
      stack = [], this.stickyStack = [];
    }
    return o(e, "Filter"), pxe(e, [{
      key: "toHtml",
      value: /* @__PURE__ */ o(function(r) {
        var n = this;
        r = typeof r == "string" ? [r] : r;
        var i = this.stack, s = this.options, a = [];
        return this.stickyStack.forEach(function(l) {
          var u = NV(i, l.token, l.data, s);
          u && a.push(u);
        }), _xe(r.join(""), s, function(l, u) {
          var c = NV(i, l, u, s);
          c && a.push(c), s.stream && (n.stickyStack = Rxe(n.stickyStack, l, u));
        }), i.length && a.push(DV(i)), a.join("");
      }, "toHtml")
    }]), e;
  }();
  $V.exports = wxe;
});

// ../node_modules/browser-dtector/browser-dtector.umd.min.js
var ez = v((ax, lx) => {
  (function(e, t) {
    typeof ax == "object" && typeof lx < "u" ? lx.exports = t() : typeof define == "function" && define.amd ? define(t) : (e = typeof globalThis <
    "u" ? globalThis : e || self).BrowserDetector = t();
  })(ax, function() {
    "use strict";
    function e(a, l) {
      for (var u = 0; u < l.length; u++) {
        var c = l[u];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, (d = c.key, p = void 0,
        typeof (p = function(y, f) {
          if (typeof y != "object" || y === null) return y;
          var m = y[Symbol.toPrimitive];
          if (m !== void 0) {
            var h = m.call(y, f || "default");
            if (typeof h != "object") return h;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (f === "string" ? String : Number)(y);
        }(d, "string")) == "symbol" ? p : String(p)), c);
      }
      var d, p;
    }
    o(e, "e");
    var t = { chrome: "Google Chrome", brave: "Brave", crios: "Google Chrome", edge: "Microsoft Edge", edg: "Microsoft Edge", edgios: "Micro\
soft Edge", fennec: "Mozilla Firefox", jsdom: "JsDOM", mozilla: "Mozilla Firefox", fxios: "Mozilla Firefox", msie: "Microsoft Internet Explo\
rer", opera: "Opera", opios: "Opera", opr: "Opera", opt: "Opera", rv: "Microsoft Internet Explorer", safari: "Safari", samsungbrowser: "Sams\
ung Browser", electron: "Electron" }, r = { android: "Android", androidTablet: "Android Tablet", cros: "Chrome OS", fennec: "Android Tablet",
    ipad: "IPad", iphone: "IPhone", jsdom: "JsDOM", linux: "Linux", mac: "Macintosh", tablet: "Android Tablet", win: "Windows", "windows pho\
ne": "Windows Phone", xbox: "Microsoft Xbox" }, n = /* @__PURE__ */ o(function(a) {
      var l = new RegExp("^-?\\d+(?:.\\d{0,".concat(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, "})?")), u = Number(
      a).toString().match(l);
      return u ? u[0] : null;
    }, "n"), i = /* @__PURE__ */ o(function() {
      return typeof window < "u" ? window.navigator : null;
    }, "i"), s = function() {
      function a(d) {
        var p;
        (function(y, f) {
          if (!(y instanceof f)) throw new TypeError("Cannot call a class as a function");
        })(this, a), this.userAgent = d || ((p = i()) === null || p === void 0 ? void 0 : p.userAgent) || null;
      }
      o(a, "t");
      var l, u, c;
      return l = a, u = [{ key: "parseUserAgent", value: /* @__PURE__ */ o(function(d) {
        var p, y, f, m = {}, h = d || this.userAgent || "", b = h.toLowerCase().replace(/\s\s+/g, " "), g = /(edge)\/([\w.]+)/.exec(b) || /(edg)[/]([\w.]+)/.
        exec(b) || /(opr)[/]([\w.]+)/.exec(b) || /(opt)[/]([\w.]+)/.exec(b) || /(fxios)[/]([\w.]+)/.exec(b) || /(edgios)[/]([\w.]+)/.exec(b) ||
        /(jsdom)[/]([\w.]+)/.exec(b) || /(samsungbrowser)[/]([\w.]+)/.exec(b) || /(electron)[/]([\w.]+)/.exec(b) || /(chrome)[/]([\w.]+)/.exec(
        b) || /(crios)[/]([\w.]+)/.exec(b) || /(opios)[/]([\w.]+)/.exec(b) || /(version)(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(
        b) || /(webkit)[/]([\w.]+).*(version)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(b) || /(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(
        b) || /(webkit)[/]([\w.]+)/.exec(b) || /(opera)(?:.*version|)[/]([\w.]+)/.exec(b) || /(msie) ([\w.]+)/.exec(b) || /(fennec)[/]([\w.]+)/.
        exec(b) || b.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(b) || b.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.
        exec(b) || [], T = /(ipad)/.exec(b) || /(ipod)/.exec(b) || /(iphone)/.exec(b) || /(jsdom)/.exec(b) || /(windows phone)/.exec(b) || /(xbox)/.
        exec(b) || /(win)/.exec(b) || /(tablet)/.exec(b) || /(android)/.test(b) && /(mobile)/.test(b) === !1 && ["androidTablet"] || /(android)/.
        exec(b) || /(mac)/.exec(b) || /(linux)/.exec(b) || /(cros)/.exec(b) || [], _ = g[5] || g[3] || g[1] || null, E = T[0] || null, R = g[4] ||
        g[2] || null, C = i();
        _ === "chrome" && typeof (C == null || (p = C.brave) === null || p === void 0 ? void 0 : p.isBrave) == "function" && (_ = "brave"), _ &&
        (m[_] = !0), E && (m[E] = !0);
        var w = !!(m.tablet || m.android || m.androidTablet), P = !!(m.ipad || m.tablet || m.androidTablet), O = !!(m.android || m.androidTablet ||
        m.tablet || m.ipad || m.ipod || m.iphone || m["windows phone"]), D = !!(m.cros || m.mac || m.linux || m.win), A = !!(m.brave || m.chrome ||
        m.crios || m.opr || m.safari || m.edg || m.electron), L = !!(m.msie || m.rv);
        return { name: (y = t[_]) !== null && y !== void 0 ? y : null, platform: (f = r[E]) !== null && f !== void 0 ? f : null, userAgent: h,
        version: R, shortVersion: R ? n(parseFloat(R), 2) : null, isAndroid: w, isTablet: P, isMobile: O, isDesktop: D, isWebkit: A, isIE: L };
      }, "value") }, { key: "getBrowserInfo", value: /* @__PURE__ */ o(function() {
        var d = this.parseUserAgent();
        return { name: d.name, platform: d.platform, userAgent: d.userAgent, version: d.version, shortVersion: d.shortVersion };
      }, "value") }], c = [{ key: "VERSION", get: /* @__PURE__ */ o(function() {
        return "3.4.0";
      }, "get") }], u && e(l.prototype, u), c && e(l, c), Object.defineProperty(l, "prototype", { writable: !1 }), a;
    }();
    return s;
  });
});

// src/core-events/index.ts
var To = {};
ft(To, {
  ARGTYPES_INFO_REQUEST: () => Ib,
  ARGTYPES_INFO_RESPONSE: () => sl,
  CHANNEL_CREATED: () => dz,
  CHANNEL_WS_DISCONNECT: () => mb,
  CONFIG_ERROR: () => hb,
  CREATE_NEW_STORYFILE_REQUEST: () => pz,
  CREATE_NEW_STORYFILE_RESPONSE: () => fz,
  CURRENT_STORY_WAS_SET: () => nl,
  DOCS_PREPARED: () => yb,
  DOCS_RENDERED: () => $i,
  FILE_COMPONENT_SEARCH_REQUEST: () => mz,
  FILE_COMPONENT_SEARCH_RESPONSE: () => hz,
  FORCE_REMOUNT: () => vo,
  FORCE_RE_RENDER: () => Bi,
  GLOBALS_UPDATED: () => Sn,
  NAVIGATE_URL: () => yz,
  PLAY_FUNCTION_THREW_EXCEPTION: () => bb,
  PRELOAD_ENTRIES: () => vb,
  PREVIEW_BUILDER_PROGRESS: () => bz,
  PREVIEW_KEYDOWN: () => Eb,
  REGISTER_SUBSCRIPTION: () => gz,
  REQUEST_WHATS_NEW_DATA: () => Az,
  RESET_STORY_ARGS: () => Ui,
  RESULT_WHATS_NEW_DATA: () => Oz,
  SAVE_STORY_REQUEST: () => Mz,
  SAVE_STORY_RESPONSE: () => Nz,
  SELECT_STORY: () => vz,
  SET_CONFIG: () => Ez,
  SET_CURRENT_STORY: () => Hi,
  SET_FILTER: () => Tz,
  SET_GLOBALS: () => Tb,
  SET_INDEX: () => _z,
  SET_STORIES: () => Rz,
  SET_WHATS_NEW_CACHE: () => qz,
  SHARED_STATE_CHANGED: () => wz,
  SHARED_STATE_SET: () => Sz,
  STORIES_COLLAPSE_ALL: () => xz,
  STORIES_EXPAND_ALL: () => Cz,
  STORY_ARGS_UPDATED: () => _b,
  STORY_CHANGED: () => Rb,
  STORY_ERRORED: () => wb,
  STORY_FINISHED: () => il,
  STORY_HOT_UPDATED: () => Pz,
  STORY_INDEX_INVALIDATED: () => Sb,
  STORY_MISSING: () => ol,
  STORY_PREPARED: () => xb,
  STORY_RENDERED: () => Eo,
  STORY_RENDER_PHASE_CHANGED: () => Ut,
  STORY_SPECIFIED: () => Cb,
  STORY_THREW_EXCEPTION: () => Pb,
  STORY_UNCHANGED: () => Ab,
  TELEMETRY_ERROR: () => qb,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: () => Iz,
  UNHANDLED_ERRORS_WHILE_PLAYING: () => gb,
  UPDATE_GLOBALS: () => Vi,
  UPDATE_QUERY_PARAMS: () => Ob,
  UPDATE_STORY_ARGS: () => zi,
  default: () => cz
});
var fb = /* @__PURE__ */ ((W) => (W.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", W.CHANNEL_CREATED = "channelCreated", W.CONFIG_ERROR = "c\
onfigError", W.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", W.STORY_SPECIFIED = "storySpecified", W.SET_CONFIG = "setConfig", W.SET_STORIES =
"setStories", W.SET_INDEX = "setIndex", W.SET_CURRENT_STORY = "setCurrentStory", W.CURRENT_STORY_WAS_SET = "currentStoryWasSet", W.FORCE_RE_RENDER =
"forceReRender", W.FORCE_REMOUNT = "forceRemount", W.PRELOAD_ENTRIES = "preloadStories", W.STORY_PREPARED = "storyPrepared", W.DOCS_PREPARED =
"docsPrepared", W.STORY_CHANGED = "storyChanged", W.STORY_UNCHANGED = "storyUnchanged", W.STORY_RENDERED = "storyRendered", W.STORY_FINISHED =
"storyFinished", W.STORY_MISSING = "storyMissing", W.STORY_ERRORED = "storyErrored", W.STORY_THREW_EXCEPTION = "storyThrewException", W.STORY_RENDER_PHASE_CHANGED =
"storyRenderPhaseChanged", W.STORY_HOT_UPDATED = "storyHotUpdated", W.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", W.UNHANDLED_ERRORS_WHILE_PLAYING =
"unhandledErrorsWhilePlaying", W.UPDATE_STORY_ARGS = "updateStoryArgs", W.STORY_ARGS_UPDATED = "storyArgsUpdated", W.RESET_STORY_ARGS = "res\
etStoryArgs", W.SET_FILTER = "setFilter", W.SET_GLOBALS = "setGlobals", W.UPDATE_GLOBALS = "updateGlobals", W.GLOBALS_UPDATED = "globalsUpda\
ted", W.REGISTER_SUBSCRIPTION = "registerSubscription", W.PREVIEW_KEYDOWN = "previewKeydown", W.PREVIEW_BUILDER_PROGRESS = "preview_builder_\
progress", W.SELECT_STORY = "selectStory", W.STORIES_COLLAPSE_ALL = "storiesCollapseAll", W.STORIES_EXPAND_ALL = "storiesExpandAll", W.DOCS_RENDERED =
"docsRendered", W.SHARED_STATE_CHANGED = "sharedStateChanged", W.SHARED_STATE_SET = "sharedStateSet", W.NAVIGATE_URL = "navigateUrl", W.UPDATE_QUERY_PARAMS =
"updateQueryParams", W.REQUEST_WHATS_NEW_DATA = "requestWhatsNewData", W.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", W.SET_WHATS_NEW_CACHE =
"setWhatsNewCache", W.TOGGLE_WHATS_NEW_NOTIFICATIONS = "toggleWhatsNewNotifications", W.TELEMETRY_ERROR = "telemetryError", W.FILE_COMPONENT_SEARCH_REQUEST =
"fileComponentSearchRequest", W.FILE_COMPONENT_SEARCH_RESPONSE = "fileComponentSearchResponse", W.SAVE_STORY_REQUEST = "saveStoryRequest", W.
SAVE_STORY_RESPONSE = "saveStoryResponse", W.ARGTYPES_INFO_REQUEST = "argtypesInfoRequest", W.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse",
W.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", W.CREATE_NEW_STORYFILE_RESPONSE = "createNewStoryfileResponse", W))(fb || {}),
cz = fb, {
  CHANNEL_WS_DISCONNECT: mb,
  CHANNEL_CREATED: dz,
  CONFIG_ERROR: hb,
  CREATE_NEW_STORYFILE_REQUEST: pz,
  CREATE_NEW_STORYFILE_RESPONSE: fz,
  CURRENT_STORY_WAS_SET: nl,
  DOCS_PREPARED: yb,
  DOCS_RENDERED: $i,
  FILE_COMPONENT_SEARCH_REQUEST: mz,
  FILE_COMPONENT_SEARCH_RESPONSE: hz,
  FORCE_RE_RENDER: Bi,
  FORCE_REMOUNT: vo,
  GLOBALS_UPDATED: Sn,
  NAVIGATE_URL: yz,
  PLAY_FUNCTION_THREW_EXCEPTION: bb,
  UNHANDLED_ERRORS_WHILE_PLAYING: gb,
  PRELOAD_ENTRIES: vb,
  PREVIEW_BUILDER_PROGRESS: bz,
  PREVIEW_KEYDOWN: Eb,
  REGISTER_SUBSCRIPTION: gz,
  RESET_STORY_ARGS: Ui,
  SELECT_STORY: vz,
  SET_CONFIG: Ez,
  SET_CURRENT_STORY: Hi,
  SET_FILTER: Tz,
  SET_GLOBALS: Tb,
  SET_INDEX: _z,
  SET_STORIES: Rz,
  SHARED_STATE_CHANGED: wz,
  SHARED_STATE_SET: Sz,
  STORIES_COLLAPSE_ALL: xz,
  STORIES_EXPAND_ALL: Cz,
  STORY_ARGS_UPDATED: _b,
  STORY_CHANGED: Rb,
  STORY_ERRORED: wb,
  STORY_INDEX_INVALIDATED: Sb,
  STORY_MISSING: ol,
  STORY_PREPARED: xb,
  STORY_RENDER_PHASE_CHANGED: Ut,
  STORY_RENDERED: Eo,
  STORY_FINISHED: il,
  STORY_SPECIFIED: Cb,
  STORY_THREW_EXCEPTION: Pb,
  STORY_UNCHANGED: Ab,
  STORY_HOT_UPDATED: Pz,
  UPDATE_GLOBALS: Vi,
  UPDATE_QUERY_PARAMS: Ob,
  UPDATE_STORY_ARGS: zi,
  REQUEST_WHATS_NEW_DATA: Az,
  RESULT_WHATS_NEW_DATA: Oz,
  SET_WHATS_NEW_CACHE: qz,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: Iz,
  TELEMETRY_ERROR: qb,
  SAVE_STORY_REQUEST: Mz,
  SAVE_STORY_RESPONSE: Nz,
  ARGTYPES_INFO_REQUEST: Ib,
  ARGTYPES_INFO_RESPONSE: sl
} = fb;

// ../node_modules/@storybook/global/dist/index.mjs
var Mb = {};
ft(Mb, {
  global: () => k
});
var k = (() => {
  let e;
  return typeof window < "u" ? e = window : typeof globalThis < "u" ? e = globalThis : typeof global < "u" ? e = global : typeof self < "u" ?
  e = self : e = {}, e;
})();

// src/preview/globals/globals.ts
var Nb = {
  "@storybook/global": "__STORYBOOK_MODULE_GLOBAL__",
  "storybook/test": "__STORYBOOK_MODULE_TEST__",
  "storybook/actions": "__STORYBOOK_MODULE_ACTIONS__",
  "storybook/preview-api": "__STORYBOOK_MODULE_PREVIEW_API__",
  "storybook/internal/channels": "__STORYBOOK_MODULE_CHANNELS__",
  "storybook/internal/client-logger": "__STORYBOOK_MODULE_CLIENT_LOGGER__",
  "storybook/internal/core-events": "__STORYBOOK_MODULE_CORE_EVENTS__",
  "storybook/internal/preview-errors": "__STORYBOOK_MODULE_CORE_EVENTS_PREVIEW_ERRORS__",
  "storybook/internal/types": "__STORYBOOK_MODULE_TYPES__",
  // @deprecated TODO: Remove in 9.1
  "storybook/internal/preview-api": "__STORYBOOK_MODULE_PREVIEW_API__"
}, dx = Object.keys(Nb);

// src/channels/index.ts
var rg = {};
ft(rg, {
  Channel: () => Fr,
  HEARTBEAT_INTERVAL: () => Qb,
  HEARTBEAT_MAX_LATENCY: () => eg,
  PostMessageTransport: () => Po,
  WebsocketTransport: () => Ao,
  createBrowserChannel: () => Y4,
  default: () => G4
});

// ../node_modules/ts-dedent/esm/index.js
function ee(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  var n = Array.from(typeof e == "string" ? [e] : e);
  n[n.length - 1] = n[n.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var i = n.reduce(function(l, u) {
    var c = u.match(/\n([\t ]+|(?!\s).)/g);
    return c ? l.concat(c.map(function(d) {
      var p, y;
      return (y = (p = d.match(/[\t ]/g)) === null || p === void 0 ? void 0 : p.length) !== null && y !== void 0 ? y : 0;
    })) : l;
  }, []);
  if (i.length) {
    var s = new RegExp(`
[	 ]{` + Math.min.apply(Math, i) + "}", "g");
    n = n.map(function(l) {
      return l.replace(s, `
`);
    });
  }
  n[0] = n[0].replace(/^\r?\n/, "");
  var a = n[0];
  return t.forEach(function(l, u) {
    var c = a.match(/(?:^|\n)( *)$/), d = c ? c[1] : "", p = l;
    typeof l == "string" && l.includes(`
`) && (p = String(l).split(`
`).map(function(y, f) {
      return f === 0 ? y : "" + d + y;
    }).join(`
`)), a += p + n[u + 1];
  }), a;
}
o(ee, "dedent");
var px = ee;

// src/shared/universal-store/instances.ts
var jb = /* @__PURE__ */ new Map();

// src/shared/universal-store/index.ts
var jz = "UNIVERSAL_STORE:", Ot = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
  REJECTED: "REJECTED"
}, Z = class Z {
  constructor(t, r) {
    /** Enable debug logs for this store */
    this.debugging = !1;
    // TODO: narrow type of listeners based on event type
    this.listeners = /* @__PURE__ */ new Map([["*", /* @__PURE__ */ new Set()]]);
    /** Gets the current state */
    this.getState = /* @__PURE__ */ o(() => (this.debug("getState", { state: this.state }), this.state), "getState");
    /**
     * Subscribes to store events
     *
     * @returns A function to unsubscribe
     */
    this.subscribe = /* @__PURE__ */ o((t, r) => {
      let n = typeof t == "function", i = n ? "*" : t, s = n ? t : r;
      if (this.debug("subscribe", { eventType: i, listener: s }), !s)
        throw new TypeError(
          `Missing first subscribe argument, or second if first is the event type, when subscribing to a UniversalStore with id '${this.id}'`
        );
      return this.listeners.has(i) || this.listeners.set(i, /* @__PURE__ */ new Set()), this.listeners.get(i).add(s), () => {
        this.debug("unsubscribe", { eventType: i, listener: s }), this.listeners.has(i) && (this.listeners.get(i).delete(s), this.listeners.
        get(i)?.size === 0 && this.listeners.delete(i));
      };
    }, "subscribe");
    /** Sends a custom event to the other stores */
    this.send = /* @__PURE__ */ o((t) => {
      if (this.debug("send", { event: t }), this.status !== Z.Status.READY)
        throw new TypeError(
          ee`Cannot send event before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify(
            {
              event: t,
              id: this.id,
              actor: this.actor,
              environment: this.environment
            },
            null,
            2
          )}`
        );
      this.emitToListeners(t, { actor: this.actor }), this.emitToChannel(t, { actor: this.actor });
    }, "send");
    if (this.debugging = t.debug ?? !1, !Z.isInternalConstructing)
      throw new TypeError(
        "UniversalStore is not constructable - use UniversalStore.create() instead"
      );
    if (Z.isInternalConstructing = !1, this.id = t.id, this.actorId = Date.now().toString(36) + Math.random().toString(36).substring(2), this.
    actorType = t.leader ? Z.ActorType.LEADER : Z.ActorType.FOLLOWER, this.state = t.initialState, this.channelEventName = `${jz}${this.id}`,
    this.debug("constructor", {
      options: t,
      environmentOverrides: r,
      channelEventName: this.channelEventName
    }), this.actor.type === Z.ActorType.LEADER)
      this.syncing = {
        state: Ot.RESOLVED,
        promise: Promise.resolve()
      };
    else {
      let n, i, s = new Promise((a, l) => {
        n = /* @__PURE__ */ o(() => {
          this.syncing.state === Ot.PENDING && (this.syncing.state = Ot.RESOLVED, a());
        }, "syncingResolve"), i = /* @__PURE__ */ o((u) => {
          this.syncing.state === Ot.PENDING && (this.syncing.state = Ot.REJECTED, l(u));
        }, "syncingReject");
      });
      this.syncing = {
        state: Ot.PENDING,
        promise: s,
        resolve: n,
        reject: i
      };
    }
    this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.subscribe = this.subscribe.bind(this), this.onStateChange =
    this.onStateChange.bind(this), this.send = this.send.bind(this), this.emitToChannel = this.emitToChannel.bind(this), this.prepareThis = this.
    prepareThis.bind(this), this.emitToListeners = this.emitToListeners.bind(this), this.handleChannelEvents = this.handleChannelEvents.bind(
    this), this.debug = this.debug.bind(this), this.channel = r?.channel ?? Z.preparation.channel, this.environment = r?.environment ?? Z.preparation.
    environment, this.channel && this.environment ? (Z.preparation.resolve({ channel: this.channel, environment: this.environment }), this.prepareThis(
    { channel: this.channel, environment: this.environment })) : Z.preparation.promise.then(this.prepareThis);
  }
  static setupPreparationPromise() {
    let t, r, n = new Promise(
      (i, s) => {
        t = /* @__PURE__ */ o((a) => {
          i(a);
        }, "resolveRef"), r = /* @__PURE__ */ o((...a) => {
          s(a);
        }, "rejectRef");
      }
    );
    Z.preparation = {
      resolve: t,
      reject: r,
      promise: n
    };
  }
  /** The actor object representing the store instance with a unique ID and a type */
  get actor() {
    return Object.freeze({
      id: this.actorId,
      type: this.actorType,
      environment: this.environment ?? Z.Environment.UNKNOWN
    });
  }
  /**
   * The current state of the store, that signals both if the store is prepared by Storybook and
   * also - in the case of a follower - if the state has been synced with the leader's state.
   */
  get status() {
    if (!this.channel || !this.environment)
      return Z.Status.UNPREPARED;
    switch (this.syncing?.state) {
      case Ot.PENDING:
      case void 0:
        return Z.Status.SYNCING;
      case Ot.REJECTED:
        return Z.Status.ERROR;
      case Ot.RESOLVED:
      default:
        return Z.Status.READY;
    }
  }
  /**
   * A promise that resolves when the store is fully ready. A leader will be ready when the store
   * has been prepared by Storybook, which is almost instantly.
   *
   * A follower will be ready when the state has been synced with the leader's state, within a few
   * hundred milliseconds.
   */
  untilReady() {
    return Promise.all([Z.preparation.promise, this.syncing?.promise]);
  }
  /** Creates a new instance of UniversalStore */
  static create(t) {
    if (!t || typeof t?.id != "string")
      throw new TypeError("id is required and must be a string, when creating a UniversalStore");
    t.debug && console.debug(
      ee`[UniversalStore]
        create`,
      { options: t }
    );
    let r = jb.get(t.id);
    if (r)
      return console.warn(ee`UniversalStore with id "${t.id}" already exists in this environment, re-using existing.
        You should reuse the existing instance instead of trying to create a new one.`), r;
    Z.isInternalConstructing = !0;
    let n = new Z(t);
    return jb.set(t.id, n), n;
  }
  /**
   * Used by Storybook to set the channel for all instances of UniversalStore in the given
   * environment.
   *
   * @internal
   */
  static __prepare(t, r) {
    Z.preparation.channel = t, Z.preparation.environment = r, Z.preparation.resolve({ channel: t, environment: r });
  }
  /**
   * Updates the store's state
   *
   * Either a new state or a state updater function can be passed to the method.
   */
  setState(t) {
    let r = this.state, n = typeof t == "function" ? t(r) : t;
    if (this.debug("setState", { newState: n, previousState: r, updater: t }), this.status !== Z.Status.READY)
      throw new TypeError(
        ee`Cannot set state before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify(
          {
            newState: n,
            id: this.id,
            actor: this.actor,
            environment: this.environment
          },
          null,
          2
        )}`
      );
    this.state = n;
    let i = {
      type: Z.InternalEventType.SET_STATE,
      payload: {
        state: n,
        previousState: r
      }
    };
    this.emitToChannel(i, { actor: this.actor }), this.emitToListeners(i, { actor: this.actor });
  }
  /**
   * Subscribes to state changes
   *
   * @returns Unsubscribe function
   */
  onStateChange(t) {
    return this.debug("onStateChange", { listener: t }), this.subscribe(
      Z.InternalEventType.SET_STATE,
      ({ payload: r }, n) => {
        t(r.state, r.previousState, n);
      }
    );
  }
  emitToChannel(t, r) {
    this.debug("emitToChannel", { event: t, eventInfo: r, channel: !!this.channel }), this.channel?.emit(this.channelEventName, {
      event: t,
      eventInfo: r
    });
  }
  prepareThis({
    channel: t,
    environment: r
  }) {
    this.channel = t, this.environment = r, this.debug("prepared", { channel: !!t, environment: r }), this.channel.on(this.channelEventName,
    this.handleChannelEvents), this.actor.type === Z.ActorType.LEADER ? this.emitToChannel(
      { type: Z.InternalEventType.LEADER_CREATED },
      { actor: this.actor }
    ) : (this.emitToChannel(
      { type: Z.InternalEventType.FOLLOWER_CREATED },
      { actor: this.actor }
    ), this.emitToChannel(
      { type: Z.InternalEventType.EXISTING_STATE_REQUEST },
      { actor: this.actor }
    ), setTimeout(() => {
      this.syncing.reject(
        new TypeError(
          `No existing state found for follower with id: '${this.id}'. Make sure a leader with the same id exists before creating a follower\
.`
        )
      );
    }, 1e3));
  }
  emitToListeners(t, r) {
    let n = this.listeners.get(t.type), i = this.listeners.get("*");
    this.debug("emitToListeners", {
      event: t,
      eventInfo: r,
      eventTypeListeners: n,
      everythingListeners: i
    }), [...n ?? [], ...i ?? []].forEach(
      (s) => s(t, r)
    );
  }
  handleChannelEvents(t) {
    let { event: r, eventInfo: n } = t;
    if ([n.actor.id, n.forwardingActor?.id].includes(this.actor.id)) {
      this.debug("handleChannelEvents: Ignoring event from self", { channelEvent: t });
      return;
    } else if (this.syncing?.state === Ot.PENDING && r.type !== Z.InternalEventType.EXISTING_STATE_RESPONSE) {
      this.debug("handleChannelEvents: Ignoring event while syncing", { channelEvent: t });
      return;
    }
    if (this.debug("handleChannelEvents", { channelEvent: t }), this.actor.type === Z.ActorType.LEADER) {
      let i = !0;
      switch (r.type) {
        case Z.InternalEventType.EXISTING_STATE_REQUEST:
          i = !1;
          let s = {
            type: Z.InternalEventType.EXISTING_STATE_RESPONSE,
            payload: this.state
          };
          this.debug("handleChannelEvents: responding to existing state request", {
            responseEvent: s
          }), this.emitToChannel(s, { actor: this.actor }), this.emitToListeners(s, { actor: this.actor });
          break;
        case Z.InternalEventType.LEADER_CREATED:
          i = !1, this.syncing.state = Ot.REJECTED, this.debug("handleChannelEvents: erroring due to second leader being created", {
            event: r
          }), console.error(
            ee`Detected multiple UniversalStore leaders created with the same id "${this.id}".
            Only one leader can exists at a time, your stores are now in an invalid state.
            Leaders detected:
            this: ${JSON.stringify(this.actor, null, 2)}
            other: ${JSON.stringify(n.actor, null, 2)}`
          );
          break;
      }
      i && (this.debug("handleChannelEvents: forwarding event", { channelEvent: t }), this.emitToChannel(r, { actor: n.actor, forwardingActor: this.
      actor }));
    }
    if (this.actor.type === Z.ActorType.FOLLOWER)
      switch (r.type) {
        case Z.InternalEventType.EXISTING_STATE_RESPONSE:
          if (this.debug("handleChannelEvents: Setting state from leader's existing state response", {
            event: r
          }), this.syncing?.state !== Ot.PENDING)
            break;
          this.syncing.resolve?.();
          let i = {
            type: Z.InternalEventType.SET_STATE,
            payload: {
              state: r.payload,
              previousState: this.state
            }
          };
          this.state = r.payload, this.emitToListeners(i, n);
          break;
      }
    switch (r.type) {
      case Z.InternalEventType.SET_STATE:
        this.debug("handleChannelEvents: Setting state", { event: r }), this.state = r.payload.state;
        break;
    }
    this.emitToListeners(r, { actor: n.actor });
  }
  debug(t, r) {
    this.debugging && console.debug(
      ee`[UniversalStore::${this.id}::${this.environment ?? Z.Environment.UNKNOWN}]
        ${t}`,
      JSON.stringify(
        {
          data: r,
          actor: this.actor,
          state: this.state,
          status: this.status
        },
        null,
        2
      )
    );
  }
  /**
   * Used to reset the static fields of the UniversalStore class when cleaning up tests
   *
   * @internal
   */
  static __reset() {
    Z.preparation.reject(new Error("reset")), Z.setupPreparationPromise(), Z.isInternalConstructing = !1;
  }
};
o(Z, "UniversalStore"), /**
 * Defines the possible actor types in the store system
 *
 * @readonly
 */
Z.ActorType = {
  LEADER: "LEADER",
  FOLLOWER: "FOLLOWER"
}, /**
 * Defines the possible environments the store can run in
 *
 * @readonly
 */
Z.Environment = {
  SERVER: "SERVER",
  MANAGER: "MANAGER",
  PREVIEW: "PREVIEW",
  UNKNOWN: "UNKNOWN",
  MOCK: "MOCK"
}, /**
 * Internal event types used for store synchronization
 *
 * @readonly
 */
Z.InternalEventType = {
  EXISTING_STATE_REQUEST: "__EXISTING_STATE_REQUEST",
  EXISTING_STATE_RESPONSE: "__EXISTING_STATE_RESPONSE",
  SET_STATE: "__SET_STATE",
  LEADER_CREATED: "__LEADER_CREATED",
  FOLLOWER_CREATED: "__FOLLOWER_CREATED"
}, Z.Status = {
  UNPREPARED: "UNPREPARED",
  SYNCING: "SYNCING",
  READY: "READY",
  ERROR: "ERROR"
}, // This is used to check if constructor was called from the static factory create()
Z.isInternalConstructing = !1, Z.setupPreparationPromise();
var _o = Z;

// src/channels/main.ts
var Lz = /* @__PURE__ */ o((e) => e.transports !== void 0, "isMulti"), Fz = /* @__PURE__ */ o(() => Math.random().toString(16).slice(2), "ge\
nerateRandomId"), Lb = class Lb {
  constructor(t = {}) {
    this.sender = Fz();
    this.events = {};
    this.data = {};
    this.transports = [];
    this.isAsync = t.async || !1, Lz(t) ? (this.transports = t.transports || [], this.transports.forEach((r) => {
      r.setHandler((n) => this.handleEvent(n));
    })) : this.transports = t.transport ? [t.transport] : [], this.transports.forEach((r) => {
      r.setHandler((n) => this.handleEvent(n));
    });
  }
  get hasTransport() {
    return this.transports.length > 0;
  }
  addListener(t, r) {
    this.events[t] = this.events[t] || [], this.events[t].push(r);
  }
  emit(t, ...r) {
    let n = { type: t, args: r, from: this.sender }, i = {};
    r.length >= 1 && r[0] && r[0].options && (i = r[0].options);
    let s = /* @__PURE__ */ o(() => {
      this.transports.forEach((a) => {
        a.send(n, i);
      }), this.handleEvent(n);
    }, "handler");
    this.isAsync ? setImmediate(s) : s();
  }
  last(t) {
    return this.data[t];
  }
  eventNames() {
    return Object.keys(this.events);
  }
  listenerCount(t) {
    let r = this.listeners(t);
    return r ? r.length : 0;
  }
  listeners(t) {
    return this.events[t] || void 0;
  }
  once(t, r) {
    let n = this.onceListener(t, r);
    this.addListener(t, n);
  }
  removeAllListeners(t) {
    t ? this.events[t] && delete this.events[t] : this.events = {};
  }
  removeListener(t, r) {
    let n = this.listeners(t);
    n && (this.events[t] = n.filter((i) => i !== r));
  }
  on(t, r) {
    this.addListener(t, r);
  }
  off(t, r) {
    this.removeListener(t, r);
  }
  handleEvent(t) {
    let r = this.listeners(t.type);
    r && r.length && r.forEach((n) => {
      n.apply(t, t.args);
    }), this.data[t.type] = t.args;
  }
  onceListener(t, r) {
    let n = /* @__PURE__ */ o((...i) => (this.removeListener(t, n), r(...i)), "onceListener");
    return n;
  }
};
o(Lb, "Channel");
var Fr = Lb;

// src/client-logger/index.ts
var kb = {};
ft(kb, {
  deprecate: () => Gi,
  logger: () => ue,
  once: () => we,
  pretty: () => vt
});
var { LOGLEVEL: kz } = k, kr = {
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
  silent: 10
}, Dz = kz, Ro = kr[Dz] || kr.info, ue = {
  trace: /* @__PURE__ */ o((e, ...t) => {
    Ro <= kr.trace && console.trace(e, ...t);
  }, "trace"),
  debug: /* @__PURE__ */ o((e, ...t) => {
    Ro <= kr.debug && console.debug(e, ...t);
  }, "debug"),
  info: /* @__PURE__ */ o((e, ...t) => {
    Ro <= kr.info && console.info(e, ...t);
  }, "info"),
  warn: /* @__PURE__ */ o((e, ...t) => {
    Ro <= kr.warn && console.warn(e, ...t);
  }, "warn"),
  error: /* @__PURE__ */ o((e, ...t) => {
    Ro <= kr.error && console.error(e, ...t);
  }, "error"),
  log: /* @__PURE__ */ o((e, ...t) => {
    Ro < kr.silent && console.log(e, ...t);
  }, "log")
}, Fb = /* @__PURE__ */ new Set(), we = /* @__PURE__ */ o((e) => (t, ...r) => {
  if (!Fb.has(t))
    return Fb.add(t), ue[e](t, ...r);
}, "once");
we.clear = () => Fb.clear();
we.trace = we("trace");
we.debug = we("debug");
we.info = we("info");
we.warn = we("warn");
we.error = we("error");
we.log = we("log");
var Gi = we("warn"), vt = /* @__PURE__ */ o((e) => (...t) => {
  let r = [];
  if (t.length) {
    let n = /<span\s+style=(['"])([^'"]*)\1\s*>/gi, i = /<\/span>/gi, s;
    for (r.push(t[0].replace(n, "%c").replace(i, "%c")); s = n.exec(t[0]); )
      r.push(s[2]), r.push("");
    for (let a = 1; a < t.length; a++)
      r.push(t[a]);
  }
  ue[e].apply(ue, r);
}, "pretty");
vt.trace = vt("trace");
vt.debug = vt("debug");
vt.info = vt("info");
vt.warn = vt("warn");
vt.error = vt("error");

// ../node_modules/telejson/dist/chunk-EAFQLD22.mjs
var $z = Object.create, fx = Object.defineProperty, Bz = Object.getOwnPropertyDescriptor, mx = Object.getOwnPropertyNames, Uz = Object.getPrototypeOf,
Hz = Object.prototype.hasOwnProperty, ne = /* @__PURE__ */ o((e, t) => /* @__PURE__ */ o(function() {
  return t || (0, e[mx(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, "__require"), "__commonJS"), Vz = /* @__PURE__ */ o((e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let i of mx(t))
      !Hz.call(e, i) && i !== r && fx(e, i, { get: /* @__PURE__ */ o(() => t[i], "get"), enumerable: !(n = Bz(t, i)) || n.enumerable });
  return e;
}, "__copyProps"), al = /* @__PURE__ */ o((e, t, r) => (r = e != null ? $z(Uz(e)) : {}, Vz(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? fx(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), "__toESM"), zz = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
], Gz = ["detail"];
function hx(e) {
  let t = zz.filter((r) => e[r] !== void 0).reduce((r, n) => (r[n] = e[n], r), {});
  if (e instanceof CustomEvent)
    for (let r of Gz.filter(
      (n) => e[n] !== void 0
    ))
      t[r] = e[r];
  return t;
}
o(hx, "extractEventHiddenProperties");

// ../node_modules/telejson/dist/index.mjs
var Tx = ne({
  "node_modules/.pnpm/es-object-atoms@1.1.1/node_modules/es-object-atoms/index.js"(e, t) {
    "use strict";
    t.exports = Object;
  }
}), Yz = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/index.js"(e, t) {
    "use strict";
    t.exports = Error;
  }
}), Wz = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/eval.js"(e, t) {
    "use strict";
    t.exports = EvalError;
  }
}), Kz = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/range.js"(e, t) {
    "use strict";
    t.exports = RangeError;
  }
}), Xz = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/ref.js"(e, t) {
    "use strict";
    t.exports = ReferenceError;
  }
}), Jz = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/syntax.js"(e, t) {
    "use strict";
    t.exports = SyntaxError;
  }
}), $b = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/type.js"(e, t) {
    "use strict";
    t.exports = TypeError;
  }
}), Zz = ne({
  "node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/uri.js"(e, t) {
    "use strict";
    t.exports = URIError;
  }
}), Qz = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/abs.js"(e, t) {
    "use strict";
    t.exports = Math.abs;
  }
}), eG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/floor.js"(e, t) {
    "use strict";
    t.exports = Math.floor;
  }
}), tG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/max.js"(e, t) {
    "use strict";
    t.exports = Math.max;
  }
}), rG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/min.js"(e, t) {
    "use strict";
    t.exports = Math.min;
  }
}), nG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/pow.js"(e, t) {
    "use strict";
    t.exports = Math.pow;
  }
}), oG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/round.js"(e, t) {
    "use strict";
    t.exports = Math.round;
  }
}), iG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/isNaN.js"(e, t) {
    "use strict";
    t.exports = Number.isNaN || /* @__PURE__ */ o(function(n) {
      return n !== n;
    }, "isNaN2");
  }
}), sG = ne({
  "node_modules/.pnpm/math-intrinsics@1.1.0/node_modules/math-intrinsics/sign.js"(e, t) {
    "use strict";
    var r = iG();
    t.exports = /* @__PURE__ */ o(function(i) {
      return r(i) || i === 0 ? i : i < 0 ? -1 : 1;
    }, "sign");
  }
}), aG = ne({
  "node_modules/.pnpm/gopd@1.2.0/node_modules/gopd/gOPD.js"(e, t) {
    "use strict";
    t.exports = Object.getOwnPropertyDescriptor;
  }
}), Bb = ne({
  "node_modules/.pnpm/gopd@1.2.0/node_modules/gopd/index.js"(e, t) {
    "use strict";
    var r = aG();
    if (r)
      try {
        r([], "length");
      } catch {
        r = null;
      }
    t.exports = r;
  }
}), lG = ne({
  "node_modules/.pnpm/es-define-property@1.0.1/node_modules/es-define-property/index.js"(e, t) {
    "use strict";
    var r = Object.defineProperty || !1;
    if (r)
      try {
        r({}, "a", { value: 1 });
      } catch {
        r = !1;
      }
    t.exports = r;
  }
}), _x = ne({
  "node_modules/.pnpm/has-symbols@1.1.0/node_modules/has-symbols/shams.js"(e, t) {
    "use strict";
    t.exports = /* @__PURE__ */ o(function() {
      if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
        return !1;
      if (typeof Symbol.iterator == "symbol")
        return !0;
      var n = {}, i = Symbol("test"), s = Object(i);
      if (typeof i == "string" || Object.prototype.toString.call(i) !== "[object Symbol]" || Object.prototype.toString.call(s) !== "[object \
Symbol]")
        return !1;
      var a = 42;
      n[i] = a;
      for (var l in n)
        return !1;
      if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(
      n).length !== 0)
        return !1;
      var u = Object.getOwnPropertySymbols(n);
      if (u.length !== 1 || u[0] !== i || !Object.prototype.propertyIsEnumerable.call(n, i))
        return !1;
      if (typeof Object.getOwnPropertyDescriptor == "function") {
        var c = (
          /** @type {PropertyDescriptor} */
          Object.getOwnPropertyDescriptor(n, i)
        );
        if (c.value !== a || c.enumerable !== !0)
          return !1;
      }
      return !0;
    }, "hasSymbols");
  }
}), Rx = ne({
  "node_modules/.pnpm/has-symbols@1.1.0/node_modules/has-symbols/index.js"(e, t) {
    "use strict";
    var r = typeof Symbol < "u" && Symbol, n = _x();
    t.exports = /* @__PURE__ */ o(function() {
      return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 :
      n();
    }, "hasNativeSymbols");
  }
}), wx = ne({
  "node_modules/.pnpm/get-proto@1.0.1/node_modules/get-proto/Reflect.getPrototypeOf.js"(e, t) {
    "use strict";
    t.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
  }
}), Sx = ne({
  "node_modules/.pnpm/get-proto@1.0.1/node_modules/get-proto/Object.getPrototypeOf.js"(e, t) {
    "use strict";
    var r = Tx();
    t.exports = r.getPrototypeOf || null;
  }
}), uG = ne({
  "node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/implementation.js"(e, t) {
    "use strict";
    var r = "Function.prototype.bind called on incompatible ", n = Object.prototype.toString, i = Math.max, s = "[object Function]", a = /* @__PURE__ */ o(
    function(d, p) {
      for (var y = [], f = 0; f < d.length; f += 1)
        y[f] = d[f];
      for (var m = 0; m < p.length; m += 1)
        y[m + d.length] = p[m];
      return y;
    }, "concatty2"), l = /* @__PURE__ */ o(function(d, p) {
      for (var y = [], f = p || 0, m = 0; f < d.length; f += 1, m += 1)
        y[m] = d[f];
      return y;
    }, "slicy2"), u = /* @__PURE__ */ o(function(c, d) {
      for (var p = "", y = 0; y < c.length; y += 1)
        p += c[y], y + 1 < c.length && (p += d);
      return p;
    }, "joiny");
    t.exports = /* @__PURE__ */ o(function(d) {
      var p = this;
      if (typeof p != "function" || n.apply(p) !== s)
        throw new TypeError(r + p);
      for (var y = l(arguments, 1), f, m = /* @__PURE__ */ o(function() {
        if (this instanceof f) {
          var _ = p.apply(
            this,
            a(y, arguments)
          );
          return Object(_) === _ ? _ : this;
        }
        return p.apply(
          d,
          a(y, arguments)
        );
      }, "binder"), h = i(0, p.length - y.length), b = [], g = 0; g < h; g++)
        b[g] = "$" + g;
      if (f = Function("binder", "return function (" + u(b, ",") + "){ return binder.apply(this,arguments); }")(m), p.prototype) {
        var T = /* @__PURE__ */ o(function() {
        }, "Empty2");
        T.prototype = p.prototype, f.prototype = new T(), T.prototype = null;
      }
      return f;
    }, "bind");
  }
}), ll = ne({
  "node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/index.js"(e, t) {
    "use strict";
    var r = uG();
    t.exports = Function.prototype.bind || r;
  }
}), Ub = ne({
  "node_modules/.pnpm/call-bind-apply-helpers@1.0.2/node_modules/call-bind-apply-helpers/functionCall.js"(e, t) {
    "use strict";
    t.exports = Function.prototype.call;
  }
}), xx = ne({
  "node_modules/.pnpm/call-bind-apply-helpers@1.0.2/node_modules/call-bind-apply-helpers/functionApply.js"(e, t) {
    "use strict";
    t.exports = Function.prototype.apply;
  }
}), cG = ne({
  "node_modules/.pnpm/call-bind-apply-helpers@1.0.2/node_modules/call-bind-apply-helpers/reflectApply.js"(e, t) {
    "use strict";
    t.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
  }
}), dG = ne({
  "node_modules/.pnpm/call-bind-apply-helpers@1.0.2/node_modules/call-bind-apply-helpers/actualApply.js"(e, t) {
    "use strict";
    var r = ll(), n = xx(), i = Ub(), s = cG();
    t.exports = s || r.call(i, n);
  }
}), Cx = ne({
  "node_modules/.pnpm/call-bind-apply-helpers@1.0.2/node_modules/call-bind-apply-helpers/index.js"(e, t) {
    "use strict";
    var r = ll(), n = $b(), i = Ub(), s = dG();
    t.exports = /* @__PURE__ */ o(function(l) {
      if (l.length < 1 || typeof l[0] != "function")
        throw new n("a function is required");
      return s(r, i, l);
    }, "callBindBasic");
  }
}), pG = ne({
  "node_modules/.pnpm/dunder-proto@1.0.1/node_modules/dunder-proto/get.js"(e, t) {
    "use strict";
    var r = Cx(), n = Bb(), i;
    try {
      i = /** @type {{ __proto__?: typeof Array.prototype }} */
      [].__proto__ === Array.prototype;
    } catch (u) {
      if (!u || typeof u != "object" || !("code" in u) || u.code !== "ERR_PROTO_ACCESS")
        throw u;
    }
    var s = !!i && n && n(
      Object.prototype,
      /** @type {keyof typeof Object.prototype} */
      "__proto__"
    ), a = Object, l = a.getPrototypeOf;
    t.exports = s && typeof s.get == "function" ? r([s.get]) : typeof l == "function" ? (
      /** @type {import('./get')} */
      /* @__PURE__ */ o(function(c) {
        return l(c == null ? c : a(c));
      }, "getDunder")
    ) : !1;
  }
}), fG = ne({
  "node_modules/.pnpm/get-proto@1.0.1/node_modules/get-proto/index.js"(e, t) {
    "use strict";
    var r = wx(), n = Sx(), i = pG();
    t.exports = r ? /* @__PURE__ */ o(function(a) {
      return r(a);
    }, "getProto") : n ? /* @__PURE__ */ o(function(a) {
      if (!a || typeof a != "object" && typeof a != "function")
        throw new TypeError("getProto: not an object");
      return n(a);
    }, "getProto") : i ? /* @__PURE__ */ o(function(a) {
      return i(a);
    }, "getProto") : null;
  }
}), Px = ne({
  "node_modules/.pnpm/hasown@2.0.2/node_modules/hasown/index.js"(e, t) {
    "use strict";
    var r = Function.prototype.call, n = Object.prototype.hasOwnProperty, i = ll();
    t.exports = i.call(r, n);
  }
}), mG = ne({
  "node_modules/.pnpm/get-intrinsic@1.3.0/node_modules/get-intrinsic/index.js"(e, t) {
    "use strict";
    var r, n = Tx(), i = Yz(), s = Wz(), a = Kz(), l = Xz(), u = Jz(), c = $b(), d = Zz(), p = Qz(), y = eG(), f = tG(), m = rG(), h = nG(),
    b = oG(), g = sG(), T = Function, _ = /* @__PURE__ */ o(function(ot) {
      try {
        return T('"use strict"; return (' + ot + ").constructor;")();
      } catch {
      }
    }, "getEvalledConstructor"), E = Bb(), R = lG(), C = /* @__PURE__ */ o(function() {
      throw new c();
    }, "throwTypeError"), w = E ? function() {
      try {
        return arguments.callee, C;
      } catch {
        try {
          return E(arguments, "callee").get;
        } catch {
          return C;
        }
      }
    }() : C, P = Rx()(), O = fG(), D = Sx(), A = wx(), L = xx(), B = Ub(), N = {}, $ = typeof Uint8Array > "u" || !O ? r : O(Uint8Array), M = {
      __proto__: null,
      "%AggregateError%": typeof AggregateError > "u" ? r : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer > "u" ? r : ArrayBuffer,
      "%ArrayIteratorPrototype%": P && O ? O([][Symbol.iterator]()) : r,
      "%AsyncFromSyncIteratorPrototype%": r,
      "%AsyncFunction%": N,
      "%AsyncGenerator%": N,
      "%AsyncGeneratorFunction%": N,
      "%AsyncIteratorPrototype%": N,
      "%Atomics%": typeof Atomics > "u" ? r : Atomics,
      "%BigInt%": typeof BigInt > "u" ? r : BigInt,
      "%BigInt64Array%": typeof BigInt64Array > "u" ? r : BigInt64Array,
      "%BigUint64Array%": typeof BigUint64Array > "u" ? r : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView > "u" ? r : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": i,
      "%eval%": eval,
      // eslint-disable-line no-eval
      "%EvalError%": s,
      "%Float16Array%": typeof Float16Array > "u" ? r : Float16Array,
      "%Float32Array%": typeof Float32Array > "u" ? r : Float32Array,
      "%Float64Array%": typeof Float64Array > "u" ? r : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? r : FinalizationRegistry,
      "%Function%": T,
      "%GeneratorFunction%": N,
      "%Int8Array%": typeof Int8Array > "u" ? r : Int8Array,
      "%Int16Array%": typeof Int16Array > "u" ? r : Int16Array,
      "%Int32Array%": typeof Int32Array > "u" ? r : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": P && O ? O(O([][Symbol.iterator]())) : r,
      "%JSON%": typeof JSON == "object" ? JSON : r,
      "%Map%": typeof Map > "u" ? r : Map,
      "%MapIteratorPrototype%": typeof Map > "u" || !P || !O ? r : O((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": n,
      "%Object.getOwnPropertyDescriptor%": E,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise > "u" ? r : Promise,
      "%Proxy%": typeof Proxy > "u" ? r : Proxy,
      "%RangeError%": a,
      "%ReferenceError%": l,
      "%Reflect%": typeof Reflect > "u" ? r : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set > "u" ? r : Set,
      "%SetIteratorPrototype%": typeof Set > "u" || !P || !O ? r : O((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? r : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": P && O ? O(""[Symbol.iterator]()) : r,
      "%Symbol%": P ? Symbol : r,
      "%SyntaxError%": u,
      "%ThrowTypeError%": w,
      "%TypedArray%": $,
      "%TypeError%": c,
      "%Uint8Array%": typeof Uint8Array > "u" ? r : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? r : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array > "u" ? r : Uint16Array,
      "%Uint32Array%": typeof Uint32Array > "u" ? r : Uint32Array,
      "%URIError%": d,
      "%WeakMap%": typeof WeakMap > "u" ? r : WeakMap,
      "%WeakRef%": typeof WeakRef > "u" ? r : WeakRef,
      "%WeakSet%": typeof WeakSet > "u" ? r : WeakSet,
      "%Function.prototype.call%": B,
      "%Function.prototype.apply%": L,
      "%Object.defineProperty%": R,
      "%Object.getPrototypeOf%": D,
      "%Math.abs%": p,
      "%Math.floor%": y,
      "%Math.max%": f,
      "%Math.min%": m,
      "%Math.pow%": h,
      "%Math.round%": b,
      "%Math.sign%": g,
      "%Reflect.getPrototypeOf%": A
    };
    if (O)
      try {
        null.error;
      } catch (ot) {
        V = O(O(ot)), M["%Error.prototype%"] = V;
      }
    var V, G = /* @__PURE__ */ o(function ot(ve) {
      var it;
      if (ve === "%AsyncFunction%")
        it = _("async function () {}");
      else if (ve === "%GeneratorFunction%")
        it = _("function* () {}");
      else if (ve === "%AsyncGeneratorFunction%")
        it = _("async function* () {}");
      else if (ve === "%AsyncGenerator%") {
        var $e = ot("%AsyncGeneratorFunction%");
        $e && (it = $e.prototype);
      } else if (ve === "%AsyncIteratorPrototype%") {
        var pt = ot("%AsyncGenerator%");
        pt && O && (it = O(pt.prototype));
      }
      return M[ve] = it, it;
    }, "doEval2"), Q = {
      __proto__: null,
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    }, te = ll(), fe = Px(), F = te.call(B, Array.prototype.concat), j = te.call(L, Array.prototype.splice), Y = te.call(B, String.prototype.
    replace), z = te.call(B, String.prototype.slice), X = te.call(B, RegExp.prototype.exec), ce = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
    Re = /\\(\\)?/g, Me = /* @__PURE__ */ o(function(ve) {
      var it = z(ve, 0, 1), $e = z(ve, -1);
      if (it === "%" && $e !== "%")
        throw new u("invalid intrinsic syntax, expected closing `%`");
      if ($e === "%" && it !== "%")
        throw new u("invalid intrinsic syntax, expected opening `%`");
      var pt = [];
      return Y(ve, ce, function(lr, go, gt, Qa) {
        pt[pt.length] = gt ? Y(Qa, Re, "$1") : go || lr;
      }), pt;
    }, "stringToPath3"), vr = /* @__PURE__ */ o(function(ve, it) {
      var $e = ve, pt;
      if (fe(Q, $e) && (pt = Q[$e], $e = "%" + pt[0] + "%"), fe(M, $e)) {
        var lr = M[$e];
        if (lr === N && (lr = G($e)), typeof lr > "u" && !it)
          throw new c("intrinsic " + ve + " exists, but is not available. Please file an issue!");
        return {
          alias: pt,
          name: $e,
          value: lr
        };
      }
      throw new u("intrinsic " + ve + " does not exist!");
    }, "getBaseIntrinsic2");
    t.exports = /* @__PURE__ */ o(function(ve, it) {
      if (typeof ve != "string" || ve.length === 0)
        throw new c("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && typeof it != "boolean")
        throw new c('"allowMissing" argument must be a boolean');
      if (X(/^%?[^%]*%?$/, ve) === null)
        throw new u("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      var $e = Me(ve), pt = $e.length > 0 ? $e[0] : "", lr = vr("%" + pt + "%", it), go = lr.name, gt = lr.value, Qa = !1, pb = lr.alias;
      pb && (pt = pb[0], j($e, F([0, 1], pb)));
      for (var W = 1, Fi = !0; W < $e.length; W += 1) {
        var Er = $e[W], el = z(Er, 0, 1), tl = z(Er, -1);
        if ((el === '"' || el === "'" || el === "`" || tl === '"' || tl === "'" || tl === "`") && el !== tl)
          throw new u("property names with quotes must have matching quotes");
        if ((Er === "constructor" || !Fi) && (Qa = !0), pt += "." + Er, go = "%" + pt + "%", fe(M, go))
          gt = M[go];
        else if (gt != null) {
          if (!(Er in gt)) {
            if (!it)
              throw new c("base intrinsic for " + ve + " exists, but the property is not available.");
            return;
          }
          if (E && W + 1 >= $e.length) {
            var rl = E(gt, Er);
            Fi = !!rl, Fi && "get" in rl && !("originalValue" in rl.get) ? gt = rl.get : gt = gt[Er];
          } else
            Fi = fe(gt, Er), gt = gt[Er];
          Fi && !Qa && (M[go] = gt);
        }
      }
      return gt;
    }, "GetIntrinsic");
  }
}), Hb = ne({
  "node_modules/.pnpm/call-bound@1.0.4/node_modules/call-bound/index.js"(e, t) {
    "use strict";
    var r = mG(), n = Cx(), i = n([r("%String.prototype.indexOf%")]);
    t.exports = /* @__PURE__ */ o(function(a, l) {
      var u = (
        /** @type {(this: unknown, ...args: unknown[]) => unknown} */
        r(a, !!l)
      );
      return typeof u == "function" && i(a, ".prototype.") > -1 ? n(
        /** @type {const} */
        [u]
      ) : u;
    }, "callBoundIntrinsic");
  }
}), hG = ne({
  "node_modules/.pnpm/has-tostringtag@1.0.2/node_modules/has-tostringtag/shams.js"(e, t) {
    "use strict";
    var r = _x();
    t.exports = /* @__PURE__ */ o(function() {
      return r() && !!Symbol.toStringTag;
    }, "hasToStringTagShams");
  }
}), Ax = ne({
  "node_modules/.pnpm/is-regex@1.2.1/node_modules/is-regex/index.js"(e, t) {
    "use strict";
    var r = Hb(), n = hG()(), i = Px(), s = Bb(), a;
    n ? (l = r("RegExp.prototype.exec"), u = {}, c = /* @__PURE__ */ o(function() {
      throw u;
    }, "throwRegexMarker"), d = {
      toString: c,
      valueOf: c
    }, typeof Symbol.toPrimitive == "symbol" && (d[Symbol.toPrimitive] = c), a = /* @__PURE__ */ o(function(m) {
      if (!m || typeof m != "object")
        return !1;
      var h = (
        /** @type {NonNullable<typeof gOPD>} */
        s(
          /** @type {{ lastIndex?: unknown }} */
          m,
          "lastIndex"
        )
      ), b = h && i(h, "value");
      if (!b)
        return !1;
      try {
        l(
          m,
          /** @type {string} */
          /** @type {unknown} */
          d
        );
      } catch (g) {
        return g === u;
      }
    }, "isRegex")) : (p = r("Object.prototype.toString"), y = "[object RegExp]", a = /* @__PURE__ */ o(function(m) {
      return !m || typeof m != "object" && typeof m != "function" ? !1 : p(m) === y;
    }, "isRegex"));
    var l, u, c, d, p, y;
    t.exports = a;
  }
}), yG = ne({
  "node_modules/.pnpm/is-function@1.0.2/node_modules/is-function/index.js"(e, t) {
    t.exports = n;
    var r = Object.prototype.toString;
    function n(i) {
      if (!i)
        return !1;
      var s = r.call(i);
      return s === "[object Function]" || typeof i == "function" && s !== "[object RegExp]" || typeof window < "u" && // IE8 and below
      (i === window.setTimeout || i === window.alert || i === window.confirm || i === window.prompt);
    }
    o(n, "isFunction3");
  }
}), bG = ne({
  "node_modules/.pnpm/safe-regex-test@1.1.0/node_modules/safe-regex-test/index.js"(e, t) {
    "use strict";
    var r = Hb(), n = Ax(), i = r("RegExp.prototype.exec"), s = $b();
    t.exports = /* @__PURE__ */ o(function(l) {
      if (!n(l))
        throw new s("`regex` must be a RegExp");
      return /* @__PURE__ */ o(function(c) {
        return i(l, c) !== null;
      }, "test");
    }, "regexTester");
  }
}), gG = ne({
  "node_modules/.pnpm/is-symbol@1.1.1/node_modules/is-symbol/index.js"(e, t) {
    "use strict";
    var r = Hb(), n = r("Object.prototype.toString"), i = Rx()(), s = bG();
    i ? (a = r("Symbol.prototype.toString"), l = s(/^Symbol\(.*\)$/), u = /* @__PURE__ */ o(function(d) {
      return typeof d.valueOf() != "symbol" ? !1 : l(a(d));
    }, "isRealSymbolObject"), t.exports = /* @__PURE__ */ o(function(d) {
      if (typeof d == "symbol")
        return !0;
      if (!d || typeof d != "object" || n(d) !== "[object Symbol]")
        return !1;
      try {
        return u(d);
      } catch {
        return !1;
      }
    }, "isSymbol3")) : t.exports = /* @__PURE__ */ o(function(d) {
      return !1;
    }, "isSymbol3");
    var a, l, u;
  }
}), vG = al(Ax()), EG = al(yG()), TG = al(gG());
function _G(e) {
  return e != null && typeof e == "object" && Array.isArray(e) === !1;
}
o(_G, "isObject");
var RG = typeof global == "object" && global && global.Object === Object && global, wG = RG, SG = typeof self == "object" && self && self.Object ===
Object && self, xG = wG || SG || Function("return this")(), Vb = xG, CG = Vb.Symbol, wo = CG, Ox = Object.prototype, PG = Ox.hasOwnProperty,
AG = Ox.toString, Yi = wo ? wo.toStringTag : void 0;
function OG(e) {
  var t = PG.call(e, Yi), r = e[Yi];
  try {
    e[Yi] = void 0;
    var n = !0;
  } catch {
  }
  var i = AG.call(e);
  return n && (t ? e[Yi] = r : delete e[Yi]), i;
}
o(OG, "getRawTag");
var qG = OG, IG = Object.prototype, MG = IG.toString;
function NG(e) {
  return MG.call(e);
}
o(NG, "objectToString");
var jG = NG, LG = "[object Null]", FG = "[object Undefined]", yx = wo ? wo.toStringTag : void 0;
function kG(e) {
  return e == null ? e === void 0 ? FG : LG : yx && yx in Object(e) ? qG(e) : jG(e);
}
o(kG, "baseGetTag");
var qx = kG;
function DG(e) {
  return e != null && typeof e == "object";
}
o(DG, "isObjectLike");
var $G = DG, BG = "[object Symbol]";
function UG(e) {
  return typeof e == "symbol" || $G(e) && qx(e) == BG;
}
o(UG, "isSymbol");
var zb = UG;
function HG(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
o(HG, "arrayMap");
var VG = HG, zG = Array.isArray, Gb = zG, GG = 1 / 0, bx = wo ? wo.prototype : void 0, gx = bx ? bx.toString : void 0;
function Ix(e) {
  if (typeof e == "string")
    return e;
  if (Gb(e))
    return VG(e, Ix) + "";
  if (zb(e))
    return gx ? gx.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -GG ? "-0" : t;
}
o(Ix, "baseToString");
var YG = Ix;
function WG(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
o(WG, "isObject2");
var Mx = WG, KG = "[object AsyncFunction]", XG = "[object Function]", JG = "[object GeneratorFunction]", ZG = "[object Proxy]";
function QG(e) {
  if (!Mx(e))
    return !1;
  var t = qx(e);
  return t == XG || t == JG || t == KG || t == ZG;
}
o(QG, "isFunction");
var eY = QG, tY = Vb["__core-js_shared__"], Db = tY, vx = function() {
  var e = /[^.]+$/.exec(Db && Db.keys && Db.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function rY(e) {
  return !!vx && vx in e;
}
o(rY, "isMasked");
var nY = rY, oY = Function.prototype, iY = oY.toString;
function sY(e) {
  if (e != null) {
    try {
      return iY.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
o(sY, "toSource");
var aY = sY, lY = /[\\^$.*+?()[\]{}|]/g, uY = /^\[object .+?Constructor\]$/, cY = Function.prototype, dY = Object.prototype, pY = cY.toString,
fY = dY.hasOwnProperty, mY = RegExp(
  "^" + pY.call(fY).replace(lY, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function hY(e) {
  if (!Mx(e) || nY(e))
    return !1;
  var t = eY(e) ? mY : uY;
  return t.test(aY(e));
}
o(hY, "baseIsNative");
var yY = hY;
function bY(e, t) {
  return e?.[t];
}
o(bY, "getValue");
var gY = bY;
function vY(e, t) {
  var r = gY(e, t);
  return yY(r) ? r : void 0;
}
o(vY, "getNative");
var Nx = vY;
function EY(e, t) {
  return e === t || e !== e && t !== t;
}
o(EY, "eq");
var TY = EY, _Y = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, RY = /^\w*$/;
function wY(e, t) {
  if (Gb(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || zb(e) ? !0 : RY.test(e) || !_Y.test(e) || t != null && e in Object(
  t);
}
o(wY, "isKey");
var SY = wY, xY = Nx(Object, "create"), Wi = xY;
function CY() {
  this.__data__ = Wi ? Wi(null) : {}, this.size = 0;
}
o(CY, "hashClear");
var PY = CY;
function AY(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
o(AY, "hashDelete");
var OY = AY, qY = "__lodash_hash_undefined__", IY = Object.prototype, MY = IY.hasOwnProperty;
function NY(e) {
  var t = this.__data__;
  if (Wi) {
    var r = t[e];
    return r === qY ? void 0 : r;
  }
  return MY.call(t, e) ? t[e] : void 0;
}
o(NY, "hashGet");
var jY = NY, LY = Object.prototype, FY = LY.hasOwnProperty;
function kY(e) {
  var t = this.__data__;
  return Wi ? t[e] !== void 0 : FY.call(t, e);
}
o(kY, "hashHas");
var DY = kY, $Y = "__lodash_hash_undefined__";
function BY(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Wi && t === void 0 ? $Y : t, this;
}
o(BY, "hashSet");
var UY = BY;
function So(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
o(So, "Hash");
So.prototype.clear = PY;
So.prototype.delete = OY;
So.prototype.get = jY;
So.prototype.has = DY;
So.prototype.set = UY;
var Ex = So;
function HY() {
  this.__data__ = [], this.size = 0;
}
o(HY, "listCacheClear");
var VY = HY;
function zY(e, t) {
  for (var r = e.length; r--; )
    if (TY(e[r][0], t))
      return r;
  return -1;
}
o(zY, "assocIndexOf");
var ul = zY, GY = Array.prototype, YY = GY.splice;
function WY(e) {
  var t = this.__data__, r = ul(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : YY.call(t, r, 1), --this.size, !0;
}
o(WY, "listCacheDelete");
var KY = WY;
function XY(e) {
  var t = this.__data__, r = ul(t, e);
  return r < 0 ? void 0 : t[r][1];
}
o(XY, "listCacheGet");
var JY = XY;
function ZY(e) {
  return ul(this.__data__, e) > -1;
}
o(ZY, "listCacheHas");
var QY = ZY;
function e4(e, t) {
  var r = this.__data__, n = ul(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
o(e4, "listCacheSet");
var t4 = e4;
function xo(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
o(xo, "ListCache");
xo.prototype.clear = VY;
xo.prototype.delete = KY;
xo.prototype.get = JY;
xo.prototype.has = QY;
xo.prototype.set = t4;
var r4 = xo, n4 = Nx(Vb, "Map"), o4 = n4;
function i4() {
  this.size = 0, this.__data__ = {
    hash: new Ex(),
    map: new (o4 || r4)(),
    string: new Ex()
  };
}
o(i4, "mapCacheClear");
var s4 = i4;
function a4(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
o(a4, "isKeyable");
var l4 = a4;
function u4(e, t) {
  var r = e.__data__;
  return l4(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
o(u4, "getMapData");
var cl = u4;
function c4(e) {
  var t = cl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
o(c4, "mapCacheDelete");
var d4 = c4;
function p4(e) {
  return cl(this, e).get(e);
}
o(p4, "mapCacheGet");
var f4 = p4;
function m4(e) {
  return cl(this, e).has(e);
}
o(m4, "mapCacheHas");
var h4 = m4;
function y4(e, t) {
  var r = cl(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
o(y4, "mapCacheSet");
var b4 = y4;
function Co(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
o(Co, "MapCache");
Co.prototype.clear = s4;
Co.prototype.delete = d4;
Co.prototype.get = f4;
Co.prototype.has = h4;
Co.prototype.set = b4;
var jx = Co, g4 = "Expected a function";
function Yb(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(g4);
  var r = /* @__PURE__ */ o(function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
    if (s.has(i))
      return s.get(i);
    var a = e.apply(this, n);
    return r.cache = s.set(i, a) || s, a;
  }, "memoized");
  return r.cache = new (Yb.Cache || jx)(), r;
}
o(Yb, "memoize");
Yb.Cache = jx;
var v4 = Yb, E4 = 500;
function T4(e) {
  var t = v4(e, function(n) {
    return r.size === E4 && r.clear(), n;
  }), r = t.cache;
  return t;
}
o(T4, "memoizeCapped");
var _4 = T4, R4 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, w4 = /\\(\\)?/g, S4 = _4(
function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(R4, function(r, n, i, s) {
    t.push(i ? s.replace(w4, "$1") : n || r);
  }), t;
}), x4 = S4;
function C4(e) {
  return e == null ? "" : YG(e);
}
o(C4, "toString");
var P4 = C4;
function A4(e, t) {
  return Gb(e) ? e : SY(e, t) ? [e] : x4(P4(e));
}
o(A4, "castPath");
var O4 = A4, q4 = 1 / 0;
function I4(e) {
  if (typeof e == "string" || zb(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -q4 ? "-0" : t;
}
o(I4, "toKey");
var M4 = I4;
function N4(e, t) {
  t = O4(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[M4(t[r++])];
  return r && r == n ? e : void 0;
}
o(N4, "baseGet");
var j4 = N4;
function L4(e, t, r) {
  var n = e == null ? void 0 : j4(e, t);
  return n === void 0 ? r : n;
}
o(L4, "get");
var F4 = L4, Wb = _G, k4 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, Ki = /* @__PURE__ */ o((e) => e.match(/^[\[\{\"\}].*[\]\}\"]$/),
"isJSON");
function Lx(e) {
  if (!Wb(e))
    return e;
  let t = e, r = !1;
  return typeof Event < "u" && e instanceof Event && (t = hx(t), r = !0), t = Object.keys(t).reduce((n, i) => {
    try {
      t[i] && t[i].toJSON, n[i] = t[i];
    } catch {
      r = !0;
    }
    return n;
  }, {}), r ? t : e;
}
o(Lx, "convertUnconventionalData");
var D4 = /* @__PURE__ */ o(function(t) {
  let r, n, i, s;
  return /* @__PURE__ */ o(function(l, u) {
    try {
      if (l === "")
        return s = [], r = /* @__PURE__ */ new Map([[u, "[]"]]), n = /* @__PURE__ */ new Map(), i = [], u;
      let c = n.get(this) || this;
      for (; i.length && c !== i[0]; )
        i.shift(), s.pop();
      if (typeof u == "boolean")
        return u;
      if (u === void 0)
        return t.allowUndefined ? "_undefined_" : void 0;
      if (u === null)
        return null;
      if (typeof u == "number")
        return u === Number.NEGATIVE_INFINITY ? "_-Infinity_" : u === Number.POSITIVE_INFINITY ? "_Infinity_" : Number.isNaN(u) ? "_NaN_" : u;
      if (typeof u == "bigint")
        return `_bigint_${u.toString()}`;
      if (typeof u == "string")
        return k4.test(u) ? t.allowDate ? `_date_${u}` : void 0 : u;
      if ((0, vG.default)(u))
        return t.allowRegExp ? `_regexp_${u.flags}|${u.source}` : void 0;
      if ((0, EG.default)(u))
        return;
      if ((0, TG.default)(u)) {
        if (!t.allowSymbol)
          return;
        let p = Symbol.keyFor(u);
        return p !== void 0 ? `_gsymbol_${p}` : `_symbol_${u.toString().slice(7, -1)}`;
      }
      if (i.length >= t.maxDepth)
        return Array.isArray(u) ? `[Array(${u.length})]` : "[Object]";
      if (u === this)
        return `_duplicate_${JSON.stringify(s)}`;
      if (u instanceof Error && t.allowError)
        return {
          __isConvertedError__: !0,
          errorProperties: {
            // @ts-expect-error cause is not defined in the current tsconfig target(es2020)
            ...u.cause ? { cause: u.cause } : {},
            ...u,
            name: u.name,
            message: u.message,
            stack: u.stack,
            "_constructor-name_": u.constructor.name
          }
        };
      if (u?.constructor?.name && u.constructor.name !== "Object" && !Array.isArray(u)) {
        let p = r.get(u);
        if (!p) {
          let y = {
            __isClassInstance__: !0,
            __className__: u.constructor.name,
            ...Object.getOwnPropertyNames(u).reduce(
              (f, m) => {
                try {
                  f[m] = u[m];
                } catch {
                }
                return f;
              },
              {}
            )
          };
          return s.push(l), i.unshift(y), r.set(u, JSON.stringify(s)), u !== y && n.set(u, y), y;
        }
        return `_duplicate_${p}`;
      }
      let d = r.get(u);
      if (!d) {
        let p = Array.isArray(u) ? u : Lx(u);
        return s.push(l), i.unshift(p), r.set(u, JSON.stringify(s)), u !== p && n.set(u, p), p;
      }
      return `_duplicate_${d}`;
    } catch {
      return;
    }
  }, "replace");
}, "replacer2"), $4 = /* @__PURE__ */ o(function(t) {
  let r = [], n;
  return /* @__PURE__ */ o(function(s, a) {
    if (s === "" && (n = a, r.forEach(({ target: l, container: u, replacement: c }) => {
      let d = Ki(c) ? JSON.parse(c) : c.split(".");
      d.length === 0 ? u[l] = n : u[l] = F4(n, d);
    })), s === "_constructor-name_")
      return a;
    if (Wb(a) && a.__isConvertedError__) {
      let { message: l, ...u } = a.errorProperties, c = new Error(l);
      return Object.assign(c, u), c;
    }
    if (typeof a == "string" && a.startsWith("_regexp_") && t.allowRegExp) {
      let [, l, u] = a.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(u, l);
    }
    return typeof a == "string" && a.startsWith("_date_") && t.allowDate ? new Date(a.replace("_date_", "")) : typeof a == "string" && a.startsWith(
    "_duplicate_") ? (r.push({ target: s, container: this, replacement: a.replace(/^_duplicate_/, "") }), null) : typeof a == "string" && a.
    startsWith("_symbol_") && t.allowSymbol ? Symbol(a.replace("_symbol_", "")) : typeof a == "string" && a.startsWith("_gsymbol_") && t.allowSymbol ?
    Symbol.for(a.replace("_gsymbol_", "")) : typeof a == "string" && a === "_-Infinity_" ? Number.NEGATIVE_INFINITY : typeof a == "string" &&
    a === "_Infinity_" ? Number.POSITIVE_INFINITY : typeof a == "string" && a === "_NaN_" ? Number.NaN : typeof a == "string" && a.startsWith(
    "_bigint_") && typeof BigInt == "function" ? BigInt(a.replace("_bigint_", "")) : a;
  }, "revive");
}, "reviver2"), Fx = {
  maxDepth: 10,
  space: void 0,
  allowRegExp: !0,
  allowDate: !0,
  allowError: !0,
  allowUndefined: !0,
  allowSymbol: !0
}, dl = /* @__PURE__ */ o((e, t = {}) => {
  let r = { ...Fx, ...t };
  return JSON.stringify(Lx(e), D4(r), t.space);
}, "stringify"), B4 = /* @__PURE__ */ o(() => {
  let e = /* @__PURE__ */ new Map();
  return /* @__PURE__ */ o(function t(r) {
    Wb(r) && Object.entries(r).forEach(([n, i]) => {
      i === "_undefined_" ? r[n] = void 0 : e.get(i) || (e.set(i, !0), t(i));
    }), Array.isArray(r) && r.forEach((n, i) => {
      n === "_undefined_" ? (e.set(n, !0), r[i] = void 0) : e.get(n) || (e.set(n, !0), t(n));
    });
  }, "mutateUndefined");
}, "mutator"), pl = /* @__PURE__ */ o((e, t = {}) => {
  let r = { ...Fx, ...t }, n = JSON.parse(e, $4(r));
  return B4()(n), n;
}, "parse");

// ../node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var U4 = !0, Kb = "Invariant failed";
function wt(e, t) {
  if (!e) {
    if (U4)
      throw new Error(Kb);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(Kb, ": ").concat(r) : Kb;
    throw new Error(n);
  }
}
o(wt, "invariant");

// src/channels/postmessage/getEventSourceUrl.ts
var kx = /* @__PURE__ */ o((e) => {
  let t = Array.from(
    document.querySelectorAll("iframe[data-is-storybook]")
  ), [r, ...n] = t.filter((s) => {
    try {
      return s.contentWindow?.location.origin === e.source.location.origin && s.contentWindow?.location.pathname === e.source.location.pathname;
    } catch {
    }
    try {
      return s.contentWindow === e.source;
    } catch {
    }
    let a = s.getAttribute("src"), l;
    try {
      if (!a)
        return !1;
      ({ origin: l } = new URL(a, document.location.toString()));
    } catch {
      return !1;
    }
    return l === e.origin;
  }), i = r?.getAttribute("src");
  if (i && n.length === 0) {
    let { protocol: s, host: a, pathname: l } = new URL(i, document.location.toString());
    return `${s}//${a}${l}`;
  }
  return n.length > 0 && ue.error("found multiple candidates for event source"), null;
}, "getEventSourceUrl");

// src/channels/postmessage/index.ts
var { document: Xb, location: Jb } = k, Dx = "storybook-channel", H4 = { maxDepth: 25 }, Zb = class Zb {
  constructor(t) {
    this.config = t;
    this.connected = !1;
    if (this.buffer = [], typeof k?.addEventListener == "function" && k.addEventListener("message", this.handleEvent.bind(this), !1), t.page !==
    "manager" && t.page !== "preview")
      throw new Error(`postmsg-channel: "config.page" cannot be "${t.page}"`);
  }
  setHandler(t) {
    this.handler = (...r) => {
      t.apply(this, r), !this.connected && this.getLocalFrame().length && (this.flush(), this.connected = !0);
    };
  }
  /**
   * Sends `event` to the associated window. If the window does not yet exist the event will be
   * stored in a buffer and sent when the window exists.
   *
   * @param event
   */
  send(t, r) {
    let {
      target: n,
      // telejson options
      allowRegExp: i,
      allowSymbol: s,
      allowDate: a,
      allowError: l,
      allowUndefined: u,
      maxDepth: c,
      space: d
    } = r || {}, p = Object.fromEntries(
      Object.entries({
        allowRegExp: i,
        allowSymbol: s,
        allowDate: a,
        allowError: l,
        allowUndefined: u,
        maxDepth: c,
        space: d
      }).filter(([b, g]) => typeof g < "u")
    ), y = {
      ...H4,
      ...k.CHANNEL_OPTIONS || {},
      ...p
    }, f = this.getFrames(n), m = new URLSearchParams(Jb?.search || ""), h = dl(
      {
        key: Dx,
        event: t,
        refId: m.get("refId")
      },
      y
    );
    return f.length ? (this.buffer.length && this.flush(), f.forEach((b) => {
      try {
        b.postMessage(h, "*");
      } catch {
        ue.error("sending over postmessage fail");
      }
    }), Promise.resolve(null)) : new Promise((b, g) => {
      this.buffer.push({ event: t, resolve: b, reject: g });
    });
  }
  flush() {
    let { buffer: t } = this;
    this.buffer = [], t.forEach((r) => {
      this.send(r.event).then(r.resolve).catch(r.reject);
    });
  }
  getFrames(t) {
    if (this.config.page === "manager") {
      let n = Array.from(
        Xb.querySelectorAll("iframe[data-is-storybook][data-is-loaded]")
      ).flatMap((i) => {
        try {
          return i.contentWindow && i.dataset.isStorybook !== void 0 && i.id === t ? [i.contentWindow] : [];
        } catch {
          return [];
        }
      });
      return n?.length ? n : this.getCurrentFrames();
    }
    return k && k.parent && k.parent !== k.self ? [k.parent] : [];
  }
  getCurrentFrames() {
    return this.config.page === "manager" ? Array.from(
      Xb.querySelectorAll('[data-is-storybook="true"]')
    ).flatMap((r) => r.contentWindow ? [r.contentWindow] : []) : k && k.parent ? [k.parent] : [];
  }
  getLocalFrame() {
    return this.config.page === "manager" ? Array.from(
      Xb.querySelectorAll("#storybook-preview-iframe")
    ).flatMap((r) => r.contentWindow ? [r.contentWindow] : []) : k && k.parent ? [k.parent] : [];
  }
  handleEvent(t) {
    try {
      let { data: r } = t, { key: n, event: i, refId: s } = typeof r == "string" && Ki(r) ? pl(r, k.CHANNEL_OPTIONS || {}) : r;
      if (n === Dx) {
        let a = this.config.page === "manager" ? '<span style="color: #37D5D3; background: black"> manager </span>' : '<span style="color: #\
1EA7FD; background: black"> preview </span>', l = Object.values(To).includes(i.type) ? `<span style="color: #FF4785">${i.type}</span>` : `<s\
pan style="color: #FFAE00">${i.type}</span>`;
        if (s && (i.refId = s), i.source = this.config.page === "preview" ? t.origin : kx(t), !i.source) {
          vt.error(
            `${a} received ${l} but was unable to determine the source of the event`
          );
          return;
        }
        let u = `${a} received ${l} (${r.length})`;
        vt.debug(
          Jb.origin !== i.source ? u : `${u} <span style="color: gray">(on ${Jb.origin} from ${i.source})</span>`,
          ...i.args
        ), wt(this.handler, "ChannelHandler should be set"), this.handler(i);
      }
    } catch (r) {
      ue.error(r);
    }
  }
};
o(Zb, "PostMessageTransport");
var Po = Zb;

// src/channels/websocket/index.ts
var { WebSocket: V4 } = k, Qb = 15e3, eg = 5e3, tg = class tg {
  constructor({ url: t, onError: r, page: n }) {
    this.buffer = [];
    this.isReady = !1;
    this.isClosed = !1;
    this.pingTimeout = 0;
    this.socket = new V4(t), this.socket.onopen = () => {
      this.isReady = !0, this.heartbeat(), this.flush();
    }, this.socket.onmessage = ({ data: i }) => {
      let s = typeof i == "string" && Ki(i) ? pl(i) : i;
      wt(this.handler, "WebsocketTransport handler should be set"), this.handler(s), s.type === "ping" && (this.heartbeat(), this.send({ type: "\
pong" }));
    }, this.socket.onerror = (i) => {
      r && r(i);
    }, this.socket.onclose = (i) => {
      wt(this.handler, "WebsocketTransport handler should be set"), this.handler({
        type: mb,
        args: [{ reason: i.reason, code: i.code }],
        from: n || "preview"
      }), this.isClosed = !0, clearTimeout(this.pingTimeout);
    };
  }
  heartbeat() {
    clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(() => {
      this.socket.close(3008, "timeout");
    }, Qb + eg);
  }
  setHandler(t) {
    this.handler = t;
  }
  send(t) {
    this.isClosed || (this.isReady ? this.sendNow(t) : this.sendLater(t));
  }
  sendLater(t) {
    this.buffer.push(t);
  }
  sendNow(t) {
    let r = dl(t, {
      maxDepth: 15,
      ...k.CHANNEL_OPTIONS
    });
    this.socket.send(r);
  }
  flush() {
    let { buffer: t } = this;
    this.buffer = [], t.forEach((r) => this.send(r));
  }
};
o(tg, "WebsocketTransport");
var Ao = tg;

// src/channels/index.ts
var { CONFIG_TYPE: z4 } = k, G4 = Fr;
function Y4({ page: e, extraTransports: t = [] }) {
  let r = [new Po({ page: e }), ...t];
  if (z4 === "DEVELOPMENT") {
    let i = window.location.protocol === "http:" ? "ws" : "wss", { hostname: s, port: a } = window.location, l = `${i}://${s}:${a}/storybook\
-server-channel`;
    r.push(new Ao({ url: l, onError: /* @__PURE__ */ o(() => {
    }, "onError"), page: e }));
  }
  let n = new Fr({ transports: r });
  return _o.__prepare(
    n,
    e === "manager" ? _o.Environment.MANAGER : _o.Environment.PREVIEW
  ), n;
}
o(Y4, "createBrowserChannel");

// src/preview-errors.ts
var ug = {};
ft(ug, {
  CalledExtractOnStoreError: () => Zi,
  CalledPreviewMethodBeforeInitializationError: () => Ze,
  Category: () => Bx,
  ElementA11yParameterError: () => lg,
  EmptyIndexError: () => rs,
  ImplicitActionsDuringRendering: () => Ji,
  MdxFileWithNoCsfReferencesError: () => ts,
  MissingRenderToCanvasError: () => Qi,
  MissingStoryAfterHmrError: () => Xi,
  MissingStoryFromCsfFileError: () => os,
  MountMustBeDestructuredError: () => xn,
  NextJsSharpError: () => og,
  NextjsRouterMocksNotAvailable: () => ig,
  NoRenderFunctionError: () => ss,
  NoStoryMatchError: () => ns,
  NoStoryMountedError: () => as,
  StatusTypeIdMismatchError: () => ng,
  StoryIndexFetchError: () => es,
  StoryStoreAccessedBeforeInitializationError: () => is,
  UnknownArgTypesError: () => sg,
  UnsupportedViewportDimensionError: () => ag
});

// src/storybook-error.ts
function $x({
  code: e,
  category: t
}) {
  let r = String(e).padStart(4, "0");
  return `SB_${t}_${r}`;
}
o($x, "parseErrorCode");
var fl = class fl extends Error {
  constructor(r) {
    super(fl.getFullMessage(r));
    /**
     * Data associated with the error. Used to provide additional information in the error message or
     * to be passed to telemetry.
     */
    this.data = {};
    /** Flag used to easily determine if the error originates from Storybook. */
    this.fromStorybook = !0;
    this.category = r.category, this.documentation = r.documentation ?? !1, this.code = r.code;
  }
  get fullErrorCode() {
    return $x({ code: this.code, category: this.category });
  }
  /** Overrides the default `Error.name` property in the format: SB_<CATEGORY>_<CODE>. */
  get name() {
    let r = this.constructor.name;
    return `${this.fullErrorCode} (${r})`;
  }
  /** Generates the error message along with additional documentation link (if applicable). */
  static getFullMessage({
    documentation: r,
    code: n,
    category: i,
    message: s
  }) {
    let a;
    return r === !0 ? a = `https://storybook.js.org/error/${$x({ code: n, category: i })}` : typeof r == "string" ? a = r : Array.isArray(r) &&
    (a = `
${r.map((l) => `	- ${l}`).join(`
`)}`), `${s}${a != null ? `

More info: ${a}
` : ""}`;
  }
};
o(fl, "StorybookError");
var Ne = fl;

// src/preview-errors.ts
var Bx = /* @__PURE__ */ ((R) => (R.BLOCKS = "BLOCKS", R.DOCS_TOOLS = "DOCS-TOOLS", R.PREVIEW_CLIENT_LOGGER = "PREVIEW_CLIENT-LOGGER", R.PREVIEW_CHANNELS =
"PREVIEW_CHANNELS", R.PREVIEW_CORE_EVENTS = "PREVIEW_CORE-EVENTS", R.PREVIEW_INSTRUMENTER = "PREVIEW_INSTRUMENTER", R.PREVIEW_API = "PREVIEW\
_API", R.PREVIEW_REACT_DOM_SHIM = "PREVIEW_REACT-DOM-SHIM", R.PREVIEW_ROUTER = "PREVIEW_ROUTER", R.PREVIEW_THEMING = "PREVIEW_THEMING", R.RENDERER_HTML =
"RENDERER_HTML", R.RENDERER_PREACT = "RENDERER_PREACT", R.RENDERER_REACT = "RENDERER_REACT", R.RENDERER_SERVER = "RENDERER_SERVER", R.RENDERER_SVELTE =
"RENDERER_SVELTE", R.RENDERER_VUE = "RENDERER_VUE", R.RENDERER_VUE3 = "RENDERER_VUE3", R.RENDERER_WEB_COMPONENTS = "RENDERER_WEB-COMPONENTS",
R.FRAMEWORK_NEXTJS = "FRAMEWORK_NEXTJS", R.ADDON_VITEST = "ADDON_VITEST", R.ADDON_A11Y = "ADDON_A11Y", R))(Bx || {}), cg = class cg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 1,
      message: ee`
        Couldn't find story matching id '${r.storyId}' after HMR.
        - Did you just rename a story?
        - Did you remove it from your CSF file?
        - Are you sure a story with the id '${r.storyId}' exists?
        - Please check the values in the stories field of your main.js config and see if they would match your CSF File.
        - Also check the browser console and terminal for potential error messages.`
    });
    this.data = r;
  }
};
o(cg, "MissingStoryAfterHmrError");
var Xi = cg, dg = class dg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 2,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#using-implicit-actions-during-rendering-is-deprecated-\
for-example-in-the-play-function",
      message: ee`
        We detected that you use an implicit action arg while ${r.phase} of your story.  
        ${r.deprecated ? `
This is deprecated and won't work in Storybook 8 anymore.
` : ""}
        Please provide an explicit spy to your args like this:
          import { fn } from 'storybook/test';
          ... 
          args: {
           ${r.name}: fn()
          }`
    });
    this.data = r;
  }
};
o(dg, "ImplicitActionsDuringRendering");
var Ji = dg, pg = class pg extends Ne {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 3,
      message: ee`
        Cannot call \`storyStore.extract()\` without calling \`storyStore.cacheAllCsfFiles()\` first.

        You probably meant to call \`await preview.extract()\` which does the above for you.`
    });
  }
};
o(pg, "CalledExtractOnStoreError");
var Zi = pg, fg = class fg extends Ne {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 4,
      message: ee`
        Expected your framework's preset to export a \`renderToCanvas\` field.

        Perhaps it needs to be upgraded for Storybook 7.0?`,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field"
    });
  }
};
o(fg, "MissingRenderToCanvasError");
var Qi = fg, mg = class mg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 5,
      message: ee`
        Called \`Preview.${r.methodName}()\` before initialization.
        
        The preview needs to load the story index before most methods can be called. If you want
        to call \`${r.methodName}\`, try \`await preview.initializationPromise;\` first.
        
        If you didn't call the above code, then likely it was called by an addon that needs to
        do the above.`
    });
    this.data = r;
  }
};
o(mg, "CalledPreviewMethodBeforeInitializationError");
var Ze = mg, hg = class hg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 6,
      message: ee`
        Error fetching \`/index.json\`:
        
        ${r.text}

        If you are in development, this likely indicates a problem with your Storybook process,
        check the terminal for errors.

        If you are in a deployed Storybook, there may have been an issue deploying the full Storybook
        build.`
    });
    this.data = r;
  }
};
o(hg, "StoryIndexFetchError");
var es = hg, yg = class yg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 7,
      message: ee`
        Tried to render docs entry ${r.storyId} but it is a MDX file that has no CSF
        references, or autodocs for a CSF file that some doesn't refer to itself.
        
        This likely is an internal error in Storybook's indexing, or you've attached the
        \`attached-mdx\` tag to an MDX file that is not attached.`
    });
    this.data = r;
  }
};
o(yg, "MdxFileWithNoCsfReferencesError");
var ts = yg, bg = class bg extends Ne {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 8,
      message: ee`
        Couldn't find any stories in your Storybook.

        - Please check your stories field of your main.js config: does it match correctly?
        - Also check the browser console and terminal for error messages.`
    });
  }
};
o(bg, "EmptyIndexError");
var rs = bg, gg = class gg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 9,
      message: ee`
        Couldn't find story matching '${r.storySpecifier}'.

        - Are you sure a story with that id exists?
        - Please check your stories field of your main.js config.
        - Also check the browser console and terminal for error messages.`
    });
    this.data = r;
  }
};
o(gg, "NoStoryMatchError");
var ns = gg, vg = class vg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 10,
      message: ee`
        Couldn't find story matching id '${r.storyId}' after importing a CSF file.

        The file was indexed as if the story was there, but then after importing the file in the browser
        we didn't find the story. Possible reasons:
        - You are using a custom story indexer that is misbehaving.
        - You have a custom file loader that is removing or renaming exports.

        Please check your browser console and terminal for errors that may explain the issue.`
    });
    this.data = r;
  }
};
o(vg, "MissingStoryFromCsfFileError");
var os = vg, Eg = class Eg extends Ne {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 11,
      message: ee`
        Cannot access the Story Store until the index is ready.

        It is not recommended to use methods directly on the Story Store anyway, in Storybook 9 we will
        remove access to the store entirely`
    });
  }
};
o(Eg, "StoryStoreAccessedBeforeInitializationError");
var is = Eg, Tg = class Tg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 12,
      message: ee`
      Incorrect use of mount in the play function.
      
      To use mount in the play function, you must satisfy the following two requirements: 
      
      1. You *must* destructure the mount property from the \`context\` (the argument passed to your play function). 
         This makes sure that Storybook does not start rendering the story before the play function begins.
      
      2. Your Storybook framework or builder must be configured to transpile to ES2017 or newer. 
         This is because destructuring statements and async/await usages are otherwise transpiled away, 
         which prevents Storybook from recognizing your usage of \`mount\`.
      
      Note that Angular is not supported. As async/await is transpiled to support the zone.js polyfill. 
      
      More info: https://storybook.js.org/docs/writing-tests/interaction-testing#run-code-before-the-component-gets-rendered
      
      Received the following play function:
      ${r.playFunction}`
    });
    this.data = r;
  }
};
o(Tg, "MountMustBeDestructuredError");
var xn = Tg, _g = class _g extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 14,
      message: ee`
        No render function available for storyId '${r.id}'
      `
    });
    this.data = r;
  }
};
o(_g, "NoRenderFunctionError");
var ss = _g, Rg = class Rg extends Ne {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 15,
      message: ee`
        No component is mounted in your story.
        
        This usually occurs when you destructure mount in the play function, but forget to call it.
        
        For example:

        async play({ mount, canvasElement }) {
          // 👈 mount should be called: await mount(); 
          const canvas = within(canvasElement);
          const button = await canvas.findByRole('button');
          await userEvent.click(button);
        };

        Make sure to either remove it or call mount in your play function.
      `
    });
  }
};
o(Rg, "NoStoryMountedError");
var as = Rg, wg = class wg extends Ne {
  constructor(r) {
    super({
      category: "PREVIEW_API",
      code: 16,
      message: `Status has typeId "${r.status.typeId}" but was added to store with typeId "${r.typeId}". Full status: ${JSON.stringify(
        r.status,
        null,
        2
      )}`
    });
    this.data = r;
  }
};
o(wg, "StatusTypeIdMismatchError");
var ng = wg, Sg = class Sg extends Ne {
  constructor() {
    super({
      category: "FRAMEWORK_NEXTJS",
      code: 1,
      documentation: "https://storybook.js.org/docs/get-started/nextjs#faq",
      message: ee`
      You are importing avif images, but you don't have sharp installed.

      You have to install sharp in order to use image optimization features in Next.js.
      `
    });
  }
};
o(Sg, "NextJsSharpError");
var og = Sg, xg = class xg extends Ne {
  constructor(r) {
    super({
      category: "FRAMEWORK_NEXTJS",
      code: 2,
      message: ee`
        Tried to access router mocks from "${r.importType}" but they were not created yet. You might be running code in an unsupported environment.
      `
    });
    this.data = r;
  }
};
o(xg, "NextjsRouterMocksNotAvailable");
var ig = xg, Cg = class Cg extends Ne {
  constructor(r) {
    super({
      category: "DOCS-TOOLS",
      code: 1,
      documentation: "https://github.com/storybookjs/storybook/issues/26606",
      message: ee`
        There was a failure when generating detailed ArgTypes in ${r.language} for:
        ${JSON.stringify(r.type, null, 2)} 
        
        Storybook will fall back to use a generic type description instead.

        This type is either not supported or it is a bug in the docgen generation in Storybook.
        If you think this is a bug, please detail it as much as possible in the Github issue.
      `
    });
    this.data = r;
  }
};
o(Cg, "UnknownArgTypesError");
var sg = Cg, Pg = class Pg extends Ne {
  constructor(r) {
    super({
      category: "ADDON_VITEST",
      code: 1,
      // TODO: Add documentation about viewports support
      // documentation: '',
      message: ee`
        Encountered an unsupported value "${r.value}" when setting the viewport ${r.dimension} dimension.
        
        The Storybook plugin only supports values in the following units:
        - px, vh, vw, em, rem and %.
        
        You can either change the viewport for this story to use one of the supported units or skip the test by adding '!test' to the story's tags per https://storybook.js.org/docs/writing-stories/tags
      `
    });
    this.data = r;
  }
};
o(Pg, "UnsupportedViewportDimensionError");
var ag = Pg, Ag = class Ag extends Ne {
  constructor() {
    super({
      category: "ADDON_A11Y",
      code: 1,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#a11y-addon-replace-element-parameter-with-context-para\
meter",
      message: 'The "element" parameter in parameters.a11y has been removed. Use "context" instead.'
    });
  }
};
o(Ag, "ElementA11yParameterError");
var lg = Ag;

// src/types/index.ts
var Og = {};
ft(Og, {
  Addon_TypesEnum: () => Ux
});

// src/types/modules/addons.ts
var Ux = /* @__PURE__ */ ((l) => (l.TAB = "tab", l.PANEL = "panel", l.TOOL = "tool", l.TOOLEXTRA = "toolextra", l.PREVIEW = "preview", l.experimental_PAGE =
"page", l.experimental_TEST_PROVIDER = "test-provider", l))(Ux || {});

// src/actions/index.ts
var sx = {};
ft(sx, {
  ADDON_ID: () => ml,
  CLEAR_ID: () => X4,
  CYCLIC_KEY: () => J4,
  EVENT_ID: () => qg,
  PANEL_ID: () => K4,
  PARAM_KEY: () => W4,
  action: () => Br,
  actions: () => qxe,
  config: () => bo,
  configureActions: () => Pxe
});

// src/actions/constants.ts
var W4 = "actions", ml = "storybook/actions", K4 = `${ml}/panel`, qg = `${ml}/action-event`, X4 = `${ml}/action-clear`, J4 = "$___storybook.\
isCyclic";

// src/preview-api/index.ts
var db = {};
ft(db, {
  DocsContext: () => jr,
  HooksContext: () => Dr,
  Preview: () => lo,
  PreviewWeb: () => Ja,
  PreviewWithSelection: () => uo,
  ReporterAPI: () => vn,
  StoryStore: () => so,
  UrlStore: () => fo,
  WebView: () => ho,
  addons: () => Ye,
  applyHooks: () => yl,
  combineArgs: () => Mi,
  combineParameters: () => At,
  composeConfigs: () => Nr,
  composeStepRunners: () => Wy,
  composeStories: () => D3,
  composeStory: () => PS,
  createPlaywrightTest: () => $3,
  decorateStory: () => RS,
  defaultDecorateStory: () => zy,
  emitTransformCode: () => ix,
  filterArgTypes: () => Ha,
  getCsfFactoryAnnotations: () => Jy,
  inferControls: () => Li,
  makeDecorator: () => eC,
  mockChannel: () => hl,
  normalizeArrays: () => he,
  normalizeProjectAnnotations: () => no,
  normalizeStory: () => ro,
  pauseAnimations: () => oo,
  prepareMeta: () => Gy,
  prepareStory: () => ji,
  sanitizeStoryContextUpdate: () => wS,
  setDefaultProjectAnnotations: () => F3,
  setProjectAnnotations: () => k3,
  simulateDOMContentLoaded: () => Za,
  simulatePageLoad: () => ox,
  sortStoriesV7: () => G3,
  useArgs: () => Zx,
  useCallback: () => Oo,
  useChannel: () => Xx,
  useEffect: () => Ht,
  useGlobals: () => Qx,
  useMemo: () => gl,
  useParameter: () => Jx,
  useReducer: () => Kx,
  useRef: () => Gx,
  useState: () => Wx,
  useStoryContext: () => ls,
  userOrAutoTitle: () => H3,
  userOrAutoTitleFromSpecifier: () => qS,
  waitForAnimations: () => io
});

// src/preview-api/modules/addons/storybook-channel-mock.ts
function hl() {
  let e = {
    setHandler: /* @__PURE__ */ o(() => {
    }, "setHandler"),
    send: /* @__PURE__ */ o(() => {
    }, "send")
  };
  return new Fr({ transport: e });
}
o(hl, "mockChannel");

// src/preview-api/modules/addons/main.ts
var Ng = class Ng {
  constructor() {
    this.getChannel = /* @__PURE__ */ o(() => {
      if (!this.channel) {
        let t = hl();
        return this.setChannel(t), t;
      }
      return this.channel;
    }, "getChannel");
    this.ready = /* @__PURE__ */ o(() => this.promise, "ready");
    this.hasChannel = /* @__PURE__ */ o(() => !!this.channel, "hasChannel");
    this.setChannel = /* @__PURE__ */ o((t) => {
      this.channel = t, this.resolve();
    }, "setChannel");
    this.promise = new Promise((t) => {
      this.resolve = () => t(this.getChannel());
    });
  }
};
o(Ng, "AddonStore");
var Mg = Ng, Ig = "__STORYBOOK_ADDONS_PREVIEW";
function Z4() {
  return k[Ig] || (k[Ig] = new Mg()), k[Ig];
}
o(Z4, "getAddonsStore");
var Ye = Z4();

// src/preview-api/modules/addons/hooks.ts
var kg = class kg {
  constructor() {
    this.hookListsMap = void 0;
    this.mountedDecorators = void 0;
    this.prevMountedDecorators = void 0;
    this.currentHooks = void 0;
    this.nextHookIndex = void 0;
    this.currentPhase = void 0;
    this.currentEffects = void 0;
    this.prevEffects = void 0;
    this.currentDecoratorName = void 0;
    this.hasUpdates = void 0;
    this.currentContext = void 0;
    this.renderListener = /* @__PURE__ */ o((t) => {
      t === this.currentContext?.id && (this.triggerEffects(), this.currentContext = null, this.removeRenderListeners());
    }, "renderListener");
    this.init();
  }
  init() {
    this.hookListsMap = /* @__PURE__ */ new WeakMap(), this.mountedDecorators = /* @__PURE__ */ new Set(), this.prevMountedDecorators = /* @__PURE__ */ new Set(),
    this.currentHooks = [], this.nextHookIndex = 0, this.currentPhase = "NONE", this.currentEffects = [], this.prevEffects = [], this.currentDecoratorName =
    null, this.hasUpdates = !1, this.currentContext = null;
  }
  clean() {
    this.prevEffects.forEach((t) => {
      t.destroy && t.destroy();
    }), this.init(), this.removeRenderListeners();
  }
  getNextHook() {
    let t = this.currentHooks[this.nextHookIndex];
    return this.nextHookIndex += 1, t;
  }
  triggerEffects() {
    this.prevEffects.forEach((t) => {
      !this.currentEffects.includes(t) && t.destroy && t.destroy();
    }), this.currentEffects.forEach((t) => {
      this.prevEffects.includes(t) || (t.destroy = t.create());
    }), this.prevEffects = this.currentEffects, this.currentEffects = [];
  }
  addRenderListeners() {
    this.removeRenderListeners(), Ye.getChannel().on(Eo, this.renderListener);
  }
  removeRenderListeners() {
    Ye.getChannel().removeListener(Eo, this.renderListener);
  }
};
o(kg, "HooksContext");
var Dr = kg;
function Hx(e) {
  let t = /* @__PURE__ */ o((...r) => {
    let { hooks: n } = typeof r[0] == "function" ? r[1] : r[0], i = n.currentPhase, s = n.currentHooks, a = n.nextHookIndex, l = n.currentDecoratorName;
    n.currentDecoratorName = e.name, n.prevMountedDecorators.has(e) ? (n.currentPhase = "UPDATE", n.currentHooks = n.hookListsMap.get(e) || []) :
    (n.currentPhase = "MOUNT", n.currentHooks = [], n.hookListsMap.set(e, n.currentHooks), n.prevMountedDecorators.add(e)), n.nextHookIndex =
    0;
    let u = k.STORYBOOK_HOOKS_CONTEXT;
    k.STORYBOOK_HOOKS_CONTEXT = n;
    let c = e(...r);
    if (k.STORYBOOK_HOOKS_CONTEXT = u, n.currentPhase === "UPDATE" && n.getNextHook() != null)
      throw new Error(
        "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
      );
    return n.currentPhase = i, n.currentHooks = s, n.nextHookIndex = a, n.currentDecoratorName = l, c;
  }, "hookified");
  return t.originalFn = e, t;
}
o(Hx, "hookify");
var jg = 0, Q4 = 25, yl = /* @__PURE__ */ o((e) => (t, r) => {
  let n = e(
    Hx(t),
    r.map((i) => Hx(i))
  );
  return (i) => {
    let { hooks: s } = i;
    s.prevMountedDecorators ??= /* @__PURE__ */ new Set(), s.mountedDecorators = /* @__PURE__ */ new Set([t, ...r]), s.currentContext = i, s.
    hasUpdates = !1;
    let a = n(i);
    for (jg = 1; s.hasUpdates; )
      if (s.hasUpdates = !1, s.currentEffects = [], a = n(i), jg += 1, jg > Q4)
        throw new Error(
          "Too many re-renders. Storybook limits the number of renders to prevent an infinite loop."
        );
    return s.addRenderListeners(), a;
  };
}, "applyHooks"), eW = /* @__PURE__ */ o((e, t) => e.length === t.length && e.every((r, n) => r === t[n]), "areDepsEqual"), Lg = /* @__PURE__ */ o(
() => new Error("Storybook preview hooks can only be called inside decorators and story functions."), "invalidHooksError");
function Vx() {
  return k.STORYBOOK_HOOKS_CONTEXT || null;
}
o(Vx, "getHooksContextOrNull");
function Fg() {
  let e = Vx();
  if (e == null)
    throw Lg();
  return e;
}
o(Fg, "getHooksContextOrThrow");
function tW(e, t, r) {
  let n = Fg();
  if (n.currentPhase === "MOUNT") {
    r != null && !Array.isArray(r) && ue.warn(
      `${e} received a final argument that is not an array (instead, received ${r}). When specified, the final argument must be an array.`
    );
    let i = { name: e, deps: r };
    return n.currentHooks.push(i), t(i), i;
  }
  if (n.currentPhase === "UPDATE") {
    let i = n.getNextHook();
    if (i == null)
      throw new Error("Rendered more hooks than during the previous render.");
    return i.name !== e && ue.warn(
      `Storybook has detected a change in the order of Hooks${n.currentDecoratorName ? ` called by ${n.currentDecoratorName}` : ""}. This wi\
ll lead to bugs and errors if not fixed.`
    ), r != null && i.deps == null && ue.warn(
      `${e} received a final argument during this render, but not during the previous render. Even though the final argument is optional, it\
s type cannot change between renders.`
    ), r != null && i.deps != null && r.length !== i.deps.length && ue.warn(`The final argument passed to ${e} changed size between renders.\
 The order and size of this array must remain constant.
Previous: ${i.deps}
Incoming: ${r}`), (r == null || i.deps == null || !eW(r, i.deps)) && (t(i), i.deps = r), i;
  }
  throw Lg();
}
o(tW, "useHook");
function bl(e, t, r) {
  let { memoizedState: n } = tW(
    e,
    (i) => {
      i.memoizedState = t();
    },
    r
  );
  return n;
}
o(bl, "useMemoLike");
function gl(e, t) {
  return bl("useMemo", e, t);
}
o(gl, "useMemo");
function Oo(e, t) {
  return bl("useCallback", () => e, t);
}
o(Oo, "useCallback");
function zx(e, t) {
  return bl(e, () => ({ current: t }), []);
}
o(zx, "useRefLike");
function Gx(e) {
  return zx("useRef", e);
}
o(Gx, "useRef");
function rW() {
  let e = Vx();
  if (e != null && e.currentPhase !== "NONE")
    e.hasUpdates = !0;
  else
    try {
      Ye.getChannel().emit(Bi);
    } catch {
      ue.warn("State updates of Storybook preview hooks work only in browser");
    }
}
o(rW, "triggerUpdate");
function Yx(e, t) {
  let r = zx(
    e,
    // @ts-expect-error S type should never be function, but there's no way to tell that to TypeScript
    typeof t == "function" ? t() : t
  ), n = /* @__PURE__ */ o((i) => {
    r.current = typeof i == "function" ? i(r.current) : i, rW();
  }, "setState");
  return [r.current, n];
}
o(Yx, "useStateLike");
function Wx(e) {
  return Yx("useState", e);
}
o(Wx, "useState");
function Kx(e, t, r) {
  let n = r != null ? () => r(t) : t, [i, s] = Yx("useReducer", n);
  return [i, /* @__PURE__ */ o((l) => s((u) => e(u, l)), "dispatch")];
}
o(Kx, "useReducer");
function Ht(e, t) {
  let r = Fg(), n = bl("useEffect", () => ({ create: e }), t);
  r.currentEffects.includes(n) || r.currentEffects.push(n);
}
o(Ht, "useEffect");
function Xx(e, t = []) {
  let r = Ye.getChannel();
  return Ht(() => (Object.entries(e).forEach(([n, i]) => r.on(n, i)), () => {
    Object.entries(e).forEach(
      ([n, i]) => r.removeListener(n, i)
    );
  }), [...Object.keys(e), ...t]), Oo(r.emit.bind(r), [r]);
}
o(Xx, "useChannel");
function ls() {
  let { currentContext: e } = Fg();
  if (e == null)
    throw Lg();
  return e;
}
o(ls, "useStoryContext");
function Jx(e, t) {
  let { parameters: r } = ls();
  if (e)
    return r[e] ?? t;
}
o(Jx, "useParameter");
function Zx() {
  let e = Ye.getChannel(), { id: t, args: r } = ls(), n = Oo(
    (s) => e.emit(zi, { storyId: t, updatedArgs: s }),
    [e, t]
  ), i = Oo(
    (s) => e.emit(Ui, { storyId: t, argNames: s }),
    [e, t]
  );
  return [r, n, i];
}
o(Zx, "useArgs");
function Qx() {
  let e = Ye.getChannel(), { globals: t } = ls(), r = Oo(
    (n) => e.emit(Vi, { globals: n }),
    [e]
  );
  return [t, r];
}
o(Qx, "useGlobals");

// src/preview-api/modules/addons/make-decorator.ts
var eC = /* @__PURE__ */ o(({
  name: e,
  parameterName: t,
  wrapper: r,
  skipIfNoParametersOrOptions: n = !1
}) => {
  let i = /* @__PURE__ */ o((s) => (a, l) => {
    let u = l.parameters && l.parameters[t];
    return u && u.disable || n && !s && !u ? a(l) : r(a, l, {
      options: s,
      parameters: u
    });
  }, "decorator");
  return (...s) => typeof s[0] == "function" ? i()(...s) : (...a) => {
    if (a.length > 1)
      return s.length > 1 ? i(s)(...a) : i(...s)(...a);
    throw new Error(
      `Passing stories directly into ${e}() is not allowed,
        instead use addDecorator(${e}) and pass options with the '${t}' parameter`
    );
  };
}, "makeDecorator");

// src/csf/toStartCaseStr.ts
function tC(e) {
  return e.replace(/_/g, " ").replace(/-/g, " ").replace(/\./g, " ").replace(/([^\n])([A-Z])([a-z])/g, (t, r, n, i) => `${r} ${n}${i}`).replace(
  /([a-z])([A-Z])/g, (t, r, n) => `${r} ${n}`).replace(/([a-z])([0-9])/gi, (t, r, n) => `${r} ${n}`).replace(/([0-9])([a-z])/gi, (t, r, n) => `${r}\
 ${n}`).replace(/(\s|^)(\w)/g, (t, r, n) => `${r}${n.toUpperCase()}`).replace(/ +/g, " ").trim();
}
o(tC, "toStartCaseStr");

// src/csf/includeConditionalArg.ts
var $g = De(rC(), 1);
var nC = /* @__PURE__ */ o((e) => e.map((t) => typeof t < "u").filter(Boolean).length, "count"), nW = /* @__PURE__ */ o((e, t) => {
  let { exists: r, eq: n, neq: i, truthy: s } = e;
  if (nC([r, n, i, s]) > 1)
    throw new Error(`Invalid conditional test ${JSON.stringify({ exists: r, eq: n, neq: i })}`);
  if (typeof n < "u")
    return (0, $g.isEqual)(t, n);
  if (typeof i < "u")
    return !(0, $g.isEqual)(t, i);
  if (typeof r < "u") {
    let l = typeof t < "u";
    return r ? l : !l;
  }
  return (typeof s > "u" ? !0 : s) ? !!t : !t;
}, "testValue"), Bg = /* @__PURE__ */ o((e, t, r) => {
  if (!e.if)
    return !0;
  let { arg: n, global: i } = e.if;
  if (nC([n, i]) !== 1)
    throw new Error(`Invalid conditional value ${JSON.stringify({ arg: n, global: i })}`);
  let s = n ? t[n] : r[i];
  return nW(e.if, s);
}, "includeConditionalArg");

// ../node_modules/tinyrainbow/dist/chunk-BVHSVHOK.js
var oW = {
  reset: [0, 0],
  bold: [1, 22, "\x1B[22m\x1B[1m"],
  dim: [2, 22, "\x1B[22m\x1B[2m"],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
}, iW = Object.entries(oW);
function Ug(e) {
  return String(e);
}
o(Ug, "a");
Ug.open = "";
Ug.close = "";
function oC(e = !1) {
  let t = typeof process < "u" ? process : void 0, r = t?.env || {}, n = t?.argv || [];
  return !("NO_COLOR" in r || n.includes("--no-color")) && ("FORCE_COLOR" in r || n.includes("--color") || t?.platform === "win32" || e && r.
  TERM !== "dumb" || "CI" in r) || typeof window < "u" && !!window.chrome;
}
o(oC, "C");
function iC(e = !1) {
  let t = oC(e), r = /* @__PURE__ */ o((a, l, u, c) => {
    let d = "", p = 0;
    do
      d += a.substring(p, c) + u, p = c + l.length, c = a.indexOf(l, p);
    while (~c);
    return d + a.substring(p);
  }, "i"), n = /* @__PURE__ */ o((a, l, u = a) => {
    let c = /* @__PURE__ */ o((d) => {
      let p = String(d), y = p.indexOf(l, a.length);
      return ~y ? a + r(p, l, u, y) + l : a + p + l;
    }, "o");
    return c.open = a, c.close = l, c;
  }, "g"), i = {
    isColorSupported: t
  }, s = /* @__PURE__ */ o((a) => `\x1B[${a}m`, "d");
  for (let [a, l] of iW)
    i[a] = t ? n(
      s(l[0]),
      s(l[1]),
      l[2]
    ) : Ug;
  return i;
}
o(iC, "p");

// ../node_modules/tinyrainbow/dist/browser.js
var ae = iC();

// ../node_modules/@vitest/pretty-format/dist/index.js
function gC(e, t) {
  return t.forEach(function(r) {
    r && typeof r != "string" && !Array.isArray(r) && Object.keys(r).forEach(function(n) {
      if (n !== "default" && !(n in e)) {
        var i = Object.getOwnPropertyDescriptor(r, n);
        Object.defineProperty(e, n, i.get ? i : {
          enumerable: !0,
          get: /* @__PURE__ */ o(function() {
            return r[n];
          }, "get")
        });
      }
    });
  }), Object.freeze(e);
}
o(gC, "_mergeNamespaces");
function sW(e, t) {
  let r = Object.keys(e), n = t === null ? r : r.sort(t);
  if (Object.getOwnPropertySymbols)
    for (let i of Object.getOwnPropertySymbols(e))
      Object.getOwnPropertyDescriptor(e, i).enumerable && n.push(i);
  return n;
}
o(sW, "getKeysOfEnumerableProperties");
function cs(e, t, r, n, i, s, a = ": ") {
  let l = "", u = 0, c = e.next();
  if (!c.done) {
    l += t.spacingOuter;
    let d = r + t.indent;
    for (; !c.done; ) {
      if (l += d, u++ === t.maxWidth) {
        l += "\u2026";
        break;
      }
      let p = s(c.value[0], t, d, n, i), y = s(c.value[1], t, d, n, i);
      l += p + a + y, c = e.next(), c.done ? t.min || (l += ",") : l += `,${t.spacingInner}`;
    }
    l += t.spacingOuter + r;
  }
  return l;
}
o(cs, "printIteratorEntries");
function Yg(e, t, r, n, i, s) {
  let a = "", l = 0, u = e.next();
  if (!u.done) {
    a += t.spacingOuter;
    let c = r + t.indent;
    for (; !u.done; ) {
      if (a += c, l++ === t.maxWidth) {
        a += "\u2026";
        break;
      }
      a += s(u.value, t, c, n, i), u = e.next(), u.done ? t.min || (a += ",") : a += `,${t.spacingInner}`;
    }
    a += t.spacingOuter + r;
  }
  return a;
}
o(Yg, "printIteratorValues");
function Tl(e, t, r, n, i, s) {
  let a = "";
  e = e instanceof ArrayBuffer ? new DataView(e) : e;
  let l = /* @__PURE__ */ o((c) => c instanceof DataView, "isDataView"), u = l(e) ? e.byteLength : e.length;
  if (u > 0) {
    a += t.spacingOuter;
    let c = r + t.indent;
    for (let d = 0; d < u; d++) {
      if (a += c, d === t.maxWidth) {
        a += "\u2026";
        break;
      }
      (l(e) || d in e) && (a += s(l(e) ? e.getInt8(d) : e[d], t, c, n, i)), d < u - 1 ? a += `,${t.spacingInner}` : t.min || (a += ",");
    }
    a += t.spacingOuter + r;
  }
  return a;
}
o(Tl, "printListItems");
function Wg(e, t, r, n, i, s) {
  let a = "", l = sW(e, t.compareKeys);
  if (l.length > 0) {
    a += t.spacingOuter;
    let u = r + t.indent;
    for (let c = 0; c < l.length; c++) {
      let d = l[c], p = s(d, t, u, n, i), y = s(e[d], t, u, n, i);
      a += `${u + p}: ${y}`, c < l.length - 1 ? a += `,${t.spacingInner}` : t.min || (a += ",");
    }
    a += t.spacingOuter + r;
  }
  return a;
}
o(Wg, "printObjectProperties");
var aW = typeof Symbol == "function" && Symbol.for ? Symbol.for("jest.asymmetricMatcher") : 1267621, vl = " ", lW = /* @__PURE__ */ o((e, t, r, n, i, s) => {
  let a = e.toString();
  if (a === "ArrayContaining" || a === "ArrayNotContaining")
    return ++n > t.maxDepth ? `[${a}]` : `${a + vl}[${Tl(e.sample, t, r, n, i, s)}]`;
  if (a === "ObjectContaining" || a === "ObjectNotContaining")
    return ++n > t.maxDepth ? `[${a}]` : `${a + vl}{${Wg(e.sample, t, r, n, i, s)}}`;
  if (a === "StringMatching" || a === "StringNotMatching" || a === "StringContaining" || a === "StringNotContaining")
    return a + vl + s(e.sample, t, r, n, i);
  if (typeof e.toAsymmetricMatcher != "function")
    throw new TypeError(`Asymmetric matcher ${e.constructor.name} does not implement toAsymmetricMatcher()`);
  return e.toAsymmetricMatcher();
}, "serialize$5"), uW = /* @__PURE__ */ o((e) => e && e.$$typeof === aW, "test$5"), cW = {
  serialize: lW,
  test: uW
}, dW = " ", vC = /* @__PURE__ */ new Set(["DOMStringMap", "NamedNodeMap"]), pW = /^(?:HTML\w*Collection|NodeList)$/;
function fW(e) {
  return vC.has(e) || pW.test(e);
}
o(fW, "testName");
var mW = /* @__PURE__ */ o((e) => e && e.constructor && !!e.constructor.name && fW(e.constructor.name), "test$4");
function hW(e) {
  return e.constructor.name === "NamedNodeMap";
}
o(hW, "isNamedNodeMap");
var yW = /* @__PURE__ */ o((e, t, r, n, i, s) => {
  let a = e.constructor.name;
  return ++n > t.maxDepth ? `[${a}]` : (t.min ? "" : a + dW) + (vC.has(a) ? `{${Wg(hW(e) ? [...e].reduce((l, u) => (l[u.name] = u.value, l),
  {}) : { ...e }, t, r, n, i, s)}}` : `[${Tl([...e], t, r, n, i, s)}]`);
}, "serialize$4"), bW = {
  serialize: yW,
  test: mW
};
function EC(e) {
  return e.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
o(EC, "escapeHTML");
function Kg(e, t, r, n, i, s, a) {
  let l = n + r.indent, u = r.colors;
  return e.map((c) => {
    let d = t[c], p = a(d, r, l, i, s);
    return typeof d != "string" && (p.includes(`
`) && (p = r.spacingOuter + l + p + r.spacingOuter + n), p = `{${p}}`), `${r.spacingInner + n + u.prop.open + c + u.prop.close}=${u.value.open}${p}${u.
    value.close}`;
  }).join("");
}
o(Kg, "printProps");
function Xg(e, t, r, n, i, s) {
  return e.map((a) => t.spacingOuter + r + (typeof a == "string" ? TC(a, t) : s(a, t, r, n, i))).join("");
}
o(Xg, "printChildren");
function TC(e, t) {
  let r = t.colors.content;
  return r.open + EC(e) + r.close;
}
o(TC, "printText");
function gW(e, t) {
  let r = t.colors.comment;
  return `${r.open}<!--${EC(e)}-->${r.close}`;
}
o(gW, "printComment");
function Jg(e, t, r, n, i) {
  let s = n.colors.tag;
  return `${s.open}<${e}${t && s.close + t + n.spacingOuter + i + s.open}${r ? `>${s.close}${r}${n.spacingOuter}${i}${s.open}</${e}` : `${t &&
  !n.min ? "" : " "}/`}>${s.close}`;
}
o(Jg, "printElement");
function Zg(e, t) {
  let r = t.colors.tag;
  return `${r.open}<${e}${r.close} \u2026${r.open} />${r.close}`;
}
o(Zg, "printElementAsLeaf");
var vW = 1, _C = 3, RC = 8, wC = 11, EW = /^(?:(?:HTML|SVG)\w*)?Element$/;
function TW(e) {
  try {
    return typeof e.hasAttribute == "function" && e.hasAttribute("is");
  } catch {
    return !1;
  }
}
o(TW, "testHasAttribute");
function _W(e) {
  let t = e.constructor.name, { nodeType: r, tagName: n } = e, i = typeof n == "string" && n.includes("-") || TW(e);
  return r === vW && (EW.test(t) || i) || r === _C && t === "Text" || r === RC && t === "Comment" || r === wC && t === "DocumentFragment";
}
o(_W, "testNode");
var RW = /* @__PURE__ */ o((e) => {
  var t;
  return (e == null || (t = e.constructor) === null || t === void 0 ? void 0 : t.name) && _W(e);
}, "test$3");
function wW(e) {
  return e.nodeType === _C;
}
o(wW, "nodeIsText");
function SW(e) {
  return e.nodeType === RC;
}
o(SW, "nodeIsComment");
function Hg(e) {
  return e.nodeType === wC;
}
o(Hg, "nodeIsFragment");
var xW = /* @__PURE__ */ o((e, t, r, n, i, s) => {
  if (wW(e))
    return TC(e.data, t);
  if (SW(e))
    return gW(e.data, t);
  let a = Hg(e) ? "DocumentFragment" : e.tagName.toLowerCase();
  return ++n > t.maxDepth ? Zg(a, t) : Jg(a, Kg(Hg(e) ? [] : Array.from(e.attributes, (l) => l.name).sort(), Hg(e) ? {} : [...e.attributes].
  reduce((l, u) => (l[u.name] = u.value, l), {}), t, r + t.indent, n, i, s), Xg(Array.prototype.slice.call(e.childNodes || e.children), t, r +
  t.indent, n, i, s), t, r);
}, "serialize$3"), CW = {
  serialize: xW,
  test: RW
}, PW = "@@__IMMUTABLE_ITERABLE__@@", AW = "@@__IMMUTABLE_LIST__@@", OW = "@@__IMMUTABLE_KEYED__@@", qW = "@@__IMMUTABLE_MAP__@@", sC = "@@_\
_IMMUTABLE_ORDERED__@@", IW = "@@__IMMUTABLE_RECORD__@@", MW = "@@__IMMUTABLE_SEQ__@@", NW = "@@__IMMUTABLE_SET__@@", jW = "@@__IMMUTABLE_ST\
ACK__@@", qo = /* @__PURE__ */ o((e) => `Immutable.${e}`, "getImmutableName"), Rl = /* @__PURE__ */ o((e) => `[${e}]`, "printAsLeaf"), us = "\
 ", aC = "\u2026";
function LW(e, t, r, n, i, s, a) {
  return ++n > t.maxDepth ? Rl(qo(a)) : `${qo(a) + us}{${cs(e.entries(), t, r, n, i, s)}}`;
}
o(LW, "printImmutableEntries");
function FW(e) {
  let t = 0;
  return { next() {
    if (t < e._keys.length) {
      let r = e._keys[t++];
      return {
        done: !1,
        value: [r, e.get(r)]
      };
    }
    return {
      done: !0,
      value: void 0
    };
  } };
}
o(FW, "getRecordEntries");
function kW(e, t, r, n, i, s) {
  let a = qo(e._name || "Record");
  return ++n > t.maxDepth ? Rl(a) : `${a + us}{${cs(FW(e), t, r, n, i, s)}}`;
}
o(kW, "printImmutableRecord");
function DW(e, t, r, n, i, s) {
  let a = qo("Seq");
  return ++n > t.maxDepth ? Rl(a) : e[OW] ? `${a + us}{${e._iter || e._object ? cs(e.entries(), t, r, n, i, s) : aC}}` : `${a + us}[${e._iter ||
  e._array || e._collection || e._iterable ? Yg(e.values(), t, r, n, i, s) : aC}]`;
}
o(DW, "printImmutableSeq");
function Vg(e, t, r, n, i, s, a) {
  return ++n > t.maxDepth ? Rl(qo(a)) : `${qo(a) + us}[${Yg(e.values(), t, r, n, i, s)}]`;
}
o(Vg, "printImmutableValues");
var $W = /* @__PURE__ */ o((e, t, r, n, i, s) => e[qW] ? LW(e, t, r, n, i, s, e[sC] ? "OrderedMap" : "Map") : e[AW] ? Vg(e, t, r, n, i, s, "\
List") : e[NW] ? Vg(e, t, r, n, i, s, e[sC] ? "OrderedSet" : "Set") : e[jW] ? Vg(e, t, r, n, i, s, "Stack") : e[MW] ? DW(e, t, r, n, i, s) :
kW(e, t, r, n, i, s), "serialize$2"), BW = /* @__PURE__ */ o((e) => e && (e[PW] === !0 || e[IW] === !0), "test$2"), UW = {
  serialize: $W,
  test: BW
};
function SC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
o(SC, "getDefaultExportFromCjs");
var zg = { exports: {} }, Ee = {};
var lC;
function HW() {
  if (lC) return Ee;
  lC = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.\
strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.fo\
rward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.la\
zy"), y = Symbol.for("react.view_transition"), f = Symbol.for("react.client.reference");
  function m(h) {
    if (typeof h == "object" && h !== null) {
      var b = h.$$typeof;
      switch (b) {
        case e:
          switch (h = h.type, h) {
            case r:
            case i:
            case n:
            case u:
            case c:
            case y:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case a:
                case l:
                case p:
                case d:
                  return h;
                case s:
                  return h;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return o(m, "typeOf"), Ee.ContextConsumer = s, Ee.ContextProvider = a, Ee.Element = e, Ee.ForwardRef = l, Ee.Fragment = r, Ee.Lazy = p, Ee.
  Memo = d, Ee.Portal = t, Ee.Profiler = i, Ee.StrictMode = n, Ee.Suspense = u, Ee.SuspenseList = c, Ee.isContextConsumer = function(h) {
    return m(h) === s;
  }, Ee.isContextProvider = function(h) {
    return m(h) === a;
  }, Ee.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, Ee.isForwardRef = function(h) {
    return m(h) === l;
  }, Ee.isFragment = function(h) {
    return m(h) === r;
  }, Ee.isLazy = function(h) {
    return m(h) === p;
  }, Ee.isMemo = function(h) {
    return m(h) === d;
  }, Ee.isPortal = function(h) {
    return m(h) === t;
  }, Ee.isProfiler = function(h) {
    return m(h) === i;
  }, Ee.isStrictMode = function(h) {
    return m(h) === n;
  }, Ee.isSuspense = function(h) {
    return m(h) === u;
  }, Ee.isSuspenseList = function(h) {
    return m(h) === c;
  }, Ee.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === i || h === n || h === u || h === c || typeof h == "object" && h !==
    null && (h.$$typeof === p || h.$$typeof === d || h.$$typeof === a || h.$$typeof === s || h.$$typeof === l || h.$$typeof === f || h.getModuleId !==
    void 0);
  }, Ee.typeOf = m, Ee;
}
o(HW, "requireReactIs_production");
var uC;
function VW() {
  return uC || (uC = 1, zg.exports = HW()), zg.exports;
}
o(VW, "requireReactIs$1");
var xC = VW(), zW = /* @__PURE__ */ SC(xC), GW = /* @__PURE__ */ gC({
  __proto__: null,
  default: zW
}, [xC]), Gg = { exports: {} }, ye = {};
var cC;
function YW() {
  if (cC) return ye;
  cC = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"),
  i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"),
  u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"),
  y = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function h(b) {
    if (typeof b == "object" && b !== null) {
      var g = b.$$typeof;
      switch (g) {
        case e:
          switch (b = b.type, b) {
            case r:
            case i:
            case n:
            case c:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case l:
                case a:
                case u:
                case y:
                case p:
                case s:
                  return b;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  return o(h, "v"), ye.ContextConsumer = a, ye.ContextProvider = s, ye.Element = e, ye.ForwardRef = u, ye.Fragment = r, ye.Lazy = y, ye.Memo =
  p, ye.Portal = t, ye.Profiler = i, ye.StrictMode = n, ye.Suspense = c, ye.SuspenseList = d, ye.isAsyncMode = function() {
    return !1;
  }, ye.isConcurrentMode = function() {
    return !1;
  }, ye.isContextConsumer = function(b) {
    return h(b) === a;
  }, ye.isContextProvider = function(b) {
    return h(b) === s;
  }, ye.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, ye.isForwardRef = function(b) {
    return h(b) === u;
  }, ye.isFragment = function(b) {
    return h(b) === r;
  }, ye.isLazy = function(b) {
    return h(b) === y;
  }, ye.isMemo = function(b) {
    return h(b) === p;
  }, ye.isPortal = function(b) {
    return h(b) === t;
  }, ye.isProfiler = function(b) {
    return h(b) === i;
  }, ye.isStrictMode = function(b) {
    return h(b) === n;
  }, ye.isSuspense = function(b) {
    return h(b) === c;
  }, ye.isSuspenseList = function(b) {
    return h(b) === d;
  }, ye.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === i || b === n || b === c || b === d || b === f || typeof b == "\
object" && b !== null && (b.$$typeof === y || b.$$typeof === p || b.$$typeof === s || b.$$typeof === a || b.$$typeof === u || b.$$typeof ===
    m || b.getModuleId !== void 0);
  }, ye.typeOf = h, ye;
}
o(YW, "requireReactIs_production_min");
var dC;
function WW() {
  return dC || (dC = 1, Gg.exports = YW()), Gg.exports;
}
o(WW, "requireReactIs");
var CC = WW(), KW = /* @__PURE__ */ SC(CC), XW = /* @__PURE__ */ gC({
  __proto__: null,
  default: KW
}, [CC]), JW = [
  "isAsyncMode",
  "isConcurrentMode",
  "isContextConsumer",
  "isContextProvider",
  "isElement",
  "isForwardRef",
  "isFragment",
  "isLazy",
  "isMemo",
  "isPortal",
  "isProfiler",
  "isStrictMode",
  "isSuspense",
  "isSuspenseList",
  "isValidElementType"
], Cn = Object.fromEntries(JW.map((e) => [e, (t) => XW[e](t) || GW[e](t)]));
function PC(e, t = []) {
  if (Array.isArray(e))
    for (let r of e)
      PC(r, t);
  else e != null && e !== !1 && e !== "" && t.push(e);
  return t;
}
o(PC, "getChildren");
function pC(e) {
  let t = e.type;
  if (typeof t == "string")
    return t;
  if (typeof t == "function")
    return t.displayName || t.name || "Unknown";
  if (Cn.isFragment(e))
    return "React.Fragment";
  if (Cn.isSuspense(e))
    return "React.Suspense";
  if (typeof t == "object" && t !== null) {
    if (Cn.isContextProvider(e))
      return "Context.Provider";
    if (Cn.isContextConsumer(e))
      return "Context.Consumer";
    if (Cn.isForwardRef(e)) {
      if (t.displayName)
        return t.displayName;
      let r = t.render.displayName || t.render.name || "";
      return r === "" ? "ForwardRef" : `ForwardRef(${r})`;
    }
    if (Cn.isMemo(e)) {
      let r = t.displayName || t.type.displayName || t.type.name || "";
      return r === "" ? "Memo" : `Memo(${r})`;
    }
  }
  return "UNDEFINED";
}
o(pC, "getType");
function ZW(e) {
  let { props: t } = e;
  return Object.keys(t).filter((r) => r !== "children" && t[r] !== void 0).sort();
}
o(ZW, "getPropKeys$1");
var QW = /* @__PURE__ */ o((e, t, r, n, i, s) => ++n > t.maxDepth ? Zg(pC(e), t) : Jg(pC(e), Kg(ZW(e), e.props, t, r + t.indent, n, i, s), Xg(
PC(e.props.children), t, r + t.indent, n, i, s), t, r), "serialize$1"), e6 = /* @__PURE__ */ o((e) => e != null && Cn.isElement(e), "test$1"),
t6 = {
  serialize: QW,
  test: e6
}, r6 = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.test.json") : 245830487;
function n6(e) {
  let { props: t } = e;
  return t ? Object.keys(t).filter((r) => t[r] !== void 0).sort() : [];
}
o(n6, "getPropKeys");
var o6 = /* @__PURE__ */ o((e, t, r, n, i, s) => ++n > t.maxDepth ? Zg(e.type, t) : Jg(e.type, e.props ? Kg(n6(e), e.props, t, r + t.indent,
n, i, s) : "", e.children ? Xg(e.children, t, r + t.indent, n, i, s) : "", t, r), "serialize"), i6 = /* @__PURE__ */ o((e) => e && e.$$typeof ===
r6, "test"), s6 = {
  serialize: o6,
  test: i6
}, AC = Object.prototype.toString, a6 = Date.prototype.toISOString, l6 = Error.prototype.toString, fC = RegExp.prototype.toString;
function El(e) {
  return typeof e.constructor == "function" && e.constructor.name || "Object";
}
o(El, "getConstructorName");
function u6(e) {
  return typeof window < "u" && e === window;
}
o(u6, "isWindow");
var c6 = /^Symbol\((.*)\)(.*)$/, d6 = /\n/g, ev = class ev extends Error {
  constructor(t, r) {
    super(t), this.stack = r, this.name = this.constructor.name;
  }
};
o(ev, "PrettyFormatPluginError");
var _l = ev;
function p6(e) {
  return e === "[object Array]" || e === "[object ArrayBuffer]" || e === "[object DataView]" || e === "[object Float32Array]" || e === "[obj\
ect Float64Array]" || e === "[object Int8Array]" || e === "[object Int16Array]" || e === "[object Int32Array]" || e === "[object Uint8Array]" ||
  e === "[object Uint8ClampedArray]" || e === "[object Uint16Array]" || e === "[object Uint32Array]";
}
o(p6, "isToStringedArrayType");
function f6(e) {
  return Object.is(e, -0) ? "-0" : String(e);
}
o(f6, "printNumber");
function m6(e) {
  return `${e}n`;
}
o(m6, "printBigInt");
function mC(e, t) {
  return t ? `[Function ${e.name || "anonymous"}]` : "[Function]";
}
o(mC, "printFunction");
function hC(e) {
  return String(e).replace(c6, "Symbol($1)");
}
o(hC, "printSymbol");
function yC(e) {
  return `[${l6.call(e)}]`;
}
o(yC, "printError");
function OC(e, t, r, n) {
  if (e === !0 || e === !1)
    return `${e}`;
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  let i = typeof e;
  if (i === "number")
    return f6(e);
  if (i === "bigint")
    return m6(e);
  if (i === "string")
    return n ? `"${e.replaceAll(/"|\\/g, "\\$&")}"` : `"${e}"`;
  if (i === "function")
    return mC(e, t);
  if (i === "symbol")
    return hC(e);
  let s = AC.call(e);
  return s === "[object WeakMap]" ? "WeakMap {}" : s === "[object WeakSet]" ? "WeakSet {}" : s === "[object Function]" || s === "[object Gen\
eratorFunction]" ? mC(e, t) : s === "[object Symbol]" ? hC(e) : s === "[object Date]" ? Number.isNaN(+e) ? "Date { NaN }" : a6.call(e) : s ===
  "[object Error]" ? yC(e) : s === "[object RegExp]" ? r ? fC.call(e).replaceAll(/[$()*+.?[\\\]^{|}]/g, "\\$&") : fC.call(e) : e instanceof Error ?
  yC(e) : null;
}
o(OC, "printBasicValue");
function qC(e, t, r, n, i, s) {
  if (i.includes(e))
    return "[Circular]";
  i = [...i], i.push(e);
  let a = ++n > t.maxDepth, l = t.min;
  if (t.callToJSON && !a && e.toJSON && typeof e.toJSON == "function" && !s)
    return $r(e.toJSON(), t, r, n, i, !0);
  let u = AC.call(e);
  return u === "[object Arguments]" ? a ? "[Arguments]" : `${l ? "" : "Arguments "}[${Tl(e, t, r, n, i, $r)}]` : p6(u) ? a ? `[${e.constructor.
  name}]` : `${l || !t.printBasicPrototype && e.constructor.name === "Array" ? "" : `${e.constructor.name} `}[${Tl(e, t, r, n, i, $r)}]` : u ===
  "[object Map]" ? a ? "[Map]" : `Map {${cs(e.entries(), t, r, n, i, $r, " => ")}}` : u === "[object Set]" ? a ? "[Set]" : `Set {${Yg(e.values(),
  t, r, n, i, $r)}}` : a || u6(e) ? `[${El(e)}]` : `${l || !t.printBasicPrototype && El(e) === "Object" ? "" : `${El(e)} `}{${Wg(e, t, r, n,
  i, $r)}}`;
}
o(qC, "printComplexValue");
var h6 = {
  test: /* @__PURE__ */ o((e) => e && e instanceof Error, "test"),
  serialize(e, t, r, n, i, s) {
    if (i.includes(e))
      return "[Circular]";
    i = [...i, e];
    let a = ++n > t.maxDepth, { message: l, cause: u, ...c } = e, d = {
      message: l,
      ...typeof u < "u" ? { cause: u } : {},
      ...e instanceof AggregateError ? { errors: e.errors } : {},
      ...c
    }, p = e.name !== "Error" ? e.name : El(e);
    return a ? `[${p}]` : `${p} {${cs(Object.entries(d).values(), t, r, n, i, s)}}`;
  }
};
function y6(e) {
  return e.serialize != null;
}
o(y6, "isNewPlugin");
function IC(e, t, r, n, i, s) {
  let a;
  try {
    a = y6(e) ? e.serialize(t, r, n, i, s, $r) : e.print(t, (l) => $r(l, r, n, i, s), (l) => {
      let u = n + r.indent;
      return u + l.replaceAll(d6, `
${u}`);
    }, {
      edgeSpacing: r.spacingOuter,
      min: r.min,
      spacing: r.spacingInner
    }, r.colors);
  } catch (l) {
    throw new _l(l.message, l.stack);
  }
  if (typeof a != "string")
    throw new TypeError(`pretty-format: Plugin must return type "string" but instead returned "${typeof a}".`);
  return a;
}
o(IC, "printPlugin");
function MC(e, t) {
  for (let r of e)
    try {
      if (r.test(t))
        return r;
    } catch (n) {
      throw new _l(n.message, n.stack);
    }
  return null;
}
o(MC, "findPlugin");
function $r(e, t, r, n, i, s) {
  let a = MC(t.plugins, e);
  if (a !== null)
    return IC(a, e, t, r, n, i);
  let l = OC(e, t.printFunctionName, t.escapeRegex, t.escapeString);
  return l !== null ? l : qC(e, t, r, n, i, s);
}
o($r, "printer");
var Qg = {
  comment: "gray",
  content: "reset",
  prop: "yellow",
  tag: "cyan",
  value: "green"
}, NC = Object.keys(Qg), Vt = {
  callToJSON: !0,
  compareKeys: void 0,
  escapeRegex: !1,
  escapeString: !0,
  highlight: !1,
  indent: 2,
  maxDepth: Number.POSITIVE_INFINITY,
  maxWidth: Number.POSITIVE_INFINITY,
  min: !1,
  plugins: [],
  printBasicPrototype: !0,
  printFunctionName: !0,
  theme: Qg
};
function b6(e) {
  for (let t of Object.keys(e))
    if (!Object.prototype.hasOwnProperty.call(Vt, t))
      throw new Error(`pretty-format: Unknown option "${t}".`);
  if (e.min && e.indent !== void 0 && e.indent !== 0)
    throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
}
o(b6, "validateOptions");
function g6() {
  return NC.reduce((e, t) => {
    let r = Qg[t], n = r && ae[r];
    if (n && typeof n.close == "string" && typeof n.open == "string")
      e[t] = n;
    else
      throw new Error(`pretty-format: Option "theme" has a key "${t}" whose value "${r}" is undefined in ansi-styles.`);
    return e;
  }, /* @__PURE__ */ Object.create(null));
}
o(g6, "getColorsHighlight");
function v6() {
  return NC.reduce((e, t) => (e[t] = {
    close: "",
    open: ""
  }, e), /* @__PURE__ */ Object.create(null));
}
o(v6, "getColorsEmpty");
function jC(e) {
  return e?.printFunctionName ?? Vt.printFunctionName;
}
o(jC, "getPrintFunctionName");
function LC(e) {
  return e?.escapeRegex ?? Vt.escapeRegex;
}
o(LC, "getEscapeRegex");
function FC(e) {
  return e?.escapeString ?? Vt.escapeString;
}
o(FC, "getEscapeString");
function bC(e) {
  return {
    callToJSON: e?.callToJSON ?? Vt.callToJSON,
    colors: e?.highlight ? g6() : v6(),
    compareKeys: typeof e?.compareKeys == "function" || e?.compareKeys === null ? e.compareKeys : Vt.compareKeys,
    escapeRegex: LC(e),
    escapeString: FC(e),
    indent: e?.min ? "" : E6(e?.indent ?? Vt.indent),
    maxDepth: e?.maxDepth ?? Vt.maxDepth,
    maxWidth: e?.maxWidth ?? Vt.maxWidth,
    min: e?.min ?? Vt.min,
    plugins: e?.plugins ?? Vt.plugins,
    printBasicPrototype: e?.printBasicPrototype ?? !0,
    printFunctionName: jC(e),
    spacingInner: e?.min ? " " : `
`,
    spacingOuter: e?.min ? "" : `
`
  };
}
o(bC, "getConfig");
function E6(e) {
  return Array.from({ length: e + 1 }).join(" ");
}
o(E6, "createIndent");
function qt(e, t) {
  if (t && (b6(t), t.plugins)) {
    let n = MC(t.plugins, e);
    if (n !== null)
      return IC(n, e, bC(t), "", 0, []);
  }
  let r = OC(e, jC(t), LC(t), FC(t));
  return r !== null ? r : qC(e, bC(t), "", 0, []);
}
o(qt, "format");
var ds = {
  AsymmetricMatcher: cW,
  DOMCollection: bW,
  DOMElement: CW,
  Immutable: UW,
  ReactElement: t6,
  ReactTestComponent: s6,
  Error: h6
};

// ../node_modules/loupe/lib/helpers.js
var kC = {
  bold: ["1", "22"],
  dim: ["2", "22"],
  italic: ["3", "23"],
  underline: ["4", "24"],
  // 5 & 6 are blinking
  inverse: ["7", "27"],
  hidden: ["8", "28"],
  strike: ["9", "29"],
  // 10-20 are fonts
  // 21-29 are resets for 1-9
  black: ["30", "39"],
  red: ["31", "39"],
  green: ["32", "39"],
  yellow: ["33", "39"],
  blue: ["34", "39"],
  magenta: ["35", "39"],
  cyan: ["36", "39"],
  white: ["37", "39"],
  brightblack: ["30;1", "39"],
  brightred: ["31;1", "39"],
  brightgreen: ["32;1", "39"],
  brightyellow: ["33;1", "39"],
  brightblue: ["34;1", "39"],
  brightmagenta: ["35;1", "39"],
  brightcyan: ["36;1", "39"],
  brightwhite: ["37;1", "39"],
  grey: ["90", "39"]
}, T6 = {
  special: "cyan",
  number: "yellow",
  bigint: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  symbol: "green",
  date: "magenta",
  regexp: "red"
}, Tr = "\u2026";
function _6(e, t) {
  let r = kC[T6[t]] || kC[t] || "";
  return r ? `\x1B[${r[0]}m${String(e)}\x1B[${r[1]}m` : String(e);
}
o(_6, "colorise");
function DC({
  showHidden: e = !1,
  depth: t = 2,
  colors: r = !1,
  customInspect: n = !0,
  showProxy: i = !1,
  maxArrayLength: s = 1 / 0,
  breakLength: a = 1 / 0,
  seen: l = [],
  // eslint-disable-next-line no-shadow
  truncate: u = 1 / 0,
  stylize: c = String
} = {}, d) {
  let p = {
    showHidden: !!e,
    depth: Number(t),
    colors: !!r,
    customInspect: !!n,
    showProxy: !!i,
    maxArrayLength: Number(s),
    breakLength: Number(a),
    truncate: Number(u),
    seen: l,
    inspect: d,
    stylize: c
  };
  return p.colors && (p.stylize = _6), p;
}
o(DC, "normaliseOptions");
function R6(e) {
  return e >= "\uD800" && e <= "\uDBFF";
}
o(R6, "isHighSurrogate");
function st(e, t, r = Tr) {
  e = String(e);
  let n = r.length, i = e.length;
  if (n > t && i > n)
    return r;
  if (i > t && i > n) {
    let s = t - n;
    return s > 0 && R6(e[s - 1]) && (s = s - 1), `${e.slice(0, s)}${r}`;
  }
  return e;
}
o(st, "truncate");
function He(e, t, r, n = ", ") {
  r = r || t.inspect;
  let i = e.length;
  if (i === 0)
    return "";
  let s = t.truncate, a = "", l = "", u = "";
  for (let c = 0; c < i; c += 1) {
    let d = c + 1 === e.length, p = c + 2 === e.length;
    u = `${Tr}(${e.length - c})`;
    let y = e[c];
    t.truncate = s - a.length - (d ? 0 : n.length);
    let f = l || r(y, t) + (d ? "" : n), m = a.length + f.length, h = m + u.length;
    if (d && m > s && a.length + u.length <= s || !d && !p && h > s || (l = d ? "" : r(e[c + 1], t) + (p ? "" : n), !d && p && h > s && m + l.
    length > s))
      break;
    if (a += f, !d && !p && m + l.length >= s) {
      u = `${Tr}(${e.length - c - 1})`;
      break;
    }
    u = "";
  }
  return `${a}${u}`;
}
o(He, "inspectList");
function w6(e) {
  return e.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) ? e : JSON.stringify(e).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
}
o(w6, "quoteComplexKey");
function _r([e, t], r) {
  return r.truncate -= 2, typeof e == "string" ? e = w6(e) : typeof e != "number" && (e = `[${r.inspect(e, r)}]`), r.truncate -= e.length, t =
  r.inspect(t, r), `${e}: ${t}`;
}
o(_r, "inspectProperty");

// ../node_modules/loupe/lib/array.js
function tv(e, t) {
  let r = Object.keys(e).slice(e.length);
  if (!e.length && !r.length)
    return "[]";
  t.truncate -= 4;
  let n = He(e, t);
  t.truncate -= n.length;
  let i = "";
  return r.length && (i = He(r.map((s) => [s, e[s]]), t, _r)), `[ ${n}${i ? `, ${i}` : ""} ]`;
}
o(tv, "inspectArray");

// ../node_modules/loupe/lib/typedarray.js
var S6 = /* @__PURE__ */ o((e) => typeof Buffer == "function" && e instanceof Buffer ? "Buffer" : e[Symbol.toStringTag] ? e[Symbol.toStringTag] :
e.constructor.name, "getArrayName");
function zt(e, t) {
  let r = S6(e);
  t.truncate -= r.length + 4;
  let n = Object.keys(e).slice(e.length);
  if (!e.length && !n.length)
    return `${r}[]`;
  let i = "";
  for (let a = 0; a < e.length; a++) {
    let l = `${t.stylize(st(e[a], t.truncate), "number")}${a === e.length - 1 ? "" : ", "}`;
    if (t.truncate -= l.length, e[a] !== e.length && t.truncate <= 3) {
      i += `${Tr}(${e.length - e[a] + 1})`;
      break;
    }
    i += l;
  }
  let s = "";
  return n.length && (s = He(n.map((a) => [a, e[a]]), t, _r)), `${r}[ ${i}${s ? `, ${s}` : ""} ]`;
}
o(zt, "inspectTypedArray");

// ../node_modules/loupe/lib/date.js
function rv(e, t) {
  let r = e.toJSON();
  if (r === null)
    return "Invalid Date";
  let n = r.split("T"), i = n[0];
  return t.stylize(`${i}T${st(n[1], t.truncate - i.length - 1)}`, "date");
}
o(rv, "inspectDate");

// ../node_modules/loupe/lib/function.js
function wl(e, t) {
  let r = e[Symbol.toStringTag] || "Function", n = e.name;
  return n ? t.stylize(`[${r} ${st(n, t.truncate - 11)}]`, "special") : t.stylize(`[${r}]`, "special");
}
o(wl, "inspectFunction");

// ../node_modules/loupe/lib/map.js
function x6([e, t], r) {
  return r.truncate -= 4, e = r.inspect(e, r), r.truncate -= e.length, t = r.inspect(t, r), `${e} => ${t}`;
}
o(x6, "inspectMapEntry");
function C6(e) {
  let t = [];
  return e.forEach((r, n) => {
    t.push([n, r]);
  }), t;
}
o(C6, "mapToEntries");
function nv(e, t) {
  return e.size === 0 ? "Map{}" : (t.truncate -= 7, `Map{ ${He(C6(e), t, x6)} }`);
}
o(nv, "inspectMap");

// ../node_modules/loupe/lib/number.js
var P6 = Number.isNaN || ((e) => e !== e);
function Sl(e, t) {
  return P6(e) ? t.stylize("NaN", "number") : e === 1 / 0 ? t.stylize("Infinity", "number") : e === -1 / 0 ? t.stylize("-Infinity", "number") :
  e === 0 ? t.stylize(1 / e === 1 / 0 ? "+0" : "-0", "number") : t.stylize(st(String(e), t.truncate), "number");
}
o(Sl, "inspectNumber");

// ../node_modules/loupe/lib/bigint.js
function xl(e, t) {
  let r = st(e.toString(), t.truncate - 1);
  return r !== Tr && (r += "n"), t.stylize(r, "bigint");
}
o(xl, "inspectBigInt");

// ../node_modules/loupe/lib/regexp.js
function ov(e, t) {
  let r = e.toString().split("/")[2], n = t.truncate - (2 + r.length), i = e.source;
  return t.stylize(`/${st(i, n)}/${r}`, "regexp");
}
o(ov, "inspectRegExp");

// ../node_modules/loupe/lib/set.js
function A6(e) {
  let t = [];
  return e.forEach((r) => {
    t.push(r);
  }), t;
}
o(A6, "arrayFromSet");
function iv(e, t) {
  return e.size === 0 ? "Set{}" : (t.truncate -= 7, `Set{ ${He(A6(e), t)} }`);
}
o(iv, "inspectSet");

// ../node_modules/loupe/lib/string.js
var $C = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\u\
ffff]", "g"), O6 = {
  "\b": "\\b",
  "	": "\\t",
  "\n": "\\n",
  "\f": "\\f",
  "\r": "\\r",
  "'": "\\'",
  "\\": "\\\\"
}, q6 = 16, I6 = 4;
function M6(e) {
  return O6[e] || `\\u${`0000${e.charCodeAt(0).toString(q6)}`.slice(-I6)}`;
}
o(M6, "escape");
function Cl(e, t) {
  return $C.test(e) && (e = e.replace($C, M6)), t.stylize(`'${st(e, t.truncate - 2)}'`, "string");
}
o(Cl, "inspectString");

// ../node_modules/loupe/lib/symbol.js
function Pl(e) {
  return "description" in Symbol.prototype ? e.description ? `Symbol(${e.description})` : "Symbol()" : e.toString();
}
o(Pl, "inspectSymbol");

// ../node_modules/loupe/lib/promise.js
var BC = /* @__PURE__ */ o(() => "Promise{\u2026}", "getPromiseValue");
try {
  let { getPromiseDetails: e, kPending: t, kRejected: r } = process.binding("util");
  Array.isArray(e(Promise.resolve())) && (BC = /* @__PURE__ */ o((n, i) => {
    let [s, a] = e(n);
    return s === t ? "Promise{<pending>}" : `Promise${s === r ? "!" : ""}{${i.inspect(a, i)}}`;
  }, "getPromiseValue"));
} catch {
}
var UC = BC;

// ../node_modules/loupe/lib/object.js
function Pn(e, t) {
  let r = Object.getOwnPropertyNames(e), n = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e) : [];
  if (r.length === 0 && n.length === 0)
    return "{}";
  if (t.truncate -= 4, t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let i = He(r.map((l) => [l, e[l]]), t, _r), s = He(n.map((l) => [l, e[l]]), t, _r);
  t.seen.pop();
  let a = "";
  return i && s && (a = ", "), `{ ${i}${a}${s} }`;
}
o(Pn, "inspectObject");

// ../node_modules/loupe/lib/class.js
var sv = typeof Symbol < "u" && Symbol.toStringTag ? Symbol.toStringTag : !1;
function av(e, t) {
  let r = "";
  return sv && sv in e && (r = e[sv]), r = r || e.constructor.name, (!r || r === "_class") && (r = "<Anonymous Class>"), t.truncate -= r.length,
  `${r}${Pn(e, t)}`;
}
o(av, "inspectClass");

// ../node_modules/loupe/lib/arguments.js
function lv(e, t) {
  return e.length === 0 ? "Arguments[]" : (t.truncate -= 13, `Arguments[ ${He(e, t)} ]`);
}
o(lv, "inspectArguments");

// ../node_modules/loupe/lib/error.js
var N6 = [
  "stack",
  "line",
  "column",
  "name",
  "message",
  "fileName",
  "lineNumber",
  "columnNumber",
  "number",
  "description",
  "cause"
];
function uv(e, t) {
  let r = Object.getOwnPropertyNames(e).filter((a) => N6.indexOf(a) === -1), n = e.name;
  t.truncate -= n.length;
  let i = "";
  if (typeof e.message == "string" ? i = st(e.message, t.truncate) : r.unshift("message"), i = i ? `: ${i}` : "", t.truncate -= i.length + 5,
  t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let s = He(r.map((a) => [a, e[a]]), t, _r);
  return `${n}${i}${s ? ` { ${s} }` : ""}`;
}
o(uv, "inspectObject");

// ../node_modules/loupe/lib/html.js
function j6([e, t], r) {
  return r.truncate -= 3, t ? `${r.stylize(String(e), "yellow")}=${r.stylize(`"${t}"`, "string")}` : `${r.stylize(String(e), "yellow")}`;
}
o(j6, "inspectAttribute");
function Al(e, t) {
  return He(e, t, Ol, `
`);
}
o(Al, "inspectHTMLCollection");
function Ol(e, t) {
  let r = e.getAttributeNames(), n = e.tagName.toLowerCase(), i = t.stylize(`<${n}`, "special"), s = t.stylize(">", "special"), a = t.stylize(
  `</${n}>`, "special");
  t.truncate -= n.length * 2 + 5;
  let l = "";
  r.length > 0 && (l += " ", l += He(r.map((d) => [d, e.getAttribute(d)]), t, j6, " ")), t.truncate -= l.length;
  let u = t.truncate, c = Al(e.children, t);
  return c && c.length > u && (c = `${Tr}(${e.children.length})`), `${i}${l}${s}${c}${a}`;
}
o(Ol, "inspectHTML");

// ../node_modules/loupe/lib/index.js
var L6 = typeof Symbol == "function" && typeof Symbol.for == "function", cv = L6 ? Symbol.for("chai/inspect") : "@@chai/inspect", Io = !1;
try {
  let e = HC();
  Io = e.inspect ? e.inspect.custom : !1;
} catch {
  Io = !1;
}
var VC = /* @__PURE__ */ new WeakMap(), zC = {}, GC = {
  undefined: /* @__PURE__ */ o((e, t) => t.stylize("undefined", "undefined"), "undefined"),
  null: /* @__PURE__ */ o((e, t) => t.stylize("null", "null"), "null"),
  boolean: /* @__PURE__ */ o((e, t) => t.stylize(String(e), "boolean"), "boolean"),
  Boolean: /* @__PURE__ */ o((e, t) => t.stylize(String(e), "boolean"), "Boolean"),
  number: Sl,
  Number: Sl,
  bigint: xl,
  BigInt: xl,
  string: Cl,
  String: Cl,
  function: wl,
  Function: wl,
  symbol: Pl,
  // A Symbol polyfill will return `Symbol` not `symbol` from typedetect
  Symbol: Pl,
  Array: tv,
  Date: rv,
  Map: nv,
  Set: iv,
  RegExp: ov,
  Promise: UC,
  // WeakSet, WeakMap are totally opaque to us
  WeakSet: /* @__PURE__ */ o((e, t) => t.stylize("WeakSet{\u2026}", "special"), "WeakSet"),
  WeakMap: /* @__PURE__ */ o((e, t) => t.stylize("WeakMap{\u2026}", "special"), "WeakMap"),
  Arguments: lv,
  Int8Array: zt,
  Uint8Array: zt,
  Uint8ClampedArray: zt,
  Int16Array: zt,
  Uint16Array: zt,
  Int32Array: zt,
  Uint32Array: zt,
  Float32Array: zt,
  Float64Array: zt,
  Generator: /* @__PURE__ */ o(() => "", "Generator"),
  DataView: /* @__PURE__ */ o(() => "", "DataView"),
  ArrayBuffer: /* @__PURE__ */ o(() => "", "ArrayBuffer"),
  Error: uv,
  HTMLCollection: Al,
  NodeList: Al
}, F6 = /* @__PURE__ */ o((e, t, r) => cv in e && typeof e[cv] == "function" ? e[cv](t) : Io && Io in e && typeof e[Io] == "function" ? e[Io](
t.depth, t) : "inspect" in e && typeof e.inspect == "function" ? e.inspect(t.depth, t) : "constructor" in e && VC.has(e.constructor) ? VC.get(
e.constructor)(e, t) : zC[r] ? zC[r](e, t) : "", "inspectCustom"), k6 = Object.prototype.toString;
function Mo(e, t = {}) {
  let r = DC(t, Mo), { customInspect: n } = r, i = e === null ? "null" : typeof e;
  if (i === "object" && (i = k6.call(e).slice(8, -1)), i in GC)
    return GC[i](e, r);
  if (n && e) {
    let a = F6(e, r, i);
    if (a)
      return typeof a == "string" ? a : Mo(a, r);
  }
  let s = e ? Object.getPrototypeOf(e) : !1;
  return s === Object.prototype || s === null ? Pn(e, r) : e && typeof HTMLElement == "function" && e instanceof HTMLElement ? Ol(e, r) : "c\
onstructor" in e ? e.constructor !== Object ? av(e, r) : Pn(e, r) : e === Object(e) ? Pn(e, r) : r.stylize(String(e), i);
}
o(Mo, "inspect");

// ../node_modules/@vitest/utils/dist/chunk-_commonjsHelpers.js
var { AsymmetricMatcher: D6, DOMCollection: $6, DOMElement: B6, Immutable: U6, ReactElement: H6, ReactTestComponent: V6 } = ds, WC = [
  V6,
  H6,
  B6,
  $6,
  U6,
  D6
];
function An(e, t = 10, { maxLength: r, ...n } = {}) {
  let i = r ?? 1e4, s;
  try {
    s = qt(e, {
      maxDepth: t,
      escapeString: !1,
      plugins: WC,
      ...n
    });
  } catch {
    s = qt(e, {
      callToJSON: !1,
      maxDepth: t,
      escapeString: !1,
      plugins: WC,
      ...n
    });
  }
  return s.length >= i && t > 1 ? An(e, Math.floor(Math.min(t, Number.MAX_SAFE_INTEGER) / 2), {
    maxLength: r,
    ...n
  }) : s;
}
o(An, "stringify");
var z6 = /%[sdjifoOc%]/g;
function KC(...e) {
  if (typeof e[0] != "string") {
    let s = [];
    for (let a = 0; a < e.length; a++)
      s.push(ps(e[a], {
        depth: 0,
        colors: !1
      }));
    return s.join(" ");
  }
  let t = e.length, r = 1, n = e[0], i = String(n).replace(z6, (s) => {
    if (s === "%%")
      return "%";
    if (r >= t)
      return s;
    switch (s) {
      case "%s": {
        let a = e[r++];
        return typeof a == "bigint" ? `${a.toString()}n` : typeof a == "number" && a === 0 && 1 / a < 0 ? "-0" : typeof a == "object" && a !==
        null ? typeof a.toString == "function" && a.toString !== Object.prototype.toString ? a.toString() : ps(a, {
          depth: 0,
          colors: !1
        }) : String(a);
      }
      case "%d": {
        let a = e[r++];
        return typeof a == "bigint" ? `${a.toString()}n` : Number(a).toString();
      }
      case "%i": {
        let a = e[r++];
        return typeof a == "bigint" ? `${a.toString()}n` : Number.parseInt(String(a)).toString();
      }
      case "%f":
        return Number.parseFloat(String(e[r++])).toString();
      case "%o":
        return ps(e[r++], {
          showHidden: !0,
          showProxy: !0
        });
      case "%O":
        return ps(e[r++]);
      case "%c":
        return r++, "";
      case "%j":
        try {
          return JSON.stringify(e[r++]);
        } catch (a) {
          let l = a.message;
          if (l.includes("circular structure") || l.includes("cyclic structures") || l.includes("cyclic object"))
            return "[Circular]";
          throw a;
        }
      default:
        return s;
    }
  });
  for (let s = e[r]; r < t; s = e[++r])
    s === null || typeof s != "object" ? i += ` ${s}` : i += ` ${ps(s)}`;
  return i;
}
o(KC, "format");
function ps(e, t = {}) {
  return t.truncate === 0 && (t.truncate = Number.POSITIVE_INFINITY), Mo(e, t);
}
o(ps, "inspect");
function XC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
o(XC, "getDefaultExportFromCjs");

// ../node_modules/@vitest/utils/dist/helpers.js
function G6(e) {
  return e === Object.prototype || e === Function.prototype || e === RegExp.prototype;
}
o(G6, "isFinalObj");
function ql(e) {
  return Object.prototype.toString.apply(e).slice(8, -1);
}
o(ql, "getType");
function Y6(e, t) {
  let r = typeof t == "function" ? t : (n) => t.add(n);
  Object.getOwnPropertyNames(e).forEach(r), Object.getOwnPropertySymbols(e).forEach(r);
}
o(Y6, "collectOwnProperties");
function pv(e) {
  let t = /* @__PURE__ */ new Set();
  return G6(e) ? [] : (Y6(e, t), Array.from(t));
}
o(pv, "getOwnProperties");
var JC = { forceWritable: !1 };
function fv(e, t = JC) {
  return dv(e, /* @__PURE__ */ new WeakMap(), t);
}
o(fv, "deepClone");
function dv(e, t, r = JC) {
  let n, i;
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    for (i = Array.from({ length: n = e.length }), t.set(e, i); n--; )
      i[n] = dv(e[n], t, r);
    return i;
  }
  if (Object.prototype.toString.call(e) === "[object Object]") {
    i = Object.create(Object.getPrototypeOf(e)), t.set(e, i);
    let s = pv(e);
    for (let a of s) {
      let l = Object.getOwnPropertyDescriptor(e, a);
      if (!l)
        continue;
      let u = dv(e[a], t, r);
      r.forceWritable ? Object.defineProperty(i, a, {
        enumerable: l.enumerable,
        configurable: !0,
        writable: !0,
        value: u
      }) : "get" in l ? Object.defineProperty(i, a, {
        ...l,
        get() {
          return u;
        }
      }) : Object.defineProperty(i, a, {
        ...l,
        value: u
      });
    }
    return i;
  }
  return e;
}
o(dv, "clone");

// ../node_modules/@vitest/utils/dist/diff.js
var at = -1, Qe = 1, Le = 0, _v = class _v {
  0;
  1;
  constructor(t, r) {
    this[0] = t, this[1] = r;
  }
};
o(_v, "Diff");
var Ce = _v;
function W6(e, t) {
  if (!e || !t || e.charAt(0) !== t.charAt(0))
    return 0;
  let r = 0, n = Math.min(e.length, t.length), i = n, s = 0;
  for (; r < i; )
    e.substring(s, i) === t.substring(s, i) ? (r = i, s = r) : n = i, i = Math.floor((n - r) / 2 + r);
  return i;
}
o(W6, "diff_commonPrefix");
function fP(e, t) {
  if (!e || !t || e.charAt(e.length - 1) !== t.charAt(t.length - 1))
    return 0;
  let r = 0, n = Math.min(e.length, t.length), i = n, s = 0;
  for (; r < i; )
    e.substring(e.length - i, e.length - s) === t.substring(t.length - i, t.length - s) ? (r = i, s = r) : n = i, i = Math.floor((n - r) / 2 +
    r);
  return i;
}
o(fP, "diff_commonSuffix");
function ZC(e, t) {
  let r = e.length, n = t.length;
  if (r === 0 || n === 0)
    return 0;
  r > n ? e = e.substring(r - n) : r < n && (t = t.substring(0, r));
  let i = Math.min(r, n);
  if (e === t)
    return i;
  let s = 0, a = 1;
  for (; ; ) {
    let l = e.substring(i - a), u = t.indexOf(l);
    if (u === -1)
      return s;
    a += u, (u === 0 || e.substring(i - a) === t.substring(0, a)) && (s = a, a++);
  }
}
o(ZC, "diff_commonOverlap_");
function K6(e) {
  let t = !1, r = [], n = 0, i = null, s = 0, a = 0, l = 0, u = 0, c = 0;
  for (; s < e.length; )
    e[s][0] === Le ? (r[n++] = s, a = u, l = c, u = 0, c = 0, i = e[s][1]) : (e[s][0] === Qe ? u += e[s][1].length : c += e[s][1].length, i &&
    i.length <= Math.max(a, l) && i.length <= Math.max(u, c) && (e.splice(r[n - 1], 0, new Ce(at, i)), e[r[n - 1] + 1][0] = Qe, n--, n--, s =
    n > 0 ? r[n - 1] : -1, a = 0, l = 0, u = 0, c = 0, i = null, t = !0)), s++;
  for (t && mP(e), Z6(e), s = 1; s < e.length; ) {
    if (e[s - 1][0] === at && e[s][0] === Qe) {
      let d = e[s - 1][1], p = e[s][1], y = ZC(d, p), f = ZC(p, d);
      y >= f ? (y >= d.length / 2 || y >= p.length / 2) && (e.splice(s, 0, new Ce(Le, p.substring(0, y))), e[s - 1][1] = d.substring(0, d.length -
      y), e[s + 1][1] = p.substring(y), s++) : (f >= d.length / 2 || f >= p.length / 2) && (e.splice(s, 0, new Ce(Le, d.substring(0, f))), e[s -
      1][0] = Qe, e[s - 1][1] = p.substring(0, p.length - f), e[s + 1][0] = at, e[s + 1][1] = d.substring(f), s++), s++;
    }
    s++;
  }
}
o(K6, "diff_cleanupSemantic");
var QC = /[^a-z0-9]/i, eP = /\s/, tP = /[\r\n]/, X6 = /\n\r?\n$/, J6 = /^\r?\n\r?\n/;
function Z6(e) {
  let t = 1;
  for (; t < e.length - 1; ) {
    if (e[t - 1][0] === Le && e[t + 1][0] === Le) {
      let r = e[t - 1][1], n = e[t][1], i = e[t + 1][1], s = fP(r, n);
      if (s) {
        let d = n.substring(n.length - s);
        r = r.substring(0, r.length - s), n = d + n.substring(0, n.length - s), i = d + i;
      }
      let a = r, l = n, u = i, c = Il(r, n) + Il(n, i);
      for (; n.charAt(0) === i.charAt(0); ) {
        r += n.charAt(0), n = n.substring(1) + i.charAt(0), i = i.substring(1);
        let d = Il(r, n) + Il(n, i);
        d >= c && (c = d, a = r, l = n, u = i);
      }
      e[t - 1][1] !== a && (a ? e[t - 1][1] = a : (e.splice(t - 1, 1), t--), e[t][1] = l, u ? e[t + 1][1] = u : (e.splice(t + 1, 1), t--));
    }
    t++;
  }
}
o(Z6, "diff_cleanupSemanticLossless");
function mP(e) {
  e.push(new Ce(Le, ""));
  let t = 0, r = 0, n = 0, i = "", s = "", a;
  for (; t < e.length; )
    switch (e[t][0]) {
      case Qe:
        n++, s += e[t][1], t++;
        break;
      case at:
        r++, i += e[t][1], t++;
        break;
      case Le:
        r + n > 1 ? (r !== 0 && n !== 0 && (a = W6(s, i), a !== 0 && (t - r - n > 0 && e[t - r - n - 1][0] === Le ? e[t - r - n - 1][1] += s.
        substring(0, a) : (e.splice(0, 0, new Ce(Le, s.substring(0, a))), t++), s = s.substring(a), i = i.substring(a)), a = fP(s, i), a !==
        0 && (e[t][1] = s.substring(s.length - a) + e[t][1], s = s.substring(0, s.length - a), i = i.substring(0, i.length - a))), t -= r + n,
        e.splice(t, r + n), i.length && (e.splice(t, 0, new Ce(at, i)), t++), s.length && (e.splice(t, 0, new Ce(Qe, s)), t++), t++) : t !==
        0 && e[t - 1][0] === Le ? (e[t - 1][1] += e[t][1], e.splice(t, 1)) : t++, n = 0, r = 0, i = "", s = "";
        break;
    }
  e[e.length - 1][1] === "" && e.pop();
  let l = !1;
  for (t = 1; t < e.length - 1; )
    e[t - 1][0] === Le && e[t + 1][0] === Le && (e[t][1].substring(e[t][1].length - e[t - 1][1].length) === e[t - 1][1] ? (e[t][1] = e[t - 1][1] +
    e[t][1].substring(0, e[t][1].length - e[t - 1][1].length), e[t + 1][1] = e[t - 1][1] + e[t + 1][1], e.splice(t - 1, 1), l = !0) : e[t][1].
    substring(0, e[t + 1][1].length) === e[t + 1][1] && (e[t - 1][1] += e[t + 1][1], e[t][1] = e[t][1].substring(e[t + 1][1].length) + e[t +
    1][1], e.splice(t + 1, 1), l = !0)), t++;
  l && mP(e);
}
o(mP, "diff_cleanupMerge");
function Il(e, t) {
  if (!e || !t)
    return 6;
  let r = e.charAt(e.length - 1), n = t.charAt(0), i = r.match(QC), s = n.match(QC), a = i && r.match(eP), l = s && n.match(eP), u = a && r.
  match(tP), c = l && n.match(tP), d = u && e.match(X6), p = c && t.match(J6);
  return d || p ? 5 : u || c ? 4 : i && !a && l ? 3 : a || l ? 2 : i || s ? 1 : 0;
}
o(Il, "diff_cleanupSemanticScore_");
var hP = "Compared values have no visual difference.", Q6 = "Compared values serialize to the same structure.\nPrinting internal object struc\
ture without calling `toJSON` instead.", Ml = {}, rP;
function e8() {
  if (rP) return Ml;
  rP = 1, Object.defineProperty(Ml, "__esModule", {
    value: !0
  }), Ml.default = y;
  let e = "diff-sequences", t = 0, r = /* @__PURE__ */ o((f, m, h, b, g) => {
    let T = 0;
    for (; f < m && h < b && g(f, h); )
      f += 1, h += 1, T += 1;
    return T;
  }, "countCommonItemsF"), n = /* @__PURE__ */ o((f, m, h, b, g) => {
    let T = 0;
    for (; f <= m && h <= b && g(m, b); )
      m -= 1, b -= 1, T += 1;
    return T;
  }, "countCommonItemsR"), i = /* @__PURE__ */ o((f, m, h, b, g, T, _) => {
    let E = 0, R = -f, C = T[E], w = C;
    T[E] += r(
      C + 1,
      m,
      b + C - R + 1,
      h,
      g
    );
    let P = f < _ ? f : _;
    for (E += 1, R += 2; E <= P; E += 1, R += 2) {
      if (E !== f && w < T[E])
        C = T[E];
      else if (C = w + 1, m <= C)
        return E - 1;
      w = T[E], T[E] = C + r(C + 1, m, b + C - R + 1, h, g);
    }
    return _;
  }, "extendPathsF"), s = /* @__PURE__ */ o((f, m, h, b, g, T, _) => {
    let E = 0, R = f, C = T[E], w = C;
    T[E] -= n(
      m,
      C - 1,
      h,
      b + C - R - 1,
      g
    );
    let P = f < _ ? f : _;
    for (E += 1, R -= 2; E <= P; E += 1, R -= 2) {
      if (E !== f && T[E] < w)
        C = T[E];
      else if (C = w - 1, C < m)
        return E - 1;
      w = T[E], T[E] = C - n(
        m,
        C - 1,
        h,
        b + C - R - 1,
        g
      );
    }
    return _;
  }, "extendPathsR"), a = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R, C, w) => {
    let P = b - m, O = h - m, A = g - b - O, L = -A - (f - 1), B = -A + (f - 1), N = t, $ = f < E ? f : E;
    for (let M = 0, V = -f; M <= $; M += 1, V += 2) {
      let G = M === 0 || M !== f && N < _[M], Q = G ? _[M] : N, te = G ? Q : Q + 1, fe = P + te - V, F = r(
        te + 1,
        h,
        fe + 1,
        g,
        T
      ), j = te + F;
      if (N = _[M], _[M] = j, L <= V && V <= B) {
        let Y = (f - 1 - (V + A)) / 2;
        if (Y <= C && R[Y] - 1 <= j) {
          let z = P + Q - (G ? V + 1 : V - 1), X = n(
            m,
            Q,
            b,
            z,
            T
          ), ce = Q - X, Re = z - X, Me = ce + 1, vr = Re + 1;
          w.nChangePreceding = f - 1, f - 1 === Me + vr - m - b ? (w.aEndPreceding = m, w.bEndPreceding = b) : (w.aEndPreceding = Me, w.bEndPreceding =
          vr), w.nCommonPreceding = X, X !== 0 && (w.aCommonPreceding = Me, w.bCommonPreceding = vr), w.nCommonFollowing = F, F !== 0 && (w.
          aCommonFollowing = te + 1, w.bCommonFollowing = fe + 1);
          let ot = j + 1, ve = fe + F + 1;
          return w.nChangeFollowing = f - 1, f - 1 === h + g - ot - ve ? (w.aStartFollowing = h, w.bStartFollowing = g) : (w.aStartFollowing =
          ot, w.bStartFollowing = ve), !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsF"), l = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R, C, w) => {
    let P = g - h, O = h - m, A = g - b - O, L = A - f, B = A + f, N = t, $ = f < C ? f : C;
    for (let M = 0, V = f; M <= $; M += 1, V -= 2) {
      let G = M === 0 || M !== f && R[M] < N, Q = G ? R[M] : N, te = G ? Q : Q - 1, fe = P + te - V, F = n(
        m,
        te - 1,
        b,
        fe - 1,
        T
      ), j = te - F;
      if (N = R[M], R[M] = j, L <= V && V <= B) {
        let Y = (f + (V - A)) / 2;
        if (Y <= E && j - 1 <= _[Y]) {
          let z = fe - F;
          if (w.nChangePreceding = f, f === j + z - m - b ? (w.aEndPreceding = m, w.bEndPreceding = b) : (w.aEndPreceding = j, w.bEndPreceding =
          z), w.nCommonPreceding = F, F !== 0 && (w.aCommonPreceding = j, w.bCommonPreceding = z), w.nChangeFollowing = f - 1, f === 1)
            w.nCommonFollowing = 0, w.aStartFollowing = h, w.bStartFollowing = g;
          else {
            let X = P + Q - (G ? V - 1 : V + 1), ce = r(
              Q,
              h,
              X,
              g,
              T
            );
            w.nCommonFollowing = ce, ce !== 0 && (w.aCommonFollowing = Q, w.bCommonFollowing = X);
            let Re = Q + ce, Me = X + ce;
            f - 1 === h + g - Re - Me ? (w.aStartFollowing = h, w.bStartFollowing = g) : (w.aStartFollowing = Re, w.bStartFollowing = Me);
          }
          return !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsR"), u = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R) => {
    let C = b - m, w = g - h, P = h - m, O = g - b, D = O - P, A = P, L = P;
    if (_[0] = m - 1, E[0] = h, D % 2 === 0) {
      let B = (f || D) / 2, N = (P + O) / 2;
      for (let $ = 1; $ <= N; $ += 1)
        if (A = i($, h, g, C, T, _, A), $ < B)
          L = s($, m, b, w, T, E, L);
        else if (
          // If a reverse path overlaps a forward path in the same diagonal,
          // return a division of the index intervals at the middle change.
          l(
            $,
            m,
            h,
            b,
            g,
            T,
            _,
            A,
            E,
            L,
            R
          )
        )
          return;
    } else {
      let B = ((f || D) + 1) / 2, N = (P + O + 1) / 2, $ = 1;
      for (A = i($, h, g, C, T, _, A), $ += 1; $ <= N; $ += 1)
        if (L = s(
          $ - 1,
          m,
          b,
          w,
          T,
          E,
          L
        ), $ < B)
          A = i($, h, g, C, T, _, A);
        else if (
          // If a forward path overlaps a reverse path in the same diagonal,
          // return a division of the index intervals at the middle change.
          a(
            $,
            m,
            h,
            b,
            g,
            T,
            _,
            A,
            E,
            L,
            R
          )
        )
          return;
    }
    throw new Error(
      `${e}: no overlap aStart=${m} aEnd=${h} bStart=${b} bEnd=${g}`
    );
  }, "divide"), c = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R, C) => {
    if (g - b < h - m) {
      if (T = !T, T && _.length === 1) {
        let { foundSubsequence: j, isCommon: Y } = _[0];
        _[1] = {
          foundSubsequence: /* @__PURE__ */ o((z, X, ce) => {
            j(z, ce, X);
          }, "foundSubsequence"),
          isCommon: /* @__PURE__ */ o((z, X) => Y(X, z), "isCommon")
        };
      }
      let fe = m, F = h;
      m = b, h = g, b = fe, g = F;
    }
    let { foundSubsequence: w, isCommon: P } = _[T ? 1 : 0];
    u(
      f,
      m,
      h,
      b,
      g,
      P,
      E,
      R,
      C
    );
    let {
      nChangePreceding: O,
      aEndPreceding: D,
      bEndPreceding: A,
      nCommonPreceding: L,
      aCommonPreceding: B,
      bCommonPreceding: N,
      nCommonFollowing: $,
      aCommonFollowing: M,
      bCommonFollowing: V,
      nChangeFollowing: G,
      aStartFollowing: Q,
      bStartFollowing: te
    } = C;
    m < D && b < A && c(
      O,
      m,
      D,
      b,
      A,
      T,
      _,
      E,
      R,
      C
    ), L !== 0 && w(L, B, N), $ !== 0 && w($, M, V), Q < h && te < g && c(
      G,
      Q,
      h,
      te,
      g,
      T,
      _,
      E,
      R,
      C
    );
  }, "findSubsequences"), d = /* @__PURE__ */ o((f, m) => {
    if (typeof m != "number")
      throw new TypeError(`${e}: ${f} typeof ${typeof m} is not a number`);
    if (!Number.isSafeInteger(m))
      throw new RangeError(`${e}: ${f} value ${m} is not a safe integer`);
    if (m < 0)
      throw new RangeError(`${e}: ${f} value ${m} is a negative integer`);
  }, "validateLength"), p = /* @__PURE__ */ o((f, m) => {
    let h = typeof m;
    if (h !== "function")
      throw new TypeError(`${e}: ${f} typeof ${h} is not a function`);
  }, "validateCallback");
  function y(f, m, h, b) {
    d("aLength", f), d("bLength", m), p("isCommon", h), p("foundSubsequence", b);
    let g = r(0, f, 0, m, h);
    if (g !== 0 && b(g, 0, 0), f !== g || m !== g) {
      let T = g, _ = g, E = n(
        T,
        f - 1,
        _,
        m - 1,
        h
      ), R = f - E, C = m - E, w = g + E;
      f !== w && m !== w && c(
        0,
        T,
        R,
        _,
        C,
        !1,
        [
          {
            foundSubsequence: b,
            isCommon: h
          }
        ],
        [t],
        [t],
        {
          aCommonFollowing: t,
          aCommonPreceding: t,
          aEndPreceding: t,
          aStartFollowing: t,
          bCommonFollowing: t,
          bCommonPreceding: t,
          bEndPreceding: t,
          bStartFollowing: t,
          nChangeFollowing: t,
          nChangePreceding: t,
          nCommonFollowing: t,
          nCommonPreceding: t
        }
      ), E !== 0 && b(E, R, C);
    }
  }
  return o(y, "diffSequence"), Ml;
}
o(e8, "requireBuild");
var t8 = e8(), yP = /* @__PURE__ */ XC(t8);
function r8(e, t) {
  return e.replace(/\s+$/, (r) => t(r));
}
o(r8, "formatTrailingSpaces");
function Ev(e, t, r, n, i, s) {
  return e.length !== 0 ? r(`${n} ${r8(e, i)}`) : n !== " " ? r(n) : t && s.length !== 0 ? r(`${n} ${s}`) : "";
}
o(Ev, "printDiffLine");
function bP(e, t, { aColor: r, aIndicator: n, changeLineTrailingSpaceColor: i, emptyFirstOrLastLinePlaceholder: s }) {
  return Ev(e, t, r, n, i, s);
}
o(bP, "printDeleteLine");
function gP(e, t, { bColor: r, bIndicator: n, changeLineTrailingSpaceColor: i, emptyFirstOrLastLinePlaceholder: s }) {
  return Ev(e, t, r, n, i, s);
}
o(gP, "printInsertLine");
function vP(e, t, { commonColor: r, commonIndicator: n, commonLineTrailingSpaceColor: i, emptyFirstOrLastLinePlaceholder: s }) {
  return Ev(e, t, r, n, i, s);
}
o(vP, "printCommonLine");
function nP(e, t, r, n, { patchColor: i }) {
  return i(`@@ -${e + 1},${t - e} +${r + 1},${n - r} @@`);
}
o(nP, "createPatchMark");
function n8(e, t) {
  let r = e.length, n = t.contextLines, i = n + n, s = r, a = !1, l = 0, u = 0;
  for (; u !== r; ) {
    let E = u;
    for (; u !== r && e[u][0] === Le; )
      u += 1;
    if (E !== u)
      if (E === 0)
        u > n && (s -= u - n, a = !0);
      else if (u === r) {
        let R = u - E;
        R > n && (s -= R - n, a = !0);
      } else {
        let R = u - E;
        R > i && (s -= R - i, l += 1);
      }
    for (; u !== r && e[u][0] !== Le; )
      u += 1;
  }
  let c = l !== 0 || a;
  l !== 0 ? s += l + 1 : a && (s += 1);
  let d = s - 1, p = [], y = 0;
  c && p.push("");
  let f = 0, m = 0, h = 0, b = 0, g = /* @__PURE__ */ o((E) => {
    let R = p.length;
    p.push(vP(E, R === 0 || R === d, t)), h += 1, b += 1;
  }, "pushCommonLine"), T = /* @__PURE__ */ o((E) => {
    let R = p.length;
    p.push(bP(E, R === 0 || R === d, t)), h += 1;
  }, "pushDeleteLine"), _ = /* @__PURE__ */ o((E) => {
    let R = p.length;
    p.push(gP(E, R === 0 || R === d, t)), b += 1;
  }, "pushInsertLine");
  for (u = 0; u !== r; ) {
    let E = u;
    for (; u !== r && e[u][0] === Le; )
      u += 1;
    if (E !== u)
      if (E === 0) {
        u > n && (E = u - n, f = E, m = E, h = f, b = m);
        for (let R = E; R !== u; R += 1)
          g(e[R][1]);
      } else if (u === r) {
        let R = u - E > n ? E + n : u;
        for (let C = E; C !== R; C += 1)
          g(e[C][1]);
      } else {
        let R = u - E;
        if (R > i) {
          let C = E + n;
          for (let P = E; P !== C; P += 1)
            g(e[P][1]);
          p[y] = nP(f, h, m, b, t), y = p.length, p.push("");
          let w = R - i;
          f = h + w, m = b + w, h = f, b = m;
          for (let P = u - n; P !== u; P += 1)
            g(e[P][1]);
        } else
          for (let C = E; C !== u; C += 1)
            g(e[C][1]);
      }
    for (; u !== r && e[u][0] === at; )
      T(e[u][1]), u += 1;
    for (; u !== r && e[u][0] === Qe; )
      _(e[u][1]), u += 1;
  }
  return c && (p[y] = nP(f, h, m, b, t)), p.join(`
`);
}
o(n8, "joinAlignedDiffsNoExpand");
function o8(e, t) {
  return e.map((r, n, i) => {
    let s = r[1], a = n === 0 || n === i.length - 1;
    switch (r[0]) {
      case at:
        return bP(s, a, t);
      case Qe:
        return gP(s, a, t);
      default:
        return vP(s, a, t);
    }
  }).join(`
`);
}
o(o8, "joinAlignedDiffsExpand");
var mv = /* @__PURE__ */ o((e) => e, "noColor"), EP = 5, i8 = 0;
function s8() {
  return {
    aAnnotation: "Expected",
    aColor: ae.green,
    aIndicator: "-",
    bAnnotation: "Received",
    bColor: ae.red,
    bIndicator: "+",
    changeColor: ae.inverse,
    changeLineTrailingSpaceColor: mv,
    commonColor: ae.dim,
    commonIndicator: " ",
    commonLineTrailingSpaceColor: mv,
    compareKeys: void 0,
    contextLines: EP,
    emptyFirstOrLastLinePlaceholder: "",
    expand: !1,
    includeChangeCounts: !1,
    omitAnnotationLines: !1,
    patchColor: ae.yellow,
    printBasicPrototype: !1,
    truncateThreshold: i8,
    truncateAnnotation: "... Diff result is truncated",
    truncateAnnotationColor: mv
  };
}
o(s8, "getDefaultOptions");
function a8(e) {
  return e && typeof e == "function" ? e : void 0;
}
o(a8, "getCompareKeys");
function l8(e) {
  return typeof e == "number" && Number.isSafeInteger(e) && e >= 0 ? e : EP;
}
o(l8, "getContextLines");
function On(e = {}) {
  return {
    ...s8(),
    ...e,
    compareKeys: a8(e.compareKeys),
    contextLines: l8(e.contextLines)
  };
}
o(On, "normalizeDiffOptions");
function No(e) {
  return e.length === 1 && e[0].length === 0;
}
o(No, "isEmptyString");
function u8(e) {
  let t = 0, r = 0;
  return e.forEach((n) => {
    switch (n[0]) {
      case at:
        t += 1;
        break;
      case Qe:
        r += 1;
        break;
    }
  }), {
    a: t,
    b: r
  };
}
o(u8, "countChanges");
function c8({ aAnnotation: e, aColor: t, aIndicator: r, bAnnotation: n, bColor: i, bIndicator: s, includeChangeCounts: a, omitAnnotationLines: l }, u) {
  if (l)
    return "";
  let c = "", d = "";
  if (a) {
    let f = String(u.a), m = String(u.b), h = n.length - e.length, b = " ".repeat(Math.max(0, h)), g = " ".repeat(Math.max(0, -h)), T = m.length -
    f.length, _ = " ".repeat(Math.max(0, T)), E = " ".repeat(Math.max(0, -T));
    c = `${b}  ${r} ${_}${f}`, d = `${g}  ${s} ${E}${m}`;
  }
  let p = `${r} ${e}${c}`, y = `${s} ${n}${d}`;
  return `${t(p)}
${i(y)}

`;
}
o(c8, "printAnnotation");
function Tv(e, t, r) {
  return c8(r, u8(e)) + (r.expand ? o8(e, r) : n8(e, r)) + (t ? r.truncateAnnotationColor(`
${r.truncateAnnotation}`) : "");
}
o(Tv, "printDiffLines");
function jl(e, t, r) {
  let n = On(r), [i, s] = TP(No(e) ? [] : e, No(t) ? [] : t, n);
  return Tv(i, s, n);
}
o(jl, "diffLinesUnified");
function d8(e, t, r, n, i) {
  if (No(e) && No(r) && (e = [], r = []), No(t) && No(n) && (t = [], n = []), e.length !== r.length || t.length !== n.length)
    return jl(e, t, i);
  let [s, a] = TP(r, n, i), l = 0, u = 0;
  return s.forEach((c) => {
    switch (c[0]) {
      case at:
        c[1] = e[l], l += 1;
        break;
      case Qe:
        c[1] = t[u], u += 1;
        break;
      default:
        c[1] = t[u], l += 1, u += 1;
    }
  }), Tv(s, a, On(i));
}
o(d8, "diffLinesUnified2");
function TP(e, t, r) {
  let n = r?.truncateThreshold ?? !1, i = Math.max(Math.floor(r?.truncateThreshold ?? 0), 0), s = n ? Math.min(e.length, i) : e.length, a = n ?
  Math.min(t.length, i) : t.length, l = s !== e.length || a !== t.length, u = /* @__PURE__ */ o((f, m) => e[f] === t[m], "isCommon"), c = [],
  d = 0, p = 0;
  for (yP(s, a, u, /* @__PURE__ */ o((f, m, h) => {
    for (; d !== m; d += 1)
      c.push(new Ce(at, e[d]));
    for (; p !== h; p += 1)
      c.push(new Ce(Qe, t[p]));
    for (; f !== 0; f -= 1, d += 1, p += 1)
      c.push(new Ce(Le, t[p]));
  }, "foundSubsequence")); d !== s; d += 1)
    c.push(new Ce(at, e[d]));
  for (; p !== a; p += 1)
    c.push(new Ce(Qe, t[p]));
  return [c, l];
}
o(TP, "diffLinesRaw");
function oP(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  if (Array.isArray(e))
    return "array";
  if (typeof e == "boolean")
    return "boolean";
  if (typeof e == "function")
    return "function";
  if (typeof e == "number")
    return "number";
  if (typeof e == "string")
    return "string";
  if (typeof e == "bigint")
    return "bigint";
  if (typeof e == "object") {
    if (e != null) {
      if (e.constructor === RegExp)
        return "regexp";
      if (e.constructor === Map)
        return "map";
      if (e.constructor === Set)
        return "set";
      if (e.constructor === Date)
        return "date";
    }
    return "object";
  } else if (typeof e == "symbol")
    return "symbol";
  throw new Error(`value of unknown type: ${e}`);
}
o(oP, "getType");
function iP(e) {
  return e.includes(`\r
`) ? `\r
` : `
`;
}
o(iP, "getNewLineSymbol");
function p8(e, t, r) {
  let n = r?.truncateThreshold ?? !1, i = Math.max(Math.floor(r?.truncateThreshold ?? 0), 0), s = e.length, a = t.length;
  if (n) {
    let f = e.includes(`
`), m = t.includes(`
`), h = iP(e), b = iP(t), g = f ? `${e.split(h, i).join(h)}
` : e, T = m ? `${t.split(b, i).join(b)}
` : t;
    s = g.length, a = T.length;
  }
  let l = s !== e.length || a !== t.length, u = /* @__PURE__ */ o((f, m) => e[f] === t[m], "isCommon"), c = 0, d = 0, p = [];
  return yP(s, a, u, /* @__PURE__ */ o((f, m, h) => {
    c !== m && p.push(new Ce(at, e.slice(c, m))), d !== h && p.push(new Ce(Qe, t.slice(d, h))), c = m + f, d = h + f, p.push(new Ce(Le, t.slice(
    h, d)));
  }, "foundSubsequence")), c !== s && p.push(new Ce(at, e.slice(c))), d !== a && p.push(new Ce(Qe, t.slice(d))), [p, l];
}
o(p8, "diffStrings");
function f8(e, t, r) {
  return t.reduce((n, i) => n + (i[0] === Le ? i[1] : i[0] === e && i[1].length !== 0 ? r(i[1]) : ""), "");
}
o(f8, "concatenateRelevantDiffs");
var Rv = class Rv {
  op;
  line;
  lines;
  changeColor;
  constructor(t, r) {
    this.op = t, this.line = [], this.lines = [], this.changeColor = r;
  }
  pushSubstring(t) {
    this.pushDiff(new Ce(this.op, t));
  }
  pushLine() {
    this.lines.push(this.line.length !== 1 ? new Ce(this.op, f8(this.op, this.line, this.changeColor)) : this.line[0][0] === this.op ? this.
    line[0] : new Ce(this.op, this.line[0][1])), this.line.length = 0;
  }
  isLineEmpty() {
    return this.line.length === 0;
  }
  pushDiff(t) {
    this.line.push(t);
  }
  align(t) {
    let r = t[1];
    if (r.includes(`
`)) {
      let n = r.split(`
`), i = n.length - 1;
      n.forEach((s, a) => {
        a < i ? (this.pushSubstring(s), this.pushLine()) : s.length !== 0 && this.pushSubstring(s);
      });
    } else
      this.pushDiff(t);
  }
  moveLinesTo(t) {
    this.isLineEmpty() || this.pushLine(), t.push(...this.lines), this.lines.length = 0;
  }
};
o(Rv, "ChangeBuffer");
var Nl = Rv, wv = class wv {
  deleteBuffer;
  insertBuffer;
  lines;
  constructor(t, r) {
    this.deleteBuffer = t, this.insertBuffer = r, this.lines = [];
  }
  pushDiffCommonLine(t) {
    this.lines.push(t);
  }
  pushDiffChangeLines(t) {
    let r = t[1].length === 0;
    (!r || this.deleteBuffer.isLineEmpty()) && this.deleteBuffer.pushDiff(t), (!r || this.insertBuffer.isLineEmpty()) && this.insertBuffer.pushDiff(
    t);
  }
  flushChangeLines() {
    this.deleteBuffer.moveLinesTo(this.lines), this.insertBuffer.moveLinesTo(this.lines);
  }
  align(t) {
    let r = t[0], n = t[1];
    if (n.includes(`
`)) {
      let i = n.split(`
`), s = i.length - 1;
      i.forEach((a, l) => {
        if (l === 0) {
          let u = new Ce(r, a);
          this.deleteBuffer.isLineEmpty() && this.insertBuffer.isLineEmpty() ? (this.flushChangeLines(), this.pushDiffCommonLine(u)) : (this.
          pushDiffChangeLines(u), this.flushChangeLines());
        } else l < s ? this.pushDiffCommonLine(new Ce(r, a)) : a.length !== 0 && this.pushDiffChangeLines(new Ce(r, a));
      });
    } else
      this.pushDiffChangeLines(t);
  }
  getLines() {
    return this.flushChangeLines(), this.lines;
  }
};
o(wv, "CommonBuffer");
var yv = wv;
function m8(e, t) {
  let r = new Nl(at, t), n = new Nl(Qe, t), i = new yv(r, n);
  return e.forEach((s) => {
    switch (s[0]) {
      case at:
        r.align(s);
        break;
      case Qe:
        n.align(s);
        break;
      default:
        i.align(s);
    }
  }), i.getLines();
}
o(m8, "getAlignedDiffs");
function h8(e, t) {
  if (t) {
    let r = e.length - 1;
    return e.some((n, i) => n[0] === Le && (i !== r || n[1] !== `
`));
  }
  return e.some((r) => r[0] === Le);
}
o(h8, "hasCommonDiff");
function y8(e, t, r) {
  if (e !== t && e.length !== 0 && t.length !== 0) {
    let n = e.includes(`
`) || t.includes(`
`), [i, s] = _P(n ? `${e}
` : e, n ? `${t}
` : t, !0, r);
    if (h8(i, n)) {
      let a = On(r), l = m8(i, a.changeColor);
      return Tv(l, s, a);
    }
  }
  return jl(e.split(`
`), t.split(`
`), r);
}
o(y8, "diffStringsUnified");
function _P(e, t, r, n) {
  let [i, s] = p8(e, t, n);
  return r && K6(i), [i, s];
}
o(_P, "diffStringsRaw");
function bv(e, t) {
  let { commonColor: r } = On(t);
  return r(e);
}
o(bv, "getCommonMessage");
var { AsymmetricMatcher: b8, DOMCollection: g8, DOMElement: v8, Immutable: E8, ReactElement: T8, ReactTestComponent: _8 } = ds, RP = [
  _8,
  T8,
  v8,
  g8,
  E8,
  b8,
  ds.Error
], gv = {
  maxDepth: 20,
  plugins: RP
}, wP = {
  callToJSON: !1,
  maxDepth: 8,
  plugins: RP
};
function R8(e, t, r) {
  if (Object.is(e, t))
    return "";
  let n = oP(e), i = n, s = !1;
  if (n === "object" && typeof e.asymmetricMatch == "function") {
    if (e.$$typeof !== Symbol.for("jest.asymmetricMatcher") || typeof e.getExpectedType != "function")
      return;
    i = e.getExpectedType(), s = i === "string";
  }
  if (i !== oP(t)) {
    let b = function(_) {
      return _.length <= h ? _ : `${_.slice(0, h)}...`;
    };
    o(b, "truncate");
    let { aAnnotation: a, aColor: l, aIndicator: u, bAnnotation: c, bColor: d, bIndicator: p } = On(r), y = vv(wP, r), f = qt(e, y), m = qt(
    t, y), h = 1e5;
    f = b(f), m = b(m);
    let g = `${l(`${u} ${a}:`)} 
${f}`, T = `${d(`${p} ${c}:`)} 
${m}`;
    return `${g}

${T}`;
  }
  if (!s)
    switch (n) {
      case "string":
        return jl(e.split(`
`), t.split(`
`), r);
      case "boolean":
      case "number":
        return w8(e, t, r);
      case "map":
        return hv(sP(e), sP(t), r);
      case "set":
        return hv(aP(e), aP(t), r);
      default:
        return hv(e, t, r);
    }
}
o(R8, "diff");
function w8(e, t, r) {
  let n = qt(e, gv), i = qt(t, gv);
  return n === i ? "" : jl(n.split(`
`), i.split(`
`), r);
}
o(w8, "comparePrimitive");
function sP(e) {
  return new Map(Array.from(e.entries()).sort());
}
o(sP, "sortMap");
function aP(e) {
  return new Set(Array.from(e.values()).sort());
}
o(aP, "sortSet");
function hv(e, t, r) {
  let n, i = !1;
  try {
    let a = vv(gv, r);
    n = lP(e, t, a, r);
  } catch {
    i = !0;
  }
  let s = bv(hP, r);
  if (n === void 0 || n === s) {
    let a = vv(wP, r);
    n = lP(e, t, a, r), n !== s && !i && (n = `${bv(Q6, r)}

${n}`);
  }
  return n;
}
o(hv, "compareObjects");
function vv(e, t) {
  let { compareKeys: r, printBasicPrototype: n, maxDepth: i } = On(t);
  return {
    ...e,
    compareKeys: r,
    printBasicPrototype: n,
    maxDepth: i ?? e.maxDepth
  };
}
o(vv, "getFormatOptions");
function lP(e, t, r, n) {
  let i = {
    ...r,
    indent: 0
  }, s = qt(e, i), a = qt(t, i);
  if (s === a)
    return bv(hP, n);
  {
    let l = qt(e, r), u = qt(t, r);
    return d8(l.split(`
`), u.split(`
`), s.split(`
`), a.split(`
`), n);
  }
}
o(lP, "getObjectsDifference");
var uP = 2e4;
function cP(e) {
  return ql(e) === "Object" && typeof e.asymmetricMatch == "function";
}
o(cP, "isAsymmetricMatcher");
function dP(e, t) {
  let r = ql(e), n = ql(t);
  return r === n && (r === "Object" || r === "Array");
}
o(dP, "isReplaceable");
function SP(e, t, r) {
  let { aAnnotation: n, bAnnotation: i } = On(r);
  if (typeof t == "string" && typeof e == "string" && t.length > 0 && e.length > 0 && t.length <= uP && e.length <= uP && t !== e) {
    if (t.includes(`
`) || e.includes(`
`))
      return y8(t, e, r);
    let [d] = _P(t, e, !0), p = d.some((h) => h[0] === Le), y = S8(n, i), f = y(n) + P8(pP(d, at, p)), m = y(i) + C8(pP(d, Qe, p));
    return `${f}
${m}`;
  }
  let s = fv(t, { forceWritable: !0 }), a = fv(e, { forceWritable: !0 }), { replacedExpected: l, replacedActual: u } = xP(a, s);
  return R8(l, u, r);
}
o(SP, "printDiffOrStringify");
function xP(e, t, r = /* @__PURE__ */ new WeakSet(), n = /* @__PURE__ */ new WeakSet()) {
  return e instanceof Error && t instanceof Error && typeof e.cause < "u" && typeof t.cause > "u" ? (delete e.cause, {
    replacedActual: e,
    replacedExpected: t
  }) : dP(e, t) ? r.has(e) || n.has(t) ? {
    replacedActual: e,
    replacedExpected: t
  } : (r.add(e), n.add(t), pv(t).forEach((i) => {
    let s = t[i], a = e[i];
    if (cP(s))
      s.asymmetricMatch(a) && (e[i] = s);
    else if (cP(a))
      a.asymmetricMatch(s) && (t[i] = a);
    else if (dP(a, s)) {
      let l = xP(a, s, r, n);
      e[i] = l.replacedActual, t[i] = l.replacedExpected;
    }
  }), {
    replacedActual: e,
    replacedExpected: t
  }) : {
    replacedActual: e,
    replacedExpected: t
  };
}
o(xP, "replaceAsymmetricMatcher");
function S8(...e) {
  let t = e.reduce((r, n) => n.length > r ? n.length : r, 0);
  return (r) => `${r}: ${" ".repeat(t - r.length)}`;
}
o(S8, "getLabelPrinter");
var x8 = "\xB7";
function CP(e) {
  return e.replace(/\s+$/gm, (t) => x8.repeat(t.length));
}
o(CP, "replaceTrailingSpaces");
function C8(e) {
  return ae.red(CP(An(e)));
}
o(C8, "printReceived");
function P8(e) {
  return ae.green(CP(An(e)));
}
o(P8, "printExpected");
function pP(e, t, r) {
  return e.reduce((n, i) => n + (i[0] === Le ? i[1] : i[0] === t ? r ? ae.inverse(i[1]) : i[1] : ""), "");
}
o(pP, "getCommonAndChangedSubstrings");

// ../node_modules/@vitest/utils/dist/error.js
var A8 = "@@__IMMUTABLE_RECORD__@@", O8 = "@@__IMMUTABLE_ITERABLE__@@";
function q8(e) {
  return e && (e[O8] || e[A8]);
}
o(q8, "isImmutable");
var I8 = Object.getPrototypeOf({});
function PP(e) {
  return e instanceof Error ? `<unserializable>: ${e.message}` : typeof e == "string" ? `<unserializable>: ${e}` : "<unserializable>";
}
o(PP, "getUnserializableMessage");
function jo(e, t = /* @__PURE__ */ new WeakMap()) {
  if (!e || typeof e == "string")
    return e;
  if (typeof e == "function")
    return `Function<${e.name || "anonymous"}>`;
  if (typeof e == "symbol")
    return e.toString();
  if (typeof e != "object")
    return e;
  if (q8(e))
    return jo(e.toJSON(), t);
  if (e instanceof Promise || e.constructor && e.constructor.prototype === "AsyncFunction")
    return "Promise";
  if (typeof Element < "u" && e instanceof Element)
    return e.tagName;
  if (typeof e.asymmetricMatch == "function")
    return `${e.toString()} ${KC(e.sample)}`;
  if (typeof e.toJSON == "function")
    return jo(e.toJSON(), t);
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    let r = new Array(e.length);
    return t.set(e, r), e.forEach((n, i) => {
      try {
        r[i] = jo(n, t);
      } catch (s) {
        r[i] = PP(s);
      }
    }), r;
  } else {
    let r = /* @__PURE__ */ Object.create(null);
    t.set(e, r);
    let n = e;
    for (; n && n !== I8; )
      Object.getOwnPropertyNames(n).forEach((i) => {
        if (!(i in r))
          try {
            r[i] = jo(e[i], t);
          } catch (s) {
            delete r[i], r[i] = PP(s);
          }
      }), n = Object.getPrototypeOf(n);
    return r;
  }
}
o(jo, "serializeValue");
function M8(e) {
  return e.replace(/__(vite_ssr_import|vi_import)_\d+__\./g, "");
}
o(M8, "normalizeErrorMessage");
function Sv(e, t, r = /* @__PURE__ */ new WeakSet()) {
  if (!e || typeof e != "object")
    return { message: String(e) };
  let n = e;
  n.stack && (n.stackStr = String(n.stack)), n.name && (n.nameStr = String(n.name)), (n.showDiff || n.showDiff === void 0 && n.expected !== void 0 &&
  n.actual !== void 0) && (n.diff = SP(n.actual, n.expected, {
    ...t,
    ...n.diffOptions
  })), typeof n.expected != "string" && (n.expected = An(n.expected, 10)), typeof n.actual != "string" && (n.actual = An(n.actual, 10));
  try {
    typeof n.message == "string" && (n.message = M8(n.message));
  } catch {
  }
  try {
    !r.has(n) && typeof n.cause == "object" && (r.add(n), n.cause = Sv(n.cause, t, r));
  } catch {
  }
  try {
    return jo(n);
  } catch (i) {
    return jo(new Error(`Failed to fully serialize error: ${i?.message}
Inner error message: ${n?.message}`));
  }
}
o(Sv, "processError");

// src/instrumenter/EVENTS.ts
var ur = {
  CALL: "storybook/instrumenter/call",
  SYNC: "storybook/instrumenter/sync",
  START: "storybook/instrumenter/start",
  BACK: "storybook/instrumenter/back",
  GOTO: "storybook/instrumenter/goto",
  NEXT: "storybook/instrumenter/next",
  END: "storybook/instrumenter/end"
};

// src/instrumenter/preview-api.ts
var Ll = globalThis.__STORYBOOK_ADDONS_PREVIEW;

// src/instrumenter/instrumenter.ts
var AP = {
  start: !1,
  back: !1,
  goto: !1,
  next: !1,
  end: !1
}, N8 = new Error(
  "This function ran after the play function completed. Did you forget to `await` it?"
), OP = /* @__PURE__ */ o((e) => Object.prototype.toString.call(e) === "[object Object]", "isObject"), j8 = /* @__PURE__ */ o((e) => Object.
prototype.toString.call(e) === "[object Module]", "isModule"), L8 = /* @__PURE__ */ o((e) => {
  if (!OP(e) && !j8(e))
    return !1;
  if (e.constructor === void 0)
    return !0;
  let t = e.constructor.prototype;
  return !!OP(t);
}, "isInstrumentable"), F8 = /* @__PURE__ */ o((e) => {
  try {
    return new e.constructor();
  } catch {
    return {};
  }
}, "construct"), xv = /* @__PURE__ */ o(() => ({
  renderPhase: void 0,
  isDebugging: !1,
  isPlaying: !1,
  isLocked: !1,
  cursor: 0,
  calls: [],
  shadowCalls: [],
  callRefsByResult: /* @__PURE__ */ new Map(),
  chainedCallIds: /* @__PURE__ */ new Set(),
  ancestors: [],
  playUntil: void 0,
  resolvers: {},
  syncTimeout: void 0
}), "getInitialState"), qP = /* @__PURE__ */ o((e, t = !1) => {
  let r = (t ? e.shadowCalls : e.calls).filter((i) => i.retain);
  if (!r.length)
    return;
  let n = new Map(
    Array.from(e.callRefsByResult.entries()).filter(([, i]) => i.retain)
  );
  return { cursor: r.length, calls: r, callRefsByResult: n };
}, "getRetainedState"), Pv = class Pv {
  constructor() {
    this.initialized = !1;
    this.state = k.window?.parent?.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ || {};
    let t = /* @__PURE__ */ o(({
      storyId: u,
      isPlaying: c = !0,
      isDebugging: d = !1
    }) => {
      let p = this.getState(u);
      this.setState(u, {
        ...xv(),
        ...qP(p, d),
        shadowCalls: d ? p.shadowCalls : [],
        chainedCallIds: d ? p.chainedCallIds : /* @__PURE__ */ new Set(),
        playUntil: d ? p.playUntil : void 0,
        isPlaying: c,
        isDebugging: d
      }), this.sync(u);
    }, "resetState"), r = /* @__PURE__ */ o((u) => ({ storyId: c, playUntil: d }) => {
      this.getState(c).isDebugging || this.setState(c, ({ calls: y }) => ({
        calls: [],
        shadowCalls: y.map((f) => ({ ...f, status: "waiting" })),
        isDebugging: !0
      }));
      let p = this.getLog(c);
      this.setState(c, ({ shadowCalls: y }) => {
        if (d || !p.length)
          return { playUntil: d };
        let f = y.findIndex((m) => m.id === p[0].callId);
        return {
          playUntil: y.slice(0, f).filter((m) => m.interceptable && !m.ancestors?.length).slice(-1)[0]?.id
        };
      }), u.emit(vo, { storyId: c, isDebugging: !0 });
    }, "start"), n = /* @__PURE__ */ o((u) => ({ storyId: c }) => {
      let d = this.getLog(c).filter((y) => !y.ancestors?.length), p = d.reduceRight((y, f, m) => y >= 0 || f.status === "waiting" ? y : m, -1);
      r(u)({ storyId: c, playUntil: d[p - 1]?.callId });
    }, "back"), i = /* @__PURE__ */ o((u) => ({ storyId: c, callId: d }) => {
      let { calls: p, shadowCalls: y, resolvers: f } = this.getState(c), m = p.find(({ id: b }) => b === d), h = y.find(({ id: b }) => b ===
      d);
      if (!m && h && Object.values(f).length > 0) {
        let b = this.getLog(c).find((g) => g.status === "waiting")?.callId;
        h.id !== b && this.setState(c, { playUntil: h.id }), Object.values(f).forEach((g) => g());
      } else
        r(u)({ storyId: c, playUntil: d });
    }, "goto"), s = /* @__PURE__ */ o((u) => ({ storyId: c }) => {
      let { resolvers: d } = this.getState(c);
      if (Object.values(d).length > 0)
        Object.values(d).forEach((p) => p());
      else {
        let p = this.getLog(c).find((y) => y.status === "waiting")?.callId;
        p ? r(u)({ storyId: c, playUntil: p }) : a({ storyId: c });
      }
    }, "next"), a = /* @__PURE__ */ o(({ storyId: u }) => {
      this.setState(u, { playUntil: void 0, isDebugging: !1 }), Object.values(this.getState(u).resolvers).forEach((c) => c());
    }, "end"), l = /* @__PURE__ */ o(({ storyId: u, newPhase: c }) => {
      let { isDebugging: d } = this.getState(u);
      this.setState(u, { renderPhase: c }), c === "preparing" && d && t({ storyId: u }), c === "playing" && t({ storyId: u, isDebugging: d }),
      c === "played" && this.setState(u, {
        isLocked: !1,
        isPlaying: !1,
        isDebugging: !1
      }), c === "errored" && this.setState(u, {
        isLocked: !1,
        isPlaying: !1
      });
    }, "renderPhaseChanged");
    Ll && Ll.ready().then(() => {
      this.channel = Ll.getChannel(), this.channel.on(vo, t), this.channel.on(Ut, l), this.channel.on(Hi, () => {
        this.initialized ? this.cleanup() : this.initialized = !0;
      }), this.channel.on(ur.START, r(this.channel)), this.channel.on(ur.BACK, n(this.channel)), this.channel.on(ur.GOTO, i(this.channel)), this.
      channel.on(ur.NEXT, s(this.channel)), this.channel.on(ur.END, a);
    });
  }
  getState(t) {
    return this.state[t] || xv();
  }
  setState(t, r) {
    let n = this.getState(t), i = typeof r == "function" ? r(n) : r;
    this.state = { ...this.state, [t]: { ...n, ...i } }, k.window?.parent && (k.window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ =
    this.state);
  }
  cleanup() {
    this.state = Object.entries(this.state).reduce(
      (r, [n, i]) => {
        let s = qP(i);
        return s && (r[n] = Object.assign(xv(), s)), r;
      },
      {}
    );
    let t = { controlStates: AP, logItems: [] };
    this.channel?.emit(ur.SYNC, t), k.window?.parent && (k.window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state);
  }
  getLog(t) {
    let { calls: r, shadowCalls: n } = this.getState(t), i = [...n];
    r.forEach((a, l) => {
      i[l] = a;
    });
    let s = /* @__PURE__ */ new Set();
    return i.reduceRight((a, l) => (l.args.forEach((u) => {
      u?.__callId__ && s.add(u.__callId__);
    }), l.path.forEach((u) => {
      u.__callId__ && s.add(u.__callId__);
    }), (l.interceptable || l.exception) && !s.has(l.id) && (a.unshift({ callId: l.id, status: l.status, ancestors: l.ancestors }), s.add(l.
    id)), a), []);
  }
  // Traverses the object structure to recursively patch all function properties.
  // Returns the original object, or a new object with the same constructor,
  // depending on whether it should mutate.
  instrument(t, r, n = 0) {
    if (!L8(t))
      return t;
    let { mutate: i = !1, path: s = [] } = r, a = r.getKeys ? r.getKeys(t, n) : Object.keys(t);
    return n += 1, a.reduce(
      (l, u) => {
        let c = k8(t, u);
        if (typeof c?.get == "function") {
          if (c.configurable) {
            let p = /* @__PURE__ */ o(() => c?.get?.bind(t)?.(), "getter");
            Object.defineProperty(l, u, {
              get: /* @__PURE__ */ o(() => this.instrument(p(), { ...r, path: s.concat(u) }, n), "get")
            });
          }
          return l;
        }
        let d = t[u];
        return typeof d != "function" ? (l[u] = this.instrument(d, { ...r, path: s.concat(u) }, n), l) : "__originalFn__" in d && typeof d.__originalFn__ ==
        "function" ? (l[u] = d, l) : (l[u] = (...p) => this.track(u, d, t, p, r), l[u].__originalFn__ = d, Object.defineProperty(l[u], "name",
        { value: u, writable: !1 }), Object.keys(d).length > 0 && Object.assign(
          l[u],
          this.instrument({ ...d }, { ...r, path: s.concat(u) }, n)
        ), l);
      },
      i ? t : F8(t)
    );
  }
  // Monkey patch an object method to record calls.
  // Returns a function that invokes the original function, records the invocation ("call") and
  // returns the original result.
  track(t, r, n, i, s) {
    let a = i?.[0]?.__storyId__ || k.__STORYBOOK_PREVIEW__?.selectionStore?.selection?.storyId, { cursor: l, ancestors: u } = this.getState(
    a);
    this.setState(a, { cursor: l + 1 });
    let c = `${u.slice(-1)[0] || a} [${l}] ${t}`, { path: d = [], intercept: p = !1, retain: y = !1 } = s, f = typeof p == "function" ? p(t,
    d) : p, m = { id: c, cursor: l, storyId: a, ancestors: u, path: d, method: t, args: i, interceptable: f, retain: y }, b = (f && !u.length ?
    this.intercept : this.invoke).call(this, r, n, m, s);
    return this.instrument(b, { ...s, mutate: !0, path: [{ __callId__: m.id }] });
  }
  intercept(t, r, n, i) {
    let { chainedCallIds: s, isDebugging: a, playUntil: l } = this.getState(n.storyId), u = s.has(n.id);
    return !a || u || l ? (l === n.id && this.setState(n.storyId, { playUntil: void 0 }), this.invoke(t, r, n, i)) : new Promise((c) => {
      this.setState(n.storyId, ({ resolvers: d }) => ({
        isLocked: !1,
        resolvers: { ...d, [n.id]: c }
      }));
    }).then(() => (this.setState(n.storyId, (c) => {
      let { [n.id]: d, ...p } = c.resolvers;
      return { isLocked: !0, resolvers: p };
    }), this.invoke(t, r, n, i)));
  }
  invoke(t, r, n, i) {
    let { callRefsByResult: s, renderPhase: a } = this.getState(n.storyId), l = 25, u = /* @__PURE__ */ o((p, y, f) => {
      if (f.includes(p))
        return "[Circular]";
      if (f = [...f, p], y > l)
        return "...";
      if (s.has(p))
        return s.get(p);
      if (p instanceof Array)
        return p.map((m) => u(m, ++y, f));
      if (p instanceof Date)
        return { __date__: { value: p.toISOString() } };
      if (p instanceof Error) {
        let { name: m, message: h, stack: b } = p;
        return { __error__: { name: m, message: h, stack: b } };
      }
      if (p instanceof RegExp) {
        let { flags: m, source: h } = p;
        return { __regexp__: { flags: m, source: h } };
      }
      if (p instanceof k.window?.HTMLElement) {
        let { prefix: m, localName: h, id: b, classList: g, innerText: T } = p, _ = Array.from(g);
        return { __element__: { prefix: m, localName: h, id: b, classNames: _, innerText: T } };
      }
      return typeof p == "function" ? {
        __function__: { name: "getMockName" in p ? p.getMockName() : p.name }
      } : typeof p == "symbol" ? { __symbol__: { description: p.description } } : typeof p == "object" && p?.constructor?.name && p?.constructor?.
      name !== "Object" ? { __class__: { name: p.constructor.name } } : Object.prototype.toString.call(p) === "[object Object]" ? Object.fromEntries(
        Object.entries(p).map(([m, h]) => [m, u(h, ++y, f)])
      ) : p;
    }, "serializeValues"), c = {
      ...n,
      args: n.args.map((p) => u(p, 0, []))
    };
    n.path.forEach((p) => {
      p?.__callId__ && this.setState(n.storyId, ({ chainedCallIds: y }) => ({
        chainedCallIds: new Set(Array.from(y).concat(p.__callId__))
      }));
    });
    let d = /* @__PURE__ */ o((p) => {
      if (p instanceof Error) {
        let { name: y, message: f, stack: m, callId: h = n.id } = p, {
          showDiff: b = void 0,
          diff: g = void 0,
          actual: T = void 0,
          expected: _ = void 0
        } = p.name === "AssertionError" ? Sv(p) : p, E = { name: y, message: f, stack: m, callId: h, showDiff: b, diff: g, actual: T, expected: _ };
        if (this.update({ ...c, status: "error", exception: E }), this.setState(n.storyId, (R) => ({
          callRefsByResult: new Map([
            ...Array.from(R.callRefsByResult.entries()),
            [p, { __callId__: n.id, retain: n.retain }]
          ])
        })), n.ancestors?.length)
          throw Object.prototype.hasOwnProperty.call(p, "callId") || Object.defineProperty(p, "callId", { value: n.id }), p;
      }
      throw p;
    }, "handleException");
    try {
      if (a === "played" && !n.retain)
        throw N8;
      let y = (i.getArgs ? i.getArgs(n, this.getState(n.storyId)) : n.args).map((m) => typeof m != "function" || D8(m) || Object.keys(m).length ?
      m : (...h) => {
        let { cursor: b, ancestors: g } = this.getState(n.storyId);
        this.setState(n.storyId, { cursor: 0, ancestors: [...g, n.id] });
        let T = /* @__PURE__ */ o(() => this.setState(n.storyId, { cursor: b, ancestors: g }), "restore"), _ = !1;
        try {
          let E = m(...h);
          return E instanceof Promise ? (_ = !0, E.finally(T)) : E;
        } finally {
          _ || T();
        }
      }), f = t.apply(r, y);
      return f && ["object", "function", "symbol"].includes(typeof f) && this.setState(n.storyId, (m) => ({
        callRefsByResult: new Map([
          ...Array.from(m.callRefsByResult.entries()),
          [f, { __callId__: n.id, retain: n.retain }]
        ])
      })), this.update({
        ...c,
        status: f instanceof Promise ? "active" : "done"
      }), f instanceof Promise ? f.then((m) => (this.update({ ...c, status: "done" }), m), d) : f;
    } catch (p) {
      return d(p);
    }
  }
  // Sends the call info to the manager and synchronizes the log.
  update(t) {
    this.channel?.emit(ur.CALL, t), this.setState(t.storyId, ({ calls: r }) => {
      let n = r.concat(t).reduce((i, s) => Object.assign(i, { [s.id]: s }), {});
      return {
        // Calls are sorted to ensure parent calls always come before calls in their callback.
        calls: Object.values(n).sort(
          (i, s) => i.id.localeCompare(s.id, void 0, { numeric: !0 })
        )
      };
    }), this.sync(t.storyId);
  }
  // Builds a log of interceptable calls and control states and sends it to the manager.
  // Uses a 0ms debounce because this might get called many times in one tick.
  sync(t) {
    let r = /* @__PURE__ */ o(() => {
      let { isLocked: n, isPlaying: i } = this.getState(t), s = this.getLog(t), a = s.filter(({ ancestors: p }) => !p.length).find((p) => p.
      status === "waiting")?.callId, l = s.some((p) => p.status === "active");
      if (n || l || s.length === 0) {
        let p = { controlStates: AP, logItems: s };
        this.channel?.emit(ur.SYNC, p);
        return;
      }
      let u = s.some(
        (p) => p.status === "done" || p.status === "error"
      ), d = { controlStates: {
        start: u,
        back: u,
        goto: !0,
        next: i,
        end: i
      }, logItems: s, pausedAt: a };
      this.channel?.emit(ur.SYNC, d);
    }, "synchronize");
    this.setState(t, ({ syncTimeout: n }) => (clearTimeout(n), { syncTimeout: setTimeout(r, 0) }));
  }
};
o(Pv, "Instrumenter");
var Cv = Pv;
function cr(e, t = {}) {
  try {
    let r = !1, n = !1;
    return k.window?.location?.search?.includes("instrument=true") ? r = !0 : k.window?.location?.search?.includes("instrument=false") && (n =
    !0), k.window?.parent === k.window && !r || n ? e : (k.window && !k.window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ && (k.window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ =
    new Cv()), (k.window?.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__).instrument(e, t));
  } catch (r) {
    return we.warn(r), e;
  }
}
o(cr, "instrument");
function k8(e, t) {
  let r = e;
  for (; r != null; ) {
    let n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = Object.getPrototypeOf(r);
  }
}
o(k8, "getPropertyDescriptor");
function D8(e) {
  if (typeof e != "function")
    return !1;
  let t = Object.getOwnPropertyDescriptor(e, "prototype");
  return t ? !t.writable : !1;
}
o(D8, "isClass");

// src/component-testing/preview.ts
var { step: $8 } = cr(
  {
    // It seems like the label is unused, but the instrumenter has access to it
    // The context will be bounded later in StoryRender, so that the user can write just:
    // await step("label", (context) => {
    //   // labeled step
    // });
    step: /* @__PURE__ */ o(async (e, t, r) => t(r), "step")
  },
  { intercept: !0 }
), Av = /* @__PURE__ */ o(() => ({
  parameters: {
    throwPlayFunctionExceptions: !1
  },
  runStep: $8
}), "default");

// src/actions/addArgs.ts
var Ov = {};
ft(Ov, {
  argsEnhancers: () => B8
});

// src/actions/addArgsHelpers.ts
var IP = /* @__PURE__ */ o((e, t) => typeof t[e] > "u" && !(e in t), "isInInitialArgs"), MP = /* @__PURE__ */ o((e) => {
  let {
    initialArgs: t,
    argTypes: r,
    id: n,
    parameters: { actions: i }
  } = e;
  if (!i || i.disable || !i.argTypesRegex || !r)
    return {};
  let s = new RegExp(i.argTypesRegex);
  return Object.entries(r).filter(
    ([l]) => !!s.test(l)
  ).reduce((l, [u, c]) => (IP(u, t) && (l[u] = Br(u, { implicit: !0, id: n })), l), {});
}, "inferActionsFromArgTypesRegex"), NP = /* @__PURE__ */ o((e) => {
  let {
    initialArgs: t,
    argTypes: r,
    parameters: { actions: n }
  } = e;
  return n?.disable || !r ? {} : Object.entries(r).filter(([s, a]) => !!a.action).reduce((s, [a, l]) => (IP(a, t) && (s[a] = Br(typeof l.action ==
  "string" ? l.action : a)), s), {});
}, "addActionsFromArgTypes");

// src/actions/addArgs.ts
var B8 = [
  NP,
  MP
];

// src/actions/loaders.ts
var Vw = {};
ft(Vw, {
  loaders: () => swe
});

// src/test/index.ts
var Hw = {};
ft(Hw, {
  buildQueries: () => $_e,
  clearAllMocks: () => uR,
  configure: () => B_e,
  createEvent: () => U_e,
  expect: () => owe,
  findAllByAltText: () => V_e,
  findAllByDisplayValue: () => z_e,
  findAllByLabelText: () => G_e,
  findAllByPlaceholderText: () => Y_e,
  findAllByRole: () => W_e,
  findAllByTestId: () => K_e,
  findAllByText: () => X_e,
  findAllByTitle: () => J_e,
  findByAltText: () => Z_e,
  findByDisplayValue: () => Q_e,
  findByLabelText: () => eRe,
  findByPlaceholderText: () => tRe,
  findByRole: () => rRe,
  findByTestId: () => nRe,
  findByText: () => oRe,
  findByTitle: () => iRe,
  fireEvent: () => H_e,
  fn: () => lR,
  getAllByAltText: () => sRe,
  getAllByDisplayValue: () => aRe,
  getAllByLabelText: () => lRe,
  getAllByPlaceholderText: () => uRe,
  getAllByRole: () => cRe,
  getAllByTestId: () => dRe,
  getAllByText: () => pRe,
  getAllByTitle: () => fRe,
  getByAltText: () => mRe,
  getByDisplayValue: () => hRe,
  getByLabelText: () => yRe,
  getByPlaceholderText: () => bRe,
  getByRole: () => gRe,
  getByTestId: () => vRe,
  getByText: () => ERe,
  getByTitle: () => TRe,
  getConfig: () => _Re,
  getDefaultNormalizer: () => RRe,
  getElementError: () => wRe,
  getNodeText: () => SRe,
  getQueriesForElement: () => xRe,
  getRoles: () => CRe,
  getSuggestedQuery: () => PRe,
  isInaccessible: () => ARe,
  isMockFunction: () => Xr,
  logDOM: () => ORe,
  logRoles: () => qRe,
  mocked: () => gue,
  mocks: () => ui,
  onMockCall: () => aR,
  prettyDOM: () => IRe,
  prettyFormat: () => rwe,
  queries: () => MRe,
  queryAllByAltText: () => NRe,
  queryAllByAttribute: () => jRe,
  queryAllByDisplayValue: () => LRe,
  queryAllByLabelText: () => FRe,
  queryAllByPlaceholderText: () => kRe,
  queryAllByRole: () => DRe,
  queryAllByTestId: () => $Re,
  queryAllByText: () => BRe,
  queryAllByTitle: () => URe,
  queryByAltText: () => HRe,
  queryByAttribute: () => VRe,
  queryByDisplayValue: () => zRe,
  queryByLabelText: () => GRe,
  queryByPlaceholderText: () => YRe,
  queryByRole: () => WRe,
  queryByTestId: () => KRe,
  queryByText: () => XRe,
  queryByTitle: () => JRe,
  queryHelpers: () => ZRe,
  resetAllMocks: () => cR,
  restoreAllMocks: () => dR,
  screen: () => QRe,
  spyOn: () => bue,
  uninstrumentedUserEvent: () => Uw,
  userEvent: () => nwe,
  waitFor: () => ewe,
  waitForElementToBeRemoved: () => twe,
  within: () => Bw
});

// ../node_modules/chai/chai.js
var VP = Object.defineProperty, U8 = Object.getOwnPropertyNames, I = /* @__PURE__ */ o((e, t) => VP(e, "name", { value: t, configurable: !0 }),
"__name"), H8 = /* @__PURE__ */ o((e, t) => /* @__PURE__ */ o(function() {
  return t || (0, e[U8(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, "__require"), "__commonJS"), Yv = /* @__PURE__ */ o((e, t) => {
  for (var r in t)
    VP(e, r, { get: t[r], enumerable: !0 });
}, "__export"), V8 = H8({
  "(disabled):util"() {
  }
}), It = {};
Yv(It, {
  addChainableMethod: /* @__PURE__ */ o(() => iE, "addChainableMethod"),
  addLengthGuard: /* @__PURE__ */ o(() => bs, "addLengthGuard"),
  addMethod: /* @__PURE__ */ o(() => rE, "addMethod"),
  addProperty: /* @__PURE__ */ o(() => tE, "addProperty"),
  checkError: /* @__PURE__ */ o(() => St, "checkError"),
  compareByInspect: /* @__PURE__ */ o(() => $l, "compareByInspect"),
  eql: /* @__PURE__ */ o(() => b0, "eql"),
  expectTypes: /* @__PURE__ */ o(() => JP, "expectTypes"),
  flag: /* @__PURE__ */ o(() => re, "flag"),
  getActual: /* @__PURE__ */ o(() => zl, "getActual"),
  getMessage: /* @__PURE__ */ o(() => Xv, "getMessage"),
  getName: /* @__PURE__ */ o(() => Yl, "getName"),
  getOperator: /* @__PURE__ */ o(() => uE, "getOperator"),
  getOwnEnumerableProperties: /* @__PURE__ */ o(() => lE, "getOwnEnumerableProperties"),
  getOwnEnumerablePropertySymbols: /* @__PURE__ */ o(() => aE, "getOwnEnumerablePropertySymbols"),
  getPathInfo: /* @__PURE__ */ o(() => eE, "getPathInfo"),
  hasProperty: /* @__PURE__ */ o(() => Gl, "hasProperty"),
  inspect: /* @__PURE__ */ o(() => de, "inspect"),
  isNaN: /* @__PURE__ */ o(() => Bl, "isNaN"),
  isNumeric: /* @__PURE__ */ o(() => We, "isNumeric"),
  isProxyEnabled: /* @__PURE__ */ o(() => ys, "isProxyEnabled"),
  isRegExp: /* @__PURE__ */ o(() => Ul, "isRegExp"),
  objDisplay: /* @__PURE__ */ o(() => qn, "objDisplay"),
  overwriteChainableMethod: /* @__PURE__ */ o(() => sE, "overwriteChainableMethod"),
  overwriteMethod: /* @__PURE__ */ o(() => oE, "overwriteMethod"),
  overwriteProperty: /* @__PURE__ */ o(() => nE, "overwriteProperty"),
  proxify: /* @__PURE__ */ o(() => Do, "proxify"),
  test: /* @__PURE__ */ o(() => Wv, "test"),
  transferFlags: /* @__PURE__ */ o(() => Gt, "transferFlags"),
  type: /* @__PURE__ */ o(() => Te, "type")
});
var St = {};
Yv(St, {
  compatibleConstructor: /* @__PURE__ */ o(() => YP, "compatibleConstructor"),
  compatibleInstance: /* @__PURE__ */ o(() => GP, "compatibleInstance"),
  compatibleMessage: /* @__PURE__ */ o(() => WP, "compatibleMessage"),
  getConstructorName: /* @__PURE__ */ o(() => KP, "getConstructorName"),
  getMessage: /* @__PURE__ */ o(() => XP, "getMessage")
});
function Vl(e) {
  return e instanceof Error || Object.prototype.toString.call(e) === "[object Error]";
}
o(Vl, "isErrorInstance");
I(Vl, "isErrorInstance");
function zP(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
o(zP, "isRegExp");
I(zP, "isRegExp");
function GP(e, t) {
  return Vl(t) && e === t;
}
o(GP, "compatibleInstance");
I(GP, "compatibleInstance");
function YP(e, t) {
  return Vl(t) ? e.constructor === t.constructor || e instanceof t.constructor : (typeof t == "object" || typeof t == "function") && t.prototype ?
  e.constructor === t || e instanceof t : !1;
}
o(YP, "compatibleConstructor");
I(YP, "compatibleConstructor");
function WP(e, t) {
  let r = typeof e == "string" ? e : e.message;
  return zP(t) ? t.test(r) : typeof t == "string" ? r.indexOf(t) !== -1 : !1;
}
o(WP, "compatibleMessage");
I(WP, "compatibleMessage");
function KP(e) {
  let t = e;
  return Vl(e) ? t = e.constructor.name : typeof e == "function" && (t = e.name, t === "" && (t = new e().name || t)), t;
}
o(KP, "getConstructorName");
I(KP, "getConstructorName");
function XP(e) {
  let t = "";
  return e && e.message ? t = e.message : typeof e == "string" && (t = e), t;
}
o(XP, "getMessage");
I(XP, "getMessage");
function re(e, t, r) {
  var n = e.__flags || (e.__flags = /* @__PURE__ */ Object.create(null));
  if (arguments.length === 3)
    n[t] = r;
  else
    return n[t];
}
o(re, "flag");
I(re, "flag");
function Wv(e, t) {
  var r = re(e, "negate"), n = t[0];
  return r ? !n : n;
}
o(Wv, "test");
I(Wv, "test");
function Te(e) {
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  let t = e[Symbol.toStringTag];
  return typeof t == "string" ? t : Object.prototype.toString.call(e).slice(8, -1);
}
o(Te, "type");
I(Te, "type");
var z8 = "captureStackTrace" in Error, Hr, pe = (Hr = class extends Error {
  message;
  get name() {
    return "AssertionError";
  }
  get ok() {
    return !1;
  }
  constructor(t = "Unspecified AssertionError", r, n) {
    super(t), this.message = t, z8 && Error.captureStackTrace(this, n || Hr);
    for (let i in r)
      i in this || (this[i] = r[i]);
  }
  toJSON(t) {
    return {
      ...this,
      name: this.name,
      message: this.message,
      ok: !1,
      stack: t !== !1 ? this.stack : void 0
    };
  }
}, o(Hr, "_AssertionError"), I(Hr, "AssertionError"), Hr);
function JP(e, t) {
  var r = re(e, "message"), n = re(e, "ssfi");
  r = r ? r + ": " : "", e = re(e, "object"), t = t.map(function(a) {
    return a.toLowerCase();
  }), t.sort();
  var i = t.map(function(a, l) {
    var u = ~["a", "e", "i", "o", "u"].indexOf(a.charAt(0)) ? "an" : "a", c = t.length > 1 && l === t.length - 1 ? "or " : "";
    return c + u + " " + a;
  }).join(", "), s = Te(e).toLowerCase();
  if (!t.some(function(a) {
    return s === a;
  }))
    throw new pe(
      r + "object tested must be " + i + ", but " + s + " given",
      void 0,
      n
    );
}
o(JP, "expectTypes");
I(JP, "expectTypes");
function zl(e, t) {
  return t.length > 4 ? t[4] : e._obj;
}
o(zl, "getActual");
I(zl, "getActual");
var jP = {
  bold: ["1", "22"],
  dim: ["2", "22"],
  italic: ["3", "23"],
  underline: ["4", "24"],
  // 5 & 6 are blinking
  inverse: ["7", "27"],
  hidden: ["8", "28"],
  strike: ["9", "29"],
  // 10-20 are fonts
  // 21-29 are resets for 1-9
  black: ["30", "39"],
  red: ["31", "39"],
  green: ["32", "39"],
  yellow: ["33", "39"],
  blue: ["34", "39"],
  magenta: ["35", "39"],
  cyan: ["36", "39"],
  white: ["37", "39"],
  brightblack: ["30;1", "39"],
  brightred: ["31;1", "39"],
  brightgreen: ["32;1", "39"],
  brightyellow: ["33;1", "39"],
  brightblue: ["34;1", "39"],
  brightmagenta: ["35;1", "39"],
  brightcyan: ["36;1", "39"],
  brightwhite: ["37;1", "39"],
  grey: ["90", "39"]
}, G8 = {
  special: "cyan",
  number: "yellow",
  bigint: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  symbol: "green",
  date: "magenta",
  regexp: "red"
}, Fo = "\u2026";
function ZP(e, t) {
  let r = jP[G8[t]] || jP[t] || "";
  return r ? `\x1B[${r[0]}m${String(e)}\x1B[${r[1]}m` : String(e);
}
o(ZP, "colorise");
I(ZP, "colorise");
function QP({
  showHidden: e = !1,
  depth: t = 2,
  colors: r = !1,
  customInspect: n = !0,
  showProxy: i = !1,
  maxArrayLength: s = 1 / 0,
  breakLength: a = 1 / 0,
  seen: l = [],
  // eslint-disable-next-line no-shadow
  truncate: u = 1 / 0,
  stylize: c = String
} = {}, d) {
  let p = {
    showHidden: !!e,
    depth: Number(t),
    colors: !!r,
    customInspect: !!n,
    showProxy: !!i,
    maxArrayLength: Number(s),
    breakLength: Number(a),
    truncate: Number(u),
    seen: l,
    inspect: d,
    stylize: c
  };
  return p.colors && (p.stylize = ZP), p;
}
o(QP, "normaliseOptions");
I(QP, "normaliseOptions");
function e0(e) {
  return e >= "\uD800" && e <= "\uDBFF";
}
o(e0, "isHighSurrogate");
I(e0, "isHighSurrogate");
function Rr(e, t, r = Fo) {
  e = String(e);
  let n = r.length, i = e.length;
  if (n > t && i > n)
    return r;
  if (i > t && i > n) {
    let s = t - n;
    return s > 0 && e0(e[s - 1]) && (s = s - 1), `${e.slice(0, s)}${r}`;
  }
  return e;
}
o(Rr, "truncate");
I(Rr, "truncate");
function Mt(e, t, r, n = ", ") {
  r = r || t.inspect;
  let i = e.length;
  if (i === 0)
    return "";
  let s = t.truncate, a = "", l = "", u = "";
  for (let c = 0; c < i; c += 1) {
    let d = c + 1 === e.length, p = c + 2 === e.length;
    u = `${Fo}(${e.length - c})`;
    let y = e[c];
    t.truncate = s - a.length - (d ? 0 : n.length);
    let f = l || r(y, t) + (d ? "" : n), m = a.length + f.length, h = m + u.length;
    if (d && m > s && a.length + u.length <= s || !d && !p && h > s || (l = d ? "" : r(e[c + 1], t) + (p ? "" : n), !d && p && h > s && m + l.
    length > s))
      break;
    if (a += f, !d && !p && m + l.length >= s) {
      u = `${Fo}(${e.length - c - 1})`;
      break;
    }
    u = "";
  }
  return `${a}${u}`;
}
o(Mt, "inspectList");
I(Mt, "inspectList");
function t0(e) {
  return e.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) ? e : JSON.stringify(e).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
}
o(t0, "quoteComplexKey");
I(t0, "quoteComplexKey");
function ko([e, t], r) {
  return r.truncate -= 2, typeof e == "string" ? e = t0(e) : typeof e != "number" && (e = `[${r.inspect(e, r)}]`), r.truncate -= e.length, t =
  r.inspect(t, r), `${e}: ${t}`;
}
o(ko, "inspectProperty");
I(ko, "inspectProperty");
function r0(e, t) {
  let r = Object.keys(e).slice(e.length);
  if (!e.length && !r.length)
    return "[]";
  t.truncate -= 4;
  let n = Mt(e, t);
  t.truncate -= n.length;
  let i = "";
  return r.length && (i = Mt(r.map((s) => [s, e[s]]), t, ko)), `[ ${n}${i ? `, ${i}` : ""} ]`;
}
o(r0, "inspectArray");
I(r0, "inspectArray");
var Y8 = /* @__PURE__ */ I((e) => typeof Buffer == "function" && e instanceof Buffer ? "Buffer" : e[Symbol.toStringTag] ? e[Symbol.toStringTag] :
e.constructor.name, "getArrayName");
function dr(e, t) {
  let r = Y8(e);
  t.truncate -= r.length + 4;
  let n = Object.keys(e).slice(e.length);
  if (!e.length && !n.length)
    return `${r}[]`;
  let i = "";
  for (let a = 0; a < e.length; a++) {
    let l = `${t.stylize(Rr(e[a], t.truncate), "number")}${a === e.length - 1 ? "" : ", "}`;
    if (t.truncate -= l.length, e[a] !== e.length && t.truncate <= 3) {
      i += `${Fo}(${e.length - e[a] + 1})`;
      break;
    }
    i += l;
  }
  let s = "";
  return n.length && (s = Mt(n.map((a) => [a, e[a]]), t, ko)), `${r}[ ${i}${s ? `, ${s}` : ""} ]`;
}
o(dr, "inspectTypedArray");
I(dr, "inspectTypedArray");
function n0(e, t) {
  let r = e.toJSON();
  if (r === null)
    return "Invalid Date";
  let n = r.split("T"), i = n[0];
  return t.stylize(`${i}T${Rr(n[1], t.truncate - i.length - 1)}`, "date");
}
o(n0, "inspectDate");
I(n0, "inspectDate");
function Mv(e, t) {
  let r = e[Symbol.toStringTag] || "Function", n = e.name;
  return n ? t.stylize(`[${r} ${Rr(n, t.truncate - 11)}]`, "special") : t.stylize(`[${r}]`, "special");
}
o(Mv, "inspectFunction");
I(Mv, "inspectFunction");
function o0([e, t], r) {
  return r.truncate -= 4, e = r.inspect(e, r), r.truncate -= e.length, t = r.inspect(t, r), `${e} => ${t}`;
}
o(o0, "inspectMapEntry");
I(o0, "inspectMapEntry");
function i0(e) {
  let t = [];
  return e.forEach((r, n) => {
    t.push([n, r]);
  }), t;
}
o(i0, "mapToEntries");
I(i0, "mapToEntries");
function s0(e, t) {
  return e.size - 1 <= 0 ? "Map{}" : (t.truncate -= 7, `Map{ ${Mt(i0(e), t, o0)} }`);
}
o(s0, "inspectMap");
I(s0, "inspectMap");
var W8 = Number.isNaN || ((e) => e !== e);
function Nv(e, t) {
  return W8(e) ? t.stylize("NaN", "number") : e === 1 / 0 ? t.stylize("Infinity", "number") : e === -1 / 0 ? t.stylize("-Infinity", "number") :
  e === 0 ? t.stylize(1 / e === 1 / 0 ? "+0" : "-0", "number") : t.stylize(Rr(String(e), t.truncate), "number");
}
o(Nv, "inspectNumber");
I(Nv, "inspectNumber");
function jv(e, t) {
  let r = Rr(e.toString(), t.truncate - 1);
  return r !== Fo && (r += "n"), t.stylize(r, "bigint");
}
o(jv, "inspectBigInt");
I(jv, "inspectBigInt");
function a0(e, t) {
  let r = e.toString().split("/")[2], n = t.truncate - (2 + r.length), i = e.source;
  return t.stylize(`/${Rr(i, n)}/${r}`, "regexp");
}
o(a0, "inspectRegExp");
I(a0, "inspectRegExp");
function l0(e) {
  let t = [];
  return e.forEach((r) => {
    t.push(r);
  }), t;
}
o(l0, "arrayFromSet");
I(l0, "arrayFromSet");
function u0(e, t) {
  return e.size === 0 ? "Set{}" : (t.truncate -= 7, `Set{ ${Mt(l0(e), t)} }`);
}
o(u0, "inspectSet");
I(u0, "inspectSet");
var LP = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\u\
ffff]", "g"), K8 = {
  "\b": "\\b",
  "	": "\\t",
  "\n": "\\n",
  "\f": "\\f",
  "\r": "\\r",
  "'": "\\'",
  "\\": "\\\\"
}, X8 = 16, J8 = 4;
function c0(e) {
  return K8[e] || `\\u${`0000${e.charCodeAt(0).toString(X8)}`.slice(-J8)}`;
}
o(c0, "escape");
I(c0, "escape");
function Lv(e, t) {
  return LP.test(e) && (e = e.replace(LP, c0)), t.stylize(`'${Rr(e, t.truncate - 2)}'`, "string");
}
o(Lv, "inspectString");
I(Lv, "inspectString");
function Fv(e) {
  return "description" in Symbol.prototype ? e.description ? `Symbol(${e.description})` : "Symbol()" : e.toString();
}
o(Fv, "inspectSymbol");
I(Fv, "inspectSymbol");
var d0 = /* @__PURE__ */ I(() => "Promise{\u2026}", "getPromiseValue");
try {
  let { getPromiseDetails: e, kPending: t, kRejected: r } = process.binding("util");
  Array.isArray(e(Promise.resolve())) && (d0 = /* @__PURE__ */ I((n, i) => {
    let [s, a] = e(n);
    return s === t ? "Promise{<pending>}" : `Promise${s === r ? "!" : ""}{${i.inspect(a, i)}}`;
  }, "getPromiseValue"));
} catch {
}
var Z8 = d0;
function ms(e, t) {
  let r = Object.getOwnPropertyNames(e), n = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e) : [];
  if (r.length === 0 && n.length === 0)
    return "{}";
  if (t.truncate -= 4, t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let i = Mt(r.map((l) => [l, e[l]]), t, ko), s = Mt(n.map((l) => [l, e[l]]), t, ko);
  t.seen.pop();
  let a = "";
  return i && s && (a = ", "), `{ ${i}${a}${s} }`;
}
o(ms, "inspectObject");
I(ms, "inspectObject");
var qv = typeof Symbol < "u" && Symbol.toStringTag ? Symbol.toStringTag : !1;
function p0(e, t) {
  let r = "";
  return qv && qv in e && (r = e[qv]), r = r || e.constructor.name, (!r || r === "_class") && (r = "<Anonymous Class>"), t.truncate -= r.length,
  `${r}${ms(e, t)}`;
}
o(p0, "inspectClass");
I(p0, "inspectClass");
function f0(e, t) {
  return e.length === 0 ? "Arguments[]" : (t.truncate -= 13, `Arguments[ ${Mt(e, t)} ]`);
}
o(f0, "inspectArguments");
I(f0, "inspectArguments");
var Q8 = [
  "stack",
  "line",
  "column",
  "name",
  "message",
  "fileName",
  "lineNumber",
  "columnNumber",
  "number",
  "description",
  "cause"
];
function m0(e, t) {
  let r = Object.getOwnPropertyNames(e).filter((a) => Q8.indexOf(a) === -1), n = e.name;
  t.truncate -= n.length;
  let i = "";
  if (typeof e.message == "string" ? i = Rr(e.message, t.truncate) : r.unshift("message"), i = i ? `: ${i}` : "", t.truncate -= i.length + 5,
  t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let s = Mt(r.map((a) => [a, e[a]]), t, ko);
  return `${n}${i}${s ? ` { ${s} }` : ""}`;
}
o(m0, "inspectObject2");
I(m0, "inspectObject");
function h0([e, t], r) {
  return r.truncate -= 3, t ? `${r.stylize(String(e), "yellow")}=${r.stylize(`"${t}"`, "string")}` : `${r.stylize(String(e), "yellow")}`;
}
o(h0, "inspectAttribute");
I(h0, "inspectAttribute");
function Fl(e, t) {
  return Mt(e, t, Kv, `
`);
}
o(Fl, "inspectHTMLCollection");
I(Fl, "inspectHTMLCollection");
function Kv(e, t) {
  let r = e.getAttributeNames(), n = e.tagName.toLowerCase(), i = t.stylize(`<${n}`, "special"), s = t.stylize(">", "special"), a = t.stylize(
  `</${n}>`, "special");
  t.truncate -= n.length * 2 + 5;
  let l = "";
  r.length > 0 && (l += " ", l += Mt(r.map((d) => [d, e.getAttribute(d)]), t, h0, " ")), t.truncate -= l.length;
  let u = t.truncate, c = Fl(e.children, t);
  return c && c.length > u && (c = `${Fo}(${e.children.length})`), `${i}${l}${s}${c}${a}`;
}
o(Kv, "inspectHTML");
I(Kv, "inspectHTML");
var e9 = typeof Symbol == "function" && typeof Symbol.for == "function", Iv = e9 ? Symbol.for("chai/inspect") : "@@chai/inspect", Lo = !1;
try {
  let e = V8();
  Lo = e.inspect ? e.inspect.custom : !1;
} catch {
  Lo = !1;
}
var FP = /* @__PURE__ */ new WeakMap(), kP = {}, DP = {
  undefined: /* @__PURE__ */ o((e, t) => t.stylize("undefined", "undefined"), "undefined"),
  null: /* @__PURE__ */ o((e, t) => t.stylize("null", "null"), "null"),
  boolean: /* @__PURE__ */ o((e, t) => t.stylize(String(e), "boolean"), "boolean"),
  Boolean: /* @__PURE__ */ o((e, t) => t.stylize(String(e), "boolean"), "Boolean"),
  number: Nv,
  Number: Nv,
  bigint: jv,
  BigInt: jv,
  string: Lv,
  String: Lv,
  function: Mv,
  Function: Mv,
  symbol: Fv,
  // A Symbol polyfill will return `Symbol` not `symbol` from typedetect
  Symbol: Fv,
  Array: r0,
  Date: n0,
  Map: s0,
  Set: u0,
  RegExp: a0,
  Promise: Z8,
  // WeakSet, WeakMap are totally opaque to us
  WeakSet: /* @__PURE__ */ o((e, t) => t.stylize("WeakSet{\u2026}", "special"), "WeakSet"),
  WeakMap: /* @__PURE__ */ o((e, t) => t.stylize("WeakMap{\u2026}", "special"), "WeakMap"),
  Arguments: f0,
  Int8Array: dr,
  Uint8Array: dr,
  Uint8ClampedArray: dr,
  Int16Array: dr,
  Uint16Array: dr,
  Int32Array: dr,
  Uint32Array: dr,
  Float32Array: dr,
  Float64Array: dr,
  Generator: /* @__PURE__ */ o(() => "", "Generator"),
  DataView: /* @__PURE__ */ o(() => "", "DataView"),
  ArrayBuffer: /* @__PURE__ */ o(() => "", "ArrayBuffer"),
  Error: m0,
  HTMLCollection: Fl,
  NodeList: Fl
}, t9 = /* @__PURE__ */ I((e, t, r) => Iv in e && typeof e[Iv] == "function" ? e[Iv](t) : Lo && Lo in e && typeof e[Lo] == "function" ? e[Lo](
t.depth, t) : "inspect" in e && typeof e.inspect == "function" ? e.inspect(t.depth, t) : "constructor" in e && FP.has(e.constructor) ? FP.get(
e.constructor)(e, t) : kP[r] ? kP[r](e, t) : "", "inspectCustom"), r9 = Object.prototype.toString;
function kl(e, t = {}) {
  let r = QP(t, kl), { customInspect: n } = r, i = e === null ? "null" : typeof e;
  if (i === "object" && (i = r9.call(e).slice(8, -1)), i in DP)
    return DP[i](e, r);
  if (n && e) {
    let a = t9(e, r, i);
    if (a)
      return typeof a == "string" ? a : kl(a, r);
  }
  let s = e ? Object.getPrototypeOf(e) : !1;
  return s === Object.prototype || s === null ? ms(e, r) : e && typeof HTMLElement == "function" && e instanceof HTMLElement ? Kv(e, r) : "c\
onstructor" in e ? e.constructor !== Object ? p0(e, r) : ms(e, r) : e === Object(e) ? ms(e, r) : r.stylize(String(e), i);
}
o(kl, "inspect");
I(kl, "inspect");
var mt = {
  /**
   * ### config.includeStack
   *
   * User configurable property, influences whether stack trace
   * is included in Assertion error message. Default of false
   * suppresses stack trace in the error message.
   *
   *     chai.config.includeStack = true;  // enable stack on error
   *
   * @param {boolean}
   * @public
   */
  includeStack: !1,
  /**
   * ### config.showDiff
   *
   * User configurable property, influences whether or not
   * the `showDiff` flag should be included in the thrown
   * AssertionErrors. `false` will always be `false`; `true`
   * will be true when the assertion has requested a diff
   * be shown.
   *
   * @param {boolean}
   * @public
   */
  showDiff: !0,
  /**
   * ### config.truncateThreshold
   *
   * User configurable property, sets length threshold for actual and
   * expected values in assertion errors. If this threshold is exceeded, for
   * example for large data structures, the value is replaced with something
   * like `[ Array(3) ]` or `{ Object (prop1, prop2) }`.
   *
   * Set it to zero if you want to disable truncating altogether.
   *
   * This is especially userful when doing assertions on arrays: having this
   * set to a reasonable large value makes the failure messages readily
   * inspectable.
   *
   *     chai.config.truncateThreshold = 0;  // disable truncating
   *
   * @param {number}
   * @public
   */
  truncateThreshold: 40,
  /**
   * ### config.useProxy
   *
   * User configurable property, defines if chai will use a Proxy to throw
   * an error when a non-existent property is read, which protects users
   * from typos when using property-based assertions.
   *
   * Set it to false if you want to disable this feature.
   *
   *     chai.config.useProxy = false;  // disable use of Proxy
   *
   * This feature is automatically disabled regardless of this config value
   * in environments that don't support proxies.
   *
   * @param {boolean}
   * @public
   */
  useProxy: !0,
  /**
   * ### config.proxyExcludedKeys
   *
   * User configurable property, defines which properties should be ignored
   * instead of throwing an error if they do not exist on the assertion.
   * This is only applied if the environment Chai is running in supports proxies and
   * if the `useProxy` configuration setting is enabled.
   * By default, `then` and `inspect` will not throw an error if they do not exist on the
   * assertion object because the `.inspect` property is read by `util.inspect` (for example, when
   * using `console.log` on the assertion object) and `.then` is necessary for promise type-checking.
   *
   *     // By default these keys will not throw an error if they do not exist on the assertion object
   *     chai.config.proxyExcludedKeys = ['then', 'inspect'];
   *
   * @param {Array}
   * @public
   */
  proxyExcludedKeys: ["then", "catch", "inspect", "toJSON"],
  /**
   * ### config.deepEqual
   *
   * User configurable property, defines which a custom function to use for deepEqual
   * comparisons.
   * By default, the function used is the one from the `deep-eql` package without custom comparator.
   *
   *     // use a custom comparator
   *     chai.config.deepEqual = (expected, actual) => {
   *         return chai.util.eql(expected, actual, {
   *             comparator: (expected, actual) => {
   *                 // for non number comparison, use the default behavior
   *                 if(typeof expected !== 'number') return null;
   *                 // allow a difference of 10 between compared numbers
   *                 return typeof actual === 'number' && Math.abs(actual - expected) < 10
   *             }
   *         })
   *     };
   *
   * @param {Function}
   * @public
   */
  deepEqual: null
};
function de(e, t, r, n) {
  var i = {
    colors: n,
    depth: typeof r > "u" ? 2 : r,
    showHidden: t,
    truncate: mt.truncateThreshold ? mt.truncateThreshold : 1 / 0
  };
  return kl(e, i);
}
o(de, "inspect2");
I(de, "inspect");
function qn(e) {
  var t = de(e), r = Object.prototype.toString.call(e);
  if (mt.truncateThreshold && t.length >= mt.truncateThreshold) {
    if (r === "[object Function]")
      return !e.name || e.name === "" ? "[Function]" : "[Function: " + e.name + "]";
    if (r === "[object Array]")
      return "[ Array(" + e.length + ") ]";
    if (r === "[object Object]") {
      var n = Object.keys(e), i = n.length > 2 ? n.splice(0, 2).join(", ") + ", ..." : n.join(", ");
      return "{ Object (" + i + ") }";
    } else
      return t;
  } else
    return t;
}
o(qn, "objDisplay");
I(qn, "objDisplay");
function Xv(e, t) {
  var r = re(e, "negate"), n = re(e, "object"), i = t[3], s = zl(e, t), a = r ? t[2] : t[1], l = re(e, "message");
  return typeof a == "function" && (a = a()), a = a || "", a = a.replace(/#\{this\}/g, function() {
    return qn(n);
  }).replace(/#\{act\}/g, function() {
    return qn(s);
  }).replace(/#\{exp\}/g, function() {
    return qn(i);
  }), l ? l + ": " + a : a;
}
o(Xv, "getMessage2");
I(Xv, "getMessage");
function Gt(e, t, r) {
  var n = e.__flags || (e.__flags = /* @__PURE__ */ Object.create(null));
  t.__flags || (t.__flags = /* @__PURE__ */ Object.create(null)), r = arguments.length === 3 ? r : !0;
  for (var i in n)
    (r || i !== "object" && i !== "ssfi" && i !== "lockSsfi" && i != "message") && (t.__flags[i] = n[i]);
}
o(Gt, "transferFlags");
I(Gt, "transferFlags");
function kv(e) {
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  let t = e[Symbol.toStringTag];
  return typeof t == "string" ? t : Object.prototype.toString.call(e).slice(8, -1);
}
o(kv, "type2");
I(kv, "type");
function Jv() {
  this._key = "chai/deep-eql__" + Math.random() + Date.now();
}
o(Jv, "FakeMap");
I(Jv, "FakeMap");
Jv.prototype = {
  get: /* @__PURE__ */ I(/* @__PURE__ */ o(function(t) {
    return t[this._key];
  }, "get"), "get"),
  set: /* @__PURE__ */ I(/* @__PURE__ */ o(function(t, r) {
    Object.isExtensible(t) && Object.defineProperty(t, this._key, {
      value: r,
      configurable: !0
    });
  }, "set"), "set")
};
var y0 = typeof WeakMap == "function" ? WeakMap : Jv;
function Dv(e, t, r) {
  if (!r || In(e) || In(t))
    return null;
  var n = r.get(e);
  if (n) {
    var i = n.get(t);
    if (typeof i == "boolean")
      return i;
  }
  return null;
}
o(Dv, "memoizeCompare");
I(Dv, "memoizeCompare");
function fs(e, t, r, n) {
  if (!(!r || In(e) || In(t))) {
    var i = r.get(e);
    i ? i.set(t, n) : (i = new y0(), i.set(t, n), r.set(e, i));
  }
}
o(fs, "memoizeSet");
I(fs, "memoizeSet");
var b0 = hs;
function hs(e, t, r) {
  if (r && r.comparator)
    return $v(e, t, r);
  var n = Zv(e, t);
  return n !== null ? n : $v(e, t, r);
}
o(hs, "deepEqual");
I(hs, "deepEqual");
function Zv(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && // eslint-disable-line no-self-compare
  t !== t ? !0 : In(e) || In(t) ? !1 : null;
}
o(Zv, "simpleEqual");
I(Zv, "simpleEqual");
function $v(e, t, r) {
  r = r || {}, r.memoize = r.memoize === !1 ? !1 : r.memoize || new y0();
  var n = r && r.comparator, i = Dv(e, t, r.memoize);
  if (i !== null)
    return i;
  var s = Dv(t, e, r.memoize);
  if (s !== null)
    return s;
  if (n) {
    var a = n(e, t);
    if (a === !1 || a === !0)
      return fs(e, t, r.memoize, a), a;
    var l = Zv(e, t);
    if (l !== null)
      return l;
  }
  var u = kv(e);
  if (u !== kv(t))
    return fs(e, t, r.memoize, !1), !1;
  fs(e, t, r.memoize, !0);
  var c = g0(e, t, u, r);
  return fs(e, t, r.memoize, c), c;
}
o($v, "extensiveDeepEqual");
I($v, "extensiveDeepEqual");
function g0(e, t, r, n) {
  switch (r) {
    case "String":
    case "Number":
    case "Boolean":
    case "Date":
      return hs(e.valueOf(), t.valueOf());
    case "Promise":
    case "Symbol":
    case "function":
    case "WeakMap":
    case "WeakSet":
      return e === t;
    case "Error":
      return Qv(e, t, ["name", "message", "code"], n);
    case "Arguments":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "Array":
      return Ur(e, t, n);
    case "RegExp":
      return v0(e, t);
    case "Generator":
      return E0(e, t, n);
    case "DataView":
      return Ur(new Uint8Array(e.buffer), new Uint8Array(t.buffer), n);
    case "ArrayBuffer":
      return Ur(new Uint8Array(e), new Uint8Array(t), n);
    case "Set":
      return Bv(e, t, n);
    case "Map":
      return Bv(e, t, n);
    case "Temporal.PlainDate":
    case "Temporal.PlainTime":
    case "Temporal.PlainDateTime":
    case "Temporal.Instant":
    case "Temporal.ZonedDateTime":
    case "Temporal.PlainYearMonth":
    case "Temporal.PlainMonthDay":
      return e.equals(t);
    case "Temporal.Duration":
      return e.total("nanoseconds") === t.total("nanoseconds");
    case "Temporal.TimeZone":
    case "Temporal.Calendar":
      return e.toString() === t.toString();
    default:
      return _0(e, t, n);
  }
}
o(g0, "extensiveDeepEqualByType");
I(g0, "extensiveDeepEqualByType");
function v0(e, t) {
  return e.toString() === t.toString();
}
o(v0, "regexpEqual");
I(v0, "regexpEqual");
function Bv(e, t, r) {
  try {
    if (e.size !== t.size)
      return !1;
    if (e.size === 0)
      return !0;
  } catch {
    return !1;
  }
  var n = [], i = [];
  return e.forEach(/* @__PURE__ */ I(/* @__PURE__ */ o(function(a, l) {
    n.push([a, l]);
  }, "gatherEntries"), "gatherEntries")), t.forEach(/* @__PURE__ */ I(/* @__PURE__ */ o(function(a, l) {
    i.push([a, l]);
  }, "gatherEntries"), "gatherEntries")), Ur(n.sort(), i.sort(), r);
}
o(Bv, "entriesEqual");
I(Bv, "entriesEqual");
function Ur(e, t, r) {
  var n = e.length;
  if (n !== t.length)
    return !1;
  if (n === 0)
    return !0;
  for (var i = -1; ++i < n; )
    if (hs(e[i], t[i], r) === !1)
      return !1;
  return !0;
}
o(Ur, "iterableEqual");
I(Ur, "iterableEqual");
function E0(e, t, r) {
  return Ur(Dl(e), Dl(t), r);
}
o(E0, "generatorEqual");
I(E0, "generatorEqual");
function T0(e) {
  return typeof Symbol < "u" && typeof e == "object" && typeof Symbol.iterator < "u" && typeof e[Symbol.iterator] == "function";
}
o(T0, "hasIteratorFunction");
I(T0, "hasIteratorFunction");
function Uv(e) {
  if (T0(e))
    try {
      return Dl(e[Symbol.iterator]());
    } catch {
      return [];
    }
  return [];
}
o(Uv, "getIteratorEntries");
I(Uv, "getIteratorEntries");
function Dl(e) {
  for (var t = e.next(), r = [t.value]; t.done === !1; )
    t = e.next(), r.push(t.value);
  return r;
}
o(Dl, "getGeneratorEntries");
I(Dl, "getGeneratorEntries");
function Hv(e) {
  var t = [];
  for (var r in e)
    t.push(r);
  return t;
}
o(Hv, "getEnumerableKeys");
I(Hv, "getEnumerableKeys");
function Vv(e) {
  for (var t = [], r = Object.getOwnPropertySymbols(e), n = 0; n < r.length; n += 1) {
    var i = r[n];
    Object.getOwnPropertyDescriptor(e, i).enumerable && t.push(i);
  }
  return t;
}
o(Vv, "getEnumerableSymbols");
I(Vv, "getEnumerableSymbols");
function Qv(e, t, r, n) {
  var i = r.length;
  if (i === 0)
    return !0;
  for (var s = 0; s < i; s += 1)
    if (hs(e[r[s]], t[r[s]], n) === !1)
      return !1;
  return !0;
}
o(Qv, "keysEqual");
I(Qv, "keysEqual");
function _0(e, t, r) {
  var n = Hv(e), i = Hv(t), s = Vv(e), a = Vv(t);
  if (n = n.concat(s), i = i.concat(a), n.length && n.length === i.length)
    return Ur(zv(n).sort(), zv(i).sort()) === !1 ? !1 : Qv(e, t, n, r);
  var l = Uv(e), u = Uv(t);
  return l.length && l.length === u.length ? (l.sort(), u.sort(), Ur(l, u, r)) : n.length === 0 && l.length === 0 && i.length === 0 && u.length ===
  0;
}
o(_0, "objectEqual");
I(_0, "objectEqual");
function In(e) {
  return e === null || typeof e != "object";
}
o(In, "isPrimitive");
I(In, "isPrimitive");
function zv(e) {
  return e.map(/* @__PURE__ */ I(/* @__PURE__ */ o(function(r) {
    return typeof r == "symbol" ? r.toString() : r;
  }, "mapSymbol"), "mapSymbol"));
}
o(zv, "mapSymbols");
I(zv, "mapSymbols");
function Gl(e, t) {
  return typeof e > "u" || e === null ? !1 : t in Object(e);
}
o(Gl, "hasProperty");
I(Gl, "hasProperty");
function R0(e) {
  return e.replace(/([^\\])\[/g, "$1.[").match(/(\\\.|[^.]+?)+/g).map((n) => {
    if (n === "constructor" || n === "__proto__" || n === "prototype")
      return {};
    let s = /^\[(\d+)\]$/.exec(n), a = null;
    return s ? a = { i: parseFloat(s[1]) } : a = { p: n.replace(/\\([.[\]])/g, "$1") }, a;
  });
}
o(R0, "parsePath");
I(R0, "parsePath");
function Gv(e, t, r) {
  let n = e, i = null;
  r = typeof r > "u" ? t.length : r;
  for (let s = 0; s < r; s++) {
    let a = t[s];
    n && (typeof a.p > "u" ? n = n[a.i] : n = n[a.p], s === r - 1 && (i = n));
  }
  return i;
}
o(Gv, "internalGetPathValue");
I(Gv, "internalGetPathValue");
function eE(e, t) {
  let r = R0(t), n = r[r.length - 1], i = {
    parent: r.length > 1 ? Gv(e, r, r.length - 1) : e,
    name: n.p || n.i,
    value: Gv(e, r)
  };
  return i.exists = Gl(i.parent, i.name), i;
}
o(eE, "getPathInfo");
I(eE, "getPathInfo");
function x(e, t, r, n) {
  return re(this, "ssfi", r || x), re(this, "lockSsfi", n), re(this, "object", e), re(this, "message", t), re(this, "eql", mt.deepEqual || b0),
  Do(this);
}
o(x, "Assertion");
I(x, "Assertion");
Object.defineProperty(x, "includeStack", {
  get: /* @__PURE__ */ o(function() {
    return console.warn(
      "Assertion.includeStack is deprecated, use chai.config.includeStack instead."
    ), mt.includeStack;
  }, "get"),
  set: /* @__PURE__ */ o(function(e) {
    console.warn(
      "Assertion.includeStack is deprecated, use chai.config.includeStack instead."
    ), mt.includeStack = e;
  }, "set")
});
Object.defineProperty(x, "showDiff", {
  get: /* @__PURE__ */ o(function() {
    return console.warn(
      "Assertion.showDiff is deprecated, use chai.config.showDiff instead."
    ), mt.showDiff;
  }, "get"),
  set: /* @__PURE__ */ o(function(e) {
    console.warn(
      "Assertion.showDiff is deprecated, use chai.config.showDiff instead."
    ), mt.showDiff = e;
  }, "set")
});
x.addProperty = function(e, t) {
  tE(this.prototype, e, t);
};
x.addMethod = function(e, t) {
  rE(this.prototype, e, t);
};
x.addChainableMethod = function(e, t, r) {
  iE(this.prototype, e, t, r);
};
x.overwriteProperty = function(e, t) {
  nE(this.prototype, e, t);
};
x.overwriteMethod = function(e, t) {
  oE(this.prototype, e, t);
};
x.overwriteChainableMethod = function(e, t, r) {
  sE(this.prototype, e, t, r);
};
x.prototype.assert = function(e, t, r, n, i, s) {
  var a = Wv(this, arguments);
  if (s !== !1 && (s = !0), n === void 0 && i === void 0 && (s = !1), mt.showDiff !== !0 && (s = !1), !a) {
    t = Xv(this, arguments);
    var l = zl(this, arguments), u = {
      actual: l,
      expected: n,
      showDiff: s
    }, c = uE(this, arguments);
    throw c && (u.operator = c), new pe(
      t,
      u,
      mt.includeStack ? this.assert : re(this, "ssfi")
    );
  }
};
Object.defineProperty(x.prototype, "_obj", {
  get: /* @__PURE__ */ o(function() {
    return re(this, "object");
  }, "get"),
  set: /* @__PURE__ */ o(function(e) {
    re(this, "object", e);
  }, "set")
});
function ys() {
  return mt.useProxy && typeof Proxy < "u" && typeof Reflect < "u";
}
o(ys, "isProxyEnabled");
I(ys, "isProxyEnabled");
function tE(e, t, r) {
  r = r === void 0 ? function() {
  } : r, Object.defineProperty(e, t, {
    get: /* @__PURE__ */ I(/* @__PURE__ */ o(function n() {
      !ys() && !re(this, "lockSsfi") && re(this, "ssfi", n);
      var i = r.call(this);
      if (i !== void 0)
        return i;
      var s = new x();
      return Gt(this, s), s;
    }, "propertyGetter"), "propertyGetter"),
    configurable: !0
  });
}
o(tE, "addProperty");
I(tE, "addProperty");
var n9 = Object.getOwnPropertyDescriptor(function() {
}, "length");
function bs(e, t, r) {
  return n9.configurable && Object.defineProperty(e, "length", {
    get: /* @__PURE__ */ o(function() {
      throw Error(
        r ? "Invalid Chai property: " + t + '.length. Due to a compatibility issue, "length" cannot directly follow "' + t + '". Use "' + t +
        '.lengthOf" instead.' : "Invalid Chai property: " + t + '.length. See docs for proper usage of "' + t + '".'
      );
    }, "get")
  }), e;
}
o(bs, "addLengthGuard");
I(bs, "addLengthGuard");
function w0(e) {
  var t = Object.getOwnPropertyNames(e);
  function r(i) {
    t.indexOf(i) === -1 && t.push(i);
  }
  o(r, "addProperty2"), I(r, "addProperty");
  for (var n = Object.getPrototypeOf(e); n !== null; )
    Object.getOwnPropertyNames(n).forEach(r), n = Object.getPrototypeOf(n);
  return t;
}
o(w0, "getProperties");
I(w0, "getProperties");
var $P = ["__flags", "__methods", "_obj", "assert"];
function Do(e, t) {
  return ys() ? new Proxy(e, {
    get: /* @__PURE__ */ I(/* @__PURE__ */ o(function r(n, i) {
      if (typeof i == "string" && mt.proxyExcludedKeys.indexOf(i) === -1 && !Reflect.has(n, i)) {
        if (t)
          throw Error(
            "Invalid Chai property: " + t + "." + i + '. See docs for proper usage of "' + t + '".'
          );
        var s = null, a = 4;
        throw w0(n).forEach(function(l) {
          if (
            // we actually mean to check `Object.prototype` here
            // eslint-disable-next-line no-prototype-builtins
            !Object.prototype.hasOwnProperty(l) && $P.indexOf(l) === -1
          ) {
            var u = S0(i, l, a);
            u < a && (s = l, a = u);
          }
        }), Error(
          s !== null ? "Invalid Chai property: " + i + '. Did you mean "' + s + '"?' : "Invalid Chai property: " + i
        );
      }
      return $P.indexOf(i) === -1 && !re(n, "lockSsfi") && re(n, "ssfi", r), Reflect.get(n, i);
    }, "proxyGetter"), "proxyGetter")
  }) : e;
}
o(Do, "proxify");
I(Do, "proxify");
function S0(e, t, r) {
  if (Math.abs(e.length - t.length) >= r)
    return r;
  var n = [];
  for (let s = 0; s <= e.length; s++)
    n[s] = Array(t.length + 1).fill(0), n[s][0] = s;
  for (let s = 0; s < t.length; s++)
    n[0][s] = s;
  for (let s = 1; s <= e.length; s++) {
    var i = e.charCodeAt(s - 1);
    for (let a = 1; a <= t.length; a++) {
      if (Math.abs(s - a) >= r) {
        n[s][a] = r;
        continue;
      }
      n[s][a] = Math.min(
        n[s - 1][a] + 1,
        n[s][a - 1] + 1,
        n[s - 1][a - 1] + (i === t.charCodeAt(a - 1) ? 0 : 1)
      );
    }
  }
  return n[e.length][t.length];
}
o(S0, "stringDistanceCapped");
I(S0, "stringDistanceCapped");
function rE(e, t, r) {
  var n = /* @__PURE__ */ I(function() {
    re(this, "lockSsfi") || re(this, "ssfi", n);
    var i = r.apply(this, arguments);
    if (i !== void 0)
      return i;
    var s = new x();
    return Gt(this, s), s;
  }, "methodWrapper");
  bs(n, t, !1), e[t] = Do(n, t);
}
o(rE, "addMethod");
I(rE, "addMethod");
function nE(e, t, r) {
  var n = Object.getOwnPropertyDescriptor(e, t), i = /* @__PURE__ */ I(function() {
  }, "_super");
  n && typeof n.get == "function" && (i = n.get), Object.defineProperty(e, t, {
    get: /* @__PURE__ */ I(/* @__PURE__ */ o(function s() {
      !ys() && !re(this, "lockSsfi") && re(this, "ssfi", s);
      var a = re(this, "lockSsfi");
      re(this, "lockSsfi", !0);
      var l = r(i).call(this);
      if (re(this, "lockSsfi", a), l !== void 0)
        return l;
      var u = new x();
      return Gt(this, u), u;
    }, "overwritingPropertyGetter"), "overwritingPropertyGetter"),
    configurable: !0
  });
}
o(nE, "overwriteProperty");
I(nE, "overwriteProperty");
function oE(e, t, r) {
  var n = e[t], i = /* @__PURE__ */ I(function() {
    throw new Error(t + " is not a function");
  }, "_super");
  n && typeof n == "function" && (i = n);
  var s = /* @__PURE__ */ I(function() {
    re(this, "lockSsfi") || re(this, "ssfi", s);
    var a = re(this, "lockSsfi");
    re(this, "lockSsfi", !0);
    var l = r(i).apply(this, arguments);
    if (re(this, "lockSsfi", a), l !== void 0)
      return l;
    var u = new x();
    return Gt(this, u), u;
  }, "overwritingMethodWrapper");
  bs(s, t, !1), e[t] = Do(s, t);
}
o(oE, "overwriteMethod");
I(oE, "overwriteMethod");
var o9 = typeof Object.setPrototypeOf == "function", BP = /* @__PURE__ */ I(function() {
}, "testFn"), i9 = Object.getOwnPropertyNames(BP).filter(function(e) {
  var t = Object.getOwnPropertyDescriptor(BP, e);
  return typeof t != "object" ? !0 : !t.configurable;
}), s9 = Function.prototype.call, a9 = Function.prototype.apply;
function iE(e, t, r, n) {
  typeof n != "function" && (n = /* @__PURE__ */ I(function() {
  }, "chainingBehavior"));
  var i = {
    method: r,
    chainingBehavior: n
  };
  e.__methods || (e.__methods = {}), e.__methods[t] = i, Object.defineProperty(e, t, {
    get: /* @__PURE__ */ I(/* @__PURE__ */ o(function() {
      i.chainingBehavior.call(this);
      var a = /* @__PURE__ */ I(function() {
        re(this, "lockSsfi") || re(this, "ssfi", a);
        var c = i.method.apply(this, arguments);
        if (c !== void 0)
          return c;
        var d = new x();
        return Gt(this, d), d;
      }, "chainableMethodWrapper");
      if (bs(a, t, !0), o9) {
        var l = Object.create(this);
        l.call = s9, l.apply = a9, Object.setPrototypeOf(a, l);
      } else {
        var u = Object.getOwnPropertyNames(e);
        u.forEach(function(c) {
          if (i9.indexOf(c) === -1) {
            var d = Object.getOwnPropertyDescriptor(e, c);
            Object.defineProperty(a, c, d);
          }
        });
      }
      return Gt(this, a), Do(a);
    }, "chainableMethodGetter"), "chainableMethodGetter"),
    configurable: !0
  });
}
o(iE, "addChainableMethod");
I(iE, "addChainableMethod");
function sE(e, t, r, n) {
  var i = e.__methods[t], s = i.chainingBehavior;
  i.chainingBehavior = /* @__PURE__ */ I(/* @__PURE__ */ o(function() {
    var u = n(s).call(this);
    if (u !== void 0)
      return u;
    var c = new x();
    return Gt(this, c), c;
  }, "overwritingChainableMethodGetter"), "overwritingChainableMethodGetter");
  var a = i.method;
  i.method = /* @__PURE__ */ I(/* @__PURE__ */ o(function() {
    var u = r(a).apply(this, arguments);
    if (u !== void 0)
      return u;
    var c = new x();
    return Gt(this, c), c;
  }, "overwritingChainableMethodWrapper"), "overwritingChainableMethodWrapper");
}
o(sE, "overwriteChainableMethod");
I(sE, "overwriteChainableMethod");
function $l(e, t) {
  return de(e) < de(t) ? -1 : 1;
}
o($l, "compareByInspect");
I($l, "compareByInspect");
function aE(e) {
  return typeof Object.getOwnPropertySymbols != "function" ? [] : Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.getOwnPropertyDescriptor(e, t).enumerable;
  });
}
o(aE, "getOwnEnumerablePropertySymbols");
I(aE, "getOwnEnumerablePropertySymbols");
function lE(e) {
  return Object.keys(e).concat(aE(e));
}
o(lE, "getOwnEnumerableProperties");
I(lE, "getOwnEnumerableProperties");
var Bl = Number.isNaN;
function x0(e) {
  var t = Te(e), r = ["Array", "Object", "Function"];
  return r.indexOf(t) !== -1;
}
o(x0, "isObjectType");
I(x0, "isObjectType");
function uE(e, t) {
  var r = re(e, "operator"), n = re(e, "negate"), i = t[3], s = n ? t[2] : t[1];
  if (r)
    return r;
  if (typeof s == "function" && (s = s()), s = s || "", !!s && !/\shave\s/.test(s)) {
    var a = x0(i);
    return /\snot\s/.test(s) ? a ? "notDeepStrictEqual" : "notStrictEqual" : a ? "deepStrictEqual" : "strictEqual";
  }
}
o(uE, "getOperator");
I(uE, "getOperator");
function Yl(e) {
  return e.name;
}
o(Yl, "getName");
I(Yl, "getName");
function Ul(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
o(Ul, "isRegExp2");
I(Ul, "isRegExp");
function We(e) {
  return ["Number", "BigInt"].includes(Te(e));
}
o(We, "isNumeric");
I(We, "isNumeric");
var { flag: q } = It;
[
  "to",
  "be",
  "been",
  "is",
  "and",
  "has",
  "have",
  "with",
  "that",
  "which",
  "at",
  "of",
  "same",
  "but",
  "does",
  "still",
  "also"
].forEach(function(e) {
  x.addProperty(e);
});
x.addProperty("not", function() {
  q(this, "negate", !0);
});
x.addProperty("deep", function() {
  q(this, "deep", !0);
});
x.addProperty("nested", function() {
  q(this, "nested", !0);
});
x.addProperty("own", function() {
  q(this, "own", !0);
});
x.addProperty("ordered", function() {
  q(this, "ordered", !0);
});
x.addProperty("any", function() {
  q(this, "any", !0), q(this, "all", !1);
});
x.addProperty("all", function() {
  q(this, "all", !0), q(this, "any", !1);
});
var UP = {
  function: [
    "function",
    "asyncfunction",
    "generatorfunction",
    "asyncgeneratorfunction"
  ],
  asyncfunction: ["asyncfunction", "asyncgeneratorfunction"],
  generatorfunction: ["generatorfunction", "asyncgeneratorfunction"],
  asyncgeneratorfunction: ["asyncgeneratorfunction"]
};
function cE(e, t) {
  t && q(this, "message", t), e = e.toLowerCase();
  var r = q(this, "object"), n = ~["a", "e", "i", "o", "u"].indexOf(e.charAt(0)) ? "an " : "a ";
  let i = Te(r).toLowerCase();
  UP.function.includes(e) ? this.assert(
    UP[e].includes(i),
    "expected #{this} to be " + n + e,
    "expected #{this} not to be " + n + e
  ) : this.assert(
    e === i,
    "expected #{this} to be " + n + e,
    "expected #{this} not to be " + n + e
  );
}
o(cE, "an");
I(cE, "an");
x.addChainableMethod("an", cE);
x.addChainableMethod("a", cE);
function C0(e, t) {
  return Bl(e) && Bl(t) || e === t;
}
o(C0, "SameValueZero");
I(C0, "SameValueZero");
function gs() {
  q(this, "contains", !0);
}
o(gs, "includeChainingBehavior");
I(gs, "includeChainingBehavior");
function vs(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = Te(r).toLowerCase(), i = q(this, "message"), s = q(this, "negate"), a = q(this, "ssfi"), l = q(this, "deep"),
  u = l ? "deep " : "", c = l ? q(this, "eql") : C0;
  i = i ? i + ": " : "";
  var d = !1;
  switch (n) {
    case "string":
      d = r.indexOf(e) !== -1;
      break;
    case "weakset":
      if (l)
        throw new pe(
          i + "unable to use .deep.include with WeakSet",
          void 0,
          a
        );
      d = r.has(e);
      break;
    case "map":
      r.forEach(function(m) {
        d = d || c(m, e);
      });
      break;
    case "set":
      l ? r.forEach(function(m) {
        d = d || c(m, e);
      }) : d = r.has(e);
      break;
    case "array":
      l ? d = r.some(function(m) {
        return c(m, e);
      }) : d = r.indexOf(e) !== -1;
      break;
    default:
      if (e !== Object(e))
        throw new pe(
          i + "the given combination of arguments (" + n + " and " + Te(e).toLowerCase() + ") is invalid for this assertion. You can use an \
array, a map, an object, a set, a string, or a weakset instead of a " + Te(e).toLowerCase(),
          void 0,
          a
        );
      var p = Object.keys(e), y = null, f = 0;
      if (p.forEach(function(m) {
        var h = new x(r);
        if (Gt(this, h, !0), q(h, "lockSsfi", !0), !s || p.length === 1) {
          h.property(m, e[m]);
          return;
        }
        try {
          h.property(m, e[m]);
        } catch (b) {
          if (!St.compatibleConstructor(b, pe))
            throw b;
          y === null && (y = b), f++;
        }
      }, this), s && p.length > 1 && f === p.length)
        throw y;
      return;
  }
  this.assert(
    d,
    "expected #{this} to " + u + "include " + de(e),
    "expected #{this} to not " + u + "include " + de(e)
  );
}
o(vs, "include");
I(vs, "include");
x.addChainableMethod("include", vs, gs);
x.addChainableMethod("contain", vs, gs);
x.addChainableMethod("contains", vs, gs);
x.addChainableMethod("includes", vs, gs);
x.addProperty("ok", function() {
  this.assert(
    q(this, "object"),
    "expected #{this} to be truthy",
    "expected #{this} to be falsy"
  );
});
x.addProperty("true", function() {
  this.assert(
    q(this, "object") === !0,
    "expected #{this} to be true",
    "expected #{this} to be false",
    !q(this, "negate")
  );
});
x.addProperty("numeric", function() {
  let e = q(this, "object");
  this.assert(
    ["Number", "BigInt"].includes(Te(e)),
    "expected #{this} to be numeric",
    "expected #{this} to not be numeric",
    !q(this, "negate")
  );
});
x.addProperty("callable", function() {
  let e = q(this, "object"), t = q(this, "ssfi"), r = q(this, "message"), n = r ? `${r}: ` : "", i = q(this, "negate"), s = i ? `${n}expecte\
d ${de(e)} not to be a callable function` : `${n}expected ${de(e)} to be a callable function`, a = [
    "Function",
    "AsyncFunction",
    "GeneratorFunction",
    "AsyncGeneratorFunction"
  ].includes(Te(e));
  if (a && i || !a && !i)
    throw new pe(s, void 0, t);
});
x.addProperty("false", function() {
  this.assert(
    q(this, "object") === !1,
    "expected #{this} to be false",
    "expected #{this} to be true",
    !!q(this, "negate")
  );
});
x.addProperty("null", function() {
  this.assert(
    q(this, "object") === null,
    "expected #{this} to be null",
    "expected #{this} not to be null"
  );
});
x.addProperty("undefined", function() {
  this.assert(
    q(this, "object") === void 0,
    "expected #{this} to be undefined",
    "expected #{this} not to be undefined"
  );
});
x.addProperty("NaN", function() {
  this.assert(
    Bl(q(this, "object")),
    "expected #{this} to be NaN",
    "expected #{this} not to be NaN"
  );
});
function dE() {
  var e = q(this, "object");
  this.assert(
    e != null,
    "expected #{this} to exist",
    "expected #{this} to not exist"
  );
}
o(dE, "assertExist");
I(dE, "assertExist");
x.addProperty("exist", dE);
x.addProperty("exists", dE);
x.addProperty("empty", function() {
  var e = q(this, "object"), t = q(this, "ssfi"), r = q(this, "message"), n;
  switch (r = r ? r + ": " : "", Te(e).toLowerCase()) {
    case "array":
    case "string":
      n = e.length;
      break;
    case "map":
    case "set":
      n = e.size;
      break;
    case "weakmap":
    case "weakset":
      throw new pe(
        r + ".empty was passed a weak collection",
        void 0,
        t
      );
    case "function":
      var i = r + ".empty was passed a function " + Yl(e);
      throw new pe(i.trim(), void 0, t);
    default:
      if (e !== Object(e))
        throw new pe(
          r + ".empty was passed non-string primitive " + de(e),
          void 0,
          t
        );
      n = Object.keys(e).length;
  }
  this.assert(
    n === 0,
    "expected #{this} to be empty",
    "expected #{this} not to be empty"
  );
});
function pE() {
  var e = q(this, "object"), t = Te(e);
  this.assert(
    t === "Arguments",
    "expected #{this} to be arguments but got " + t,
    "expected #{this} to not be arguments"
  );
}
o(pE, "checkArguments");
I(pE, "checkArguments");
x.addProperty("arguments", pE);
x.addProperty("Arguments", pE);
function Wl(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object");
  if (q(this, "deep")) {
    var n = q(this, "lockSsfi");
    q(this, "lockSsfi", !0), this.eql(e), q(this, "lockSsfi", n);
  } else
    this.assert(
      e === r,
      "expected #{this} to equal #{exp}",
      "expected #{this} to not equal #{exp}",
      e,
      this._obj,
      !0
    );
}
o(Wl, "assertEqual");
I(Wl, "assertEqual");
x.addMethod("equal", Wl);
x.addMethod("equals", Wl);
x.addMethod("eq", Wl);
function fE(e, t) {
  t && q(this, "message", t);
  var r = q(this, "eql");
  this.assert(
    r(e, q(this, "object")),
    "expected #{this} to deeply equal #{exp}",
    "expected #{this} to not deeply equal #{exp}",
    e,
    this._obj,
    !0
  );
}
o(fE, "assertEql");
I(fE, "assertEql");
x.addMethod("eql", fE);
x.addMethod("eqls", fE);
function Kl(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "doLength"), i = q(this, "message"), s = i ? i + ": " : "", a = q(this, "ssfi"), l = Te(r).toLowerCase(),
  u = Te(e).toLowerCase();
  if (n && l !== "map" && l !== "set" && new x(r, i, a, !0).to.have.property("length"), !n && l === "date" && u !== "date")
    throw new pe(
      s + "the argument to above must be a date",
      void 0,
      a
    );
  if (!We(e) && (n || We(r)))
    throw new pe(
      s + "the argument to above must be a number",
      void 0,
      a
    );
  if (!n && l !== "date" && !We(r)) {
    var c = l === "string" ? "'" + r + "'" : r;
    throw new pe(
      s + "expected " + c + " to be a number or a date",
      void 0,
      a
    );
  }
  if (n) {
    var d = "length", p;
    l === "map" || l === "set" ? (d = "size", p = r.size) : p = r.length, this.assert(
      p > e,
      "expected #{this} to have a " + d + " above #{exp} but got #{act}",
      "expected #{this} to not have a " + d + " above #{exp}",
      e,
      p
    );
  } else
    this.assert(
      r > e,
      "expected #{this} to be above #{exp}",
      "expected #{this} to be at most #{exp}",
      e
    );
}
o(Kl, "assertAbove");
I(Kl, "assertAbove");
x.addMethod("above", Kl);
x.addMethod("gt", Kl);
x.addMethod("greaterThan", Kl);
function Xl(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "doLength"), i = q(this, "message"), s = i ? i + ": " : "", a = q(this, "ssfi"), l = Te(r).toLowerCase(),
  u = Te(e).toLowerCase(), c, d = !0;
  if (n && l !== "map" && l !== "set" && new x(r, i, a, !0).to.have.property("length"), !n && l === "date" && u !== "date")
    c = s + "the argument to least must be a date";
  else if (!We(e) && (n || We(r)))
    c = s + "the argument to least must be a number";
  else if (!n && l !== "date" && !We(r)) {
    var p = l === "string" ? "'" + r + "'" : r;
    c = s + "expected " + p + " to be a number or a date";
  } else
    d = !1;
  if (d)
    throw new pe(c, void 0, a);
  if (n) {
    var y = "length", f;
    l === "map" || l === "set" ? (y = "size", f = r.size) : f = r.length, this.assert(
      f >= e,
      "expected #{this} to have a " + y + " at least #{exp} but got #{act}",
      "expected #{this} to have a " + y + " below #{exp}",
      e,
      f
    );
  } else
    this.assert(
      r >= e,
      "expected #{this} to be at least #{exp}",
      "expected #{this} to be below #{exp}",
      e
    );
}
o(Xl, "assertLeast");
I(Xl, "assertLeast");
x.addMethod("least", Xl);
x.addMethod("gte", Xl);
x.addMethod("greaterThanOrEqual", Xl);
function Jl(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "doLength"), i = q(this, "message"), s = i ? i + ": " : "", a = q(this, "ssfi"), l = Te(r).toLowerCase(),
  u = Te(e).toLowerCase(), c, d = !0;
  if (n && l !== "map" && l !== "set" && new x(r, i, a, !0).to.have.property("length"), !n && l === "date" && u !== "date")
    c = s + "the argument to below must be a date";
  else if (!We(e) && (n || We(r)))
    c = s + "the argument to below must be a number";
  else if (!n && l !== "date" && !We(r)) {
    var p = l === "string" ? "'" + r + "'" : r;
    c = s + "expected " + p + " to be a number or a date";
  } else
    d = !1;
  if (d)
    throw new pe(c, void 0, a);
  if (n) {
    var y = "length", f;
    l === "map" || l === "set" ? (y = "size", f = r.size) : f = r.length, this.assert(
      f < e,
      "expected #{this} to have a " + y + " below #{exp} but got #{act}",
      "expected #{this} to not have a " + y + " below #{exp}",
      e,
      f
    );
  } else
    this.assert(
      r < e,
      "expected #{this} to be below #{exp}",
      "expected #{this} to be at least #{exp}",
      e
    );
}
o(Jl, "assertBelow");
I(Jl, "assertBelow");
x.addMethod("below", Jl);
x.addMethod("lt", Jl);
x.addMethod("lessThan", Jl);
function Zl(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "doLength"), i = q(this, "message"), s = i ? i + ": " : "", a = q(this, "ssfi"), l = Te(r).toLowerCase(),
  u = Te(e).toLowerCase(), c, d = !0;
  if (n && l !== "map" && l !== "set" && new x(r, i, a, !0).to.have.property("length"), !n && l === "date" && u !== "date")
    c = s + "the argument to most must be a date";
  else if (!We(e) && (n || We(r)))
    c = s + "the argument to most must be a number";
  else if (!n && l !== "date" && !We(r)) {
    var p = l === "string" ? "'" + r + "'" : r;
    c = s + "expected " + p + " to be a number or a date";
  } else
    d = !1;
  if (d)
    throw new pe(c, void 0, a);
  if (n) {
    var y = "length", f;
    l === "map" || l === "set" ? (y = "size", f = r.size) : f = r.length, this.assert(
      f <= e,
      "expected #{this} to have a " + y + " at most #{exp} but got #{act}",
      "expected #{this} to have a " + y + " above #{exp}",
      e,
      f
    );
  } else
    this.assert(
      r <= e,
      "expected #{this} to be at most #{exp}",
      "expected #{this} to be above #{exp}",
      e
    );
}
o(Zl, "assertMost");
I(Zl, "assertMost");
x.addMethod("most", Zl);
x.addMethod("lte", Zl);
x.addMethod("lessThanOrEqual", Zl);
x.addMethod("within", function(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "object"), i = q(this, "doLength"), s = q(this, "message"), a = s ? s + ": " : "", l = q(this, "ssfi"), u = Te(n).toLowerCase(),
  c = Te(e).toLowerCase(), d = Te(t).toLowerCase(), p, y = !0, f = c === "date" && d === "date" ? e.toISOString() + ".." + t.toISOString() :
  e + ".." + t;
  if (i && u !== "map" && u !== "set" && new x(n, s, l, !0).to.have.property("length"), !i && u === "date" && (c !== "date" || d !== "date"))
    p = a + "the arguments to within must be dates";
  else if ((!We(e) || !We(t)) && (i || We(n)))
    p = a + "the arguments to within must be numbers";
  else if (!i && u !== "date" && !We(n)) {
    var m = u === "string" ? "'" + n + "'" : n;
    p = a + "expected " + m + " to be a number or a date";
  } else
    y = !1;
  if (y)
    throw new pe(p, void 0, l);
  if (i) {
    var h = "length", b;
    u === "map" || u === "set" ? (h = "size", b = n.size) : b = n.length, this.assert(
      b >= e && b <= t,
      "expected #{this} to have a " + h + " within " + f,
      "expected #{this} to not have a " + h + " within " + f
    );
  } else
    this.assert(
      n >= e && n <= t,
      "expected #{this} to be within " + f,
      "expected #{this} to not be within " + f
    );
});
function mE(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "ssfi"), i = q(this, "message");
  try {
    var s = r instanceof e;
  } catch (l) {
    throw l instanceof TypeError ? (i = i ? i + ": " : "", new pe(
      i + "The instanceof assertion needs a constructor but " + Te(e) + " was given.",
      void 0,
      n
    )) : l;
  }
  var a = Yl(e);
  a == null && (a = "an unnamed constructor"), this.assert(
    s,
    "expected #{this} to be an instance of " + a,
    "expected #{this} to not be an instance of " + a
  );
}
o(mE, "assertInstanceOf");
I(mE, "assertInstanceOf");
x.addMethod("instanceof", mE);
x.addMethod("instanceOf", mE);
function hE(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "nested"), i = q(this, "own"), s = q(this, "message"), a = q(this, "object"), l = q(this, "ssfi"), u = typeof e;
  if (s = s ? s + ": " : "", n) {
    if (u !== "string")
      throw new pe(
        s + "the argument to property must be a string when using nested syntax",
        void 0,
        l
      );
  } else if (u !== "string" && u !== "number" && u !== "symbol")
    throw new pe(
      s + "the argument to property must be a string, number, or symbol",
      void 0,
      l
    );
  if (n && i)
    throw new pe(
      s + 'The "nested" and "own" flags cannot be combined.',
      void 0,
      l
    );
  if (a == null)
    throw new pe(
      s + "Target cannot be null or undefined.",
      void 0,
      l
    );
  var c = q(this, "deep"), d = q(this, "negate"), p = n ? eE(a, e) : null, y = n ? p.value : a[e], f = c ? q(this, "eql") : (b, g) => b === g,
  m = "";
  c && (m += "deep "), i && (m += "own "), n && (m += "nested "), m += "property ";
  var h;
  i ? h = Object.prototype.hasOwnProperty.call(a, e) : n ? h = p.exists : h = Gl(a, e), (!d || arguments.length === 1) && this.assert(
    h,
    "expected #{this} to have " + m + de(e),
    "expected #{this} to not have " + m + de(e)
  ), arguments.length > 1 && this.assert(
    h && f(t, y),
    "expected #{this} to have " + m + de(e) + " of #{exp}, but got #{act}",
    "expected #{this} to not have " + m + de(e) + " of #{act}",
    t,
    y
  ), q(this, "object", y);
}
o(hE, "assertProperty");
I(hE, "assertProperty");
x.addMethod("property", hE);
function yE(e, t, r) {
  q(this, "own", !0), hE.apply(this, arguments);
}
o(yE, "assertOwnProperty");
I(yE, "assertOwnProperty");
x.addMethod("ownProperty", yE);
x.addMethod("haveOwnProperty", yE);
function bE(e, t, r) {
  typeof t == "string" && (r = t, t = null), r && q(this, "message", r);
  var n = q(this, "object"), i = Object.getOwnPropertyDescriptor(Object(n), e), s = q(this, "eql");
  i && t ? this.assert(
    s(t, i),
    "expected the own property descriptor for " + de(e) + " on #{this} to match " + de(t) + ", got " + de(i),
    "expected the own property descriptor for " + de(e) + " on #{this} to not match " + de(t),
    t,
    i,
    !0
  ) : this.assert(
    i,
    "expected #{this} to have an own property descriptor for " + de(e),
    "expected #{this} to not have an own property descriptor for " + de(e)
  ), q(this, "object", i);
}
o(bE, "assertOwnPropertyDescriptor");
I(bE, "assertOwnPropertyDescriptor");
x.addMethod("ownPropertyDescriptor", bE);
x.addMethod("haveOwnPropertyDescriptor", bE);
function gE() {
  q(this, "doLength", !0);
}
o(gE, "assertLengthChain");
I(gE, "assertLengthChain");
function vE(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = Te(r).toLowerCase(), i = q(this, "message"), s = q(this, "ssfi"), a = "length", l;
  switch (n) {
    case "map":
    case "set":
      a = "size", l = r.size;
      break;
    default:
      new x(r, i, s, !0).to.have.property("length"), l = r.length;
  }
  this.assert(
    l == e,
    "expected #{this} to have a " + a + " of #{exp} but got #{act}",
    "expected #{this} to not have a " + a + " of #{act}",
    e,
    l
  );
}
o(vE, "assertLength");
I(vE, "assertLength");
x.addChainableMethod("length", vE, gE);
x.addChainableMethod("lengthOf", vE, gE);
function EE(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object");
  this.assert(
    e.exec(r),
    "expected #{this} to match " + e,
    "expected #{this} not to match " + e
  );
}
o(EE, "assertMatch");
I(EE, "assertMatch");
x.addMethod("match", EE);
x.addMethod("matches", EE);
x.addMethod("string", function(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "message"), i = q(this, "ssfi");
  new x(r, n, i, !0).is.a("string"), this.assert(
    ~r.indexOf(e),
    "expected #{this} to contain " + de(e),
    "expected #{this} to not contain " + de(e)
  );
});
function TE(e) {
  var t = q(this, "object"), r = Te(t), n = Te(e), i = q(this, "ssfi"), s = q(this, "deep"), a, l = "", u, c = !0, d = q(this, "message");
  d = d ? d + ": " : "";
  var p = d + "when testing keys against an object or an array you must give a single Array|Object|String argument or multiple String argume\
nts";
  if (r === "Map" || r === "Set")
    l = s ? "deeply " : "", u = [], t.forEach(function(T, _) {
      u.push(_);
    }), n !== "Array" && (e = Array.prototype.slice.call(arguments));
  else {
    switch (u = lE(t), n) {
      case "Array":
        if (arguments.length > 1)
          throw new pe(p, void 0, i);
        break;
      case "Object":
        if (arguments.length > 1)
          throw new pe(p, void 0, i);
        e = Object.keys(e);
        break;
      default:
        e = Array.prototype.slice.call(arguments);
    }
    e = e.map(function(T) {
      return typeof T == "symbol" ? T : String(T);
    });
  }
  if (!e.length)
    throw new pe(d + "keys required", void 0, i);
  var y = e.length, f = q(this, "any"), m = q(this, "all"), h = e, b = s ? q(this, "eql") : (T, _) => T === _;
  if (!f && !m && (m = !0), f && (c = h.some(function(T) {
    return u.some(function(_) {
      return b(T, _);
    });
  })), m && (c = h.every(function(T) {
    return u.some(function(_) {
      return b(T, _);
    });
  }), q(this, "contains") || (c = c && e.length == u.length)), y > 1) {
    e = e.map(function(T) {
      return de(T);
    });
    var g = e.pop();
    m && (a = e.join(", ") + ", and " + g), f && (a = e.join(", ") + ", or " + g);
  } else
    a = de(e[0]);
  a = (y > 1 ? "keys " : "key ") + a, a = (q(this, "contains") ? "contain " : "have ") + a, this.assert(
    c,
    "expected #{this} to " + l + a,
    "expected #{this} to not " + l + a,
    h.slice(0).sort($l),
    u.sort($l),
    !0
  );
}
o(TE, "assertKeys");
I(TE, "assertKeys");
x.addMethod("keys", TE);
x.addMethod("key", TE);
function Ql(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "object"), i = q(this, "ssfi"), s = q(this, "message"), a = q(this, "negate") || !1;
  new x(n, s, i, !0).is.a("function"), (Ul(e) || typeof e == "string") && (t = e, e = null);
  let l, u = !1;
  try {
    n();
  } catch (T) {
    u = !0, l = T;
  }
  var c = e === void 0 && t === void 0, d = !!(e && t), p = !1, y = !1;
  if (c || !c && !a) {
    var f = "an error";
    e instanceof Error ? f = "#{exp}" : e && (f = St.getConstructorName(e));
    let T = l;
    if (l instanceof Error)
      T = l.toString();
    else if (typeof l == "string")
      T = l;
    else if (l && (typeof l == "object" || typeof l == "function"))
      try {
        T = St.getConstructorName(l);
      } catch {
      }
    this.assert(
      u,
      "expected #{this} to throw " + f,
      "expected #{this} to not throw an error but #{act} was thrown",
      e && e.toString(),
      T
    );
  }
  if (e && l) {
    if (e instanceof Error) {
      var m = St.compatibleInstance(
        l,
        e
      );
      m === a && (d && a ? p = !0 : this.assert(
        a,
        "expected #{this} to throw #{exp} but #{act} was thrown",
        "expected #{this} to not throw #{exp}" + (l && !a ? " but #{act} was thrown" : ""),
        e.toString(),
        l.toString()
      ));
    }
    var h = St.compatibleConstructor(
      l,
      e
    );
    h === a && (d && a ? p = !0 : this.assert(
      a,
      "expected #{this} to throw #{exp} but #{act} was thrown",
      "expected #{this} to not throw #{exp}" + (l ? " but #{act} was thrown" : ""),
      e instanceof Error ? e.toString() : e && St.getConstructorName(e),
      l instanceof Error ? l.toString() : l && St.getConstructorName(l)
    ));
  }
  if (l && t !== void 0 && t !== null) {
    var b = "including";
    Ul(t) && (b = "matching");
    var g = St.compatibleMessage(
      l,
      t
    );
    g === a && (d && a ? y = !0 : this.assert(
      a,
      "expected #{this} to throw error " + b + " #{exp} but got #{act}",
      "expected #{this} to throw error not " + b + " #{exp}",
      t,
      St.getMessage(l)
    ));
  }
  p && y && this.assert(
    a,
    "expected #{this} to throw #{exp} but #{act} was thrown",
    "expected #{this} to not throw #{exp}" + (l ? " but #{act} was thrown" : ""),
    e instanceof Error ? e.toString() : e && St.getConstructorName(e),
    l instanceof Error ? l.toString() : l && St.getConstructorName(l)
  ), q(this, "object", l);
}
o(Ql, "assertThrows");
I(Ql, "assertThrows");
x.addMethod("throw", Ql);
x.addMethod("throws", Ql);
x.addMethod("Throw", Ql);
function _E(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "itself"), i = typeof r == "function" && !n ? r.prototype[e] : r[e];
  this.assert(
    typeof i == "function",
    "expected #{this} to respond to " + de(e),
    "expected #{this} to not respond to " + de(e)
  );
}
o(_E, "respondTo");
I(_E, "respondTo");
x.addMethod("respondTo", _E);
x.addMethod("respondsTo", _E);
x.addProperty("itself", function() {
  q(this, "itself", !0);
});
function RE(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = e(r);
  this.assert(
    n,
    "expected #{this} to satisfy " + qn(e),
    "expected #{this} to not satisfy" + qn(e),
    !q(this, "negate"),
    n
  );
}
o(RE, "satisfy");
I(RE, "satisfy");
x.addMethod("satisfy", RE);
x.addMethod("satisfies", RE);
function wE(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "object"), i = q(this, "message"), s = q(this, "ssfi");
  new x(n, i, s, !0).is.numeric;
  let a = "A `delta` value is required for `closeTo`";
  if (t == null)
    throw new pe(
      i ? `${i}: ${a}` : a,
      void 0,
      s
    );
  if (new x(t, i, s, !0).is.numeric, a = "A `expected` value is required for `closeTo`", e == null)
    throw new pe(
      i ? `${i}: ${a}` : a,
      void 0,
      s
    );
  new x(e, i, s, !0).is.numeric;
  let l = /* @__PURE__ */ I((c) => c < 0n ? -c : c, "abs"), u = /* @__PURE__ */ I((c) => parseFloat(parseFloat(c).toPrecision(12)), "strip");
  this.assert(
    u(l(n - e)) <= t,
    "expected #{this} to be close to " + e + " +/- " + t,
    "expected #{this} not to be close to " + e + " +/- " + t
  );
}
o(wE, "closeTo");
I(wE, "closeTo");
x.addMethod("closeTo", wE);
x.addMethod("approximately", wE);
function P0(e, t, r, n, i) {
  let s = Array.from(t), a = Array.from(e);
  if (!n) {
    if (a.length !== s.length)
      return !1;
    s = s.slice();
  }
  return a.every(function(l, u) {
    if (i)
      return r ? r(l, s[u]) : l === s[u];
    if (!r) {
      var c = s.indexOf(l);
      return c === -1 ? !1 : (n || s.splice(c, 1), !0);
    }
    return s.some(function(d, p) {
      return r(l, d) ? (n || s.splice(p, 1), !0) : !1;
    });
  });
}
o(P0, "isSubsetOf");
I(P0, "isSubsetOf");
x.addMethod("members", function(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "message"), i = q(this, "ssfi");
  new x(r, n, i, !0).to.be.iterable, new x(e, n, i, !0).to.be.iterable;
  var s = q(this, "contains"), a = q(this, "ordered"), l, u, c;
  s ? (l = a ? "an ordered superset" : "a superset", u = "expected #{this} to be " + l + " of #{exp}", c = "expected #{this} to not be " + l +
  " of #{exp}") : (l = a ? "ordered members" : "members", u = "expected #{this} to have the same " + l + " as #{exp}", c = "expected #{this}\
 to not have the same " + l + " as #{exp}");
  var d = q(this, "deep") ? q(this, "eql") : void 0;
  this.assert(
    P0(e, r, d, s, a),
    u,
    c,
    e,
    r,
    !0
  );
});
x.addProperty("iterable", function(e) {
  e && q(this, "message", e);
  var t = q(this, "object");
  this.assert(
    t != null && t[Symbol.iterator],
    "expected #{this} to be an iterable",
    "expected #{this} to not be an iterable",
    t
  );
});
function A0(e, t) {
  t && q(this, "message", t);
  var r = q(this, "object"), n = q(this, "message"), i = q(this, "ssfi"), s = q(this, "contains"), a = q(this, "deep"), l = q(this, "eql");
  new x(e, n, i, !0).to.be.an("array"), s ? this.assert(
    e.some(function(u) {
      return r.indexOf(u) > -1;
    }),
    "expected #{this} to contain one of #{exp}",
    "expected #{this} to not contain one of #{exp}",
    e,
    r
  ) : a ? this.assert(
    e.some(function(u) {
      return l(r, u);
    }),
    "expected #{this} to deeply equal one of #{exp}",
    "expected #{this} to deeply equal one of #{exp}",
    e,
    r
  ) : this.assert(
    e.indexOf(r) > -1,
    "expected #{this} to be one of #{exp}",
    "expected #{this} to not be one of #{exp}",
    e,
    r
  );
}
o(A0, "oneOf");
I(A0, "oneOf");
x.addMethod("oneOf", A0);
function SE(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "object"), i = q(this, "message"), s = q(this, "ssfi");
  new x(n, i, s, !0).is.a("function");
  var a;
  t ? (new x(e, i, s, !0).to.have.property(t), a = e[t]) : (new x(e, i, s, !0).is.a("function"), a = e()), n();
  var l = t == null ? e() : e[t], u = t == null ? a : "." + t;
  q(this, "deltaMsgObj", u), q(this, "initialDeltaValue", a), q(this, "finalDeltaValue", l), q(this, "deltaBehavior", "change"), q(this, "re\
alDelta", l !== a), this.assert(
    a !== l,
    "expected " + u + " to change",
    "expected " + u + " to not change"
  );
}
o(SE, "assertChanges");
I(SE, "assertChanges");
x.addMethod("change", SE);
x.addMethod("changes", SE);
function xE(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "object"), i = q(this, "message"), s = q(this, "ssfi");
  new x(n, i, s, !0).is.a("function");
  var a;
  t ? (new x(e, i, s, !0).to.have.property(t), a = e[t]) : (new x(e, i, s, !0).is.a("function"), a = e()), new x(a, i, s, !0).is.a("number"),
  n();
  var l = t == null ? e() : e[t], u = t == null ? a : "." + t;
  q(this, "deltaMsgObj", u), q(this, "initialDeltaValue", a), q(this, "finalDeltaValue", l), q(this, "deltaBehavior", "increase"), q(this, "\
realDelta", l - a), this.assert(
    l - a > 0,
    "expected " + u + " to increase",
    "expected " + u + " to not increase"
  );
}
o(xE, "assertIncreases");
I(xE, "assertIncreases");
x.addMethod("increase", xE);
x.addMethod("increases", xE);
function CE(e, t, r) {
  r && q(this, "message", r);
  var n = q(this, "object"), i = q(this, "message"), s = q(this, "ssfi");
  new x(n, i, s, !0).is.a("function");
  var a;
  t ? (new x(e, i, s, !0).to.have.property(t), a = e[t]) : (new x(e, i, s, !0).is.a("function"), a = e()), new x(a, i, s, !0).is.a("number"),
  n();
  var l = t == null ? e() : e[t], u = t == null ? a : "." + t;
  q(this, "deltaMsgObj", u), q(this, "initialDeltaValue", a), q(this, "finalDeltaValue", l), q(this, "deltaBehavior", "decrease"), q(this, "\
realDelta", a - l), this.assert(
    l - a < 0,
    "expected " + u + " to decrease",
    "expected " + u + " to not decrease"
  );
}
o(CE, "assertDecreases");
I(CE, "assertDecreases");
x.addMethod("decrease", CE);
x.addMethod("decreases", CE);
function O0(e, t) {
  t && q(this, "message", t);
  var r = q(this, "deltaMsgObj"), n = q(this, "initialDeltaValue"), i = q(this, "finalDeltaValue"), s = q(this, "deltaBehavior"), a = q(this,
  "realDelta"), l;
  s === "change" ? l = Math.abs(i - n) === Math.abs(e) : l = a === Math.abs(e), this.assert(
    l,
    "expected " + r + " to " + s + " by " + e,
    "expected " + r + " to not " + s + " by " + e
  );
}
o(O0, "assertDelta");
I(O0, "assertDelta");
x.addMethod("by", O0);
x.addProperty("extensible", function() {
  var e = q(this, "object"), t = e === Object(e) && Object.isExtensible(e);
  this.assert(
    t,
    "expected #{this} to be extensible",
    "expected #{this} to not be extensible"
  );
});
x.addProperty("sealed", function() {
  var e = q(this, "object"), t = e === Object(e) ? Object.isSealed(e) : !0;
  this.assert(
    t,
    "expected #{this} to be sealed",
    "expected #{this} to not be sealed"
  );
});
x.addProperty("frozen", function() {
  var e = q(this, "object"), t = e === Object(e) ? Object.isFrozen(e) : !0;
  this.assert(
    t,
    "expected #{this} to be frozen",
    "expected #{this} to not be frozen"
  );
});
x.addProperty("finite", function(e) {
  var t = q(this, "object");
  this.assert(
    typeof t == "number" && isFinite(t),
    "expected #{this} to be a finite number",
    "expected #{this} to not be a finite number"
  );
});
function Hl(e, t) {
  return e === t ? !0 : typeof t != typeof e ? !1 : typeof e != "object" || e === null ? e === t : t ? Array.isArray(e) ? Array.isArray(t) ?
  e.every(function(r) {
    return t.some(function(n) {
      return Hl(r, n);
    });
  }) : !1 : e instanceof Date ? t instanceof Date ? e.getTime() === t.getTime() : !1 : Object.keys(e).every(function(r) {
    var n = e[r], i = t[r];
    return typeof n == "object" && n !== null && i !== null ? Hl(n, i) : typeof n == "function" ? n(i) : i === n;
  }) : !1;
}
o(Hl, "compareSubset");
I(Hl, "compareSubset");
x.addMethod("containSubset", function(e) {
  let t = re(this, "object"), r = mt.showDiff;
  this.assert(
    Hl(e, t),
    "expected #{act} to contain subset #{exp}",
    "expected #{act} to not contain subset #{exp}",
    e,
    t,
    r
  );
});
function Vr(e, t) {
  return new x(e, t);
}
o(Vr, "expect");
I(Vr, "expect");
Vr.fail = function(e, t, r, n) {
  throw arguments.length < 2 && (r = e, e = void 0), r = r || "expect.fail()", new pe(
    r,
    {
      actual: e,
      expected: t,
      operator: n
    },
    Vr.fail
  );
};
var q0 = {};
Yv(q0, {
  Should: /* @__PURE__ */ o(() => u9, "Should"),
  should: /* @__PURE__ */ o(() => l9, "should")
});
function PE() {
  function e() {
    return this instanceof String || this instanceof Number || this instanceof Boolean || typeof Symbol == "function" && this instanceof Symbol ||
    typeof BigInt == "function" && this instanceof BigInt ? new x(this.valueOf(), null, e) : new x(this, null, e);
  }
  o(e, "shouldGetter"), I(e, "shouldGetter");
  function t(n) {
    Object.defineProperty(this, "should", {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    });
  }
  o(t, "shouldSetter"), I(t, "shouldSetter"), Object.defineProperty(Object.prototype, "should", {
    set: t,
    get: e,
    configurable: !0
  });
  var r = {};
  return r.fail = function(n, i, s, a) {
    throw arguments.length < 2 && (s = n, n = void 0), s = s || "should.fail()", new pe(
      s,
      {
        actual: n,
        expected: i,
        operator: a
      },
      r.fail
    );
  }, r.equal = function(n, i, s) {
    new x(n, s).to.equal(i);
  }, r.Throw = function(n, i, s, a) {
    new x(n, a).to.Throw(i, s);
  }, r.exist = function(n, i) {
    new x(n, i).to.exist;
  }, r.not = {}, r.not.equal = function(n, i, s) {
    new x(n, s).to.not.equal(i);
  }, r.not.Throw = function(n, i, s, a) {
    new x(n, a).to.not.Throw(i, s);
  }, r.not.exist = function(n, i) {
    new x(n, i).to.not.exist;
  }, r.throw = r.Throw, r.not.throw = r.not.Throw, r;
}
o(PE, "loadShould");
I(PE, "loadShould");
var l9 = PE, u9 = PE;
function S(e, t) {
  var r = new x(null, null, S, !0);
  r.assert(e, t, "[ negation message unavailable ]");
}
o(S, "assert");
I(S, "assert");
S.fail = function(e, t, r, n) {
  throw arguments.length < 2 && (r = e, e = void 0), r = r || "assert.fail()", new pe(
    r,
    {
      actual: e,
      expected: t,
      operator: n
    },
    S.fail
  );
};
S.isOk = function(e, t) {
  new x(e, t, S.isOk, !0).is.ok;
};
S.isNotOk = function(e, t) {
  new x(e, t, S.isNotOk, !0).is.not.ok;
};
S.equal = function(e, t, r) {
  var n = new x(e, r, S.equal, !0);
  n.assert(
    t == re(n, "object"),
    "expected #{this} to equal #{exp}",
    "expected #{this} to not equal #{act}",
    t,
    e,
    !0
  );
};
S.notEqual = function(e, t, r) {
  var n = new x(e, r, S.notEqual, !0);
  n.assert(
    t != re(n, "object"),
    "expected #{this} to not equal #{exp}",
    "expected #{this} to equal #{act}",
    t,
    e,
    !0
  );
};
S.strictEqual = function(e, t, r) {
  new x(e, r, S.strictEqual, !0).to.equal(t);
};
S.notStrictEqual = function(e, t, r) {
  new x(e, r, S.notStrictEqual, !0).to.not.equal(t);
};
S.deepEqual = S.deepStrictEqual = function(e, t, r) {
  new x(e, r, S.deepEqual, !0).to.eql(t);
};
S.notDeepEqual = function(e, t, r) {
  new x(e, r, S.notDeepEqual, !0).to.not.eql(t);
};
S.isAbove = function(e, t, r) {
  new x(e, r, S.isAbove, !0).to.be.above(t);
};
S.isAtLeast = function(e, t, r) {
  new x(e, r, S.isAtLeast, !0).to.be.least(t);
};
S.isBelow = function(e, t, r) {
  new x(e, r, S.isBelow, !0).to.be.below(t);
};
S.isAtMost = function(e, t, r) {
  new x(e, r, S.isAtMost, !0).to.be.most(t);
};
S.isTrue = function(e, t) {
  new x(e, t, S.isTrue, !0).is.true;
};
S.isNotTrue = function(e, t) {
  new x(e, t, S.isNotTrue, !0).to.not.equal(!0);
};
S.isFalse = function(e, t) {
  new x(e, t, S.isFalse, !0).is.false;
};
S.isNotFalse = function(e, t) {
  new x(e, t, S.isNotFalse, !0).to.not.equal(!1);
};
S.isNull = function(e, t) {
  new x(e, t, S.isNull, !0).to.equal(null);
};
S.isNotNull = function(e, t) {
  new x(e, t, S.isNotNull, !0).to.not.equal(null);
};
S.isNaN = function(e, t) {
  new x(e, t, S.isNaN, !0).to.be.NaN;
};
S.isNotNaN = function(e, t) {
  new x(e, t, S.isNotNaN, !0).not.to.be.NaN;
};
S.exists = function(e, t) {
  new x(e, t, S.exists, !0).to.exist;
};
S.notExists = function(e, t) {
  new x(e, t, S.notExists, !0).to.not.exist;
};
S.isUndefined = function(e, t) {
  new x(e, t, S.isUndefined, !0).to.equal(void 0);
};
S.isDefined = function(e, t) {
  new x(e, t, S.isDefined, !0).to.not.equal(void 0);
};
S.isCallable = function(e, t) {
  new x(e, t, S.isCallable, !0).is.callable;
};
S.isNotCallable = function(e, t) {
  new x(e, t, S.isNotCallable, !0).is.not.callable;
};
S.isObject = function(e, t) {
  new x(e, t, S.isObject, !0).to.be.a("object");
};
S.isNotObject = function(e, t) {
  new x(e, t, S.isNotObject, !0).to.not.be.a("object");
};
S.isArray = function(e, t) {
  new x(e, t, S.isArray, !0).to.be.an("array");
};
S.isNotArray = function(e, t) {
  new x(e, t, S.isNotArray, !0).to.not.be.an("array");
};
S.isString = function(e, t) {
  new x(e, t, S.isString, !0).to.be.a("string");
};
S.isNotString = function(e, t) {
  new x(e, t, S.isNotString, !0).to.not.be.a("string");
};
S.isNumber = function(e, t) {
  new x(e, t, S.isNumber, !0).to.be.a("number");
};
S.isNotNumber = function(e, t) {
  new x(e, t, S.isNotNumber, !0).to.not.be.a("number");
};
S.isNumeric = function(e, t) {
  new x(e, t, S.isNumeric, !0).is.numeric;
};
S.isNotNumeric = function(e, t) {
  new x(e, t, S.isNotNumeric, !0).is.not.numeric;
};
S.isFinite = function(e, t) {
  new x(e, t, S.isFinite, !0).to.be.finite;
};
S.isBoolean = function(e, t) {
  new x(e, t, S.isBoolean, !0).to.be.a("boolean");
};
S.isNotBoolean = function(e, t) {
  new x(e, t, S.isNotBoolean, !0).to.not.be.a("boolean");
};
S.typeOf = function(e, t, r) {
  new x(e, r, S.typeOf, !0).to.be.a(t);
};
S.notTypeOf = function(e, t, r) {
  new x(e, r, S.notTypeOf, !0).to.not.be.a(t);
};
S.instanceOf = function(e, t, r) {
  new x(e, r, S.instanceOf, !0).to.be.instanceOf(t);
};
S.notInstanceOf = function(e, t, r) {
  new x(e, r, S.notInstanceOf, !0).to.not.be.instanceOf(
    t
  );
};
S.include = function(e, t, r) {
  new x(e, r, S.include, !0).include(t);
};
S.notInclude = function(e, t, r) {
  new x(e, r, S.notInclude, !0).not.include(t);
};
S.deepInclude = function(e, t, r) {
  new x(e, r, S.deepInclude, !0).deep.include(t);
};
S.notDeepInclude = function(e, t, r) {
  new x(e, r, S.notDeepInclude, !0).not.deep.include(t);
};
S.nestedInclude = function(e, t, r) {
  new x(e, r, S.nestedInclude, !0).nested.include(t);
};
S.notNestedInclude = function(e, t, r) {
  new x(e, r, S.notNestedInclude, !0).not.nested.include(
    t
  );
};
S.deepNestedInclude = function(e, t, r) {
  new x(e, r, S.deepNestedInclude, !0).deep.nested.include(
    t
  );
};
S.notDeepNestedInclude = function(e, t, r) {
  new x(
    e,
    r,
    S.notDeepNestedInclude,
    !0
  ).not.deep.nested.include(t);
};
S.ownInclude = function(e, t, r) {
  new x(e, r, S.ownInclude, !0).own.include(t);
};
S.notOwnInclude = function(e, t, r) {
  new x(e, r, S.notOwnInclude, !0).not.own.include(t);
};
S.deepOwnInclude = function(e, t, r) {
  new x(e, r, S.deepOwnInclude, !0).deep.own.include(t);
};
S.notDeepOwnInclude = function(e, t, r) {
  new x(e, r, S.notDeepOwnInclude, !0).not.deep.own.include(
    t
  );
};
S.match = function(e, t, r) {
  new x(e, r, S.match, !0).to.match(t);
};
S.notMatch = function(e, t, r) {
  new x(e, r, S.notMatch, !0).to.not.match(t);
};
S.property = function(e, t, r) {
  new x(e, r, S.property, !0).to.have.property(t);
};
S.notProperty = function(e, t, r) {
  new x(e, r, S.notProperty, !0).to.not.have.property(t);
};
S.propertyVal = function(e, t, r, n) {
  new x(e, n, S.propertyVal, !0).to.have.property(t, r);
};
S.notPropertyVal = function(e, t, r, n) {
  new x(e, n, S.notPropertyVal, !0).to.not.have.property(
    t,
    r
  );
};
S.deepPropertyVal = function(e, t, r, n) {
  new x(e, n, S.deepPropertyVal, !0).to.have.deep.property(
    t,
    r
  );
};
S.notDeepPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.notDeepPropertyVal,
    !0
  ).to.not.have.deep.property(t, r);
};
S.ownProperty = function(e, t, r) {
  new x(e, r, S.ownProperty, !0).to.have.own.property(t);
};
S.notOwnProperty = function(e, t, r) {
  new x(e, r, S.notOwnProperty, !0).to.not.have.own.property(
    t
  );
};
S.ownPropertyVal = function(e, t, r, n) {
  new x(e, n, S.ownPropertyVal, !0).to.have.own.property(
    t,
    r
  );
};
S.notOwnPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.notOwnPropertyVal,
    !0
  ).to.not.have.own.property(t, r);
};
S.deepOwnPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.deepOwnPropertyVal,
    !0
  ).to.have.deep.own.property(t, r);
};
S.notDeepOwnPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.notDeepOwnPropertyVal,
    !0
  ).to.not.have.deep.own.property(t, r);
};
S.nestedProperty = function(e, t, r) {
  new x(e, r, S.nestedProperty, !0).to.have.nested.property(
    t
  );
};
S.notNestedProperty = function(e, t, r) {
  new x(
    e,
    r,
    S.notNestedProperty,
    !0
  ).to.not.have.nested.property(t);
};
S.nestedPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.nestedPropertyVal,
    !0
  ).to.have.nested.property(t, r);
};
S.notNestedPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.notNestedPropertyVal,
    !0
  ).to.not.have.nested.property(t, r);
};
S.deepNestedPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.deepNestedPropertyVal,
    !0
  ).to.have.deep.nested.property(t, r);
};
S.notDeepNestedPropertyVal = function(e, t, r, n) {
  new x(
    e,
    n,
    S.notDeepNestedPropertyVal,
    !0
  ).to.not.have.deep.nested.property(t, r);
};
S.lengthOf = function(e, t, r) {
  new x(e, r, S.lengthOf, !0).to.have.lengthOf(t);
};
S.hasAnyKeys = function(e, t, r) {
  new x(e, r, S.hasAnyKeys, !0).to.have.any.keys(t);
};
S.hasAllKeys = function(e, t, r) {
  new x(e, r, S.hasAllKeys, !0).to.have.all.keys(t);
};
S.containsAllKeys = function(e, t, r) {
  new x(e, r, S.containsAllKeys, !0).to.contain.all.keys(
    t
  );
};
S.doesNotHaveAnyKeys = function(e, t, r) {
  new x(e, r, S.doesNotHaveAnyKeys, !0).to.not.have.any.keys(
    t
  );
};
S.doesNotHaveAllKeys = function(e, t, r) {
  new x(e, r, S.doesNotHaveAllKeys, !0).to.not.have.all.keys(
    t
  );
};
S.hasAnyDeepKeys = function(e, t, r) {
  new x(e, r, S.hasAnyDeepKeys, !0).to.have.any.deep.keys(
    t
  );
};
S.hasAllDeepKeys = function(e, t, r) {
  new x(e, r, S.hasAllDeepKeys, !0).to.have.all.deep.keys(
    t
  );
};
S.containsAllDeepKeys = function(e, t, r) {
  new x(
    e,
    r,
    S.containsAllDeepKeys,
    !0
  ).to.contain.all.deep.keys(t);
};
S.doesNotHaveAnyDeepKeys = function(e, t, r) {
  new x(
    e,
    r,
    S.doesNotHaveAnyDeepKeys,
    !0
  ).to.not.have.any.deep.keys(t);
};
S.doesNotHaveAllDeepKeys = function(e, t, r) {
  new x(
    e,
    r,
    S.doesNotHaveAllDeepKeys,
    !0
  ).to.not.have.all.deep.keys(t);
};
S.throws = function(e, t, r, n) {
  (typeof t == "string" || t instanceof RegExp) && (r = t, t = null);
  var i = new x(e, n, S.throws, !0).to.throw(
    t,
    r
  );
  return re(i, "object");
};
S.doesNotThrow = function(e, t, r, n) {
  (typeof t == "string" || t instanceof RegExp) && (r = t, t = null), new x(e, n, S.doesNotThrow, !0).to.not.throw(
    t,
    r
  );
};
S.operator = function(e, t, r, n) {
  var i;
  switch (t) {
    case "==":
      i = e == r;
      break;
    case "===":
      i = e === r;
      break;
    case ">":
      i = e > r;
      break;
    case ">=":
      i = e >= r;
      break;
    case "<":
      i = e < r;
      break;
    case "<=":
      i = e <= r;
      break;
    case "!=":
      i = e != r;
      break;
    case "!==":
      i = e !== r;
      break;
    default:
      throw n = n && n + ": ", new pe(
        n + 'Invalid operator "' + t + '"',
        void 0,
        S.operator
      );
  }
  var s = new x(i, n, S.operator, !0);
  s.assert(
    re(s, "object") === !0,
    "expected " + de(e) + " to be " + t + " " + de(r),
    "expected " + de(e) + " to not be " + t + " " + de(r)
  );
};
S.closeTo = function(e, t, r, n) {
  new x(e, n, S.closeTo, !0).to.be.closeTo(t, r);
};
S.approximately = function(e, t, r, n) {
  new x(e, n, S.approximately, !0).to.be.approximately(
    t,
    r
  );
};
S.sameMembers = function(e, t, r) {
  new x(e, r, S.sameMembers, !0).to.have.same.members(t);
};
S.notSameMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notSameMembers,
    !0
  ).to.not.have.same.members(t);
};
S.sameDeepMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.sameDeepMembers,
    !0
  ).to.have.same.deep.members(t);
};
S.notSameDeepMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notSameDeepMembers,
    !0
  ).to.not.have.same.deep.members(t);
};
S.sameOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.sameOrderedMembers,
    !0
  ).to.have.same.ordered.members(t);
};
S.notSameOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notSameOrderedMembers,
    !0
  ).to.not.have.same.ordered.members(t);
};
S.sameDeepOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.sameDeepOrderedMembers,
    !0
  ).to.have.same.deep.ordered.members(t);
};
S.notSameDeepOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notSameDeepOrderedMembers,
    !0
  ).to.not.have.same.deep.ordered.members(t);
};
S.includeMembers = function(e, t, r) {
  new x(e, r, S.includeMembers, !0).to.include.members(
    t
  );
};
S.notIncludeMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notIncludeMembers,
    !0
  ).to.not.include.members(t);
};
S.includeDeepMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.includeDeepMembers,
    !0
  ).to.include.deep.members(t);
};
S.notIncludeDeepMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notIncludeDeepMembers,
    !0
  ).to.not.include.deep.members(t);
};
S.includeOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.includeOrderedMembers,
    !0
  ).to.include.ordered.members(t);
};
S.notIncludeOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notIncludeOrderedMembers,
    !0
  ).to.not.include.ordered.members(t);
};
S.includeDeepOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.includeDeepOrderedMembers,
    !0
  ).to.include.deep.ordered.members(t);
};
S.notIncludeDeepOrderedMembers = function(e, t, r) {
  new x(
    e,
    r,
    S.notIncludeDeepOrderedMembers,
    !0
  ).to.not.include.deep.ordered.members(t);
};
S.oneOf = function(e, t, r) {
  new x(e, r, S.oneOf, !0).to.be.oneOf(t);
};
S.isIterable = function(e, t) {
  if (e == null || !e[Symbol.iterator])
    throw t = t ? `${t} expected ${de(e)} to be an iterable` : `expected ${de(e)} to be an iterable`, new pe(t, void 0, S.isIterable);
};
S.changes = function(e, t, r, n) {
  arguments.length === 3 && typeof t == "function" && (n = r, r = null), new x(e, n, S.changes, !0).to.change(t, r);
};
S.changesBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  new x(e, i, S.changesBy, !0).to.change(t, r).by(n);
};
S.doesNotChange = function(e, t, r, n) {
  return arguments.length === 3 && typeof t == "function" && (n = r, r = null), new x(e, n, S.doesNotChange, !0).to.not.change(
    t,
    r
  );
};
S.changesButNotBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  new x(e, i, S.changesButNotBy, !0).to.change(t, r).but.not.by(n);
};
S.increases = function(e, t, r, n) {
  return arguments.length === 3 && typeof t == "function" && (n = r, r = null), new x(e, n, S.increases, !0).to.increase(t, r);
};
S.increasesBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  new x(e, i, S.increasesBy, !0).to.increase(t, r).by(n);
};
S.doesNotIncrease = function(e, t, r, n) {
  return arguments.length === 3 && typeof t == "function" && (n = r, r = null), new x(e, n, S.doesNotIncrease, !0).to.not.increase(
    t,
    r
  );
};
S.increasesButNotBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  new x(e, i, S.increasesButNotBy, !0).to.increase(t, r).but.not.by(n);
};
S.decreases = function(e, t, r, n) {
  return arguments.length === 3 && typeof t == "function" && (n = r, r = null), new x(e, n, S.decreases, !0).to.decrease(t, r);
};
S.decreasesBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  new x(e, i, S.decreasesBy, !0).to.decrease(t, r).by(n);
};
S.doesNotDecrease = function(e, t, r, n) {
  return arguments.length === 3 && typeof t == "function" && (n = r, r = null), new x(e, n, S.doesNotDecrease, !0).to.not.decrease(
    t,
    r
  );
};
S.doesNotDecreaseBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  return new x(e, i, S.doesNotDecreaseBy, !0).to.not.decrease(t, r).by(n);
};
S.decreasesButNotBy = function(e, t, r, n, i) {
  if (arguments.length === 4 && typeof t == "function") {
    var s = n;
    n = r, i = s;
  } else arguments.length === 3 && (n = r, r = null);
  new x(e, i, S.decreasesButNotBy, !0).to.decrease(t, r).but.not.by(n);
};
S.ifError = function(e) {
  if (e)
    throw e;
};
S.isExtensible = function(e, t) {
  new x(e, t, S.isExtensible, !0).to.be.extensible;
};
S.isNotExtensible = function(e, t) {
  new x(e, t, S.isNotExtensible, !0).to.not.be.extensible;
};
S.isSealed = function(e, t) {
  new x(e, t, S.isSealed, !0).to.be.sealed;
};
S.isNotSealed = function(e, t) {
  new x(e, t, S.isNotSealed, !0).to.not.be.sealed;
};
S.isFrozen = function(e, t) {
  new x(e, t, S.isFrozen, !0).to.be.frozen;
};
S.isNotFrozen = function(e, t) {
  new x(e, t, S.isNotFrozen, !0).to.not.be.frozen;
};
S.isEmpty = function(e, t) {
  new x(e, t, S.isEmpty, !0).to.be.empty;
};
S.isNotEmpty = function(e, t) {
  new x(e, t, S.isNotEmpty, !0).to.not.be.empty;
};
S.containsSubset = function(e, t, r) {
  new x(e, r).to.containSubset(t);
};
S.doesNotContainSubset = function(e, t, r) {
  new x(e, r).to.not.containSubset(t);
};
var c9 = [
  ["isOk", "ok"],
  ["isNotOk", "notOk"],
  ["throws", "throw"],
  ["throws", "Throw"],
  ["isExtensible", "extensible"],
  ["isNotExtensible", "notExtensible"],
  ["isSealed", "sealed"],
  ["isNotSealed", "notSealed"],
  ["isFrozen", "frozen"],
  ["isNotFrozen", "notFrozen"],
  ["isEmpty", "empty"],
  ["isNotEmpty", "notEmpty"],
  ["isCallable", "isFunction"],
  ["isNotCallable", "isNotFunction"],
  ["containsSubset", "containSubset"]
];
for (let [e, t] of c9)
  S[t] = S[e];
var HP = [];
function zr(e) {
  let t = {
    use: zr,
    AssertionError: pe,
    util: It,
    config: mt,
    expect: Vr,
    assert: S,
    Assertion: x,
    ...q0
  };
  return ~HP.indexOf(e) || (e(t, It), HP.push(e)), t;
}
o(zr, "use");
I(zr, "use");

// ../node_modules/@testing-library/jest-dom/dist/matchers.mjs
var d_ = {};
ft(d_, {
  toBeChecked: () => r_,
  toBeDisabled: () => KT,
  toBeEmpty: () => DT,
  toBeEmptyDOMElement: () => $T,
  toBeEnabled: () => XT,
  toBeInTheDOM: () => pp,
  toBeInTheDocument: () => kT,
  toBeInvalid: () => ZT,
  toBePartiallyChecked: () => n_,
  toBeRequired: () => JT,
  toBeValid: () => QT,
  toBeVisible: () => WT,
  toContainElement: () => fp,
  toContainHTML: () => BT,
  toHaveAccessibleDescription: () => mp,
  toHaveAccessibleErrorMessage: () => HT,
  toHaveAccessibleName: () => yp,
  toHaveAttribute: () => VT,
  toHaveClass: () => zT,
  toHaveDescription: () => o_,
  toHaveDisplayValue: () => t_,
  toHaveErrorMessage: () => i_,
  toHaveFocus: () => GT,
  toHaveFormValues: () => YT,
  toHaveRole: () => hp,
  toHaveSelection: () => s_,
  toHaveStyle: () => bp,
  toHaveTextContent: () => UT,
  toHaveValue: () => e_
});

// ../node_modules/@testing-library/jest-dom/dist/matchers-c85aadf8.mjs
var jT = De(AE(), 1);

// ../node_modules/@adobe/css-tools/dist/index.mjs
function D0(e) {
  Object.defineProperty(e, "__esModule", { value: !0, configurable: !0 });
}
o(D0, "$parcel$defineInteropFlag");
function IE(e, t, r, n) {
  Object.defineProperty(e, t, { get: r, set: n, enumerable: !0, configurable: !0 });
}
o(IE, "$parcel$export");
var $0 = {};
D0($0);
IE($0, "default", () => eu);
var ME = class ME extends Error {
  constructor(t, r, n, i, s) {
    super(t + ":" + n + ":" + i + ": " + r), this.reason = r, this.filename = t, this.line = n, this.column = i, this.source = s;
  }
};
o(ME, "$009ddb00d3ec72b8$export$2e2bcd8739ae039");
var eu = ME, B0 = {};
D0(B0);
IE(B0, "default", () => tu);
var NE = class NE {
  constructor(t, r, n) {
    this.start = t, this.end = r, this.source = n;
  }
};
o(NE, "$0865a9fb4cc365fe$export$2e2bcd8739ae039");
var tu = NE, h9 = {};
IE(h9, "CssTypes", () => Ke);
var Ke = /* @__PURE__ */ function(e) {
  return e.stylesheet = "stylesheet", e.rule = "rule", e.declaration = "declaration", e.comment = "comment", e.container = "container", e.charset =
  "charset", e.document = "document", e.customMedia = "custom-media", e.fontFace = "font-face", e.host = "host", e.import = "import", e.keyframes =
  "keyframes", e.keyframe = "keyframe", e.layer = "layer", e.media = "media", e.namespace = "namespace", e.page = "page", e.startingStyle = "\
starting-style", e.supports = "supports", e;
}({}), OE = /\/\*[^]*?(?:\*\/|$)/g, y9 = /* @__PURE__ */ o((e, t) => {
  t = t || {};
  let r = 1, n = 1;
  function i(F) {
    let j = F.match(/\n/g);
    j && (r += j.length);
    let Y = F.lastIndexOf(`
`);
    n = ~Y ? F.length - Y : n + F.length;
  }
  o(i, "updatePosition");
  function s() {
    let F = {
      line: r,
      column: n
    };
    return function(j) {
      return j.position = new tu(F, {
        line: r,
        column: n
      }, t?.source || ""), f(), j;
    };
  }
  o(s, "position");
  let a = [];
  function l(F) {
    let j = new eu(t?.source || "", F, r, n, e);
    if (t?.silent) a.push(j);
    else throw j;
  }
  o(l, "error");
  function u() {
    let F = p();
    return {
      type: Ke.stylesheet,
      stylesheet: {
        source: t?.source,
        rules: F,
        parsingErrors: a
      }
    };
  }
  o(u, "stylesheet");
  function c() {
    return y(/^{\s*/);
  }
  o(c, "open");
  function d() {
    return y(/^}/);
  }
  o(d, "close");
  function p() {
    let F, j = [];
    for (f(), m(j); e.length && e.charAt(0) !== "}" && (F = te() || fe()); ) F && (j.push(F), m(j));
    return j;
  }
  o(p, "rules");
  function y(F) {
    let j = F.exec(e);
    if (!j) return;
    let Y = j[0];
    return i(Y), e = e.slice(Y.length), j;
  }
  o(y, "match");
  function f() {
    y(/^\s*/);
  }
  o(f, "whitespace");
  function m(F) {
    let j;
    for (F = F || []; j = h(); ) j && F.push(j);
    return F;
  }
  o(m, "comments");
  function h() {
    let F = s();
    if (e.charAt(0) !== "/" || e.charAt(1) !== "*") return;
    let j = y(/^\/\*[^]*?\*\//);
    return j ? F({
      type: Ke.comment,
      comment: j[0].slice(2, -2)
    }) : l("End of comment missing");
  }
  o(h, "comment");
  function b(F, j, Y) {
    let z = j + 1, X = !1, ce = F.indexOf(")", z);
    for (; !X && ce !== -1; ) {
      let Re = F.indexOf("(", z);
      Re !== -1 && Re < ce ? (z = b(F, Re + 1, Y + 1) + 1, ce = F.indexOf(")", z)) : X = !0;
    }
    return X && ce !== -1 ? ce : -1;
  }
  o(b, "findClosingParenthese");
  function g() {
    let F = y(/^([^{]+)/);
    if (!F) return;
    let j = Nt(F[0]).replace(OE, "");
    if (j.indexOf(",") === -1) return [
      j
    ];
    let Y = 0, z = j.indexOf("(", Y);
    for (; z !== -1; ) {
      let X = b(j, z, 0);
      if (X === -1) break;
      Y = X + 1, j = j.substring(0, z) + j.substring(z, X).replace(/,/g, "\u200C") + j.substring(X), z = j.indexOf("(", Y);
    }
    return j = j.replace(/("|')(?:\\\1|.)*?\1/g, (X) => X.replace(/,/g, "\u200C")), j.split(",").map((X) => Nt(X.replace(/\u200C/g, ",")));
  }
  o(g, "selector");
  function T() {
    let F = s(), j = y(/^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
    if (!j) return;
    let Y = Nt(j[0]);
    if (!y(/^:\s*/)) return l("property missing ':'");
    let z = y(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)])*?\)|[^};])+)/), X = F({
      type: Ke.declaration,
      property: Y.replace(OE, ""),
      value: z ? Nt(z[0]).replace(OE, "") : ""
    });
    return y(/^[;\s]*/), X;
  }
  o(T, "declaration");
  function _() {
    let F = [];
    if (!c()) return l("missing '{'");
    m(F);
    let j;
    for (; j = T(); ) j && (F.push(j), m(F));
    return d() ? F : l("missing '}'");
  }
  o(_, "declarations");
  function E() {
    let F, j = [], Y = s();
    for (; F = y(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
      j.push(F[1]), y(/^,\s*/);
    if (j.length)
      return Y({
        type: Ke.keyframe,
        values: j,
        declarations: _() || []
      });
  }
  o(E, "keyframe");
  function R() {
    let F = s(), j = y(/^@([-\w]+)?keyframes\s*/);
    if (!j) return;
    let Y = j[1], z = y(/^([-\w]+)\s*/);
    if (!z) return l("@keyframes missing name");
    let X = z[1];
    if (!c()) return l("@keyframes missing '{'");
    let ce, Re = m();
    for (; ce = E(); )
      Re.push(ce), Re = Re.concat(m());
    return d() ? F({
      type: Ke.keyframes,
      name: X,
      vendor: Y,
      keyframes: Re
    }) : l("@keyframes missing '}'");
  }
  o(R, "atkeyframes");
  function C() {
    let F = s(), j = y(/^@supports *([^{]+)/);
    if (!j) return;
    let Y = Nt(j[1]);
    if (!c()) return l("@supports missing '{'");
    let z = m().concat(p());
    return d() ? F({
      type: Ke.supports,
      supports: Y,
      rules: z
    }) : l("@supports missing '}'");
  }
  o(C, "atsupports");
  function w() {
    let F = s();
    if (!y(/^@host\s*/)) return;
    if (!c()) return l("@host missing '{'");
    let Y = m().concat(p());
    return d() ? F({
      type: Ke.host,
      rules: Y
    }) : l("@host missing '}'");
  }
  o(w, "athost");
  function P() {
    let F = s(), j = y(/^@container *([^{]+)/);
    if (!j) return;
    let Y = Nt(j[1]);
    if (!c()) return l("@container missing '{'");
    let z = m().concat(p());
    return d() ? F({
      type: Ke.container,
      container: Y,
      rules: z
    }) : l("@container missing '}'");
  }
  o(P, "atcontainer");
  function O() {
    let F = s(), j = y(/^@layer *([^{;@]+)/);
    if (!j) return;
    let Y = Nt(j[1]);
    if (!c())
      return y(/^[;\s]*/), F({
        type: Ke.layer,
        layer: Y
      });
    let z = m().concat(p());
    return d() ? F({
      type: Ke.layer,
      layer: Y,
      rules: z
    }) : l("@layer missing '}'");
  }
  o(O, "atlayer");
  function D() {
    let F = s(), j = y(/^@media *([^{]+)/);
    if (!j) return;
    let Y = Nt(j[1]);
    if (!c()) return l("@media missing '{'");
    let z = m().concat(p());
    return d() ? F({
      type: Ke.media,
      media: Y,
      rules: z
    }) : l("@media missing '}'");
  }
  o(D, "atmedia");
  function A() {
    let F = s(), j = y(/^@custom-media\s+(--\S+)\s*([^{;\s][^{;]*);/);
    if (j)
      return F({
        type: Ke.customMedia,
        name: Nt(j[1]),
        media: Nt(j[2])
      });
  }
  o(A, "atcustommedia");
  function L() {
    let F = s();
    if (!y(/^@page */)) return;
    let Y = g() || [];
    if (!c()) return l("@page missing '{'");
    let z = m(), X;
    for (; X = T(); )
      z.push(X), z = z.concat(m());
    return d() ? F({
      type: Ke.page,
      selectors: Y,
      declarations: z
    }) : l("@page missing '}'");
  }
  o(L, "atpage");
  function B() {
    let F = s(), j = y(/^@([-\w]+)?document *([^{]+)/);
    if (!j) return;
    let Y = Nt(j[1]), z = Nt(j[2]);
    if (!c()) return l("@document missing '{'");
    let X = m().concat(p());
    return d() ? F({
      type: Ke.document,
      document: z,
      vendor: Y,
      rules: X
    }) : l("@document missing '}'");
  }
  o(B, "atdocument");
  function N() {
    let F = s();
    if (!y(/^@font-face\s*/)) return;
    if (!c()) return l("@font-face missing '{'");
    let Y = m(), z;
    for (; z = T(); )
      Y.push(z), Y = Y.concat(m());
    return d() ? F({
      type: Ke.fontFace,
      declarations: Y
    }) : l("@font-face missing '}'");
  }
  o(N, "atfontface");
  function $() {
    let F = s();
    if (!y(/^@starting-style\s*/)) return;
    if (!c()) return l("@starting-style missing '{'");
    let Y = m().concat(p());
    return d() ? F({
      type: Ke.startingStyle,
      rules: Y
    }) : l("@starting-style missing '}'");
  }
  o($, "atstartingstyle");
  let M = Q("import"), V = Q("charset"), G = Q("namespace");
  function Q(F) {
    let j = new RegExp("^@" + F + `\\s*((?::?[^;'"]|"(?:\\\\"|[^"])*?"|'(?:\\\\'|[^'])*?')+)(?:;|$)`);
    return function() {
      let Y = s(), z = y(j);
      if (!z) return;
      let X = {
        type: F
      };
      return X[F] = z[1].trim(), Y(X);
    };
  }
  o(Q, "_compileAtrule");
  function te() {
    if (e[0] === "@")
      return R() || D() || A() || C() || M() || V() || G() || B() || L() || w() || N() || P() || $() || O();
  }
  o(te, "atrule");
  function fe() {
    let F = s(), j = g();
    return j ? (m(), F({
      type: Ke.rule,
      selectors: j,
      declarations: _() || []
    })) : l("selector missing");
  }
  return o(fe, "rule"), qE(u());
}, "$d708735ed1303b43$export$98e6a39c04603d36");
function Nt(e) {
  return e ? e.trim() : "";
}
o(Nt, "$d708735ed1303b43$var$trim");
function qE(e, t) {
  let r = e && typeof e.type == "string", n = r ? e : t;
  for (let i in e) {
    let s = e[i];
    Array.isArray(s) ? s.forEach((a) => {
      qE(a, n);
    }) : s && typeof s == "object" && qE(s, n);
  }
  return r && Object.defineProperty(e, "parent", {
    configurable: !0,
    writable: !0,
    enumerable: !1,
    value: t || null
  }), e;
}
o(qE, "$d708735ed1303b43$var$addParent");
var b9 = y9;
var U0 = b9;

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/polyfills/array.from.mjs
var g9 = Object.prototype.toString;
function H0(e) {
  return typeof e == "function" || g9.call(e) === "[object Function]";
}
o(H0, "isCallable");
function v9(e) {
  var t = Number(e);
  return isNaN(t) ? 0 : t === 0 || !isFinite(t) ? t : (t > 0 ? 1 : -1) * Math.floor(Math.abs(t));
}
o(v9, "toInteger");
var E9 = Math.pow(2, 53) - 1;
function T9(e) {
  var t = v9(e);
  return Math.min(Math.max(t, 0), E9);
}
o(T9, "toLength");
function xt(e, t) {
  var r = Array, n = Object(e);
  if (e == null)
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  if (typeof t < "u" && !H0(t))
    throw new TypeError("Array.from: when provided, the second argument must be a function");
  for (var i = T9(n.length), s = H0(r) ? Object(new r(i)) : new Array(i), a = 0, l; a < i; )
    l = n[a], t ? s[a] = t(l, a) : s[a] = l, a += 1;
  return s.length = i, s;
}
o(xt, "arrayFrom");

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/polyfills/SetLike.mjs
function Es(e) {
  "@babel/helpers - typeof";
  return Es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Es(e);
}
o(Es, "_typeof");
function _9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
o(_9, "_classCallCheck");
function V0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, z0(n.key), n);
  }
}
o(V0, "_defineProperties");
function R9(e, t, r) {
  return t && V0(e.prototype, t), r && V0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
o(R9, "_createClass");
function w9(e, t, r) {
  return t = z0(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
o(w9, "_defineProperty");
function z0(e) {
  var t = S9(e, "string");
  return Es(t) === "symbol" ? t : String(t);
}
o(z0, "_toPropertyKey");
function S9(e, t) {
  if (Es(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Es(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
o(S9, "_toPrimitive");
var x9 = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    _9(this, e), w9(this, "items", void 0), this.items = t;
  }
  return o(e, "SetLike"), R9(e, [{
    key: "add",
    value: /* @__PURE__ */ o(function(r) {
      return this.has(r) === !1 && this.items.push(r), this;
    }, "add")
  }, {
    key: "clear",
    value: /* @__PURE__ */ o(function() {
      this.items = [];
    }, "clear")
  }, {
    key: "delete",
    value: /* @__PURE__ */ o(function(r) {
      var n = this.items.length;
      return this.items = this.items.filter(function(i) {
        return i !== r;
      }), n !== this.items.length;
    }, "_delete")
  }, {
    key: "forEach",
    value: /* @__PURE__ */ o(function(r) {
      var n = this;
      this.items.forEach(function(i) {
        r(i, i, n);
      });
    }, "forEach")
  }, {
    key: "has",
    value: /* @__PURE__ */ o(function(r) {
      return this.items.indexOf(r) !== -1;
    }, "has")
  }, {
    key: "size",
    get: /* @__PURE__ */ o(function() {
      return this.items.length;
    }, "get")
  }]), e;
}(), G0 = typeof Set > "u" ? Set : x9;

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/getRole.mjs
function Be(e) {
  var t;
  return (
    // eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (t = e.localName) !== null && t !== void 0 ? t : (
      // eslint-disable-next-line no-restricted-properties -- required for the fallback
      e.tagName.toLowerCase()
    )
  );
}
o(Be, "getLocalName");
var C9 = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
}, P9 = {
  caption: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  code: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  deletion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  emphasis: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  generic: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  none: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  paragraph: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  presentation: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  strong: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  subscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  superscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"])
};
function A9(e, t) {
  return [
    "aria-atomic",
    "aria-busy",
    "aria-controls",
    "aria-current",
    "aria-description",
    "aria-describedby",
    "aria-details",
    // "disabled",
    "aria-dropeffect",
    // "errormessage",
    "aria-flowto",
    "aria-grabbed",
    // "haspopup",
    "aria-hidden",
    // "invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-live",
    "aria-owns",
    "aria-relevant",
    "aria-roledescription"
  ].some(function(r) {
    var n;
    return e.hasAttribute(r) && !((n = P9[t]) !== null && n !== void 0 && n.has(r));
  });
}
o(A9, "hasGlobalAriaAttributes");
function Y0(e, t) {
  return A9(e, t);
}
o(Y0, "ignorePresentationalRole");
function ru(e) {
  var t = q9(e);
  if (t === null || Ts.indexOf(t) !== -1) {
    var r = O9(e);
    if (Ts.indexOf(t || "") === -1 || Y0(e, r || ""))
      return r;
  }
  return t;
}
o(ru, "getRole");
function O9(e) {
  var t = C9[Be(e)];
  if (t !== void 0)
    return t;
  switch (Be(e)) {
    case "a":
    case "area":
    case "link":
      if (e.hasAttribute("href"))
        return "link";
      break;
    case "img":
      return e.getAttribute("alt") === "" && !Y0(e, "img") ? "presentation" : "img";
    case "input": {
      var r = e, n = r.type;
      switch (n) {
        case "button":
        case "image":
        case "reset":
        case "submit":
          return "button";
        case "checkbox":
        case "radio":
          return n;
        case "range":
          return "slider";
        case "email":
        case "tel":
        case "text":
        case "url":
          return e.hasAttribute("list") ? "combobox" : "textbox";
        case "search":
          return e.hasAttribute("list") ? "combobox" : "searchbox";
        case "number":
          return "spinbutton";
        default:
          return null;
      }
    }
    case "select":
      return e.hasAttribute("multiple") || e.size > 1 ? "listbox" : "combobox";
  }
  return null;
}
o(O9, "getImplicitRole");
function q9(e) {
  var t = e.getAttribute("role");
  if (t !== null) {
    var r = t.trim().split(" ")[0];
    if (r.length > 0)
      return r;
  }
  return null;
}
o(q9, "getExplicitRole");

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/util.mjs
var Ts = ["presentation", "none"];
function Pe(e) {
  return e !== null && e.nodeType === e.ELEMENT_NODE;
}
o(Pe, "isElement");
function jE(e) {
  return Pe(e) && Be(e) === "caption";
}
o(jE, "isHTMLTableCaptionElement");
function _s(e) {
  return Pe(e) && Be(e) === "input";
}
o(_s, "isHTMLInputElement");
function W0(e) {
  return Pe(e) && Be(e) === "optgroup";
}
o(W0, "isHTMLOptGroupElement");
function K0(e) {
  return Pe(e) && Be(e) === "select";
}
o(K0, "isHTMLSelectElement");
function X0(e) {
  return Pe(e) && Be(e) === "table";
}
o(X0, "isHTMLTableElement");
function J0(e) {
  return Pe(e) && Be(e) === "textarea";
}
o(J0, "isHTMLTextAreaElement");
function Z0(e) {
  var t = e.ownerDocument === null ? e : e.ownerDocument, r = t.defaultView;
  if (r === null)
    throw new TypeError("no window available");
  return r;
}
o(Z0, "safeWindow");
function Q0(e) {
  return Pe(e) && Be(e) === "fieldset";
}
o(Q0, "isHTMLFieldSetElement");
function eA(e) {
  return Pe(e) && Be(e) === "legend";
}
o(eA, "isHTMLLegendElement");
function tA(e) {
  return Pe(e) && Be(e) === "slot";
}
o(tA, "isHTMLSlotElement");
function I9(e) {
  return Pe(e) && e.ownerSVGElement !== void 0;
}
o(I9, "isSVGElement");
function rA(e) {
  return Pe(e) && Be(e) === "svg";
}
o(rA, "isSVGSVGElement");
function nA(e) {
  return I9(e) && Be(e) === "title";
}
o(nA, "isSVGTitleElement");
function $o(e, t) {
  if (Pe(e) && e.hasAttribute(t)) {
    var r = e.getAttribute(t).split(" "), n = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return r.map(function(i) {
      return n.getElementById(i);
    }).filter(
      function(i) {
        return i !== null;
      }
      // TODO: why does this not narrow?
    );
  }
  return [];
}
o($o, "queryIdRefs");
function Yt(e, t) {
  return Pe(e) ? t.indexOf(ru(e)) !== -1 : !1;
}
o(Yt, "hasAnyConcreteRoles");

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/accessible-name-and-description.mjs
function M9(e) {
  return e.trim().replace(/\s\s+/g, " ");
}
o(M9, "asFlatString");
function N9(e, t) {
  if (!Pe(e))
    return !1;
  if (e.hasAttribute("hidden") || e.getAttribute("aria-hidden") === "true")
    return !0;
  var r = t(e);
  return r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}
o(N9, "isHidden");
function j9(e) {
  return Yt(e, ["button", "combobox", "listbox", "textbox"]) || sA(e, "range");
}
o(j9, "isControl");
function sA(e, t) {
  if (!Pe(e))
    return !1;
  switch (t) {
    case "range":
      return Yt(e, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(t, "'. This is likely a bug :("));
  }
}
o(sA, "hasAbstractRole");
function oA(e, t) {
  var r = xt(e.querySelectorAll(t));
  return $o(e, "aria-owns").forEach(function(n) {
    r.push.apply(r, xt(n.querySelectorAll(t)));
  }), r;
}
o(oA, "querySelectorAllSubtree");
function L9(e) {
  return K0(e) ? e.selectedOptions || oA(e, "[selected]") : oA(e, '[aria-selected="true"]');
}
o(L9, "querySelectedOptions");
function F9(e) {
  return Yt(e, Ts);
}
o(F9, "isMarkedPresentational");
function k9(e) {
  return jE(e);
}
o(k9, "isNativeHostLanguageTextAlternativeElement");
function D9(e) {
  return Yt(e, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbo\
x", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
o(D9, "allowsNameFromContent");
function $9(e) {
  return !1;
}
o($9, "isDescendantOfNativeHostLanguageTextAlternativeElement");
function B9(e) {
  return _s(e) || J0(e) ? e.value : e.textContent || "";
}
o(B9, "getValueOfTextbox");
function iA(e) {
  var t = e.getPropertyValue("content");
  return /^["'].*["']$/.test(t) ? t.slice(1, -1) : "";
}
o(iA, "getTextualContent");
function aA(e) {
  var t = Be(e);
  return t === "button" || t === "input" && e.getAttribute("type") !== "hidden" || t === "meter" || t === "output" || t === "progress" || t ===
  "select" || t === "textarea";
}
o(aA, "isLabelableElement");
function lA(e) {
  if (aA(e))
    return e;
  var t = null;
  return e.childNodes.forEach(function(r) {
    if (t === null && Pe(r)) {
      var n = lA(r);
      n !== null && (t = n);
    }
  }), t;
}
o(lA, "findLabelableElement");
function U9(e) {
  if (e.control !== void 0)
    return e.control;
  var t = e.getAttribute("for");
  return t !== null ? e.ownerDocument.getElementById(t) : lA(e);
}
o(U9, "getControlOfLabel");
function H9(e) {
  var t = e.labels;
  if (t === null)
    return t;
  if (t !== void 0)
    return xt(t);
  if (!aA(e))
    return null;
  var r = e.ownerDocument;
  return xt(r.querySelectorAll("label")).filter(function(n) {
    return U9(n) === e;
  });
}
o(H9, "getLabels");
function V9(e) {
  var t = e.assignedNodes();
  return t.length === 0 ? xt(e.childNodes) : t;
}
o(V9, "getSlotContents");
function nu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = new G0(), n = Z0(e), i = t.compute, s = i === void 0 ? "n\
ame" : i, a = t.computedStyleSupportsPseudoElements, l = a === void 0 ? t.getComputedStyle !== void 0 : a, u = t.getComputedStyle, c = u ===
  void 0 ? n.getComputedStyle.bind(n) : u, d = t.hidden, p = d === void 0 ? !1 : d;
  function y(g, T) {
    var _ = "";
    if (Pe(g) && l) {
      var E = c(g, "::before"), R = iA(E);
      _ = "".concat(R, " ").concat(_);
    }
    var C = tA(g) ? V9(g) : xt(g.childNodes).concat($o(g, "aria-owns"));
    if (C.forEach(function(O) {
      var D = b(O, {
        isEmbeddedInLabel: T.isEmbeddedInLabel,
        isReferenced: !1,
        recursion: !0
      }), A = Pe(O) ? c(O).getPropertyValue("display") : "inline", L = A !== "inline" ? " " : "";
      _ += "".concat(L).concat(D).concat(L);
    }), Pe(g) && l) {
      var w = c(g, "::after"), P = iA(w);
      _ = "".concat(_, " ").concat(P);
    }
    return _.trim();
  }
  o(y, "computeMiscTextAlternative");
  function f(g, T) {
    var _ = g.getAttributeNode(T);
    return _ !== null && !r.has(_) && _.value.trim() !== "" ? (r.add(_), _.value) : null;
  }
  o(f, "useAttribute");
  function m(g) {
    return Pe(g) ? f(g, "title") : null;
  }
  o(m, "computeTooltipAttributeValue");
  function h(g) {
    if (!Pe(g))
      return null;
    if (Q0(g)) {
      r.add(g);
      for (var T = xt(g.childNodes), _ = 0; _ < T.length; _ += 1) {
        var E = T[_];
        if (eA(E))
          return b(E, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (X0(g)) {
      r.add(g);
      for (var R = xt(g.childNodes), C = 0; C < R.length; C += 1) {
        var w = R[C];
        if (jE(w))
          return b(w, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (rA(g)) {
      r.add(g);
      for (var P = xt(g.childNodes), O = 0; O < P.length; O += 1) {
        var D = P[O];
        if (nA(D))
          return D.textContent;
      }
      return null;
    } else if (Be(g) === "img" || Be(g) === "area") {
      var A = f(g, "alt");
      if (A !== null)
        return A;
    } else if (W0(g)) {
      var L = f(g, "label");
      if (L !== null)
        return L;
    }
    if (_s(g) && (g.type === "button" || g.type === "submit" || g.type === "reset")) {
      var B = f(g, "value");
      if (B !== null)
        return B;
      if (g.type === "submit")
        return "Submit";
      if (g.type === "reset")
        return "Reset";
    }
    var N = H9(g);
    if (N !== null && N.length !== 0)
      return r.add(g), xt(N).map(function(G) {
        return b(G, {
          isEmbeddedInLabel: !0,
          isReferenced: !1,
          recursion: !0
        });
      }).filter(function(G) {
        return G.length > 0;
      }).join(" ");
    if (_s(g) && g.type === "image") {
      var $ = f(g, "alt");
      if ($ !== null)
        return $;
      var M = f(g, "title");
      return M !== null ? M : "Submit Query";
    }
    if (Yt(g, ["button"])) {
      var V = y(g, {
        isEmbeddedInLabel: !1,
        isReferenced: !1
      });
      if (V !== "")
        return V;
    }
    return null;
  }
  o(h, "computeElementTextAlternative");
  function b(g, T) {
    if (r.has(g))
      return "";
    if (!p && N9(g, c) && !T.isReferenced)
      return r.add(g), "";
    var _ = Pe(g) ? g.getAttributeNode("aria-labelledby") : null, E = _ !== null && !r.has(_) ? $o(g, "aria-labelledby") : [];
    if (s === "name" && !T.isReferenced && E.length > 0)
      return r.add(_), E.map(function(A) {
        return b(A, {
          isEmbeddedInLabel: T.isEmbeddedInLabel,
          isReferenced: !0,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: !1
        });
      }).join(" ");
    var R = T.recursion && j9(g) && s === "name";
    if (!R) {
      var C = (Pe(g) && g.getAttribute("aria-label") || "").trim();
      if (C !== "" && s === "name")
        return r.add(g), C;
      if (!F9(g)) {
        var w = h(g);
        if (w !== null)
          return r.add(g), w;
      }
    }
    if (Yt(g, ["menu"]))
      return r.add(g), "";
    if (R || T.isEmbeddedInLabel || T.isReferenced) {
      if (Yt(g, ["combobox", "listbox"])) {
        r.add(g);
        var P = L9(g);
        return P.length === 0 ? _s(g) ? g.value : "" : xt(P).map(function(A) {
          return b(A, {
            isEmbeddedInLabel: T.isEmbeddedInLabel,
            isReferenced: !1,
            recursion: !0
          });
        }).join(" ");
      }
      if (sA(g, "range"))
        return r.add(g), g.hasAttribute("aria-valuetext") ? g.getAttribute("aria-valuetext") : g.hasAttribute("aria-valuenow") ? g.getAttribute(
        "aria-valuenow") : g.getAttribute("value") || "";
      if (Yt(g, ["textbox"]))
        return r.add(g), B9(g);
    }
    if (D9(g) || Pe(g) && T.isReferenced || k9(g) || $9(g)) {
      var O = y(g, {
        isEmbeddedInLabel: T.isEmbeddedInLabel,
        isReferenced: !1
      });
      if (O !== "")
        return r.add(g), O;
    }
    if (g.nodeType === g.TEXT_NODE)
      return r.add(g), g.textContent || "";
    if (T.recursion)
      return r.add(g), y(g, {
        isEmbeddedInLabel: T.isEmbeddedInLabel,
        isReferenced: !1
      });
    var D = m(g);
    return D !== null ? (r.add(g), D) : (r.add(g), "");
  }
  return o(b, "computeTextAlternative"), M9(b(e, {
    isEmbeddedInLabel: !1,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: s === "description",
    recursion: !1
  }));
}
o(nu, "computeTextAlternative");

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/accessible-description.mjs
function Rs(e) {
  "@babel/helpers - typeof";
  return Rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rs(e);
}
o(Rs, "_typeof");
function uA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
o(uA, "ownKeys");
function cA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uA(Object(r), !0).forEach(function(n) {
      z9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
o(cA, "_objectSpread");
function z9(e, t, r) {
  return t = G9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
o(z9, "_defineProperty");
function G9(e) {
  var t = Y9(e, "string");
  return Rs(t) === "symbol" ? t : String(t);
}
o(G9, "_toPropertyKey");
function Y9(e, t) {
  if (Rs(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Rs(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
o(Y9, "_toPrimitive");
function LE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = $o(e, "aria-describedby").map(function(s) {
    return nu(s, cA(cA({}, t), {}, {
      compute: "description"
    }));
  }).join(" ");
  if (r === "") {
    var n = e.getAttribute("aria-description");
    r = n === null ? "" : n;
  }
  if (r === "") {
    var i = e.getAttribute("title");
    r = i === null ? "" : i;
  }
  return r;
}
o(LE, "computeAccessibleDescription");

// ../node_modules/@testing-library/jest-dom/node_modules/dom-accessibility-api/dist/accessible-name.mjs
function W9(e) {
  return Yt(e, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "none", "paragraph", "presentation", "strong", "subscript",
  "superscript"]);
}
o(W9, "prohibitsNaming");
function FE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return W9(e) ? "" : nu(e, t);
}
o(FE, "computeAccessibleName");

// ../node_modules/@testing-library/jest-dom/dist/matchers-c85aadf8.mjs
var Bs = De(rT(), 1), yj = De(pT(), 1), gp = De(IT(), 1), bj = De(NT(), 1);
var a_ = class a_ extends Error {
  constructor(t, r, n, i) {
    super(), Error.captureStackTrace && Error.captureStackTrace(this, n);
    let s = "";
    try {
      s = i.utils.printWithType(
        "Received",
        r,
        i.utils.printReceived
      );
    } catch {
    }
    this.message = [
      i.utils.matcherHint(
        `${i.isNot ? ".not" : ""}.${n.name}`,
        "received",
        ""
      ),
      "",
      // eslint-disable-next-line new-cap
      `${i.utils.RECEIVED_COLOR(
        "received"
      )} value must ${t}.`,
      s
    ].join(`
`);
  }
};
o(a_, "GenericTypeError");
var up = a_, l_ = class l_ extends up {
  constructor(...t) {
    super("be an HTMLElement or an SVGElement", ...t);
  }
};
o(l_, "HtmlElementTypeError");
var cp = l_, u_ = class u_ extends up {
  constructor(...t) {
    super("be a Node", ...t);
  }
};
o(u_, "NodeTypeError");
var dp = u_;
function gj(e, t, ...r) {
  if (!e || !e.ownerDocument || !e.ownerDocument.defaultView)
    throw new t(e, ...r);
}
o(gj, "checkHasWindow");
function Die(e, ...t) {
  gj(e, dp, ...t);
  let r = e.ownerDocument.defaultView;
  if (!(e instanceof r.Node))
    throw new dp(e, ...t);
}
o(Die, "checkNode");
function be(e, ...t) {
  gj(e, cp, ...t);
  let r = e.ownerDocument.defaultView;
  if (!(e instanceof r.HTMLElement) && !(e instanceof r.SVGElement))
    throw new cp(e, ...t);
}
o(be, "checkHtmlElement");
var c_ = class c_ extends Error {
  constructor(t, r, n) {
    super(), Error.captureStackTrace && Error.captureStackTrace(this, r), this.message = [
      t.message,
      "",
      // eslint-disable-next-line new-cap
      n.utils.RECEIVED_COLOR("Failing css:"),
      // eslint-disable-next-line new-cap
      n.utils.RECEIVED_COLOR(`${t.css}`)
    ].join(`
`);
  }
};
o(c_, "InvalidCSSError");
var LT = c_;
function $ie(e, ...t) {
  let r = U0(`selector { ${e} }`, { silent: !0 }).stylesheet;
  if (r.parsingErrors && r.parsingErrors.length > 0) {
    let { reason: i, line: s } = r.parsingErrors[0];
    throw new LT(
      {
        css: e,
        message: `Syntax error parsing expected css: ${i} on line: ${s}`
      },
      ...t
    );
  }
  return r.rules[0].declarations.filter((i) => i.type === "declaration").reduce(
    (i, { property: s, value: a }) => Object.assign(i, { [s]: a }),
    {}
  );
}
o($ie, "parseCSS");
function dj(e, t) {
  return typeof t == "string" ? t : e.utils.stringify(t);
}
o(dj, "display");
function et(e, t, r, n, i, s) {
  return [
    `${t}
`,
    // eslint-disable-next-line new-cap
    `${r}:
${e.utils.EXPECTED_COLOR(
      (0, jT.default)(dj(e, n), 2)
    )}`,
    // eslint-disable-next-line new-cap
    `${i}:
${e.utils.RECEIVED_COLOR(
      (0, jT.default)(dj(e, s), 2)
    )}`
  ].join(`
`);
}
o(et, "getMessage");
function Bie(e, t) {
  return t instanceof RegExp ? t.test(e) : e.includes(String(t));
}
o(Bie, "matches");
function vp(e, t) {
  console.warn(
    `Warning: ${e} has been deprecated and will be removed in future updates.`,
    t
  );
}
o(vp, "deprecate");
function Ep(e) {
  return e.replace(/\s+/g, " ").trim();
}
o(Ep, "normalize");
function Wr(e) {
  return e.tagName && e.tagName.toLowerCase();
}
o(Wr, "getTag");
function Uie({ multiple: e, options: t }) {
  let r = [...t].filter((n) => n.selected);
  if (e)
    return [...r].map((n) => n.value);
  if (r.length !== 0)
    return r[0].value;
}
o(Uie, "getSelectValue");
function Hie(e) {
  switch (e.type) {
    case "number":
      return e.value === "" ? null : Number(e.value);
    case "checkbox":
      return e.checked;
    default:
      return e.value;
  }
}
o(Hie, "getInputValue");
var Vie = ["meter", "progressbar", "slider", "spinbutton"];
function zie(e) {
  if (Vie.includes(e.getAttribute("role")))
    return Number(e.getAttribute("aria-valuenow"));
}
o(zie, "getAccessibleValue");
function vj(e) {
  if (e)
    switch (e.tagName.toLowerCase()) {
      case "input":
        return Hie(e);
      case "select":
        return Uie(e);
      default:
        return e.value ?? zie(e);
    }
}
o(vj, "getSingleElementValue");
function Gie(e, { wordConnector: t = ", ", lastWordConnector: r = " and " } = {}) {
  return [e.slice(0, -1).join(t), e[e.length - 1]].join(
    e.length > 1 ? r : ""
  );
}
o(Gie, "toSentence");
function FT(e, t) {
  if (Array.isArray(e) && Array.isArray(t))
    return [...new Set(e)].every((r) => new Set(t).has(r));
}
o(FT, "compareArraysAsSet");
function pp(e, t) {
  return vp(
    "toBeInTheDOM",
    "Please use toBeInTheDocument for searching the entire document and toContainElement for searching a specific container."
  ), e && be(e, pp, this), t && be(t, pp, this), {
    pass: t ? t.contains(e) : !!e,
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toBeInTheDOM`,
        "element",
        ""
      ),
      "",
      "Received:",
      `  ${this.utils.printReceived(
        e && e.cloneNode(!1)
      )}`
    ].join(`
`), "message")
  };
}
o(pp, "toBeInTheDOM");
function kT(e) {
  (e !== null || !this.isNot) && be(e, kT, this);
  let t = e === null ? !1 : e.ownerDocument === e.getRootNode({ composed: !0 }), r = /* @__PURE__ */ o(() => `expected document not to conta\
in element, found ${this.utils.stringify(
    e.cloneNode(!0)
  )} instead`, "errorFound"), n = /* @__PURE__ */ o(() => "element could not be found in the document", "errorNotFound");
  return {
    pass: t,
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toBeInTheDocument`,
        "element",
        ""
      ),
      "",
      // eslint-disable-next-line new-cap
      this.utils.RECEIVED_COLOR(this.isNot ? r() : n())
    ].join(`
`), "message")
  };
}
o(kT, "toBeInTheDocument");
function DT(e) {
  return vp(
    "toBeEmpty",
    "Please use instead toBeEmptyDOMElement for finding empty nodes in the DOM."
  ), be(e, DT, this), {
    pass: e.innerHTML === "",
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toBeEmpty`,
        "element",
        ""
      ),
      "",
      "Received:",
      `  ${this.utils.printReceived(e.innerHTML)}`
    ].join(`
`), "message")
  };
}
o(DT, "toBeEmpty");
function $T(e) {
  return be(e, $T, this), {
    pass: Yie(e),
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toBeEmptyDOMElement`,
        "element",
        ""
      ),
      "",
      "Received:",
      `  ${this.utils.printReceived(e.innerHTML)}`
    ].join(`
`), "message")
  };
}
o($T, "toBeEmptyDOMElement");
function Yie(e) {
  return [...e.childNodes].filter((r) => r.nodeType !== 8).length === 0;
}
o(Yie, "isEmptyElement");
function fp(e, t) {
  return be(e, fp, this), t !== null && be(t, fp, this), {
    pass: e.contains(t),
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toContainElement`,
        "element",
        "element"
      ),
      "",
      // eslint-disable-next-line new-cap
      this.utils.RECEIVED_COLOR(`${this.utils.stringify(
        e.cloneNode(!1)
      )} ${this.isNot ? "contains:" : "does not contain:"} ${this.utils.stringify(t && t.cloneNode(!1))}
        `)
    ].join(`
`), "message")
  };
}
o(fp, "toContainElement");
function Wie(e, t) {
  let r = e.ownerDocument.createElement("div");
  return r.innerHTML = t, r.innerHTML;
}
o(Wie, "getNormalizedHtml");
function BT(e, t) {
  if (be(e, BT, this), typeof t != "string")
    throw new Error(`.toContainHTML() expects a string value, got ${t}`);
  return {
    pass: e.outerHTML.includes(Wie(e, t)),
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toContainHTML`,
        "element",
        ""
      ),
      "Expected:",
      // eslint-disable-next-line new-cap
      `  ${this.utils.EXPECTED_COLOR(t)}`,
      "Received:",
      `  ${this.utils.printReceived(e.cloneNode(!0))}`
    ].join(`
`), "message")
  };
}
o(BT, "toContainHTML");
function UT(e, t, r = { normalizeWhitespace: !0 }) {
  Die(e, UT, this);
  let n = r.normalizeWhitespace ? Ep(e.textContent) : e.textContent.replace(/\u00a0/g, " "), i = n !== "" && t === "";
  return {
    pass: !i && Bie(n, t),
    message: /* @__PURE__ */ o(() => {
      let s = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toHaveTextContent`,
          "element",
          ""
        ),
        i ? "Checking with empty string will always match, use .toBeEmptyDOMElement() instead" : `Expected element ${s} have text content`,
        t,
        "Received",
        n
      );
    }, "message")
  };
}
o(UT, "toHaveTextContent");
function mp(e, t) {
  be(e, mp, this);
  let r = LE(e), n = arguments.length === 1, i = !1;
  return n ? i = r !== "" : i = t instanceof RegExp ? t.test(r) : this.equals(
    r,
    t
  ), {
    pass: i,
    message: /* @__PURE__ */ o(() => {
      let s = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.${mp.name}`,
          "element",
          ""
        ),
        `Expected element ${s} have accessible description`,
        t,
        "Received",
        r
      );
    }, "message")
  };
}
o(mp, "toHaveAccessibleDescription");
var $s = "aria-invalid", Kie = ["false"];
function HT(e, t) {
  be(e, HT, this);
  let r = this.isNot ? "not to" : "to", n = this.isNot ? ".not.toHaveAccessibleErrorMessage" : ".toHaveAccessibleErrorMessage", i = e.getAttribute(
  "aria-errormessage");
  if (!!i && /\s+/.test(i))
    return {
      pass: !1,
      message: /* @__PURE__ */ o(() => et(
        this,
        this.utils.matcherHint(n, "element"),
        "Expected element's `aria-errormessage` attribute to be empty or a single, valid ID",
        "",
        "Received",
        `aria-errormessage="${i}"`
      ), "message")
    };
  let a = e.getAttribute($s);
  if (!e.hasAttribute($s) || Kie.includes(a))
    return {
      pass: !1,
      message: /* @__PURE__ */ o(() => et(
        this,
        this.utils.matcherHint(n, "element"),
        "Expected element to be marked as invalid with attribute",
        `${$s}="${String(!0)}"`,
        "Received",
        e.hasAttribute("aria-invalid") ? `${$s}="${e.getAttribute($s)}` : null
      ), "message")
    };
  let u = Ep(
    e.ownerDocument.getElementById(i)?.textContent ?? ""
  );
  return {
    pass: t === void 0 ? !!u : t instanceof RegExp ? t.test(u) : this.equals(u, t),
    message: /* @__PURE__ */ o(() => et(
      this,
      this.utils.matcherHint(n, "element"),
      `Expected element ${r} have accessible error message`,
      t ?? "",
      "Received",
      u
    ), "message")
  };
}
o(HT, "toHaveAccessibleErrorMessage");
var Xie = Qie(Bs.elementRoles);
function hp(e, t) {
  be(e, hp, this);
  let r = Jie(e);
  return {
    pass: r.some((i) => i === t),
    message: /* @__PURE__ */ o(() => {
      let i = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.${hp.name}`,
          "element",
          ""
        ),
        `Expected element ${i} have role`,
        t,
        "Received",
        r.join(", ")
      );
    }, "message")
  };
}
o(hp, "toHaveRole");
function Jie(e) {
  return e.hasAttribute("role") ? e.getAttribute("role").split(" ").filter(Boolean) : Zie(e);
}
o(Jie, "getExplicitOrImplicitRoles");
function Zie(e) {
  for (let { match: t, roles: r } of Xie)
    if (t(e))
      return [...r];
  return [];
}
o(Zie, "getImplicitAriaRoles");
function Qie(e) {
  function t({ name: a, attributes: l }) {
    return `${a}${l.map(({ name: u, value: c, constraints: d = [] }) => d.indexOf("undefined") !== -1 ? `:not([${u}])` : c ? `[${u}="${c}"]` :
    `[${u}]`).join("")}`;
  }
  o(t, "makeElementSelector");
  function r({ attributes: a = [] }) {
    return a.length;
  }
  o(r, "getSelectorSpecificity");
  function n({ specificity: a }, { specificity: l }) {
    return l - a;
  }
  o(n, "bySelectorSpecificity");
  function i(a) {
    let { attributes: l = [] } = a, u = l.findIndex(
      (d) => d.value && d.name === "type" && d.value === "text"
    );
    u >= 0 && (l = [
      ...l.slice(0, u),
      ...l.slice(u + 1)
    ]);
    let c = t({ ...a, attributes: l });
    return (d) => u >= 0 && d.type !== "text" ? !1 : d.matches(c);
  }
  o(i, "match");
  let s = [];
  for (let [a, l] of e.entries())
    s = [
      ...s,
      {
        match: i(a),
        roles: Array.from(l),
        specificity: r(a)
      }
    ];
  return s.sort(n);
}
o(Qie, "buildElementRoleList");
function yp(e, t) {
  be(e, yp, this);
  let r = FE(e), n = arguments.length === 1, i = !1;
  return n ? i = r !== "" : i = t instanceof RegExp ? t.test(r) : this.equals(r, t), {
    pass: i,
    message: /* @__PURE__ */ o(() => {
      let s = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.${yp.name}`,
          "element",
          ""
        ),
        `Expected element ${s} have accessible name`,
        t,
        "Received",
        r
      );
    }, "message")
  };
}
o(yp, "toHaveAccessibleName");
function pj(e, t, r) {
  return r === void 0 ? t : `${t}=${e(r)}`;
}
o(pj, "printAttribute");
function ese(e, t, r) {
  return r === void 0 ? `element.hasAttribute(${e(t)})` : `element.getAttribute(${e(t)}) === ${e(r)}`;
}
o(ese, "getAttributeComment");
function VT(e, t, r) {
  be(e, VT, this);
  let n = r !== void 0, i = e.hasAttribute(t), s = e.getAttribute(t);
  return {
    pass: n ? i && this.equals(s, r) : i,
    message: /* @__PURE__ */ o(() => {
      let a = this.isNot ? "not to" : "to", l = i ? pj(this.utils.stringify, t, s) : null, u = this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toHaveAttribute`,
        "element",
        this.utils.printExpected(t),
        {
          secondArgument: n ? this.utils.printExpected(r) : void 0,
          comment: ese(
            this.utils.stringify,
            t,
            r
          )
        }
      );
      return et(
        this,
        u,
        `Expected the element ${a} have attribute`,
        pj(this.utils.stringify, t, r),
        "Received",
        l
      );
    }, "message")
  };
}
o(VT, "toHaveAttribute");
function tse(e) {
  let t = e.pop(), r, n;
  return typeof t == "object" && !(t instanceof RegExp) ? (r = e, n = t) : (r = e.concat(t), n = { exact: !1 }), { expectedClassNames: r, options: n };
}
o(tse, "getExpectedClassNamesAndOptions");
function fj(e) {
  return e ? e.split(/\s+/).filter((t) => t.length > 0) : [];
}
o(fj, "splitClassNames");
function mj(e, t) {
  return e.every(
    (r) => typeof r == "string" ? t.includes(r) : t.some((n) => r.test(n))
  );
}
o(mj, "isSubset$1");
function zT(e, ...t) {
  be(e, zT, this);
  let { expectedClassNames: r, options: n } = tse(t), i = fj(e.getAttribute("class")), s = r.reduce(
    (l, u) => l.concat(
      typeof u == "string" || !u ? fj(u) : u
    ),
    []
  ), a = s.some((l) => l instanceof RegExp);
  if (n.exact && a)
    throw new Error("Exact option does not support RegExp expected class names");
  return n.exact ? {
    pass: mj(s, i) && s.length === i.length,
    message: /* @__PURE__ */ o(() => {
      let l = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toHaveClass`,
          "element",
          this.utils.printExpected(s.join(" "))
        ),
        `Expected the element ${l} have EXACTLY defined classes`,
        s.join(" "),
        "Received",
        i.join(" ")
      );
    }, "message")
  } : s.length > 0 ? {
    pass: mj(s, i),
    message: /* @__PURE__ */ o(() => {
      let l = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toHaveClass`,
          "element",
          this.utils.printExpected(s.join(" "))
        ),
        `Expected the element ${l} have class`,
        s.join(" "),
        "Received",
        i.join(" ")
      );
    }, "message")
  } : {
    pass: this.isNot ? i.length > 0 : !1,
    message: /* @__PURE__ */ o(() => this.isNot ? et(
      this,
      this.utils.matcherHint(".not.toHaveClass", "element", ""),
      "Expected the element to have classes",
      "(none)",
      "Received",
      i.join(" ")
    ) : [
      this.utils.matcherHint(".toHaveClass", "element"),
      "At least one expected class must be provided."
    ].join(`
`), "message")
  };
}
o(zT, "toHaveClass");
function rse(e, t) {
  let r = {}, n = e.createElement("div");
  return Object.keys(t).forEach((i) => {
    n.style[i] = t[i], r[i] = n.style[i];
  }), r;
}
o(rse, "getStyleDeclaration");
function nse(e, t) {
  return !!Object.keys(e).length && Object.entries(e).every(([r, n]) => {
    let i = r.startsWith("--"), s = [r];
    return i || s.push(r.toLowerCase()), s.some(
      (a) => t[a] === n || t.getPropertyValue(a) === n
    );
  });
}
o(nse, "isSubset");
function hj(e) {
  return Object.keys(e).sort().map((t) => `${t}: ${e[t]};`).join(`
`);
}
o(hj, "printoutStyles");
function ose(e, t, r) {
  let n = Array.from(r).filter((s) => t[s] !== void 0).reduce(
    (s, a) => Object.assign(s, { [a]: r.getPropertyValue(a) }),
    {}
  );
  return e(hj(t), hj(n)).replace(`${yj.default.red("+ Received")}
`, "");
}
o(ose, "expectedDiff");
function bp(e, t) {
  be(e, bp, this);
  let r = typeof t == "object" ? t : $ie(t, bp, this), { getComputedStyle: n } = e.ownerDocument.defaultView, i = rse(e.ownerDocument, r), s = n(
  e);
  return {
    pass: nse(i, s),
    message: /* @__PURE__ */ o(() => {
      let a = `${this.isNot ? ".not" : ""}.toHaveStyle`;
      return [
        this.utils.matcherHint(a, "element", ""),
        ose(this.utils.diff, i, s)
      ].join(`

`);
    }, "message")
  };
}
o(bp, "toHaveStyle");
function GT(e) {
  return be(e, GT, this), {
    pass: e.ownerDocument.activeElement === e,
    message: /* @__PURE__ */ o(() => [
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toHaveFocus`,
        "element",
        ""
      ),
      "",
      ...this.isNot ? [
        "Received element is focused:",
        `  ${this.utils.printReceived(e)}`
      ] : [
        "Expected element with focus:",
        `  ${this.utils.printExpected(e)}`,
        "Received element with focus:",
        `  ${this.utils.printReceived(
          e.ownerDocument.activeElement
        )}`
      ]
    ].join(`
`), "message")
  };
}
o(GT, "toHaveFocus");
function ise(e) {
  let t = [...new Set(e.map((r) => r.type))];
  if (t.length !== 1)
    throw new Error(
      "Multiple form elements with the same name must be of the same type"
    );
  switch (t[0]) {
    case "radio": {
      let r = e.find((n) => n.checked);
      return r ? r.value : void 0;
    }
    case "checkbox":
      return e.filter((r) => r.checked).map((r) => r.value);
    default:
      return e.map((r) => r.value);
  }
}
o(ise, "getMultiElementValue");
function sse(e, t) {
  let r = [...e.querySelectorAll(`[name="${(0, bj.default)(t)}"]`)];
  if (r.length !== 0)
    switch (r.length) {
      case 1:
        return vj(r[0]);
      default:
        return ise(r);
    }
}
o(sse, "getFormValue");
function ase(e) {
  return /\[\]$/.test(e) ? e.slice(0, -2) : e;
}
o(ase, "getPureName");
function lse(e) {
  return Array.from(e.elements).map((r) => r.name).reduce(
    (r, n) => ({
      ...r,
      [ase(n)]: sse(e, n)
    }),
    {}
  );
}
o(lse, "getAllFormValues");
function YT(e, t) {
  if (be(e, YT, this), !e.elements)
    throw new Error("toHaveFormValues must be called on a form or a fieldset");
  let r = lse(e);
  return {
    pass: Object.entries(t).every(
      ([n, i]) => (0, gp.default)(r[n], i, FT)
    ),
    message: /* @__PURE__ */ o(() => {
      let n = this.isNot ? "not to" : "to", i = `${this.isNot ? ".not" : ""}.toHaveFormValues`, s = Object.keys(r).filter((a) => t.hasOwnProperty(
      a)).reduce((a, l) => ({ ...a, [l]: r[l] }), {});
      return [
        this.utils.matcherHint(i, "element", ""),
        `Expected the element ${n} have form values`,
        this.utils.diff(t, s)
      ].join(`

`);
    }, "message")
  };
}
o(YT, "toHaveFormValues");
function use(e) {
  let { getComputedStyle: t } = e.ownerDocument.defaultView, { display: r, visibility: n, opacity: i } = t(e);
  return r !== "none" && n !== "hidden" && n !== "collapse" && i !== "0" && i !== 0;
}
o(use, "isStyleVisible");
function cse(e, t) {
  let r;
  return t ? r = e.nodeName === "DETAILS" && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0 : r = e.nodeName === "DETAILS" ? e.hasAttribute(
  "open") : !0, !e.hasAttribute("hidden") && r;
}
o(cse, "isAttributeVisible");
function Ej(e, t) {
  return use(e) && cse(e, t) && (!e.parentElement || Ej(e.parentElement, e));
}
o(Ej, "isElementVisible");
function WT(e) {
  be(e, WT, this);
  let t = e.ownerDocument === e.getRootNode({ composed: !0 }), r = t && Ej(e);
  return {
    pass: r,
    message: /* @__PURE__ */ o(() => {
      let n = r ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeVisible`,
          "element",
          ""
        ),
        "",
        `Received element ${n} visible${t ? "" : " (element is not in the document)"}:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(WT, "toBeVisible");
var dse = [
  "fieldset",
  "input",
  "select",
  "optgroup",
  "option",
  "button",
  "textarea"
];
function pse(e, t) {
  return Wr(e) === "legend" && Wr(t) === "fieldset" && e.isSameNode(
    Array.from(t.children).find((r) => Wr(r) === "legend")
  );
}
o(pse, "isFirstLegendChildOfFieldset");
function fse(e, t) {
  return _j(t) && !pse(e, t);
}
o(fse, "isElementDisabledByParent");
function mse(e) {
  return e.includes("-");
}
o(mse, "isCustomElement");
function Tj(e) {
  let t = Wr(e);
  return dse.includes(t) || mse(t);
}
o(Tj, "canElementBeDisabled");
function _j(e) {
  return Tj(e) && e.hasAttribute("disabled");
}
o(_j, "isElementDisabled");
function Rj(e) {
  let t = e.parentElement;
  return !!t && (fse(e, t) || Rj(t));
}
o(Rj, "isAncestorDisabled");
function wj(e) {
  return Tj(e) && (_j(e) || Rj(e));
}
o(wj, "isElementOrAncestorDisabled");
function KT(e) {
  be(e, KT, this);
  let t = wj(e);
  return {
    pass: t,
    message: /* @__PURE__ */ o(() => {
      let r = t ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeDisabled`,
          "element",
          ""
        ),
        "",
        `Received element ${r} disabled:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(KT, "toBeDisabled");
function XT(e) {
  be(e, XT, this);
  let t = !wj(e);
  return {
    pass: t,
    message: /* @__PURE__ */ o(() => {
      let r = t ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeEnabled`,
          "element",
          ""
        ),
        "",
        `Received element ${r} enabled:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(XT, "toBeEnabled");
var hse = ["select", "textarea"], yse = ["input", "select", "textarea"], bse = [
  "color",
  "hidden",
  "range",
  "submit",
  "image",
  "reset"
], gse = [
  "checkbox",
  "combobox",
  "gridcell",
  "listbox",
  "radiogroup",
  "spinbutton",
  "textbox",
  "tree"
];
function vse(e) {
  return hse.includes(Wr(e)) && e.hasAttribute("required");
}
o(vse, "isRequiredOnFormTagsExceptInput");
function Ese(e) {
  return Wr(e) === "input" && e.hasAttribute("required") && (e.hasAttribute("type") && !bse.includes(e.getAttribute("type")) || !e.hasAttribute(
  "type"));
}
o(Ese, "isRequiredOnSupportedInput");
function Tse(e) {
  return e.hasAttribute("aria-required") && e.getAttribute("aria-required") === "true" && (yse.includes(Wr(e)) || e.hasAttribute("role") && gse.
  includes(e.getAttribute("role")));
}
o(Tse, "isElementRequiredByARIA");
function JT(e) {
  be(e, JT, this);
  let t = vse(e) || Ese(e) || Tse(e);
  return {
    pass: t,
    message: /* @__PURE__ */ o(() => {
      let r = t ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeRequired`,
          "element",
          ""
        ),
        "",
        `Received element ${r} required:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(JT, "toBeRequired");
var _se = ["form", "input", "select", "textarea"];
function Rse(e) {
  return e.hasAttribute("aria-invalid") && e.getAttribute("aria-invalid") !== "false";
}
o(Rse, "isElementHavingAriaInvalid");
function wse(e) {
  return _se.includes(Wr(e));
}
o(wse, "isSupportsValidityMethod");
function Sj(e) {
  let t = Rse(e);
  return wse(e) ? t || !e.checkValidity() : t;
}
o(Sj, "isElementInvalid");
function ZT(e) {
  be(e, ZT, this);
  let t = Sj(e);
  return {
    pass: t,
    message: /* @__PURE__ */ o(() => {
      let r = t ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeInvalid`,
          "element",
          ""
        ),
        "",
        `Received element ${r} currently invalid:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(ZT, "toBeInvalid");
function QT(e) {
  be(e, QT, this);
  let t = !Sj(e);
  return {
    pass: t,
    message: /* @__PURE__ */ o(() => {
      let r = t ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeValid`,
          "element",
          ""
        ),
        "",
        `Received element ${r} currently valid:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(QT, "toBeValid");
function e_(e, t) {
  if (be(e, e_, this), e.tagName.toLowerCase() === "input" && ["checkbox", "radio"].includes(e.type))
    throw new Error(
      "input with type=checkbox or type=radio cannot be used with .toHaveValue(). Use .toBeChecked() for type=checkbox or .toHaveFormValues(\
) instead"
    );
  let r = vj(e), n = t !== void 0, i = t, s = r;
  return t == r && t !== r && (i = `${t} (${typeof t})`, s = `${r} (${typeof r})`), {
    pass: n ? (0, gp.default)(r, t, FT) : !!r,
    message: /* @__PURE__ */ o(() => {
      let a = this.isNot ? "not to" : "to", l = this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toHaveValue`,
        "element",
        t
      );
      return et(
        this,
        l,
        `Expected the element ${a} have value`,
        n ? i : "(any)",
        "Received",
        s
      );
    }, "message")
  };
}
o(e_, "toHaveValue");
function t_(e, t) {
  be(e, t_, this);
  let r = e.tagName.toLowerCase();
  if (!["select", "input", "textarea"].includes(r))
    throw new Error(
      ".toHaveDisplayValue() currently supports only input, textarea or select elements, try with another matcher instead."
    );
  if (r === "input" && ["radio", "checkbox"].includes(e.type))
    throw new Error(
      `.toHaveDisplayValue() currently does not support input[type="${e.type}"], try with another matcher instead.`
    );
  let n = Sse(r, e), i = xse(t), s = i.filter(
    (u) => n.some(
      (c) => u instanceof RegExp ? u.test(c) : this.equals(c, String(u))
    )
  ).length, a = s === n.length, l = s === i.length;
  return {
    pass: a && l,
    message: /* @__PURE__ */ o(() => et(
      this,
      this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toHaveDisplayValue`,
        "element",
        ""
      ),
      `Expected element ${this.isNot ? "not " : ""}to have display value`,
      t,
      "Received",
      n
    ), "message")
  };
}
o(t_, "toHaveDisplayValue");
function Sse(e, t) {
  return e === "select" ? Array.from(t).filter((r) => r.selected).map((r) => r.textContent) : [t.value];
}
o(Sse, "getValues");
function xse(e) {
  return e instanceof Array ? e : [e];
}
o(xse, "getExpectedValues");
function r_(e) {
  be(e, r_, this);
  let t = /* @__PURE__ */ o(() => e.tagName.toLowerCase() === "input" && ["checkbox", "radio"].includes(e.type), "isValidInput"), r = /* @__PURE__ */ o(
  () => xj(e.getAttribute("role")) && ["true", "false"].includes(e.getAttribute("aria-checked")), "isValidAriaElement");
  if (!t() && !r())
    return {
      pass: !1,
      message: /* @__PURE__ */ o(() => `only inputs with type="checkbox" or type="radio" or elements with ${Cse()} and a valid aria-checked \
attribute can be used with .toBeChecked(). Use .toHaveValue() instead`, "message")
    };
  let n = /* @__PURE__ */ o(() => t() ? e.checked : e.getAttribute("aria-checked") === "true", "isChecked");
  return {
    pass: n(),
    message: /* @__PURE__ */ o(() => {
      let i = n() ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBeChecked`,
          "element",
          ""
        ),
        "",
        `Received element ${i} checked:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(r_, "toBeChecked");
function Cse() {
  return Gie(
    Pse().map((e) => `role="${e}"`),
    { lastWordConnector: " or " }
  );
}
o(Cse, "supportedRolesSentence");
function Pse() {
  return Bs.roles.keys().filter(xj);
}
o(Pse, "supportedRoles");
function xj(e) {
  return Bs.roles.get(e)?.props["aria-checked"] !== void 0;
}
o(xj, "roleSupportsChecked");
function n_(e) {
  be(e, n_, this);
  let t = /* @__PURE__ */ o(() => e.tagName.toLowerCase() === "input" && e.type === "checkbox", "isValidInput"), r = /* @__PURE__ */ o(() => e.
  getAttribute("role") === "checkbox", "isValidAriaElement");
  if (!t() && !r())
    return {
      pass: !1,
      message: /* @__PURE__ */ o(() => 'only inputs with type="checkbox" or elements with role="checkbox" and a valid aria-checked attribute\
 can be used with .toBePartiallyChecked(). Use .toHaveValue() instead', "message")
    };
  let n = /* @__PURE__ */ o(() => {
    let i = e.getAttribute("aria-checked") === "mixed";
    return t() && e.indeterminate || i;
  }, "isPartiallyChecked");
  return {
    pass: n(),
    message: /* @__PURE__ */ o(() => {
      let i = n() ? "is" : "is not";
      return [
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toBePartiallyChecked`,
          "element",
          ""
        ),
        "",
        `Received element ${i} partially checked:`,
        `  ${this.utils.printReceived(e.cloneNode(!1))}`
      ].join(`
`);
    }, "message")
  };
}
o(n_, "toBePartiallyChecked");
function o_(e, t) {
  vp(
    "toHaveDescription",
    "Please use toHaveAccessibleDescription."
  ), be(e, o_, this);
  let r = t !== void 0, i = (e.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean), s = "";
  if (i.length > 0) {
    let a = e.ownerDocument, l = i.map((u) => a.getElementById(u)).filter(Boolean);
    s = Ep(l.map((u) => u.textContent).join(" "));
  }
  return {
    pass: r ? t instanceof RegExp ? t.test(s) : this.equals(s, t) : !!s,
    message: /* @__PURE__ */ o(() => {
      let a = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toHaveDescription`,
          "element",
          ""
        ),
        `Expected the element ${a} have description`,
        this.utils.printExpected(t),
        "Received",
        this.utils.printReceived(s)
      );
    }, "message")
  };
}
o(o_, "toHaveDescription");
function i_(e, t) {
  if (vp("toHaveErrorMessage", "Please use toHaveAccessibleErrorMessage."), be(e, i_, this), !e.hasAttribute("aria-invalid") || e.getAttribute(
  "aria-invalid") === "false") {
    let a = this.isNot ? ".not" : "";
    return {
      pass: !1,
      message: /* @__PURE__ */ o(() => et(
        this,
        this.utils.matcherHint(`${a}.toHaveErrorMessage`, "element", ""),
        "Expected the element to have invalid state indicated by",
        'aria-invalid="true"',
        "Received",
        e.hasAttribute("aria-invalid") ? `aria-invalid="${e.getAttribute("aria-invalid")}"` : this.utils.printReceived("")
      ), "message")
    };
  }
  let r = t !== void 0, i = (e.getAttribute("aria-errormessage") || "").split(/\s+/).filter(Boolean), s = "";
  if (i.length > 0) {
    let a = e.ownerDocument, l = i.map((u) => a.getElementById(u)).filter(Boolean);
    s = Ep(
      l.map((u) => u.textContent).join(" ")
    );
  }
  return {
    pass: r ? t instanceof RegExp ? t.test(s) : this.equals(s, t) : !!s,
    message: /* @__PURE__ */ o(() => {
      let a = this.isNot ? "not to" : "to";
      return et(
        this,
        this.utils.matcherHint(
          `${this.isNot ? ".not" : ""}.toHaveErrorMessage`,
          "element",
          ""
        ),
        `Expected the element ${a} have error message`,
        this.utils.printExpected(t),
        "Received",
        this.utils.printReceived(s)
      );
    }, "message")
  };
}
o(i_, "toHaveErrorMessage");
function Ase(e) {
  let t = e.ownerDocument.getSelection();
  if (["input", "textarea"].includes(e.tagName.toLowerCase()))
    return ["radio", "checkbox"].includes(e.type) ? "" : e.value.toString().substring(e.selectionStart, e.selectionEnd);
  if (t.anchorNode === null || t.focusNode === null)
    return "";
  let r = t.getRangeAt(0), n = e.ownerDocument.createRange();
  if (t.containsNode(e, !1))
    n.selectNodeContents(e), t.removeAllRanges(), t.addRange(n);
  else if (!(e.contains(t.anchorNode) && e.contains(t.focusNode))) {
    let s = e === r.startContainer || e.contains(r.startContainer), a = e === r.endContainer || e.contains(r.endContainer);
    t.removeAllRanges(), (s || a) && (n.selectNodeContents(e), s && n.setStart(
      r.startContainer,
      r.startOffset
    ), a && n.setEnd(
      r.endContainer,
      r.endOffset
    ), t.addRange(n));
  }
  let i = t.toString();
  return t.removeAllRanges(), t.addRange(r), i;
}
o(Ase, "getSelection");
function s_(e, t) {
  be(e, s_, this);
  let r = t !== void 0;
  if (r && typeof t != "string")
    throw new Error("expected selection must be a string or undefined");
  let n = Ase(e);
  return {
    pass: r ? (0, gp.default)(n, t, FT) : !!n,
    message: /* @__PURE__ */ o(() => {
      let i = this.isNot ? "not to" : "to", s = this.utils.matcherHint(
        `${this.isNot ? ".not" : ""}.toHaveSelection`,
        "element",
        t
      );
      return et(
        this,
        s,
        `Expected the element ${i} have selection`,
        r ? t : "(any)",
        "Received",
        n
      );
    }, "message")
  };
}
o(s_, "toHaveSelection");

// ../node_modules/@testing-library/jest-dom/dist/matchers.mjs
var Nke = De(AE(), 1);
var Fke = De(rT(), 1), kke = De(pT(), 1), Dke = De(IT(), 1), $ke = De(NT(), 1);

// ../node_modules/@vitest/expect/node_modules/@vitest/pretty-format/dist/index.js
function Dj(e, t) {
  return t.forEach(function(r) {
    r && typeof r != "string" && !Array.isArray(r) && Object.keys(r).forEach(function(n) {
      if (n !== "default" && !(n in e)) {
        var i = Object.getOwnPropertyDescriptor(r, n);
        Object.defineProperty(e, n, i.get ? i : {
          enumerable: !0,
          get: /* @__PURE__ */ o(function() {
            return r[n];
          }, "get")
        });
      }
    });
  }), Object.freeze(e);
}
o(Dj, "_mergeNamespaces");
function Ose(e, t) {
  let r = Object.keys(e), n = t === null ? r : r.sort(t);
  if (Object.getOwnPropertySymbols)
    for (let i of Object.getOwnPropertySymbols(e))
      Object.getOwnPropertyDescriptor(e, i).enumerable && n.push(i);
  return n;
}
o(Ose, "getKeysOfEnumerableProperties");
function Hs(e, t, r, n, i, s, a = ": ") {
  let l = "", u = 0, c = e.next();
  if (!c.done) {
    l += t.spacingOuter;
    let d = r + t.indent;
    for (; !c.done; ) {
      if (l += d, u++ === t.maxWidth) {
        l += "\u2026";
        break;
      }
      let p = s(
        c.value[0],
        t,
        d,
        n,
        i
      ), y = s(
        c.value[1],
        t,
        d,
        n,
        i
      );
      l += p + a + y, c = e.next(), c.done ? t.min || (l += ",") : l += `,${t.spacingInner}`;
    }
    l += t.spacingOuter + r;
  }
  return l;
}
o(Hs, "printIteratorEntries");
function y_(e, t, r, n, i, s) {
  let a = "", l = 0, u = e.next();
  if (!u.done) {
    a += t.spacingOuter;
    let c = r + t.indent;
    for (; !u.done; ) {
      if (a += c, l++ === t.maxWidth) {
        a += "\u2026";
        break;
      }
      a += s(u.value, t, c, n, i), u = e.next(), u.done ? t.min || (a += ",") : a += `,${t.spacingInner}`;
    }
    a += t.spacingOuter + r;
  }
  return a;
}
o(y_, "printIteratorValues");
function Rp(e, t, r, n, i, s) {
  let a = "";
  e = e instanceof ArrayBuffer ? new DataView(e) : e;
  let l = /* @__PURE__ */ o((c) => c instanceof DataView, "isDataView"), u = l(e) ? e.byteLength : e.length;
  if (u > 0) {
    a += t.spacingOuter;
    let c = r + t.indent;
    for (let d = 0; d < u; d++) {
      if (a += c, d === t.maxWidth) {
        a += "\u2026";
        break;
      }
      (l(e) || d in e) && (a += s(
        l(e) ? e.getInt8(d) : e[d],
        t,
        c,
        n,
        i
      )), d < u - 1 ? a += `,${t.spacingInner}` : t.min || (a += ",");
    }
    a += t.spacingOuter + r;
  }
  return a;
}
o(Rp, "printListItems");
function b_(e, t, r, n, i, s) {
  let a = "", l = Ose(e, t.compareKeys);
  if (l.length > 0) {
    a += t.spacingOuter;
    let u = r + t.indent;
    for (let c = 0; c < l.length; c++) {
      let d = l[c], p = s(d, t, u, n, i), y = s(e[d], t, u, n, i);
      a += `${u + p}: ${y}`, c < l.length - 1 ? a += `,${t.spacingInner}` : t.min || (a += ",");
    }
    a += t.spacingOuter + r;
  }
  return a;
}
o(b_, "printObjectProperties");
var qse = typeof Symbol == "function" && Symbol.for ? Symbol.for("jest.asymmetricMatcher") : 1267621, Tp = " ", Ise = /* @__PURE__ */ o((e, t, r, n, i, s) => {
  let a = e.toString();
  if (a === "ArrayContaining" || a === "ArrayNotContaining")
    return ++n > t.maxDepth ? `[${a}]` : `${a + Tp}[${Rp(
      e.sample,
      t,
      r,
      n,
      i,
      s
    )}]`;
  if (a === "ObjectContaining" || a === "ObjectNotContaining")
    return ++n > t.maxDepth ? `[${a}]` : `${a + Tp}{${b_(
      e.sample,
      t,
      r,
      n,
      i,
      s
    )}}`;
  if (a === "StringMatching" || a === "StringNotMatching" || a === "StringContaining" || a === "StringNotContaining")
    return a + Tp + s(e.sample, t, r, n, i);
  if (typeof e.toAsymmetricMatcher != "function")
    throw new TypeError(
      `Asymmetric matcher ${e.constructor.name} does not implement toAsymmetricMatcher()`
    );
  return e.toAsymmetricMatcher();
}, "serialize$5"), Mse = /* @__PURE__ */ o((e) => e && e.$$typeof === qse, "test$5"), Nse = { serialize: Ise, test: Mse }, jse = " ", $j = /* @__PURE__ */ new Set(
["DOMStringMap", "NamedNodeMap"]), Lse = /^(?:HTML\w*Collection|NodeList)$/;
function Fse(e) {
  return $j.has(e) || Lse.test(e);
}
o(Fse, "testName");
var kse = /* @__PURE__ */ o((e) => e && e.constructor && !!e.constructor.name && Fse(e.constructor.name), "test$4");
function Dse(e) {
  return e.constructor.name === "NamedNodeMap";
}
o(Dse, "isNamedNodeMap");
var $se = /* @__PURE__ */ o((e, t, r, n, i, s) => {
  let a = e.constructor.name;
  return ++n > t.maxDepth ? `[${a}]` : (t.min ? "" : a + jse) + ($j.has(a) ? `{${b_(
    Dse(e) ? [...e].reduce(
      (l, u) => (l[u.name] = u.value, l),
      {}
    ) : { ...e },
    t,
    r,
    n,
    i,
    s
  )}}` : `[${Rp(
    [...e],
    t,
    r,
    n,
    i,
    s
  )}]`);
}, "serialize$4"), Bse = { serialize: $se, test: kse };
function Bj(e) {
  return e.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
o(Bj, "escapeHTML");
function g_(e, t, r, n, i, s, a) {
  let l = n + r.indent, u = r.colors;
  return e.map((c) => {
    let d = t[c], p = a(d, r, l, i, s);
    return typeof d != "string" && (p.includes(`
`) && (p = r.spacingOuter + l + p + r.spacingOuter + n), p = `{${p}}`), `${r.spacingInner + n + u.prop.open + c + u.prop.close}=${u.value.open}${p}${u.
    value.close}`;
  }).join("");
}
o(g_, "printProps");
function v_(e, t, r, n, i, s) {
  return e.map(
    (a) => t.spacingOuter + r + (typeof a == "string" ? Uj(a, t) : s(a, t, r, n, i))
  ).join("");
}
o(v_, "printChildren");
function Uj(e, t) {
  let r = t.colors.content;
  return r.open + Bj(e) + r.close;
}
o(Uj, "printText");
function Use(e, t) {
  let r = t.colors.comment;
  return `${r.open}<!--${Bj(e)}-->${r.close}`;
}
o(Use, "printComment");
function E_(e, t, r, n, i) {
  let s = n.colors.tag;
  return `${s.open}<${e}${t && s.close + t + n.spacingOuter + i + s.open}${r ? `>${s.close}${r}${n.spacingOuter}${i}${s.open}</${e}` : `${t &&
  !n.min ? "" : " "}/`}>${s.close}`;
}
o(E_, "printElement");
function T_(e, t) {
  let r = t.colors.tag;
  return `${r.open}<${e}${r.close} \u2026${r.open} />${r.close}`;
}
o(T_, "printElementAsLeaf");
var Hse = 1, Hj = 3, Vj = 8, zj = 11, Vse = /^(?:(?:HTML|SVG)\w*)?Element$/;
function zse(e) {
  try {
    return typeof e.hasAttribute == "function" && e.hasAttribute("is");
  } catch {
    return !1;
  }
}
o(zse, "testHasAttribute");
function Gse(e) {
  let t = e.constructor.name, { nodeType: r, tagName: n } = e, i = typeof n == "string" && n.includes("-") || zse(e);
  return r === Hse && (Vse.test(t) || i) || r === Hj && t === "Text" || r === Vj && t === "Comment" || r === zj && t === "DocumentFragment";
}
o(Gse, "testNode");
var Yse = /* @__PURE__ */ o((e) => {
  var t;
  return ((t = e?.constructor) == null ? void 0 : t.name) && Gse(e);
}, "test$3");
function Wse(e) {
  return e.nodeType === Hj;
}
o(Wse, "nodeIsText");
function Kse(e) {
  return e.nodeType === Vj;
}
o(Kse, "nodeIsComment");
function p_(e) {
  return e.nodeType === zj;
}
o(p_, "nodeIsFragment");
var Xse = /* @__PURE__ */ o((e, t, r, n, i, s) => {
  if (Wse(e))
    return Uj(e.data, t);
  if (Kse(e))
    return Use(e.data, t);
  let a = p_(e) ? "DocumentFragment" : e.tagName.toLowerCase();
  return ++n > t.maxDepth ? T_(a, t) : E_(
    a,
    g_(
      p_(e) ? [] : Array.from(e.attributes, (l) => l.name).sort(),
      p_(e) ? {} : [...e.attributes].reduce(
        (l, u) => (l[u.name] = u.value, l),
        {}
      ),
      t,
      r + t.indent,
      n,
      i,
      s
    ),
    v_(
      Array.prototype.slice.call(e.childNodes || e.children),
      t,
      r + t.indent,
      n,
      i,
      s
    ),
    t,
    r
  );
}, "serialize$3"), Jse = { serialize: Xse, test: Yse }, Zse = "@@__IMMUTABLE_ITERABLE__@@", Qse = "@@__IMMUTABLE_LIST__@@", eae = "@@__IMMUT\
ABLE_KEYED__@@", tae = "@@__IMMUTABLE_MAP__@@", Cj = "@@__IMMUTABLE_ORDERED__@@", rae = "@@__IMMUTABLE_RECORD__@@", nae = "@@__IMMUTABLE_SEQ\
__@@", oae = "@@__IMMUTABLE_SET__@@", iae = "@@__IMMUTABLE_STACK__@@", ti = /* @__PURE__ */ o((e) => `Immutable.${e}`, "getImmutableName"), Sp = /* @__PURE__ */ o(
(e) => `[${e}]`, "printAsLeaf"), Us = " ", Pj = "\u2026";
function sae(e, t, r, n, i, s, a) {
  return ++n > t.maxDepth ? Sp(ti(a)) : `${ti(a) + Us}{${Hs(
    e.entries(),
    t,
    r,
    n,
    i,
    s
  )}}`;
}
o(sae, "printImmutableEntries");
function aae(e) {
  let t = 0;
  return {
    next() {
      if (t < e._keys.length) {
        let r = e._keys[t++];
        return { done: !1, value: [r, e.get(r)] };
      }
      return { done: !0, value: void 0 };
    }
  };
}
o(aae, "getRecordEntries");
function lae(e, t, r, n, i, s) {
  let a = ti(e._name || "Record");
  return ++n > t.maxDepth ? Sp(a) : `${a + Us}{${Hs(
    aae(e),
    t,
    r,
    n,
    i,
    s
  )}}`;
}
o(lae, "printImmutableRecord");
function uae(e, t, r, n, i, s) {
  let a = ti("Seq");
  return ++n > t.maxDepth ? Sp(a) : e[eae] ? `${a + Us}{${// from Immutable collection of entries or from ECMAScript object
  e._iter || e._object ? Hs(
    e.entries(),
    t,
    r,
    n,
    i,
    s
  ) : Pj}}` : `${a + Us}[${e._iter || e._array || e._collection || e._iterable ? y_(
    e.values(),
    t,
    r,
    n,
    i,
    s
  ) : Pj}]`;
}
o(uae, "printImmutableSeq");
function f_(e, t, r, n, i, s, a) {
  return ++n > t.maxDepth ? Sp(ti(a)) : `${ti(a) + Us}[${y_(
    e.values(),
    t,
    r,
    n,
    i,
    s
  )}]`;
}
o(f_, "printImmutableValues");
var cae = /* @__PURE__ */ o((e, t, r, n, i, s) => e[tae] ? sae(
  e,
  t,
  r,
  n,
  i,
  s,
  e[Cj] ? "OrderedMap" : "Map"
) : e[Qse] ? f_(
  e,
  t,
  r,
  n,
  i,
  s,
  "List"
) : e[oae] ? f_(
  e,
  t,
  r,
  n,
  i,
  s,
  e[Cj] ? "OrderedSet" : "Set"
) : e[iae] ? f_(
  e,
  t,
  r,
  n,
  i,
  s,
  "Stack"
) : e[nae] ? uae(e, t, r, n, i, s) : lae(e, t, r, n, i, s), "serialize$2"), dae = /* @__PURE__ */ o((e) => e && (e[Zse] === !0 || e[rae] ===
!0), "test$2"), pae = { serialize: cae, test: dae };
function Gj(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
o(Gj, "getDefaultExportFromCjs");
var m_ = { exports: {} }, _e = {};
var Aj;
function fae() {
  if (Aj) return _e;
  Aj = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.\
strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.fo\
rward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.la\
zy"), y = Symbol.for("react.offscreen"), f = Symbol.for("react.client.reference");
  function m(h) {
    if (typeof h == "object" && h !== null) {
      var b = h.$$typeof;
      switch (b) {
        case e:
          switch (h = h.type, h) {
            case r:
            case i:
            case n:
            case u:
            case c:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case a:
                case l:
                case p:
                case d:
                  return h;
                case s:
                  return h;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return o(m, "typeOf"), _e.ContextConsumer = s, _e.ContextProvider = a, _e.Element = e, _e.ForwardRef = l, _e.Fragment = r, _e.Lazy = p, _e.
  Memo = d, _e.Portal = t, _e.Profiler = i, _e.StrictMode = n, _e.Suspense = u, _e.SuspenseList = c, _e.isContextConsumer = function(h) {
    return m(h) === s;
  }, _e.isContextProvider = function(h) {
    return m(h) === a;
  }, _e.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, _e.isForwardRef = function(h) {
    return m(h) === l;
  }, _e.isFragment = function(h) {
    return m(h) === r;
  }, _e.isLazy = function(h) {
    return m(h) === p;
  }, _e.isMemo = function(h) {
    return m(h) === d;
  }, _e.isPortal = function(h) {
    return m(h) === t;
  }, _e.isProfiler = function(h) {
    return m(h) === i;
  }, _e.isStrictMode = function(h) {
    return m(h) === n;
  }, _e.isSuspense = function(h) {
    return m(h) === u;
  }, _e.isSuspenseList = function(h) {
    return m(h) === c;
  }, _e.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === i || h === n || h === u || h === c || h === y || typeof h == "\
object" && h !== null && (h.$$typeof === p || h.$$typeof === d || h.$$typeof === a || h.$$typeof === s || h.$$typeof === l || h.$$typeof ===
    f || h.getModuleId !== void 0);
  }, _e.typeOf = m, _e;
}
o(fae, "requireReactIs_production");
var Oj;
function mae() {
  return Oj || (Oj = 1, m_.exports = fae()), m_.exports;
}
o(mae, "requireReactIs$1");
var Yj = /* @__PURE__ */ mae(), hae = /* @__PURE__ */ Gj(Yj), yae = /* @__PURE__ */ Dj({
  __proto__: null,
  default: hae
}, [Yj]), h_ = { exports: {} }, ge = {};
var qj;
function bae() {
  if (qj) return ge;
  qj = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"),
  i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"),
  u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"),
  y = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function h(b) {
    if (typeof b == "object" && b !== null) {
      var g = b.$$typeof;
      switch (g) {
        case e:
          switch (b = b.type, b) {
            case r:
            case i:
            case n:
            case c:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case l:
                case a:
                case u:
                case y:
                case p:
                case s:
                  return b;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  return o(h, "v"), ge.ContextConsumer = a, ge.ContextProvider = s, ge.Element = e, ge.ForwardRef = u, ge.Fragment = r, ge.Lazy = y, ge.Memo =
  p, ge.Portal = t, ge.Profiler = i, ge.StrictMode = n, ge.Suspense = c, ge.SuspenseList = d, ge.isAsyncMode = function() {
    return !1;
  }, ge.isConcurrentMode = function() {
    return !1;
  }, ge.isContextConsumer = function(b) {
    return h(b) === a;
  }, ge.isContextProvider = function(b) {
    return h(b) === s;
  }, ge.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, ge.isForwardRef = function(b) {
    return h(b) === u;
  }, ge.isFragment = function(b) {
    return h(b) === r;
  }, ge.isLazy = function(b) {
    return h(b) === y;
  }, ge.isMemo = function(b) {
    return h(b) === p;
  }, ge.isPortal = function(b) {
    return h(b) === t;
  }, ge.isProfiler = function(b) {
    return h(b) === i;
  }, ge.isStrictMode = function(b) {
    return h(b) === n;
  }, ge.isSuspense = function(b) {
    return h(b) === c;
  }, ge.isSuspenseList = function(b) {
    return h(b) === d;
  }, ge.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === i || b === n || b === c || b === d || b === f || typeof b == "\
object" && b !== null && (b.$$typeof === y || b.$$typeof === p || b.$$typeof === s || b.$$typeof === a || b.$$typeof === u || b.$$typeof ===
    m || b.getModuleId !== void 0);
  }, ge.typeOf = h, ge;
}
o(bae, "requireReactIs_production_min");
var Ij;
function gae() {
  return Ij || (Ij = 1, h_.exports = bae()), h_.exports;
}
o(gae, "requireReactIs");
var Wj = gae(), vae = /* @__PURE__ */ Gj(Wj), Eae = /* @__PURE__ */ Dj({
  __proto__: null,
  default: vae
}, [Wj]), Tae = [
  "isAsyncMode",
  "isConcurrentMode",
  "isContextConsumer",
  "isContextProvider",
  "isElement",
  "isForwardRef",
  "isFragment",
  "isLazy",
  "isMemo",
  "isPortal",
  "isProfiler",
  "isStrictMode",
  "isSuspense",
  "isSuspenseList",
  "isValidElementType"
], Ln = Object.fromEntries(
  Tae.map((e) => [e, (t) => Eae[e](t) || yae[e](t)])
);
function Kj(e, t = []) {
  if (Array.isArray(e))
    for (let r of e)
      Kj(r, t);
  else e != null && e !== !1 && e !== "" && t.push(e);
  return t;
}
o(Kj, "getChildren");
function Mj(e) {
  let t = e.type;
  if (typeof t == "string")
    return t;
  if (typeof t == "function")
    return t.displayName || t.name || "Unknown";
  if (Ln.isFragment(e))
    return "React.Fragment";
  if (Ln.isSuspense(e))
    return "React.Suspense";
  if (typeof t == "object" && t !== null) {
    if (Ln.isContextProvider(e))
      return "Context.Provider";
    if (Ln.isContextConsumer(e))
      return "Context.Consumer";
    if (Ln.isForwardRef(e)) {
      if (t.displayName)
        return t.displayName;
      let r = t.render.displayName || t.render.name || "";
      return r === "" ? "ForwardRef" : `ForwardRef(${r})`;
    }
    if (Ln.isMemo(e)) {
      let r = t.displayName || t.type.displayName || t.type.name || "";
      return r === "" ? "Memo" : `Memo(${r})`;
    }
  }
  return "UNDEFINED";
}
o(Mj, "getType");
function _ae(e) {
  let { props: t } = e;
  return Object.keys(t).filter((r) => r !== "children" && t[r] !== void 0).sort();
}
o(_ae, "getPropKeys$1");
var Rae = /* @__PURE__ */ o((e, t, r, n, i, s) => ++n > t.maxDepth ? T_(Mj(e), t) : E_(
  Mj(e),
  g_(
    _ae(e),
    e.props,
    t,
    r + t.indent,
    n,
    i,
    s
  ),
  v_(
    Kj(e.props.children),
    t,
    r + t.indent,
    n,
    i,
    s
  ),
  t,
  r
), "serialize$1"), wae = /* @__PURE__ */ o((e) => e != null && Ln.isElement(e), "test$1"), Sae = { serialize: Rae, test: wae }, xae = typeof Symbol ==
"function" && Symbol.for ? Symbol.for("react.test.json") : 245830487;
function Cae(e) {
  let { props: t } = e;
  return t ? Object.keys(t).filter((r) => t[r] !== void 0).sort() : [];
}
o(Cae, "getPropKeys");
var Pae = /* @__PURE__ */ o((e, t, r, n, i, s) => ++n > t.maxDepth ? T_(e.type, t) : E_(
  e.type,
  e.props ? g_(
    Cae(e),
    e.props,
    t,
    r + t.indent,
    n,
    i,
    s
  ) : "",
  e.children ? v_(
    e.children,
    t,
    r + t.indent,
    n,
    i,
    s
  ) : "",
  t,
  r
), "serialize"), Aae = /* @__PURE__ */ o((e) => e && e.$$typeof === xae, "test"), Oae = { serialize: Pae, test: Aae }, Xj = Object.prototype.
toString, qae = Date.prototype.toISOString, Iae = Error.prototype.toString, Nj = RegExp.prototype.toString;
function _p(e) {
  return typeof e.constructor == "function" && e.constructor.name || "Object";
}
o(_p, "getConstructorName");
function Mae(e) {
  return typeof window < "u" && e === window;
}
o(Mae, "isWindow");
var Nae = /^Symbol\((.*)\)(.*)$/, jae = /\n/g, R_ = class R_ extends Error {
  constructor(t, r) {
    super(t), this.stack = r, this.name = this.constructor.name;
  }
};
o(R_, "PrettyFormatPluginError");
var wp = R_;
function Lae(e) {
  return e === "[object Array]" || e === "[object ArrayBuffer]" || e === "[object DataView]" || e === "[object Float32Array]" || e === "[obj\
ect Float64Array]" || e === "[object Int8Array]" || e === "[object Int16Array]" || e === "[object Int32Array]" || e === "[object Uint8Array]" ||
  e === "[object Uint8ClampedArray]" || e === "[object Uint16Array]" || e === "[object Uint32Array]";
}
o(Lae, "isToStringedArrayType");
function Fae(e) {
  return Object.is(e, -0) ? "-0" : String(e);
}
o(Fae, "printNumber");
function kae(e) {
  return `${e}n`;
}
o(kae, "printBigInt");
function jj(e, t) {
  return t ? `[Function ${e.name || "anonymous"}]` : "[Function]";
}
o(jj, "printFunction");
function Lj(e) {
  return String(e).replace(Nae, "Symbol($1)");
}
o(Lj, "printSymbol");
function Fj(e) {
  return `[${Iae.call(e)}]`;
}
o(Fj, "printError");
function Jj(e, t, r, n) {
  if (e === !0 || e === !1)
    return `${e}`;
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  let i = typeof e;
  if (i === "number")
    return Fae(e);
  if (i === "bigint")
    return kae(e);
  if (i === "string")
    return n ? `"${e.replaceAll(/"|\\/g, "\\$&")}"` : `"${e}"`;
  if (i === "function")
    return jj(e, t);
  if (i === "symbol")
    return Lj(e);
  let s = Xj.call(e);
  return s === "[object WeakMap]" ? "WeakMap {}" : s === "[object WeakSet]" ? "WeakSet {}" : s === "[object Function]" || s === "[object Gen\
eratorFunction]" ? jj(e, t) : s === "[object Symbol]" ? Lj(e) : s === "[object Date]" ? Number.isNaN(+e) ? "Date { NaN }" : qae.call(e) : s ===
  "[object Error]" ? Fj(e) : s === "[object RegExp]" ? r ? Nj.call(e).replaceAll(/[$()*+.?[\\\]^{|}]/g, "\\$&") : Nj.call(e) : e instanceof Error ?
  Fj(e) : null;
}
o(Jj, "printBasicValue");
function Zj(e, t, r, n, i, s) {
  if (i.includes(e))
    return "[Circular]";
  i = [...i], i.push(e);
  let a = ++n > t.maxDepth, l = t.min;
  if (t.callToJSON && !a && e.toJSON && typeof e.toJSON == "function" && !s)
    return Kr(e.toJSON(), t, r, n, i, !0);
  let u = Xj.call(e);
  return u === "[object Arguments]" ? a ? "[Arguments]" : `${l ? "" : "Arguments "}[${Rp(
    e,
    t,
    r,
    n,
    i,
    Kr
  )}]` : Lae(u) ? a ? `[${e.constructor.name}]` : `${l || !t.printBasicPrototype && e.constructor.name === "Array" ? "" : `${e.constructor.name}\
 `}[${Rp(e, t, r, n, i, Kr)}]` : u === "[object Map]" ? a ? "[Map]" : `Map {${Hs(
    e.entries(),
    t,
    r,
    n,
    i,
    Kr,
    " => "
  )}}` : u === "[object Set]" ? a ? "[Set]" : `Set {${y_(
    e.values(),
    t,
    r,
    n,
    i,
    Kr
  )}}` : a || Mae(e) ? `[${_p(e)}]` : `${l || !t.printBasicPrototype && _p(e) === "Object" ? "" : `${_p(e)} `}{${b_(
    e,
    t,
    r,
    n,
    i,
    Kr
  )}}`;
}
o(Zj, "printComplexValue");
var Dae = {
  test: /* @__PURE__ */ o((e) => e && e instanceof Error, "test"),
  serialize(e, t, r, n, i, s) {
    if (i.includes(e))
      return "[Circular]";
    i = [...i, e];
    let a = ++n > t.maxDepth, { message: l, cause: u, ...c } = e, d = {
      message: l,
      ...typeof u < "u" ? { cause: u } : {},
      ...e instanceof AggregateError ? { errors: e.errors } : {},
      ...c
    }, p = e.name !== "Error" ? e.name : _p(e);
    return a ? `[${p}]` : `${p} {${Hs(
      Object.entries(d).values(),
      t,
      r,
      n,
      i,
      s
    )}}`;
  }
};
function $ae(e) {
  return e.serialize != null;
}
o($ae, "isNewPlugin");
function Qj(e, t, r, n, i, s) {
  let a;
  try {
    a = $ae(e) ? e.serialize(t, r, n, i, s, Kr) : e.print(
      t,
      (l) => Kr(l, r, n, i, s),
      (l) => {
        let u = n + r.indent;
        return u + l.replaceAll(jae, `
${u}`);
      },
      {
        edgeSpacing: r.spacingOuter,
        min: r.min,
        spacing: r.spacingInner
      },
      r.colors
    );
  } catch (l) {
    throw new wp(l.message, l.stack);
  }
  if (typeof a != "string")
    throw new TypeError(
      `pretty-format: Plugin must return type "string" but instead returned "${typeof a}".`
    );
  return a;
}
o(Qj, "printPlugin");
function eL(e, t) {
  for (let r of e)
    try {
      if (r.test(t))
        return r;
    } catch (n) {
      throw new wp(n.message, n.stack);
    }
  return null;
}
o(eL, "findPlugin");
function Kr(e, t, r, n, i, s) {
  let a = eL(t.plugins, e);
  if (a !== null)
    return Qj(a, e, t, r, n, i);
  let l = Jj(
    e,
    t.printFunctionName,
    t.escapeRegex,
    t.escapeString
  );
  return l !== null ? l : Zj(
    e,
    t,
    r,
    n,
    i,
    s
  );
}
o(Kr, "printer");
var __ = {
  comment: "gray",
  content: "reset",
  prop: "yellow",
  tag: "cyan",
  value: "green"
}, tL = Object.keys(__), Wt = {
  callToJSON: !0,
  compareKeys: void 0,
  escapeRegex: !1,
  escapeString: !0,
  highlight: !1,
  indent: 2,
  maxDepth: Number.POSITIVE_INFINITY,
  maxWidth: Number.POSITIVE_INFINITY,
  min: !1,
  plugins: [],
  printBasicPrototype: !0,
  printFunctionName: !0,
  theme: __
};
function Bae(e) {
  for (let t of Object.keys(e))
    if (!Object.prototype.hasOwnProperty.call(Wt, t))
      throw new Error(`pretty-format: Unknown option "${t}".`);
  if (e.min && e.indent !== void 0 && e.indent !== 0)
    throw new Error(
      'pretty-format: Options "min" and "indent" cannot be used together.'
    );
}
o(Bae, "validateOptions");
function Uae() {
  return tL.reduce((e, t) => {
    let r = __[t], n = r && ae[r];
    if (n && typeof n.close == "string" && typeof n.open == "string")
      e[t] = n;
    else
      throw new Error(
        `pretty-format: Option "theme" has a key "${t}" whose value "${r}" is undefined in ansi-styles.`
      );
    return e;
  }, /* @__PURE__ */ Object.create(null));
}
o(Uae, "getColorsHighlight");
function Hae() {
  return tL.reduce((e, t) => (e[t] = { close: "", open: "" }, e), /* @__PURE__ */ Object.create(null));
}
o(Hae, "getColorsEmpty");
function rL(e) {
  return e?.printFunctionName ?? Wt.printFunctionName;
}
o(rL, "getPrintFunctionName");
function nL(e) {
  return e?.escapeRegex ?? Wt.escapeRegex;
}
o(nL, "getEscapeRegex");
function oL(e) {
  return e?.escapeString ?? Wt.escapeString;
}
o(oL, "getEscapeString");
function kj(e) {
  return {
    callToJSON: e?.callToJSON ?? Wt.callToJSON,
    colors: e?.highlight ? Uae() : Hae(),
    compareKeys: typeof e?.compareKeys == "function" || e?.compareKeys === null ? e.compareKeys : Wt.compareKeys,
    escapeRegex: nL(e),
    escapeString: oL(e),
    indent: e?.min ? "" : Vae(e?.indent ?? Wt.indent),
    maxDepth: e?.maxDepth ?? Wt.maxDepth,
    maxWidth: e?.maxWidth ?? Wt.maxWidth,
    min: e?.min ?? Wt.min,
    plugins: e?.plugins ?? Wt.plugins,
    printBasicPrototype: e?.printBasicPrototype ?? !0,
    printFunctionName: rL(e),
    spacingInner: e?.min ? " " : `
`,
    spacingOuter: e?.min ? "" : `
`
  };
}
o(kj, "getConfig");
function Vae(e) {
  return Array.from({ length: e + 1 }).join(" ");
}
o(Vae, "createIndent");
function Ft(e, t) {
  if (t && (Bae(t), t.plugins)) {
    let n = eL(t.plugins, e);
    if (n !== null)
      return Qj(n, e, kj(t), "", 0, []);
  }
  let r = Jj(
    e,
    rL(t),
    nL(t),
    oL(t)
  );
  return r !== null ? r : Zj(e, kj(t), "", 0, []);
}
o(Ft, "format");
var Vs = {
  AsymmetricMatcher: Nse,
  DOMCollection: Bse,
  DOMElement: Jse,
  Immutable: pae,
  ReactElement: Sae,
  ReactTestComponent: Oae,
  Error: Dae
};

// ../node_modules/@vitest/expect/node_modules/@vitest/utils/dist/chunk-_commonjsHelpers.js
var {
  AsymmetricMatcher: zae,
  DOMCollection: Gae,
  DOMElement: Yae,
  Immutable: Wae,
  ReactElement: Kae,
  ReactTestComponent: Xae
} = Vs, iL = [
  Xae,
  Kae,
  Yae,
  Gae,
  Wae,
  zae
];
function tt(e, t = 10, { maxLength: r, ...n } = {}) {
  let i = r ?? 1e4, s;
  try {
    s = Ft(e, {
      maxDepth: t,
      escapeString: !1,
      // min: true,
      plugins: iL,
      ...n
    });
  } catch {
    s = Ft(e, {
      callToJSON: !1,
      maxDepth: t,
      escapeString: !1,
      // min: true,
      plugins: iL,
      ...n
    });
  }
  return s.length >= i && t > 1 ? tt(e, Math.floor(Math.min(t, Number.MAX_SAFE_INTEGER) / 2), { maxLength: r, ...n }) : s;
}
o(tt, "stringify");
var Jae = /%[sdjifoOc%]/g;
function w_(...e) {
  if (typeof e[0] != "string") {
    let s = [];
    for (let a = 0; a < e.length; a++)
      s.push(ri(e[a], { depth: 0, colors: !1 }));
    return s.join(" ");
  }
  let t = e.length, r = 1, n = e[0], i = String(n).replace(Jae, (s) => {
    if (s === "%%")
      return "%";
    if (r >= t)
      return s;
    switch (s) {
      case "%s": {
        let a = e[r++];
        return typeof a == "bigint" ? `${a.toString()}n` : typeof a == "number" && a === 0 && 1 / a < 0 ? "-0" : typeof a == "object" && a !==
        null ? typeof a.toString == "function" && a.toString !== Object.prototype.toString ? a.toString() : ri(a, { depth: 0, colors: !1 }) :
        String(a);
      }
      case "%d": {
        let a = e[r++];
        return typeof a == "bigint" ? `${a.toString()}n` : Number(a).toString();
      }
      case "%i": {
        let a = e[r++];
        return typeof a == "bigint" ? `${a.toString()}n` : Number.parseInt(String(a)).toString();
      }
      case "%f":
        return Number.parseFloat(String(e[r++])).toString();
      case "%o":
        return ri(e[r++], { showHidden: !0, showProxy: !0 });
      case "%O":
        return ri(e[r++]);
      case "%c":
        return r++, "";
      case "%j":
        try {
          return JSON.stringify(e[r++]);
        } catch (a) {
          let l = a.message;
          if (
            // chromium
            l.includes("circular structure") || l.includes("cyclic structures") || l.includes("cyclic object")
          )
            return "[Circular]";
          throw a;
        }
      default:
        return s;
    }
  });
  for (let s = e[r]; r < t; s = e[++r])
    s === null || typeof s != "object" ? i += ` ${s}` : i += ` ${ri(s)}`;
  return i;
}
o(w_, "format");
function ri(e, t = {}) {
  return t.truncate === 0 && (t.truncate = Number.POSITIVE_INFINITY), Mo(e, t);
}
o(ri, "inspect");
function sL(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
o(sL, "getDefaultExportFromCjs");

// ../node_modules/@vitest/expect/node_modules/@vitest/utils/dist/helpers.js
function Kt(e, t, r) {
  let n = typeof e;
  if (!r.includes(n))
    throw new TypeError(
      `${t} value must be ${r.join(" or ")}, received "${n}"`
    );
}
o(Kt, "assertTypes");
function ni(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
o(ni, "isObject");
function Zae(e) {
  return e === Object.prototype || e === Function.prototype || e === RegExp.prototype;
}
o(Zae, "isFinalObj");
function oi(e) {
  return Object.prototype.toString.apply(e).slice(8, -1);
}
o(oi, "getType");
function Qae(e, t) {
  let r = typeof t == "function" ? t : (n) => t.add(n);
  Object.getOwnPropertyNames(e).forEach(r), Object.getOwnPropertySymbols(e).forEach(r);
}
o(Qae, "collectOwnProperties");
function Cp(e) {
  let t = /* @__PURE__ */ new Set();
  return Zae(e) ? [] : (Qae(e, t), Array.from(t));
}
o(Cp, "getOwnProperties");
var aL = { forceWritable: !1 };
function Pp(e, t = aL) {
  return xp(e, /* @__PURE__ */ new WeakMap(), t);
}
o(Pp, "deepClone");
function xp(e, t, r = aL) {
  let n, i;
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    for (i = Array.from({ length: n = e.length }), t.set(e, i); n--; )
      i[n] = xp(e[n], t, r);
    return i;
  }
  if (Object.prototype.toString.call(e) === "[object Object]") {
    i = Object.create(Object.getPrototypeOf(e)), t.set(e, i);
    let s = Cp(e);
    for (let a of s) {
      let l = Object.getOwnPropertyDescriptor(e, a);
      if (!l)
        continue;
      let u = xp(e[a], t, r);
      r.forceWritable ? Object.defineProperty(i, a, {
        enumerable: l.enumerable,
        configurable: !0,
        writable: !0,
        value: u
      }) : "get" in l ? Object.defineProperty(i, a, {
        ...l,
        get() {
          return u;
        }
      }) : Object.defineProperty(i, a, {
        ...l,
        value: u
      });
    }
    return i;
  }
  return e;
}
o(xp, "clone");

// ../node_modules/@vitest/expect/node_modules/@vitest/utils/dist/index.js
var S_, lL;
function ele() {
  if (lL) return S_;
  lL = 1;
  var e, t, r, n, i, s, a, l, u, c, d, p, y, f, m, h, b, g, T;
  return y = /\/(?![*\/])(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\\]).|\\.)*(\/[$_\u200C\u200D\p{ID_Continue}]*|\\)?/yu, p = /--|\+\+|=>|\.{3}|\??\.(?!\d)|(?:&&|\|\||\?\?|[+\-%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2}|\/(?![\/*]))=?|[?~,:;[\](){}]/y,
  e = /(\x23?)(?=[$_\p{ID_Start}\\])(?:[$_\u200C\u200D\p{ID_Continue}]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+/yu, m = /(['"])(?:(?!\1)[^\\\n\r]|\\(?:\r\n|[^]))*(\1)?/y,
  d = /(?:0[xX][\da-fA-F](?:_?[\da-fA-F])*|0[oO][0-7](?:_?[0-7])*|0[bB][01](?:_?[01])*)n?|0n|[1-9](?:_?\d)*n|(?:(?:0(?!\d)|0\d*[89]\d*|[1-9](?:_?\d)*)(?:\.(?:\d(?:_?\d)*)?)?|\.\d(?:_?\d)*)(?:[eE][+-]?\d(?:_?\d)*)?|0[0-7]+/y,
  h = /[`}](?:[^`\\$]|\\[^]|\$(?!\{))*(`|\$\{)?/y, T = /[\t\v\f\ufeff\p{Zs}]+/yu, l = /\r?\n|[\r\u2028\u2029]/y, u = /\/\*(?:[^*]|\*(?!\/))*(\*\/)?/y,
  f = /\/\/.*/y, r = /[<>.:={}]|\/(?![\/*])/y, t = /[$_\p{ID_Start}][$_\u200C\u200D\p{ID_Continue}-]*/yu, n = /(['"])(?:(?!\1)[^])*(\1)?/y, i =
  /[^<>{}]+/y, g = /^(?:[\/+-]|\.{3}|\?(?:InterpolationIn(?:JSX|Template)|NoLineTerminatorHere|NonExpressionParenEnd|UnaryIncDec))?$|[{}([,;<>=*%&|^!~?:]$/,
  b = /^(?:=>|[;\]){}]|else|\?(?:NoLineTerminatorHere|NonExpressionParenEnd))?$/, s = /^(?:await|case|default|delete|do|else|instanceof|new|return|throw|typeof|void|yield)$/,
  a = /^(?:return|throw|yield)$/, c = RegExp(l.source), S_ = /* @__PURE__ */ o(function* (_, { jsx: E = !1 } = {}) {
    var R, C, w, P, O, D, A, L, B, N, $, M, V, G;
    for ({ length: D } = _, P = 0, O = "", G = [
      { tag: "JS" }
    ], R = [], $ = 0, M = !1; P < D; ) {
      switch (L = G[G.length - 1], L.tag) {
        case "JS":
        case "JSNonExpressionParen":
        case "InterpolationInTemplate":
        case "InterpolationInJSX":
          if (_[P] === "/" && (g.test(O) || s.test(O)) && (y.lastIndex = P, A = y.exec(_))) {
            P = y.lastIndex, O = A[0], M = !0, yield {
              type: "RegularExpressionLiteral",
              value: A[0],
              closed: A[1] !== void 0 && A[1] !== "\\"
            };
            continue;
          }
          if (p.lastIndex = P, A = p.exec(_)) {
            switch (V = A[0], B = p.lastIndex, N = V, V) {
              case "(":
                O === "?NonExpressionParenKeyword" && G.push({
                  tag: "JSNonExpressionParen",
                  nesting: $
                }), $++, M = !1;
                break;
              case ")":
                $--, M = !0, L.tag === "JSNonExpressionParen" && $ === L.nesting && (G.pop(), N = "?NonExpressionParenEnd", M = !1);
                break;
              case "{":
                p.lastIndex = 0, w = !b.test(O) && (g.test(O) || s.test(O)), R.push(w), M = !1;
                break;
              case "}":
                switch (L.tag) {
                  case "InterpolationInTemplate":
                    if (R.length === L.nesting) {
                      h.lastIndex = P, A = h.exec(_), P = h.lastIndex, O = A[0], A[1] === "${" ? (O = "?InterpolationInTemplate", M = !1, yield {
                        type: "TemplateMiddle",
                        value: A[0]
                      }) : (G.pop(), M = !0, yield {
                        type: "TemplateTail",
                        value: A[0],
                        closed: A[1] === "`"
                      });
                      continue;
                    }
                    break;
                  case "InterpolationInJSX":
                    if (R.length === L.nesting) {
                      G.pop(), P += 1, O = "}", yield {
                        type: "JSXPunctuator",
                        value: "}"
                      };
                      continue;
                    }
                }
                M = R.pop(), N = M ? "?ExpressionBraceEnd" : "}";
                break;
              case "]":
                M = !0;
                break;
              case "++":
              case "--":
                N = M ? "?PostfixIncDec" : "?UnaryIncDec";
                break;
              case "<":
                if (E && (g.test(O) || s.test(O))) {
                  G.push({ tag: "JSXTag" }), P += 1, O = "<", yield {
                    type: "JSXPunctuator",
                    value: V
                  };
                  continue;
                }
                M = !1;
                break;
              default:
                M = !1;
            }
            P = B, O = N, yield {
              type: "Punctuator",
              value: V
            };
            continue;
          }
          if (e.lastIndex = P, A = e.exec(_)) {
            switch (P = e.lastIndex, N = A[0], A[0]) {
              case "for":
              case "if":
              case "while":
              case "with":
                O !== "." && O !== "?." && (N = "?NonExpressionParenKeyword");
            }
            O = N, M = !s.test(A[0]), yield {
              type: A[1] === "#" ? "PrivateIdentifier" : "IdentifierName",
              value: A[0]
            };
            continue;
          }
          if (m.lastIndex = P, A = m.exec(_)) {
            P = m.lastIndex, O = A[0], M = !0, yield {
              type: "StringLiteral",
              value: A[0],
              closed: A[2] !== void 0
            };
            continue;
          }
          if (d.lastIndex = P, A = d.exec(_)) {
            P = d.lastIndex, O = A[0], M = !0, yield {
              type: "NumericLiteral",
              value: A[0]
            };
            continue;
          }
          if (h.lastIndex = P, A = h.exec(_)) {
            P = h.lastIndex, O = A[0], A[1] === "${" ? (O = "?InterpolationInTemplate", G.push({
              tag: "InterpolationInTemplate",
              nesting: R.length
            }), M = !1, yield {
              type: "TemplateHead",
              value: A[0]
            }) : (M = !0, yield {
              type: "NoSubstitutionTemplate",
              value: A[0],
              closed: A[1] === "`"
            });
            continue;
          }
          break;
        case "JSXTag":
        case "JSXTagEnd":
          if (r.lastIndex = P, A = r.exec(_)) {
            switch (P = r.lastIndex, N = A[0], A[0]) {
              case "<":
                G.push({ tag: "JSXTag" });
                break;
              case ">":
                G.pop(), O === "/" || L.tag === "JSXTagEnd" ? (N = "?JSX", M = !0) : G.push({ tag: "JSXChildren" });
                break;
              case "{":
                G.push({
                  tag: "InterpolationInJSX",
                  nesting: R.length
                }), N = "?InterpolationInJSX", M = !1;
                break;
              case "/":
                O === "<" && (G.pop(), G[G.length - 1].tag === "JSXChildren" && G.pop(), G.push({ tag: "JSXTagEnd" }));
            }
            O = N, yield {
              type: "JSXPunctuator",
              value: A[0]
            };
            continue;
          }
          if (t.lastIndex = P, A = t.exec(_)) {
            P = t.lastIndex, O = A[0], yield {
              type: "JSXIdentifier",
              value: A[0]
            };
            continue;
          }
          if (n.lastIndex = P, A = n.exec(_)) {
            P = n.lastIndex, O = A[0], yield {
              type: "JSXString",
              value: A[0],
              closed: A[2] !== void 0
            };
            continue;
          }
          break;
        case "JSXChildren":
          if (i.lastIndex = P, A = i.exec(_)) {
            P = i.lastIndex, O = A[0], yield {
              type: "JSXText",
              value: A[0]
            };
            continue;
          }
          switch (_[P]) {
            case "<":
              G.push({ tag: "JSXTag" }), P++, O = "<", yield {
                type: "JSXPunctuator",
                value: "<"
              };
              continue;
            case "{":
              G.push({
                tag: "InterpolationInJSX",
                nesting: R.length
              }), P++, O = "?InterpolationInJSX", M = !1, yield {
                type: "JSXPunctuator",
                value: "{"
              };
              continue;
          }
      }
      if (T.lastIndex = P, A = T.exec(_)) {
        P = T.lastIndex, yield {
          type: "WhiteSpace",
          value: A[0]
        };
        continue;
      }
      if (l.lastIndex = P, A = l.exec(_)) {
        P = l.lastIndex, M = !1, a.test(O) && (O = "?NoLineTerminatorHere"), yield {
          type: "LineTerminatorSequence",
          value: A[0]
        };
        continue;
      }
      if (u.lastIndex = P, A = u.exec(_)) {
        P = u.lastIndex, c.test(A[0]) && (M = !1, a.test(O) && (O = "?NoLineTerminatorHere")), yield {
          type: "MultiLineComment",
          value: A[0],
          closed: A[1] !== void 0
        };
        continue;
      }
      if (f.lastIndex = P, A = f.exec(_)) {
        P = f.lastIndex, M = !1, yield {
          type: "SingleLineComment",
          value: A[0]
        };
        continue;
      }
      C = String.fromCodePoint(_.codePointAt(P)), P += C.length, O = C, M = !1, yield {
        type: L.tag.startsWith("JSX") ? "JSXInvalid" : "Invalid",
        value: C
      };
    }
  }, "jsTokens_1"), S_;
}
o(ele, "requireJsTokens");
var dDe = ele();
var uL = {
  keyword: [
    "break",
    "case",
    "catch",
    "continue",
    "debugger",
    "default",
    "do",
    "else",
    "finally",
    "for",
    "function",
    "if",
    "return",
    "switch",
    "throw",
    "try",
    "var",
    "const",
    "while",
    "with",
    "new",
    "this",
    "super",
    "class",
    "extends",
    "export",
    "import",
    "null",
    "true",
    "false",
    "in",
    "instanceof",
    "typeof",
    "void",
    "delete"
  ],
  strict: [
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    "yield"
  ]
}, pDe = new Set(uL.keyword), fDe = new Set(uL.strict);
var mDe = Symbol("vitest:SAFE_TIMERS");

// ../node_modules/@vitest/expect/node_modules/@vitest/utils/dist/diff.js
var lt = -1, rt = 1, Fe = 0, N_ = class N_ {
  0;
  1;
  constructor(t, r) {
    this[0] = t, this[1] = r;
  }
};
o(N_, "Diff");
var Oe = N_;
function tle(e, t) {
  if (!e || !t || e.charAt(0) !== t.charAt(0))
    return 0;
  let r = 0, n = Math.min(e.length, t.length), i = n, s = 0;
  for (; r < i; )
    e.substring(s, i) === t.substring(s, i) ? (r = i, s = r) : n = i, i = Math.floor((n - r) / 2 + r);
  return i;
}
o(tle, "diff_commonPrefix");
function SL(e, t) {
  if (!e || !t || e.charAt(e.length - 1) !== t.charAt(t.length - 1))
    return 0;
  let r = 0, n = Math.min(e.length, t.length), i = n, s = 0;
  for (; r < i; )
    e.substring(e.length - i, e.length - s) === t.substring(t.length - i, t.length - s) ? (r = i, s = r) : n = i, i = Math.floor((n - r) / 2 +
    r);
  return i;
}
o(SL, "diff_commonSuffix");
function cL(e, t) {
  let r = e.length, n = t.length;
  if (r === 0 || n === 0)
    return 0;
  r > n ? e = e.substring(r - n) : r < n && (t = t.substring(0, r));
  let i = Math.min(r, n);
  if (e === t)
    return i;
  let s = 0, a = 1;
  for (; ; ) {
    let l = e.substring(i - a), u = t.indexOf(l);
    if (u === -1)
      return s;
    a += u, (u === 0 || e.substring(i - a) === t.substring(0, a)) && (s = a, a++);
  }
}
o(cL, "diff_commonOverlap_");
function rle(e) {
  let t = !1, r = [], n = 0, i = null, s = 0, a = 0, l = 0, u = 0, c = 0;
  for (; s < e.length; )
    e[s][0] === Fe ? (r[n++] = s, a = u, l = c, u = 0, c = 0, i = e[s][1]) : (e[s][0] === rt ? u += e[s][1].length : c += e[s][1].length, i &&
    i.length <= Math.max(a, l) && i.length <= Math.max(u, c) && (e.splice(
      r[n - 1],
      0,
      new Oe(lt, i)
    ), e[r[n - 1] + 1][0] = rt, n--, n--, s = n > 0 ? r[n - 1] : -1, a = 0, l = 0, u = 0, c = 0, i = null, t = !0)), s++;
  for (t && xL(e), ile(e), s = 1; s < e.length; ) {
    if (e[s - 1][0] === lt && e[s][0] === rt) {
      let d = e[s - 1][1], p = e[s][1], y = cL(d, p), f = cL(p, d);
      y >= f ? (y >= d.length / 2 || y >= p.length / 2) && (e.splice(
        s,
        0,
        new Oe(Fe, p.substring(0, y))
      ), e[s - 1][1] = d.substring(
        0,
        d.length - y
      ), e[s + 1][1] = p.substring(y), s++) : (f >= d.length / 2 || f >= p.length / 2) && (e.splice(
        s,
        0,
        new Oe(Fe, d.substring(0, f))
      ), e[s - 1][0] = rt, e[s - 1][1] = p.substring(
        0,
        p.length - f
      ), e[s + 1][0] = lt, e[s + 1][1] = d.substring(f), s++), s++;
    }
    s++;
  }
}
o(rle, "diff_cleanupSemantic");
var dL = /[^a-z0-9]/i, pL = /\s/, fL = /[\r\n]/, nle = /\n\r?\n$/, ole = /^\r?\n\r?\n/;
function ile(e) {
  let t = 1;
  for (; t < e.length - 1; ) {
    if (e[t - 1][0] === Fe && e[t + 1][0] === Fe) {
      let r = e[t - 1][1], n = e[t][1], i = e[t + 1][1], s = SL(r, n);
      if (s) {
        let d = n.substring(n.length - s);
        r = r.substring(0, r.length - s), n = d + n.substring(0, n.length - s), i = d + i;
      }
      let a = r, l = n, u = i, c = Ap(r, n) + Ap(n, i);
      for (; n.charAt(0) === i.charAt(0); ) {
        r += n.charAt(0), n = n.substring(1) + i.charAt(0), i = i.substring(1);
        let d = Ap(r, n) + Ap(n, i);
        d >= c && (c = d, a = r, l = n, u = i);
      }
      e[t - 1][1] !== a && (a ? e[t - 1][1] = a : (e.splice(t - 1, 1), t--), e[t][1] = l, u ? e[t + 1][1] = u : (e.splice(t + 1, 1), t--));
    }
    t++;
  }
}
o(ile, "diff_cleanupSemanticLossless");
function xL(e) {
  e.push(new Oe(Fe, ""));
  let t = 0, r = 0, n = 0, i = "", s = "", a;
  for (; t < e.length; )
    switch (e[t][0]) {
      case rt:
        n++, s += e[t][1], t++;
        break;
      case lt:
        r++, i += e[t][1], t++;
        break;
      case Fe:
        r + n > 1 ? (r !== 0 && n !== 0 && (a = tle(s, i), a !== 0 && (t - r - n > 0 && e[t - r - n - 1][0] === Fe ? e[t - r - n - 1][1] += s.
        substring(0, a) : (e.splice(
          0,
          0,
          new Oe(Fe, s.substring(0, a))
        ), t++), s = s.substring(a), i = i.substring(a)), a = SL(s, i), a !== 0 && (e[t][1] = s.substring(s.length - a) + e[t][1], s = s.substring(
          0,
          s.length - a
        ), i = i.substring(
          0,
          i.length - a
        ))), t -= r + n, e.splice(t, r + n), i.length && (e.splice(t, 0, new Oe(lt, i)), t++), s.length && (e.splice(t, 0, new Oe(rt, s)), t++),
        t++) : t !== 0 && e[t - 1][0] === Fe ? (e[t - 1][1] += e[t][1], e.splice(t, 1)) : t++, n = 0, r = 0, i = "", s = "";
        break;
    }
  e[e.length - 1][1] === "" && e.pop();
  let l = !1;
  for (t = 1; t < e.length - 1; )
    e[t - 1][0] === Fe && e[t + 1][0] === Fe && (e[t][1].substring(
      e[t][1].length - e[t - 1][1].length
    ) === e[t - 1][1] ? (e[t][1] = e[t - 1][1] + e[t][1].substring(
      0,
      e[t][1].length - e[t - 1][1].length
    ), e[t + 1][1] = e[t - 1][1] + e[t + 1][1], e.splice(t - 1, 1), l = !0) : e[t][1].substring(0, e[t + 1][1].length) === e[t + 1][1] && (e[t -
    1][1] += e[t + 1][1], e[t][1] = e[t][1].substring(e[t + 1][1].length) + e[t + 1][1], e.splice(t + 1, 1), l = !0)), t++;
  l && xL(e);
}
o(xL, "diff_cleanupMerge");
function Ap(e, t) {
  if (!e || !t)
    return 6;
  let r = e.charAt(e.length - 1), n = t.charAt(0), i = r.match(dL), s = n.match(dL), a = i && r.match(pL), l = s && n.match(pL), u = a && r.
  match(fL), c = l && n.match(fL), d = u && e.match(nle), p = c && t.match(ole);
  return d || p ? 5 : u || c ? 4 : i && !a && l ? 3 : a || l ? 2 : i || s ? 1 : 0;
}
o(Ap, "diff_cleanupSemanticScore_");
var CL = "Compared values have no visual difference.", sle = "Compared values serialize to the same structure.\nPrinting internal object stru\
cture without calling `toJSON` instead.", Op = {}, mL;
function ale() {
  if (mL) return Op;
  mL = 1, Object.defineProperty(Op, "__esModule", {
    value: !0
  }), Op.default = y;
  let e = "diff-sequences", t = 0, r = /* @__PURE__ */ o((f, m, h, b, g) => {
    let T = 0;
    for (; f < m && h < b && g(f, h); )
      f += 1, h += 1, T += 1;
    return T;
  }, "countCommonItemsF"), n = /* @__PURE__ */ o((f, m, h, b, g) => {
    let T = 0;
    for (; f <= m && h <= b && g(m, b); )
      m -= 1, b -= 1, T += 1;
    return T;
  }, "countCommonItemsR"), i = /* @__PURE__ */ o((f, m, h, b, g, T, _) => {
    let E = 0, R = -f, C = T[E], w = C;
    T[E] += r(
      C + 1,
      m,
      b + C - R + 1,
      h,
      g
    );
    let P = f < _ ? f : _;
    for (E += 1, R += 2; E <= P; E += 1, R += 2) {
      if (E !== f && w < T[E])
        C = T[E];
      else if (C = w + 1, m <= C)
        return E - 1;
      w = T[E], T[E] = C + r(C + 1, m, b + C - R + 1, h, g);
    }
    return _;
  }, "extendPathsF"), s = /* @__PURE__ */ o((f, m, h, b, g, T, _) => {
    let E = 0, R = f, C = T[E], w = C;
    T[E] -= n(
      m,
      C - 1,
      h,
      b + C - R - 1,
      g
    );
    let P = f < _ ? f : _;
    for (E += 1, R -= 2; E <= P; E += 1, R -= 2) {
      if (E !== f && T[E] < w)
        C = T[E];
      else if (C = w - 1, C < m)
        return E - 1;
      w = T[E], T[E] = C - n(
        m,
        C - 1,
        h,
        b + C - R - 1,
        g
      );
    }
    return _;
  }, "extendPathsR"), a = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R, C, w) => {
    let P = b - m, O = h - m, A = g - b - O, L = -A - (f - 1), B = -A + (f - 1), N = t, $ = f < E ? f : E;
    for (let M = 0, V = -f; M <= $; M += 1, V += 2) {
      let G = M === 0 || M !== f && N < _[M], Q = G ? _[M] : N, te = G ? Q : Q + 1, fe = P + te - V, F = r(
        te + 1,
        h,
        fe + 1,
        g,
        T
      ), j = te + F;
      if (N = _[M], _[M] = j, L <= V && V <= B) {
        let Y = (f - 1 - (V + A)) / 2;
        if (Y <= C && R[Y] - 1 <= j) {
          let z = P + Q - (G ? V + 1 : V - 1), X = n(
            m,
            Q,
            b,
            z,
            T
          ), ce = Q - X, Re = z - X, Me = ce + 1, vr = Re + 1;
          w.nChangePreceding = f - 1, f - 1 === Me + vr - m - b ? (w.aEndPreceding = m, w.bEndPreceding = b) : (w.aEndPreceding = Me, w.bEndPreceding =
          vr), w.nCommonPreceding = X, X !== 0 && (w.aCommonPreceding = Me, w.bCommonPreceding = vr), w.nCommonFollowing = F, F !== 0 && (w.
          aCommonFollowing = te + 1, w.bCommonFollowing = fe + 1);
          let ot = j + 1, ve = fe + F + 1;
          return w.nChangeFollowing = f - 1, f - 1 === h + g - ot - ve ? (w.aStartFollowing = h, w.bStartFollowing = g) : (w.aStartFollowing =
          ot, w.bStartFollowing = ve), !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsF"), l = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R, C, w) => {
    let P = g - h, O = h - m, A = g - b - O, L = A - f, B = A + f, N = t, $ = f < C ? f : C;
    for (let M = 0, V = f; M <= $; M += 1, V -= 2) {
      let G = M === 0 || M !== f && R[M] < N, Q = G ? R[M] : N, te = G ? Q : Q - 1, fe = P + te - V, F = n(
        m,
        te - 1,
        b,
        fe - 1,
        T
      ), j = te - F;
      if (N = R[M], R[M] = j, L <= V && V <= B) {
        let Y = (f + (V - A)) / 2;
        if (Y <= E && j - 1 <= _[Y]) {
          let z = fe - F;
          if (w.nChangePreceding = f, f === j + z - m - b ? (w.aEndPreceding = m, w.bEndPreceding = b) : (w.aEndPreceding = j, w.bEndPreceding =
          z), w.nCommonPreceding = F, F !== 0 && (w.aCommonPreceding = j, w.bCommonPreceding = z), w.nChangeFollowing = f - 1, f === 1)
            w.nCommonFollowing = 0, w.aStartFollowing = h, w.bStartFollowing = g;
          else {
            let X = P + Q - (G ? V - 1 : V + 1), ce = r(
              Q,
              h,
              X,
              g,
              T
            );
            w.nCommonFollowing = ce, ce !== 0 && (w.aCommonFollowing = Q, w.bCommonFollowing = X);
            let Re = Q + ce, Me = X + ce;
            f - 1 === h + g - Re - Me ? (w.aStartFollowing = h, w.bStartFollowing = g) : (w.aStartFollowing = Re, w.bStartFollowing = Me);
          }
          return !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsR"), u = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R) => {
    let C = b - m, w = g - h, P = h - m, O = g - b, D = O - P, A = P, L = P;
    if (_[0] = m - 1, E[0] = h, D % 2 === 0) {
      let B = (f || D) / 2, N = (P + O) / 2;
      for (let $ = 1; $ <= N; $ += 1)
        if (A = i($, h, g, C, T, _, A), $ < B)
          L = s($, m, b, w, T, E, L);
        else if (
          // If a reverse path overlaps a forward path in the same diagonal,
          // return a division of the index intervals at the middle change.
          l(
            $,
            m,
            h,
            b,
            g,
            T,
            _,
            A,
            E,
            L,
            R
          )
        )
          return;
    } else {
      let B = ((f || D) + 1) / 2, N = (P + O + 1) / 2, $ = 1;
      for (A = i($, h, g, C, T, _, A), $ += 1; $ <= N; $ += 1)
        if (L = s(
          $ - 1,
          m,
          b,
          w,
          T,
          E,
          L
        ), $ < B)
          A = i($, h, g, C, T, _, A);
        else if (
          // If a forward path overlaps a reverse path in the same diagonal,
          // return a division of the index intervals at the middle change.
          a(
            $,
            m,
            h,
            b,
            g,
            T,
            _,
            A,
            E,
            L,
            R
          )
        )
          return;
    }
    throw new Error(
      `${e}: no overlap aStart=${m} aEnd=${h} bStart=${b} bEnd=${g}`
    );
  }, "divide"), c = /* @__PURE__ */ o((f, m, h, b, g, T, _, E, R, C) => {
    if (g - b < h - m) {
      if (T = !T, T && _.length === 1) {
        let { foundSubsequence: j, isCommon: Y } = _[0];
        _[1] = {
          foundSubsequence: /* @__PURE__ */ o((z, X, ce) => {
            j(z, ce, X);
          }, "foundSubsequence"),
          isCommon: /* @__PURE__ */ o((z, X) => Y(X, z), "isCommon")
        };
      }
      let fe = m, F = h;
      m = b, h = g, b = fe, g = F;
    }
    let { foundSubsequence: w, isCommon: P } = _[T ? 1 : 0];
    u(
      f,
      m,
      h,
      b,
      g,
      P,
      E,
      R,
      C
    );
    let {
      nChangePreceding: O,
      aEndPreceding: D,
      bEndPreceding: A,
      nCommonPreceding: L,
      aCommonPreceding: B,
      bCommonPreceding: N,
      nCommonFollowing: $,
      aCommonFollowing: M,
      bCommonFollowing: V,
      nChangeFollowing: G,
      aStartFollowing: Q,
      bStartFollowing: te
    } = C;
    m < D && b < A && c(
      O,
      m,
      D,
      b,
      A,
      T,
      _,
      E,
      R,
      C
    ), L !== 0 && w(L, B, N), $ !== 0 && w($, M, V), Q < h && te < g && c(
      G,
      Q,
      h,
      te,
      g,
      T,
      _,
      E,
      R,
      C
    );
  }, "findSubsequences"), d = /* @__PURE__ */ o((f, m) => {
    if (typeof m != "number")
      throw new TypeError(`${e}: ${f} typeof ${typeof m} is not a number`);
    if (!Number.isSafeInteger(m))
      throw new RangeError(`${e}: ${f} value ${m} is not a safe integer`);
    if (m < 0)
      throw new RangeError(`${e}: ${f} value ${m} is a negative integer`);
  }, "validateLength"), p = /* @__PURE__ */ o((f, m) => {
    let h = typeof m;
    if (h !== "function")
      throw new TypeError(`${e}: ${f} typeof ${h} is not a function`);
  }, "validateCallback");
  function y(f, m, h, b) {
    d("aLength", f), d("bLength", m), p("isCommon", h), p("foundSubsequence", b);
    let g = r(0, f, 0, m, h);
    if (g !== 0 && b(g, 0, 0), f !== g || m !== g) {
      let T = g, _ = g, E = n(
        T,
        f - 1,
        _,
        m - 1,
        h
      ), R = f - E, C = m - E, w = g + E;
      f !== w && m !== w && c(
        0,
        T,
        R,
        _,
        C,
        !1,
        [
          {
            foundSubsequence: b,
            isCommon: h
          }
        ],
        [t],
        [t],
        {
          aCommonFollowing: t,
          aCommonPreceding: t,
          aEndPreceding: t,
          aStartFollowing: t,
          bCommonFollowing: t,
          bCommonPreceding: t,
          bEndPreceding: t,
          bStartFollowing: t,
          nChangeFollowing: t,
          nChangePreceding: t,
          nCommonFollowing: t,
          nCommonPreceding: t
        }
      ), E !== 0 && b(E, R, C);
    }
  }
  return o(y, "diffSequence"), Op;
}
o(ale, "requireBuild");
var lle = ale(), PL = /* @__PURE__ */ sL(lle);
function ule(e, t) {
  return e.replace(/\s+$/, (r) => t(r));
}
o(ule, "formatTrailingSpaces");
function I_(e, t, r, n, i, s) {
  return e.length !== 0 ? r(
    `${n} ${ule(e, i)}`
  ) : n !== " " ? r(n) : t && s.length !== 0 ? r(`${n} ${s}`) : "";
}
o(I_, "printDiffLine");
function AL(e, t, {
  aColor: r,
  aIndicator: n,
  changeLineTrailingSpaceColor: i,
  emptyFirstOrLastLinePlaceholder: s
}) {
  return I_(
    e,
    t,
    r,
    n,
    i,
    s
  );
}
o(AL, "printDeleteLine");
function OL(e, t, {
  bColor: r,
  bIndicator: n,
  changeLineTrailingSpaceColor: i,
  emptyFirstOrLastLinePlaceholder: s
}) {
  return I_(
    e,
    t,
    r,
    n,
    i,
    s
  );
}
o(OL, "printInsertLine");
function qL(e, t, {
  commonColor: r,
  commonIndicator: n,
  commonLineTrailingSpaceColor: i,
  emptyFirstOrLastLinePlaceholder: s
}) {
  return I_(
    e,
    t,
    r,
    n,
    i,
    s
  );
}
o(qL, "printCommonLine");
function hL(e, t, r, n, { patchColor: i }) {
  return i(
    `@@ -${e + 1},${t - e} +${r + 1},${n - r} @@`
  );
}
o(hL, "createPatchMark");
function cle(e, t) {
  let r = e.length, n = t.contextLines, i = n + n, s = r, a = !1, l = 0, u = 0;
  for (; u !== r; ) {
    let E = u;
    for (; u !== r && e[u][0] === Fe; )
      u += 1;
    if (E !== u)
      if (E === 0)
        u > n && (s -= u - n, a = !0);
      else if (u === r) {
        let R = u - E;
        R > n && (s -= R - n, a = !0);
      } else {
        let R = u - E;
        R > i && (s -= R - i, l += 1);
      }
    for (; u !== r && e[u][0] !== Fe; )
      u += 1;
  }
  let c = l !== 0 || a;
  l !== 0 ? s += l + 1 : a && (s += 1);
  let d = s - 1, p = [], y = 0;
  c && p.push("");
  let f = 0, m = 0, h = 0, b = 0, g = /* @__PURE__ */ o((E) => {
    let R = p.length;
    p.push(qL(E, R === 0 || R === d, t)), h += 1, b += 1;
  }, "pushCommonLine"), T = /* @__PURE__ */ o((E) => {
    let R = p.length;
    p.push(AL(E, R === 0 || R === d, t)), h += 1;
  }, "pushDeleteLine"), _ = /* @__PURE__ */ o((E) => {
    let R = p.length;
    p.push(OL(E, R === 0 || R === d, t)), b += 1;
  }, "pushInsertLine");
  for (u = 0; u !== r; ) {
    let E = u;
    for (; u !== r && e[u][0] === Fe; )
      u += 1;
    if (E !== u)
      if (E === 0) {
        u > n && (E = u - n, f = E, m = E, h = f, b = m);
        for (let R = E; R !== u; R += 1)
          g(e[R][1]);
      } else if (u === r) {
        let R = u - E > n ? E + n : u;
        for (let C = E; C !== R; C += 1)
          g(e[C][1]);
      } else {
        let R = u - E;
        if (R > i) {
          let C = E + n;
          for (let P = E; P !== C; P += 1)
            g(e[P][1]);
          p[y] = hL(
            f,
            h,
            m,
            b,
            t
          ), y = p.length, p.push("");
          let w = R - i;
          f = h + w, m = b + w, h = f, b = m;
          for (let P = u - n; P !== u; P += 1)
            g(e[P][1]);
        } else
          for (let C = E; C !== u; C += 1)
            g(e[C][1]);
      }
    for (; u !== r && e[u][0] === lt; )
      T(e[u][1]), u += 1;
    for (; u !== r && e[u][0] === rt; )
      _(e[u][1]), u += 1;
  }
  return c && (p[y] = hL(f, h, m, b, t)), p.join(`
`);
}
o(cle, "joinAlignedDiffsNoExpand");
function dle(e, t) {
  return e.map((r, n, i) => {
    let s = r[1], a = n === 0 || n === i.length - 1;
    switch (r[0]) {
      case lt:
        return AL(s, a, t);
      case rt:
        return OL(s, a, t);
      default:
        return qL(s, a, t);
    }
  }).join(`
`);
}
o(dle, "joinAlignedDiffsExpand");
var x_ = /* @__PURE__ */ o((e) => e, "noColor"), IL = 5, ple = 0;
function fle() {
  return {
    aAnnotation: "Expected",
    aColor: ae.green,
    aIndicator: "-",
    bAnnotation: "Received",
    bColor: ae.red,
    bIndicator: "+",
    changeColor: ae.inverse,
    changeLineTrailingSpaceColor: x_,
    commonColor: ae.dim,
    commonIndicator: " ",
    commonLineTrailingSpaceColor: x_,
    compareKeys: void 0,
    contextLines: IL,
    emptyFirstOrLastLinePlaceholder: "",
    expand: !0,
    includeChangeCounts: !1,
    omitAnnotationLines: !1,
    patchColor: ae.yellow,
    printBasicPrototype: !1,
    truncateThreshold: ple,
    truncateAnnotation: "... Diff result is truncated",
    truncateAnnotationColor: x_
  };
}
o(fle, "getDefaultOptions");
function mle(e) {
  return e && typeof e == "function" ? e : void 0;
}
o(mle, "getCompareKeys");
function hle(e) {
  return typeof e == "number" && Number.isSafeInteger(e) && e >= 0 ? e : IL;
}
o(hle, "getContextLines");
function Fn(e = {}) {
  return {
    ...fle(),
    ...e,
    compareKeys: mle(e.compareKeys),
    contextLines: hle(e.contextLines)
  };
}
o(Fn, "normalizeDiffOptions");
function ii(e) {
  return e.length === 1 && e[0].length === 0;
}
o(ii, "isEmptyString");
function yle(e) {
  let t = 0, r = 0;
  return e.forEach((n) => {
    switch (n[0]) {
      case lt:
        t += 1;
        break;
      case rt:
        r += 1;
        break;
    }
  }), { a: t, b: r };
}
o(yle, "countChanges");
function ble({
  aAnnotation: e,
  aColor: t,
  aIndicator: r,
  bAnnotation: n,
  bColor: i,
  bIndicator: s,
  includeChangeCounts: a,
  omitAnnotationLines: l
}, u) {
  if (l)
    return "";
  let c = "", d = "";
  if (a) {
    let f = String(u.a), m = String(u.b), h = n.length - e.length, b = " ".repeat(Math.max(0, h)), g = " ".repeat(Math.max(0, -h)), T = m.length -
    f.length, _ = " ".repeat(Math.max(0, T)), E = " ".repeat(Math.max(0, -T));
    c = `${b}  ${r} ${_}${f}`, d = `${g}  ${s} ${E}${m}`;
  }
  let p = `${r} ${e}${c}`, y = `${s} ${n}${d}`;
  return `${t(p)}
${i(y)}

`;
}
o(ble, "printAnnotation");
function M_(e, t, r) {
  return ble(r, yle(e)) + (r.expand ? dle(e, r) : cle(e, r)) + (t ? r.truncateAnnotationColor(`
${r.truncateAnnotation}`) : "");
}
o(M_, "printDiffLines");
function Ip(e, t, r) {
  let n = Fn(r), [i, s] = ML(
    ii(e) ? [] : e,
    ii(t) ? [] : t,
    n
  );
  return M_(i, s, n);
}
o(Ip, "diffLinesUnified");
function gle(e, t, r, n, i) {
  if (ii(e) && ii(r) && (e = [], r = []), ii(t) && ii(n) && (t = [], n = []), e.length !== r.length || t.length !== n.length)
    return Ip(e, t, i);
  let [s, a] = ML(
    r,
    n,
    i
  ), l = 0, u = 0;
  return s.forEach((c) => {
    switch (c[0]) {
      case lt:
        c[1] = e[l], l += 1;
        break;
      case rt:
        c[1] = t[u], u += 1;
        break;
      default:
        c[1] = t[u], l += 1, u += 1;
    }
  }), M_(s, a, Fn(i));
}
o(gle, "diffLinesUnified2");
function ML(e, t, r) {
  let n = r?.truncateThreshold ?? !1, i = Math.max(
    Math.floor(r?.truncateThreshold ?? 0),
    0
  ), s = n ? Math.min(e.length, i) : e.length, a = n ? Math.min(t.length, i) : t.length, l = s !== e.length || a !== t.length, u = /* @__PURE__ */ o(
  (f, m) => e[f] === t[m], "isCommon"), c = [], d = 0, p = 0;
  for (PL(s, a, u, /* @__PURE__ */ o((f, m, h) => {
    for (; d !== m; d += 1)
      c.push(new Oe(lt, e[d]));
    for (; p !== h; p += 1)
      c.push(new Oe(rt, t[p]));
    for (; f !== 0; f -= 1, d += 1, p += 1)
      c.push(new Oe(Fe, t[p]));
  }, "foundSubsequence")); d !== s; d += 1)
    c.push(new Oe(lt, e[d]));
  for (; p !== a; p += 1)
    c.push(new Oe(rt, t[p]));
  return [c, l];
}
o(ML, "diffLinesRaw");
function yL(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  if (Array.isArray(e))
    return "array";
  if (typeof e == "boolean")
    return "boolean";
  if (typeof e == "function")
    return "function";
  if (typeof e == "number")
    return "number";
  if (typeof e == "string")
    return "string";
  if (typeof e == "bigint")
    return "bigint";
  if (typeof e == "object") {
    if (e != null) {
      if (e.constructor === RegExp)
        return "regexp";
      if (e.constructor === Map)
        return "map";
      if (e.constructor === Set)
        return "set";
      if (e.constructor === Date)
        return "date";
    }
    return "object";
  } else if (typeof e == "symbol")
    return "symbol";
  throw new Error(`value of unknown type: ${e}`);
}
o(yL, "getType");
function bL(e) {
  return e.includes(`\r
`) ? `\r
` : `
`;
}
o(bL, "getNewLineSymbol");
function vle(e, t, r) {
  let n = r?.truncateThreshold ?? !1, i = Math.max(
    Math.floor(r?.truncateThreshold ?? 0),
    0
  ), s = e.length, a = t.length;
  if (n) {
    let f = e.includes(`
`), m = t.includes(`
`), h = bL(e), b = bL(t), g = f ? `${e.split(h, i).join(h)}
` : e, T = m ? `${t.split(b, i).join(b)}
` : t;
    s = g.length, a = T.length;
  }
  let l = s !== e.length || a !== t.length, u = /* @__PURE__ */ o((f, m) => e[f] === t[m], "isCommon"), c = 0, d = 0, p = [];
  return PL(s, a, u, /* @__PURE__ */ o((f, m, h) => {
    c !== m && p.push(new Oe(lt, e.slice(c, m))), d !== h && p.push(new Oe(rt, t.slice(d, h))), c = m + f, d = h + f, p.push(new Oe(Fe, t.slice(
    h, d)));
  }, "foundSubsequence")), c !== s && p.push(new Oe(lt, e.slice(c))), d !== a && p.push(new Oe(rt, t.slice(d))), [p, l];
}
o(vle, "diffStrings");
function Ele(e, t, r) {
  return t.reduce(
    (n, i) => n + (i[0] === Fe ? i[1] : i[0] === e && i[1].length !== 0 ? r(i[1]) : ""),
    ""
  );
}
o(Ele, "concatenateRelevantDiffs");
var j_ = class j_ {
  op;
  line;
  // incomplete line
  lines;
  // complete lines
  changeColor;
  constructor(t, r) {
    this.op = t, this.line = [], this.lines = [], this.changeColor = r;
  }
  pushSubstring(t) {
    this.pushDiff(new Oe(this.op, t));
  }
  pushLine() {
    this.lines.push(
      this.line.length !== 1 ? new Oe(
        this.op,
        Ele(this.op, this.line, this.changeColor)
      ) : this.line[0][0] === this.op ? this.line[0] : new Oe(this.op, this.line[0][1])
      // was common diff
    ), this.line.length = 0;
  }
  isLineEmpty() {
    return this.line.length === 0;
  }
  // Minor input to buffer.
  pushDiff(t) {
    this.line.push(t);
  }
  // Main input to buffer.
  align(t) {
    let r = t[1];
    if (r.includes(`
`)) {
      let n = r.split(`
`), i = n.length - 1;
      n.forEach((s, a) => {
        a < i ? (this.pushSubstring(s), this.pushLine()) : s.length !== 0 && this.pushSubstring(s);
      });
    } else
      this.pushDiff(t);
  }
  // Output from buffer.
  moveLinesTo(t) {
    this.isLineEmpty() || this.pushLine(), t.push(...this.lines), this.lines.length = 0;
  }
};
o(j_, "ChangeBuffer");
var qp = j_, L_ = class L_ {
  deleteBuffer;
  insertBuffer;
  lines;
  constructor(t, r) {
    this.deleteBuffer = t, this.insertBuffer = r, this.lines = [];
  }
  pushDiffCommonLine(t) {
    this.lines.push(t);
  }
  pushDiffChangeLines(t) {
    let r = t[1].length === 0;
    (!r || this.deleteBuffer.isLineEmpty()) && this.deleteBuffer.pushDiff(t), (!r || this.insertBuffer.isLineEmpty()) && this.insertBuffer.pushDiff(
    t);
  }
  flushChangeLines() {
    this.deleteBuffer.moveLinesTo(this.lines), this.insertBuffer.moveLinesTo(this.lines);
  }
  // Input to buffer.
  align(t) {
    let r = t[0], n = t[1];
    if (n.includes(`
`)) {
      let i = n.split(`
`), s = i.length - 1;
      i.forEach((a, l) => {
        if (l === 0) {
          let u = new Oe(r, a);
          this.deleteBuffer.isLineEmpty() && this.insertBuffer.isLineEmpty() ? (this.flushChangeLines(), this.pushDiffCommonLine(u)) : (this.
          pushDiffChangeLines(u), this.flushChangeLines());
        } else l < s ? this.pushDiffCommonLine(new Oe(r, a)) : a.length !== 0 && this.pushDiffChangeLines(new Oe(r, a));
      });
    } else
      this.pushDiffChangeLines(t);
  }
  // Output from buffer.
  getLines() {
    return this.flushChangeLines(), this.lines;
  }
};
o(L_, "CommonBuffer");
var P_ = L_;
function Tle(e, t) {
  let r = new qp(lt, t), n = new qp(rt, t), i = new P_(r, n);
  return e.forEach((s) => {
    switch (s[0]) {
      case lt:
        r.align(s);
        break;
      case rt:
        n.align(s);
        break;
      default:
        i.align(s);
    }
  }), i.getLines();
}
o(Tle, "getAlignedDiffs");
function _le(e, t) {
  if (t) {
    let r = e.length - 1;
    return e.some(
      (n, i) => n[0] === Fe && (i !== r || n[1] !== `
`)
    );
  }
  return e.some((r) => r[0] === Fe);
}
o(_le, "hasCommonDiff");
function Rle(e, t, r) {
  if (e !== t && e.length !== 0 && t.length !== 0) {
    let n = e.includes(`
`) || t.includes(`
`), [i, s] = NL(
      n ? `${e}
` : e,
      n ? `${t}
` : t,
      !0,
      // cleanupSemantic
      r
    );
    if (_le(i, n)) {
      let a = Fn(r), l = Tle(i, a.changeColor);
      return M_(l, s, a);
    }
  }
  return Ip(e.split(`
`), t.split(`
`), r);
}
o(Rle, "diffStringsUnified");
function NL(e, t, r, n) {
  let [i, s] = vle(e, t, n);
  return r && rle(i), [i, s];
}
o(NL, "diffStringsRaw");
function A_(e, t) {
  let { commonColor: r } = Fn(t);
  return r(e);
}
o(A_, "getCommonMessage");
var {
  AsymmetricMatcher: wle,
  DOMCollection: Sle,
  DOMElement: xle,
  Immutable: Cle,
  ReactElement: Ple,
  ReactTestComponent: Ale
} = Vs, jL = [
  Ale,
  Ple,
  xle,
  Sle,
  Cle,
  wle,
  Vs.Error
], O_ = {
  plugins: jL
}, LL = {
  callToJSON: !1,
  maxDepth: 8,
  plugins: jL
};
function kn(e, t, r) {
  if (Object.is(e, t))
    return "";
  let n = yL(e), i = n, s = !1;
  if (n === "object" && typeof e.asymmetricMatch == "function") {
    if (e.$$typeof !== Symbol.for("jest.asymmetricMatcher") || typeof e.getExpectedType != "function")
      return;
    i = e.getExpectedType(), s = i === "string";
  }
  if (i !== yL(t)) {
    let a = /* @__PURE__ */ o(function(_) {
      return _.length <= b ? _ : `${_.slice(0, b)}...`;
    }, "truncate2"), { aAnnotation: l, aColor: u, aIndicator: c, bAnnotation: d, bColor: p, bIndicator: y } = Fn(r), f = q_(LL, r), m = Ft(e,
    f), h = Ft(t, f), b = 1e5;
    m = a(m), h = a(h);
    let g = `${u(`${c} ${l}:`)} 
${m}`, T = `${p(`${y} ${d}:`)} 
${h}`;
    return `${g}

${T}`;
  }
  if (!s)
    switch (n) {
      case "string":
        return Ip(e.split(`
`), t.split(`
`), r);
      case "boolean":
      case "number":
        return Ole(e, t, r);
      case "map":
        return C_(gL(e), gL(t), r);
      case "set":
        return C_(vL(e), vL(t), r);
      default:
        return C_(e, t, r);
    }
}
o(kn, "diff");
function Ole(e, t, r) {
  let n = Ft(e, O_), i = Ft(t, O_);
  return n === i ? "" : Ip(n.split(`
`), i.split(`
`), r);
}
o(Ole, "comparePrimitive");
function gL(e) {
  return new Map(Array.from(e.entries()).sort());
}
o(gL, "sortMap");
function vL(e) {
  return new Set(Array.from(e.values()).sort());
}
o(vL, "sortSet");
function C_(e, t, r) {
  let n, i = !1;
  try {
    let a = q_(O_, r);
    n = EL(e, t, a, r);
  } catch {
    i = !0;
  }
  let s = A_(CL, r);
  if (n === void 0 || n === s) {
    let a = q_(LL, r);
    n = EL(e, t, a, r), n !== s && !i && (n = `${A_(
      sle,
      r
    )}

${n}`);
  }
  return n;
}
o(C_, "compareObjects");
function q_(e, t) {
  let { compareKeys: r, printBasicPrototype: n } = Fn(t);
  return {
    ...e,
    compareKeys: r,
    printBasicPrototype: n
  };
}
o(q_, "getFormatOptions");
function EL(e, t, r, n) {
  let i = { ...r, indent: 0 }, s = Ft(e, i), a = Ft(t, i);
  if (s === a)
    return A_(CL, n);
  {
    let l = Ft(e, r), u = Ft(t, r);
    return gle(
      l.split(`
`),
      u.split(`
`),
      s.split(`
`),
      a.split(`
`),
      n
    );
  }
}
o(EL, "getObjectsDifference");
var TL = 2e4;
function _L(e) {
  return oi(e) === "Object" && typeof e.asymmetricMatch == "function";
}
o(_L, "isAsymmetricMatcher");
function RL(e, t) {
  let r = oi(e), n = oi(t);
  return r === n && (r === "Object" || r === "Array");
}
o(RL, "isReplaceable");
function Mp(e, t, r) {
  let { aAnnotation: n, bAnnotation: i } = Fn(r);
  if (typeof t == "string" && typeof e == "string" && t.length > 0 && e.length > 0 && t.length <= TL && e.length <= TL && t !== e) {
    if (t.includes(`
`) || e.includes(`
`))
      return Rle(t, e, r);
    let [d] = NL(t, e, !0), p = d.some((h) => h[0] === Fe), y = qle(n, i), f = y(n) + Nle(
      wL(d, lt, p)
    ), m = y(i) + Mle(
      wL(d, rt, p)
    );
    return `${f}
${m}`;
  }
  let s = Pp(t, { forceWritable: !0 }), a = Pp(e, { forceWritable: !0 }), { replacedExpected: l, replacedActual: u } = FL(a, s);
  return kn(l, u, r);
}
o(Mp, "printDiffOrStringify");
function FL(e, t, r = /* @__PURE__ */ new WeakSet(), n = /* @__PURE__ */ new WeakSet()) {
  return e instanceof Error && t instanceof Error && typeof e.cause < "u" && typeof t.cause > "u" ? (delete e.cause, {
    replacedActual: e,
    replacedExpected: t
  }) : RL(e, t) ? r.has(e) || n.has(t) ? { replacedActual: e, replacedExpected: t } : (r.add(e), n.add(t), Cp(t).forEach((i) => {
    let s = t[i], a = e[i];
    if (_L(s))
      s.asymmetricMatch(a) && (e[i] = s);
    else if (_L(a))
      a.asymmetricMatch(s) && (t[i] = a);
    else if (RL(a, s)) {
      let l = FL(
        a,
        s,
        r,
        n
      );
      e[i] = l.replacedActual, t[i] = l.replacedExpected;
    }
  }), {
    replacedActual: e,
    replacedExpected: t
  }) : { replacedActual: e, replacedExpected: t };
}
o(FL, "replaceAsymmetricMatcher");
function qle(...e) {
  let t = e.reduce(
    (r, n) => n.length > r ? n.length : r,
    0
  );
  return (r) => `${r}: ${" ".repeat(t - r.length)}`;
}
o(qle, "getLabelPrinter");
var Ile = "\xB7";
function kL(e) {
  return e.replace(/\s+$/gm, (t) => Ile.repeat(t.length));
}
o(kL, "replaceTrailingSpaces");
function Mle(e) {
  return ae.red(kL(tt(e)));
}
o(Mle, "printReceived");
function Nle(e) {
  return ae.green(kL(tt(e)));
}
o(Nle, "printExpected");
function wL(e, t, r) {
  return e.reduce(
    (n, i) => n + (i[0] === Fe ? i[1] : i[0] === t ? r ? ae.inverse(i[1]) : i[1] : ""),
    ""
  );
}
o(wL, "getCommonAndChangedSubstrings");

// ../node_modules/tinyspy/dist/index.js
function Np(e, t) {
  if (!e)
    throw new Error(t);
}
o(Np, "d");
function si(e, t) {
  return typeof t === e;
}
o(si, "y");
function jle(e) {
  return e instanceof Promise;
}
o(jle, "w");
function F_(e, t, r) {
  Object.defineProperty(e, t, r);
}
o(F_, "f");
function ai(e, t, r) {
  Object.defineProperty(e, t, { value: r });
}
o(ai, "l");
var zs = Symbol.for("tinyspy:spy"), Lle = /* @__PURE__ */ new Set(), Fle = /* @__PURE__ */ o((e) => {
  e.called = !1, e.callCount = 0, e.calls = [], e.results = [], e.resolves = [], e.next = [];
}, "P"), kle = /* @__PURE__ */ o((e) => (F_(e, zs, { value: { reset: /* @__PURE__ */ o(() => Fle(e[zs]), "reset") } }), e[zs]), "K"), li = /* @__PURE__ */ o(
(e) => e[zs] || kle(e), "T");
function Dle(e) {
  Np(
    si("function", e) || si("undefined", e),
    "cannot spy on a non-function value"
  );
  let t = /* @__PURE__ */ o(function(...n) {
    let i = li(t);
    i.called = !0, i.callCount++, i.calls.push(n);
    let s = i.next.shift();
    if (s) {
      i.results.push(s);
      let [d, p] = s;
      if (d === "ok")
        return p;
      throw p;
    }
    let a, l = "ok", u = i.results.length;
    if (i.impl)
      try {
        new.target ? a = Reflect.construct(i.impl, n, new.target) : a = i.impl.apply(this, n), l = "ok";
      } catch (d) {
        throw a = d, l = "error", i.results.push([l, d]), d;
      }
    let c = [l, a];
    return jle(a) && a.then(
      (d) => i.resolves[u] = ["ok", d],
      (d) => i.resolves[u] = ["error", d]
    ), i.results.push(c), a;
  }, "t");
  ai(t, "_isMockFunction", !0), ai(t, "length", e ? e.length : 0), ai(t, "name", e && e.name || "spy");
  let r = li(t);
  return r.reset(), r.impl = e, t;
}
o(Dle, "m");
var DL = /* @__PURE__ */ o((e, t) => Object.getOwnPropertyDescriptor(e, t), "k"), $L = /* @__PURE__ */ o((e, t) => {
  t != null && typeof t == "function" && t.prototype != null && Object.setPrototypeOf(e.prototype, t.prototype);
}, "O");
function k_(e, t, r) {
  Np(
    !si("undefined", e),
    "spyOn could not find an object to spy upon"
  ), Np(
    si("object", e) || si("function", e),
    "cannot spyOn on a primitive value"
  );
  let [n, i] = (() => {
    if (!si("object", t))
      return [t, "value"];
    if ("getter" in t && "setter" in t)
      throw new Error("cannot spy on both getter and setter");
    if ("getter" in t)
      return [t.getter, "get"];
    if ("setter" in t)
      return [t.setter, "set"];
    throw new Error("specify getter or setter to spy on");
  })(), s = DL(e, n), a = Object.getPrototypeOf(e), l = a && DL(a, n), u = s || l;
  Np(
    u || n in e,
    `${String(n)} does not exist`
  );
  let c = !1;
  i === "value" && u && !u.value && u.get && (i = "get", c = !0, r = u.get());
  let d;
  u ? d = u[i] : i !== "value" ? d = /* @__PURE__ */ o(() => e[n], "o") : d = e[n];
  let p = /* @__PURE__ */ o((h) => {
    let { value: b, ...g } = u || {
      configurable: !0,
      writable: !0
    };
    i !== "value" && delete g.writable, g[i] = h, F_(e, n, g);
  }, "g"), y = /* @__PURE__ */ o(() => u ? F_(e, n, u) : p(d), "b");
  r || (r = d);
  let f = Dle(r);
  i === "value" && $L(f, d);
  let m = f[zs];
  return ai(m, "restore", y), ai(m, "getOriginal", () => c ? d() : d), ai(m, "willCall", (h) => (m.impl = h, f)), p(
    c ? () => ($L(f, r), f) : f
  ), Lle.add(f), f;
}
o(k_, "C");

// ../node_modules/@vitest/spy/dist/index.js
var ui = /* @__PURE__ */ new Set();
function Xr(e) {
  return typeof e == "function" && "_isMockFunction" in e && e._isMockFunction;
}
o(Xr, "isMockFunction");
function UL(e, t, r) {
  let i = r ? { [{
    get: "getter",
    set: "setter"
  }[r]]: t } : t, s = k_(e, i);
  return HL(s);
}
o(UL, "spyOn");
var $le = 0;
function HL(e) {
  let t = e, r, n = [], i = [], s = [], a = li(e), l = {
    get calls() {
      return a.calls;
    },
    get contexts() {
      return i;
    },
    get instances() {
      return n;
    },
    get invocationCallOrder() {
      return s;
    },
    get results() {
      return a.results.map(([f, m]) => ({ type: f === "error" ? "throw" : "return", value: m }));
    },
    get settledResults() {
      return a.resolves.map(([f, m]) => ({ type: f === "error" ? "rejected" : "fulfilled", value: m }));
    },
    get lastCall() {
      return a.calls[a.calls.length - 1];
    }
  }, u = [], c = !1;
  function d(...f) {
    return n.push(this), i.push(this), s.push(++$le), (c ? r : u.shift() || r || a.getOriginal() || (() => {
    })).apply(this, f);
  }
  o(d, "mockCall");
  let p = t.name;
  t.getMockName = () => p || "vi.fn()", t.mockName = (f) => (p = f, t), t.mockClear = () => (a.reset(), n = [], i = [], s = [], t), t.mockReset =
  () => (t.mockClear(), r = void 0, u = [], t), t.mockRestore = () => (t.mockReset(), a.restore(), t), t.getMockImplementation = () => c ? r :
  u.at(0) || r, t.mockImplementation = (f) => (r = f, a.willCall(d), t), t.mockImplementationOnce = (f) => (u.push(f), t);
  function y(f, m) {
    let h = r;
    r = f, a.willCall(d), c = !0;
    let b = /* @__PURE__ */ o(() => {
      r = h, c = !1;
    }, "reset"), g = m();
    return g instanceof Promise ? g.then(() => (b(), t)) : (b(), t);
  }
  return o(y, "withImplementation"), t.withImplementation = y, t.mockReturnThis = () => t.mockImplementation(function() {
    return this;
  }), t.mockReturnValue = (f) => t.mockImplementation(() => f), t.mockReturnValueOnce = (f) => t.mockImplementationOnce(() => f), t.mockResolvedValue =
  (f) => t.mockImplementation(() => Promise.resolve(f)), t.mockResolvedValueOnce = (f) => t.mockImplementationOnce(() => Promise.resolve(f)),
  t.mockRejectedValue = (f) => t.mockImplementation(() => Promise.reject(f)), t.mockRejectedValueOnce = (f) => t.mockImplementationOnce(() => Promise.
  reject(f)), Object.defineProperty(t, "mock", {
    get: /* @__PURE__ */ o(() => l, "get")
  }), a.willCall(d), ui.add(t), t;
}
o(HL, "enhanceSpy");
function D_(e) {
  let t = HL(k_({
    spy: e || function() {
    }
  }, "spy"));
  return e && t.mockImplementation(e), t;
}
o(D_, "fn");

// ../node_modules/@vitest/expect/node_modules/@vitest/utils/dist/error.js
var Ble = "@@__IMMUTABLE_RECORD__@@", Ule = "@@__IMMUTABLE_ITERABLE__@@";
function Hle(e) {
  return e && (e[Ule] || e[Ble]);
}
o(Hle, "isImmutable");
var Vle = Object.getPrototypeOf({});
function VL(e) {
  return e instanceof Error ? `<unserializable>: ${e.message}` : typeof e == "string" ? `<unserializable>: ${e}` : "<unserializable>";
}
o(VL, "getUnserializableMessage");
function ci(e, t = /* @__PURE__ */ new WeakMap()) {
  if (!e || typeof e == "string")
    return e;
  if (typeof e == "function")
    return `Function<${e.name || "anonymous"}>`;
  if (typeof e == "symbol")
    return e.toString();
  if (typeof e != "object")
    return e;
  if (Hle(e))
    return ci(e.toJSON(), t);
  if (e instanceof Promise || e.constructor && e.constructor.prototype === "AsyncFunction")
    return "Promise";
  if (typeof Element < "u" && e instanceof Element)
    return e.tagName;
  if (typeof e.asymmetricMatch == "function")
    return `${e.toString()} ${w_(e.sample)}`;
  if (typeof e.toJSON == "function")
    return ci(e.toJSON(), t);
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    let r = new Array(e.length);
    return t.set(e, r), e.forEach((n, i) => {
      try {
        r[i] = ci(n, t);
      } catch (s) {
        r[i] = VL(s);
      }
    }), r;
  } else {
    let r = /* @__PURE__ */ Object.create(null);
    t.set(e, r);
    let n = e;
    for (; n && n !== Vle; )
      Object.getOwnPropertyNames(n).forEach((i) => {
        if (!(i in r))
          try {
            r[i] = ci(e[i], t);
          } catch (s) {
            delete r[i], r[i] = VL(s);
          }
      }), n = Object.getPrototypeOf(n);
    return r;
  }
}
o(ci, "serializeValue");
function zle(e) {
  return e.replace(/__(vite_ssr_import|vi_import)_\d+__\./g, "");
}
o(zle, "normalizeErrorMessage");
function $_(e, t, r = /* @__PURE__ */ new WeakSet()) {
  if (!e || typeof e != "object")
    return { message: String(e) };
  let n = e;
  n.stack && (n.stackStr = String(n.stack)), n.name && (n.nameStr = String(n.name)), (n.showDiff || n.showDiff === void 0 && n.expected !== void 0 &&
  n.actual !== void 0) && (n.diff = Mp(n.actual, n.expected, {
    ...t,
    ...n.diffOptions
  })), typeof n.expected != "string" && (n.expected = tt(n.expected, 10)), typeof n.actual != "string" && (n.actual = tt(n.actual, 10));
  try {
    typeof n.message == "string" && (n.message = zle(n.message));
  } catch {
  }
  try {
    !r.has(n) && typeof n.cause == "object" && (r.add(n), n.cause = $_(n.cause, t, r));
  } catch {
  }
  try {
    return ci(n);
  } catch (i) {
    return ci(
      new Error(
        `Failed to fully serialize error: ${i?.message}
Inner error message: ${n?.message}`
      )
    );
  }
}
o($_, "processError");

// ../node_modules/@vitest/expect/dist/index.js
var Ws = Symbol.for("matchers-object"), Ks = Symbol.for("$$jest-matchers-object-storybook"), Up = Symbol.for("expect-global"), H_ = Symbol.for(
  "asymmetric-matchers-object"
), QL = {
  toSatisfy(e, t, r) {
    let { printReceived: n, printExpected: i, matcherHint: s } = this.utils, a = t(e);
    return {
      pass: a,
      message: /* @__PURE__ */ o(() => a ? `${s(".not.toSatisfy", "received", "")}

Expected value to not satisfy:
${r || i(t)}
Received:
${n(e)}` : `${s(".toSatisfy", "received", "")}

Expected value to satisfy:
${r || i(t)}

Received:
${n(e)}`, "message")
    };
  },
  toBeOneOf(e, t) {
    let { equals: r, customTesters: n } = this, { printReceived: i, printExpected: s, matcherHint: a } = this.utils;
    if (!Array.isArray(t))
      throw new TypeError(
        `You must provide an array to ${a(".toBeOneOf")}, not '${typeof t}'.`
      );
    let l = t.length === 0 || t.some(
      (u) => r(u, e, n)
    );
    return {
      pass: l,
      message: /* @__PURE__ */ o(() => l ? `${a(".not.toBeOneOf", "received", "")}

Expected value to not be one of:
${s(t)}
Received:
${i(e)}` : `${a(".toBeOneOf", "received", "")}

Expected value to be one of:
${s(t)}

Received:
${i(e)}`, "message")
    };
  }
}, jp = ae.green, Y_ = ae.red, Gle = ae.inverse, Yle = ae.bold, Jr = ae.dim;
function Wle(e, t = "received", r = "expected", n = {}) {
  let {
    comment: i = "",
    isDirectExpectCall: s = !1,
    // seems redundant with received === ''
    isNot: a = !1,
    promise: l = "",
    secondArgument: u = "",
    expectedColor: c = jp,
    receivedColor: d = Y_,
    secondArgumentColor: p = jp
  } = n, y = "", f = "expect";
  return !s && t !== "" && (y += Jr(`${f}(`) + d(t), f = ")"), l !== "" && (y += Jr(`${f}.`) + l, f = ""), a && (y += `${Jr(`${f}.`)}not`, f =
  ""), e.includes(".") ? f += e : (y += Jr(`${f}.`) + e, f = ""), r === "" ? f += "()" : (y += Jr(`${f}(`) + c(r), u && (y += Jr(", ") + p(u)),
  f = ")"), i !== "" && (f += ` // ${i}`), f !== "" && (y += Jr(f)), y;
}
o(Wle, "matcherHint");
var Kle = "\xB7";
function eF(e) {
  return e.replace(/\s+$/gm, (t) => Kle.repeat(t.length));
}
o(eF, "replaceTrailingSpaces");
function Xle(e) {
  return Y_(eF(tt(e)));
}
o(Xle, "printReceived");
function Jle(e) {
  return jp(eF(tt(e)));
}
o(Jle, "printExpected");
function tF() {
  return {
    EXPECTED_COLOR: jp,
    RECEIVED_COLOR: Y_,
    INVERTED_COLOR: Gle,
    BOLD_WEIGHT: Yle,
    DIM_COLOR: Jr,
    diff: kn,
    matcherHint: Wle,
    printReceived: Xle,
    printExpected: Jle,
    printDiffOrStringify: Mp
  };
}
o(tF, "getMatcherUtils");
function W_() {
  return globalThis[Ks].customEqualityTesters;
}
o(W_, "getCustomEqualityTesters");
function me(e, t, r, n) {
  return r = r || [], Gs(e, t, [], [], r, n ? rF : eue);
}
o(me, "equals");
var BDe = Function.prototype.toString;
function zL(e) {
  return !!e && typeof e == "object" && "asymmetricMatch" in e && Xt("Function", e.asymmetricMatch);
}
o(zL, "isAsymmetric");
function Zle(e, t) {
  let r = zL(e), n = zL(t);
  if (!(r && n)) {
    if (r)
      return e.asymmetricMatch(t);
    if (n)
      return t.asymmetricMatch(e);
  }
}
o(Zle, "asymmetricMatch");
function Gs(e, t, r, n, i, s) {
  let a = !0, l = Zle(e, t);
  if (l !== void 0)
    return l;
  let u = { equals: me };
  for (let m = 0; m < i.length; m++) {
    let h = i[m].call(
      u,
      e,
      t,
      i
    );
    if (h !== void 0)
      return h;
  }
  if (typeof URL == "function" && e instanceof URL && t instanceof URL)
    return e.href === t.href;
  if (Object.is(e, t))
    return !0;
  if (e === null || t === null)
    return e === t;
  let c = Object.prototype.toString.call(e);
  if (c !== Object.prototype.toString.call(t))
    return !1;
  switch (c) {
    case "[object Boolean]":
    case "[object String]":
    case "[object Number]":
      return typeof e != typeof t ? !1 : typeof e != "object" && typeof t != "object" ? Object.is(e, t) : Object.is(e.valueOf(), t.valueOf());
    case "[object Date]": {
      let m = +e, h = +t;
      return m === h || Number.isNaN(m) && Number.isNaN(h);
    }
    // RegExps are compared by their source patterns and flags.
    case "[object RegExp]":
      return e.source === t.source && e.flags === t.flags;
  }
  if (typeof e != "object" || typeof t != "object")
    return !1;
  if (YL(e) && YL(t))
    return e.isEqualNode(t);
  let d = r.length;
  for (; d--; ) {
    if (r[d] === e)
      return n[d] === t;
    if (n[d] === t)
      return !1;
  }
  if (r.push(e), n.push(t), c === "[object Array]" && e.length !== t.length)
    return !1;
  if (e instanceof Error && t instanceof Error)
    try {
      return Qle(e, t, r, n, i, s);
    } finally {
      r.pop(), n.pop();
    }
  let p = GL(e, s), y, f = p.length;
  if (GL(t, s).length !== f)
    return !1;
  for (; f--; )
    if (y = p[f], a = s(t, y) && Gs(e[y], t[y], r, n, i, s), !a)
      return !1;
  return r.pop(), n.pop(), a;
}
o(Gs, "eq");
function Qle(e, t, r, n, i, s) {
  let a = Object.getPrototypeOf(e) === Object.getPrototypeOf(t) && e.name === t.name && e.message === t.message;
  return typeof t.cause < "u" && a && (a = Gs(e.cause, t.cause, r, n, i, s)), e instanceof AggregateError && t instanceof AggregateError && a &&
  (a = Gs(e.errors, t.errors, r, n, i, s)), a && (a = Gs({ ...e }, { ...t }, r, n, i, s)), a;
}
o(Qle, "isErrorEqual");
function GL(e, t) {
  let r = [];
  for (let n in e)
    t(e, n) && r.push(n);
  return r.concat(
    Object.getOwnPropertySymbols(e).filter(
      (n) => Object.getOwnPropertyDescriptor(e, n).enumerable
    )
  );
}
o(GL, "keys");
function eue(e, t) {
  return rF(e, t) && e[t] !== void 0;
}
o(eue, "hasDefinedKey");
function rF(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
o(rF, "hasKey");
function Xt(e, t) {
  return Object.prototype.toString.apply(t) === `[object ${e}]`;
}
o(Xt, "isA");
function YL(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number" && "nodeName" in e && typeof e.nodeName == "\
string" && "isEqualNode" in e && typeof e.isEqualNode == "function";
}
o(YL, "isDomNode");
var nF = "@@__IMMUTABLE_KEYED__@@", oF = "@@__IMMUTABLE_SET__@@", tue = "@@__IMMUTABLE_LIST__@@", Hp = "@@__IMMUTABLE_ORDERED__@@", rue = "@\
@__IMMUTABLE_RECORD__@@";
function nue(e) {
  return !!(e && e[nF] && !e[Hp]);
}
o(nue, "isImmutableUnorderedKeyed");
function oue(e) {
  return !!(e && e[oF] && !e[Hp]);
}
o(oue, "isImmutableUnorderedSet");
function Vp(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
o(Vp, "isObjectLiteral");
function iue(e) {
  return !!(e && Vp(e) && e[tue]);
}
o(iue, "isImmutableList");
function sue(e) {
  return !!(e && Vp(e) && e[nF] && e[Hp]);
}
o(sue, "isImmutableOrderedKeyed");
function aue(e) {
  return !!(e && Vp(e) && e[oF] && e[Hp]);
}
o(aue, "isImmutableOrderedSet");
function lue(e) {
  return !!(e && Vp(e) && e[rue]);
}
o(lue, "isImmutableRecord");
var iF = Symbol.iterator;
function WL(e) {
  return !!(e != null && e[iF]);
}
o(WL, "hasIterator");
function kt(e, t, r = [], n = [], i = []) {
  if (typeof e != "object" || typeof t != "object" || Array.isArray(e) || Array.isArray(t) || !WL(e) || !WL(t))
    return;
  if (e.constructor !== t.constructor)
    return !1;
  let s = n.length;
  for (; s--; )
    if (n[s] === e)
      return i[s] === t;
  n.push(e), i.push(t);
  let a = [
    ...r.filter((c) => c !== kt),
    l
  ];
  function l(c, d) {
    return kt(c, d, [...r], [...n], [...i]);
  }
  if (o(l, "iterableEqualityWithStack"), e.size !== void 0) {
    if (e.size !== t.size)
      return !1;
    if (Xt("Set", e) || oue(e)) {
      let c = !0;
      for (let d of e)
        if (!t.has(d)) {
          let p = !1;
          for (let y of t)
            me(d, y, a) === !0 && (p = !0);
          if (p === !1) {
            c = !1;
            break;
          }
        }
      return n.pop(), i.pop(), c;
    } else if (Xt("Map", e) || nue(e)) {
      let c = !0;
      for (let d of e)
        if (!t.has(d[0]) || !me(d[1], t.get(d[0]), a)) {
          let p = !1;
          for (let y of t) {
            let f = me(
              d[0],
              y[0],
              a
            ), m = !1;
            f === !0 && (m = me(
              d[1],
              y[1],
              a
            )), m === !0 && (p = !0);
          }
          if (p === !1) {
            c = !1;
            break;
          }
        }
      return n.pop(), i.pop(), c;
    }
  }
  let u = t[iF]();
  for (let c of e) {
    let d = u.next();
    if (d.done || !me(c, d.value, a))
      return !1;
  }
  if (!u.next().done)
    return !1;
  if (!iue(e) && !sue(e) && !aue(e) && !lue(e)) {
    let c = Object.entries(e), d = Object.entries(t);
    if (!me(c, d))
      return !1;
  }
  return n.pop(), i.pop(), !0;
}
o(kt, "iterableEquality");
function K_(e, t) {
  return !e || typeof e != "object" || e === Object.prototype ? !1 : Object.prototype.hasOwnProperty.call(e, t) || K_(Object.getPrototypeOf(
  e), t);
}
o(K_, "hasPropertyInObject");
function uue(e) {
  return ni(e) && !(e instanceof Error) && !Array.isArray(e) && !(e instanceof Date);
}
o(uue, "isObjectWithKeys");
function Xs(e, t, r = []) {
  let n = r.filter(
    (s) => s !== Xs
  ), i = /* @__PURE__ */ o((s = /* @__PURE__ */ new WeakMap()) => (a, l) => {
    if (uue(l))
      return Object.keys(l).every((u) => {
        if (l[u] != null && typeof l[u] == "object") {
          if (s.has(l[u]))
            return me(a[u], l[u], n);
          s.set(l[u], !0);
        }
        let c = a != null && K_(a, u) && me(a[u], l[u], [
          ...n,
          i(s)
        ]);
        return s.delete(l[u]), c;
      });
  }, "subsetEqualityWithContext");
  return i()(e, t);
}
o(Xs, "subsetEquality");
function KL(e, t) {
  if (!(e == null || t == null || e.constructor === t.constructor))
    return !1;
}
o(KL, "typeEquality");
function XL(e, t) {
  let r = e, n = t;
  if (!(e instanceof DataView && t instanceof DataView)) {
    if (!(e instanceof ArrayBuffer) || !(t instanceof ArrayBuffer))
      return;
    try {
      r = new DataView(e), n = new DataView(t);
    } catch {
      return;
    }
  }
  if (r.byteLength !== n.byteLength)
    return !1;
  for (let i = 0; i < r.byteLength; i++)
    if (r.getUint8(i) !== n.getUint8(i))
      return !1;
  return !0;
}
o(XL, "arrayBufferEquality");
function V_(e, t, r = []) {
  if (!Array.isArray(e) || !Array.isArray(t))
    return;
  let n = Object.keys(e), i = Object.keys(t), s = r.filter(
    (a) => a !== V_
  );
  return me(e, t, s, !0) && me(n, i);
}
o(V_, "sparseArrayEquality");
function cue(e, t = "#{this}", r = "#{exp}") {
  let n = `expected ${t} to be ${r} // Object.is equality`;
  return ["toStrictEqual", "toEqual"].includes(e) ? `${n}

If it should pass with deep equality, replace "toBe" with "${e}"

Expected: ${t}
Received: serializes to the same string
` : n;
}
o(cue, "generateToBeMessage");
function due(e, t) {
  return `${t} ${e}${t === 1 ? "" : "s"}`;
}
o(due, "pluralize");
function B_(e) {
  return [
    ...Object.keys(e),
    ...Object.getOwnPropertySymbols(e).filter(
      (t) => {
        var r;
        return (r = Object.getOwnPropertyDescriptor(e, t)) == null ? void 0 : r.enumerable;
      }
    )
  ];
}
o(B_, "getObjectKeys");
function pue(e, t, r) {
  let n = 0, i = /* @__PURE__ */ o((s = /* @__PURE__ */ new WeakMap()) => (a, l) => {
    if (Array.isArray(a)) {
      if (Array.isArray(l) && l.length === a.length)
        return l.map(
          (u, c) => i(s)(a[c], u)
        );
    } else {
      if (a instanceof Date)
        return a;
      if (ni(a) && ni(l)) {
        if (me(a, l, [
          ...r,
          kt,
          Xs
        ]))
          return l;
        let u = {};
        s.set(a, u), typeof a.constructor == "function" && typeof a.constructor.name == "string" && Object.defineProperty(u, "constructor", {
          enumerable: !1,
          value: a.constructor
        });
        for (let c of B_(a))
          K_(l, c) ? u[c] = s.has(a[c]) ? s.get(a[c]) : i(s)(
            a[c],
            l[c]
          ) : s.has(a[c]) || (n += 1, ni(a[c]) && (n += B_(a[c]).length), i(s)(
            a[c],
            l[c]
          ));
        if (B_(u).length > 0)
          return u;
      }
    }
    return a;
  }, "getObjectSubsetWithContext");
  return { subset: i()(e, t), stripped: n };
}
o(pue, "getObjectSubset");
if (!Object.prototype.hasOwnProperty.call(globalThis, Ws)) {
  let e = /* @__PURE__ */ new WeakMap();
  Object.defineProperty(globalThis, Ws, {
    get: /* @__PURE__ */ o(() => e, "get")
  });
}
if (!Object.prototype.hasOwnProperty.call(globalThis, Ks)) {
  let e = /* @__PURE__ */ Object.create(null), t = [];
  Object.defineProperty(globalThis, Ks, {
    configurable: !0,
    get: /* @__PURE__ */ o(() => ({
      state: globalThis[Ws].get(globalThis[Up]),
      matchers: e,
      customEqualityTesters: t
    }), "get")
  });
}
if (!Object.prototype.hasOwnProperty.call(globalThis, H_)) {
  let e = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(globalThis, H_, {
    get: /* @__PURE__ */ o(() => e, "get")
  });
}
function Js(e) {
  return globalThis[Ws].get(e);
}
o(Js, "getState");
function zp(e, t) {
  let r = globalThis[Ws], n = r.get(t) || {}, i = Object.defineProperties(n, {
    ...Object.getOwnPropertyDescriptors(n),
    ...Object.getOwnPropertyDescriptors(e)
  });
  r.set(t, i);
}
o(zp, "setState");
var X_ = class X_ {
  constructor(t, r = !1) {
    this.sample = t, this.inverse = r;
  }
  // should have "jest" to be compatible with its ecosystem
  $$typeof = Symbol.for("jest.asymmetricMatcher");
  getMatcherContext(t) {
    return {
      ...Js(t || globalThis[Up]),
      equals: me,
      isNot: this.inverse,
      customTesters: W_(),
      utils: {
        ...tF(),
        diff: kn,
        stringify: tt,
        iterableEquality: kt,
        subsetEquality: Xs
      }
    };
  }
};
o(X_, "AsymmetricMatcher");
var Jt = X_;
Jt.prototype[Symbol.for("chai/inspect")] = function(e) {
  let t = tt(this, e.depth, { min: !0 });
  return t.length <= e.truncate ? t : `${this.toString()}{\u2026}`;
};
var J_ = class J_ extends Jt {
  constructor(t, r = !1) {
    if (!Xt("String", t))
      throw new Error("Expected is not a string");
    super(t, r);
  }
  asymmetricMatch(t) {
    let r = Xt("String", t) && t.includes(this.sample);
    return this.inverse ? !r : r;
  }
  toString() {
    return `String${this.inverse ? "Not" : ""}Containing`;
  }
  getExpectedType() {
    return "string";
  }
};
o(J_, "StringContaining");
var Lp = J_, Z_ = class Z_ extends Jt {
  asymmetricMatch(t) {
    return t != null;
  }
  toString() {
    return "Anything";
  }
  toAsymmetricMatcher() {
    return "Anything";
  }
};
o(Z_, "Anything");
var z_ = Z_, Q_ = class Q_ extends Jt {
  constructor(t, r = !1) {
    super(t, r);
  }
  getPrototype(t) {
    return Object.getPrototypeOf ? Object.getPrototypeOf(t) : t.constructor.prototype === t ? null : t.constructor.prototype;
  }
  hasProperty(t, r) {
    return t ? Object.prototype.hasOwnProperty.call(t, r) ? !0 : this.hasProperty(this.getPrototype(t), r) : !1;
  }
  asymmetricMatch(t) {
    if (typeof this.sample != "object")
      throw new TypeError(
        `You must provide an object to ${this.toString()}, not '${typeof this.sample}'.`
      );
    let r = !0, n = this.getMatcherContext();
    for (let i in this.sample)
      if (!this.hasProperty(t, i) || !me(
        this.sample[i],
        t[i],
        n.customTesters
      )) {
        r = !1;
        break;
      }
    return this.inverse ? !r : r;
  }
  toString() {
    return `Object${this.inverse ? "Not" : ""}Containing`;
  }
  getExpectedType() {
    return "object";
  }
};
o(Q_, "ObjectContaining");
var Fp = Q_, eR = class eR extends Jt {
  constructor(t, r = !1) {
    super(t, r);
  }
  asymmetricMatch(t) {
    if (!Array.isArray(this.sample))
      throw new TypeError(
        `You must provide an array to ${this.toString()}, not '${typeof this.sample}'.`
      );
    let r = this.getMatcherContext(), n = this.sample.length === 0 || Array.isArray(t) && this.sample.every(
      (i) => t.some(
        (s) => me(i, s, r.customTesters)
      )
    );
    return this.inverse ? !n : n;
  }
  toString() {
    return `Array${this.inverse ? "Not" : ""}Containing`;
  }
  getExpectedType() {
    return "array";
  }
};
o(eR, "ArrayContaining");
var kp = eR, tR = class tR extends Jt {
  constructor(t) {
    if (typeof t > "u")
      throw new TypeError(
        "any() expects to be passed a constructor function. Please pass one or use anything() to match any object."
      );
    super(t);
  }
  fnNameFor(t) {
    if (t.name)
      return t.name;
    let n = Function.prototype.toString.call(t).match(/^(?:async)?\s*function\s*(?:\*\s*)?([\w$]+)\s*\(/);
    return n ? n[1] : "<anonymous>";
  }
  asymmetricMatch(t) {
    return this.sample === String ? typeof t == "string" || t instanceof String : this.sample === Number ? typeof t == "number" || t instanceof
    Number : this.sample === Function ? typeof t == "function" || typeof t == "function" : this.sample === Boolean ? typeof t == "boolean" ||
    t instanceof Boolean : this.sample === BigInt ? typeof t == "bigint" || t instanceof BigInt : this.sample === Symbol ? typeof t == "symb\
ol" || t instanceof Symbol : this.sample === Object ? typeof t == "object" : t instanceof this.sample;
  }
  toString() {
    return "Any";
  }
  getExpectedType() {
    return this.sample === String ? "string" : this.sample === Number ? "number" : this.sample === Function ? "function" : this.sample === Object ?
    "object" : this.sample === Boolean ? "boolean" : this.fnNameFor(this.sample);
  }
  toAsymmetricMatcher() {
    return `Any<${this.fnNameFor(this.sample)}>`;
  }
};
o(tR, "Any");
var G_ = tR, rR = class rR extends Jt {
  constructor(t, r = !1) {
    if (!Xt("String", t) && !Xt("RegExp", t))
      throw new Error("Expected is not a String or a RegExp");
    super(new RegExp(t), r);
  }
  asymmetricMatch(t) {
    let r = Xt("String", t) && this.sample.test(t);
    return this.inverse ? !r : r;
  }
  toString() {
    return `String${this.inverse ? "Not" : ""}Matching`;
  }
  getExpectedType() {
    return "string";
  }
};
o(rR, "StringMatching");
var Dp = rR, nR = class nR extends Jt {
  precision;
  constructor(t, r = 2, n = !1) {
    if (!Xt("Number", t))
      throw new Error("Expected is not a Number");
    if (!Xt("Number", r))
      throw new Error("Precision is not a Number");
    super(t), this.inverse = n, this.precision = r;
  }
  asymmetricMatch(t) {
    if (!Xt("Number", t))
      return !1;
    let r = !1;
    return t === Number.POSITIVE_INFINITY && this.sample === Number.POSITIVE_INFINITY || t === Number.NEGATIVE_INFINITY && this.sample === Number.
    NEGATIVE_INFINITY ? r = !0 : r = Math.abs(this.sample - t) < 10 ** -this.precision / 2, this.inverse ? !r : r;
  }
  toString() {
    return `Number${this.inverse ? "Not" : ""}CloseTo`;
  }
  getExpectedType() {
    return "number";
  }
  toAsymmetricMatcher() {
    return [
      this.toString(),
      this.sample,
      `(${due("digit", this.precision)})`
    ].join(" ");
  }
};
o(nR, "CloseTo");
var $p = nR, sF = /* @__PURE__ */ o((e, t) => {
  t.addMethod(e.expect, "anything", () => new z_()), t.addMethod(e.expect, "any", (r) => new G_(r)), t.addMethod(
    e.expect,
    "stringContaining",
    (r) => new Lp(r)
  ), t.addMethod(
    e.expect,
    "objectContaining",
    (r) => new Fp(r)
  ), t.addMethod(
    e.expect,
    "arrayContaining",
    (r) => new kp(r)
  ), t.addMethod(
    e.expect,
    "stringMatching",
    (r) => new Dp(r)
  ), t.addMethod(
    e.expect,
    "closeTo",
    (r, n) => new $p(r, n)
  ), e.expect.not = {
    stringContaining: /* @__PURE__ */ o((r) => new Lp(r, !0), "stringContaining"),
    objectContaining: /* @__PURE__ */ o((r) => new Fp(r, !0), "objectContaining"),
    arrayContaining: /* @__PURE__ */ o((r) => new kp(r, !0), "arrayContaining"),
    stringMatching: /* @__PURE__ */ o((r) => new Dp(r, !0), "stringMatching"),
    closeTo: /* @__PURE__ */ o((r, n) => new $p(r, n, !0), "closeTo")
  };
}, "JestAsymmetricMatchers");
function JL(e, t, r) {
  let n = e.flag(t, "negate") ? "not." : "", i = `${e.flag(t, "_name")}(${r ? "expected" : ""})`, s = e.flag(t, "promise");
  return `expect(actual)${s ? `.${s}` : ""}.${n}${i}`;
}
o(JL, "createAssertionMessage");
function ZL(e, t, r, n) {
  let i = e;
  if (i && t instanceof Promise) {
    t = t.finally(() => {
      if (!i.promises)
        return;
      let a = i.promises.indexOf(t);
      a !== -1 && i.promises.splice(a, 1);
    }), i.promises || (i.promises = []), i.promises.push(t);
    let s = !1;
    return i.onFinished ?? (i.onFinished = []), i.onFinished.push(() => {
      var a;
      if (!s) {
        let u = (((a = globalThis.__vitest_worker__) == null ? void 0 : a.onFilterStackTrace) || ((c) => c || ""))(n.stack);
        console.warn([
          `Promise returned by \`${r}\` was not awaited. `,
          "Vitest currently auto-awaits hanging assertions at the end of the test, but this will cause the test to fail in Vitest 3. ",
          `Please remember to await the assertion.
`,
          u
        ].join(""));
      }
    }), {
      then(a, l) {
        return s = !0, t.then(a, l);
      },
      catch(a) {
        return t.catch(a);
      },
      finally(a) {
        return t.finally(a);
      },
      [Symbol.toStringTag]: "Promise"
    };
  }
  return t;
}
o(ZL, "recordAsyncExpect");
function aF(e, t, r) {
  return function(...n) {
    var i;
    if (t !== "withTest" && e.flag(this, "_name", t), !e.flag(this, "soft"))
      return r.apply(this, n);
    let s = e.flag(this, "vitest-test");
    if (!s)
      throw new Error("expect.soft() can only be used inside a test");
    try {
      return r.apply(this, n);
    } catch (a) {
      s.result || (s.result = { state: "fail" }), s.result.state = "fail", (i = s.result).errors || (i.errors = []), s.result.errors.push($_(
      a));
    }
  };
}
o(aF, "wrapAssertion");
var lF = /* @__PURE__ */ o((e, t) => {
  let { AssertionError: r } = e, n = W_();
  function i(c, d) {
    let p = /* @__PURE__ */ o((y) => {
      let f = aF(t, y, d);
      t.addMethod(e.Assertion.prototype, y, f), t.addMethod(
        globalThis[Ks].matchers,
        y,
        f
      );
    }, "addMethod");
    Array.isArray(c) ? c.forEach((y) => p(y)) : p(c);
  }
  o(i, "def"), ["throw", "throws", "Throw"].forEach((c) => {
    t.overwriteMethod(e.Assertion.prototype, c, (d) => function(...p) {
      let y = t.flag(this, "promise"), f = t.flag(this, "object"), m = t.flag(this, "negate");
      if (y === "rejects")
        t.flag(this, "object", () => {
          throw f;
        });
      else if (y === "resolves" && typeof f != "function") {
        if (m)
          return;
        {
          let h = t.flag(this, "message") || "expected promise to throw an error, but it didn't", b = {
            showDiff: !1
          };
          throw new r(h, b, t.flag(this, "ssfi"));
        }
      }
      d.apply(this, p);
    });
  }), i("withTest", function(c) {
    return t.flag(this, "vitest-test", c), this;
  }), i("toEqual", function(c) {
    let d = t.flag(this, "object"), p = me(d, c, [
      ...n,
      kt
    ]);
    return this.assert(
      p,
      "expected #{this} to deeply equal #{exp}",
      "expected #{this} to not deeply equal #{exp}",
      c,
      d
    );
  }), i("toStrictEqual", function(c) {
    let d = t.flag(this, "object"), p = me(
      d,
      c,
      [
        ...n,
        kt,
        KL,
        V_,
        XL
      ],
      !0
    );
    return this.assert(
      p,
      "expected #{this} to strictly equal #{exp}",
      "expected #{this} to not strictly equal #{exp}",
      c,
      d
    );
  }), i("toBe", function(c) {
    let d = this._obj, p = Object.is(d, c), y = "";
    return p || (me(
      d,
      c,
      [
        ...n,
        kt,
        KL,
        V_,
        XL
      ],
      !0
    ) ? y = "toStrictEqual" : me(d, c, [
      ...n,
      kt
    ]) && (y = "toEqual")), this.assert(
      p,
      cue(y),
      "expected #{this} not to be #{exp} // Object.is equality",
      c,
      d
    );
  }), i("toMatchObject", function(c) {
    let d = this._obj, p = me(d, c, [
      ...n,
      kt,
      Xs
    ]), y = t.flag(this, "negate"), { subset: f, stripped: m } = pue(
      d,
      c,
      n
    );
    if (p && y || !p && !y) {
      let h = t.getMessage(this, [
        p,
        "expected #{this} to match object #{exp}",
        "expected #{this} to not match object #{exp}",
        c,
        f,
        !1
      ]), b = m === 0 ? h : `${h}
(${m} matching ${m === 1 ? "property" : "properties"} omitted from actual)`;
      throw new r(b, {
        showDiff: !0,
        expected: c,
        actual: f
      });
    }
  }), i("toMatch", function(c) {
    let d = this._obj;
    if (typeof d != "string")
      throw new TypeError(
        `.toMatch() expects to receive a string, but got ${typeof d}`
      );
    return this.assert(
      typeof c == "string" ? d.includes(c) : d.match(c),
      "expected #{this} to match #{exp}",
      "expected #{this} not to match #{exp}",
      c,
      d
    );
  }), i("toContain", function(c) {
    let d = this._obj;
    if (typeof Node < "u" && d instanceof Node) {
      if (!(c instanceof Node))
        throw new TypeError(
          `toContain() expected a DOM node as the argument, but got ${typeof c}`
        );
      return this.assert(
        d.contains(c),
        "expected #{this} to contain element #{exp}",
        "expected #{this} not to contain element #{exp}",
        c,
        d
      );
    }
    if (typeof DOMTokenList < "u" && d instanceof DOMTokenList) {
      Kt(c, "class name", ["string"]);
      let y = t.flag(this, "negate") ? d.value.replace(c, "").trim() : `${d.value} ${c}`;
      return this.assert(
        d.contains(c),
        `expected "${d.value}" to contain "${c}"`,
        `expected "${d.value}" not to contain "${c}"`,
        y,
        d.value
      );
    }
    return typeof d == "string" && typeof c == "string" ? this.assert(
      d.includes(c),
      "expected #{this} to contain #{exp}",
      "expected #{this} not to contain #{exp}",
      c,
      d
    ) : (d != null && typeof d != "string" && t.flag(this, "object", Array.from(d)), this.contain(c));
  }), i("toContainEqual", function(c) {
    let d = t.flag(this, "object"), p = Array.from(d).findIndex((y) => me(y, c, n));
    this.assert(
      p !== -1,
      "expected #{this} to deep equally contain #{exp}",
      "expected #{this} to not deep equally contain #{exp}",
      c
    );
  }), i("toBeTruthy", function() {
    let c = t.flag(this, "object");
    this.assert(
      !!c,
      "expected #{this} to be truthy",
      "expected #{this} to not be truthy",
      !0,
      c
    );
  }), i("toBeFalsy", function() {
    let c = t.flag(this, "object");
    this.assert(
      !c,
      "expected #{this} to be falsy",
      "expected #{this} to not be falsy",
      !1,
      c
    );
  }), i("toBeGreaterThan", function(c) {
    let d = this._obj;
    return Kt(d, "actual", ["number", "bigint"]), Kt(c, "expected", ["number", "bigint"]), this.assert(
      d > c,
      `expected ${d} to be greater than ${c}`,
      `expected ${d} to be not greater than ${c}`,
      c,
      d,
      !1
    );
  }), i("toBeGreaterThanOrEqual", function(c) {
    let d = this._obj;
    return Kt(d, "actual", ["number", "bigint"]), Kt(c, "expected", ["number", "bigint"]), this.assert(
      d >= c,
      `expected ${d} to be greater than or equal to ${c}`,
      `expected ${d} to be not greater than or equal to ${c}`,
      c,
      d,
      !1
    );
  }), i("toBeLessThan", function(c) {
    let d = this._obj;
    return Kt(d, "actual", ["number", "bigint"]), Kt(c, "expected", ["number", "bigint"]), this.assert(
      d < c,
      `expected ${d} to be less than ${c}`,
      `expected ${d} to be not less than ${c}`,
      c,
      d,
      !1
    );
  }), i("toBeLessThanOrEqual", function(c) {
    let d = this._obj;
    return Kt(d, "actual", ["number", "bigint"]), Kt(c, "expected", ["number", "bigint"]), this.assert(
      d <= c,
      `expected ${d} to be less than or equal to ${c}`,
      `expected ${d} to be not less than or equal to ${c}`,
      c,
      d,
      !1
    );
  }), i("toBeNaN", function() {
    let c = t.flag(this, "object");
    this.assert(
      Number.isNaN(c),
      "expected #{this} to be NaN",
      "expected #{this} not to be NaN",
      Number.NaN,
      c
    );
  }), i("toBeUndefined", function() {
    let c = t.flag(this, "object");
    this.assert(
      c === void 0,
      "expected #{this} to be undefined",
      "expected #{this} not to be undefined",
      void 0,
      c
    );
  }), i("toBeNull", function() {
    let c = t.flag(this, "object");
    this.assert(
      c === null,
      "expected #{this} to be null",
      "expected #{this} not to be null",
      null,
      c
    );
  }), i("toBeDefined", function() {
    let c = t.flag(this, "object");
    this.assert(
      typeof c < "u",
      "expected #{this} to be defined",
      "expected #{this} to be undefined",
      c
    );
  }), i(
    "toBeTypeOf",
    function(c) {
      let d = typeof this._obj, p = c === d;
      return this.assert(
        p,
        "expected #{this} to be type of #{exp}",
        "expected #{this} not to be type of #{exp}",
        c,
        d
      );
    }
  ), i("toBeInstanceOf", function(c) {
    return this.instanceOf(c);
  }), i("toHaveLength", function(c) {
    return this.have.length(c);
  }), i(
    "toHaveProperty",
    function(...c) {
      Array.isArray(c[0]) && (c[0] = c[0].map((T) => String(T).replace(/([.[\]])/g, "\\$1")).join("."));
      let d = this._obj, [p, y] = c, f = /* @__PURE__ */ o(() => Object.prototype.hasOwnProperty.call(
        d,
        p
      ) ? { value: d[p], exists: !0 } : t.getPathInfo(d, p), "getValue"), { value: m, exists: h } = f(), b = h && (c.length === 1 || me(y, m,
      n)), g = c.length === 1 ? "" : ` with value ${t.objDisplay(y)}`;
      return this.assert(
        b,
        `expected #{this} to have property "${p}"${g}`,
        `expected #{this} to not have property "${p}"${g}`,
        y,
        h ? m : void 0
      );
    }
  ), i("toBeCloseTo", function(c, d = 2) {
    let p = this._obj, y = !1, f = 0, m = 0;
    return c === Number.POSITIVE_INFINITY && p === Number.POSITIVE_INFINITY || c === Number.NEGATIVE_INFINITY && p === Number.NEGATIVE_INFINITY ?
    y = !0 : (f = 10 ** -d / 2, m = Math.abs(p - c), y = m < f), this.assert(
      y,
      `expected #{this} to be close to #{exp}, received difference is ${m}, but expected ${f}`,
      `expected #{this} to not be close to #{exp}, received difference is ${m}, but expected ${f}`,
      c,
      p,
      !1
    );
  });
  function s(c) {
    if (!Xr(c._obj))
      throw new TypeError(
        `${t.inspect(c._obj)} is not a spy or a call to a spy!`
      );
  }
  o(s, "assertIsMock");
  function a(c) {
    return s(c), c._obj;
  }
  o(a, "getSpy"), i(["toHaveBeenCalledTimes", "toBeCalledTimes"], function(c) {
    let d = a(this), p = d.getMockName(), y = d.mock.calls.length;
    return this.assert(
      y === c,
      `expected "${p}" to be called #{exp} times, but got ${y} times`,
      `expected "${p}" to not be called #{exp} times`,
      c,
      y,
      !1
    );
  }), i("toHaveBeenCalledOnce", function() {
    let c = a(this), d = c.getMockName(), p = c.mock.calls.length;
    return this.assert(
      p === 1,
      `expected "${d}" to be called once, but got ${p} times`,
      `expected "${d}" to not be called once`,
      1,
      p,
      !1
    );
  }), i(["toHaveBeenCalled", "toBeCalled"], function() {
    let c = a(this), d = c.getMockName(), p = c.mock.calls.length, y = p > 0, f = t.flag(this, "negate"), m = t.getMessage(this, [
      y,
      `expected "${d}" to be called at least once`,
      `expected "${d}" to not be called at all, but actually been called ${p} times`,
      !0,
      y
    ]);
    if (y && f && (m = U_(c, m)), y && f || !y && !f)
      throw new r(m);
  });
  function l(c, d) {
    return c.length === d.length && c.every(
      (p, y) => me(p, d[y], [...n, kt])
    );
  }
  o(l, "equalsArgumentArray"), i(["toHaveBeenCalledWith", "toBeCalledWith"], function(...c) {
    let d = a(this), p = d.getMockName(), y = d.mock.calls.some((h) => l(h, c)), f = t.flag(this, "negate"), m = t.getMessage(this, [
      y,
      `expected "${p}" to be called with arguments: #{exp}`,
      `expected "${p}" to not be called with arguments: #{exp}`,
      c
    ]);
    if (y && f || !y && !f)
      throw new r(U_(d, m, c));
  }), i("toHaveBeenCalledExactlyOnceWith", function(...c) {
    let d = a(this), p = d.getMockName(), y = d.mock.calls.length, m = d.mock.calls.some((g) => l(g, c)) && y === 1, h = t.flag(this, "negat\
e"), b = t.getMessage(this, [
      m,
      `expected "${p}" to be called once with arguments: #{exp}`,
      `expected "${p}" to not be called once with arguments: #{exp}`,
      c
    ]);
    if (m && h || !m && !h)
      throw new r(U_(d, b, c));
  }), i(
    ["toHaveBeenNthCalledWith", "nthCalledWith"],
    function(c, ...d) {
      let p = a(this), y = p.getMockName(), f = p.mock.calls[c - 1], m = p.mock.calls.length, h = c <= m;
      this.assert(
        f && l(f, d),
        `expected ${Ys(
          c
        )} "${y}" call to have been called with #{exp}${h ? "" : `, but called only ${m} times`}`,
        `expected ${Ys(
          c
        )} "${y}" call to not have been called with #{exp}`,
        d,
        f,
        h
      );
    }
  ), i(
    ["toHaveBeenLastCalledWith", "lastCalledWith"],
    function(...c) {
      let d = a(this), p = d.getMockName(), y = d.mock.calls[d.mock.calls.length - 1];
      this.assert(
        y && l(y, c),
        `expected last "${p}" call to have been called with #{exp}`,
        `expected last "${p}" call to not have been called with #{exp}`,
        c,
        y
      );
    }
  );
  function u(c, d, p) {
    let y = c.mock.invocationCallOrder, f = d.mock.invocationCallOrder;
    return y.length === 0 ? !p : f.length === 0 ? !1 : y[0] < f[0];
  }
  o(u, "isSpyCalledBeforeAnotherSpy"), i(
    ["toHaveBeenCalledBefore"],
    function(c, d = !0) {
      let p = a(this);
      if (!Xr(c))
        throw new TypeError(
          `${t.inspect(c)} is not a spy or a call to a spy`
        );
      this.assert(
        u(
          p,
          c,
          d
        ),
        `expected "${p.getMockName()}" to have been called before "${c.getMockName()}"`,
        `expected "${p.getMockName()}" to not have been called before "${c.getMockName()}"`,
        c,
        p
      );
    }
  ), i(
    ["toHaveBeenCalledAfter"],
    function(c, d = !0) {
      let p = a(this);
      if (!Xr(c))
        throw new TypeError(
          `${t.inspect(c)} is not a spy or a call to a spy`
        );
      this.assert(
        u(
          c,
          p,
          d
        ),
        `expected "${p.getMockName()}" to have been called after "${c.getMockName()}"`,
        `expected "${p.getMockName()}" to not have been called after "${c.getMockName()}"`,
        c,
        p
      );
    }
  ), i(
    ["toThrow", "toThrowError"],
    function(c) {
      if (typeof c == "string" || typeof c > "u" || c instanceof RegExp)
        return this.throws(c === "" ? /^$/ : c);
      let d = this._obj, p = t.flag(this, "promise"), y = t.flag(this, "negate"), f = null;
      if (p === "rejects")
        f = d;
      else if (p === "resolves" && typeof d != "function") {
        if (y)
          return;
        {
          let m = t.flag(this, "message") || "expected promise to throw an error, but it didn't", h = {
            showDiff: !1
          };
          throw new r(m, h, t.flag(this, "ssfi"));
        }
      } else {
        let m = !1;
        try {
          d();
        } catch (h) {
          m = !0, f = h;
        }
        if (!m && !y) {
          let h = t.flag(this, "message") || "expected function to throw an error, but it didn't", b = {
            showDiff: !1
          };
          throw new r(h, b, t.flag(this, "ssfi"));
        }
      }
      if (typeof c == "function") {
        let m = c.name || c.prototype.constructor.name;
        return this.assert(
          f && f instanceof c,
          `expected error to be instance of ${m}`,
          `expected error not to be instance of ${m}`,
          c,
          f
        );
      }
      if (c instanceof Error) {
        let m = me(f, c, [
          ...n,
          kt
        ]);
        return this.assert(
          m,
          "expected a thrown error to be #{exp}",
          "expected a thrown error not to be #{exp}",
          c,
          f
        );
      }
      if (typeof c == "object" && "asymmetricMatch" in c && typeof c.asymmetricMatch == "function") {
        let m = c;
        return this.assert(
          f && m.asymmetricMatch(f),
          "expected error to match asymmetric matcher",
          "expected error not to match asymmetric matcher",
          m,
          f
        );
      }
      throw new Error(
        `"toThrow" expects string, RegExp, function, Error instance or asymmetric matcher, got "${typeof c}"`
      );
    }
  ), [
    {
      name: "toHaveResolved",
      condition: /* @__PURE__ */ o((c) => c.mock.settledResults.length > 0 && c.mock.settledResults.some(({ type: d }) => d === "fulfilled"),
      "condition"),
      action: "resolved"
    },
    {
      name: ["toHaveReturned", "toReturn"],
      condition: /* @__PURE__ */ o((c) => c.mock.calls.length > 0 && c.mock.results.some(({ type: d }) => d !== "throw"), "condition"),
      action: "called"
    }
  ].forEach(({ name: c, condition: d, action: p }) => {
    i(c, function() {
      let y = a(this), f = y.getMockName(), m = d(y);
      this.assert(
        m,
        `expected "${f}" to be successfully ${p} at least once`,
        `expected "${f}" to not be successfully ${p}`,
        m,
        !m,
        !1
      );
    });
  }), [
    {
      name: "toHaveResolvedTimes",
      condition: /* @__PURE__ */ o((c, d) => c.mock.settledResults.reduce(
        (p, { type: y }) => y === "fulfilled" ? ++p : p,
        0
      ) === d, "condition"),
      action: "resolved"
    },
    {
      name: ["toHaveReturnedTimes", "toReturnTimes"],
      condition: /* @__PURE__ */ o((c, d) => c.mock.results.reduce(
        (p, { type: y }) => y === "throw" ? p : ++p,
        0
      ) === d, "condition"),
      action: "called"
    }
  ].forEach(({ name: c, condition: d, action: p }) => {
    i(c, function(y) {
      let f = a(this), m = f.getMockName(), h = d(f, y);
      this.assert(
        h,
        `expected "${m}" to be successfully ${p} ${y} times`,
        `expected "${m}" to not be successfully ${p} ${y} times`,
        `expected resolved times: ${y}`,
        `received resolved times: ${h}`,
        !1
      );
    });
  }), [
    {
      name: "toHaveResolvedWith",
      condition: /* @__PURE__ */ o((c, d) => c.mock.settledResults.some(
        ({ type: p, value: y }) => p === "fulfilled" && me(d, y)
      ), "condition"),
      action: "resolve"
    },
    {
      name: ["toHaveReturnedWith", "toReturnWith"],
      condition: /* @__PURE__ */ o((c, d) => c.mock.results.some(
        ({ type: p, value: y }) => p === "return" && me(d, y)
      ), "condition"),
      action: "return"
    }
  ].forEach(({ name: c, condition: d, action: p }) => {
    i(c, function(y) {
      let f = a(this), m = d(f, y), h = t.flag(this, "negate");
      if (m && h || !m && !h) {
        let b = f.getMockName(), g = t.getMessage(this, [
          m,
          `expected "${b}" to ${p} with: #{exp} at least once`,
          `expected "${b}" to not ${p} with: #{exp}`,
          y
        ]), T = p === "return" ? f.mock.results : f.mock.settledResults;
        throw new r(fue(f, T, g, y));
      }
    });
  }), [
    {
      name: "toHaveLastResolvedWith",
      condition: /* @__PURE__ */ o((c, d) => {
        let p = c.mock.settledResults[c.mock.settledResults.length - 1];
        return p && p.type === "fulfilled" && me(p.value, d);
      }, "condition"),
      action: "resolve"
    },
    {
      name: ["toHaveLastReturnedWith", "lastReturnedWith"],
      condition: /* @__PURE__ */ o((c, d) => {
        let p = c.mock.results[c.mock.results.length - 1];
        return p && p.type === "return" && me(p.value, d);
      }, "condition"),
      action: "return"
    }
  ].forEach(({ name: c, condition: d, action: p }) => {
    i(c, function(y) {
      let f = a(this), m = p === "return" ? f.mock.results : f.mock.settledResults, h = m[m.length - 1], b = f.getMockName();
      this.assert(
        d(f, y),
        `expected last "${b}" call to ${p} #{exp}`,
        `expected last "${b}" call to not ${p} #{exp}`,
        y,
        h?.value
      );
    });
  }), [
    {
      name: "toHaveNthResolvedWith",
      condition: /* @__PURE__ */ o((c, d, p) => {
        let y = c.mock.settledResults[d - 1];
        return y && y.type === "fulfilled" && me(y.value, p);
      }, "condition"),
      action: "resolve"
    },
    {
      name: ["toHaveNthReturnedWith", "nthReturnedWith"],
      condition: /* @__PURE__ */ o((c, d, p) => {
        let y = c.mock.results[d - 1];
        return y && y.type === "return" && me(y.value, p);
      }, "condition"),
      action: "return"
    }
  ].forEach(({ name: c, condition: d, action: p }) => {
    i(c, function(y, f) {
      let m = a(this), h = m.getMockName(), g = (p === "return" ? m.mock.results : m.mock.settledResults)[y - 1], T = `${Ys(y)} call`;
      this.assert(
        d(m, y, f),
        `expected ${T} "${h}" call to ${p} #{exp}`,
        `expected ${T} "${h}" call to not ${p} #{exp}`,
        f,
        g?.value
      );
    });
  }), i("withContext", function(c) {
    for (let d in c)
      t.flag(this, d, c[d]);
    return this;
  }), t.addProperty(
    e.Assertion.prototype,
    "resolves",
    /* @__PURE__ */ o(function() {
      let d = new Error("resolves");
      t.flag(this, "promise", "resolves"), t.flag(this, "error", d);
      let p = t.flag(this, "vitest-test"), y = t.flag(this, "object");
      if (t.flag(this, "poll"))
        throw new SyntaxError(
          "expect.poll() is not supported in combination with .resolves"
        );
      if (typeof y?.then != "function")
        throw new TypeError(
          `You must provide a Promise to expect() when using .resolves, not '${typeof y}'.`
        );
      let f = new Proxy(this, {
        get: /* @__PURE__ */ o((m, h, b) => {
          let g = Reflect.get(m, h, b);
          return typeof g != "function" ? g instanceof e.Assertion ? f : g : (...T) => {
            t.flag(this, "_name", h);
            let _ = y.then(
              (E) => (t.flag(this, "object", E), g.call(this, ...T)),
              (E) => {
                let R = new r(
                  `promise rejected "${t.inspect(
                    E
                  )}" instead of resolving`,
                  { showDiff: !1 }
                );
                throw R.cause = E, R.stack = d.stack.replace(
                  d.message,
                  R.message
                ), R;
              }
            );
            return ZL(
              p,
              _,
              JL(t, this, !!T.length),
              d
            );
          };
        }, "get")
      });
      return f;
    }, "__VITEST_RESOLVES__")
  ), t.addProperty(
    e.Assertion.prototype,
    "rejects",
    /* @__PURE__ */ o(function() {
      let d = new Error("rejects");
      t.flag(this, "promise", "rejects"), t.flag(this, "error", d);
      let p = t.flag(this, "vitest-test"), y = t.flag(this, "object"), f = typeof y == "function" ? y() : y;
      if (t.flag(this, "poll"))
        throw new SyntaxError(
          "expect.poll() is not supported in combination with .rejects"
        );
      if (typeof f?.then != "function")
        throw new TypeError(
          `You must provide a Promise to expect() when using .rejects, not '${typeof f}'.`
        );
      let m = new Proxy(this, {
        get: /* @__PURE__ */ o((h, b, g) => {
          let T = Reflect.get(h, b, g);
          return typeof T != "function" ? T instanceof e.Assertion ? m : T : (..._) => {
            t.flag(this, "_name", b);
            let E = f.then(
              (R) => {
                let C = new r(
                  `promise resolved "${t.inspect(
                    R
                  )}" instead of rejecting`,
                  {
                    showDiff: !0,
                    expected: new Error("rejected promise"),
                    actual: R
                  }
                );
                throw C.stack = d.stack.replace(
                  d.message,
                  C.message
                ), C;
              },
              (R) => (t.flag(this, "object", R), T.call(this, ..._))
            );
            return ZL(
              p,
              E,
              JL(t, this, !!_.length),
              d
            );
          };
        }, "get")
      });
      return m;
    }, "__VITEST_REJECTS__")
  );
}, "JestChaiExpect");
function Ys(e) {
  let t = e % 10, r = e % 100;
  return t === 1 && r !== 11 ? `${e}st` : t === 2 && r !== 12 ? `${e}nd` : t === 3 && r !== 13 ? `${e}rd` : `${e}th`;
}
o(Ys, "ordinalOf");
function U_(e, t, r) {
  return e.mock.calls && (t += ae.gray(
    `

Received: 

${e.mock.calls.map((n, i) => {
      let s = ae.bold(
        `  ${Ys(i + 1)} ${e.getMockName()} call:

`
      );
      return r ? s += kn(r, n, {
        omitAnnotationLines: !0
      }) : s += tt(n).split(`
`).map((a) => `    ${a}`).join(`
`), s += `
`, s;
    }).join(`
`)}`
  )), t += ae.gray(
    `

Number of calls: ${ae.bold(e.mock.calls.length)}
`
  ), t;
}
o(U_, "formatCalls");
function fue(e, t, r, n) {
  return r += ae.gray(
    `

Received: 

${t.map((i, s) => {
      let a = ae.bold(
        `  ${Ys(s + 1)} ${e.getMockName()} call return:

`
      );
      return n ? a += kn(n, i.value, {
        omitAnnotationLines: !0
      }) : a += tt(i).split(`
`).map((l) => `    ${l}`).join(`
`), a += `
`, a;
    }).join(`
`)}`
  ), r += ae.gray(
    `

Number of calls: ${ae.bold(e.mock.calls.length)}
`
  ), r;
}
o(fue, "formatReturns");
function mue(e, t) {
  let r = e._obj, n = It.flag(e, "negate"), i = It.flag(e, "promise") || "", s = {
    ...tF(),
    diff: kn,
    stringify: tt,
    iterableEquality: kt,
    subsetEquality: Xs
  };
  return {
    state: {
      ...Js(t),
      customTesters: W_(),
      isNot: n,
      utils: s,
      promise: i,
      equals: me,
      // needed for built-in jest-snapshots, but we don't use it
      suppressedErrors: [],
      soft: It.flag(e, "soft"),
      poll: It.flag(e, "poll")
    },
    isNot: n,
    obj: r
  };
}
o(mue, "getMatcherState");
var oR = class oR extends Error {
  constructor(t, r, n) {
    super(t), this.actual = r, this.expected = n;
  }
};
o(oR, "JestExtendError");
var Bp = oR;
function hue(e, t, r) {
  return (n, i) => {
    Object.entries(r).forEach(
      ([s, a]) => {
        function l(...y) {
          let { state: f, isNot: m, obj: h } = mue(this, t), b = a.call(f, h, ...y);
          if (b && typeof b == "object" && b instanceof Promise)
            return b.then(({ pass: R, message: C, actual: w, expected: P }) => {
              if (R && m || !R && !m)
                throw new Bp(C(), w, P);
            });
          let { pass: g, message: T, actual: _, expected: E } = b;
          if (g && m || !g && !m)
            throw new Bp(T(), _, E);
        }
        o(l, "expectWrapper");
        let u = aF(i, s, l);
        i.addMethod(
          globalThis[Ks].matchers,
          s,
          u
        ), i.addMethod(
          e.Assertion.prototype,
          s,
          u
        );
        let p = class p extends Jt {
          constructor(f = !1, ...m) {
            super(m, f);
          }
          asymmetricMatch(f) {
            let { pass: m } = a.call(
              this.getMatcherContext(t),
              f,
              ...this.sample
            );
            return this.inverse ? !m : m;
          }
          toString() {
            return `${this.inverse ? "not." : ""}${s}`;
          }
          getExpectedType() {
            return "any";
          }
          toAsymmetricMatcher() {
            return `${this.toString()}<${this.sample.map((f) => tt(f)).join(", ")}>`;
          }
        };
        o(p, "CustomMatcher");
        let c = p, d = /* @__PURE__ */ o((...y) => new c(!1, ...y), "customMatcher");
        Object.defineProperty(t, s, {
          configurable: !0,
          enumerable: !0,
          value: d,
          writable: !0
        }), Object.defineProperty(t.not, s, {
          configurable: !0,
          enumerable: !0,
          value: /* @__PURE__ */ o((...y) => new c(!0, ...y), "value"),
          writable: !0
        }), Object.defineProperty(
          globalThis[H_],
          s,
          {
            configurable: !0,
            enumerable: !0,
            value: d,
            writable: !0
          }
        );
      }
    );
  };
}
o(hue, "JestExtendPlugin");
var uF = /* @__PURE__ */ o((e, t) => {
  t.addMethod(
    e.expect,
    "extend",
    (r, n) => {
      zr(hue(e, r, n));
    }
  );
}, "JestExtend");

// src/test/expect.ts
function yue() {
  zr(uF), zr(lF), zr(sF);
  let e = /* @__PURE__ */ o((n, i) => {
    let { assertionCalls: s } = Js(e);
    return zp({ assertionCalls: s + 1, soft: !1 }, e), Vr(n, i);
  }, "expect");
  Object.assign(e, Vr), e.getState = () => Js(e), e.setState = (n) => zp(n, e), e.extend = (n) => Vr.extend(e, n), e.soft = (...n) => {
    let i = e(...n);
    return e.setState({
      soft: !0
    }), i;
  }, e.extend(QL), e.unreachable = (n) => {
    S.fail(`expected${n ? ` "${n}" ` : " "}not to be reached`);
  };
  function t(n) {
    let i = /* @__PURE__ */ o(() => new Error(
      `expected number of assertions to be ${n}, but got ${e.getState().assertionCalls}`
    ), "errorGen");
    "captureStackTrace" in Error && typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i(), t), e.setState({
      expectedAssertionsNumber: n,
      expectedAssertionsNumberErrorGen: i
    });
  }
  o(t, "assertions");
  function r() {
    let n = new Error("expected any number of assertion, but got none");
    "captureStackTrace" in Error && typeof Error.captureStackTrace == "function" && Error.captureStackTrace(n, r), e.setState({
      isExpectingAssertions: !0,
      isExpectingAssertionsError: n
    });
  }
  return o(r, "hasAssertions"), zp(
    {
      // this should also add "snapshotState" that is added conditionally
      assertionCalls: 0,
      isExpectingAssertions: !1,
      isExpectingAssertionsError: null,
      expectedAssertionsNumber: null,
      expectedAssertionsNumberErrorGen: null
    },
    e
  ), It.addMethod(e, "assertions", t), It.addMethod(e, "hasAssertions", r), e.extend(d_), e;
}
o(yue, "createExpect");
var iR = yue();
Object.defineProperty(globalThis, Up, {
  value: iR,
  writable: !0,
  configurable: !0
});

// src/test/spy.ts
var sR = /* @__PURE__ */ new Set();
function aR(e) {
  return sR.add(e), () => void sR.delete(e);
}
o(aR, "onMockCall");
var bue = /* @__PURE__ */ o((...e) => {
  let t = UL(...e);
  return dF(t);
}, "spyOn");
function lR(e) {
  let t = e ? D_(e) : D_();
  return dF(t);
}
o(lR, "fn");
function dF(e) {
  let t = cF(e), r = t.mockImplementation.bind(null);
  return t.mockImplementation = (n) => cF(r(n)), t;
}
o(dF, "reactiveMock");
function cF(e) {
  let t = li(e), r = t.impl;
  return t.willCall(function(...n) {
    return sR.forEach((i) => i(e, n)), r?.apply(this, n);
  }), e;
}
o(cF, "listenWhenCalled");
function uR() {
  ui.forEach((e) => e.mockClear());
}
o(uR, "clearAllMocks");
function cR() {
  ui.forEach((e) => e.mockReset());
}
o(cR, "resetAllMocks");
function dR() {
  ui.forEach((e) => e.mockRestore());
}
o(dR, "restoreAllMocks");
function gue(e, t = {}) {
  return e;
}
o(gue, "mocked");

// ../node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js
var uw = {};
ft(uw, {
  buildQueries: () => Cr,
  configure: () => NEe,
  createEvent: () => ry,
  findAllByAltText: () => eU,
  findAllByDisplayValue: () => W2,
  findAllByLabelText: () => C2,
  findAllByPlaceholderText: () => L2,
  findAllByRole: () => fU,
  findAllByTestId: () => vU,
  findAllByText: () => U2,
  findAllByTitle: () => sU,
  findByAltText: () => tU,
  findByDisplayValue: () => K2,
  findByLabelText: () => P2,
  findByPlaceholderText: () => F2,
  findByRole: () => mU,
  findByTestId: () => EU,
  findByText: () => H2,
  findByTitle: () => aU,
  fireEvent: () => Ea,
  getAllByAltText: () => Z2,
  getAllByDisplayValue: () => G2,
  getAllByLabelText: () => A2,
  getAllByPlaceholderText: () => N2,
  getAllByRole: () => dU,
  getAllByTestId: () => bU,
  getAllByText: () => $2,
  getAllByTitle: () => oU,
  getByAltText: () => Q2,
  getByDisplayValue: () => Y2,
  getByLabelText: () => O2,
  getByPlaceholderText: () => j2,
  getByRole: () => pU,
  getByTestId: () => gU,
  getByText: () => B2,
  getByTitle: () => iU,
  getConfig: () => le,
  getDefaultNormalizer: () => ow,
  getElementError: () => sy,
  getMultipleElementsFoundError: () => ay,
  getNodeText: () => _a,
  getQueriesForElement: () => TU,
  getRoles: () => E2,
  getSuggestedQuery: () => ny,
  isInaccessible: () => iy,
  logDOM: () => GR,
  logRoles: () => DEe,
  makeFindQuery: () => vi,
  makeGetAllQuery: () => aw,
  makeSingleQuery: () => gi,
  prettyDOM: () => ga,
  prettyFormat: () => Ta,
  queries: () => oy,
  queryAllByAltText: () => X2,
  queryAllByAttribute: () => Vn,
  queryAllByDisplayValue: () => V2,
  queryAllByLabelText: () => q2,
  queryAllByPlaceholderText: () => I2,
  queryAllByRole: () => uU,
  queryAllByTestId: () => hU,
  queryAllByText: () => k2,
  queryAllByTitle: () => rU,
  queryByAltText: () => J2,
  queryByAttribute: () => _2,
  queryByDisplayValue: () => z2,
  queryByLabelText: () => S2,
  queryByPlaceholderText: () => M2,
  queryByRole: () => cU,
  queryByTestId: () => yU,
  queryByText: () => D2,
  queryByTitle: () => nU,
  queryHelpers: () => QEe,
  screen: () => CTe,
  waitFor: () => sw,
  waitForElementToBeRemoved: () => ETe,
  within: () => TU,
  wrapAllByQueryWithSuggestion: () => Tt,
  wrapSingleQueryWithSuggestion: () => pn
});
var Ta = De(Rk());

// ../node_modules/dom-accessibility-api/dist/polyfills/array.from.mjs
var Qce = Object.prototype.toString;
function wk(e) {
  return typeof e == "function" || Qce.call(e) === "[object Function]";
}
o(wk, "isCallable");
function ede(e) {
  var t = Number(e);
  return isNaN(t) ? 0 : t === 0 || !isFinite(t) ? t : (t > 0 ? 1 : -1) * Math.floor(Math.abs(t));
}
o(ede, "toInteger");
var tde = Math.pow(2, 53) - 1;
function rde(e) {
  var t = ede(e);
  return Math.min(Math.max(t, 0), tde);
}
o(rde, "toLength");
function Ct(e, t) {
  var r = Array, n = Object(e);
  if (e == null)
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  if (typeof t < "u" && !wk(t))
    throw new TypeError("Array.from: when provided, the second argument must be a function");
  for (var i = rde(n.length), s = wk(r) ? Object(new r(i)) : new Array(i), a = 0, l; a < i; )
    l = n[a], t ? s[a] = t(l, a) : s[a] = l, a += 1;
  return s.length = i, s;
}
o(Ct, "arrayFrom");

// ../node_modules/dom-accessibility-api/dist/polyfills/SetLike.mjs
function da(e) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, da(e);
}
o(da, "_typeof");
function nde(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
o(nde, "_classCallCheck");
function Sk(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xk(n.key), n);
  }
}
o(Sk, "_defineProperties");
function ode(e, t, r) {
  return t && Sk(e.prototype, t), r && Sk(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
o(ode, "_createClass");
function ide(e, t, r) {
  return t = xk(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
o(ide, "_defineProperty");
function xk(e) {
  var t = sde(e, "string");
  return da(t) === "symbol" ? t : String(t);
}
o(xk, "_toPropertyKey");
function sde(e, t) {
  if (da(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (da(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
o(sde, "_toPrimitive");
var ade = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    nde(this, e), ide(this, "items", void 0), this.items = t;
  }
  return o(e, "SetLike"), ode(e, [{
    key: "add",
    value: /* @__PURE__ */ o(function(r) {
      return this.has(r) === !1 && this.items.push(r), this;
    }, "add")
  }, {
    key: "clear",
    value: /* @__PURE__ */ o(function() {
      this.items = [];
    }, "clear")
  }, {
    key: "delete",
    value: /* @__PURE__ */ o(function(r) {
      var n = this.items.length;
      return this.items = this.items.filter(function(i) {
        return i !== r;
      }), n !== this.items.length;
    }, "_delete")
  }, {
    key: "forEach",
    value: /* @__PURE__ */ o(function(r) {
      var n = this;
      this.items.forEach(function(i) {
        r(i, i, n);
      });
    }, "forEach")
  }, {
    key: "has",
    value: /* @__PURE__ */ o(function(r) {
      return this.items.indexOf(r) !== -1;
    }, "has")
  }, {
    key: "size",
    get: /* @__PURE__ */ o(function() {
      return this.items.length;
    }, "get")
  }]), e;
}(), Ck = typeof Set > "u" ? Set : ade;

// ../node_modules/dom-accessibility-api/dist/getRole.mjs
function Ve(e) {
  var t;
  return (
    // eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (t = e.localName) !== null && t !== void 0 ? t : (
      // eslint-disable-next-line no-restricted-properties -- required for the fallback
      e.tagName.toLowerCase()
    )
  );
}
o(Ve, "getLocalName");
var lde = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
}, ude = {
  caption: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  code: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  deletion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  emphasis: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  generic: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  paragraph: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  presentation: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  strong: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  subscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  superscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"])
};
function cde(e, t) {
  return [
    "aria-atomic",
    "aria-busy",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    // "disabled",
    "aria-dropeffect",
    // "errormessage",
    "aria-flowto",
    "aria-grabbed",
    // "haspopup",
    "aria-hidden",
    // "invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-live",
    "aria-owns",
    "aria-relevant",
    "aria-roledescription"
  ].some(function(r) {
    var n;
    return e.hasAttribute(r) && !((n = ude[t]) !== null && n !== void 0 && n.has(r));
  });
}
o(cde, "hasGlobalAriaAttributes");
function Pk(e, t) {
  return cde(e, t);
}
o(Pk, "ignorePresentationalRole");
function rf(e) {
  var t = pde(e);
  if (t === null || t === "presentation") {
    var r = dde(e);
    if (t !== "presentation" || Pk(e, r || ""))
      return r;
  }
  return t;
}
o(rf, "getRole");
function dde(e) {
  var t = lde[Ve(e)];
  if (t !== void 0)
    return t;
  switch (Ve(e)) {
    case "a":
    case "area":
    case "link":
      if (e.hasAttribute("href"))
        return "link";
      break;
    case "img":
      return e.getAttribute("alt") === "" && !Pk(e, "img") ? "presentation" : "img";
    case "input": {
      var r = e, n = r.type;
      switch (n) {
        case "button":
        case "image":
        case "reset":
        case "submit":
          return "button";
        case "checkbox":
        case "radio":
          return n;
        case "range":
          return "slider";
        case "email":
        case "tel":
        case "text":
        case "url":
          return e.hasAttribute("list") ? "combobox" : "textbox";
        case "search":
          return e.hasAttribute("list") ? "combobox" : "searchbox";
        case "number":
          return "spinbutton";
        default:
          return null;
      }
    }
    case "select":
      return e.hasAttribute("multiple") || e.size > 1 ? "listbox" : "combobox";
  }
  return null;
}
o(dde, "getImplicitRole");
function pde(e) {
  var t = e.getAttribute("role");
  if (t !== null) {
    var r = t.trim().split(" ")[0];
    if (r.length > 0)
      return r;
  }
  return null;
}
o(pde, "getExplicitRole");

// ../node_modules/dom-accessibility-api/dist/util.mjs
function qe(e) {
  return e !== null && e.nodeType === e.ELEMENT_NODE;
}
o(qe, "isElement");
function _R(e) {
  return qe(e) && Ve(e) === "caption";
}
o(_R, "isHTMLTableCaptionElement");
function pa(e) {
  return qe(e) && Ve(e) === "input";
}
o(pa, "isHTMLInputElement");
function Ak(e) {
  return qe(e) && Ve(e) === "optgroup";
}
o(Ak, "isHTMLOptGroupElement");
function Ok(e) {
  return qe(e) && Ve(e) === "select";
}
o(Ok, "isHTMLSelectElement");
function qk(e) {
  return qe(e) && Ve(e) === "table";
}
o(qk, "isHTMLTableElement");
function Ik(e) {
  return qe(e) && Ve(e) === "textarea";
}
o(Ik, "isHTMLTextAreaElement");
function Mk(e) {
  var t = e.ownerDocument === null ? e : e.ownerDocument, r = t.defaultView;
  if (r === null)
    throw new TypeError("no window available");
  return r;
}
o(Mk, "safeWindow");
function Nk(e) {
  return qe(e) && Ve(e) === "fieldset";
}
o(Nk, "isHTMLFieldSetElement");
function jk(e) {
  return qe(e) && Ve(e) === "legend";
}
o(jk, "isHTMLLegendElement");
function Lk(e) {
  return qe(e) && Ve(e) === "slot";
}
o(Lk, "isHTMLSlotElement");
function fde(e) {
  return qe(e) && e.ownerSVGElement !== void 0;
}
o(fde, "isSVGElement");
function Fk(e) {
  return qe(e) && Ve(e) === "svg";
}
o(Fk, "isSVGSVGElement");
function kk(e) {
  return fde(e) && Ve(e) === "title";
}
o(kk, "isSVGTitleElement");
function mi(e, t) {
  if (qe(e) && e.hasAttribute(t)) {
    var r = e.getAttribute(t).split(" "), n = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return r.map(function(i) {
      return n.getElementById(i);
    }).filter(
      function(i) {
        return i !== null;
      }
      // TODO: why does this not narrow?
    );
  }
  return [];
}
o(mi, "queryIdRefs");
function er(e, t) {
  return qe(e) ? t.indexOf(rf(e)) !== -1 : !1;
}
o(er, "hasAnyConcreteRoles");

// ../node_modules/dom-accessibility-api/dist/accessible-name-and-description.mjs
function mde(e) {
  return e.trim().replace(/\s\s+/g, " ");
}
o(mde, "asFlatString");
function hde(e, t) {
  if (!qe(e))
    return !1;
  if (e.hasAttribute("hidden") || e.getAttribute("aria-hidden") === "true")
    return !0;
  var r = t(e);
  return r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}
o(hde, "isHidden");
function yde(e) {
  return er(e, ["button", "combobox", "listbox", "textbox"]) || Bk(e, "range");
}
o(yde, "isControl");
function Bk(e, t) {
  if (!qe(e))
    return !1;
  switch (t) {
    case "range":
      return er(e, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(t, "'. This is likely a bug :("));
  }
}
o(Bk, "hasAbstractRole");
function Dk(e, t) {
  var r = Ct(e.querySelectorAll(t));
  return mi(e, "aria-owns").forEach(function(n) {
    r.push.apply(r, Ct(n.querySelectorAll(t)));
  }), r;
}
o(Dk, "querySelectorAllSubtree");
function bde(e) {
  return Ok(e) ? e.selectedOptions || Dk(e, "[selected]") : Dk(e, '[aria-selected="true"]');
}
o(bde, "querySelectedOptions");
function gde(e) {
  return er(e, ["none", "presentation"]);
}
o(gde, "isMarkedPresentational");
function vde(e) {
  return _R(e);
}
o(vde, "isNativeHostLanguageTextAlternativeElement");
function Ede(e) {
  return er(e, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbo\
x", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
o(Ede, "allowsNameFromContent");
function Tde(e) {
  return !1;
}
o(Tde, "isDescendantOfNativeHostLanguageTextAlternativeElement");
function _de(e) {
  return pa(e) || Ik(e) ? e.value : e.textContent || "";
}
o(_de, "getValueOfTextbox");
function $k(e) {
  var t = e.getPropertyValue("content");
  return /^["'].*["']$/.test(t) ? t.slice(1, -1) : "";
}
o($k, "getTextualContent");
function Uk(e) {
  var t = Ve(e);
  return t === "button" || t === "input" && e.getAttribute("type") !== "hidden" || t === "meter" || t === "output" || t === "progress" || t ===
  "select" || t === "textarea";
}
o(Uk, "isLabelableElement");
function Hk(e) {
  if (Uk(e))
    return e;
  var t = null;
  return e.childNodes.forEach(function(r) {
    if (t === null && qe(r)) {
      var n = Hk(r);
      n !== null && (t = n);
    }
  }), t;
}
o(Hk, "findLabelableElement");
function Rde(e) {
  if (e.control !== void 0)
    return e.control;
  var t = e.getAttribute("for");
  return t !== null ? e.ownerDocument.getElementById(t) : Hk(e);
}
o(Rde, "getControlOfLabel");
function wde(e) {
  var t = e.labels;
  if (t === null)
    return t;
  if (t !== void 0)
    return Ct(t);
  if (!Uk(e))
    return null;
  var r = e.ownerDocument;
  return Ct(r.querySelectorAll("label")).filter(function(n) {
    return Rde(n) === e;
  });
}
o(wde, "getLabels");
function Sde(e) {
  var t = e.assignedNodes();
  return t.length === 0 ? Ct(e.childNodes) : t;
}
o(Sde, "getSlotContents");
function nf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = new Ck(), n = Mk(e), i = t.compute, s = i === void 0 ? "n\
ame" : i, a = t.computedStyleSupportsPseudoElements, l = a === void 0 ? t.getComputedStyle !== void 0 : a, u = t.getComputedStyle, c = u ===
  void 0 ? n.getComputedStyle.bind(n) : u, d = t.hidden, p = d === void 0 ? !1 : d;
  function y(g, T) {
    var _ = "";
    if (qe(g) && l) {
      var E = c(g, "::before"), R = $k(E);
      _ = "".concat(R, " ").concat(_);
    }
    var C = Lk(g) ? Sde(g) : Ct(g.childNodes).concat(mi(g, "aria-owns"));
    if (C.forEach(function(O) {
      var D = b(O, {
        isEmbeddedInLabel: T.isEmbeddedInLabel,
        isReferenced: !1,
        recursion: !0
      }), A = qe(O) ? c(O).getPropertyValue("display") : "inline", L = A !== "inline" ? " " : "";
      _ += "".concat(L).concat(D).concat(L);
    }), qe(g) && l) {
      var w = c(g, "::after"), P = $k(w);
      _ = "".concat(_, " ").concat(P);
    }
    return _.trim();
  }
  o(y, "computeMiscTextAlternative");
  function f(g, T) {
    var _ = g.getAttributeNode(T);
    return _ !== null && !r.has(_) && _.value.trim() !== "" ? (r.add(_), _.value) : null;
  }
  o(f, "useAttribute");
  function m(g) {
    return qe(g) ? f(g, "title") : null;
  }
  o(m, "computeTooltipAttributeValue");
  function h(g) {
    if (!qe(g))
      return null;
    if (Nk(g)) {
      r.add(g);
      for (var T = Ct(g.childNodes), _ = 0; _ < T.length; _ += 1) {
        var E = T[_];
        if (jk(E))
          return b(E, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (qk(g)) {
      r.add(g);
      for (var R = Ct(g.childNodes), C = 0; C < R.length; C += 1) {
        var w = R[C];
        if (_R(w))
          return b(w, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (Fk(g)) {
      r.add(g);
      for (var P = Ct(g.childNodes), O = 0; O < P.length; O += 1) {
        var D = P[O];
        if (kk(D))
          return D.textContent;
      }
      return null;
    } else if (Ve(g) === "img" || Ve(g) === "area") {
      var A = f(g, "alt");
      if (A !== null)
        return A;
    } else if (Ak(g)) {
      var L = f(g, "label");
      if (L !== null)
        return L;
    }
    if (pa(g) && (g.type === "button" || g.type === "submit" || g.type === "reset")) {
      var B = f(g, "value");
      if (B !== null)
        return B;
      if (g.type === "submit")
        return "Submit";
      if (g.type === "reset")
        return "Reset";
    }
    var N = wde(g);
    if (N !== null && N.length !== 0)
      return r.add(g), Ct(N).map(function(G) {
        return b(G, {
          isEmbeddedInLabel: !0,
          isReferenced: !1,
          recursion: !0
        });
      }).filter(function(G) {
        return G.length > 0;
      }).join(" ");
    if (pa(g) && g.type === "image") {
      var $ = f(g, "alt");
      if ($ !== null)
        return $;
      var M = f(g, "title");
      return M !== null ? M : "Submit Query";
    }
    if (er(g, ["button"])) {
      var V = y(g, {
        isEmbeddedInLabel: !1,
        isReferenced: !1
      });
      if (V !== "")
        return V;
    }
    return null;
  }
  o(h, "computeElementTextAlternative");
  function b(g, T) {
    if (r.has(g))
      return "";
    if (!p && hde(g, c) && !T.isReferenced)
      return r.add(g), "";
    var _ = qe(g) ? g.getAttributeNode("aria-labelledby") : null, E = _ !== null && !r.has(_) ? mi(g, "aria-labelledby") : [];
    if (s === "name" && !T.isReferenced && E.length > 0)
      return r.add(_), E.map(function(A) {
        return b(A, {
          isEmbeddedInLabel: T.isEmbeddedInLabel,
          isReferenced: !0,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: !1
        });
      }).join(" ");
    var R = T.recursion && yde(g) && s === "name";
    if (!R) {
      var C = (qe(g) && g.getAttribute("aria-label") || "").trim();
      if (C !== "" && s === "name")
        return r.add(g), C;
      if (!gde(g)) {
        var w = h(g);
        if (w !== null)
          return r.add(g), w;
      }
    }
    if (er(g, ["menu"]))
      return r.add(g), "";
    if (R || T.isEmbeddedInLabel || T.isReferenced) {
      if (er(g, ["combobox", "listbox"])) {
        r.add(g);
        var P = bde(g);
        return P.length === 0 ? pa(g) ? g.value : "" : Ct(P).map(function(A) {
          return b(A, {
            isEmbeddedInLabel: T.isEmbeddedInLabel,
            isReferenced: !1,
            recursion: !0
          });
        }).join(" ");
      }
      if (Bk(g, "range"))
        return r.add(g), g.hasAttribute("aria-valuetext") ? g.getAttribute("aria-valuetext") : g.hasAttribute("aria-valuenow") ? g.getAttribute(
        "aria-valuenow") : g.getAttribute("value") || "";
      if (er(g, ["textbox"]))
        return r.add(g), _de(g);
    }
    if (Ede(g) || qe(g) && T.isReferenced || vde(g) || Tde(g)) {
      var O = y(g, {
        isEmbeddedInLabel: T.isEmbeddedInLabel,
        isReferenced: !1
      });
      if (O !== "")
        return r.add(g), O;
    }
    if (g.nodeType === g.TEXT_NODE)
      return r.add(g), g.textContent || "";
    if (T.recursion)
      return r.add(g), y(g, {
        isEmbeddedInLabel: T.isEmbeddedInLabel,
        isReferenced: !1
      });
    var D = m(g);
    return D !== null ? (r.add(g), D) : (r.add(g), "");
  }
  return o(b, "computeTextAlternative"), mde(b(e, {
    isEmbeddedInLabel: !1,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: s === "description",
    recursion: !1
  }));
}
o(nf, "computeTextAlternative");

// ../node_modules/dom-accessibility-api/dist/accessible-description.mjs
function fa(e) {
  "@babel/helpers - typeof";
  return fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fa(e);
}
o(fa, "_typeof");
function Vk(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
o(Vk, "ownKeys");
function zk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vk(Object(r), !0).forEach(function(n) {
      xde(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vk(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
o(zk, "_objectSpread");
function xde(e, t, r) {
  return t = Cde(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
o(xde, "_defineProperty");
function Cde(e) {
  var t = Pde(e, "string");
  return fa(t) === "symbol" ? t : String(t);
}
o(Cde, "_toPropertyKey");
function Pde(e, t) {
  if (fa(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (fa(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
o(Pde, "_toPrimitive");
function of(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = mi(e, "aria-describedby").map(function(i) {
    return nf(i, zk(zk({}, t), {}, {
      compute: "description"
    }));
  }).join(" ");
  if (r === "") {
    var n = e.getAttribute("title");
    r = n === null ? "" : n;
  }
  return r;
}
o(of, "computeAccessibleDescription");

// ../node_modules/dom-accessibility-api/dist/accessible-name.mjs
function Ade(e) {
  return er(e, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "supe\
rscript"]);
}
o(Ade, "prohibitsNaming");
function ma(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Ade(e) ? "" : nf(e, t);
}
o(ma, "computeAccessibleName");

// ../node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js
var ht = De(XB()), o2 = De(JB());
function i2(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
o(i2, "escapeHTML");
var mEe = /* @__PURE__ */ o((e, t, r, n, i, s, a) => {
  let l = n + r.indent, u = r.colors;
  return e.map((c) => {
    let d = t[c], p = a(d, r, l, i, s);
    return typeof d != "string" && (p.indexOf(`
`) !== -1 && (p = r.spacingOuter + l + p + r.spacingOuter + n), p = "{" + p + "}"), r.spacingInner + n + u.prop.open + c + u.prop.close + "=" +
    u.value.open + p + u.value.close;
  }).join("");
}, "printProps"), hEe = 3, yEe = /* @__PURE__ */ o((e, t, r, n, i, s) => e.map((a) => {
  let l = typeof a == "string" ? s2(a, t) : s(a, t, r, n, i);
  return l === "" && typeof a == "object" && a !== null && a.nodeType !== hEe ? "" : t.spacingOuter + r + l;
}).join(""), "printChildren"), s2 = /* @__PURE__ */ o((e, t) => {
  let r = t.colors.content;
  return r.open + i2(e) + r.close;
}, "printText"), bEe = /* @__PURE__ */ o((e, t) => {
  let r = t.colors.comment;
  return r.open + "<!--" + i2(e) + "-->" + r.close;
}, "printComment"), gEe = /* @__PURE__ */ o((e, t, r, n, i) => {
  let s = n.colors.tag;
  return s.open + "<" + e + (t && s.close + t + n.spacingOuter + i + s.open) + (r ? ">" + s.close + r + n.spacingOuter + i + s.open + "</" +
  e : (t && !n.min ? "" : " ") + "/") + ">" + s.close;
}, "printElement"), vEe = /* @__PURE__ */ o((e, t) => {
  let r = t.colors.tag;
  return r.open + "<" + e + r.close + " \u2026" + r.open + " />" + r.close;
}, "printElementAsLeaf"), EEe = 1, a2 = 3, l2 = 8, u2 = 11, TEe = /^((HTML|SVG)\w*)?Element$/, c2 = /* @__PURE__ */ o((e) => {
  let {
    tagName: t
  } = e;
  return !!(typeof t == "string" && t.includes("-") || typeof e.hasAttribute == "function" && e.hasAttribute("is"));
}, "isCustomElement"), _Ee = /* @__PURE__ */ o((e) => {
  let t = e.constructor.name, {
    nodeType: r
  } = e;
  return r === EEe && (TEe.test(t) || c2(e)) || r === a2 && t === "Text" || r === l2 && t === "Comment" || r === u2 && t === "DocumentFragme\
nt";
}, "testNode");
function REe(e) {
  return e.nodeType === a2;
}
o(REe, "nodeIsText");
function wEe(e) {
  return e.nodeType === l2;
}
o(wEe, "nodeIsComment");
function VR(e) {
  return e.nodeType === u2;
}
o(VR, "nodeIsFragment");
function SEe(e) {
  return {
    test: /* @__PURE__ */ o((t) => {
      var r;
      return ((t == null || (r = t.constructor) == null ? void 0 : r.name) || c2(t)) && _Ee(t);
    }, "test"),
    serialize: /* @__PURE__ */ o((t, r, n, i, s, a) => {
      if (REe(t))
        return s2(t.data, r);
      if (wEe(t))
        return bEe(t.data, r);
      let l = VR(t) ? "DocumentFragment" : t.tagName.toLowerCase();
      return ++i > r.maxDepth ? vEe(l, r) : gEe(l, mEe(VR(t) ? [] : Array.from(t.attributes).map((u) => u.name).sort(), VR(t) ? {} : Array.from(
      t.attributes).reduce((u, c) => (u[c.name] = c.value, u), {}), r, n + r.indent, i, s, a), yEe(Array.prototype.slice.call(t.childNodes ||
      t.children).filter(e), r, n + r.indent, i, s, a), r, n);
    }, "serialize")
  };
}
o(SEe, "createDOMElementFilter");
var d2 = null, tw = null, rw = null;
try {
  let e = module && module.require;
  tw = e.call(module, "fs").readFileSync, rw = e.call(module, "@babel/code-frame").codeFrameColumns, d2 = e.call(module, "chalk");
} catch {
}
function xEe(e) {
  let t = e.indexOf("(") + 1, r = e.indexOf(")"), n = e.slice(t, r), i = n.split(":"), [s, a, l] = [i[0], parseInt(i[1], 10), parseInt(i[2],
  10)], u = "";
  try {
    u = tw(s, "utf-8");
  } catch {
    return "";
  }
  let c = rw(u, {
    start: {
      line: a,
      column: l
    }
  }, {
    highlightCode: !0,
    linesBelow: 0
  });
  return d2.dim(n) + `
` + c + `
`;
}
o(xEe, "getCodeFrame");
function CEe() {
  if (!tw || !rw)
    return "";
  let t = new Error().stack.split(`
`).slice(1).find((r) => !r.includes("node_modules/"));
  return xEe(t);
}
o(CEe, "getUserCodeFrame");
var p2 = 3;
function zR() {
  return typeof jest < "u" && jest !== null ? (
    // legacy timers
    setTimeout._isMockFunction === !0 || // modern timers
    // eslint-disable-next-line prefer-object-has-own -- not supported by our support matrix
    Object.prototype.hasOwnProperty.call(setTimeout, "clock")
  ) : !1;
}
o(zR, "jestFakeTimersAreEnabled");
function nw() {
  if (typeof window > "u")
    throw new Error("Could not find default container");
  return window.document;
}
o(nw, "getDocument");
function f2(e) {
  if (e.defaultView)
    return e.defaultView;
  if (e.ownerDocument && e.ownerDocument.defaultView)
    return e.ownerDocument.defaultView;
  if (e.window)
    return e.window;
  throw e.ownerDocument && e.ownerDocument.defaultView === null ? new Error("It looks like the window object is not available for the provid\
ed node.") : e.then instanceof Function ? new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something l\
ike `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `f\
ireEvent.click(await screen.findBy...`?") : Array.isArray(e) ? new Error("It looks like you passed an Array instead of a DOM node. Did you d\
o something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?") : typeof e.
  debug == "function" && typeof e.logTestingPlaygroundURL == "function" ? new Error("It looks like you passed a `screen` object. Did you do \
something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?") : new Error("The giv\
en node is not an Element, the node type is: " + typeof e + ".");
}
o(f2, "getWindowFromNode");
function xr(e) {
  if (!e || typeof e.querySelector != "function" || typeof e.querySelectorAll != "function")
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + t(e) + ".");
  function t(r) {
    return typeof r == "object" ? r === null ? "null" : r.constructor.name : typeof r;
  }
  o(t, "getTypeName");
}
o(xr, "checkContainerType");
var PEe = /* @__PURE__ */ o(() => {
  if (typeof process > "u")
    return !1;
  let e;
  try {
    var t;
    let r = (t = process.env) == null ? void 0 : t.COLORS;
    r && (e = JSON.parse(r));
  } catch {
  }
  return typeof e == "boolean" ? e : process.versions !== void 0 && process.versions.node !== void 0;
}, "shouldHighlight"), {
  DOMCollection: AEe
} = Ta.plugins, OEe = 1, qEe = 8;
function IEe(e) {
  return e.nodeType !== qEe && (e.nodeType !== OEe || !e.matches(le().defaultIgnore));
}
o(IEe, "filterCommentsAndDefaultIgnoreTagsTags");
function ga(e, t, r) {
  if (r === void 0 && (r = {}), e || (e = nw().body), typeof t != "number" && (t = typeof process < "u" && typeof process.env < "u" && process.
  env.DEBUG_PRINT_LIMIT || 7e3), t === 0)
    return "";
  e.documentElement && (e = e.documentElement);
  let n = typeof e;
  if (n === "object" ? n = e.constructor.name : e = {}, !("outerHTML" in e))
    throw new TypeError("Expected an element or document but got " + n);
  let {
    filterNode: i = IEe,
    ...s
  } = r, a = Ta.format(e, {
    plugins: [SEe(i), AEe],
    printFunctionName: !1,
    highlight: PEe(),
    ...s
  });
  return t !== void 0 && e.outerHTML.length > t ? a.slice(0, t) + "..." : a;
}
o(ga, "prettyDOM");
var GR = /* @__PURE__ */ o(function() {
  let e = CEe();
  console.log(e ? ga(...arguments) + `

` + e : ga(...arguments));
}, "logDOM"), Bn = {
  testIdAttribute: "data-testid",
  asyncUtilTimeout: 1e3,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: /* @__PURE__ */ o((e) => e(), "asyncWrapper"),
  unstable_advanceTimersWrapper: /* @__PURE__ */ o((e) => e(), "unstable_advanceTimersWrapper"),
  eventWrapper: /* @__PURE__ */ o((e) => e(), "eventWrapper"),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: !1,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: "script, style",
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: !1,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: !1,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(e, t) {
    let r = ga(t), n = new Error([e, "Ignored nodes: comments, " + Bn.defaultIgnore + `
` + r].filter(Boolean).join(`

`));
    return n.name = "TestingLibraryElementError", n;
  },
  _disableExpensiveErrorDiagnostics: !1,
  computedStyleSupportsPseudoElements: !1
};
function MEe(e) {
  try {
    return Bn._disableExpensiveErrorDiagnostics = !0, e();
  } finally {
    Bn._disableExpensiveErrorDiagnostics = !1;
  }
}
o(MEe, "runWithExpensiveErrorDiagnosticsDisabled");
function NEe(e) {
  typeof e == "function" && (e = e(Bn)), Bn = {
    ...Bn,
    ...e
  };
}
o(NEe, "configure");
function le() {
  return Bn;
}
o(le, "getConfig");
var jEe = ["button", "meter", "output", "progress", "select", "textarea", "input"];
function m2(e) {
  return jEe.includes(e.nodeName.toLowerCase()) ? "" : e.nodeType === p2 ? e.textContent : Array.from(e.childNodes).map((t) => m2(t)).join("");
}
o(m2, "getTextContent");
function YR(e) {
  let t;
  return e.tagName.toLowerCase() === "label" ? t = m2(e) : t = e.value || e.textContent, t;
}
o(YR, "getLabelContent");
function h2(e) {
  if (e.labels !== void 0) {
    var t;
    return (t = e.labels) != null ? t : [];
  }
  if (!LEe(e)) return [];
  let r = e.ownerDocument.querySelectorAll("label");
  return Array.from(r).filter((n) => n.control === e);
}
o(h2, "getRealLabels");
function LEe(e) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(e.tagName) || e.tagName === "INPUT" && e.getAttribute("type") !== "hidden";
}
o(LEe, "isLabelable");
function y2(e, t, r) {
  let {
    selector: n = "*"
  } = r === void 0 ? {} : r, i = t.getAttribute("aria-labelledby"), s = i ? i.split(" ") : [];
  return s.length ? s.map((a) => {
    let l = e.querySelector('[id="' + a + '"]');
    return l ? {
      content: YR(l),
      formControl: null
    } : {
      content: "",
      formControl: null
    };
  }) : Array.from(h2(t)).map((a) => {
    let l = YR(a), c = Array.from(a.querySelectorAll("button, input, meter, output, progress, select, textarea")).filter((d) => d.matches(n))[0];
    return {
      content: l,
      formControl: c
    };
  });
}
o(y2, "getLabels");
function b2(e) {
  if (e == null)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
      "It looks like " + e + " was passed instead of a matcher. Did you do something like getByText(" + e + ")?"
    );
}
o(b2, "assertNotNullOrUndefined");
function Ei(e, t, r, n) {
  if (typeof e != "string")
    return !1;
  b2(r);
  let i = n(e);
  return typeof r == "string" || typeof r == "number" ? i.toLowerCase().includes(r.toString().toLowerCase()) : typeof r == "function" ? r(i,
  t) : g2(r, i);
}
o(Ei, "fuzzyMatches");
function Sr(e, t, r, n) {
  if (typeof e != "string")
    return !1;
  b2(r);
  let i = n(e);
  return r instanceof Function ? r(i, t) : r instanceof RegExp ? g2(r, i) : i === String(r);
}
o(Sr, "matches");
function ow(e) {
  let {
    trim: t = !0,
    collapseWhitespace: r = !0
  } = e === void 0 ? {} : e;
  return (n) => {
    let i = n;
    return i = t ? i.trim() : i, i = r ? i.replace(/\s+/g, " ") : i, i;
  };
}
o(ow, "getDefaultNormalizer");
function Hn(e) {
  let {
    trim: t,
    collapseWhitespace: r,
    normalizer: n
  } = e;
  if (!n)
    return ow({
      trim: t,
      collapseWhitespace: r
    });
  if (typeof t < "u" || typeof r < "u")
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhites\
pace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  return n;
}
o(Hn, "makeNormalizer");
function g2(e, t) {
  let r = e.test(t);
  return e.global && e.lastIndex !== 0 && (console.warn("To match all elements we had to reset the lastIndex of the RegExp because the globa\
l flag is enabled. We encourage to remove the global flag from the RegExp."), e.lastIndex = 0), r;
}
o(g2, "matchRegExp");
function _a(e) {
  return e.matches("input[type=submit], input[type=button], input[type=reset]") ? e.value : Array.from(e.childNodes).filter((t) => t.nodeType ===
  p2 && !!t.textContent).map((t) => t.textContent).join("");
}
o(_a, "getNodeText");
var FEe = kEe(ht.elementRoles);
function v2(e) {
  return e.hidden === !0 || e.getAttribute("aria-hidden") === "true" || e.ownerDocument.defaultView.getComputedStyle(e).display === "none";
}
o(v2, "isSubtreeInaccessible");
function iy(e, t) {
  t === void 0 && (t = {});
  let {
    isSubtreeInaccessible: r = v2
  } = t;
  if (e.ownerDocument.defaultView.getComputedStyle(e).visibility === "hidden")
    return !0;
  let i = e;
  for (; i; ) {
    if (r(i))
      return !0;
    i = i.parentElement;
  }
  return !1;
}
o(iy, "isInaccessible");
function iw(e) {
  for (let {
    match: t,
    roles: r
  } of FEe)
    if (t(e))
      return [...r];
  return [];
}
o(iw, "getImplicitAriaRoles");
function kEe(e) {
  function t(a) {
    let {
      name: l,
      attributes: u
    } = a;
    return "" + l + u.map((c) => {
      let {
        name: d,
        value: p,
        constraints: y = []
      } = c, f = y.indexOf("undefined") !== -1, m = y.indexOf("set") !== -1;
      return typeof p < "u" ? "[" + d + '="' + p + '"]' : f ? ":not([" + d + "])" : m ? "[" + d + "]:not([" + d + '=""])' : "[" + d + "]";
    }).join("");
  }
  o(t, "makeElementSelector");
  function r(a) {
    let {
      attributes: l = []
    } = a;
    return l.length;
  }
  o(r, "getSelectorSpecificity");
  function n(a, l) {
    let {
      specificity: u
    } = a, {
      specificity: c
    } = l;
    return c - u;
  }
  o(n, "bySelectorSpecificity");
  function i(a) {
    let {
      attributes: l = []
    } = a, u = l.findIndex((d) => d.value && d.name === "type" && d.value === "text");
    u >= 0 && (l = [...l.slice(0, u), ...l.slice(u + 1)]);
    let c = t({
      ...a,
      attributes: l
    });
    return (d) => u >= 0 && d.type !== "text" ? !1 : d.matches(c);
  }
  o(i, "match");
  let s = [];
  for (let [a, l] of e.entries())
    s = [...s, {
      match: i(a),
      roles: Array.from(l),
      specificity: r(a)
    }];
  return s.sort(n);
}
o(kEe, "buildElementRoleList");
function E2(e, t) {
  let {
    hidden: r = !1
  } = t === void 0 ? {} : t;
  function n(i) {
    return [i, ...Array.from(i.children).reduce((s, a) => [...s, ...n(a)], [])];
  }
  return o(n, "flattenDOM"), n(e).filter((i) => r === !1 ? iy(i) === !1 : !0).reduce((i, s) => {
    let a = [];
    return s.hasAttribute("role") ? a = s.getAttribute("role").split(" ").slice(0, 1) : a = iw(s), a.reduce((l, u) => Array.isArray(l[u]) ? {
      ...l,
      [u]: [...l[u], s]
    } : {
      ...l,
      [u]: [s]
    }, i);
  }, {});
}
o(E2, "getRoles");
function T2(e, t) {
  let {
    hidden: r,
    includeDescription: n
  } = t, i = E2(e, {
    hidden: r
  });
  return Object.entries(i).filter((s) => {
    let [a] = s;
    return a !== "generic";
  }).map((s) => {
    let [a, l] = s, u = "-".repeat(50), c = l.map((d) => {
      let p = 'Name "' + ma(d, {
        computedStyleSupportsPseudoElements: le().computedStyleSupportsPseudoElements
      }) + `":
`, y = ga(d.cloneNode(!1));
      if (n) {
        let f = 'Description "' + of(d, {
          computedStyleSupportsPseudoElements: le().computedStyleSupportsPseudoElements
        }) + `":
`;
        return "" + p + f + y;
      }
      return "" + p + y;
    }).join(`

`);
    return a + `:

` + c + `

` + u;
  }).join(`
`);
}
o(T2, "prettyRoles");
var DEe = /* @__PURE__ */ o(function(e, t) {
  let {
    hidden: r = !1
  } = t === void 0 ? {} : t;
  return console.log(T2(e, {
    hidden: r
  }));
}, "logRoles");
function $Ee(e) {
  return e.tagName === "OPTION" ? e.selected : Ra(e, "aria-selected");
}
o($Ee, "computeAriaSelected");
function BEe(e) {
  return e.getAttribute("aria-busy") === "true";
}
o(BEe, "computeAriaBusy");
function UEe(e) {
  if (!("indeterminate" in e && e.indeterminate))
    return "checked" in e ? e.checked : Ra(e, "aria-checked");
}
o(UEe, "computeAriaChecked");
function HEe(e) {
  return Ra(e, "aria-pressed");
}
o(HEe, "computeAriaPressed");
function VEe(e) {
  var t, r;
  return (t = (r = Ra(e, "aria-current")) != null ? r : e.getAttribute("aria-current")) != null ? t : !1;
}
o(VEe, "computeAriaCurrent");
function zEe(e) {
  return Ra(e, "aria-expanded");
}
o(zEe, "computeAriaExpanded");
function Ra(e, t) {
  let r = e.getAttribute(t);
  if (r === "true")
    return !0;
  if (r === "false")
    return !1;
}
o(Ra, "checkBooleanAttribute");
function GEe(e) {
  let t = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  return e.getAttribute("aria-level") && Number(e.getAttribute("aria-level")) || t[e.tagName];
}
o(GEe, "computeHeadingLevel");
function YEe(e) {
  let t = e.getAttribute("aria-valuenow");
  return t === null ? void 0 : +t;
}
o(YEe, "computeAriaValueNow");
function WEe(e) {
  let t = e.getAttribute("aria-valuemax");
  return t === null ? void 0 : +t;
}
o(WEe, "computeAriaValueMax");
function KEe(e) {
  let t = e.getAttribute("aria-valuemin");
  return t === null ? void 0 : +t;
}
o(KEe, "computeAriaValueMin");
function XEe(e) {
  let t = e.getAttribute("aria-valuetext");
  return t === null ? void 0 : t;
}
o(XEe, "computeAriaValueText");
var ZB = ow();
function JEe(e) {
  return e.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}
o(JEe, "escapeRegExp");
function QB(e) {
  return new RegExp(JEe(e.toLowerCase()), "i");
}
o(QB, "getRegExpMatcher");
function cn(e, t, r, n) {
  let {
    variant: i,
    name: s
  } = n, a = "", l = {}, u = [["Role", "TestId"].includes(e) ? r : QB(r)];
  s && (l.name = QB(s)), e === "Role" && iy(t) && (l.hidden = !0, a = `Element is inaccessible. This means that the element and all its chil\
dren are invisible to screen readers.
    If you are using the aria-hidden prop, make sure this is the right choice for your case.
    `), Object.keys(l).length > 0 && u.push(l);
  let c = i + "By" + e;
  return {
    queryName: e,
    queryMethod: c,
    queryArgs: u,
    variant: i,
    warning: a,
    toString() {
      a && console.warn(a);
      let [d, p] = u;
      return d = typeof d == "string" ? "'" + d + "'" : d, p = p ? ", { " + Object.entries(p).map((y) => {
        let [f, m] = y;
        return f + ": " + m;
      }).join(", ") + " }" : "", c + "(" + d + p + ")";
    }
  };
}
o(cn, "makeSuggestion");
function dn(e, t, r) {
  return r && (!t || t.toLowerCase() === e.toLowerCase());
}
o(dn, "canSuggest");
function ny(e, t, r) {
  var n, i;
  if (t === void 0 && (t = "get"), e.matches(le().defaultIgnore))
    return;
  let s = (n = e.getAttribute("role")) != null ? n : (i = iw(e)) == null ? void 0 : i[0];
  if (s !== "generic" && dn("Role", r, s))
    return cn("Role", e, s, {
      variant: t,
      name: ma(e, {
        computedStyleSupportsPseudoElements: le().computedStyleSupportsPseudoElements
      })
    });
  let a = y2(document, e).map((y) => y.content).join(" ");
  if (dn("LabelText", r, a))
    return cn("LabelText", e, a, {
      variant: t
    });
  let l = e.getAttribute("placeholder");
  if (dn("PlaceholderText", r, l))
    return cn("PlaceholderText", e, l, {
      variant: t
    });
  let u = ZB(_a(e));
  if (dn("Text", r, u))
    return cn("Text", e, u, {
      variant: t
    });
  if (dn("DisplayValue", r, e.value))
    return cn("DisplayValue", e, ZB(e.value), {
      variant: t
    });
  let c = e.getAttribute("alt");
  if (dn("AltText", r, c))
    return cn("AltText", e, c, {
      variant: t
    });
  let d = e.getAttribute("title");
  if (dn("Title", r, d))
    return cn("Title", e, d, {
      variant: t
    });
  let p = e.getAttribute(le().testIdAttribute);
  if (dn("TestId", r, p))
    return cn("TestId", e, p, {
      variant: t
    });
}
o(ny, "getSuggestedQuery");
function ty(e, t) {
  e.stack = t.stack.replace(t.message, e.message);
}
o(ty, "copyStackTrace");
function ZEe(e, t) {
  let {
    container: r = nw(),
    timeout: n = le().asyncUtilTimeout,
    showOriginalStackTrace: i = le().showOriginalStackTrace,
    stackTraceError: s,
    interval: a = 50,
    onTimeout: l = /* @__PURE__ */ o((c) => (Object.defineProperty(c, "message", {
      value: le().getElementError(c.message, r).message
    }), c), "onTimeout"),
    mutationObserverOptions: u = {
      subtree: !0,
      childList: !0,
      attributes: !0,
      characterData: !0
    }
  } = t;
  if (typeof e != "function")
    throw new TypeError("Received `callback` arg must be a function");
  return new Promise(async (c, d) => {
    let p, y, f, m = !1, h = "idle", b = setTimeout(R, n), g = zR();
    if (g) {
      let {
        unstable_advanceTimersWrapper: C
      } = le();
      for (E(); !m; ) {
        if (!zR()) {
          let w = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very \
strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go\
 to https://github.com/testing-library/dom-testing-library/issues/830");
          i || ty(w, s), d(w);
          return;
        }
        if (await C(async () => {
          jest.advanceTimersByTime(a);
        }), m)
          break;
        E();
      }
    } else {
      try {
        xr(r);
      } catch (w) {
        d(w);
        return;
      }
      y = setInterval(_, a);
      let {
        MutationObserver: C
      } = f2(r);
      f = new C(_), f.observe(r, u), E();
    }
    function T(C, w) {
      m = !0, clearTimeout(b), g || (clearInterval(y), f.disconnect()), C ? d(C) : c(w);
    }
    o(T, "onDone");
    function _() {
      if (zR()) {
        let C = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very st\
range behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go t\
o https://github.com/testing-library/dom-testing-library/issues/830");
        return i || ty(C, s), d(C);
      } else
        return E();
    }
    o(_, "checkRealTimersCallback");
    function E() {
      if (h !== "pending")
        try {
          let C = MEe(e);
          typeof C?.then == "function" ? (h = "pending", C.then((w) => {
            h = "resolved", T(null, w);
          }, (w) => {
            h = "rejected", p = w;
          })) : T(null, C);
        } catch (C) {
          p = C;
        }
    }
    o(E, "checkCallback");
    function R() {
      let C;
      p ? (C = p, !i && C.name === "TestingLibraryElementError" && ty(C, s)) : (C = new Error("Timed out in waitFor."), i || ty(C, s)), T(l(
      C), null);
    }
    o(R, "handleTimeout");
  });
}
o(ZEe, "waitFor");
function sw(e, t) {
  let r = new Error("STACK_TRACE_MESSAGE");
  return le().asyncWrapper(() => ZEe(e, {
    stackTraceError: r,
    ...t
  }));
}
o(sw, "waitForWrapper");
function sy(e, t) {
  return le().getElementError(e, t);
}
o(sy, "getElementError");
function ay(e, t) {
  return sy(e + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllB\
yText`)).", t);
}
o(ay, "getMultipleElementsFoundError");
function Vn(e, t, r, n) {
  let {
    exact: i = !0,
    collapseWhitespace: s,
    trim: a,
    normalizer: l
  } = n === void 0 ? {} : n, u = i ? Sr : Ei, c = Hn({
    collapseWhitespace: s,
    trim: a,
    normalizer: l
  });
  return Array.from(t.querySelectorAll("[" + e + "]")).filter((d) => u(d.getAttribute(e), d, r, c));
}
o(Vn, "queryAllByAttribute");
function _2(e, t, r, n) {
  let i = Vn(e, t, r, n);
  if (i.length > 1)
    throw ay("Found multiple elements by [" + e + "=" + r + "]", t);
  return i[0] || null;
}
o(_2, "queryByAttribute");
function gi(e, t) {
  return function(r) {
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      i[s - 1] = arguments[s];
    let a = e(r, ...i);
    if (a.length > 1) {
      let l = a.map((u) => sy(null, u).message).join(`

`);
      throw ay(t(r, ...i) + `

Here are the matching elements:

` + l, r);
    }
    return a[0] || null;
  };
}
o(gi, "makeSingleQuery");
function R2(e, t) {
  return le().getElementError(`A better query is available, try this:
` + e.toString() + `
`, t);
}
o(R2, "getSuggestionError");
function aw(e, t) {
  return function(r) {
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      i[s - 1] = arguments[s];
    let a = e(r, ...i);
    if (!a.length)
      throw le().getElementError(t(r, ...i), r);
    return a;
  };
}
o(aw, "makeGetAllQuery");
function vi(e) {
  return (t, r, n, i) => sw(() => e(t, r, n), {
    container: t,
    ...i
  });
}
o(vi, "makeFindQuery");
var pn = /* @__PURE__ */ o((e, t, r) => function(n) {
  for (var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
    s[a - 1] = arguments[a];
  let l = e(n, ...s), [{
    suggest: u = le().throwSuggestions
  } = {}] = s.slice(-1);
  if (l && u) {
    let c = ny(l, r);
    if (c && !t.endsWith(c.queryName))
      throw R2(c.toString(), n);
  }
  return l;
}, "wrapSingleQueryWithSuggestion"), Tt = /* @__PURE__ */ o((e, t, r) => function(n) {
  for (var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
    s[a - 1] = arguments[a];
  let l = e(n, ...s), [{
    suggest: u = le().throwSuggestions
  } = {}] = s.slice(-1);
  if (l.length && u) {
    let c = [...new Set(l.map((d) => {
      var p;
      return (p = ny(d, r)) == null ? void 0 : p.toString();
    }))];
    if (
      // only want to suggest if all the els have the same suggestion.
      c.length === 1 && !t.endsWith(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
        ny(l[0], r).queryName
      )
    )
      throw R2(c[0], n);
  }
  return l;
}, "wrapAllByQueryWithSuggestion");
function Cr(e, t, r) {
  let n = pn(gi(e, t), e.name, "query"), i = aw(e, r), s = gi(i, t), a = pn(s, e.name, "get"), l = Tt(i, e.name.replace("query", "get"), "ge\
tAll"), u = vi(Tt(i, e.name, "findAll")), c = vi(pn(s, e.name, "find"));
  return [n, l, a, u, c];
}
o(Cr, "buildQueries");
var QEe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  getElementError: sy,
  wrapAllByQueryWithSuggestion: Tt,
  wrapSingleQueryWithSuggestion: pn,
  getMultipleElementsFoundError: ay,
  queryAllByAttribute: Vn,
  queryByAttribute: _2,
  makeSingleQuery: gi,
  makeGetAllQuery: aw,
  makeFindQuery: vi,
  buildQueries: Cr
});
function eTe(e) {
  return Array.from(e.querySelectorAll("label,input")).map((t) => ({
    node: t,
    textToMatch: YR(t)
  })).filter((t) => {
    let {
      textToMatch: r
    } = t;
    return r !== null;
  });
}
o(eTe, "queryAllLabels");
var tTe = /* @__PURE__ */ o(function(e, t, r) {
  let {
    exact: n = !0,
    trim: i,
    collapseWhitespace: s,
    normalizer: a
  } = r === void 0 ? {} : r, l = n ? Sr : Ei, u = Hn({
    collapseWhitespace: s,
    trim: i,
    normalizer: a
  });
  return eTe(e).filter((d) => {
    let {
      node: p,
      textToMatch: y
    } = d;
    return l(y, p, t, u);
  }).map((d) => {
    let {
      node: p
    } = d;
    return p;
  });
}, "queryAllLabelsByText"), va = /* @__PURE__ */ o(function(e, t, r) {
  let {
    selector: n = "*",
    exact: i = !0,
    collapseWhitespace: s,
    trim: a,
    normalizer: l
  } = r === void 0 ? {} : r;
  xr(e);
  let u = i ? Sr : Ei, c = Hn({
    collapseWhitespace: s,
    trim: a,
    normalizer: l
  }), d = Array.from(e.querySelectorAll("*")).filter((p) => h2(p).length || p.hasAttribute("aria-labelledby")).reduce((p, y) => {
    let f = y2(e, y, {
      selector: n
    });
    f.filter((h) => !!h.formControl).forEach((h) => {
      u(h.content, h.formControl, t, c) && h.formControl && p.push(h.formControl);
    });
    let m = f.filter((h) => !!h.content).map((h) => h.content);
    return u(m.join(" "), y, t, c) && p.push(y), m.length > 1 && m.forEach((h, b) => {
      u(h, y, t, c) && p.push(y);
      let g = [...m];
      g.splice(b, 1), g.length > 1 && u(g.join(" "), y, t, c) && p.push(y);
    }), p;
  }, []).concat(Vn("aria-label", e, t, {
    exact: i,
    normalizer: c
  }));
  return Array.from(new Set(d)).filter((p) => p.matches(n));
}, "queryAllByLabelText"), Un = /* @__PURE__ */ o(function(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  let s = va(e, t, ...n);
  if (!s.length) {
    let a = tTe(e, t, ...n);
    if (a.length) {
      let l = a.map((u) => rTe(e, u)).filter((u) => !!u);
      throw l.length ? le().getElementError(l.map((u) => "Found a label with the text of: " + t + ", however the element associated with thi\
s label (<" + u + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a \
<" + u + " />, you can use aria-label or aria-labelledby instead.").join(`

`), e) : le().getElementError("Found a label with the text of: " + t + `, however no form control was found associated to that label. Make s\
ure you're using the "for" attribute or "aria-labelledby" attribute correctly.`, e);
    } else
      throw le().getElementError("Unable to find a label with the text of: " + t, e);
  }
  return s;
}, "getAllByLabelText");
function rTe(e, t) {
  let r = t.getAttribute("for");
  if (!r)
    return null;
  let n = e.querySelector('[id="' + r + '"]');
  return n ? n.tagName.toLowerCase() : null;
}
o(rTe, "getTagNameOfElementAssociatedWithLabelViaFor");
var w2 = /* @__PURE__ */ o((e, t) => "Found multiple elements with the text of: " + t, "getMultipleError$7"), S2 = pn(gi(va, w2), va.name, "\
query"), x2 = gi(Un, w2), C2 = vi(Tt(Un, Un.name, "findAll")), P2 = vi(pn(x2, Un.name, "find")), A2 = Tt(Un, Un.name, "getAll"), O2 = pn(x2,
Un.name, "get"), q2 = Tt(va, va.name, "queryAll"), WR = /* @__PURE__ */ o(function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return xr(t[0]), Vn("placeholder", ...t);
}, "queryAllByPlaceholderText"), nTe = /* @__PURE__ */ o((e, t) => "Found multiple elements with the placeholder text of: " + t, "getMultipl\
eError$6"), oTe = /* @__PURE__ */ o((e, t) => "Unable to find an element with the placeholder text of: " + t, "getMissingError$6"), I2 = Tt(
WR, WR.name, "queryAll"), [M2, N2, j2, L2, F2] = Cr(WR, nTe, oTe), KR = /* @__PURE__ */ o(function(e, t, r) {
  let {
    selector: n = "*",
    exact: i = !0,
    collapseWhitespace: s,
    trim: a,
    ignore: l = le().defaultIgnore,
    normalizer: u
  } = r === void 0 ? {} : r;
  xr(e);
  let c = i ? Sr : Ei, d = Hn({
    collapseWhitespace: s,
    trim: a,
    normalizer: u
  }), p = [];
  return typeof e.matches == "function" && e.matches(n) && (p = [e]), [...p, ...Array.from(e.querySelectorAll(n))].filter((y) => !l || !y.matches(
  l)).filter((y) => c(_a(y), y, t, d));
}, "queryAllByText"), iTe = /* @__PURE__ */ o((e, t) => "Found multiple elements with the text: " + t, "getMultipleError$5"), sTe = /* @__PURE__ */ o(
function(e, t, r) {
  r === void 0 && (r = {});
  let {
    collapseWhitespace: n,
    trim: i,
    normalizer: s,
    selector: a
  } = r, u = Hn({
    collapseWhitespace: n,
    trim: i,
    normalizer: s
  })(t.toString()), c = u !== t.toString(), d = (a ?? "*") !== "*";
  return "Unable to find an element with the text: " + (c ? u + " (normalized from '" + t + "')" : t) + (d ? ", which matches selector '" + a +
  "'" : "") + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text ma\
tcher to make your matcher more flexible.";
}, "getMissingError$5"), k2 = Tt(KR, KR.name, "queryAll"), [D2, $2, B2, U2, H2] = Cr(KR, iTe, sTe), XR = /* @__PURE__ */ o(function(e, t, r) {
  let {
    exact: n = !0,
    collapseWhitespace: i,
    trim: s,
    normalizer: a
  } = r === void 0 ? {} : r;
  xr(e);
  let l = n ? Sr : Ei, u = Hn({
    collapseWhitespace: i,
    trim: s,
    normalizer: a
  });
  return Array.from(e.querySelectorAll("input,textarea,select")).filter((c) => c.tagName === "SELECT" ? Array.from(c.options).filter((p) => p.
  selected).some((p) => l(_a(p), p, t, u)) : l(c.value, c, t, u));
}, "queryAllByDisplayValue"), aTe = /* @__PURE__ */ o((e, t) => "Found multiple elements with the display value: " + t + ".", "getMultipleEr\
ror$4"), lTe = /* @__PURE__ */ o((e, t) => "Unable to find an element with the display value: " + t + ".", "getMissingError$4"), V2 = Tt(XR,
XR.name, "queryAll"), [z2, G2, Y2, W2, K2] = Cr(XR, aTe, lTe), uTe = /^(img|input|area|.+-.+)$/i, JR = /* @__PURE__ */ o(function(e, t, r) {
  return r === void 0 && (r = {}), xr(e), Vn("alt", e, t, r).filter((n) => uTe.test(n.tagName));
}, "queryAllByAltText"), cTe = /* @__PURE__ */ o((e, t) => "Found multiple elements with the alt text: " + t, "getMultipleError$3"), dTe = /* @__PURE__ */ o(
(e, t) => "Unable to find an element with the alt text: " + t, "getMissingError$3"), X2 = Tt(JR, JR.name, "queryAll"), [J2, Z2, Q2, eU, tU] = Cr(
JR, cTe, dTe), pTe = /* @__PURE__ */ o((e) => {
  var t;
  return e.tagName.toLowerCase() === "title" && ((t = e.parentElement) == null ? void 0 : t.tagName.toLowerCase()) === "svg";
}, "isSvgTitle"), ZR = /* @__PURE__ */ o(function(e, t, r) {
  let {
    exact: n = !0,
    collapseWhitespace: i,
    trim: s,
    normalizer: a
  } = r === void 0 ? {} : r;
  xr(e);
  let l = n ? Sr : Ei, u = Hn({
    collapseWhitespace: i,
    trim: s,
    normalizer: a
  });
  return Array.from(e.querySelectorAll("[title], svg > title")).filter((c) => l(c.getAttribute("title"), c, t, u) || pTe(c) && l(_a(c), c, t,
  u));
}, "queryAllByTitle"), fTe = /* @__PURE__ */ o((e, t) => "Found multiple elements with the title: " + t + ".", "getMultipleError$2"), mTe = /* @__PURE__ */ o(
(e, t) => "Unable to find an element with the title: " + t + ".", "getMissingError$2"), rU = Tt(ZR, ZR.name, "queryAll"), [nU, oU, iU, sU, aU] = Cr(
ZR, fTe, mTe), QR = /* @__PURE__ */ o(function(e, t, r) {
  let {
    hidden: n = le().defaultHidden,
    name: i,
    description: s,
    queryFallbacks: a = !1,
    selected: l,
    busy: u,
    checked: c,
    pressed: d,
    current: p,
    level: y,
    expanded: f,
    value: {
      now: m,
      min: h,
      max: b,
      text: g
    } = {}
  } = r === void 0 ? {} : r;
  if (xr(e), l !== void 0) {
    var T;
    if (((T = ht.roles.get(t)) == null ? void 0 : T.props["aria-selected"]) === void 0)
      throw new Error('"aria-selected" is not supported on role "' + t + '".');
  }
  if (u !== void 0) {
    var _;
    if (((_ = ht.roles.get(t)) == null ? void 0 : _.props["aria-busy"]) === void 0)
      throw new Error('"aria-busy" is not supported on role "' + t + '".');
  }
  if (c !== void 0) {
    var E;
    if (((E = ht.roles.get(t)) == null ? void 0 : E.props["aria-checked"]) === void 0)
      throw new Error('"aria-checked" is not supported on role "' + t + '".');
  }
  if (d !== void 0) {
    var R;
    if (((R = ht.roles.get(t)) == null ? void 0 : R.props["aria-pressed"]) === void 0)
      throw new Error('"aria-pressed" is not supported on role "' + t + '".');
  }
  if (p !== void 0) {
    var C;
    if (((C = ht.roles.get(t)) == null ? void 0 : C.props["aria-current"]) === void 0)
      throw new Error('"aria-current" is not supported on role "' + t + '".');
  }
  if (y !== void 0 && t !== "heading")
    throw new Error('Role "' + t + '" cannot have "level" property.');
  if (m !== void 0) {
    var w;
    if (((w = ht.roles.get(t)) == null ? void 0 : w.props["aria-valuenow"]) === void 0)
      throw new Error('"aria-valuenow" is not supported on role "' + t + '".');
  }
  if (b !== void 0) {
    var P;
    if (((P = ht.roles.get(t)) == null ? void 0 : P.props["aria-valuemax"]) === void 0)
      throw new Error('"aria-valuemax" is not supported on role "' + t + '".');
  }
  if (h !== void 0) {
    var O;
    if (((O = ht.roles.get(t)) == null ? void 0 : O.props["aria-valuemin"]) === void 0)
      throw new Error('"aria-valuemin" is not supported on role "' + t + '".');
  }
  if (g !== void 0) {
    var D;
    if (((D = ht.roles.get(t)) == null ? void 0 : D.props["aria-valuetext"]) === void 0)
      throw new Error('"aria-valuetext" is not supported on role "' + t + '".');
  }
  if (f !== void 0) {
    var A;
    if (((A = ht.roles.get(t)) == null ? void 0 : A.props["aria-expanded"]) === void 0)
      throw new Error('"aria-expanded" is not supported on role "' + t + '".');
  }
  let L = /* @__PURE__ */ new WeakMap();
  function B(N) {
    return L.has(N) || L.set(N, v2(N)), L.get(N);
  }
  return o(B, "cachedIsSubtreeInaccessible"), Array.from(e.querySelectorAll(
    // Only query elements that can be matched by the following filters
    hTe(t)
  )).filter((N) => {
    if (N.hasAttribute("role")) {
      let V = N.getAttribute("role");
      if (a)
        return V.split(" ").filter(Boolean).some((Q) => Q === t);
      let [G] = V.split(" ");
      return G === t;
    }
    return iw(N).some((V) => V === t);
  }).filter((N) => {
    if (l !== void 0)
      return l === $Ee(N);
    if (u !== void 0)
      return u === BEe(N);
    if (c !== void 0)
      return c === UEe(N);
    if (d !== void 0)
      return d === HEe(N);
    if (p !== void 0)
      return p === VEe(N);
    if (f !== void 0)
      return f === zEe(N);
    if (y !== void 0)
      return y === GEe(N);
    if (m !== void 0 || b !== void 0 || h !== void 0 || g !== void 0) {
      let M = !0;
      if (m !== void 0 && M && (M = m === YEe(N)), b !== void 0 && M && (M = b === WEe(N)), h !== void 0 && M && (M = h === KEe(N)), g !== void 0) {
        var $;
        M && (M = Sr(($ = XEe(N)) != null ? $ : null, N, g, (V) => V));
      }
      return M;
    }
    return !0;
  }).filter((N) => i === void 0 ? !0 : Sr(ma(N, {
    computedStyleSupportsPseudoElements: le().computedStyleSupportsPseudoElements
  }), N, i, ($) => $)).filter((N) => s === void 0 ? !0 : Sr(of(N, {
    computedStyleSupportsPseudoElements: le().computedStyleSupportsPseudoElements
  }), N, s, ($) => $)).filter((N) => n === !1 ? iy(N, {
    isSubtreeInaccessible: B
  }) === !1 : !0);
}, "queryAllByRole");
function hTe(e) {
  var t;
  let r = '*[role~="' + e + '"]', n = (t = ht.roleElements.get(e)) != null ? t : /* @__PURE__ */ new Set(), i = new Set(Array.from(n).map((s) => {
    let {
      name: a
    } = s;
    return a;
  }));
  return [r].concat(Array.from(i)).join(",");
}
o(hTe, "makeRoleSelector");
var lU = /* @__PURE__ */ o((e) => {
  let t = "";
  return e === void 0 ? t = "" : typeof e == "string" ? t = ' and name "' + e + '"' : t = " and name `" + e + "`", t;
}, "getNameHint"), yTe = /* @__PURE__ */ o(function(e, t, r) {
  let {
    name: n
  } = r === void 0 ? {} : r;
  return 'Found multiple elements with the role "' + t + '"' + lU(n);
}, "getMultipleError$1"), bTe = /* @__PURE__ */ o(function(e, t, r) {
  let {
    hidden: n = le().defaultHidden,
    name: i,
    description: s
  } = r === void 0 ? {} : r;
  if (le()._disableExpensiveErrorDiagnostics)
    return 'Unable to find role="' + t + '"' + lU(i);
  let a = "";
  Array.from(e.children).forEach((d) => {
    a += T2(d, {
      hidden: n,
      includeDescription: s !== void 0
    });
  });
  let l;
  a.length === 0 ? n === !1 ? l = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, th\
en set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole" :
  l = "There are no available roles." : l = (`
Here are the ` + (n === !1 ? "accessible" : "available") + ` roles:

  ` + a.replace(/\n/g, `
  `).replace(/\n\s\s\n/g, `

`) + `
`).trim();
  let u = "";
  i === void 0 ? u = "" : typeof i == "string" ? u = ' and name "' + i + '"' : u = " and name `" + i + "`";
  let c = "";
  return s === void 0 ? c = "" : typeof s == "string" ? c = ' and description "' + s + '"' : c = " and description `" + s + "`", (`
Unable to find an ` + (n === !1 ? "accessible " : "") + 'element with the role "' + t + '"' + u + c + `

` + l).trim();
}, "getMissingError$1"), uU = Tt(QR, QR.name, "queryAll"), [cU, dU, pU, fU, mU] = Cr(QR, yTe, bTe), lw = /* @__PURE__ */ o(() => le().testIdAttribute,
"getTestIdAttribute"), ew = /* @__PURE__ */ o(function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return xr(t[0]), Vn(lw(), ...t);
}, "queryAllByTestId"), gTe = /* @__PURE__ */ o((e, t) => "Found multiple elements by: [" + lw() + '="' + t + '"]', "getMultipleError"), vTe = /* @__PURE__ */ o(
(e, t) => "Unable to find an element by: [" + lw() + '="' + t + '"]', "getMissingError"), hU = Tt(ew, ew.name, "queryAll"), [yU, bU, gU, vU,
EU] = Cr(ew, gTe, vTe), oy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  queryAllByLabelText: q2,
  queryByLabelText: S2,
  getAllByLabelText: A2,
  getByLabelText: O2,
  findAllByLabelText: C2,
  findByLabelText: P2,
  queryByPlaceholderText: M2,
  queryAllByPlaceholderText: I2,
  getByPlaceholderText: j2,
  getAllByPlaceholderText: N2,
  findAllByPlaceholderText: L2,
  findByPlaceholderText: F2,
  queryByText: D2,
  queryAllByText: k2,
  getByText: B2,
  getAllByText: $2,
  findAllByText: U2,
  findByText: H2,
  queryByDisplayValue: z2,
  queryAllByDisplayValue: V2,
  getByDisplayValue: Y2,
  getAllByDisplayValue: G2,
  findAllByDisplayValue: W2,
  findByDisplayValue: K2,
  queryByAltText: J2,
  queryAllByAltText: X2,
  getByAltText: Q2,
  getAllByAltText: Z2,
  findAllByAltText: eU,
  findByAltText: tU,
  queryByTitle: nU,
  queryAllByTitle: rU,
  getByTitle: iU,
  getAllByTitle: oU,
  findAllByTitle: sU,
  findByTitle: aU,
  queryByRole: cU,
  queryAllByRole: uU,
  getAllByRole: dU,
  getByRole: pU,
  findAllByRole: fU,
  findByRole: mU,
  queryByTestId: yU,
  queryAllByTestId: hU,
  getByTestId: gU,
  getAllByTestId: bU,
  findAllByTestId: vU,
  findByTestId: EU
});
function TU(e, t, r) {
  return t === void 0 && (t = oy), r === void 0 && (r = {}), Object.keys(t).reduce((n, i) => {
    let s = t[i];
    return n[i] = s.bind(null, e), n;
  }, r);
}
o(TU, "getQueriesForElement");
var _U = /* @__PURE__ */ o((e) => !e || Array.isArray(e) && !e.length, "isRemoved");
function e2(e) {
  if (_U(e))
    throw new Error("The element(s) given to waitForElementToBeRemoved are already removed. waitForElementToBeRemoved requires that the elem\
ent(s) exist(s) before waiting for removal.");
}
o(e2, "initialCheck");
async function ETe(e, t) {
  let r = new Error("Timed out in waitForElementToBeRemoved.");
  if (typeof e != "function") {
    e2(e);
    let i = (Array.isArray(e) ? e : [e]).map((s) => {
      let a = s.parentElement;
      if (a === null) return () => null;
      for (; a.parentElement; ) a = a.parentElement;
      return () => a.contains(s) ? s : null;
    });
    e = /* @__PURE__ */ o(() => i.map((s) => s()).filter(Boolean), "callback");
  }
  return e2(e()), sw(() => {
    let n;
    try {
      n = e();
    } catch (i) {
      if (i.name === "TestingLibraryElementError")
        return;
      throw i;
    }
    if (!_U(n))
      throw r;
  }, t);
}
o(ETe, "waitForElementToBeRemoved");
var t2 = {
  // Clipboard Events
  copy: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  cut: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  paste: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  compositionStart: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  compositionUpdate: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  keyPress: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  keyUp: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  // Focus Events
  focus: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  blur: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  focusIn: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  focusOut: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  // Form Events
  change: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  input: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  invalid: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !0
    }
  },
  submit: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  reset: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  // Mouse Events
  click: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      button: 0,
      composed: !0
    }
  },
  contextMenu: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dblClick: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  drag: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragEnd: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragEnter: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragExit: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragLeave: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragOver: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragStart: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  drop: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseDown: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseEnter: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseLeave: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseMove: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseOut: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseOver: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseUp: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Selection Events
  select: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // Touch Events
  touchCancel: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  touchEnd: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  touchMove: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  touchStart: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // UI Events
  resize: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  scroll: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Wheel Events
  wheel: {
    EventType: "WheelEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Media Events
  abort: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  canPlay: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  canPlayThrough: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  durationChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  emptied: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  encrypted: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  ended: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadedData: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadedMetadata: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadStart: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pause: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  play: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  playing: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  progress: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  rateChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  seeked: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  seeking: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  stalled: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  suspend: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  timeUpdate: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  volumeChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  waiting: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  error: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Animation Events
  animationStart: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  animationEnd: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  animationIteration: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  transitionEnd: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  transitionRun: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  transitionStart: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // pointer events
  pointerOver: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerEnter: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pointerDown: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerMove: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerUp: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerCancel: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  pointerOut: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerLeave: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  gotPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  lostPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  // history events
  popState: {
    EventType: "PopStateEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // window events
  offline: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  online: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pageHide: {
    EventType: "PageTransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  pageShow: {
    EventType: "PageTransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  }
}, r2 = {
  doubleClick: "dblClick"
};
function Ea(e, t) {
  return le().eventWrapper(() => {
    if (!t)
      throw new Error("Unable to fire an event - please provide an event object.");
    if (!e)
      throw new Error('Unable to fire a "' + t.type + '" event - please provide a DOM element.');
    return e.dispatchEvent(t);
  });
}
o(Ea, "fireEvent");
function ry(e, t, r, n) {
  let {
    EventType: i = "Event",
    defaultInit: s = {}
  } = n === void 0 ? {} : n;
  if (!t)
    throw new Error('Unable to fire a "' + e + '" event - please provide a DOM element.');
  let a = {
    ...s,
    ...r
  }, {
    target: {
      value: l,
      files: u,
      ...c
    } = {}
  } = a;
  l !== void 0 && TTe(t, l), u !== void 0 && Object.defineProperty(t, "files", {
    configurable: !0,
    enumerable: !0,
    writable: !0,
    value: u
  }), Object.assign(t, c);
  let d = f2(t), p = d[i] || d.Event, y;
  if (typeof p == "function")
    y = new p(e, a);
  else {
    y = d.document.createEvent(i);
    let {
      bubbles: m,
      cancelable: h,
      detail: b,
      ...g
    } = a;
    y.initEvent(e, m, h, b), Object.keys(g).forEach((T) => {
      y[T] = g[T];
    });
  }
  return ["dataTransfer", "clipboardData"].forEach((m) => {
    let h = a[m];
    typeof h == "object" && (typeof d.DataTransfer == "function" ? Object.defineProperty(y, m, {
      value: Object.getOwnPropertyNames(h).reduce((b, g) => (Object.defineProperty(b, g, {
        value: h[g]
      }), b), new d.DataTransfer())
    }) : Object.defineProperty(y, m, {
      value: h
    }));
  }), y;
}
o(ry, "createEvent");
Object.keys(t2).forEach((e) => {
  let {
    EventType: t,
    defaultInit: r
  } = t2[e], n = e.toLowerCase();
  ry[e] = (i, s) => ry(n, i, s, {
    EventType: t,
    defaultInit: r
  }), Ea[e] = (i, s) => Ea(i, ry[e](i, s));
});
function TTe(e, t) {
  let {
    set: r
  } = Object.getOwnPropertyDescriptor(e, "value") || {}, n = Object.getPrototypeOf(e), {
    set: i
  } = Object.getOwnPropertyDescriptor(n, "value") || {};
  if (i && r !== i)
    i.call(e, t);
  else if (r)
    r.call(e, t);
  else
    throw new Error("The given element does not have a value setter");
}
o(TTe, "setNativeValue");
Object.keys(r2).forEach((e) => {
  let t = r2[e];
  Ea[e] = function() {
    return Ea[t](...arguments);
  };
});
function _Te(e) {
  return e.replace(/[ \t]*[\n][ \t]*/g, `
`);
}
o(_Te, "unindent");
function RTe(e) {
  return o2.default.compressToEncodedURIComponent(_Te(e));
}
o(RTe, "encode");
function wTe(e) {
  return "https://testing-playground.com/#markup=" + RTe(e);
}
o(wTe, "getPlaygroundUrl");
var STe = /* @__PURE__ */ o((e, t, r) => Array.isArray(e) ? e.forEach((n) => GR(n, t, r)) : GR(e, t, r), "debug"), xTe = /* @__PURE__ */ o(function(e) {
  if (e === void 0 && (e = nw().body), !e || !("innerHTML" in e)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  if (!e.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  let t = wTe(e.innerHTML);
  return console.log(`Open this URL in your browser

` + t), t;
}, "logTestingPlaygroundURL"), n2 = {
  debug: STe,
  logTestingPlaygroundURL: xTe
}, CTe = typeof document < "u" && document.body ? TU(document.body, oy, n2) : Object.keys(oy).reduce((e, t) => (e[t] = () => {
  throw new TypeError("For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s\
/screen-global-error");
}, e), n2);

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/isElementType.js
function J(e, t, r) {
  return e.namespaceURI && e.namespaceURI !== "http://www.w3.org/1999/xhtml" || (t = Array.isArray(t) ? t : [
    t
  ], !t.includes(e.tagName.toLowerCase())) ? !1 : r ? Object.entries(r).every(([n, i]) => e[n] === i) : !0;
}
o(J, "isElementType");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/getWindow.js
function je(e) {
  var t;
  if (PTe(e) && e.defaultView)
    return e.defaultView;
  if (!((t = e.ownerDocument) === null || t === void 0) && t.defaultView)
    return e.ownerDocument.defaultView;
  throw new Error(`Could not determine window of node. Node was ${ATe(e)}`);
}
o(je, "getWindow");
function PTe(e) {
  return e.nodeType === 9;
}
o(PTe, "isDocument");
function ATe(e) {
  return typeof e == "function" ? `function ${e.name}` : e === null ? "null" : String(e);
}
o(ATe, "describe");

// ../node_modules/@testing-library/user-event/dist/esm/utils/dataTransfer/Blob.js
function cw(e, t) {
  return new Promise((r, n) => {
    let i = new t();
    i.onerror = n, i.onabort = n, i.onload = () => {
      r(String(i.result));
    }, i.readAsText(e);
  });
}
o(cw, "readBlobText");

// ../node_modules/@testing-library/user-event/dist/esm/utils/dataTransfer/FileList.js
function wa(e, t) {
  let r = {
    ...t,
    length: t.length,
    item: /* @__PURE__ */ o((n) => r[n], "item"),
    [Symbol.iterator]: /* @__PURE__ */ o(function* () {
      for (let i = 0; i < r.length; i++)
        yield r[i];
    }, "nextFile")
  };
  return r.constructor = e.FileList, e.FileList && Object.setPrototypeOf(r, e.FileList.prototype), Object.freeze(r), r;
}
o(wa, "createFileList");

// ../node_modules/@testing-library/user-event/dist/esm/utils/dataTransfer/DataTransfer.js
function fn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(fn, "_define_property");
var pw = class pw {
  getAsFile() {
    return this.file;
  }
  getAsString(t) {
    typeof this.data == "string" && t(this.data);
  }
  /* istanbul ignore next */
  webkitGetAsEntry() {
    throw new Error("not implemented");
  }
  constructor(t, r) {
    fn(this, "kind", void 0), fn(this, "type", void 0), fn(this, "file", null), fn(this, "data", void 0), typeof t == "string" ? (this.kind =
    "string", this.type = String(r), this.data = t) : (this.kind = "file", this.type = t.type, this.file = t);
  }
};
o(pw, "DataTransferItemStub");
var uy = pw, fw = class fw extends Array {
  add(...t) {
    let r = new uy(t[0], t[1]);
    return this.push(r), r;
  }
  clear() {
    this.splice(0, this.length);
  }
  remove(t) {
    this.splice(t, 1);
  }
};
o(fw, "DataTransferItemListStub");
var dw = fw;
function ly(e, t) {
  let [r, n] = e.split("/"), i = !n || n === "*";
  return (s) => t ? s.type === (i ? r : e) : i ? s.type.startsWith(`${r}/`) : s.type === r;
}
o(ly, "getTypeMatcher");
function OTe(e) {
  var t;
  return new (t = class {
    getData(n) {
      var i;
      let s = (i = this.items.find(ly(n, !0))) !== null && i !== void 0 ? i : this.items.find(ly(n, !1)), a = "";
      return s?.getAsString((l) => {
        a = l;
      }), a;
    }
    setData(n, i) {
      let s = this.items.findIndex(ly(n, !0)), a = new uy(i, n);
      s >= 0 ? this.items.splice(s, 1, a) : this.items.push(a);
    }
    clearData(n) {
      if (n) {
        let i = this.items.findIndex(ly(n, !0));
        i >= 0 && this.items.remove(i);
      } else
        this.items.clear();
    }
    get types() {
      let n = [];
      return this.files.length && n.push("Files"), this.items.forEach((i) => n.push(i.type)), Object.freeze(n), n;
    }
    /* istanbul ignore next */
    setDragImage() {
    }
    constructor() {
      fn(this, "dropEffect", "none"), fn(this, "effectAllowed", "uninitialized"), fn(this, "items", new dw()), fn(this, "files", wa(e, []));
    }
  }, o(t, "DataTransferStub"), t)();
}
o(OTe, "createDataTransferStub");
function Ti(e, t = []) {
  let r = typeof e.DataTransfer > "u" ? OTe(e) : (
    /* istanbul ignore next */
    new e.DataTransfer()
  );
  return Object.defineProperty(r, "files", {
    get: /* @__PURE__ */ o(() => wa(e, t), "get")
  }), r;
}
o(Ti, "createDataTransfer");
async function RU(e, t) {
  return t.kind === "file" ? t.getAsFile() : new e.Blob([
    await new Promise((r) => t.getAsString(r))
  ], {
    type: t.type
  });
}
o(RU, "getBlobFromDataTransferItem");

// ../node_modules/@testing-library/user-event/dist/esm/utils/dataTransfer/Clipboard.js
function SU(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(SU, "_define_property");
function xU(e, ...t) {
  var n;
  let r = Object.fromEntries(t.map((i) => [
    typeof i == "string" ? "text/plain" : i.type,
    Promise.resolve(i)
  ]));
  return typeof e.ClipboardItem < "u" ? new e.ClipboardItem(r) : new (n = class {
    get types() {
      return Array.from(Object.keys(this.data));
    }
    async getType(s) {
      let a = await this.data[s];
      if (!a)
        throw new Error(`${s} is not one of the available MIME types on this item.`);
      return a instanceof e.Blob ? a : new e.Blob([
        a
      ], {
        type: s
      });
    }
    constructor(s) {
      SU(this, "data", void 0), this.data = s;
    }
  }, o(n, "ClipboardItem"), n)(r);
}
o(xU, "createClipboardItem");
var _i = Symbol("Manage ClipboardSub");
function wU(e, t) {
  var r;
  return Object.assign(new (r = class extends e.EventTarget {
    async read() {
      return Array.from(this.items);
    }
    async readText() {
      let i = "";
      for (let s of this.items) {
        let a = s.types.includes("text/plain") ? "text/plain" : s.types.find((l) => l.startsWith("text/"));
        a && (i += await s.getType(a).then((l) => cw(l, e.FileReader)));
      }
      return i;
    }
    async write(i) {
      this.items = i;
    }
    async writeText(i) {
      this.items = [
        xU(e, i)
      ];
    }
    constructor(...i) {
      super(...i), SU(this, "items", []);
    }
  }, o(r, "Clipboard"), r)(), {
    [_i]: t
  });
}
o(wU, "createClipboardStub");
function mw(e) {
  return !!e?.[_i];
}
o(mw, "isClipboardStub");
function CU(e) {
  if (mw(e.navigator.clipboard))
    return e.navigator.clipboard[_i];
  let t = Object.getOwnPropertyDescriptor(e.navigator, "clipboard"), r, n = {
    resetClipboardStub: /* @__PURE__ */ o(() => {
      r = wU(e, n);
    }, "resetClipboardStub"),
    detachClipboardStub: /* @__PURE__ */ o(() => {
      t ? Object.defineProperty(e.navigator, "clipboard", t) : Object.defineProperty(e.navigator, "clipboard", {
        value: void 0,
        configurable: !0
      });
    }, "detachClipboardStub")
  };
  return r = wU(e, n), Object.defineProperty(e.navigator, "clipboard", {
    get: /* @__PURE__ */ o(() => r, "get"),
    configurable: !0
  }), r[_i];
}
o(CU, "attachClipboardStubToView");
function qTe(e) {
  mw(e.navigator.clipboard) && e.navigator.clipboard[_i].resetClipboardStub();
}
o(qTe, "resetClipboardStubOnView");
function ITe(e) {
  mw(e.navigator.clipboard) && e.navigator.clipboard[_i].detachClipboardStub();
}
o(ITe, "detachClipboardStubFromView");
async function PU(e) {
  let t = e.defaultView, r = t?.navigator.clipboard, n = r && await r.read();
  if (!n)
    throw new Error("The Clipboard API is unavailable.");
  let i = Ti(t);
  for (let s of n)
    for (let a of s.types)
      i.setData(a, await s.getType(a).then((l) => cw(l, t.FileReader)));
  return i;
}
o(PU, "readDataTransferFromClipboard");
async function dy(e, t) {
  let r = je(e), n = r.navigator.clipboard, i = [];
  for (let a = 0; a < t.items.length; a++) {
    let l = t.items[a], u = await RU(r, l);
    i.push(xU(r, u));
  }
  if (!(n && await n.write(i).then(
    () => !0,
    // Can happen with other implementations that e.g. require permissions
    /* istanbul ignore next */
    () => !1
  )))
    throw new Error("The Clipboard API is unavailable.");
}
o(dy, "writeDataTransferToClipboard");
var cy = globalThis;
typeof cy.afterEach == "function" && cy.afterEach(() => {
  typeof globalThis.window < "u" && qTe(globalThis.window);
});
typeof cy.afterAll == "function" && cy.afterAll(() => {
  typeof globalThis.window < "u" && ITe(globalThis.window);
});

// ../node_modules/@testing-library/user-event/dist/esm/utils/focus/selector.js
var py = [
  "input:not([type=hidden]):not([disabled])",
  "button:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[contenteditable=""]',
  '[contenteditable="true"]',
  "a[href]",
  "[tabindex]:not([disabled])"
].join(", ");

// ../node_modules/@testing-library/user-event/dist/esm/utils/focus/isFocusable.js
function Sa(e) {
  return e.matches(py);
}
o(Sa, "isFocusable");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/cloneEvent.js
function AU(e) {
  return new e.constructor(e.type, e);
}
o(AU, "cloneEvent");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/isDisabled.js
function ut(e) {
  for (let r = e; r; r = r.parentElement)
    if (J(r, [
      "button",
      "input",
      "select",
      "textarea",
      "optgroup",
      "option"
    ])) {
      if (r.hasAttribute("disabled"))
        return !0;
    } else if (J(r, "fieldset")) {
      var t;
      if (r.hasAttribute("disabled") && !(!((t = r.querySelector(":scope > legend")) === null || t === void 0) && t.contains(e)))
        return !0;
    } else if (r.tagName.includes("-") && r.constructor.formAssociated && r.hasAttribute("disabled"))
      return !0;
  return !1;
}
o(ut, "isDisabled");

// ../node_modules/@testing-library/user-event/dist/esm/utils/focus/getActiveElement.js
function zn(e) {
  let t = e.activeElement;
  return t?.shadowRoot ? zn(t.shadowRoot) : ut(t) ? e.ownerDocument ? (
    /* istanbul ignore next */
    e.ownerDocument.body
  ) : e.body : t;
}
o(zn, "getActiveElement");
function fy(e) {
  var t;
  return (t = zn(e)) !== null && t !== void 0 ? t : (
    /* istanbul ignore next */
    e.body
  );
}
o(fy, "getActiveElementOrBody");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/findClosest.js
function OU(e, t) {
  let r = e;
  do {
    if (t(r))
      return r;
    r = r.parentElement;
  } while (r && r !== e.ownerDocument.body);
}
o(OU, "findClosest");

// ../node_modules/@testing-library/user-event/dist/esm/utils/edit/isContentEditable.js
function Pt(e) {
  return e.hasAttribute("contenteditable") && (e.getAttribute("contenteditable") == "true" || e.getAttribute("contenteditable") == "");
}
o(Pt, "isContentEditable");
function mn(e) {
  let t = MTe(e);
  return t && (t.closest('[contenteditable=""]') || t.closest('[contenteditable="true"]'));
}
o(mn, "getContentEditable");
function MTe(e) {
  return e.nodeType === 1 ? e : e.parentElement;
}
o(MTe, "getElement");

// ../node_modules/@testing-library/user-event/dist/esm/utils/click/isClickableInput.js
var qU = /* @__PURE__ */ function(e) {
  return e.button = "button", e.color = "color", e.file = "file", e.image = "image", e.reset = "reset", e.submit = "submit", e.checkbox = "c\
heckbox", e.radio = "radio", e;
}(qU || {});
function my(e) {
  return J(e, "button") || J(e, "input") && e.type in qU;
}
o(my, "isClickableInput");

// ../node_modules/@testing-library/user-event/dist/esm/utils/edit/isEditable.js
function tr(e) {
  return hw(e) && !e.readOnly || Pt(e);
}
o(tr, "isEditable");
var IU = /* @__PURE__ */ function(e) {
  return e.text = "text", e.date = "date", e["datetime-local"] = "datetime-local", e.email = "email", e.month = "month", e.number = "number",
  e.password = "password", e.search = "search", e.tel = "tel", e.time = "time", e.url = "url", e.week = "week", e;
}(IU || {});
function hw(e) {
  return J(e, "textarea") || J(e, "input") && e.type in IU;
}
o(hw, "isEditableInputOrTextArea");

// ../node_modules/@testing-library/user-event/dist/esm/utils/focus/selection.js
function ze(e) {
  return NU(e) && hw(e);
}
o(ze, "hasOwnSelection");
function MU(e) {
  return NU(e) && my(e);
}
o(MU, "hasNoSelection");
function NU(e) {
  return e.nodeType === 1;
}
o(NU, "isElement");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/updateSelectionOnFocus.js
function jU(e) {
  let t = e.ownerDocument.getSelection();
  if (t?.focusNode && ze(e)) {
    let n = mn(t.focusNode);
    if (n) {
      if (!t.isCollapsed) {
        var r;
        let i = ((r = n.firstChild) === null || r === void 0 ? void 0 : r.nodeType) === 3 ? n.firstChild : n;
        t.setBaseAndExtent(i, 0, i, 0);
      }
    } else
      t.setBaseAndExtent(e, 0, e, 0);
  }
}
o(jU, "updateSelectionOnFocus");

// ../node_modules/@testing-library/user-event/dist/esm/event/wrapEvent.js
function hn(e, t) {
  return le().eventWrapper(e);
}
o(hn, "wrapEvent");

// ../node_modules/@testing-library/user-event/dist/esm/event/focus.js
function _t(e) {
  let t = OU(e, Sa), r = zn(e.ownerDocument);
  (t ?? e.ownerDocument.body) !== r && (t ? hn(() => t.focus()) : hn(() => r?.blur()), jU(t ?? e.ownerDocument.body));
}
o(_t, "focusElement");
function LU(e) {
  !Sa(e) || !(zn(e.ownerDocument) === e) || hn(() => e.blur());
}
o(LU, "blurElement");

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/registry.js
var yt = {};

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/click.js
yt.click = (e, t, r) => {
  let n = t.closest("button,input,label,select,textarea"), i = n && J(n, "label") && n.control;
  if (i && i !== t)
    return () => {
      Sa(i) && (_t(i), r.dispatchEvent(i, AU(e)));
    };
  if (J(t, "input", {
    type: "file"
  }))
    return () => {
      LU(t), t.dispatchEvent(new (je(t)).Event("fileDialog")), _t(t);
    };
};

// ../node_modules/@testing-library/user-event/dist/esm/document/UI.js
var Ri = Symbol("Displayed value in UI"), Pr = Symbol("Displayed selection in UI"), hy = Symbol("Initial value to compare on blur");
function FU(e) {
  return typeof e == "object" && Ri in e;
}
o(FU, "isUIValue");
function kU(e) {
  return !!e && typeof e == "object" && Pr in e;
}
o(kU, "isUISelectionStart");
function DU(e, t) {
  e[hy] === void 0 && (e[hy] = e.value), e[Ri] = t, e.value = Object.assign(new String(t), {
    [Ri]: !0
  });
}
o(DU, "setUIValue");
function Je(e) {
  return e[Ri] === void 0 ? e.value : String(e[Ri]);
}
o(Je, "getUIValue");
function xa(e) {
  e[Ri] = void 0;
}
o(xa, "setUIValueClean");
function yy(e) {
  e[hy] = void 0;
}
o(yy, "clearInitialValue");
function $U(e) {
  return e[hy];
}
o($U, "getInitialValue");
function BU(e, t) {
  e[Pr] = t;
}
o(BU, "setUISelectionRaw");
function rr(e, { focusOffset: t, anchorOffset: r = t }, n = "replace") {
  let i = Je(e).length, s = /* @__PURE__ */ o((p) => Math.max(0, Math.min(i, p)), "sanitizeOffset"), a = n === "replace" || e[Pr] === void 0 ?
  s(r) : e[Pr].anchorOffset, l = s(t), u = Math.min(a, l), c = Math.max(a, l);
  if (e[Pr] = {
    anchorOffset: a,
    focusOffset: l
  }, e.selectionStart === u && e.selectionEnd === c)
    return;
  let d = Object.assign(new Number(u), {
    [Pr]: !0
  });
  try {
    e.setSelectionRange(d, c);
  } catch {
  }
}
o(rr, "setUISelection");
function Ar(e) {
  var t, r, n;
  let i = (n = e[Pr]) !== null && n !== void 0 ? n : {
    anchorOffset: (t = e.selectionStart) !== null && t !== void 0 ? t : 0,
    focusOffset: (r = e.selectionEnd) !== null && r !== void 0 ? r : 0
  };
  return {
    ...i,
    startOffset: Math.min(i.anchorOffset, i.focusOffset),
    endOffset: Math.max(i.anchorOffset, i.focusOffset)
  };
}
o(Ar, "getUISelection");
function UU(e) {
  return !!e[Pr];
}
o(UU, "hasUISelection");
function Ca(e) {
  e[Pr] = void 0;
}
o(Ca, "setUISelectionClean");

// ../node_modules/@testing-library/user-event/dist/esm/utils/edit/timeValue.js
var by = globalThis.parseInt;
function VU(e) {
  let t = e.replace(/\D/g, "");
  if (t.length < 2)
    return e;
  let r = by(t[0], 10), n = by(t[1], 10);
  if (r >= 3 || r === 2 && n >= 4) {
    let i;
    return r >= 3 ? i = 1 : i = 2, HU(t, i);
  }
  return e.length === 2 ? e : HU(t, 2);
}
o(VU, "buildTimeValue");
function HU(e, t) {
  let r = e.slice(0, t), n = Math.min(by(r, 10), 23), i = e.slice(t), s = by(i, 10), a = Math.min(s, 59);
  return `${n.toString().padStart(2, "0")}:${a.toString().padStart(2, "0")}`;
}
o(HU, "build");
function yw(e, t) {
  let r = e.cloneNode();
  return r.value = t, r.value === t;
}
o(yw, "isValidDateOrTimeValue");

// ../node_modules/@testing-library/user-event/dist/esm/utils/edit/maxLength.js
var zU = /* @__PURE__ */ function(e) {
  return e.email = "email", e.password = "password", e.search = "search", e.telephone = "telephone", e.text = "text", e.url = "url", e;
}(zU || {});
function GU(e) {
  var t;
  let r = (t = e.getAttribute("maxlength")) !== null && t !== void 0 ? t : "";
  return /^\d+$/.test(r) && Number(r) >= 0 ? Number(r) : void 0;
}
o(GU, "getMaxLength");
function YU(e) {
  return J(e, "textarea") || J(e, "input") && e.type in zU;
}
o(YU, "supportsMaxLength");

// ../node_modules/@testing-library/user-event/dist/esm/utils/focus/cursor.js
function Ey(e, t, r, n) {
  if (vy(e) && t + r >= 0 && t + r <= e.nodeValue.length)
    return {
      node: e,
      offset: t + r
    };
  let i = WU(e, t, r);
  if (i) {
    if (vy(i))
      return {
        node: i,
        offset: r > 0 ? Math.min(1, i.nodeValue.length) : Math.max(i.nodeValue.length - 1, 0)
      };
    if (J(i, "br")) {
      let s = WU(i, void 0, r);
      return s ? vy(s) ? {
        node: s,
        offset: r > 0 ? 0 : s.nodeValue.length
      } : r < 0 && J(s, "br") ? {
        node: i.parentNode,
        offset: gy(i)
      } : {
        node: s.parentNode,
        offset: gy(s) + (r > 0 ? 0 : 1)
      } : r < 0 && n === "deleteContentBackward" ? {
        node: i.parentNode,
        offset: gy(i)
      } : void 0;
    } else
      return {
        node: i.parentNode,
        offset: gy(i) + (r > 0 ? 1 : 0)
      };
  }
}
o(Ey, "getNextCursorPosition");
function WU(e, t, r) {
  let n = Number(t) + (r < 0 ? -1 : 0);
  return t !== void 0 && bw(e) && n >= 0 && n < e.children.length && (e = e.children[n]), jTe(e, r === 1 ? "next" : "previous", NTe);
}
o(WU, "getNextCharacterContentNode");
function NTe(e) {
  if (vy(e))
    return !0;
  if (bw(e)) {
    if (J(e, [
      "input",
      "textarea"
    ]))
      return e.type !== "hidden";
    if (J(e, "br"))
      return !0;
  }
  return !1;
}
o(NTe, "isTreatedAsCharacterContent");
function gy(e) {
  let t = 0;
  for (; e.previousSibling; )
    t++, e = e.previousSibling;
  return t;
}
o(gy, "getOffset");
function bw(e) {
  return e.nodeType === 1;
}
o(bw, "isElement");
function vy(e) {
  return e.nodeType === 3;
}
o(vy, "isTextNode");
function jTe(e, t, r) {
  for (; ; ) {
    var n;
    let i = e[`${t}Sibling`];
    if (i) {
      if (e = LTe(i, t === "next" ? "first" : "last"), r(e))
        return e;
    } else if (e.parentNode && (!bw(e.parentNode) || !Pt(e.parentNode) && e.parentNode !== ((n = e.ownerDocument) === null || n === void 0 ?
    void 0 : n.body)))
      e = e.parentNode;
    else
      break;
  }
}
o(jTe, "walkNodes");
function LTe(e, t) {
  for (; e.hasChildNodes(); )
    e = e[`${t}Child`];
  return e;
}
o(LTe, "getDescendant");

// ../node_modules/@testing-library/user-event/dist/esm/document/trackValue.js
var Pa = Symbol("Track programmatic changes for React workaround");
function FTe(e) {
  return Object.getOwnPropertyNames(e).some((t) => t.startsWith("__react")) && je(e).REACT_VERSION === 17;
}
o(FTe, "isReact17Element");
function KU(e) {
  FTe(e) && (e[Pa] = {
    previousValue: String(e.value),
    tracked: []
  });
}
o(KU, "startTrackValue");
function XU(e, t) {
  var r, n;
  (n = e[Pa]) === null || n === void 0 || (r = n.tracked) === null || r === void 0 || r.push(t), e[Pa] || (xa(e), rr(e, {
    focusOffset: t.length
  }));
}
o(XU, "trackOrSetValue");
function JU(e, t) {
  var r;
  let n = e[Pa];
  if (e[Pa] = void 0, !(!(n == null || (r = n.tracked) === null || r === void 0) && r.length))
    return;
  let i = n.tracked.length === 2 && n.tracked[0] === n.previousValue && n.tracked[1] === e.value;
  i || xa(e), UU(e) && rr(e, {
    focusOffset: i ? t : e.value.length
  });
}
o(JU, "commitValueAfterInput");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/getTargetTypeAndSelection.js
function Ty(e) {
  let t = kTe(e);
  if (t && ze(t))
    return {
      type: "input",
      selection: Ar(t)
    };
  let r = t?.ownerDocument.getSelection();
  return {
    type: mn(e) && r?.anchorNode && mn(r.anchorNode) ? "contenteditable" : "default",
    selection: r
  };
}
o(Ty, "getTargetTypeAndSelection");
function kTe(e) {
  return e.nodeType === 1 ? e : e.parentElement;
}
o(kTe, "getElement");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/getInputRange.js
function ZU(e) {
  let t = Ty(e);
  if (t.type === "input")
    return t.selection;
  if (t.type === "contenteditable") {
    var r;
    return (r = t.selection) === null || r === void 0 ? void 0 : r.getRangeAt(0);
  }
}
o(ZU, "getInputRange");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/setSelection.js
function nr({ focusNode: e, focusOffset: t, anchorNode: r = e, anchorOffset: n = t }) {
  var i, s;
  if (Ty(e).type === "input")
    return rr(e, {
      anchorOffset: n,
      focusOffset: t
    });
  (s = r.ownerDocument) === null || s === void 0 || (i = s.getSelection()) === null || i === void 0 || i.setBaseAndExtent(r, n, e, t);
}
o(nr, "setSelection");

// ../node_modules/@testing-library/user-event/dist/esm/event/input.js
function eH(e) {
  return J(e, "input") && [
    "date",
    "time"
  ].includes(e.type);
}
o(eH, "isDateOrTime");
function or(e, t, r, n = "insertText") {
  let i = ZU(t);
  i && (!eH(t) && !e.dispatchUIEvent(t, "beforeinput", {
    inputType: n,
    data: r
  }) || ("startContainer" in i ? DTe(e, t, i, r, n) : $Te(e, t, i, r, n)));
}
o(or, "input");
function DTe(e, t, r, n, i) {
  let s = !1;
  if (!r.collapsed)
    s = !0, r.deleteContents();
  else if ([
    "deleteContentBackward",
    "deleteContentForward"
  ].includes(i)) {
    let a = Ey(r.startContainer, r.startOffset, i === "deleteContentBackward" ? -1 : 1, i);
    if (a) {
      s = !0;
      let l = r.cloneRange();
      l.comparePoint(a.node, a.offset) < 0 ? l.setStart(a.node, a.offset) : l.setEnd(a.node, a.offset), l.deleteContents();
    }
  }
  if (n)
    if (r.endContainer.nodeType === 3) {
      let a = r.endOffset;
      r.endContainer.insertData(a, n), r.setStart(r.endContainer, a + n.length), r.setEnd(r.endContainer, a + n.length);
    } else {
      let a = t.ownerDocument.createTextNode(n);
      r.insertNode(a), r.setStart(a, n.length), r.setEnd(a, n.length);
    }
  (s || n) && e.dispatchUIEvent(t, "input", {
    inputType: i
  });
}
o(DTe, "editContenteditable");
function $Te(e, t, r, n, i) {
  let s = n;
  if (YU(t)) {
    let c = GU(t);
    if (c !== void 0 && n.length > 0) {
      let d = c - t.value.length;
      if (d > 0)
        s = n.substring(0, d);
      else
        return;
    }
  }
  let { newValue: a, newOffset: l, oldValue: u } = BTe(s, t, r, i);
  a === u && l === r.startOffset && l === r.endOffset || J(t, "input", {
    type: "number"
  }) && !UTe(a) || (DU(t, a), nr({
    focusNode: t,
    anchorOffset: l,
    focusOffset: l
  }), eH(t) ? yw(t, a) && (QU(e, t, l, {}), e.dispatchUIEvent(t, "change"), yy(t)) : QU(e, t, l, {
    data: n,
    inputType: i
  }));
}
o($Te, "editInputElement");
function BTe(e, t, { startOffset: r, endOffset: n }, i) {
  let s = Je(t), a = Math.max(0, r === n && i === "deleteContentBackward" ? r - 1 : r), l = s.substring(0, a), u = Math.min(s.length, r === n &&
  i === "deleteContentForward" ? r + 1 : n), c = s.substring(u, s.length), d = `${l}${e}${c}`, p = a + e.length;
  if (J(t, "input", {
    type: "time"
  })) {
    let y = VU(d);
    y !== "" && yw(t, y) && (d = y, p = y.length);
  }
  return {
    oldValue: s,
    newValue: d,
    newOffset: p
  };
}
o(BTe, "calculateNewValue");
function QU(e, t, r, n) {
  e.dispatchUIEvent(t, "input", n), JU(t, r);
}
o(QU, "commitInput");
function UTe(e) {
  var t, r;
  let n = e.split("e", 2);
  return !(/[^\d.\-e]/.test(e) || Number((t = e.match(/-/g)) === null || t === void 0 ? void 0 : t.length) > 2 || Number((r = e.match(/\./g)) ===
  null || r === void 0 ? void 0 : r.length) > 1 || n[1] && !/^-?\d*$/.test(n[1]));
}
o(UTe, "isValidNumberInput");

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/cut.js
yt.cut = (e, t, r) => () => {
  tr(t) && or(r, t, "", "deleteByCut");
};

// ../node_modules/@testing-library/user-event/dist/esm/document/getValueOrTextContent.js
function tH(e) {
  return e ? Pt(e) ? e.textContent : Je(e) : null;
}
o(tH, "getValueOrTextContent");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/isVisible.js
function rH(e) {
  let t = je(e);
  for (let r = e; r?.ownerDocument; r = r.parentElement) {
    let { display: n, visibility: i } = t.getComputedStyle(r);
    if (n === "none" || i === "hidden")
      return !1;
  }
  return !0;
}
o(rH, "isVisible");

// ../node_modules/@testing-library/user-event/dist/esm/utils/focus/getTabDestination.js
function nH(e, t) {
  let r = e.ownerDocument, n = r.querySelectorAll(py), i = Array.from(n).filter((u) => u === e || !(Number(u.getAttribute("tabindex")) < 0 ||
  ut(u)));
  Number(e.getAttribute("tabindex")) >= 0 && i.sort((u, c) => {
    let d = Number(u.getAttribute("tabindex")), p = Number(c.getAttribute("tabindex"));
    return d === p ? 0 : d === 0 ? 1 : p === 0 ? -1 : d - p;
  });
  let s = {}, a = [
    r.body
  ], l = J(e, "input", {
    type: "radio"
  }) ? e.name : void 0;
  i.forEach((u) => {
    let c = u;
    if (J(c, "input", {
      type: "radio"
    }) && c.name) {
      if (c === e) {
        a.push(c);
        return;
      } else if (c.name === l)
        return;
      if (c.checked) {
        a = a.filter((d) => !J(d, "input", {
          type: "radio",
          name: c.name
        })), a.push(c), s[c.name] = c;
        return;
      }
      if (typeof s[c.name] < "u")
        return;
    }
    a.push(c);
  });
  for (let u = a.findIndex((c) => c === e); ; )
    if (u += t ? -1 : 1, u === a.length ? u = 0 : u === -1 && (u = a.length - 1), a[u] === e || a[u] === r.body || rH(a[u]))
      return a[u];
}
o(nH, "getTabDestination");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/moveSelection.js
function gw(e, t) {
  if (ze(e)) {
    let r = Ar(e);
    nr({
      focusNode: e,
      focusOffset: r.startOffset === r.endOffset ? r.focusOffset + t : t < 0 ? r.startOffset : r.endOffset
    });
  } else {
    let r = e.ownerDocument.getSelection();
    if (!r?.focusNode)
      return;
    if (r.isCollapsed) {
      let n = Ey(r.focusNode, r.focusOffset, t);
      n && nr({
        focusNode: n.node,
        focusOffset: n.offset
      });
    } else
      r[t < 0 ? "collapseToStart" : "collapseToEnd"]();
  }
}
o(gw, "moveSelection");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/selectAll.js
function _y(e) {
  if (ze(e))
    return nr({
      focusNode: e,
      anchorOffset: 0,
      focusOffset: Je(e).length
    });
  var t;
  let r = (t = mn(e)) !== null && t !== void 0 ? t : e.ownerDocument.body;
  nr({
    focusNode: r,
    anchorOffset: 0,
    focusOffset: r.childNodes.length
  });
}
o(_y, "selectAll");
function oH(e) {
  if (ze(e))
    return Ar(e).startOffset === 0 && Ar(e).endOffset === Je(e).length;
  var t;
  let r = (t = mn(e)) !== null && t !== void 0 ? t : e.ownerDocument.body, n = e.ownerDocument.getSelection();
  return n?.anchorNode === r && n.focusNode === r && n.anchorOffset === 0 && n.focusOffset === r.childNodes.length;
}
o(oH, "isAllSelected");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/setSelectionRange.js
function Gn(e, t, r) {
  var n;
  if (ze(e))
    return nr({
      focusNode: e,
      anchorOffset: t,
      focusOffset: r
    });
  if (Pt(e) && ((n = e.firstChild) === null || n === void 0 ? void 0 : n.nodeType) === 3)
    return nr({
      focusNode: e.firstChild,
      anchorOffset: t,
      focusOffset: r
    });
  throw new Error("Not implemented. The result of this interaction is unreliable.");
}
o(Gn, "setSelectionRange");

// ../node_modules/@testing-library/user-event/dist/esm/event/radio.js
function Aa(e, t, r) {
  let n = je(t), i = Array.from(t.ownerDocument.querySelectorAll(t.name ? `input[type="radio"][name="${n.CSS.escape(t.name)}"]` : 'input[typ\
e="radio"][name=""], input[type="radio"]:not([name])'));
  for (let s = i.findIndex((a) => a === t) + r; ; s += r) {
    if (i[s] || (s = r > 0 ? 0 : i.length - 1), i[s] === t)
      return;
    if (!ut(i[s])) {
      _t(i[s]), e.dispatchUIEvent(i[s], "click");
      return;
    }
  }
}
o(Aa, "walkRadio");

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/keydown.js
yt.keydown = (e, t, r) => {
  var n, i;
  return (i = (n = iH[e.key]) === null || n === void 0 ? void 0 : n.call(iH, e, t, r)) !== null && i !== void 0 ? i : HTe(e, t, r);
};
var iH = {
  ArrowDown: /* @__PURE__ */ o((e, t, r) => {
    if (J(t, "input", {
      type: "radio"
    }))
      return () => Aa(r, t, 1);
  }, "ArrowDown"),
  ArrowLeft: /* @__PURE__ */ o((e, t, r) => J(t, "input", {
    type: "radio"
  }) ? () => Aa(r, t, -1) : () => gw(t, -1), "ArrowLeft"),
  ArrowRight: /* @__PURE__ */ o((e, t, r) => J(t, "input", {
    type: "radio"
  }) ? () => Aa(r, t, 1) : () => gw(t, 1), "ArrowRight"),
  ArrowUp: /* @__PURE__ */ o((e, t, r) => {
    if (J(t, "input", {
      type: "radio"
    }))
      return () => Aa(r, t, -1);
  }, "ArrowUp"),
  Backspace: /* @__PURE__ */ o((e, t, r) => {
    if (tr(t))
      return () => {
        or(r, t, "", "deleteContentBackward");
      };
  }, "Backspace"),
  Delete: /* @__PURE__ */ o((e, t, r) => {
    if (tr(t))
      return () => {
        or(r, t, "", "deleteContentForward");
      };
  }, "Delete"),
  End: /* @__PURE__ */ o((e, t) => {
    if (J(t, [
      "input",
      "textarea"
    ]) || Pt(t))
      return () => {
        var r, n;
        let i = (n = (r = tH(t)) === null || r === void 0 ? void 0 : r.length) !== null && n !== void 0 ? n : (
          /* istanbul ignore next */
          0
        );
        Gn(t, i, i);
      };
  }, "End"),
  Home: /* @__PURE__ */ o((e, t) => {
    if (J(t, [
      "input",
      "textarea"
    ]) || Pt(t))
      return () => {
        Gn(t, 0, 0);
      };
  }, "Home"),
  PageDown: /* @__PURE__ */ o((e, t) => {
    if (J(t, [
      "input"
    ]))
      return () => {
        let r = Je(t).length;
        Gn(t, r, r);
      };
  }, "PageDown"),
  PageUp: /* @__PURE__ */ o((e, t) => {
    if (J(t, [
      "input"
    ]))
      return () => {
        Gn(t, 0, 0);
      };
  }, "PageUp"),
  Tab: /* @__PURE__ */ o((e, t, r) => () => {
    let n = nH(t, r.system.keyboard.modifiers.Shift);
    _t(n), ze(n) && rr(n, {
      anchorOffset: 0,
      focusOffset: n.value.length
    });
  }, "Tab")
}, HTe = /* @__PURE__ */ o((e, t, r) => {
  if (e.code === "KeyA" && r.system.keyboard.modifiers.Control)
    return () => _y(t);
}, "combinationBehavior");

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/keypress.js
yt.keypress = (e, t, r) => {
  if (e.key === "Enter") {
    if (J(t, "button") || J(t, "input") && VTe.includes(t.type) || J(t, "a") && t.href)
      return () => {
        r.dispatchUIEvent(t, "click");
      };
    if (J(t, "input")) {
      let n = t.form, i = n?.querySelector('input[type="submit"], button:not([type]), button[type="submit"]');
      return i ? () => r.dispatchUIEvent(i, "click") : n && zTe.includes(t.type) && n.querySelectorAll("input").length === 1 ? () => r.dispatchUIEvent(
      n, "submit") : void 0;
    }
  }
  if (tr(t)) {
    let n = e.key === "Enter" ? Pt(t) && !r.system.keyboard.modifiers.Shift ? "insertParagraph" : "insertLineBreak" : "insertText", i = e.key ===
    "Enter" ? `
` : e.key;
    return () => or(r, t, i, n);
  }
};
var VTe = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
], zTe = [
  "email",
  "month",
  "password",
  "search",
  "tel",
  "text",
  "url",
  "week"
];

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/keyup.js
yt.keyup = (e, t, r) => {
  var n;
  return (n = sH[e.key]) === null || n === void 0 ? void 0 : n.call(sH, e, t, r);
};
var sH = {
  " ": /* @__PURE__ */ o((e, t, r) => {
    if (my(t))
      return () => r.dispatchUIEvent(t, "click");
  }, " ")
};

// ../node_modules/@testing-library/user-event/dist/esm/event/behavior/paste.js
yt.paste = (e, t, r) => {
  if (tr(t))
    return () => {
      var n;
      let i = (n = e.clipboardData) === null || n === void 0 ? void 0 : n.getData("text");
      i && or(r, t, i, "insertFromPaste");
    };
};

// ../node_modules/@testing-library/user-event/dist/esm/event/eventMap.js
var vw = {
  auxclick: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  beforeinput: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  blur: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  click: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  contextmenu: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  copy: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  change: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  cut: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dblclick: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  focus: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  focusin: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  focusout: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  keydown: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  keypress: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  keyup: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  paste: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  input: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  mousedown: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseenter: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseleave: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mousemove: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseout: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseover: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseup: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerover: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerenter: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pointerdown: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointermove: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerup: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointercancel: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  pointerout: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerleave: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  submit: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  }
};
function aH(e) {
  return vw[e].EventType;
}
o(aH, "getEventClass");
var GTe = [
  "MouseEvent",
  "PointerEvent"
];
function lH(e) {
  return GTe.includes(aH(e));
}
o(lH, "isMouseEvent");
function uH(e) {
  return aH(e) === "KeyboardEvent";
}
o(uH, "isKeyboardEvent");

// ../node_modules/@testing-library/user-event/dist/esm/event/createEvent.js
var YTe = {
  ClipboardEvent: [
    KTe
  ],
  Event: [],
  FocusEvent: [
    Oa,
    XTe
  ],
  InputEvent: [
    Oa,
    JTe
  ],
  MouseEvent: [
    Oa,
    Ew,
    cH
  ],
  PointerEvent: [
    Oa,
    Ew,
    cH,
    QTe
  ],
  KeyboardEvent: [
    Oa,
    Ew,
    ZTe
  ]
};
function Tw(e, t, r) {
  let n = je(t), { EventType: i, defaultInit: s } = vw[e], a = new (WTe(n))[i](e, s);
  return YTe[i].forEach((l) => l(a, r ?? {})), a;
}
o(Tw, "createEvent");
function WTe(e) {
  var $, M, V, G, Q, te, fe, F, j, Y, z, X, ce, Re, Me;
  var t;
  let r = (t = e.Event) !== null && t !== void 0 ? t : ($ = class {
  }, o($, "Event"), $);
  var n;
  let i = (n = e.AnimationEvent) !== null && n !== void 0 ? n : (M = class extends r {
  }, o(M, "AnimationEvent"), M);
  var s;
  let a = (s = e.ClipboardEvent) !== null && s !== void 0 ? s : (V = class extends r {
  }, o(V, "ClipboardEvent"), V);
  var l;
  let u = (l = e.PopStateEvent) !== null && l !== void 0 ? l : (G = class extends r {
  }, o(G, "PopStateEvent"), G);
  var c;
  let d = (c = e.ProgressEvent) !== null && c !== void 0 ? c : (Q = class extends r {
  }, o(Q, "ProgressEvent"), Q);
  var p;
  let y = (p = e.TransitionEvent) !== null && p !== void 0 ? p : (te = class extends r {
  }, o(te, "TransitionEvent"), te);
  var f;
  let m = (f = e.UIEvent) !== null && f !== void 0 ? f : (fe = class extends r {
  }, o(fe, "UIEvent"), fe);
  var h;
  let b = (h = e.CompositionEvent) !== null && h !== void 0 ? h : (F = class extends m {
  }, o(F, "CompositionEvent"), F);
  var g;
  let T = (g = e.FocusEvent) !== null && g !== void 0 ? g : (j = class extends m {
  }, o(j, "FocusEvent"), j);
  var _;
  let E = (_ = e.InputEvent) !== null && _ !== void 0 ? _ : (Y = class extends m {
  }, o(Y, "InputEvent"), Y);
  var R;
  let C = (R = e.KeyboardEvent) !== null && R !== void 0 ? R : (z = class extends m {
  }, o(z, "KeyboardEvent"), z);
  var w;
  let P = (w = e.MouseEvent) !== null && w !== void 0 ? w : (X = class extends m {
  }, o(X, "MouseEvent"), X);
  var O;
  let D = (O = e.DragEvent) !== null && O !== void 0 ? O : (ce = class extends P {
  }, o(ce, "DragEvent"), ce);
  var A;
  let L = (A = e.PointerEvent) !== null && A !== void 0 ? A : (Re = class extends P {
  }, o(Re, "PointerEvent"), Re);
  var B;
  let N = (B = e.TouchEvent) !== null && B !== void 0 ? B : (Me = class extends m {
  }, o(Me, "TouchEvent"), Me);
  return {
    Event: r,
    AnimationEvent: i,
    ClipboardEvent: a,
    PopStateEvent: u,
    ProgressEvent: d,
    TransitionEvent: y,
    UIEvent: m,
    CompositionEvent: b,
    FocusEvent: T,
    InputEvent: E,
    KeyboardEvent: C,
    MouseEvent: P,
    DragEvent: D,
    PointerEvent: L,
    TouchEvent: N
  };
}
o(WTe, "getEventConstructors");
function yn(e, t) {
  for (let [r, n] of Object.entries(t))
    Object.defineProperty(e, r, {
      get: /* @__PURE__ */ o(() => n ?? null, "get")
    });
}
o(yn, "assignProps");
function ke(e) {
  return Number(e ?? 0);
}
o(ke, "sanitizeNumber");
function KTe(e, { clipboardData: t }) {
  yn(e, {
    clipboardData: t
  });
}
o(KTe, "initClipboardEvent");
function XTe(e, { relatedTarget: t }) {
  yn(e, {
    relatedTarget: t
  });
}
o(XTe, "initFocusEvent");
function JTe(e, { data: t, inputType: r, isComposing: n }) {
  yn(e, {
    data: t,
    isComposing: !!n,
    inputType: String(r)
  });
}
o(JTe, "initInputEvent");
function Oa(e, { view: t, detail: r }) {
  yn(e, {
    view: t,
    detail: ke(r ?? 0)
  });
}
o(Oa, "initUIEvent");
function Ew(e, { altKey: t, ctrlKey: r, metaKey: n, shiftKey: i, modifierAltGraph: s, modifierCapsLock: a, modifierFn: l, modifierFnLock: u,
modifierNumLock: c, modifierScrollLock: d, modifierSymbol: p, modifierSymbolLock: y }) {
  yn(e, {
    altKey: !!t,
    ctrlKey: !!r,
    metaKey: !!n,
    shiftKey: !!i,
    getModifierState(f) {
      return !!{
        Alt: t,
        AltGraph: s,
        CapsLock: a,
        Control: r,
        Fn: l,
        FnLock: u,
        Meta: n,
        NumLock: c,
        ScrollLock: d,
        Shift: i,
        Symbol: p,
        SymbolLock: y
      }[f];
    }
  });
}
o(Ew, "initUIEventModifiers");
function ZTe(e, { key: t, code: r, location: n, repeat: i, isComposing: s, charCode: a }) {
  yn(e, {
    key: String(t),
    code: String(r),
    location: ke(n),
    repeat: !!i,
    isComposing: !!s,
    charCode: a
  });
}
o(ZTe, "initKeyboardEvent");
function cH(e, { x: t, y: r, screenX: n, screenY: i, clientX: s = t, clientY: a = r, button: l, buttons: u, relatedTarget: c, offsetX: d, offsetY: p,
pageX: y, pageY: f }) {
  yn(e, {
    screenX: ke(n),
    screenY: ke(i),
    clientX: ke(s),
    x: ke(s),
    clientY: ke(a),
    y: ke(a),
    button: ke(l),
    buttons: ke(u),
    relatedTarget: c,
    offsetX: ke(d),
    offsetY: ke(p),
    pageX: ke(y),
    pageY: ke(f)
  });
}
o(cH, "initMouseEvent");
function QTe(e, { pointerId: t, width: r, height: n, pressure: i, tangentialPressure: s, tiltX: a, tiltY: l, twist: u, pointerType: c, isPrimary: d }) {
  yn(e, {
    pointerId: ke(t),
    width: ke(r ?? 1),
    height: ke(n ?? 1),
    pressure: ke(i),
    tangentialPressure: ke(s),
    tiltX: ke(a),
    tiltY: ke(l),
    twist: ke(u),
    pointerType: String(c),
    isPrimary: !!d
  });
}
o(QTe, "initPointerEvent");

// ../node_modules/@testing-library/user-event/dist/esm/event/dispatchEvent.js
function dH(e, t, r, n = !1) {
  (lH(t) || uH(t)) && (r = {
    ...r,
    ...this.system.getUIEventModifiers()
  });
  let i = Tw(t, e, r);
  return _w.call(this, e, i, n);
}
o(dH, "dispatchUIEvent");
function _w(e, t, r = !1) {
  var n;
  let i = t.type, s = r ? () => {
  } : (n = yt[i]) === null || n === void 0 ? void 0 : n.call(yt, t, e, this);
  if (s) {
    t.preventDefault();
    let a = !1;
    return Object.defineProperty(t, "defaultPrevented", {
      get: /* @__PURE__ */ o(() => a, "get")
    }), Object.defineProperty(t, "preventDefault", {
      value: /* @__PURE__ */ o(() => {
        a = t.cancelable;
      }, "value")
    }), hn(() => e.dispatchEvent(t)), a || s(), !a;
  }
  return hn(() => e.dispatchEvent(t));
}
o(_w, "dispatchEvent");
function Or(e, t, r) {
  let n = Tw(t, e, r);
  hn(() => e.dispatchEvent(n));
}
o(Or, "dispatchDOMEvent");

// ../node_modules/@testing-library/user-event/dist/esm/document/patchFocus.js
var pH = Symbol("patched focus/blur methods");
function Rw(e) {
  if (e.prototype[pH])
    return;
  let { focus: t, blur: r } = e.prototype;
  Object.defineProperties(e.prototype, {
    focus: {
      configurable: !0,
      get: /* @__PURE__ */ o(() => i, "get")
    },
    blur: {
      configurable: !0,
      get: /* @__PURE__ */ o(() => s, "get")
    },
    [pH]: {
      configurable: !0,
      get: /* @__PURE__ */ o(() => ({
        focus: t,
        blur: r
      }), "get")
    }
  });
  let n;
  function i(a) {
    if (this.ownerDocument.visibilityState !== "hidden")
      return t.call(this, a);
    let l = fH(this.ownerDocument);
    if (l === this)
      return;
    let u = Symbol("focus call");
    n = u, l && (r.call(l), Or(l, "blur", {
      relatedTarget: this
    }), Or(l, "focusout", {
      relatedTarget: n === u ? this : null
    })), n === u && (t.call(this, a), Or(this, "focus", {
      relatedTarget: l
    })), n === u && Or(this, "focusin", {
      relatedTarget: l
    });
  }
  o(i, "patchedFocus");
  function s() {
    if (this.ownerDocument.visibilityState !== "hidden")
      return r.call(this);
    let a = fH(this.ownerDocument);
    if (a !== this)
      return;
    n = Symbol("blur call"), r.call(this), Or(a, "blur", {
      relatedTarget: null
    }), Or(a, "focusout", {
      relatedTarget: null
    });
  }
  o(s, "patchedBlur");
}
o(Rw, "patchFocus");
function fH(e) {
  let t = zn(e);
  return t?.tagName === "BODY" ? null : t;
}
o(fH, "getActiveTarget");

// ../node_modules/@testing-library/user-event/dist/esm/document/interceptor.js
var ww = Symbol("Interceptor for programmatical calls");
function wi(e, t, r) {
  let n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), i = Object.getOwnPropertyDescriptor(e, t), s = n?.set ? "set" : "valu\
e";
  if (typeof n?.[s] != "function" || n[s][ww])
    throw new Error(`Element ${e.tagName} does not implement "${String(t)}".`);
  function a(...l) {
    let { applyNative: u = !1, realArgs: c, then: d } = r.call(this, ...l), p = (!u && i || n)[s];
    s === "set" ? p.call(this, c) : p.call(this, ...c), d?.();
  }
  o(a, "intercept"), a[ww] = ww, Object.defineProperty(e, t, {
    ...i ?? n,
    [s]: a
  });
}
o(wi, "prepareInterceptor");
function mH(e) {
  wi(e, "value", /* @__PURE__ */ o(function(r) {
    let n = FU(r);
    return n && KU(this), {
      applyNative: !!n,
      realArgs: e_e(this, r),
      then: n ? void 0 : () => XU(this, String(r))
    };
  }, "interceptorImpl"));
}
o(mH, "prepareValueInterceptor");
function e_e(e, t) {
  return J(e, "input", {
    type: "number"
  }) && String(t) !== "" && !Number.isNaN(Number(t)) ? String(Number(t)) : String(t);
}
o(e_e, "sanitizeValue");
function hH(e) {
  wi(e, "setSelectionRange", /* @__PURE__ */ o(function(r, ...n) {
    let i = kU(r);
    return {
      applyNative: !!i,
      realArgs: [
        Number(r),
        ...n
      ],
      then: /* @__PURE__ */ o(() => i ? void 0 : Ca(e), "then")
    };
  }, "interceptorImpl")), wi(e, "selectionStart", /* @__PURE__ */ o(function(r) {
    return {
      realArgs: r,
      then: /* @__PURE__ */ o(() => Ca(e), "then")
    };
  }, "interceptorImpl")), wi(e, "selectionEnd", /* @__PURE__ */ o(function(r) {
    return {
      realArgs: r,
      then: /* @__PURE__ */ o(() => Ca(e), "then")
    };
  }, "interceptorImpl")), wi(e, "select", /* @__PURE__ */ o(function() {
    return {
      realArgs: [],
      then: /* @__PURE__ */ o(() => BU(e, {
        anchorOffset: 0,
        focusOffset: Je(e).length
      }), "then")
    };
  }, "interceptorImpl"));
}
o(hH, "prepareSelectionInterceptor");
function yH(e) {
  wi(e, "setRangeText", /* @__PURE__ */ o(function(...r) {
    return {
      realArgs: r,
      then: /* @__PURE__ */ o(() => {
        xa(e), Ca(e);
      }, "then")
    };
  }, "interceptorImpl"));
}
o(yH, "prepareRangeTextInterceptor");

// ../node_modules/@testing-library/user-event/dist/esm/document/prepareDocument.js
var Si = Symbol("Node prepared with document state workarounds");
function Sw(e) {
  e[Si] || (e.addEventListener("focus", (t) => {
    let r = t.target;
    bH(r);
  }, {
    capture: !0,
    passive: !0
  }), e.activeElement && bH(e.activeElement), e.addEventListener("blur", (t) => {
    let r = t.target, n = $U(r);
    n !== void 0 && (r.value !== n && Or(r, "change"), yy(r));
  }, {
    capture: !0,
    passive: !0
  }), e[Si] = Si);
}
o(Sw, "prepareDocument");
function bH(e) {
  e[Si] || (J(e, [
    "input",
    "textarea"
  ]) && (mH(e), hH(e), yH(e)), e[Si] = Si);
}
o(bH, "prepareElement");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/getDocumentFromNode.js
function gH(e) {
  return t_e(e) ? e : e.ownerDocument;
}
o(gH, "getDocumentFromNode");
function t_e(e) {
  return e.nodeType === 9;
}
o(t_e, "isDocument");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/level.js
var ct = /* @__PURE__ */ function(e) {
  return e[e.Trigger = 2] = "Trigger", e[e.Call = 1] = "Call", e;
}({});
function Yn(e, t) {
  e.levelRefs[t] = {};
}
o(Yn, "setLevelRef");
function qa(e, t) {
  return e.levelRefs[t];
}
o(qa, "getLevelRef");

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/wait.js
function fr(e) {
  let t = e.delay;
  if (typeof t == "number")
    return Promise.all([
      new Promise((r) => globalThis.setTimeout(() => r(), t)),
      e.advanceTimers(t)
    ]);
}
o(fr, "wait");

// ../node_modules/@testing-library/user-event/dist/esm/options.js
var Wn = /* @__PURE__ */ function(e) {
  return e[e.EachTrigger = 4] = "EachTrigger", e[e.EachApiCall = 2] = "EachApiCall", e[e.EachTarget = 1] = "EachTarget", e[e.Never = 0] = "N\
ever", e;
}({});

// ../node_modules/@testing-library/user-event/dist/esm/system/keyboard.js
function Kn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(Kn, "_define_property");
var ir = /* @__PURE__ */ function(e) {
  return e[e.STANDARD = 0] = "STANDARD", e[e.LEFT = 1] = "LEFT", e[e.RIGHT = 2] = "RIGHT", e[e.NUMPAD = 3] = "NUMPAD", e;
}({}), r_e = [
  "Alt",
  "AltGraph",
  "Control",
  "Fn",
  "Meta",
  "Shift",
  "Symbol"
];
function vH(e) {
  return r_e.includes(e);
}
o(vH, "isModifierKey");
var n_e = [
  "CapsLock",
  "FnLock",
  "NumLock",
  "ScrollLock",
  "SymbolLock"
];
function EH(e) {
  return n_e.includes(e);
}
o(EH, "isModifierLock");
var xw = class xw {
  isKeyPressed(t) {
    return this.pressed.has(String(t.code));
  }
  getPressedKeys() {
    return this.pressed.values().map((t) => t.keyDef);
  }
  /** Press a key */
  async keydown(t, r) {
    let n = String(r.key), i = String(r.code), s = fy(t.config.document);
    this.setKeydownTarget(s), this.pressed.add(i, r), vH(n) && (this.modifiers[n] = !0);
    let a = t.dispatchUIEvent(s, "keydown", {
      key: n,
      code: i
    });
    EH(n) && !this.modifiers[n] && (this.modifiers[n] = !0, this.modifierLockStart[n] = !0), a && this.pressed.setUnprevented(i), a && this.
    hasKeyPress(n) && t.dispatchUIEvent(fy(t.config.document), "keypress", {
      key: n,
      code: i,
      charCode: r.key === "Enter" ? 13 : String(r.key).charCodeAt(0)
    });
  }
  /** Release a key */
  async keyup(t, r) {
    let n = String(r.key), i = String(r.code), s = this.pressed.isUnprevented(i);
    this.pressed.delete(i), vH(n) && !this.pressed.values().find((a) => a.keyDef.key === n) && (this.modifiers[n] = !1), t.dispatchUIEvent(fy(
    t.config.document), "keyup", {
      key: n,
      code: i
    }, !s), EH(n) && this.modifiers[n] && (this.modifierLockStart[n] ? this.modifierLockStart[n] = !1 : this.modifiers[n] = !1);
  }
  setKeydownTarget(t) {
    t !== this.lastKeydownTarget && (this.carryChar = ""), this.lastKeydownTarget = t;
  }
  hasKeyPress(t) {
    return (t.length === 1 || t === "Enter") && !this.modifiers.Control && !this.modifiers.Alt;
  }
  constructor(t) {
    Kn(this, "system", void 0), Kn(this, "modifiers", {
      Alt: !1,
      AltGraph: !1,
      CapsLock: !1,
      Control: !1,
      Fn: !1,
      FnLock: !1,
      Meta: !1,
      NumLock: !1,
      ScrollLock: !1,
      Shift: !1,
      Symbol: !1,
      SymbolLock: !1
    }), Kn(this, "pressed", new class {
      add(r, n) {
        var i, s, a;
        (a = (i = this.registry)[s = r]) !== null && a !== void 0 || (i[s] = {
          keyDef: n,
          unpreventedDefault: !1
        });
      }
      has(r) {
        return !!this.registry[r];
      }
      setUnprevented(r) {
        let n = this.registry[r];
        n && (n.unpreventedDefault = !0);
      }
      isUnprevented(r) {
        var n;
        return !!(!((n = this.registry[r]) === null || n === void 0) && n.unpreventedDefault);
      }
      delete(r) {
        delete this.registry[r];
      }
      values() {
        return Object.values(this.registry);
      }
      constructor() {
        Kn(this, "registry", {});
      }
    }()), Kn(this, "carryChar", ""), Kn(this, "lastKeydownTarget", void 0), Kn(this, "modifierLockStart", {}), this.system = t;
  }
};
o(xw, "KeyboardHost");
var Ry = xw;

// ../node_modules/@testing-library/user-event/dist/esm/keyboard/keyMap.js
var TH = [
  // alphanumeric block - writing system
  ..."0123456789".split("").map((e) => ({
    code: `Digit${e}`,
    key: e
  })),
  ...")!@#$%^&*(".split("").map((e, t) => ({
    code: `Digit${t}`,
    key: e,
    shiftKey: !0
  })),
  ..."abcdefghijklmnopqrstuvwxyz".split("").map((e) => ({
    code: `Key${e.toUpperCase()}`,
    key: e
  })),
  ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((e) => ({
    code: `Key${e}`,
    key: e,
    shiftKey: !0
  })),
  {
    code: "BracketLeft",
    key: "["
  },
  {
    code: "BracketLeft",
    key: "{",
    shiftKey: !0
  },
  {
    code: "BracketRight",
    key: "]"
  },
  {
    code: "BracketRight",
    key: "}",
    shiftKey: !0
  },
  // alphanumeric block - functional
  {
    code: "Space",
    key: " "
  },
  {
    code: "AltLeft",
    key: "Alt",
    location: ir.LEFT
  },
  {
    code: "AltRight",
    key: "Alt",
    location: ir.RIGHT
  },
  {
    code: "ShiftLeft",
    key: "Shift",
    location: ir.LEFT
  },
  {
    code: "ShiftRight",
    key: "Shift",
    location: ir.RIGHT
  },
  {
    code: "ControlLeft",
    key: "Control",
    location: ir.LEFT
  },
  {
    code: "ControlRight",
    key: "Control",
    location: ir.RIGHT
  },
  {
    code: "MetaLeft",
    key: "Meta",
    location: ir.LEFT
  },
  {
    code: "MetaRight",
    key: "Meta",
    location: ir.RIGHT
  },
  {
    code: "OSLeft",
    key: "OS",
    location: ir.LEFT
  },
  {
    code: "OSRight",
    key: "OS",
    location: ir.RIGHT
  },
  {
    code: "ContextMenu",
    key: "ContextMenu"
  },
  {
    code: "Tab",
    key: "Tab"
  },
  {
    code: "CapsLock",
    key: "CapsLock"
  },
  {
    code: "Backspace",
    key: "Backspace"
  },
  {
    code: "Enter",
    key: "Enter"
  },
  // function
  {
    code: "Escape",
    key: "Escape"
  },
  // arrows
  {
    code: "ArrowUp",
    key: "ArrowUp"
  },
  {
    code: "ArrowDown",
    key: "ArrowDown"
  },
  {
    code: "ArrowLeft",
    key: "ArrowLeft"
  },
  {
    code: "ArrowRight",
    key: "ArrowRight"
  },
  // control pad
  {
    code: "Home",
    key: "Home"
  },
  {
    code: "End",
    key: "End"
  },
  {
    code: "Delete",
    key: "Delete"
  },
  {
    code: "PageUp",
    key: "PageUp"
  },
  {
    code: "PageDown",
    key: "PageDown"
  },
  // Special keys that are not part of a default US-layout but included for specific behavior
  {
    code: "Fn",
    key: "Fn"
  },
  {
    code: "Symbol",
    key: "Symbol"
  },
  {
    code: "AltRight",
    key: "AltGraph"
  }
];

// ../node_modules/@testing-library/user-event/dist/esm/pointer/keyMap.js
var _H = [
  {
    name: "MouseLeft",
    pointerType: "mouse",
    button: "primary"
  },
  {
    name: "MouseRight",
    pointerType: "mouse",
    button: "secondary"
  },
  {
    name: "MouseMiddle",
    pointerType: "mouse",
    button: "auxiliary"
  },
  {
    name: "TouchA",
    pointerType: "touch"
  },
  {
    name: "TouchB",
    pointerType: "touch"
  },
  {
    name: "TouchC",
    pointerType: "touch"
  }
];

// ../node_modules/@testing-library/user-event/dist/esm/system/pointer/buttons.js
function o_e(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(o_e, "_define_property");
var Pw = class Pw {
  getButtons() {
    let t = 0;
    for (let r of Object.keys(this.pressed))
      t |= 2 ** Number(r);
    return t;
  }
  down(t) {
    let r = Cw(t.button);
    if (r in this.pressed) {
      this.pressed[r].push(t);
      return;
    }
    return this.pressed[r] = [
      t
    ], r;
  }
  up(t) {
    let r = Cw(t.button);
    if (r in this.pressed && (this.pressed[r] = this.pressed[r].filter((n) => n.name !== t.name), this.pressed[r].length === 0))
      return delete this.pressed[r], r;
  }
  constructor() {
    o_e(this, "pressed", {});
  }
};
o(Pw, "Buttons");
var xi = Pw, RH = {
  primary: 0,
  secondary: 1,
  auxiliary: 2,
  back: 3,
  X1: 3,
  forward: 4,
  X2: 4
};
function Cw(e = 0) {
  return e in RH ? RH[e] : Number(e);
}
o(Cw, "getMouseButtonId");
var wH = {
  1: 2,
  2: 1
};
function Ia(e) {
  return e = Cw(e), e in wH ? wH[e] : e;
}
o(Ia, "getMouseEventButton");

// ../node_modules/@testing-library/user-event/dist/esm/system/pointer/device.js
function i_e(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(i_e, "_define_property");
var Aw = class Aw {
  get countPressed() {
    return this.pressedKeys.size;
  }
  isPressed(t) {
    return this.pressedKeys.has(t.name);
  }
  addPressed(t) {
    return this.pressedKeys.add(t.name);
  }
  removePressed(t) {
    return this.pressedKeys.delete(t.name);
  }
  constructor() {
    i_e(this, "pressedKeys", /* @__PURE__ */ new Set());
  }
};
o(Aw, "Device");
var wy = Aw;

// ../node_modules/@testing-library/user-event/dist/esm/utils/misc/getTreeDiff.js
function Xn(e, t) {
  let r = [];
  for (let s = e; s; s = s.parentElement)
    r.push(s);
  let n = [];
  for (let s = t; s; s = s.parentElement)
    n.push(s);
  let i = 0;
  for (; !(i >= r.length || i >= n.length || r[r.length - 1 - i] !== n[n.length - 1 - i]); i++)
    ;
  return [
    r.slice(0, r.length - i),
    n.slice(0, n.length - i),
    n.slice(n.length - i)
  ];
}
o(Xn, "getTreeDiff");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/resolveCaretPosition.js
function Ma({ target: e, node: t, offset: r }) {
  return ze(e) ? {
    node: e,
    offset: r ?? Je(e).length
  } : t ? {
    node: t,
    offset: r ?? (t.nodeType === 3 ? t.nodeValue.length : t.childNodes.length)
  } : SH(e, r);
}
o(Ma, "resolveCaretPosition");
function SH(e, t, r = !0) {
  let n = t === void 0 ? e.childNodes.length - 1 : 0, i = t === void 0 ? -1 : 1;
  for (; t === void 0 ? n >= (r ? Math.max(e.childNodes.length - 1, 0) : 0) : n <= e.childNodes.length; ) {
    if (t && n === e.childNodes.length)
      throw new Error("The given offset is out of bounds.");
    let s = e.childNodes.item(n), a = String(s.textContent);
    if (a.length)
      if (t !== void 0 && a.length < t)
        t -= a.length;
      else {
        if (s.nodeType === 1)
          return SH(s, t, !1);
        if (s.nodeType === 3)
          return {
            node: s,
            offset: t ?? s.nodeValue.length
          };
      }
    n += i;
  }
  return {
    node: e,
    offset: e.childNodes.length
  };
}
o(SH, "findNodeAtTextOffset");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/setSelectionPerMouse.js
function xH({ document: e, target: t, clickCount: r, node: n, offset: i }) {
  if (MU(t))
    return;
  let s = ze(t), a = String(s ? Je(t) : t.textContent), [l, u] = n ? (
    // which elements might be considered in the same line of text.
    // TODO: support expanding initial range on multiple clicks if node is given
    [
      i,
      i
    ]
  ) : s_e(a, i, r);
  if (s)
    return rr(t, {
      anchorOffset: l ?? a.length,
      focusOffset: u ?? a.length
    }), {
      node: t,
      start: l ?? 0,
      end: u ?? a.length
    };
  {
    let { node: c, offset: d } = Ma({
      target: t,
      node: n,
      offset: l
    }), { node: p, offset: y } = Ma({
      target: t,
      node: n,
      offset: u
    }), f = t.ownerDocument.createRange();
    try {
      f.setStart(c, d), f.setEnd(p, y);
    } catch {
      throw new Error("The given offset is out of bounds.");
    }
    let m = e.getSelection();
    return m?.removeAllRanges(), m?.addRange(f.cloneRange()), f;
  }
}
o(xH, "setSelectionPerMouseDown");
function s_e(e, t, r) {
  if (r % 3 === 1 || e.length === 0)
    return [
      t,
      t
    ];
  let n = t ?? e.length;
  return r % 3 === 2 ? [
    n - e.substr(0, t).match(/(\w+|\s+|\W)?$/)[0].length,
    t === void 0 ? t : t + e.substr(t).match(/^(\w+|\s+|\W)?/)[0].length
  ] : [
    n - e.substr(0, t).match(/[^\r\n]*$/)[0].length,
    t === void 0 ? t : t + e.substr(t).match(/^[^\r\n]*/)[0].length
  ];
}
o(s_e, "getTextRange");

// ../node_modules/@testing-library/user-event/dist/esm/event/selection/modifySelectionPerMouse.js
function CH(e, { document: t, target: r, node: n, offset: i }) {
  let s = Ma({
    target: r,
    node: n,
    offset: i
  });
  if ("node" in e) {
    if (s.node === e.node) {
      let a = s.offset < e.start ? e.end : e.start, l = s.offset > e.end || s.offset < e.start ? s.offset : e.end;
      rr(e.node, {
        anchorOffset: a,
        focusOffset: l
      });
    }
  } else {
    let a = e.cloneRange(), l = a.comparePoint(s.node, s.offset);
    l < 0 ? a.setStart(s.node, s.offset) : l > 0 && a.setEnd(s.node, s.offset);
    let u = t.getSelection();
    u?.removeAllRanges(), u?.addRange(a.cloneRange());
  }
}
o(CH, "modifySelectionPerMouseMove");

// ../node_modules/@testing-library/user-event/dist/esm/system/pointer/shared.js
function Sy(e, t) {
  var r, n, i, s, a, l, u, c, d, p, y, f, m, h, b, g, T, _, E, R, C, w, P, O;
  return e.target !== t.target || ((r = e.coords) === null || r === void 0 ? void 0 : r.x) !== ((n = t.coords) === null || n === void 0 ? void 0 :
  n.x) || ((i = e.coords) === null || i === void 0 ? void 0 : i.y) !== ((s = t.coords) === null || s === void 0 ? void 0 : s.y) || ((a = e.coords) ===
  null || a === void 0 ? void 0 : a.clientX) !== ((l = t.coords) === null || l === void 0 ? void 0 : l.clientX) || ((u = e.coords) === null ||
  u === void 0 ? void 0 : u.clientY) !== ((c = t.coords) === null || c === void 0 ? void 0 : c.clientY) || ((d = e.coords) === null || d ===
  void 0 ? void 0 : d.offsetX) !== ((p = t.coords) === null || p === void 0 ? void 0 : p.offsetX) || ((y = e.coords) === null || y === void 0 ?
  void 0 : y.offsetY) !== ((f = t.coords) === null || f === void 0 ? void 0 : f.offsetY) || ((m = e.coords) === null || m === void 0 ? void 0 :
  m.pageX) !== ((h = t.coords) === null || h === void 0 ? void 0 : h.pageX) || ((b = e.coords) === null || b === void 0 ? void 0 : b.pageY) !==
  ((g = t.coords) === null || g === void 0 ? void 0 : g.pageY) || ((T = e.coords) === null || T === void 0 ? void 0 : T.screenX) !== ((_ = t.
  coords) === null || _ === void 0 ? void 0 : _.screenX) || ((E = e.coords) === null || E === void 0 ? void 0 : E.screenY) !== ((R = t.coords) ===
  null || R === void 0 ? void 0 : R.screenY) || ((C = e.caret) === null || C === void 0 ? void 0 : C.node) !== ((w = t.caret) === null || w ===
  void 0 ? void 0 : w.node) || ((P = e.caret) === null || P === void 0 ? void 0 : P.offset) !== ((O = t.caret) === null || O === void 0 ? void 0 :
  O.offset);
}
o(Sy, "isDifferentPointerPosition");

// ../node_modules/@testing-library/user-event/dist/esm/system/pointer/mouse.js
function Jn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(Jn, "_define_property");
var Ow = class Ow {
  move(t, r, n) {
    let i = this.position, s = this.getTarget(t);
    if (this.position = r, !Sy(i, r))
      return;
    let a = this.getTarget(t), l = this.getEventInit("mousemove"), [u, c] = Xn(s, a);
    return {
      leave: /* @__PURE__ */ o(() => {
        s !== a && (t.dispatchUIEvent(s, "mouseout", l), u.forEach((d) => t.dispatchUIEvent(d, "mouseleave", l)));
      }, "leave"),
      enter: /* @__PURE__ */ o(() => {
        s !== a && (t.dispatchUIEvent(a, "mouseover", l), c.forEach((d) => t.dispatchUIEvent(d, "mouseenter", l)));
      }, "enter"),
      move: /* @__PURE__ */ o(() => {
        n || (t.dispatchUIEvent(a, "mousemove", l), this.modifySelecting(t));
      }, "move")
    };
  }
  down(t, r, n) {
    let i = this.buttons.down(r);
    if (i === void 0)
      return;
    let s = this.getTarget(t);
    this.buttonDownTarget[i] = s;
    let a = this.getEventInit("mousedown", r.button), l = ut(s);
    !n && (l || t.dispatchUIEvent(s, "mousedown", a)) && (this.startSelecting(t, a.detail), _t(s)), !l && Ia(r.button) === 2 && t.dispatchUIEvent(
    s, "contextmenu", this.getEventInit("contextmenu", r.button));
  }
  up(t, r, n) {
    let i = this.buttons.up(r);
    if (i === void 0)
      return;
    let s = this.getTarget(t);
    if (!ut(s)) {
      if (!n) {
        let l = this.getEventInit("mouseup", r.button);
        t.dispatchUIEvent(s, "mouseup", l), this.endSelecting();
      }
      let a = Xn(this.buttonDownTarget[i], s)[2][0];
      if (a) {
        let l = this.getEventInit("click", r.button);
        l.detail && (t.dispatchUIEvent(a, l.button === 0 ? "click" : "auxclick", l), l.button === 0 && l.detail === 2 && t.dispatchUIEvent(a,
        "dblclick", {
          ...this.getEventInit("dblclick", r.button),
          detail: l.detail
        }));
      }
    }
  }
  resetClickCount() {
    this.clickCount.reset();
  }
  getEventInit(t, r) {
    let n = {
      ...this.position.coords
    };
    return n.button = Ia(r), n.buttons = this.buttons.getButtons(), t === "mousedown" ? n.detail = this.clickCount.getOnDown(n.button) : t ===
    "mouseup" ? n.detail = this.clickCount.getOnUp(n.button) : (t === "click" || t === "auxclick") && (n.detail = this.clickCount.incOnClick(
    n.button)), n;
  }
  getTarget(t) {
    var r;
    return (r = this.position.target) !== null && r !== void 0 ? r : t.config.document.body;
  }
  startSelecting(t, r) {
    var n, i;
    this.selecting = xH({
      document: t.config.document,
      target: this.getTarget(t),
      node: (n = this.position.caret) === null || n === void 0 ? void 0 : n.node,
      offset: (i = this.position.caret) === null || i === void 0 ? void 0 : i.offset,
      clickCount: r
    });
  }
  modifySelecting(t) {
    var r, n;
    this.selecting && CH(this.selecting, {
      document: t.config.document,
      target: this.getTarget(t),
      node: (r = this.position.caret) === null || r === void 0 ? void 0 : r.node,
      offset: (n = this.position.caret) === null || n === void 0 ? void 0 : n.offset
    });
  }
  endSelecting() {
    this.selecting = void 0;
  }
  constructor() {
    Jn(this, "position", {}), Jn(this, "buttons", new xi()), Jn(this, "selecting", void 0), Jn(this, "buttonDownTarget", {}), Jn(this, "clic\
kCount", new class {
      incOnClick(t) {
        let r = this.down[t] === void 0 ? void 0 : Number(this.down[t]) + 1;
        return this.count = this.count[t] === void 0 ? {} : {
          [t]: Number(this.count[t]) + 1
        }, r;
      }
      getOnDown(t) {
        var r;
        this.down = {
          [t]: (r = this.count[t]) !== null && r !== void 0 ? r : 0
        };
        var n;
        return this.count = {
          [t]: (n = this.count[t]) !== null && n !== void 0 ? n : 0
        }, Number(this.count[t]) + 1;
      }
      getOnUp(t) {
        return this.down[t] === void 0 ? void 0 : Number(this.down[t]) + 1;
      }
      reset() {
        this.count = {};
      }
      constructor() {
        Jn(this, "down", {}), Jn(this, "count", {});
      }
    }());
  }
};
o(Ow, "Mouse");
var xy = Ow;

// ../node_modules/@testing-library/user-event/dist/esm/utils/pointer/cssPointerEvents.js
function Ci(e, t) {
  var r;
  return ((r = OH(e, t)) === null || r === void 0 ? void 0 : r.pointerEvents) !== "none";
}
o(Ci, "hasPointerEvents");
function a_e(e) {
  let t = je(e);
  for (let r = e, n = []; r?.ownerDocument; r = r.parentElement) {
    n.push(r);
    let i = t.getComputedStyle(r).pointerEvents;
    if (i && ![
      "inherit",
      "unset"
    ].includes(i))
      return {
        pointerEvents: i,
        tree: n
      };
  }
}
o(a_e, "closestPointerEventsDeclaration");
var PH = Symbol("Last check for pointer-events");
function OH(e, t) {
  let r = t[PH];
  if (!(e.config.pointerEventsCheck !== Wn.Never && (!r || AH(e.config.pointerEventsCheck, Wn.EachApiCall) && r[ct.Call] !== qa(e, ct.Call) ||
  AH(e.config.pointerEventsCheck, Wn.EachTrigger) && r[ct.Trigger] !== qa(e, ct.Trigger))))
    return r?.result;
  let i = a_e(t);
  return t[PH] = {
    [ct.Call]: qa(e, ct.Call),
    [ct.Trigger]: qa(e, ct.Trigger),
    result: i
  }, i;
}
o(OH, "checkPointerEvents");
function Zn(e, t) {
  let r = OH(e, t);
  if (r?.pointerEvents === "none")
    throw new Error([
      `Unable to perform pointer interaction as the element ${r.tree.length > 1 ? "inherits" : "has"} \`pointer-events: none\`:`,
      "",
      l_e(r.tree)
    ].join(`
`));
}
o(Zn, "assertPointerEvents");
function l_e(e) {
  return e.reverse().map((t, r) => [
    "".padEnd(r),
    t.tagName,
    t.id && `#${t.id}`,
    t.hasAttribute("data-testid") && `(testId=${t.getAttribute("data-testid")})`,
    u_e(t),
    e.length > 1 && r === 0 && "  <-- This element declared `pointer-events: none`",
    e.length > 1 && r === e.length - 1 && "  <-- Asserted pointer events here"
  ].filter(Boolean).join("")).join(`
`);
}
o(l_e, "printTree");
function u_e(e) {
  var t;
  let r;
  if (e.hasAttribute("aria-label"))
    r = e.getAttribute("aria-label");
  else if (e.hasAttribute("aria-labelledby")) {
    var n, i;
    r = (i = e.ownerDocument.getElementById(e.getAttribute("aria-labelledby"))) === null || i === void 0 || (n = i.textContent) === null || n ===
    void 0 ? void 0 : n.trim();
  } else if (J(e, [
    "button",
    "input",
    "meter",
    "output",
    "progress",
    "select",
    "textarea"
  ]) && (!((t = e.labels) === null || t === void 0) && t.length))
    r = Array.from(e.labels).map((a) => {
      var l;
      return (l = a.textContent) === null || l === void 0 ? void 0 : l.trim();
    }).join("|");
  else if (J(e, "button")) {
    var s;
    r = (s = e.textContent) === null || s === void 0 ? void 0 : s.trim();
  }
  return r = r?.replace(/\n/g, "  "), Number(r?.length) > 30 && (r = `${r?.substring(0, 29)}\u2026`), r ? `(label=${r})` : "";
}
o(u_e, "getLabelDescr");
function AH(e, t) {
  return (e & t) > 0;
}
o(AH, "hasBitFlag");

// ../node_modules/@testing-library/user-event/dist/esm/system/pointer/pointer.js
function qr(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(qr, "_define_property");
var qw = class qw {
  init(t) {
    let r = this.getTarget(t), [, n] = Xn(null, r), i = this.getEventInit();
    return Zn(t, r), t.dispatchUIEvent(r, "pointerover", i), n.forEach((s) => t.dispatchUIEvent(s, "pointerenter", i)), this;
  }
  move(t, r) {
    let n = this.position, i = this.getTarget(t);
    if (this.position = r, !Sy(n, r))
      return;
    let s = this.getTarget(t), a = this.getEventInit(-1), [l, u] = Xn(i, s);
    return {
      leave: /* @__PURE__ */ o(() => {
        Ci(t, i) && i !== s && (t.dispatchUIEvent(i, "pointerout", a), l.forEach((c) => t.dispatchUIEvent(c, "pointerleave", a)));
      }, "leave"),
      enter: /* @__PURE__ */ o(() => {
        Zn(t, s), i !== s && (t.dispatchUIEvent(s, "pointerover", a), u.forEach((c) => t.dispatchUIEvent(c, "pointerenter", a)));
      }, "enter"),
      move: /* @__PURE__ */ o(() => {
        t.dispatchUIEvent(s, "pointermove", a);
      }, "move")
    };
  }
  down(t, r = 0) {
    if (this.isDown)
      return;
    let n = this.getTarget(t);
    Zn(t, n), this.isDown = !0, this.isPrevented = !t.dispatchUIEvent(n, "pointerdown", this.getEventInit(r));
  }
  up(t, r = 0) {
    if (!this.isDown)
      return;
    let n = this.getTarget(t);
    Zn(t, n), this.isPrevented = !1, this.isDown = !1, t.dispatchUIEvent(n, "pointerup", this.getEventInit(r));
  }
  release(t) {
    let r = this.getTarget(t), [n] = Xn(r, null), i = this.getEventInit();
    Ci(t, r) && (t.dispatchUIEvent(r, "pointerout", i), n.forEach((s) => t.dispatchUIEvent(s, "pointerleave", i))), this.isCancelled = !0;
  }
  getTarget(t) {
    var r;
    return (r = this.position.target) !== null && r !== void 0 ? r : t.config.document.body;
  }
  getEventInit(t) {
    return {
      ...this.position.coords,
      pointerId: this.pointerId,
      pointerType: this.pointerType,
      isPrimary: this.isPrimary,
      button: Ia(t),
      buttons: this.buttons.getButtons()
    };
  }
  constructor({ pointerId: t, pointerType: r, isPrimary: n }, i) {
    qr(this, "pointerId", void 0), qr(this, "pointerType", void 0), qr(this, "isPrimary", void 0), qr(this, "buttons", void 0), qr(this, "is\
Multitouch", !1), qr(this, "isCancelled", !1), qr(this, "isDown", !1), qr(this, "isPrevented", !1), qr(this, "position", {}), this.pointerId =
    t, this.pointerType = r, this.isPrimary = n, this.isMultitouch = !n, this.buttons = i;
  }
};
o(qw, "Pointer");
var Cy = qw;

// ../node_modules/@testing-library/user-event/dist/esm/system/pointer/index.js
function bn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(bn, "_define_property");
var Iw = class Iw {
  isKeyPressed(t) {
    return this.devices.get(t.pointerType).isPressed(t);
  }
  async press(t, r, n) {
    this.devices.get(r.pointerType).addPressed(r), this.buttons.down(r);
    let i = this.getPointerName(r), s = r.pointerType === "touch" ? this.pointers.new(i, r.pointerType, this.buttons) : this.pointers.get(i);
    s.position = n, s.pointerType !== "touch" && (this.mouse.position = n), s.pointerType === "touch" && s.init(t), s.down(t, r.button), s.pointerType !==
    "touch" && this.mouse.down(t, r, s.isPrevented);
  }
  async move(t, r, n) {
    let i = this.pointers.get(r), s = i.move(t, n), a = i.pointerType === "touch" ? void 0 : this.mouse.move(t, n, i.isPrevented);
    s?.leave(), a?.leave(), s?.enter(), a?.enter(), s?.move(), a?.move();
  }
  async release(t, r, n) {
    let i = this.devices.get(r.pointerType);
    i.removePressed(r), this.buttons.up(r);
    let s = this.pointers.get(this.getPointerName(r)), a = s.isPrevented;
    if (s.position = n, s.pointerType !== "touch" && (this.mouse.position = n), i.countPressed === 0 && s.up(t, r.button), s.pointerType ===
    "touch" && s.release(t), s.pointerType === "touch" && !s.isMultitouch) {
      let l = this.mouse.move(t, n, a);
      l?.leave(), l?.enter(), l?.move(), this.mouse.down(t, r, a);
    }
    if (!s.isMultitouch) {
      let l = this.mouse.move(t, n, a);
      l?.leave(), l?.enter(), l?.move(), this.mouse.up(t, r, a);
    }
  }
  getPointerName(t) {
    return t.pointerType === "touch" ? t.name : t.pointerType;
  }
  getPreviousPosition(t) {
    return this.pointers.has(t) ? this.pointers.get(t).position : void 0;
  }
  resetClickCount() {
    this.mouse.resetClickCount();
  }
  getMouseTarget(t) {
    var r;
    return (r = this.mouse.position.target) !== null && r !== void 0 ? r : t.config.document.body;
  }
  setMousePosition(t) {
    this.mouse.position = t, this.pointers.get("mouse").position = t;
  }
  constructor(t) {
    bn(this, "system", void 0), bn(this, "mouse", void 0), bn(this, "buttons", void 0), bn(this, "devices", new class {
      get(r) {
        var n, i, s;
        return (s = (n = this.registry)[i = r]) !== null && s !== void 0 ? s : n[i] = new wy();
      }
      constructor() {
        bn(this, "registry", {});
      }
    }()), bn(this, "pointers", new class {
      new(r, n, i) {
        let s = n !== "touch" || !Object.values(this.registry).some((a) => a.pointerType === "touch" && !a.isCancelled);
        return s || Object.values(this.registry).forEach((a) => {
          a.pointerType === n && !a.isCancelled && (a.isMultitouch = !0);
        }), this.registry[r] = new Cy({
          pointerId: this.nextId++,
          pointerType: n,
          isPrimary: s
        }, i), this.registry[r];
      }
      get(r) {
        if (!this.has(r))
          throw new Error(`Trying to access pointer "${r}" which does not exist.`);
        return this.registry[r];
      }
      has(r) {
        return r in this.registry;
      }
      constructor() {
        bn(this, "registry", {}), bn(this, "nextId", 1);
      }
    }()), this.system = t, this.buttons = new xi(), this.mouse = new xy(), this.pointers.new("mouse", "mouse", this.buttons);
  }
};
o(Iw, "PointerHost");
var Py = Iw;

// ../node_modules/@testing-library/user-event/dist/esm/system/index.js
function qH(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
o(qH, "_define_property");
var Mw = class Mw {
  getUIEventModifiers() {
    return {
      altKey: this.keyboard.modifiers.Alt,
      ctrlKey: this.keyboard.modifiers.Control,
      metaKey: this.keyboard.modifiers.Meta,
      shiftKey: this.keyboard.modifiers.Shift,
      modifierAltGraph: this.keyboard.modifiers.AltGraph,
      modifierCapsLock: this.keyboard.modifiers.CapsLock,
      modifierFn: this.keyboard.modifiers.Fn,
      modifierFnLock: this.keyboard.modifiers.FnLock,
      modifierNumLock: this.keyboard.modifiers.NumLock,
      modifierScrollLock: this.keyboard.modifiers.ScrollLock,
      modifierSymbol: this.keyboard.modifiers.Symbol,
      modifierSymbolLock: this.keyboard.modifiers.SymbolLock
    };
  }
  constructor() {
    qH(this, "keyboard", new Ry(this)), qH(this, "pointer", new Py(this));
  }
};
o(Mw, "System");
var Na = Mw;

// ../node_modules/@testing-library/user-event/dist/esm/convenience/click.js
async function IH(e) {
  let t = [];
  return this.config.skipHover || t.push({
    target: e
  }), t.push({
    keys: "[MouseLeft]",
    target: e
  }), this.pointer(t);
}
o(IH, "click");
async function MH(e) {
  return this.pointer([
    {
      target: e
    },
    "[MouseLeft][MouseLeft]"
  ]);
}
o(MH, "dblClick");
async function NH(e) {
  return this.pointer([
    {
      target: e
    },
    "[MouseLeft][MouseLeft][MouseLeft]"
  ]);
}
o(NH, "tripleClick");

// ../node_modules/@testing-library/user-event/dist/esm/convenience/hover.js
async function jH(e) {
  return this.pointer({
    target: e
  });
}
o(jH, "hover");
async function LH(e) {
  return Zn(this, this.system.pointer.getMouseTarget(this)), this.pointer({
    target: e.ownerDocument.body
  });
}
o(LH, "unhover");

// ../node_modules/@testing-library/user-event/dist/esm/convenience/tab.js
async function FH({ shift: e } = {}) {
  return this.keyboard(e === !0 ? "{Shift>}{Tab}{/Shift}" : e === !1 ? "[/ShiftLeft][/ShiftRight]{Tab}" : "{Tab}");
}
o(FH, "tab");

// ../node_modules/@testing-library/user-event/dist/esm/utils/keyDef/readNextDescriptor.js
var Nw = /* @__PURE__ */ function(e) {
  return e["{"] = "}", e["["] = "]", e;
}(Nw || {});
function Ay(e, t) {
  let r = 0, n = e[r] in Nw ? e[r] : "";
  r += n.length;
  let s = new RegExp(`^\\${n}{2}`).test(e) ? "" : n;
  return {
    type: s,
    ...s === "" ? c_e(e, r, t) : d_e(e, r, s, t)
  };
}
o(Ay, "readNextDescriptor");
function c_e(e, t, r) {
  let n = e[t];
  return kH(n, e, t, r), t += n.length, {
    consumedLength: t,
    descriptor: n,
    releasePrevious: !1,
    releaseSelf: !0,
    repeat: 1
  };
}
o(c_e, "readPrintableChar");
function d_e(e, t, r, n) {
  var i, s;
  let a = e[t] === "/" ? "/" : "";
  t += a.length;
  let l = r === "{" && e[t] === "\\";
  t += Number(l);
  let u = l ? e[t] : (i = e.slice(t).match(r === "{" ? /^\w+|^[^}>/]/ : /^\w+/)) === null || i === void 0 ? void 0 : i[0];
  kH(u, e, t, n), t += u.length;
  var c;
  let d = (c = (s = e.slice(t).match(/^>\d+/)) === null || s === void 0 ? void 0 : s[0]) !== null && c !== void 0 ? c : "";
  t += d.length;
  let p = e[t] === "/" || !d && e[t] === ">" ? e[t] : "";
  t += p.length;
  let y = Nw[r], f = e[t] === y ? y : "";
  if (!f)
    throw new Error(DH([
      !d && "repeat modifier",
      !p && "release modifier",
      `"${y}"`
    ].filter(Boolean).join(" or "), e[t], e, n));
  return t += f.length, {
    consumedLength: t,
    descriptor: u,
    releasePrevious: !!a,
    repeat: d ? Math.max(Number(d.substr(1)), 1) : 1,
    releaseSelf: p_e(p, d)
  };
}
o(d_e, "readTag");
function kH(e, t, r, n) {
  if (!e)
    throw new Error(DH("key descriptor", t[r], t, n));
}
o(kH, "assertDescriptor");
function p_e(e, t) {
  if (e)
    return e === "/";
  if (t)
    return !1;
}
o(p_e, "hasReleaseSelf");
function DH(e, t, r, n) {
  return `Expected ${e} but found "${t ?? ""}" in "${r}"
    See ${n === "pointer" ? "https://testing-library.com/docs/user-event/pointer#pressing-a-button-or-touching-the-screen" : "https://testin\
g-library.com/docs/user-event/keyboard"}
    for more information about how userEvent parses your input.`;
}
o(DH, "getErrorMessage");

// ../node_modules/@testing-library/user-event/dist/esm/keyboard/parseKeyDef.js
function $H(e, t) {
  let r = [];
  do {
    let { type: i, descriptor: s, consumedLength: a, releasePrevious: l, releaseSelf: u = !0, repeat: c } = Ay(t, "keyboard");
    var n;
    let d = (n = e.find((p) => {
      if (i === "[") {
        var y;
        return ((y = p.code) === null || y === void 0 ? void 0 : y.toLowerCase()) === s.toLowerCase();
      } else if (i === "{") {
        var f;
        return ((f = p.key) === null || f === void 0 ? void 0 : f.toLowerCase()) === s.toLowerCase();
      }
      return p.key === s;
    })) !== null && n !== void 0 ? n : {
      key: "Unknown",
      code: "Unknown",
      [i === "[" ? "code" : "key"]: s
    };
    r.push({
      keyDef: d,
      releasePrevious: l,
      releaseSelf: u,
      repeat: c
    }), t = t.slice(a);
  } while (t);
  return r;
}
o($H, "parseKeyDef");

// ../node_modules/@testing-library/user-event/dist/esm/keyboard/index.js
async function BH(e) {
  let t = $H(this.config.keyboardMap, e);
  for (let r = 0; r < t.length; r++)
    await fr(this.config), await f_e(this, t[r]);
}
o(BH, "keyboard");
async function f_e(e, { keyDef: t, releasePrevious: r, releaseSelf: n, repeat: i }) {
  let { system: s } = e;
  if (s.keyboard.isKeyPressed(t) && await s.keyboard.keyup(e, t), !r) {
    for (let a = 1; a <= i; a++)
      await s.keyboard.keydown(e, t), a < i && await fr(e.config);
    n && await s.keyboard.keyup(e, t);
  }
}
o(f_e, "keyboardAction");
async function UH(e) {
  for (let t of e.system.keyboard.getPressedKeys())
    await e.system.keyboard.keyup(e, t);
}
o(UH, "releaseAllKeys");

// ../node_modules/@testing-library/user-event/dist/esm/document/copySelection.js
function Oy(e) {
  let t = ze(e) ? {
    "text/plain": m_e(e)
  } : {
    "text/plain": String(e.ownerDocument.getSelection())
  }, r = Ti(je(e));
  for (let n in t)
    t[n] && r.setData(n, t[n]);
  return r;
}
o(Oy, "copySelection");
function m_e(e) {
  let t = Ar(e);
  return Je(e).substring(t.startOffset, t.endOffset);
}
o(m_e, "readSelectedValueFromInput");

// ../node_modules/@testing-library/user-event/dist/esm/clipboard/copy.js
async function HH() {
  let e = this.config.document;
  var t;
  let r = (t = e.activeElement) !== null && t !== void 0 ? t : (
    /* istanbul ignore next */
    e.body
  ), n = Oy(r);
  if (n.items.length !== 0)
    return this.dispatchUIEvent(r, "copy", {
      clipboardData: n
    }) && this.config.writeToClipboard && await dy(e, n), n;
}
o(HH, "copy");

// ../node_modules/@testing-library/user-event/dist/esm/clipboard/cut.js
async function VH() {
  let e = this.config.document;
  var t;
  let r = (t = e.activeElement) !== null && t !== void 0 ? t : (
    /* istanbul ignore next */
    e.body
  ), n = Oy(r);
  if (n.items.length !== 0)
    return this.dispatchUIEvent(r, "cut", {
      clipboardData: n
    }) && this.config.writeToClipboard && await dy(r.ownerDocument, n), n;
}
o(VH, "cut");

// ../node_modules/@testing-library/user-event/dist/esm/clipboard/paste.js
async function zH(e) {
  let t = this.config.document;
  var r;
  let n = (r = t.activeElement) !== null && r !== void 0 ? r : (
    /* istanbul ignore next */
    t.body
  );
  var i;
  let s = (i = typeof e == "string" ? h_e(t, e) : e) !== null && i !== void 0 ? i : await PU(t).catch(() => {
    throw new Error("`userEvent.paste()` without `clipboardData` requires the `ClipboardAPI` to be available.");
  });
  this.dispatchUIEvent(n, "paste", {
    clipboardData: s
  });
}
o(zH, "paste");
function h_e(e, t) {
  let r = Ti(je(e));
  return r.setData("text", t), r;
}
o(h_e, "getClipboardDataFromString");

// ../node_modules/@testing-library/user-event/dist/esm/pointer/parseKeyDef.js
function jw(e, t) {
  let r = [];
  do {
    let { descriptor: n, consumedLength: i, releasePrevious: s, releaseSelf: a = !0 } = Ay(t, "pointer"), l = e.find((u) => u.name === n);
    l && r.push({
      keyDef: l,
      releasePrevious: s,
      releaseSelf: a
    }), t = t.slice(i);
  } while (t);
  return r;
}
o(jw, "parseKeyDef");

// ../node_modules/@testing-library/user-event/dist/esm/pointer/index.js
async function YH(e) {
  let { pointerMap: t } = this.config, r = [];
  (Array.isArray(e) ? e : [
    e
  ]).forEach((n) => {
    typeof n == "string" ? r.push(...jw(t, n)) : "keys" in n ? r.push(...jw(t, n.keys).map((i) => ({
      ...n,
      ...i
    }))) : r.push(n);
  });
  for (let n = 0; n < r.length; n++)
    await fr(this.config), await y_e(this, r[n]);
  this.system.pointer.resetClickCount();
}
o(YH, "pointer");
async function y_e(e, t) {
  var r, n;
  let i = "pointerName" in t && t.pointerName ? t.pointerName : "keyDef" in t ? e.system.pointer.getPointerName(t.keyDef) : "mouse", s = e.system.
  pointer.getPreviousPosition(i);
  var a, l, u, c;
  let d = {
    target: (a = t.target) !== null && a !== void 0 ? a : b_e(e, s),
    coords: (l = t.coords) !== null && l !== void 0 ? l : s?.coords,
    caret: {
      node: (u = t.node) !== null && u !== void 0 ? u : GH(t) || s == null || (r = s.caret) === null || r === void 0 ? void 0 : r.node,
      offset: (c = t.offset) !== null && c !== void 0 ? c : GH(t) || s == null || (n = s.caret) === null || n === void 0 ? void 0 : n.offset
    }
  };
  "keyDef" in t ? (e.system.pointer.isKeyPressed(t.keyDef) && (Yn(e, ct.Trigger), await e.system.pointer.release(e, t.keyDef, d)), t.releasePrevious ||
  (Yn(e, ct.Trigger), await e.system.pointer.press(e, t.keyDef, d), t.releaseSelf && (Yn(e, ct.Trigger), await e.system.pointer.release(e, t.
  keyDef, d)))) : (Yn(e, ct.Trigger), await e.system.pointer.move(e, i, d));
}
o(y_e, "pointerAction");
function GH(e) {
  var t, r;
  return !!((r = (t = e.target) !== null && t !== void 0 ? t : e.node) !== null && r !== void 0 ? r : e.offset !== void 0);
}
o(GH, "hasCaretPosition");
function b_e(e, t) {
  if (!t)
    throw new Error("This pointer has no previous position. Provide a target property!");
  var r;
  return (r = t.target) !== null && r !== void 0 ? r : e.config.document.body;
}
o(b_e, "getPrevTarget");

// ../node_modules/@testing-library/user-event/dist/esm/utility/clear.js
async function WH(e) {
  if (!tr(e) || ut(e))
    throw new Error("clear()` is only supported on editable elements.");
  if (_t(e), e.ownerDocument.activeElement !== e)
    throw new Error("The element to be cleared could not be focused.");
  if (_y(e), !oH(e))
    throw new Error("The element content to be cleared could not be selected.");
  or(this, e, "", "deleteContentBackward");
}
o(WH, "clear");

// ../node_modules/@testing-library/user-event/dist/esm/utility/selectOptions.js
async function KH(e, t) {
  return JH.call(this, !0, e, t);
}
o(KH, "selectOptions");
async function XH(e, t) {
  return JH.call(this, !1, e, t);
}
o(XH, "deselectOptions");
async function JH(e, t, r) {
  if (!e && !t.multiple)
    throw le().getElementError("Unable to deselect an option in a non-multiple select. Use selectOptions to change the selection instead.", t);
  let n = Array.isArray(r) ? r : [
    r
  ], i = Array.from(t.querySelectorAll('option, [role="option"]')), s = n.map((l) => {
    if (typeof l != "string" && i.includes(l))
      return l;
    {
      let u = i.find((c) => c.value === l || c.innerHTML === l);
      if (u)
        return u;
      throw le().getElementError(`Value "${String(l)}" not found in options`, t);
    }
  }).filter((l) => !ut(l));
  if (ut(t) || !s.length) return;
  let a = /* @__PURE__ */ o((l) => {
    l.selected = e, this.dispatchUIEvent(t, "input", {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }), this.dispatchUIEvent(t, "change");
  }, "selectOption");
  if (J(t, "select"))
    if (t.multiple)
      for (let l of s) {
        let u = this.config.pointerEventsCheck === 0 ? !0 : Ci(this, l);
        u && (this.dispatchUIEvent(l, "pointerover"), this.dispatchUIEvent(t, "pointerenter"), this.dispatchUIEvent(l, "mouseover"), this.dispatchUIEvent(
        t, "mouseenter"), this.dispatchUIEvent(l, "pointermove"), this.dispatchUIEvent(l, "mousemove"), this.dispatchUIEvent(l, "pointerdown"),
        this.dispatchUIEvent(l, "mousedown")), _t(t), u && (this.dispatchUIEvent(l, "pointerup"), this.dispatchUIEvent(l, "mouseup")), a(l),
        u && this.dispatchUIEvent(l, "click"), await fr(this.config);
      }
    else if (s.length === 1) {
      let l = this.config.pointerEventsCheck === 0 ? !0 : Ci(this, t);
      l ? await this.click(t) : _t(t), a(s[0]), l && (this.dispatchUIEvent(t, "pointerover"), this.dispatchUIEvent(t, "pointerenter"), this.
      dispatchUIEvent(t, "mouseover"), this.dispatchUIEvent(t, "mouseenter"), this.dispatchUIEvent(t, "pointerup"), this.dispatchUIEvent(t, "\
mouseup"), this.dispatchUIEvent(t, "click")), await fr(this.config);
    } else
      throw le().getElementError("Cannot select multiple options on a non-multiple select", t);
  else if (t.getAttribute("role") === "listbox")
    for (let l of s)
      await this.click(l), await this.unhover(l);
  else
    throw le().getElementError("Cannot select options on elements that are neither select nor listbox elements", t);
}
o(JH, "selectOptionsBase");

// ../node_modules/@testing-library/user-event/dist/esm/utility/type.js
async function ZH(e, t, { skipClick: r = this.config.skipClick, skipAutoClose: n = this.config.skipAutoClose, initialSelectionStart: i, initialSelectionEnd: s } = {}) {
  e.disabled || (r || await this.click(e), i !== void 0 && Gn(e, i, s ?? i), await this.keyboard(t), n || await UH(this));
}
o(ZH, "type");

// ../node_modules/@testing-library/user-event/dist/esm/utils/edit/setFiles.js
var QH = Symbol("files and value properties are mocked");
function Lw(e, t, r) {
  r ? Object.defineProperty(e, t, r) : delete e[t];
}
o(Lw, "restoreProperty");
function e5(e, t) {
  var r;
  (r = e[QH]) === null || r === void 0 || r.restore();
  let n = Object.getOwnPropertyDescriptor(e, "type"), i = Object.getOwnPropertyDescriptor(e, "value"), s = Object.getOwnPropertyDescriptor(e,
  "files");
  function a() {
    Lw(e, "type", n), Lw(e, "value", i), Lw(e, "files", s);
  }
  o(a, "restore"), e[QH] = {
    restore: a
  }, Object.defineProperties(e, {
    files: {
      configurable: !0,
      get: /* @__PURE__ */ o(() => t, "get")
    },
    value: {
      configurable: !0,
      get: /* @__PURE__ */ o(() => t.length ? `C:\\fakepath\\${t[0].name}` : "", "get"),
      set(l) {
        if (l === "")
          a();
        else {
          var u;
          i == null || (u = i.set) === null || u === void 0 || u.call(e, l);
        }
      }
    },
    type: {
      configurable: !0,
      get: /* @__PURE__ */ o(() => "file", "get"),
      set(l) {
        l !== "file" && (a(), e.type = l);
      }
    }
  });
}
o(e5, "setFiles");

// ../node_modules/@testing-library/user-event/dist/esm/utility/upload.js
async function t5(e, t) {
  let r = J(e, "label") ? e.control : e;
  if (!r || !J(r, "input", {
    type: "file"
  }))
    throw new TypeError(`The ${r === e ? "given" : "associated"} ${r?.tagName} element does not accept file uploads`);
  if (ut(e)) return;
  let n = (Array.isArray(t) ? t : [
    t
  ]).filter((s) => !this.config.applyAccept || g_e(s, r.accept)).slice(0, r.multiple ? void 0 : 1), i = /* @__PURE__ */ o(() => {
    var s;
    n.length === ((s = r.files) === null || s === void 0 ? void 0 : s.length) && n.every((a, l) => {
      var u;
      return a === ((u = r.files) === null || u === void 0 ? void 0 : u.item(l));
    }) || (e5(r, wa(je(e), n)), this.dispatchUIEvent(r, "input"), this.dispatchUIEvent(r, "change"));
  }, "fileDialog");
  r.addEventListener("fileDialog", i), await this.click(e), r.removeEventListener("fileDialog", i);
}
o(t5, "upload");
function qy(e) {
  return e.toLowerCase().replace(/(\.|\/)jpg\b/g, "$1jpeg");
}
o(qy, "normalize");
function g_e(e, t) {
  if (!t)
    return !0;
  let r = [
    "audio/*",
    "image/*",
    "video/*"
  ];
  return qy(t).trim().split(/\s*,\s*/).some((n) => n.startsWith(".") ? qy(e.name).endsWith(n) : r.includes(n) ? qy(e.type).startsWith(n.replace(
  "*", "")) : qy(e.type) === n);
}
o(g_e, "isAcceptableFile");

// ../node_modules/@testing-library/user-event/dist/esm/setup/api.js
var Fw = {
  click: IH,
  dblClick: MH,
  tripleClick: NH,
  hover: jH,
  unhover: LH,
  tab: FH,
  keyboard: BH,
  copy: HH,
  cut: VH,
  paste: zH,
  pointer: YH,
  clear: WH,
  deselectOptions: XH,
  selectOptions: KH,
  type: ZH,
  upload: t5
};

// ../node_modules/@testing-library/user-event/dist/esm/setup/wrapAsync.js
function r5(e) {
  return le().asyncWrapper(e);
}
o(r5, "wrapAsync");

// ../node_modules/@testing-library/user-event/dist/esm/setup/setup.js
var n5 = {
  applyAccept: !0,
  autoModify: !0,
  delay: 0,
  document: globalThis.document,
  keyboardMap: TH,
  pointerMap: _H,
  pointerEventsCheck: Wn.EachApiCall,
  skipAutoClose: !1,
  skipClick: !1,
  skipHover: !1,
  writeToClipboard: !1,
  advanceTimers: /* @__PURE__ */ o(() => Promise.resolve(), "advanceTimers")
}, v_e = {
  ...n5,
  writeToClipboard: !0
};
function o5(e = {}, t = v_e, r) {
  let n = __e(e, r, t);
  return {
    ...t,
    ...e,
    document: n
  };
}
o(o5, "createConfig");
function i5(e = {}) {
  let t = o5(e);
  Sw(t.document), Rw(je(t.document).HTMLElement);
  var r;
  let n = (r = t.document.defaultView) !== null && r !== void 0 ? r : (
    /* istanbul ignore next */
    globalThis.window
  );
  return CU(n), kw(t).api;
}
o(i5, "setupMain");
function nt({ keyboardState: e, pointerState: t, ...r } = {}, n) {
  let i = o5(r, n5, n);
  Sw(i.document), Rw(je(i.document).HTMLElement);
  var s;
  let a = (s = t ?? e) !== null && s !== void 0 ? s : new Na();
  return {
    api: kw(i, a).api,
    system: a
  };
}
o(nt, "setupDirect");
function E_e(e) {
  return kw({
    ...this.config,
    ...e
  }, this.system).api;
}
o(E_e, "setupSub");
function T_e(e, t) {
  function r(...n) {
    return Yn(e, ct.Call), r5(() => t.apply(e, n).then(async (i) => (await fr(e.config), i)));
  }
  return o(r, "method"), Object.defineProperty(r, "name", {
    get: /* @__PURE__ */ o(() => t.name, "get")
  }), r;
}
o(T_e, "wrapAndBindImpl");
function kw(e, t = new Na()) {
  let r = {};
  return Object.assign(r, {
    config: e,
    dispatchEvent: _w.bind(r),
    dispatchUIEvent: dH.bind(r),
    system: t,
    levelRefs: {},
    ...Fw
  }), {
    instance: r,
    api: {
      ...Object.fromEntries(Object.entries(Fw).map(([n, i]) => [
        n,
        T_e(r, i)
      ])),
      setup: E_e.bind(r)
    }
  };
}
o(kw, "createInstance");
function __e(e, t, r) {
  var n, i;
  return (i = (n = e.document) !== null && n !== void 0 ? n : t && gH(t)) !== null && i !== void 0 ? i : r.document;
}
o(__e, "getDocument");

// ../node_modules/@testing-library/user-event/dist/esm/setup/directApi.js
var Dw = {};
ft(Dw, {
  clear: () => R_e,
  click: () => w_e,
  copy: () => S_e,
  cut: () => x_e,
  dblClick: () => C_e,
  deselectOptions: () => P_e,
  hover: () => A_e,
  keyboard: () => O_e,
  paste: () => I_e,
  pointer: () => q_e,
  selectOptions: () => M_e,
  tab: () => k_e,
  tripleClick: () => N_e,
  type: () => j_e,
  unhover: () => L_e,
  upload: () => F_e
});
function R_e(e) {
  return nt().api.clear(e);
}
o(R_e, "clear");
function w_e(e, t = {}) {
  return nt(t, e).api.click(e);
}
o(w_e, "click");
function S_e(e = {}) {
  return nt(e).api.copy();
}
o(S_e, "copy");
function x_e(e = {}) {
  return nt(e).api.cut();
}
o(x_e, "cut");
function C_e(e, t = {}) {
  return nt(t).api.dblClick(e);
}
o(C_e, "dblClick");
function P_e(e, t, r = {}) {
  return nt(r).api.deselectOptions(e, t);
}
o(P_e, "deselectOptions");
function A_e(e, t = {}) {
  return nt(t).api.hover(e);
}
o(A_e, "hover");
async function O_e(e, t = {}) {
  let { api: r, system: n } = nt(t);
  return r.keyboard(e).then(() => n);
}
o(O_e, "keyboard");
async function q_e(e, t = {}) {
  let { api: r, system: n } = nt(t);
  return r.pointer(e).then(() => n);
}
o(q_e, "pointer");
function I_e(e, t) {
  return nt(t).api.paste(e);
}
o(I_e, "paste");
function M_e(e, t, r = {}) {
  return nt(r).api.selectOptions(e, t);
}
o(M_e, "selectOptions");
function N_e(e, t = {}) {
  return nt(t).api.tripleClick(e);
}
o(N_e, "tripleClick");
function j_e(e, t, r = {}) {
  return nt(r, e).api.type(e, t, r);
}
o(j_e, "type");
function L_e(e, t = {}) {
  let { api: r, system: n } = nt(t);
  return n.pointer.setMousePosition({
    target: e
  }), r.unhover(e);
}
o(L_e, "unhover");
function F_e(e, t, r = {}) {
  return nt(r).api.upload(e, t);
}
o(F_e, "upload");
function k_e(e = {}) {
  return nt().api.tab(e);
}
o(k_e, "tab");

// ../node_modules/@testing-library/user-event/dist/esm/setup/index.js
var ja = {
  ...Dw,
  setup: i5
};

// src/test/testing-library.ts
var $w = cr(
  { ...uw },
  {
    intercept: /* @__PURE__ */ o((e, t) => t[0] === "fireEvent" || e.startsWith("find") || e.startsWith("waitFor"), "intercept")
  }
);
$w.screen = new Proxy($w.screen, {
  get(e, t, r) {
    return we.warn(px`
          You are using Testing Library's \`screen\` object. Use \`within(canvasElement)\` instead.
          More info: https://storybook.js.org/docs/essentials/interactions
        `), Reflect.get(e, t, r);
  }
});
var {
  buildQueries: $_e,
  configure: B_e,
  createEvent: U_e,
  fireEvent: H_e,
  findAllByAltText: V_e,
  findAllByDisplayValue: z_e,
  findAllByLabelText: G_e,
  findAllByPlaceholderText: Y_e,
  findAllByRole: W_e,
  findAllByTestId: K_e,
  findAllByText: X_e,
  findAllByTitle: J_e,
  findByAltText: Z_e,
  findByDisplayValue: Q_e,
  findByLabelText: eRe,
  findByPlaceholderText: tRe,
  findByRole: rRe,
  findByTestId: nRe,
  findByText: oRe,
  findByTitle: iRe,
  getAllByAltText: sRe,
  getAllByDisplayValue: aRe,
  getAllByLabelText: lRe,
  getAllByPlaceholderText: uRe,
  getAllByRole: cRe,
  getAllByTestId: dRe,
  getAllByText: pRe,
  getAllByTitle: fRe,
  getByAltText: mRe,
  getByDisplayValue: hRe,
  getByLabelText: yRe,
  getByPlaceholderText: bRe,
  getByRole: gRe,
  getByTestId: vRe,
  getByText: ERe,
  getByTitle: TRe,
  getConfig: _Re,
  getDefaultNormalizer: RRe,
  getElementError: wRe,
  getNodeText: SRe,
  getQueriesForElement: xRe,
  getRoles: CRe,
  getSuggestedQuery: PRe,
  isInaccessible: ARe,
  logDOM: ORe,
  logRoles: qRe,
  prettyDOM: IRe,
  queries: MRe,
  queryAllByAltText: NRe,
  queryAllByAttribute: jRe,
  queryAllByDisplayValue: LRe,
  queryAllByLabelText: FRe,
  queryAllByPlaceholderText: kRe,
  queryAllByRole: DRe,
  queryAllByTestId: $Re,
  queryAllByText: BRe,
  queryAllByTitle: URe,
  queryByAltText: HRe,
  queryByAttribute: VRe,
  queryByDisplayValue: zRe,
  queryByLabelText: GRe,
  queryByPlaceholderText: YRe,
  queryByRole: WRe,
  queryByTestId: KRe,
  queryByText: XRe,
  queryByTitle: JRe,
  queryHelpers: ZRe,
  screen: QRe,
  waitFor: ewe,
  waitForElementToBeRemoved: twe,
  within: Bw,
  prettyFormat: rwe
} = $w, Uw = ja, { userEvent: nwe } = cr(
  { userEvent: ja },
  { intercept: !0 }
);

// src/test/index.ts
var { expect: owe } = cr(
  { expect: iR },
  {
    getKeys: /* @__PURE__ */ o((e, t) => {
      if ("constructor" in e && e.constructor === x) {
        let r = ["assert", "__methods", "__flags", "_obj"], n = Object.keys(Object.getPrototypeOf(e)).filter(
          (i) => !r.includes(i)
        );
        return t > 2 ? n : [...n, "not"];
      }
      return "any" in e ? Object.keys(e).filter((r) => r !== "any") : Object.keys(e);
    }, "getKeys"),
    mutate: !0,
    intercept: /* @__PURE__ */ o((e) => e !== "expect", "intercept")
  }
);

// src/actions/loaders.ts
var s5 = !1, iwe = /* @__PURE__ */ o((e) => {
  let { parameters: t } = e;
  t?.actions?.disable || s5 || (aR((r, n) => {
    let i = r.getMockName();
    i !== "spy" && (!/^next\/.*::/.test(i) || [
      "next/router::useRouter()",
      "next/navigation::useRouter()",
      "next/navigation::redirect",
      "next/cache::",
      "next/headers::cookies().set",
      "next/headers::cookies().delete",
      "next/headers::headers().set",
      "next/headers::headers().delete"
    ].some((s) => i.startsWith(s))) && Br(i)(n);
  }), s5 = !0);
}, "logActionsWhenMockCalled"), swe = [iwe];

// src/actions/preview.ts
var zw = /* @__PURE__ */ o(() => ({
  ...Ov,
  ...Vw
}), "default");

// src/backgrounds/constants.ts
var awe = "storybook/background", Pi = "backgrounds";
var wWe = {
  UPDATE: `${awe}/update`
};

// src/backgrounds/defaults.ts
var a5 = {
  light: { name: "light", value: "#F8F8F8" },
  dark: { name: "dark", value: "#333" }
};

// src/backgrounds/utils.ts
var { document: sr } = globalThis, l5 = /* @__PURE__ */ o(() => globalThis?.matchMedia ? !!globalThis.matchMedia("(prefers-reduced-motion: r\
educe)")?.matches : !1, "isReduceMotionEnabled"), Gw = /* @__PURE__ */ o((e) => {
  (Array.isArray(e) ? e : [e]).forEach(lwe);
}, "clearStyles"), lwe = /* @__PURE__ */ o((e) => {
  if (!sr)
    return;
  let t = sr.getElementById(e);
  t && t.parentElement && t.parentElement.removeChild(t);
}, "clearStyle"), u5 = /* @__PURE__ */ o((e, t) => {
  if (!sr)
    return;
  let r = sr.getElementById(e);
  if (r)
    r.innerHTML !== t && (r.innerHTML = t);
  else {
    let n = sr.createElement("style");
    n.setAttribute("id", e), n.innerHTML = t, sr.head.appendChild(n);
  }
}, "addGridStyle"), c5 = /* @__PURE__ */ o((e, t, r) => {
  if (!sr)
    return;
  let n = sr.getElementById(e);
  if (n)
    n.innerHTML !== t && (n.innerHTML = t);
  else {
    let i = sr.createElement("style");
    i.setAttribute("id", e), i.innerHTML = t;
    let s = `addon-backgrounds-grid${r ? `-docs-${r}` : ""}`, a = sr.getElementById(s);
    a ? a.parentElement?.insertBefore(i, a) : sr.head.appendChild(i);
  }
}, "addBackgroundStyle");

// src/backgrounds/decorator.ts
var uwe = {
  cellSize: 100,
  cellAmount: 10,
  opacity: 0.8
}, d5 = "addon-backgrounds", p5 = "addon-backgrounds-grid", cwe = l5() ? "" : "transition: background-color 0.3s;", f5 = /* @__PURE__ */ o((e, t) => {
  let { globals: r = {}, parameters: n = {}, viewMode: i, id: s } = t, {
    options: a = a5,
    disable: l,
    grid: u = uwe
  } = n[Pi] || {}, c = r[Pi] || {}, d = typeof c == "string" ? c : c?.value, p = d ? a[d] : void 0, y = typeof p == "string" ? p : p?.value ||
  "transparent", f = typeof c == "string" ? !1 : c.grid || !1, m = !!p && !l, h = i === "docs" ? `#anchor--${s} .docs-story` : ".sb-show-mai\
n", b = i === "docs" ? `#anchor--${s} .docs-story` : ".sb-show-main", g = n.layout === void 0 || n.layout === "padded", T = i === "docs" ? 20 :
  g ? 16 : 0, { cellAmount: _, cellSize: E, opacity: R, offsetX: C = T, offsetY: w = T } = u, P = i === "docs" ? `${d5}-docs-${s}` : `${d5}-\
color`, O = i === "docs" ? s : null;
  Ht(() => {
    let A = `
    ${h} {
      background: ${y} !important;
      ${cwe}
      }`;
    if (!m) {
      Gw(P);
      return;
    }
    c5(P, A, O);
  }, [h, P, O, m, y]);
  let D = i === "docs" ? `${p5}-docs-${s}` : `${p5}`;
  return Ht(() => {
    if (!f) {
      Gw(D);
      return;
    }
    let A = [
      `${E * _}px ${E * _}px`,
      `${E * _}px ${E * _}px`,
      `${E}px ${E}px`,
      `${E}px ${E}px`
    ].join(", "), L = `
        ${b} {
          background-size: ${A} !important;
          background-position: ${C}px ${w}px, ${C}px ${w}px, ${C}px ${w}px, ${C}px ${w}px !important;
          background-blend-mode: difference !important;
          background-image: linear-gradient(rgba(130, 130, 130, ${R}) 1px, transparent 1px),
           linear-gradient(90deg, rgba(130, 130, 130, ${R}) 1px, transparent 1px),
           linear-gradient(rgba(130, 130, 130, ${R / 2}) 1px, transparent 1px),
           linear-gradient(90deg, rgba(130, 130, 130, ${R / 2}) 1px, transparent 1px) !important;
        }
      `;
    u5(D, L);
  }, [_, E, b, D, f, C, w, R]), e();
}, "withBackgroundAndGrid");

// src/backgrounds/preview.ts
var dwe = globalThis.FEATURES?.backgrounds ? [f5] : [], pwe = {
  [Pi]: {
    grid: {
      cellSize: 20,
      opacity: 0.5,
      cellAmount: 5
    },
    disable: !1
  }
}, fwe = {
  [Pi]: { value: void 0, grid: !1 }
}, Yw = /* @__PURE__ */ o(() => ({
  decorators: dwe,
  parameters: pwe,
  initialGlobals: fwe
}), "default");

// src/highlight/constants.ts
var Iy = "storybook/highlight", m5 = `${Iy}/add`, h5 = `${Iy}/remove`, y5 = `${Iy}/reset`, b5 = `${Iy}/scroll-into-view`, Ww = 2147483647, mr = 28;

// src/highlight/icons.ts
var Kw = {
  chevronLeft: [
    "M9.10355 10.1464C9.29882 10.3417 9.29882 10.6583 9.10355 10.8536C8.90829 11.0488 8.59171 11.0488 8.39645 10.8536L4.89645 7.35355C4.7011\
8 7.15829 4.70118 6.84171 4.89645 6.64645L8.39645 3.14645C8.59171 2.95118 8.90829 2.95118 9.10355 3.14645C9.29882 3.34171 9.29882 3.65829 9.\
10355 3.85355L5.95711 7L9.10355 10.1464Z"
  ],
  chevronRight: [
    "M4.89645 10.1464C4.70118 10.3417 4.70118 10.6583 4.89645 10.8536C5.09171 11.0488 5.40829 11.0488 5.60355 10.8536L9.10355 7.35355C9.2988\
2 7.15829 9.29882 6.84171 9.10355 6.64645L5.60355 3.14645C5.40829 2.95118 5.09171 2.95118 4.89645 3.14645C4.70118 3.34171 4.70118 3.65829 4.\
89645 3.85355L8.04289 7L4.89645 10.1464Z"
  ],
  info: [
    "M7 5.5a.5.5 0 01.5.5v4a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zM7 4.5A.75.75 0 107 3a.75.75 0 000 1.5z",
    "M7 14A7 7 0 107 0a7 7 0 000 14zm0-1A6 6 0 107 1a6 6 0 000 12z"
  ],
  shareAlt: [
    "M2 1.004a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1v-4.5a.5.5 0 00-1 0v4.5H2v-10h4.5a.5.5 0 000-1H2z",
    "M7.354 7.357L12 2.711v1.793a.5.5 0 001 0v-3a.5.5 0 00-.5-.5h-3a.5.5 0 100 1h1.793L6.646 6.65a.5.5 0 10.708.707z"
  ]
};

// src/highlight/utils.ts
var mwe = "svg,path,rect,circle,line,polyline,polygon,ellipse,text".split(","), Ue = /* @__PURE__ */ o((e, t = {}, r) => {
  let n = mwe.includes(e) ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);
  return Object.entries(t).forEach(([i, s]) => {
    /[A-Z]/.test(i) ? (i === "onClick" && (n.addEventListener("click", s), n.addEventListener("keydown", (a) => {
      (a.key === "Enter" || a.key === " ") && (a.preventDefault(), s());
    })), i === "onMouseEnter" && n.addEventListener("mouseenter", s), i === "onMouseLeave" && n.addEventListener("mouseleave", s)) : n.setAttribute(
    i, s);
  }), r?.forEach((i) => {
    if (!(i == null || i === !1))
      try {
        n.appendChild(i);
      } catch {
        n.appendChild(document.createTextNode(String(i)));
      }
  }), n;
}, "createElement"), Fa = /* @__PURE__ */ o((e) => Kw[e] && Ue(
  "svg",
  { width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" },
  Kw[e].map(
    (t) => Ue("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: t
    })
  )
), "createIcon"), g5 = /* @__PURE__ */ o((e) => {
  if ("elements" in e) {
    let { elements: n, color: i, style: s } = e;
    return {
      id: void 0,
      priority: 0,
      selectors: n,
      styles: {
        outline: `2px ${s} ${i}`,
        outlineOffset: "2px",
        boxShadow: "0 0 0 6px rgba(255,255,255,0.6)"
      },
      menu: void 0
    };
  }
  let { menu: t, ...r } = e;
  return {
    id: void 0,
    priority: 0,
    styles: {
      outline: "2px dashed #029cfd"
    },
    ...r,
    menu: Array.isArray(t) ? t.every(Array.isArray) ? t : [t] : void 0
  };
}, "normalizeOptions"), hwe = /* @__PURE__ */ o((e) => e instanceof Function, "isFunction"), La = /* @__PURE__ */ new Map(), Qn = /* @__PURE__ */ new Map(),
My = /* @__PURE__ */ new Map(), hr = /* @__PURE__ */ o((e) => {
  let t = Symbol();
  return Qn.set(t, []), La.set(t, e), { get: /* @__PURE__ */ o(() => La.get(t), "get"), set: /* @__PURE__ */ o((a) => {
    let l = La.get(t), u = hwe(a) ? a(l) : a;
    u !== l && (La.set(t, u), Qn.get(t)?.forEach((c) => {
      My.get(c)?.(), My.set(c, c(u));
    }));
  }, "set"), subscribe: /* @__PURE__ */ o((a) => (Qn.get(t)?.push(a), () => {
    let l = Qn.get(t);
    l && Qn.set(
      t,
      l.filter((u) => u !== a)
    );
  }), "subscribe"), teardown: /* @__PURE__ */ o(() => {
    Qn.get(t)?.forEach((a) => {
      My.get(a)?.(), My.delete(a);
    }), Qn.delete(t), La.delete(t);
  }, "teardown") };
}, "useStore"), Xw = /* @__PURE__ */ o((e) => {
  let t = document.getElementById("storybook-root"), r = /* @__PURE__ */ new Map();
  for (let n of e) {
    let { priority: i = 0 } = n;
    for (let s of n.selectors) {
      let a = [
        ...document.querySelectorAll(
          // Elements matching the selector, excluding storybook elements and their descendants.
          // Necessary to find portaled elements (e.g. children of `body`).
          `:is(${s}):not([id^="storybook-"], [id^="storybook-"] *, [class^="sb-"], [class^="sb-"] *)`
        ),
        // Elements matching the selector inside the storybook root, as these were excluded above.
        ...t?.querySelectorAll(s) || []
      ];
      for (let l of a) {
        let u = r.get(l);
        (!u || u.priority <= i) && r.set(l, {
          ...n,
          priority: i,
          selectors: Array.from(new Set((u?.selectors || []).concat(s)))
        });
      }
    }
  }
  return r;
}, "mapElements"), v5 = /* @__PURE__ */ o((e) => Array.from(e.entries()).map(([t, { selectors: r, styles: n, hoverStyles: i, focusStyles: s,
menu: a }]) => {
  let { top: l, left: u, width: c, height: d } = t.getBoundingClientRect(), { position: p } = getComputedStyle(t);
  return {
    element: t,
    selectors: r,
    styles: n,
    hoverStyles: i,
    focusStyles: s,
    menu: a,
    top: p === "fixed" ? l : l + window.scrollY,
    left: p === "fixed" ? u : u + window.scrollX,
    width: c,
    height: d
  };
}).sort((t, r) => r.width * r.height - t.width * t.height), "mapBoxes"), Jw = /* @__PURE__ */ o((e, t) => {
  let r = e.getBoundingClientRect(), { x: n, y: i } = t;
  return r?.top && r?.left && n >= r.left && n <= r.left + r.width && i >= r.top && i <= r.top + r.height;
}, "isOverMenu"), Zw = /* @__PURE__ */ o((e, t, r) => {
  if (!t || !r)
    return !1;
  let { left: n, top: i, width: s, height: a } = e;
  a < mr && (i = i - Math.round((mr - a) / 2), a = mr), s < mr && (n = n - Math.round((mr - s) / 2), s = mr), t.style.position === "fixed" &&
  (n += window.scrollX, i += window.scrollY);
  let { x: l, y: u } = r;
  return l >= n && l <= n + s && u >= i && u <= i + a;
}, "isTargeted"), E5 = /* @__PURE__ */ o((e, t, r = {}) => {
  let { x: n, y: i } = t, { margin: s = 5, topOffset: a = 0, centered: l = !1 } = r, { scrollX: u, scrollY: c, innerHeight: d, innerWidth: p } = window,
  y = Math.min(
    e.style.position === "fixed" ? i - c : i,
    d - e.clientHeight - s - a + c
  ), f = l ? e.clientWidth / 2 : 0, m = e.style.position === "fixed" ? Math.max(Math.min(n - u, p - f - s), f + s) : Math.max(
    Math.min(n, p - f - s + u),
    f + s + u
  );
  Object.assign(e.style, {
    ...m !== n && { left: `${m}px` },
    ...y !== i && { top: `${y}px` }
  });
}, "keepInViewport"), Qw = /* @__PURE__ */ o((e) => {
  window.HTMLElement.prototype.hasOwnProperty("showPopover") && e.showPopover();
}, "showPopover"), T5 = /* @__PURE__ */ o((e) => {
  window.HTMLElement.prototype.hasOwnProperty("showPopover") && e.hidePopover();
}, "hidePopover"), _5 = /* @__PURE__ */ o((e) => ({
  top: e.top,
  left: e.left,
  width: e.width,
  height: e.height,
  selectors: e.selectors,
  element: {
    attributes: Object.fromEntries(
      Array.from(e.element.attributes).map((t) => [t.name, t.value])
    ),
    localName: e.element.localName,
    tagName: e.element.tagName,
    outerHTML: e.element.outerHTML
  }
}), "getEventDetails");

// src/highlight/useHighlights.ts
var Ie = "storybook-highlights-menu", R5 = "storybook-highlights-root", ywe = "storybook-root", w5 = /* @__PURE__ */ o((e) => {
  if (globalThis.__STORYBOOK_HIGHLIGHT_INITIALIZED)
    return;
  globalThis.__STORYBOOK_HIGHLIGHT_INITIALIZED = !0;
  let { document: t } = globalThis, r = hr([]), n = hr(/* @__PURE__ */ new Map()), i = hr([]), s = hr(), a = hr(), l = hr([]), u = hr([]), c = hr(),
  d = hr(), p = t.getElementById(R5);
  r.subscribe(() => {
    p || (p = Ue("div", { id: R5 }), t.body.appendChild(p));
  }), r.subscribe((w) => {
    let P = t.getElementById(ywe);
    if (!P)
      return;
    n.set(Xw(w));
    let O = new MutationObserver(() => n.set(Xw(w)));
    return O.observe(P, { subtree: !0, childList: !0 }), () => {
      O.disconnect();
    };
  }), n.subscribe((w) => {
    let P = /* @__PURE__ */ o(() => requestAnimationFrame(() => i.set(v5(w))), "updateBoxes"), O = new ResizeObserver(P);
    O.observe(t.body), Array.from(w.keys()).forEach((A) => O.observe(A));
    let D = Array.from(t.body.querySelectorAll("*")).filter((A) => {
      let { overflow: L, overflowX: B, overflowY: N } = window.getComputedStyle(A);
      return ["auto", "scroll"].some(($) => [L, B, N].includes($));
    });
    return D.forEach((A) => A.addEventListener("scroll", P)), () => {
      O.disconnect(), D.forEach((A) => A.removeEventListener("scroll", P));
    };
  }), n.subscribe((w) => {
    let P = Array.from(w.keys()).filter(({ style: D }) => D.position === "sticky"), O = /* @__PURE__ */ o(() => requestAnimationFrame(() => {
      i.set(
        (D) => D.map((A) => {
          if (P.includes(A.element)) {
            let { top: L, left: B } = A.element.getBoundingClientRect();
            return { ...A, top: L + window.scrollY, left: B + window.scrollX };
          }
          return A;
        })
      );
    }), "updateBoxes");
    return t.addEventListener("scroll", O), () => t.removeEventListener("scroll", O);
  }), n.subscribe((w) => {
    l.set((P) => P.filter(({ element: O }) => w.has(O)));
  }), l.subscribe((w) => {
    w.length ? (d.set((P) => w.some((O) => O.element === P?.element) ? P : void 0), c.set((P) => w.some((O) => O.element === P?.element) ? P :
    void 0)) : (d.set(void 0), c.set(void 0), s.set(void 0));
  });
  let y = new Map(/* @__PURE__ */ new Map());
  r.subscribe((w) => {
    w.forEach(({ keyframes: P }) => {
      if (P) {
        let O = y.get(P);
        O || (O = t.createElement("style"), O.setAttribute("data-highlight", "keyframes"), y.set(P, O), t.head.appendChild(O)), O.innerHTML =
        P;
      }
    }), y.forEach((P, O) => {
      w.some((D) => D.keyframes === O) || (P.remove(), y.delete(O));
    });
  });
  let f = new Map(/* @__PURE__ */ new Map());
  i.subscribe((w) => {
    w.forEach((P) => {
      let O = f.get(P.element);
      if (p && !O) {
        let D = {
          popover: "manual",
          "data-highlight-dimensions": `w${P.width.toFixed(0)}h${P.height.toFixed(0)}`,
          "data-highlight-coordinates": `x${P.left.toFixed(0)}y${P.top.toFixed(0)}`
        };
        O = p.appendChild(
          Ue("div", D, [Ue("div")])
        ), f.set(P.element, O);
      }
    }), f.forEach((P, O) => {
      w.some(({ element: D }) => D === O) || (P.remove(), f.delete(O));
    });
  }), i.subscribe((w) => {
    let P = w.filter((D) => D.menu);
    if (!P.length)
      return;
    let O = /* @__PURE__ */ o((D) => {
      requestAnimationFrame(() => {
        let A = t.getElementById(Ie), L = { x: D.pageX, y: D.pageY };
        if (A && !Jw(A, L)) {
          let B = P.filter((N) => {
            let $ = f.get(N.element);
            return Zw(N, $, L);
          });
          s.set(B.length ? L : void 0), l.set(B);
        }
      });
    }, "onClick");
    return t.addEventListener("click", O), () => t.removeEventListener("click", O);
  });
  let m = /* @__PURE__ */ o(() => {
    let w = t.getElementById(Ie), P = a.get();
    !P || w && Jw(w, P) || u.set((O) => {
      let D = i.get().filter((N) => {
        let $ = f.get(N.element);
        return Zw(N, $, P);
      }), A = O.filter((N) => D.includes(N)), L = D.filter((N) => !O.includes(N)), B = O.length - A.length;
      return L.length || B ? [...A, ...L] : O;
    });
  }, "updateHovered");
  a.subscribe(m), i.subscribe(m);
  let h = /* @__PURE__ */ o(() => {
    let w = d.get(), P = w ? [w] : l.get(), O = P.length === 1 ? P[0] : c.get(), D = s.get() !== void 0;
    i.get().forEach((A) => {
      let L = f.get(A.element);
      if (L) {
        let B = O === A, N = D ? O ? B : P.includes(A) : u.get()?.includes(A);
        Object.assign(L.style, {
          animation: "none",
          background: "transparent",
          border: "none",
          boxSizing: "border-box",
          outline: "none",
          outlineOffset: "0px",
          ...A.styles,
          ...N ? A.hoverStyles : {},
          ...B ? A.focusStyles : {},
          position: getComputedStyle(A.element).position === "fixed" ? "fixed" : "absolute",
          zIndex: Ww - 10,
          top: `${A.top}px`,
          left: `${A.left}px`,
          width: `${A.width}px`,
          height: `${A.height}px`,
          margin: 0,
          padding: 0,
          cursor: A.menu && N ? "pointer" : "default",
          pointerEvents: A.menu ? "auto" : "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "visible"
        }), Object.assign(L.children[0].style, {
          width: "100%",
          height: "100%",
          minHeight: `${mr}px`,
          minWidth: `${mr}px`,
          boxSizing: "content-box",
          padding: L.style.outlineWidth || "0px"
        }), Qw(L);
      }
    });
  }, "updateBoxStyles");
  i.subscribe(h), l.subscribe(h), u.subscribe(h), c.subscribe(h), d.subscribe(h);
  let b = /* @__PURE__ */ o(() => {
    if (!p)
      return;
    let w = t.getElementById(Ie);
    if (w)
      w.innerHTML = "";
    else {
      let A = { id: Ie, popover: "manual" };
      w = p.appendChild(Ue("div", A)), p.appendChild(
        Ue("style", {}, [
          `
            #${Ie} {
              position: absolute;
              z-index: ${Ww};
              width: 300px;
              padding: 0px;
              margin: 15px 0 0 0;
              transform: translateX(-50%);
              font-family: "Nunito Sans", -apple-system, ".SFNSText-Regular", "San Francisco", BlinkMacSystemFont, "Segoe UI", "Helvetica Ne\
ue", Helvetica, Arial, sans-serif;
              font-size: 12px;
              background: white;
              border: none;
              border-radius: 6px;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.1);
              color: #2E3438;
            }
            #${Ie} ul {
              list-style: none;
              margin: 0;
              padding: 0;
            }
            #${Ie} > ul {
              max-height: 300px;
              overflow-y: auto;
              padding: 4px 0;
            }
            #${Ie} li {
              padding: 0 4px;
              margin: 0;
            }
            #${Ie} li > :not(ul) {
              display: flex;
              padding: 8px;
              margin: 0;
              align-items: center;
              gap: 8px;
              border-radius: 4px;
            }
            #${Ie} button {
              width: 100%;
              border: 0;
              background: transparent;
              color: inherit;
              text-align: left;
              font-family: inherit;
              font-size: inherit;
            }
            #${Ie} button:focus-visible {
              outline-color: #029CFD;
            }
            #${Ie} button:hover {
              background: rgba(2, 156, 253, 0.07);
              color: #029CFD;
              cursor: pointer;
            }
            #${Ie} li code {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 16px;
              font-size: 11px;
            }
            #${Ie} li svg {
              flex-shrink: 0;
              margin: 1px;
              color: #73828C;
            }
            #${Ie} li > button:hover svg, #${Ie} li > button:focus-visible svg {
              color: #029CFD;
            }
            #${Ie} .element-list li svg {
              display: none;
            }
            #${Ie} li.selectable svg, #${Ie} li.selected svg {
              display: block;
            }
            #${Ie} .menu-list {
              border-top: 1px solid rgba(38, 85, 115, 0.15);
            }
            #${Ie} .menu-list > li:not(:last-child) {
              padding-bottom: 4px;
              margin-bottom: 4px;
              border-bottom: 1px solid rgba(38, 85, 115, 0.15);
            }
            #${Ie} .menu-items, #${Ie} .menu-items li {
              padding: 0;
            }
            #${Ie} .menu-item {
              display: flex;
            }
            #${Ie} .menu-item-content {
              display: flex;
              flex-direction: column;
              flex-grow: 1;
            }
          `
        ])
      );
    }
    let P = d.get(), O = P ? [P] : l.get();
    if (O.length && (w.style.position = getComputedStyle(O[0].element).position === "fixed" ? "fixed" : "absolute", w.appendChild(
      Ue(
        "ul",
        { class: "element-list" },
        O.map((A) => {
          let L = O.length > 1 && !!A.menu?.some(
            ($) => $.some(
              (M) => !M.selectors || M.selectors.some((V) => A.selectors.includes(V))
            )
          ), B = L ? {
            class: "selectable",
            onClick: /* @__PURE__ */ o(() => d.set(A), "onClick"),
            onMouseEnter: /* @__PURE__ */ o(() => c.set(A), "onMouseEnter"),
            onMouseLeave: /* @__PURE__ */ o(() => c.set(void 0), "onMouseLeave")
          } : P ? { class: "selected", onClick: /* @__PURE__ */ o(() => d.set(void 0), "onClick") } : {}, N = L || P;
          return Ue("li", B, [
            Ue(N ? "button" : "div", N ? { type: "button" } : {}, [
              P ? Fa("chevronLeft") : null,
              Ue("code", {}, [A.element.outerHTML]),
              L ? Fa("chevronRight") : null
            ])
          ]);
        })
      )
    )), d.get() || l.get().length === 1) {
      let A = d.get() || l.get()[0], L = A.menu?.filter(
        (B) => B.some(
          (N) => !N.selectors || N.selectors.some(($) => A.selectors.includes($))
        )
      );
      L?.length && w.appendChild(
        Ue(
          "ul",
          { class: "menu-list" },
          L.map(
            (B) => Ue("li", {}, [
              Ue(
                "ul",
                { class: "menu-items" },
                B.map(
                  ({ id: N, title: $, description: M, iconLeft: V, iconRight: G, clickEvent: Q }) => {
                    let te = Q && (() => e.emit(Q, N, _5(A)));
                    return Ue("li", {}, [
                      Ue(
                        te ? "button" : "div",
                        te ? { class: "menu-item", type: "button", onClick: te } : { class: "menu-item" },
                        [
                          V ? Fa(V) : null,
                          Ue("div", { class: "menu-item-content" }, [
                            Ue(M ? "strong" : "span", {}, [$]),
                            M && Ue("span", {}, [M])
                          ]),
                          G ? Fa(G) : null
                        ]
                      )
                    ]);
                  }
                )
              )
            ])
          )
        )
      );
    }
    let D = s.get();
    D ? (Object.assign(w.style, {
      display: "block",
      left: `${w.style.position === "fixed" ? D.x - window.scrollX : D.x}px`,
      top: `${w.style.position === "fixed" ? D.y - window.scrollY : D.y}px`
    }), Qw(w), requestAnimationFrame(() => E5(w, D, { topOffset: 15, centered: !0 }))) : (T5(w), Object.assign(w.style, { display: "none" }));
  }, "renderMenu");
  l.subscribe(b), d.subscribe(b);
  let g = /* @__PURE__ */ o((w) => {
    let P = g5(w);
    r.set((O) => {
      let D = P.id ? O.filter((A) => A.id !== P.id) : O;
      return P.selectors?.length ? [...D, P] : D;
    });
  }, "addHighlight"), T = /* @__PURE__ */ o((w) => {
    w && r.set((P) => P.filter((O) => O.id !== w));
  }, "removeHighlight"), _ = /* @__PURE__ */ o(() => {
    r.set([]), n.set(/* @__PURE__ */ new Map()), i.set([]), s.set(void 0), a.set(void 0), l.set([]), u.set([]), c.set(void 0), d.set(void 0);
  }, "resetState"), E, R = /* @__PURE__ */ o((w, P) => {
    let O = "scrollIntoView-highlight";
    clearTimeout(E), T(O);
    let D = t.querySelector(w);
    if (!D) {
      console.warn(`Cannot scroll into view: ${w} not found`);
      return;
    }
    D.scrollIntoView({ behavior: "smooth", block: "center", ...P });
    let A = `kf-${Math.random().toString(36).substring(2, 15)}`;
    r.set((L) => [
      ...L,
      {
        id: O,
        priority: 1e3,
        selectors: [w],
        styles: {
          outline: "2px solid #1EA7FD",
          outlineOffset: "-1px",
          animation: `${A} 3s linear forwards`
        },
        keyframes: `@keyframes ${A} {
          0% { outline: 2px solid #1EA7FD; }
          20% { outline: 2px solid #1EA7FD00; }
          40% { outline: 2px solid #1EA7FD; }
          60% { outline: 2px solid #1EA7FD00; }
          80% { outline: 2px solid #1EA7FD; }
          100% { outline: 2px solid #1EA7FD00; }
        }`
      }
    ]), E = setTimeout(() => T(O), 3500);
  }, "scrollIntoView"), C = /* @__PURE__ */ o((w) => {
    requestAnimationFrame(() => a.set({ x: w.pageX, y: w.pageY }));
  }, "onMouseMove");
  t.body.addEventListener("mousemove", C), e.on(m5, g), e.on(h5, T), e.on(y5, _), e.on(b5, R), e.on(Ut, ({ newPhase: w }) => {
    w === "loading" && _();
  });
}, "useHighlights");

// src/highlight/preview.ts
globalThis?.FEATURES?.highlight && Ye?.ready && Ye.ready().then(w5);
var eS = /* @__PURE__ */ o(() => ({}), "default");

// src/measure/constants.ts
var Ny = "storybook/measure-addon", e6e = `${Ny}/tool`, S5 = "measureEnabled", t6e = {
  RESULT: `${Ny}/result`,
  REQUEST: `${Ny}/request`,
  CLEAR: `${Ny}/clear`
};

// src/measure/box-model/canvas.ts
function x5() {
  let e = k.document.documentElement, t = Math.max(e.scrollHeight, e.offsetHeight);
  return { width: Math.max(e.scrollWidth, e.offsetWidth), height: t };
}
o(x5, "getDocumentWidthAndHeight");
function bwe() {
  let e = k.document.createElement("canvas");
  e.id = "storybook-addon-measure";
  let t = e.getContext("2d");
  wt(t != null);
  let { width: r, height: n } = x5();
  return tS(e, t, { width: r, height: n }), e.style.position = "absolute", e.style.left = "0", e.style.top = "0", e.style.zIndex = "21474836\
47", e.style.pointerEvents = "none", k.document.body.appendChild(e), { canvas: e, context: t, width: r, height: n };
}
o(bwe, "createCanvas");
function tS(e, t, { width: r, height: n }) {
  e.style.width = `${r}px`, e.style.height = `${n}px`;
  let i = k.window.devicePixelRatio;
  e.width = Math.floor(r * i), e.height = Math.floor(n * i), t.scale(i, i);
}
o(tS, "setCanvasWidthAndHeight");
var Ge = {};
function C5() {
  Ge.canvas || (Ge = bwe());
}
o(C5, "init");
function P5() {
  Ge.context && Ge.context.clearRect(0, 0, Ge.width ?? 0, Ge.height ?? 0);
}
o(P5, "clear");
function A5(e) {
  P5(), e(Ge.context);
}
o(A5, "draw");
function O5() {
  wt(Ge.canvas, "Canvas should exist in the state."), wt(Ge.context, "Context should exist in the state."), tS(Ge.canvas, Ge.context, { width: 0,
  height: 0 });
  let { width: e, height: t } = x5();
  tS(Ge.canvas, Ge.context, { width: e, height: t }), Ge.width = e, Ge.height = t;
}
o(O5, "rescale");
function q5() {
  Ge.canvas && (P5(), Ge.canvas.parentNode?.removeChild(Ge.canvas), Ge = {});
}
o(q5, "destroy");

// src/measure/box-model/labels.ts
var Ai = {
  margin: "#f6b26b",
  border: "#ffe599",
  padding: "#93c47d",
  content: "#6fa8dc",
  text: "#232020"
}, Ir = 6;
function I5(e, { x: t, y: r, w: n, h: i, r: s }) {
  t = t - n / 2, r = r - i / 2, n < 2 * s && (s = n / 2), i < 2 * s && (s = i / 2), e.beginPath(), e.moveTo(t + s, r), e.arcTo(t + n, r, t +
  n, r + i, s), e.arcTo(t + n, r + i, t, r + i, s), e.arcTo(t, r + i, t, r, s), e.arcTo(t, r, t + n, r, s), e.closePath();
}
o(I5, "roundedRect");
function gwe(e, { padding: t, border: r, width: n, height: i, top: s, left: a }) {
  let l = n - r.left - r.right - t.left - t.right, u = i - t.top - t.bottom - r.top - r.bottom, c = a + r.left + t.left, d = s + r.top + t.top;
  return e === "top" ? c += l / 2 : e === "right" ? (c += l, d += u / 2) : e === "bottom" ? (c += l / 2, d += u) : e === "left" ? d += u / 2 :
  e === "center" && (c += l / 2, d += u / 2), { x: c, y: d };
}
o(gwe, "positionCoordinate");
function vwe(e, t, { margin: r, border: n, padding: i }, s, a) {
  let l = /* @__PURE__ */ o((y) => 0, "shift"), u = 0, c = 0, d = a ? 1 : 0.5, p = a ? s * 2 : 0;
  return e === "padding" ? l = /* @__PURE__ */ o((y) => i[y] * d + p, "shift") : e === "border" ? l = /* @__PURE__ */ o((y) => i[y] + n[y] *
  d + p, "shift") : e === "margin" && (l = /* @__PURE__ */ o((y) => i[y] + n[y] + r[y] * d + p, "shift")), t === "top" ? c = -l("top") : t ===
  "right" ? u = l("right") : t === "bottom" ? c = l("bottom") : t === "left" && (u = -l("left")), { offsetX: u, offsetY: c };
}
o(vwe, "offset");
function Ewe(e, t) {
  return Math.abs(e.x - t.x) < Math.abs(e.w + t.w) / 2 && Math.abs(e.y - t.y) < Math.abs(e.h + t.h) / 2;
}
o(Ewe, "collide");
function Twe(e, t, r) {
  return e === "top" ? t.y = r.y - r.h - Ir : e === "right" ? t.x = r.x + r.w / 2 + Ir + t.w / 2 : e === "bottom" ? t.y = r.y + r.h + Ir : e ===
  "left" && (t.x = r.x - r.w / 2 - Ir - t.w / 2), { x: t.x, y: t.y };
}
o(Twe, "overlapAdjustment");
function M5(e, t, { x: r, y: n, w: i, h: s }, a) {
  return I5(e, { x: r, y: n, w: i, h: s, r: 3 }), e.fillStyle = `${Ai[t]}dd`, e.fill(), e.strokeStyle = Ai[t], e.stroke(), e.fillStyle = Ai.
  text, e.fillText(a, r, n), I5(e, { x: r, y: n, w: i, h: s, r: 3 }), e.fillStyle = `${Ai[t]}dd`, e.fill(), e.strokeStyle = Ai[t], e.stroke(),
  e.fillStyle = Ai.text, e.fillText(a, r, n), { x: r, y: n, w: i, h: s };
}
o(M5, "textWithRect");
function N5(e, t) {
  e.font = "600 12px monospace", e.textBaseline = "middle", e.textAlign = "center";
  let r = e.measureText(t), n = r.actualBoundingBoxAscent + r.actualBoundingBoxDescent, i = r.width + Ir * 2, s = n + Ir * 2;
  return { w: i, h: s };
}
o(N5, "configureText");
function _we(e, t, { type: r, position: n = "center", text: i }, s, a = !1) {
  let { x: l, y: u } = gwe(n, t), { offsetX: c, offsetY: d } = vwe(r, n, t, Ir + 1, a);
  l += c, u += d;
  let { w: p, h: y } = N5(e, i);
  if (s && Ewe({ x: l, y: u, w: p, h: y }, s)) {
    let f = Twe(n, { x: l, y: u, w: p, h: y }, s);
    l = f.x, u = f.y;
  }
  return M5(e, r, { x: l, y: u, w: p, h: y }, i);
}
o(_we, "drawLabel");
function Rwe(e, { w: t, h: r }) {
  let n = t * 0.5 + Ir, i = r * 0.5 + Ir;
  return {
    offsetX: (e.x === "left" ? -1 : 1) * n,
    offsetY: (e.y === "top" ? -1 : 1) * i
  };
}
o(Rwe, "floatingOffset");
function wwe(e, t, { type: r, text: n }) {
  let { floatingAlignment: i, extremities: s } = t, a = s[i.x], l = s[i.y], { w: u, h: c } = N5(e, n), { offsetX: d, offsetY: p } = Rwe(i, {
    w: u,
    h: c
  });
  return a += d, l += p, M5(e, r, { x: a, y: l, w: u, h: c }, n);
}
o(wwe, "drawFloatingLabel");
function ka(e, t, r, n) {
  let i = [];
  r.forEach((s, a) => {
    let l = n && s.position === "center" ? wwe(e, t, s) : _we(e, t, s, i[a - 1], n);
    i[a] = l;
  });
}
o(ka, "drawStack");
function j5(e, t, r, n) {
  let i = r.reduce((s, a) => (Object.prototype.hasOwnProperty.call(s, a.position) || (s[a.position] = []), s[a.position]?.push(a), s), {});
  i.top && ka(e, t, i.top, n), i.right && ka(e, t, i.right, n), i.bottom && ka(e, t, i.bottom, n), i.left && ka(e, t, i.left, n), i.center &&
  ka(e, t, i.center, n);
}
o(j5, "labelStacks");

// src/measure/box-model/visualizer.ts
var jy = {
  margin: "#f6b26ba8",
  border: "#ffe599a8",
  padding: "#93c47d8c",
  content: "#6fa8dca8"
}, L5 = 30;
function Bt(e) {
  return parseInt(e.replace("px", ""), 10);
}
o(Bt, "pxToNumber");
function Oi(e) {
  return Number.isInteger(e) ? e : e.toFixed(2);
}
o(Oi, "round");
function rS(e) {
  return e.filter((t) => t.text !== 0 && t.text !== "0");
}
o(rS, "filterZeroValues");
function Swe(e) {
  let t = {
    top: k.window.scrollY,
    bottom: k.window.scrollY + k.window.innerHeight,
    left: k.window.scrollX,
    right: k.window.scrollX + k.window.innerWidth
  }, r = {
    top: Math.abs(t.top - e.top),
    bottom: Math.abs(t.bottom - e.bottom),
    left: Math.abs(t.left - e.left),
    right: Math.abs(t.right - e.right)
  };
  return {
    x: r.left > r.right ? "left" : "right",
    y: r.top > r.bottom ? "top" : "bottom"
  };
}
o(Swe, "floatingAlignment");
function xwe(e) {
  let t = k.getComputedStyle(e), { top: r, left: n, right: i, bottom: s, width: a, height: l } = e.getBoundingClientRect(), {
    marginTop: u,
    marginBottom: c,
    marginLeft: d,
    marginRight: p,
    paddingTop: y,
    paddingBottom: f,
    paddingLeft: m,
    paddingRight: h,
    borderBottomWidth: b,
    borderTopWidth: g,
    borderLeftWidth: T,
    borderRightWidth: _
  } = t;
  r = r + k.window.scrollY, n = n + k.window.scrollX, s = s + k.window.scrollY, i = i + k.window.scrollX;
  let E = {
    top: Bt(u),
    bottom: Bt(c),
    left: Bt(d),
    right: Bt(p)
  }, R = {
    top: Bt(y),
    bottom: Bt(f),
    left: Bt(m),
    right: Bt(h)
  }, C = {
    top: Bt(g),
    bottom: Bt(b),
    left: Bt(T),
    right: Bt(_)
  }, w = {
    top: r - E.top,
    bottom: s + E.bottom,
    left: n - E.left,
    right: i + E.right
  };
  return {
    margin: E,
    padding: R,
    border: C,
    top: r,
    left: n,
    bottom: s,
    right: i,
    width: a,
    height: l,
    extremities: w,
    floatingAlignment: Swe(w)
  };
}
o(xwe, "measureElement");
function Cwe(e, { margin: t, width: r, height: n, top: i, left: s, bottom: a, right: l }) {
  let u = n + t.bottom + t.top;
  e.fillStyle = jy.margin, e.fillRect(s, i - t.top, r, t.top), e.fillRect(l, i - t.top, t.right, u), e.fillRect(s, a, r, t.bottom), e.fillRect(
  s - t.left, i - t.top, t.left, u);
  let c = [
    {
      type: "margin",
      text: Oi(t.top),
      position: "top"
    },
    {
      type: "margin",
      text: Oi(t.right),
      position: "right"
    },
    {
      type: "margin",
      text: Oi(t.bottom),
      position: "bottom"
    },
    {
      type: "margin",
      text: Oi(t.left),
      position: "left"
    }
  ];
  return rS(c);
}
o(Cwe, "drawMargin");
function Pwe(e, { padding: t, border: r, width: n, height: i, top: s, left: a, bottom: l, right: u }) {
  let c = n - r.left - r.right, d = i - t.top - t.bottom - r.top - r.bottom;
  e.fillStyle = jy.padding, e.fillRect(a + r.left, s + r.top, c, t.top), e.fillRect(
    u - t.right - r.right,
    s + t.top + r.top,
    t.right,
    d
  ), e.fillRect(
    a + r.left,
    l - t.bottom - r.bottom,
    c,
    t.bottom
  ), e.fillRect(a + r.left, s + t.top + r.top, t.left, d);
  let p = [
    {
      type: "padding",
      text: t.top,
      position: "top"
    },
    {
      type: "padding",
      text: t.right,
      position: "right"
    },
    {
      type: "padding",
      text: t.bottom,
      position: "bottom"
    },
    {
      type: "padding",
      text: t.left,
      position: "left"
    }
  ];
  return rS(p);
}
o(Pwe, "drawPadding");
function Awe(e, { border: t, width: r, height: n, top: i, left: s, bottom: a, right: l }) {
  let u = n - t.top - t.bottom;
  e.fillStyle = jy.border, e.fillRect(s, i, r, t.top), e.fillRect(s, a - t.bottom, r, t.bottom), e.fillRect(s, i + t.top, t.left, u), e.fillRect(
  l - t.right, i + t.top, t.right, u);
  let c = [
    {
      type: "border",
      text: t.top,
      position: "top"
    },
    {
      type: "border",
      text: t.right,
      position: "right"
    },
    {
      type: "border",
      text: t.bottom,
      position: "bottom"
    },
    {
      type: "border",
      text: t.left,
      position: "left"
    }
  ];
  return rS(c);
}
o(Awe, "drawBorder");
function Owe(e, { padding: t, border: r, width: n, height: i, top: s, left: a }) {
  let l = n - r.left - r.right - t.left - t.right, u = i - t.top - t.bottom - r.top - r.bottom;
  return e.fillStyle = jy.content, e.fillRect(
    a + r.left + t.left,
    s + r.top + t.top,
    l,
    u
  ), [
    {
      type: "content",
      position: "center",
      text: `${Oi(l)} x ${Oi(u)}`
    }
  ];
}
o(Owe, "drawContent");
function qwe(e) {
  return (t) => {
    if (e && t) {
      let r = xwe(e), n = Cwe(t, r), i = Pwe(t, r), s = Awe(t, r), a = Owe(t, r), l = r.width <= L5 * 3 || r.height <= L5;
      j5(
        t,
        r,
        [...a, ...i, ...s, ...n],
        l
      );
    }
  };
}
o(qwe, "drawBoxModel");
function F5(e) {
  A5(qwe(e));
}
o(F5, "drawSelectedElement");

// src/measure/util.ts
var k5 = /* @__PURE__ */ o((e, t) => {
  let r = k.document.elementFromPoint(e, t), n = /* @__PURE__ */ o((s) => {
    if (s && s.shadowRoot) {
      let a = s.shadowRoot.elementFromPoint(e, t);
      return s.isEqualNode(a) ? s : a.shadowRoot ? n(a) : a;
    }
    return s;
  }, "crawlShadows");
  return n(r) || r;
}, "deepElementFromPoint");

// src/measure/withMeasure.ts
var D5, Ly = { x: 0, y: 0 };
function $5(e, t) {
  D5 = k5(e, t), F5(D5);
}
o($5, "findAndDrawElement");
var B5 = /* @__PURE__ */ o((e, t) => {
  let { measureEnabled: r } = t.globals || {};
  return Ht(() => {
    if (typeof globalThis.document > "u")
      return;
    let n = /* @__PURE__ */ o((i) => {
      window.requestAnimationFrame(() => {
        i.stopPropagation(), Ly.x = i.clientX, Ly.y = i.clientY;
      });
    }, "onPointerMove");
    return globalThis.document.addEventListener("pointermove", n), () => {
      globalThis.document.removeEventListener("pointermove", n);
    };
  }, []), Ht(() => {
    let n = /* @__PURE__ */ o((s) => {
      window.requestAnimationFrame(() => {
        s.stopPropagation(), $5(s.clientX, s.clientY);
      });
    }, "onPointerOver"), i = /* @__PURE__ */ o(() => {
      window.requestAnimationFrame(() => {
        O5();
      });
    }, "onResize");
    return t.viewMode === "story" && r && (globalThis.document.addEventListener("pointerover", n), C5(), globalThis.window.addEventListener(
    "resize", i), $5(Ly.x, Ly.y)), () => {
      globalThis.window.removeEventListener("resize", i), q5();
    };
  }, [r, t.viewMode]), e();
}, "withMeasure");

// src/measure/preview.ts
var Iwe = globalThis.FEATURES?.measure ? [B5] : [], Mwe = {
  [S5]: !1
}, nS = /* @__PURE__ */ o(() => ({
  decorators: Iwe,
  initialGlobals: Mwe
}), "default");

// src/outline/constants.ts
var Fy = "outline";

// src/outline/helpers.ts
var oS = /* @__PURE__ */ o((e) => {
  (Array.isArray(e) ? e : [e]).forEach(Nwe);
}, "clearStyles"), Nwe = /* @__PURE__ */ o((e) => {
  let t = typeof e == "string" ? e : e.join(""), r = k.document.getElementById(t);
  r && r.parentElement && r.parentElement.removeChild(r);
}, "clearStyle"), U5 = /* @__PURE__ */ o((e, t) => {
  let r = k.document.getElementById(e);
  if (r)
    r.innerHTML !== t && (r.innerHTML = t);
  else {
    let n = k.document.createElement("style");
    n.setAttribute("id", e), n.innerHTML = t, k.document.head.appendChild(n);
  }
}, "addOutlineStyles");

// src/outline/outlineCSS.ts
function iS(e) {
  return ee`
    ${e} body {
      outline: 1px solid #2980b9 !important;
    }

    ${e} article {
      outline: 1px solid #3498db !important;
    }

    ${e} nav {
      outline: 1px solid #0088c3 !important;
    }

    ${e} aside {
      outline: 1px solid #33a0ce !important;
    }

    ${e} section {
      outline: 1px solid #66b8da !important;
    }

    ${e} header {
      outline: 1px solid #99cfe7 !important;
    }

    ${e} footer {
      outline: 1px solid #cce7f3 !important;
    }

    ${e} h1 {
      outline: 1px solid #162544 !important;
    }

    ${e} h2 {
      outline: 1px solid #314e6e !important;
    }

    ${e} h3 {
      outline: 1px solid #3e5e85 !important;
    }

    ${e} h4 {
      outline: 1px solid #449baf !important;
    }

    ${e} h5 {
      outline: 1px solid #c7d1cb !important;
    }

    ${e} h6 {
      outline: 1px solid #4371d0 !important;
    }

    ${e} main {
      outline: 1px solid #2f4f90 !important;
    }

    ${e} address {
      outline: 1px solid #1a2c51 !important;
    }

    ${e} div {
      outline: 1px solid #036cdb !important;
    }

    ${e} p {
      outline: 1px solid #ac050b !important;
    }

    ${e} hr {
      outline: 1px solid #ff063f !important;
    }

    ${e} pre {
      outline: 1px solid #850440 !important;
    }

    ${e} blockquote {
      outline: 1px solid #f1b8e7 !important;
    }

    ${e} ol {
      outline: 1px solid #ff050c !important;
    }

    ${e} ul {
      outline: 1px solid #d90416 !important;
    }

    ${e} li {
      outline: 1px solid #d90416 !important;
    }

    ${e} dl {
      outline: 1px solid #fd3427 !important;
    }

    ${e} dt {
      outline: 1px solid #ff0043 !important;
    }

    ${e} dd {
      outline: 1px solid #e80174 !important;
    }

    ${e} figure {
      outline: 1px solid #ff00bb !important;
    }

    ${e} figcaption {
      outline: 1px solid #bf0032 !important;
    }

    ${e} table {
      outline: 1px solid #00cc99 !important;
    }

    ${e} caption {
      outline: 1px solid #37ffc4 !important;
    }

    ${e} thead {
      outline: 1px solid #98daca !important;
    }

    ${e} tbody {
      outline: 1px solid #64a7a0 !important;
    }

    ${e} tfoot {
      outline: 1px solid #22746b !important;
    }

    ${e} tr {
      outline: 1px solid #86c0b2 !important;
    }

    ${e} th {
      outline: 1px solid #a1e7d6 !important;
    }

    ${e} td {
      outline: 1px solid #3f5a54 !important;
    }

    ${e} col {
      outline: 1px solid #6c9a8f !important;
    }

    ${e} colgroup {
      outline: 1px solid #6c9a9d !important;
    }

    ${e} button {
      outline: 1px solid #da8301 !important;
    }

    ${e} datalist {
      outline: 1px solid #c06000 !important;
    }

    ${e} fieldset {
      outline: 1px solid #d95100 !important;
    }

    ${e} form {
      outline: 1px solid #d23600 !important;
    }

    ${e} input {
      outline: 1px solid #fca600 !important;
    }

    ${e} keygen {
      outline: 1px solid #b31e00 !important;
    }

    ${e} label {
      outline: 1px solid #ee8900 !important;
    }

    ${e} legend {
      outline: 1px solid #de6d00 !important;
    }

    ${e} meter {
      outline: 1px solid #e8630c !important;
    }

    ${e} optgroup {
      outline: 1px solid #b33600 !important;
    }

    ${e} option {
      outline: 1px solid #ff8a00 !important;
    }

    ${e} output {
      outline: 1px solid #ff9619 !important;
    }

    ${e} progress {
      outline: 1px solid #e57c00 !important;
    }

    ${e} select {
      outline: 1px solid #e26e0f !important;
    }

    ${e} textarea {
      outline: 1px solid #cc5400 !important;
    }

    ${e} details {
      outline: 1px solid #33848f !important;
    }

    ${e} summary {
      outline: 1px solid #60a1a6 !important;
    }

    ${e} command {
      outline: 1px solid #438da1 !important;
    }

    ${e} menu {
      outline: 1px solid #449da6 !important;
    }

    ${e} del {
      outline: 1px solid #bf0000 !important;
    }

    ${e} ins {
      outline: 1px solid #400000 !important;
    }

    ${e} img {
      outline: 1px solid #22746b !important;
    }

    ${e} iframe {
      outline: 1px solid #64a7a0 !important;
    }

    ${e} embed {
      outline: 1px solid #98daca !important;
    }

    ${e} object {
      outline: 1px solid #00cc99 !important;
    }

    ${e} param {
      outline: 1px solid #37ffc4 !important;
    }

    ${e} video {
      outline: 1px solid #6ee866 !important;
    }

    ${e} audio {
      outline: 1px solid #027353 !important;
    }

    ${e} source {
      outline: 1px solid #012426 !important;
    }

    ${e} canvas {
      outline: 1px solid #a2f570 !important;
    }

    ${e} track {
      outline: 1px solid #59a600 !important;
    }

    ${e} map {
      outline: 1px solid #7be500 !important;
    }

    ${e} area {
      outline: 1px solid #305900 !important;
    }

    ${e} a {
      outline: 1px solid #ff62ab !important;
    }

    ${e} em {
      outline: 1px solid #800b41 !important;
    }

    ${e} strong {
      outline: 1px solid #ff1583 !important;
    }

    ${e} i {
      outline: 1px solid #803156 !important;
    }

    ${e} b {
      outline: 1px solid #cc1169 !important;
    }

    ${e} u {
      outline: 1px solid #ff0430 !important;
    }

    ${e} s {
      outline: 1px solid #f805e3 !important;
    }

    ${e} small {
      outline: 1px solid #d107b2 !important;
    }

    ${e} abbr {
      outline: 1px solid #4a0263 !important;
    }

    ${e} q {
      outline: 1px solid #240018 !important;
    }

    ${e} cite {
      outline: 1px solid #64003c !important;
    }

    ${e} dfn {
      outline: 1px solid #b4005a !important;
    }

    ${e} sub {
      outline: 1px solid #dba0c8 !important;
    }

    ${e} sup {
      outline: 1px solid #cc0256 !important;
    }

    ${e} time {
      outline: 1px solid #d6606d !important;
    }

    ${e} code {
      outline: 1px solid #e04251 !important;
    }

    ${e} kbd {
      outline: 1px solid #5e001f !important;
    }

    ${e} samp {
      outline: 1px solid #9c0033 !important;
    }

    ${e} var {
      outline: 1px solid #d90047 !important;
    }

    ${e} mark {
      outline: 1px solid #ff0053 !important;
    }

    ${e} bdi {
      outline: 1px solid #bf3668 !important;
    }

    ${e} bdo {
      outline: 1px solid #6f1400 !important;
    }

    ${e} ruby {
      outline: 1px solid #ff7b93 !important;
    }

    ${e} rt {
      outline: 1px solid #ff2f54 !important;
    }

    ${e} rp {
      outline: 1px solid #803e49 !important;
    }

    ${e} span {
      outline: 1px solid #cc2643 !important;
    }

    ${e} br {
      outline: 1px solid #db687d !important;
    }

    ${e} wbr {
      outline: 1px solid #db175b !important;
    }`;
}
o(iS, "outlineCSS");

// src/outline/withOutline.ts
var H5 = /* @__PURE__ */ o((e, t) => {
  let r = t.globals || {}, n = [!0, "true"].includes(r[Fy]), i = t.viewMode === "docs", s = gl(() => iS(i ? '[data-story-block="true"]' : ".\
sb-show-main"), [t]);
  return Ht(() => {
    let a = i ? `addon-outline-docs-${t.id}` : "addon-outline";
    return n ? U5(a, s) : oS(a), () => {
      oS(a);
    };
  }, [n, s, t]), e();
}, "withOutline");

// src/outline/preview.ts
var jwe = globalThis.FEATURES?.outline ? [H5] : [], Lwe = {
  [Fy]: !1
}, sS = /* @__PURE__ */ o(() => ({ decorators: jwe, initialGlobals: Lwe }), "default");

// src/test/preview.ts
var Fwe = /* @__PURE__ */ o(({ parameters: e }) => {
  e?.test?.mockReset === !0 ? cR() : e?.test?.clearMocks === !0 ? uR() : e?.test?.restoreMocks !== !1 && dR();
}, "resetAllMocksLoader"), aS = /* @__PURE__ */ o((e, t = 0, r) => {
  if (t > 5 || e == null)
    return e;
  if (Xr(e))
    return r && e.mockName(r), e;
  if (typeof e == "function" && "isAction" in e && e.isAction && !("implicit" in e && e.implicit)) {
    let n = lR(e);
    return r && n.mockName(r), n;
  }
  if (Array.isArray(e)) {
    t++;
    for (let n = 0; n < e.length; n++)
      Object.getOwnPropertyDescriptor(e, n)?.writable && (e[n] = aS(e[n], t));
    return e;
  }
  if (typeof e == "object" && e.constructor === Object) {
    t++;
    for (let [n, i] of Object.entries(e))
      Object.getOwnPropertyDescriptor(e, n)?.writable && (e[n] = aS(i, t, n));
    return e;
  }
  return e;
}, "traverseArgs"), kwe = /* @__PURE__ */ o(({ initialArgs: e }) => {
  aS(e);
}, "nameSpiesAndWrapActionsInSpies"), V5 = !1, Dwe = /* @__PURE__ */ o(async (e) => {
  if (globalThis.HTMLElement && e.canvasElement instanceof globalThis.HTMLElement && (e.canvas = Bw(e.canvasElement)), globalThis.window?.navigator?.
  clipboard) {
    e.userEvent = cr(
      { userEvent: Uw.setup() },
      { intercept: !0 }
    ).userEvent;
    let t = HTMLElement.prototype.focus;
    V5 || Object.defineProperties(HTMLElement.prototype, {
      focus: {
        configurable: !0,
        set: /* @__PURE__ */ o((r) => {
          t = r, V5 = !0;
        }, "set"),
        get: /* @__PURE__ */ o(() => t, "get")
      }
    });
  }
}, "enhanceContext"), lS = /* @__PURE__ */ o(() => ({
  loaders: [Fwe, kwe, Dwe]
}), "default");

// src/viewport/constants.ts
var z5 = "storybook/viewport", G5 = "viewport", W6e = `${z5}/panel`, K6e = `${z5}/tool`;

// src/viewport/preview.ts
var $we = {
  [G5]: { value: void 0, isRotated: !1 }
}, uS = /* @__PURE__ */ o(() => ({
  initialGlobals: $we
}), "default");

// src/csf/core-annotations.ts
function ky() {
  return [
    // @ts-expect-error CJS fallback
    (nS.default ?? nS)(),
    // @ts-expect-error CJS fallback
    (Yw.default ?? Yw)(),
    // @ts-expect-error CJS fallback
    (eS.default ?? eS)(),
    // @ts-expect-error CJS fallback
    (sS.default ?? sS)(),
    // @ts-expect-error CJS fallback
    (uS.default ?? uS)(),
    // @ts-expect-error CJS fallback
    (zw.default ?? zw)(),
    // @ts-expect-error CJS fallback
    (Av.default ?? Av)(),
    // @ts-expect-error CJS fallback
    (lS.default ?? lS)()
  ];
}
o(ky, "getCoreAnnotations");

// src/csf/csf-factories.ts
function qi(e) {
  return e != null && typeof e == "object" && "_tag" in e && e?._tag === "Story";
}
o(qi, "isStory");

// src/csf/index.ts
var cS = /* @__PURE__ */ o((e) => e.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g,
"-").replace(/^-+/, "").replace(/-+$/, ""), "sanitize"), Y5 = /* @__PURE__ */ o((e, t) => {
  let r = cS(e);
  if (r === "")
    throw new Error(`Invalid ${t} '${e}', must include alphanumeric characters`);
  return r;
}, "sanitizeSafe"), K5 = /* @__PURE__ */ o((e, t) => `${Y5(e, "kind")}${t ? `--${Y5(t, "name")}` : ""}`, "toId"), X5 = /* @__PURE__ */ o((e) => tC(
e), "storyNameFromExport");
function W5(e, t) {
  return Array.isArray(t) ? t.includes(e) : e.match(t);
}
o(W5, "matches");
function Da(e, { includeStories: t, excludeStories: r }) {
  return (
    // https://babeljs.io/docs/en/babel-plugin-transform-modules-commonjs
    e !== "__esModule" && (!t || W5(e, t)) && (!r || !W5(e, r))
  );
}
o(Da, "isExportStory");
var J5 = /* @__PURE__ */ o((...e) => {
  let t = e.reduce((r, n) => (n.startsWith("!") ? r.delete(n.slice(1)) : r.add(n), r), /* @__PURE__ */ new Set());
  return Array.from(t);
}, "combineTags");

// ../node_modules/es-toolkit/dist/function/noop.mjs
function Z5() {
}
o(Z5, "noop");

// ../node_modules/es-toolkit/dist/compat/_internal/getSymbols.mjs
function dS(e) {
  return Object.getOwnPropertySymbols(e).filter((t) => Object.prototype.propertyIsEnumerable.call(e, t));
}
o(dS, "getSymbols");

// ../node_modules/es-toolkit/dist/compat/_internal/getTag.mjs
function pS(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
o(pS, "getTag");

// ../node_modules/es-toolkit/dist/compat/_internal/tags.mjs
var Q5 = "[object RegExp]", e3 = "[object String]", t3 = "[object Number]", r3 = "[object Boolean]", fS = "[object Arguments]", n3 = "[objec\
t Symbol]", o3 = "[object Date]", i3 = "[object Map]", s3 = "[object Set]", a3 = "[object Array]", l3 = "[object Function]", u3 = "[object A\
rrayBuffer]", Dy = "[object Object]", c3 = "[object Error]", d3 = "[object DataView]", p3 = "[object Uint8Array]", f3 = "[object Uint8Clampe\
dArray]", m3 = "[object Uint16Array]", h3 = "[object Uint32Array]", y3 = "[object BigUint64Array]", b3 = "[object Int8Array]", g3 = "[object\
 Int16Array]", v3 = "[object Int32Array]", E3 = "[object BigInt64Array]", T3 = "[object Float32Array]", _3 = "[object Float64Array]";

// ../node_modules/es-toolkit/dist/predicate/isPlainObject.mjs
function bt(e) {
  if (!e || typeof e != "object")
    return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype || Object.getPrototypeOf(t) === null ? Object.prototype.toString.call(e) === "[object Object]" :
  !1;
}
o(bt, "isPlainObject");

// ../node_modules/es-toolkit/dist/object/mapValues.mjs
function Mr(e, t) {
  let r = {}, n = Object.keys(e);
  for (let i = 0; i < n.length; i++) {
    let s = n[i], a = e[s];
    r[s] = t(a, s, e);
  }
  return r;
}
o(Mr, "mapValues");

// ../node_modules/es-toolkit/dist/object/pickBy.mjs
function mS(e, t) {
  let r = {}, n = Object.keys(e);
  for (let i = 0; i < n.length; i++) {
    let s = n[i], a = e[s];
    t(a, s) && (r[s] = a);
  }
  return r;
}
o(mS, "pickBy");

// ../node_modules/es-toolkit/dist/compat/util/eq.mjs
function R3(e, t) {
  return e === t || Number.isNaN(e) && Number.isNaN(t);
}
o(R3, "eq");

// ../node_modules/es-toolkit/dist/predicate/isEqualWith.mjs
function w3(e, t, r) {
  return $a(e, t, void 0, void 0, void 0, void 0, r);
}
o(w3, "isEqualWith");
function $a(e, t, r, n, i, s, a) {
  let l = a(e, t, r, n, i, s);
  if (l !== void 0)
    return l;
  if (typeof e == typeof t)
    switch (typeof e) {
      case "bigint":
      case "string":
      case "boolean":
      case "symbol":
      case "undefined":
        return e === t;
      case "number":
        return e === t || Object.is(e, t);
      case "function":
        return e === t;
      case "object":
        return Ba(e, t, s, a);
    }
  return Ba(e, t, s, a);
}
o($a, "isEqualWithImpl");
function Ba(e, t, r, n) {
  if (Object.is(e, t))
    return !0;
  let i = pS(e), s = pS(t);
  if (i === fS && (i = Dy), s === fS && (s = Dy), i !== s)
    return !1;
  switch (i) {
    case e3:
      return e.toString() === t.toString();
    case t3: {
      let u = e.valueOf(), c = t.valueOf();
      return R3(u, c);
    }
    case r3:
    case o3:
    case n3:
      return Object.is(e.valueOf(), t.valueOf());
    case Q5:
      return e.source === t.source && e.flags === t.flags;
    case l3:
      return e === t;
  }
  r = r ?? /* @__PURE__ */ new Map();
  let a = r.get(e), l = r.get(t);
  if (a != null && l != null)
    return a === t;
  r.set(e, t), r.set(t, e);
  try {
    switch (i) {
      case i3: {
        if (e.size !== t.size)
          return !1;
        for (let [u, c] of e.entries())
          if (!t.has(u) || !$a(c, t.get(u), u, e, t, r, n))
            return !1;
        return !0;
      }
      case s3: {
        if (e.size !== t.size)
          return !1;
        let u = Array.from(e.values()), c = Array.from(t.values());
        for (let d = 0; d < u.length; d++) {
          let p = u[d], y = c.findIndex((f) => $a(p, f, void 0, e, t, r, n));
          if (y === -1)
            return !1;
          c.splice(y, 1);
        }
        return !0;
      }
      case a3:
      case p3:
      case f3:
      case m3:
      case h3:
      case y3:
      case b3:
      case g3:
      case v3:
      case E3:
      case T3:
      case _3: {
        if (typeof Buffer < "u" && Buffer.isBuffer(e) !== Buffer.isBuffer(t) || e.length !== t.length)
          return !1;
        for (let u = 0; u < e.length; u++)
          if (!$a(e[u], t[u], u, e, t, r, n))
            return !1;
        return !0;
      }
      case u3:
        return e.byteLength !== t.byteLength ? !1 : Ba(new Uint8Array(e), new Uint8Array(t), r, n);
      case d3:
        return e.byteLength !== t.byteLength || e.byteOffset !== t.byteOffset ? !1 : Ba(new Uint8Array(e), new Uint8Array(t), r, n);
      case c3:
        return e.name === t.name && e.message === t.message;
      case Dy: {
        if (!(Ba(e.constructor, t.constructor, r, n) || bt(e) && bt(t)))
          return !1;
        let c = [...Object.keys(e), ...dS(e)], d = [...Object.keys(t), ...dS(t)];
        if (c.length !== d.length)
          return !1;
        for (let p = 0; p < c.length; p++) {
          let y = c[p], f = e[y];
          if (!Object.hasOwn(t, y))
            return !1;
          let m = t[y];
          if (!$a(f, m, y, e, t, r, n))
            return !1;
        }
        return !0;
      }
      default:
        return !1;
    }
  } finally {
    r.delete(e), r.delete(t);
  }
}
o(Ba, "areObjectsEqual");

// ../node_modules/es-toolkit/dist/predicate/isEqual.mjs
function hS(e, t) {
  return w3(e, t, Z5);
}
o(hS, "isEqual");

// src/preview-api/modules/store/StoryStore.ts
var Zy = De(bS(), 1);

// src/preview-api/modules/store/args.ts
var Ii = Symbol("incompatible"), gS = /* @__PURE__ */ o((e, t) => {
  let r = t.type;
  if (e == null || !r || t.mapping)
    return e;
  switch (r.name) {
    case "string":
      return String(e);
    case "enum":
      return e;
    case "number":
      return Number(e);
    case "boolean":
      return String(e) === "true";
    case "array":
      return !r.value || !Array.isArray(e) ? Ii : e.reduce((n, i, s) => {
        let a = gS(i, { type: r.value });
        return a !== Ii && (n[s] = a), n;
      }, new Array(e.length));
    case "object":
      return typeof e == "string" || typeof e == "number" ? e : !r.value || typeof e != "object" ? Ii : Object.entries(e).reduce((n, [i, s]) => {
        let a = gS(s, { type: r.value[i] });
        return a === Ii ? n : Object.assign(n, { [i]: a });
      }, {});
    default:
      return Ii;
  }
}, "map"), x3 = /* @__PURE__ */ o((e, t) => Object.entries(e).reduce((r, [n, i]) => {
  if (!t[n])
    return r;
  let s = gS(i, t[n]);
  return s === Ii ? r : Object.assign(r, { [n]: s });
}, {}), "mapArgsToTypes"), Mi = /* @__PURE__ */ o((e, t) => Array.isArray(e) && Array.isArray(t) ? t.reduce(
  (r, n, i) => (r[i] = Mi(e[i], t[i]), r),
  [...e]
).filter((r) => r !== void 0) : !bt(e) || !bt(t) ? t : Object.keys({ ...e, ...t }).reduce((r, n) => {
  if (n in t) {
    let i = Mi(e[n], t[n]);
    i !== void 0 && (r[n] = i);
  } else
    r[n] = e[n];
  return r;
}, {}), "combineArgs"), C3 = /* @__PURE__ */ o((e, t) => Object.entries(t).reduce((r, [n, { options: i }]) => {
  function s() {
    return n in e && (r[n] = e[n]), r;
  }
  if (o(s, "allowArg"), !i)
    return s();
  if (!Array.isArray(i))
    return we.error(ee`
        Invalid argType: '${n}.options' should be an array.

        More info: https://storybook.js.org/docs/api/arg-types
      `), s();
  if (i.some((p) => p && ["object", "function"].includes(typeof p)))
    return we.error(ee`
        Invalid argType: '${n}.options' should only contain primitives. Use a 'mapping' for complex values.

        More info: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
      `), s();
  let a = Array.isArray(e[n]), l = a && e[n].findIndex((p) => !i.includes(p)), u = a && l === -1;
  if (e[n] === void 0 || i.includes(e[n]) || u)
    return s();
  let c = a ? `${n}[${l}]` : n, d = i.map((p) => typeof p == "string" ? `'${p}'` : String(p)).join(", ");
  return we.warn(`Received illegal value for '${c}'. Supported options: ${d}`), r;
}, {}), "validateOptions"), eo = Symbol("Deeply equal"), Ni = /* @__PURE__ */ o((e, t) => {
  if (typeof e != typeof t)
    return t;
  if (hS(e, t))
    return eo;
  if (Array.isArray(e) && Array.isArray(t)) {
    let r = t.reduce((n, i, s) => {
      let a = Ni(e[s], i);
      return a !== eo && (n[s] = a), n;
    }, new Array(t.length));
    return t.length >= e.length ? r : r.concat(new Array(e.length - t.length).fill(void 0));
  }
  return bt(e) && bt(t) ? Object.keys({ ...e, ...t }).reduce((r, n) => {
    let i = Ni(e?.[n], t?.[n]);
    return i === eo ? r : Object.assign(r, { [n]: i });
  }, {}) : t;
}, "deepDiff"), vS = "UNTARGETED";
function P3({
  args: e,
  argTypes: t
}) {
  let r = {};
  return Object.entries(e).forEach(([n, i]) => {
    let { target: s = vS } = t[n] || {};
    r[s] = r[s] || {}, r[s][n] = i;
  }), r;
}
o(P3, "groupArgsByTarget");

// src/preview-api/modules/store/ArgsStore.ts
function Bwe(e) {
  return Object.keys(e).forEach((t) => e[t] === void 0 && delete e[t]), e;
}
o(Bwe, "deleteUndefined");
var ES = class ES {
  constructor() {
    this.initialArgsByStoryId = {};
    this.argsByStoryId = {};
  }
  get(t) {
    if (!(t in this.argsByStoryId))
      throw new Error(`No args known for ${t} -- has it been rendered yet?`);
    return this.argsByStoryId[t];
  }
  setInitial(t) {
    if (!this.initialArgsByStoryId[t.id])
      this.initialArgsByStoryId[t.id] = t.initialArgs, this.argsByStoryId[t.id] = t.initialArgs;
    else if (this.initialArgsByStoryId[t.id] !== t.initialArgs) {
      let r = Ni(this.initialArgsByStoryId[t.id], this.argsByStoryId[t.id]);
      this.initialArgsByStoryId[t.id] = t.initialArgs, this.argsByStoryId[t.id] = t.initialArgs, r !== eo && this.updateFromDelta(t, r);
    }
  }
  updateFromDelta(t, r) {
    let n = C3(r, t.argTypes);
    this.argsByStoryId[t.id] = Mi(this.argsByStoryId[t.id], n);
  }
  updateFromPersisted(t, r) {
    let n = x3(r, t.argTypes);
    return this.updateFromDelta(t, n);
  }
  update(t, r) {
    if (!(t in this.argsByStoryId))
      throw new Error(`No args known for ${t} -- has it been rendered yet?`);
    this.argsByStoryId[t] = Bwe({
      ...this.argsByStoryId[t],
      ...r
    });
  }
};
o(ES, "ArgsStore");
var $y = ES;

// src/preview-api/modules/store/csf/getValuesFromArgTypes.ts
var By = /* @__PURE__ */ o((e = {}) => Object.entries(e).reduce((t, [r, { defaultValue: n }]) => (typeof n < "u" && (t[r] = n), t), {}), "ge\
tValuesFromArgTypes");

// src/preview-api/modules/store/GlobalsStore.ts
var TS = class TS {
  constructor({
    globals: t = {},
    globalTypes: r = {}
  }) {
    this.set({ globals: t, globalTypes: r });
  }
  set({ globals: t = {}, globalTypes: r = {} }) {
    let n = this.initialGlobals && Ni(this.initialGlobals, this.globals);
    this.allowedGlobalNames = /* @__PURE__ */ new Set([...Object.keys(t), ...Object.keys(r)]);
    let i = By(r);
    this.initialGlobals = { ...i, ...t }, this.globals = this.initialGlobals, n && n !== eo && this.updateFromPersisted(n);
  }
  filterAllowedGlobals(t) {
    return Object.entries(t).reduce((r, [n, i]) => (this.allowedGlobalNames.has(n) ? r[n] = i : ue.warn(
      `Attempted to set a global (${n}) that is not defined in initial globals or globalTypes`
    ), r), {});
  }
  updateFromPersisted(t) {
    let r = this.filterAllowedGlobals(t);
    this.globals = { ...this.globals, ...r };
  }
  get() {
    return this.globals;
  }
  update(t) {
    this.globals = { ...this.globals, ...this.filterAllowedGlobals(t) };
    for (let r in t)
      t[r] === void 0 && (this.globals[r] = this.initialGlobals[r]);
  }
};
o(TS, "GlobalsStore");
var Uy = TS;

// src/preview-api/modules/store/StoryIndexStore.ts
var A3 = De(bS(), 1);
var Uwe = (0, A3.default)(1)(
  (e) => Object.values(e).reduce(
    (t, r) => (t[r.importPath] = t[r.importPath] || r, t),
    {}
  )
), _S = class _S {
  constructor({ entries: t } = { v: 5, entries: {} }) {
    this.entries = t;
  }
  entryFromSpecifier(t) {
    let r = Object.values(this.entries);
    if (t === "*")
      return r[0];
    if (typeof t == "string")
      return this.entries[t] ? this.entries[t] : r.find((s) => s.id.startsWith(t));
    let { name: n, title: i } = t;
    return r.find((s) => s.name === n && s.title === i);
  }
  storyIdToEntry(t) {
    let r = this.entries[t];
    if (!r)
      throw new Xi({ storyId: t });
    return r;
  }
  importPathToEntry(t) {
    return Uwe(this.entries)[t];
  }
};
o(_S, "StoryIndexStore");
var Hy = _S;

// src/preview-api/modules/store/csf/normalizeInputTypes.ts
var Hwe = /* @__PURE__ */ o((e) => typeof e == "string" ? { name: e } : e, "normalizeType"), Vwe = /* @__PURE__ */ o((e) => typeof e == "str\
ing" ? { type: e } : e, "normalizeControl"), zwe = /* @__PURE__ */ o((e, t) => {
  let { type: r, control: n, ...i } = e, s = {
    name: t,
    ...i
  };
  return r && (s.type = Hwe(r)), n ? s.control = Vwe(n) : n === !1 && (s.control = { disable: !0 }), s;
}, "normalizeInputType"), to = /* @__PURE__ */ o((e) => Mr(e, zwe), "normalizeInputTypes");

// src/preview-api/modules/store/csf/normalizeArrays.ts
var he = /* @__PURE__ */ o((e) => Array.isArray(e) ? e : e ? [e] : [], "normalizeArrays");

// src/preview-api/modules/store/csf/normalizeStory.ts
var Gwe = ee`
CSF .story annotations deprecated; annotate story functions directly:
- StoryFn.story.name => StoryFn.storyName
- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)
See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.
`;
function ro(e, t, r) {
  let n = t, i = typeof t == "function" ? t : null, { story: s } = n;
  s && (ue.debug("deprecated story", s), Gi(Gwe));
  let a = X5(e), l = typeof n != "function" && n.name || n.storyName || s?.name || a, u = [
    ...he(n.decorators),
    ...he(s?.decorators)
  ], c = { ...s?.parameters, ...n.parameters }, d = { ...s?.args, ...n.args }, p = { ...s?.argTypes, ...n.argTypes }, y = [...he(n.loaders),
  ...he(s?.loaders)], f = [
    ...he(n.beforeEach),
    ...he(s?.beforeEach)
  ], m = [
    ...he(n.afterEach),
    ...he(s?.afterEach)
  ], { render: h, play: b, tags: g = [], globals: T = {} } = n, _ = c.__id || K5(r.id, a);
  return {
    moduleExport: t,
    id: _,
    name: l,
    tags: g,
    decorators: u,
    parameters: c,
    args: d,
    argTypes: to(p),
    loaders: y,
    beforeEach: f,
    afterEach: m,
    globals: T,
    ...h && { render: h },
    ...i && { userStoryFn: i },
    ...b && { play: b }
  };
}
o(ro, "normalizeStory");

// src/preview-api/modules/store/csf/normalizeComponentAnnotations.ts
function Ua(e, t = e.title, r) {
  let { id: n, argTypes: i } = e;
  return {
    id: cS(n || t),
    ...e,
    title: t,
    ...i && { argTypes: to(i) },
    parameters: {
      fileName: r,
      ...e.parameters
    }
  };
}
o(Ua, "normalizeComponentAnnotations");

// src/preview-api/modules/store/csf/processCSFFile.ts
var Ywe = /* @__PURE__ */ o((e) => {
  let { globals: t, globalTypes: r } = e;
  (t || r) && ue.error(
    "Global args/argTypes can only be set globally",
    JSON.stringify({
      globals: t,
      globalTypes: r
    })
  );
}, "checkGlobals"), Wwe = /* @__PURE__ */ o((e) => {
  let { options: t } = e;
  t?.storySort && ue.error("The storySort option parameter can only be set globally");
}, "checkStorySort"), Vy = /* @__PURE__ */ o((e) => {
  e && (Ywe(e), Wwe(e));
}, "checkDisallowedParameters");
function O3(e, t, r) {
  let { default: n, __namedExportsOrder: i, ...s } = e, a = Object.values(s)[0];
  if (qi(a)) {
    let c = Ua(a.meta.input, r, t);
    Vy(c.parameters);
    let d = { meta: c, stories: {}, moduleExports: e };
    return Object.keys(s).forEach((p) => {
      if (Da(p, c)) {
        let y = ro(p, s[p].input, c);
        Vy(y.parameters), d.stories[y.id] = y;
      }
    }), d.projectAnnotations = a.meta.preview.composed, d;
  }
  let l = Ua(
    n,
    r,
    t
  );
  Vy(l.parameters);
  let u = { meta: l, stories: {}, moduleExports: e };
  return Object.keys(s).forEach((c) => {
    if (Da(c, l)) {
      let d = ro(c, s[c], l);
      Vy(d.parameters), u.stories[d.id] = d;
    }
  }), u;
}
o(O3, "processCSFFile");

// src/preview-api/modules/preview-web/render/mount-utils.ts
function I3(e) {
  return e != null && Kwe(e).includes("mount");
}
o(I3, "mountDestructured");
function Kwe(e) {
  let t = e.toString().match(/[^(]*\(([^)]*)/);
  if (!t)
    return [];
  let r = q3(t[1]);
  if (!r.length)
    return [];
  let n = r[0];
  return n.startsWith("{") && n.endsWith("}") ? q3(n.slice(1, -1).replace(/\s/g, "")).map((s) => s.replace(/:.*|=.*/g, "")) : [];
}
o(Kwe, "getUsedProps");
function q3(e) {
  let t = [], r = [], n = 0;
  for (let s = 0; s < e.length; s++)
    if (e[s] === "{" || e[s] === "[")
      r.push(e[s] === "{" ? "}" : "]");
    else if (e[s] === r[r.length - 1])
      r.pop();
    else if (!r.length && e[s] === ",") {
      let a = e.substring(n, s).trim();
      a && t.push(a), n = s + 1;
    }
  let i = e.substring(n).trim();
  return i && t.push(i), t;
}
o(q3, "splitByComma");

// src/preview-api/modules/store/decorators.ts
function RS(e, t, r) {
  let n = r(e);
  return (i) => t(n, i);
}
o(RS, "decorateStory");
function wS({
  componentId: e,
  title: t,
  kind: r,
  id: n,
  name: i,
  story: s,
  parameters: a,
  initialArgs: l,
  argTypes: u,
  ...c
} = {}) {
  return c;
}
o(wS, "sanitizeStoryContextUpdate");
function zy(e, t) {
  let r = {}, n = /* @__PURE__ */ o((s) => (a) => {
    if (!r.value)
      throw new Error("Decorated function called without init");
    return r.value = {
      ...r.value,
      ...wS(a)
    }, s(r.value);
  }, "bindWithContext"), i = t.reduce(
    (s, a) => RS(s, a, n),
    e
  );
  return (s) => (r.value = s, i(s));
}
o(zy, "defaultDecorateStory");

// src/preview-api/modules/store/parameters.ts
var At = /* @__PURE__ */ o((...e) => {
  let t = {}, r = e.filter(Boolean), n = r.reduce((i, s) => (Object.entries(s).forEach(([a, l]) => {
    let u = i[a];
    Array.isArray(l) || typeof u > "u" ? i[a] = l : bt(l) && bt(u) ? t[a] = !0 : typeof l < "u" && (i[a] = l);
  }), i), {});
  return Object.keys(t).forEach((i) => {
    let s = r.filter(Boolean).map((a) => a[i]).filter((a) => typeof a < "u");
    s.every((a) => bt(a)) ? n[i] = At(...s) : n[i] = s[s.length - 1];
  }), n;
}, "combineParameters");

// src/preview-api/modules/store/csf/prepareStory.ts
function ji(e, t, r) {
  let { moduleExport: n, id: i, name: s } = e || {}, a = M3(
    e,
    t,
    r
  ), l = /* @__PURE__ */ o(async (C) => {
    let w = {};
    for (let P of [
      he(r.loaders),
      he(t.loaders),
      he(e.loaders)
    ]) {
      if (C.abortSignal.aborted)
        return w;
      let O = await Promise.all(P.map((D) => D(C)));
      Object.assign(w, ...O);
    }
    return w;
  }, "applyLoaders"), u = /* @__PURE__ */ o(async (C) => {
    let w = new Array();
    for (let P of [
      ...he(r.beforeEach),
      ...he(t.beforeEach),
      ...he(e.beforeEach)
    ]) {
      if (C.abortSignal.aborted)
        return w;
      let O = await P(C);
      O && w.push(O);
    }
    return w;
  }, "applyBeforeEach"), c = /* @__PURE__ */ o(async (C) => {
    let w = [
      ...he(r.afterEach),
      ...he(t.afterEach),
      ...he(e.afterEach)
    ].reverse();
    for (let P of w) {
      if (C.abortSignal.aborted)
        return;
      await P(C);
    }
  }, "applyAfterEach"), d = /* @__PURE__ */ o((C) => C.originalStoryFn(C.args, C), "undecoratedStoryFn"), { applyDecorators: p = zy, runStep: y } = r,
  f = [
    ...he(e?.decorators),
    ...he(t?.decorators),
    ...he(r?.decorators)
  ], m = e?.userStoryFn || e?.render || t.render || r.render, h = yl(p)(d, f), b = /* @__PURE__ */ o((C) => h(C), "unboundStoryFn"), g = e?.
  play ?? t?.play, T = I3(g);
  if (!m && !T)
    throw new ss({ id: i });
  let _ = /* @__PURE__ */ o((C) => async () => (await C.renderToCanvas(), C.canvas), "defaultMount"), E = e.mount ?? t.mount ?? r.mount ?? _,
  R = r.testingLibraryRender;
  return {
    storyGlobals: {},
    ...a,
    moduleExport: n,
    id: i,
    name: s,
    story: s,
    originalStoryFn: m,
    undecoratedStoryFn: d,
    unboundStoryFn: b,
    applyLoaders: l,
    applyBeforeEach: u,
    applyAfterEach: c,
    playFunction: g,
    runStep: y,
    mount: E,
    testingLibraryRender: R,
    renderToCanvas: r.renderToCanvas,
    usesMount: T
  };
}
o(ji, "prepareStory");
function Gy(e, t, r) {
  return {
    ...M3(void 0, e, t),
    moduleExport: r
  };
}
o(Gy, "prepareMeta");
function M3(e, t, r) {
  let n = ["dev", "test"], i = k.DOCS_OPTIONS?.autodocs === !0 ? ["autodocs"] : [], s = J5(
    ...n,
    ...i,
    ...r.tags ?? [],
    ...t.tags ?? [],
    ...e?.tags ?? []
  ), a = At(
    r.parameters,
    t.parameters,
    e?.parameters
  ), { argTypesEnhancers: l = [], argsEnhancers: u = [] } = r, c = At(
    r.argTypes,
    t.argTypes,
    e?.argTypes
  );
  if (e) {
    let g = e?.userStoryFn || e?.render || t.render || r.render;
    a.__isArgsStory = g && g.length > 0;
  }
  let d = {
    ...r.args,
    ...t.args,
    ...e?.args
  }, p = {
    ...t.globals,
    ...e?.globals
  }, y = {
    componentId: t.id,
    title: t.title,
    kind: t.title,
    // Back compat
    id: e?.id || t.id,
    // if there's no story name, we create a fake one since enhancers expect a name
    name: e?.name || "__meta",
    story: e?.name || "__meta",
    // Back compat
    component: t.component,
    subcomponents: t.subcomponents,
    tags: s,
    parameters: a,
    initialArgs: d,
    argTypes: c,
    storyGlobals: p
  };
  y.argTypes = l.reduce(
    (g, T) => T({ ...y, argTypes: g }),
    y.argTypes
  );
  let f = { ...d };
  y.initialArgs = [...u].reduce(
    (g, T) => ({
      ...g,
      ...T({
        ...y,
        initialArgs: g
      })
    }),
    f
  );
  let { name: m, story: h, ...b } = y;
  return b;
}
o(M3, "preparePartialAnnotations");
function Yy(e) {
  let { args: t } = e, r = {
    ...e,
    allArgs: void 0,
    argsByTarget: void 0
  };
  if (k.FEATURES?.argTypeTargetsV7) {
    let s = P3(e);
    r = {
      ...e,
      allArgs: e.args,
      argsByTarget: s,
      args: s[vS] || {}
    };
  }
  let n = Object.entries(r.args).reduce((s, [a, l]) => {
    if (!r.argTypes[a]?.mapping)
      return s[a] = l, s;
    let u = /* @__PURE__ */ o((c) => {
      let d = r.argTypes[a].mapping;
      return d && c in d ? d[c] : c;
    }, "mappingFn");
    return s[a] = Array.isArray(l) ? l.map(u) : u(l), s;
  }, {}), i = Object.entries(n).reduce((s, [a, l]) => {
    let u = r.argTypes[a] || {};
    return Bg(u, n, r.globals) && (s[a] = l), s;
  }, {});
  return { ...r, unmappedArgs: t, args: i };
}
o(Yy, "prepareContext");

// src/preview-api/modules/store/inferArgTypes.ts
var SS = /* @__PURE__ */ o((e, t, r) => {
  let n = typeof e;
  switch (n) {
    case "boolean":
    case "string":
    case "number":
    case "function":
    case "symbol":
      return { name: n };
    default:
      break;
  }
  return e ? r.has(e) ? (ue.warn(ee`
        We've detected a cycle in arg '${t}'. Args should be JSON-serializable.

        Consider using the mapping feature or fully custom args:
        - Mapping: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
        - Custom args: https://storybook.js.org/docs/essentials/controls#fully-custom-args
      `), { name: "other", value: "cyclic object" }) : (r.add(e), Array.isArray(e) ? { name: "array", value: e.length > 0 ? SS(e[0], t, new Set(
  r)) : { name: "other", value: "unknown" } } : { name: "object", value: Mr(e, (s) => SS(s, t, new Set(r))) }) : { name: "object", value: {} };
}, "inferType"), xS = /* @__PURE__ */ o((e) => {
  let { id: t, argTypes: r = {}, initialArgs: n = {} } = e, i = Mr(n, (a, l) => ({
    name: l,
    type: SS(a, `${t}.${l}`, /* @__PURE__ */ new Set())
  })), s = Mr(r, (a, l) => ({
    name: l
  }));
  return At(i, s, r);
}, "inferArgTypes");
xS.secondPass = !0;

// src/preview-api/modules/store/filterArgTypes.ts
var N3 = /* @__PURE__ */ o((e, t) => Array.isArray(t) ? t.includes(e) : e.match(t), "matches"), Ha = /* @__PURE__ */ o((e, t, r) => !t && !r ?
e : e && mS(e, (n, i) => {
  let s = n.name || i.toString();
  return !!(!t || N3(s, t)) && (!r || !N3(s, r));
}), "filterArgTypes");

// src/preview-api/modules/store/inferControls.ts
var Xwe = /* @__PURE__ */ o((e, t, r) => {
  let { type: n, options: i } = e;
  if (n) {
    if (r.color && r.color.test(t)) {
      let s = n.name;
      if (s === "string")
        return { control: { type: "color" } };
      s !== "enum" && ue.warn(
        `Addon controls: Control of type color only supports string, received "${s}" instead`
      );
    }
    if (r.date && r.date.test(t))
      return { control: { type: "date" } };
    switch (n.name) {
      case "array":
        return { control: { type: "object" } };
      case "boolean":
        return { control: { type: "boolean" } };
      case "string":
        return { control: { type: "text" } };
      case "number":
        return { control: { type: "number" } };
      case "enum": {
        let { value: s } = n;
        return { control: { type: s?.length <= 5 ? "radio" : "select" }, options: s };
      }
      case "function":
      case "symbol":
        return null;
      default:
        return { control: { type: i ? "select" : "object" } };
    }
  }
}, "inferControl"), Li = /* @__PURE__ */ o((e) => {
  let {
    argTypes: t,
    parameters: { __isArgsStory: r, controls: { include: n = null, exclude: i = null, matchers: s = {} } = {} }
  } = e;
  if (!r)
    return t;
  let a = Ha(t, n, i), l = Mr(a, (u, c) => u?.type && Xwe(u, c.toString(), s));
  return At(l, a);
}, "inferControls");
Li.secondPass = !0;

// src/preview-api/modules/store/csf/normalizeProjectAnnotations.ts
function no({
  argTypes: e,
  globalTypes: t,
  argTypesEnhancers: r,
  decorators: n,
  loaders: i,
  beforeEach: s,
  afterEach: a,
  initialGlobals: l,
  ...u
}) {
  return {
    ...e && { argTypes: to(e) },
    ...t && { globalTypes: to(t) },
    decorators: he(n),
    loaders: he(i),
    beforeEach: he(s),
    afterEach: he(a),
    argTypesEnhancers: [
      ...r || [],
      xS,
      // There's an architectural decision to be made regarding embedded addons in core:
      //
      // Option 1: Keep embedded addons but ensure consistency by moving addon-specific code
      // (like inferControls) to live alongside the addon code itself. This maintains the
      // concept of core addons while improving code organization.
      //
      // Option 2: Fully integrate these addons into core, potentially moving UI components
      // into the manager and treating them as core features rather than addons. This is a
      // bigger architectural change requiring careful consideration.
      //
      // For now, we're keeping inferControls here as we need time to properly evaluate
      // these options and their implications. Some features (like Angular's cleanArgsDecorator)
      // currently rely on this behavior.
      //
      // TODO: Make an architectural decision on the handling of core addons
      Li
    ],
    initialGlobals: l,
    ...u
  };
}
o(no, "normalizeProjectAnnotations");

// src/preview-api/modules/store/csf/beforeAll.ts
var j3 = /* @__PURE__ */ o((e) => async () => {
  let t = [];
  for (let r of e) {
    let n = await r();
    n && t.unshift(n);
  }
  return async () => {
    for (let r of t)
      await r();
  };
}, "composeBeforeAllHooks");

// src/preview-api/modules/store/csf/stepRunners.ts
function Wy(e) {
  return async (t, r, n) => {
    await e.reduceRight(
      (s, a) => async () => a(t, s, n),
      async () => r(n)
    )();
  };
}
o(Wy, "composeStepRunners");

// src/preview-api/modules/store/csf/composeConfigs.ts
function za(e, t) {
  return e.map((r) => r.default?.[t] ?? r[t]).filter(Boolean);
}
o(za, "getField");
function gn(e, t, r = {}) {
  return za(e, t).reduce((n, i) => {
    let s = he(i);
    return r.reverseFileOrder ? [...s, ...n] : [...n, ...s];
  }, []);
}
o(gn, "getArrayField");
function Ky(e, t) {
  return Object.assign({}, ...za(e, t));
}
o(Ky, "getObjectField");
function Va(e, t) {
  return za(e, t).pop();
}
o(Va, "getSingletonField");
function Nr(e) {
  let t = gn(e, "argTypesEnhancers"), r = za(e, "runStep"), n = gn(e, "beforeAll");
  return {
    parameters: At(...za(e, "parameters")),
    decorators: gn(e, "decorators", {
      reverseFileOrder: !(k.FEATURES?.legacyDecoratorFileOrder ?? !1)
    }),
    args: Ky(e, "args"),
    argsEnhancers: gn(e, "argsEnhancers"),
    argTypes: Ky(e, "argTypes"),
    argTypesEnhancers: [
      ...t.filter((i) => !i.secondPass),
      ...t.filter((i) => i.secondPass)
    ],
    initialGlobals: Ky(e, "initialGlobals"),
    globalTypes: Ky(e, "globalTypes"),
    loaders: gn(e, "loaders"),
    beforeAll: j3(n),
    beforeEach: gn(e, "beforeEach"),
    afterEach: gn(e, "afterEach"),
    render: Va(e, "render"),
    renderToCanvas: Va(e, "renderToCanvas"),
    applyDecorators: Va(e, "applyDecorators"),
    runStep: Wy(r),
    tags: gn(e, "tags"),
    mount: Va(e, "mount"),
    testingLibraryRender: Va(e, "testingLibraryRender")
  };
}
o(Nr, "composeConfigs");

// src/preview-api/modules/preview-web/render/animation-utils.ts
function Xy() {
  try {
    return (
      // @ts-expect-error this property exists in certain environments
      !!globalThis.__vitest_browser__ || // @ts-expect-error this property exists in certain environments
      !!globalThis.__playwright__binding__
    );
  } catch {
    return !1;
  }
}
o(Xy, "isTestEnvironment");
function oo(e = !0) {
  if (!("document" in globalThis && "createElement" in globalThis.document))
    return () => {
    };
  let t = document.createElement("style");
  t.textContent = `*, *:before, *:after {
    animation: none !important;
  }`, document.head.appendChild(t);
  let r = document.createElement("style");
  return r.textContent = `*, *:before, *:after {
    animation-delay: 0s !important;
    animation-direction: ${e ? "reverse" : "normal"} !important;
    animation-play-state: paused !important;
    transition: none !important;
  }`, document.head.appendChild(r), document.body.clientHeight, document.head.removeChild(t), () => {
    r.parentNode?.removeChild(r);
  };
}
o(oo, "pauseAnimations");
async function io(e) {
  if (!("document" in globalThis && "getAnimations" in globalThis.document && "querySelectorAll" in globalThis.document))
    return;
  let t = !1;
  await Promise.race([
    // After 50ms, retrieve any running animations and wait for them to finish
    // If new animations are created while waiting, we'll wait for them too
    new Promise((r) => {
      setTimeout(() => {
        let n = [globalThis.document, ...L3(globalThis.document)], i = /* @__PURE__ */ o(async () => {
          if (t || e?.aborted)
            return;
          let s = n.flatMap((a) => a?.getAnimations?.() || []).filter((a) => a.playState === "running" && !Jwe(a));
          s.length > 0 && (await Promise.all(s.map((a) => a.finished)), await i());
        }, "checkAnimationsFinished");
        i().then(r);
      }, 100);
    }),
    // If animations don't finish within the timeout, continue without waiting
    new Promise(
      (r) => setTimeout(() => {
        t = !0, r(void 0);
      }, 5e3)
    )
  ]);
}
o(io, "waitForAnimations");
function L3(e) {
  return [e, ...e.querySelectorAll("*")].reduce((t, r) => ("shadowRoot" in r && r.shadowRoot && t.push(r.shadowRoot, ...L3(r.shadowRoot)), t),
  []);
}
o(L3, "getShadowRoots");
function Jwe(e) {
  if (e instanceof CSSAnimation && e.effect instanceof KeyframeEffect && e.effect.target) {
    let t = getComputedStyle(e.effect.target, e.effect.pseudoElement), r = t.animationName?.split(", ").indexOf(e.animationName);
    return t.animationIterationCount.split(", ")[r] === "infinite";
  }
  return !1;
}
o(Jwe, "isInfiniteAnimation");

// src/preview-api/modules/store/reporter-api.ts
var CS = class CS {
  constructor() {
    this.reports = [];
  }
  async addReport(t) {
    this.reports.push(t);
  }
};
o(CS, "ReporterAPI");
var vn = CS;

// src/preview-api/modules/store/csf/csf-factory-utils.ts
function Jy(e, t, r) {
  return qi(e) ? {
    story: e.input,
    meta: e.meta.input,
    preview: e.meta.preview.composed
  } : { story: e, meta: t, preview: r };
}
o(Jy, "getCsfFactoryAnnotations");

// src/preview-api/modules/store/csf/portable-stories.ts
function F3(e) {
  globalThis.defaultProjectAnnotations = e;
}
o(F3, "setDefaultProjectAnnotations");
var Zwe = "ComposedStory", Qwe = "Unnamed Story";
function eSe(e) {
  return e ? Nr([e]) : {};
}
o(eSe, "extractAnnotation");
function k3(e) {
  let t = Array.isArray(e) ? e : [e];
  return globalThis.globalProjectAnnotations = Nr([
    ...ky(),
    globalThis.defaultProjectAnnotations ?? {},
    Nr(t.map(eSe))
  ]), globalThis.globalProjectAnnotations ?? {};
}
o(k3, "setProjectAnnotations");
var En = [];
function PS(e, t, r, n, i) {
  if (e === void 0)
    throw new Error("Expected a story but received undefined.");
  t.title = t.title ?? Zwe;
  let s = Ua(t), a = i || e.storyName || e.story?.name || e.name || Qwe, l = ro(
    a,
    e,
    s
  ), u = no(
    Nr([
      n ?? globalThis.globalProjectAnnotations ?? {},
      r ?? {}
    ])
  ), c = ji(
    l,
    s,
    u
  ), p = {
    ...By(u.globalTypes),
    ...u.initialGlobals,
    ...c.storyGlobals
  }, y = new vn(), f = /* @__PURE__ */ o(() => {
    let _ = Yy({
      hooks: new Dr(),
      globals: p,
      args: { ...c.initialArgs },
      viewMode: "story",
      reporting: y,
      loaded: {},
      abortSignal: new AbortController().signal,
      step: /* @__PURE__ */ o((E, R) => c.runStep(E, R, _), "step"),
      canvasElement: null,
      canvas: {},
      userEvent: {},
      globalTypes: u.globalTypes,
      ...c,
      context: null,
      mount: null
    });
    return _.parameters.__isPortableStory = !0, _.context = _, c.renderToCanvas && (_.renderToCanvas = async () => {
      let E = await c.renderToCanvas?.(
        {
          componentId: c.componentId,
          title: c.title,
          id: c.id,
          name: c.name,
          tags: c.tags,
          showMain: /* @__PURE__ */ o(() => {
          }, "showMain"),
          showError: /* @__PURE__ */ o((R) => {
            throw new Error(`${R.title}
${R.description}`);
          }, "showError"),
          showException: /* @__PURE__ */ o((R) => {
            throw R;
          }, "showException"),
          forceRemount: !0,
          storyContext: _,
          storyFn: /* @__PURE__ */ o(() => c.unboundStoryFn(_), "storyFn"),
          unboundStoryFn: c.unboundStoryFn
        },
        _.canvasElement
      );
      E && En.push(E);
    }), _.mount = c.mount(_), _;
  }, "initializeContext"), m, h = /* @__PURE__ */ o(async (_) => {
    let E = f();
    return E.canvasElement ??= globalThis?.document?.body, m && (E.loaded = m.loaded), Object.assign(E, _), c.playFunction(E);
  }, "play"), b = /* @__PURE__ */ o((_) => {
    let E = f();
    return Object.assign(E, _), rSe(c, E);
  }, "run"), g = c.playFunction ? h : void 0;
  return Object.assign(
    /* @__PURE__ */ o(function(E) {
      let R = f();
      return m && (R.loaded = m.loaded), R.args = {
        ...R.initialArgs,
        ...E
      }, c.unboundStoryFn(R);
    }, "storyFn"),
    {
      id: c.id,
      storyName: a,
      load: /* @__PURE__ */ o(async () => {
        for (let E of [...En].reverse())
          await E();
        En.length = 0;
        let _ = f();
        _.loaded = await c.applyLoaders(_), En.push(...(await c.applyBeforeEach(_)).filter(Boolean)), m = _;
      }, "load"),
      globals: p,
      args: c.initialArgs,
      parameters: c.parameters,
      argTypes: c.argTypes,
      play: g,
      run: b,
      reporting: y,
      tags: c.tags
    }
  );
}
o(PS, "composeStory");
var tSe = /* @__PURE__ */ o((e, t, r, n) => PS(e, t, r, {}, n), "defaultComposeStory");
function D3(e, t, r = tSe) {
  let { default: n, __esModule: i, __namedExportsOrder: s, ...a } = e, l = n;
  return Object.entries(a).reduce(
    (c, [d, p]) => {
      let { story: y, meta: f } = Jy(p);
      return !l && f && (l = f), Da(d, l) ? Object.assign(c, {
        [d]: r(y, l, t, d)
      }) : c;
    },
    {}
  );
}
o(D3, "composeStories");
function $3(e) {
  return e.extend({
    mount: /* @__PURE__ */ o(async ({ mount: t, page: r }, n) => {
      await n(async (i, ...s) => {
        if (!("__pw_type" in i) || "__pw_type" in i && i.__pw_type !== "jsx")
          throw new Error(ee`
              Portable stories in Playwright CT only work when referencing JSX elements.
              Please use JSX format for your components such as:

              instead of:
              await mount(MyComponent, { props: { foo: 'bar' } })

              do:
              await mount(<MyComponent foo="bar"/>)

              More info: https://storybook.js.org/docs/api/portable-stories-playwright
            `);
        await r.evaluate(async (l) => {
          let u = await globalThis.__pwUnwrapObject?.(l);
          return ("__pw_type" in u ? u.type : u)?.load?.();
        }, i);
        let a = await t(i, ...s);
        return await r.evaluate(async (l) => {
          let u = await globalThis.__pwUnwrapObject?.(l), c = "__pw_type" in u ? u.type : u, d = document.querySelector("#root");
          return c?.play?.({ canvasElement: d });
        }, i), a;
      });
    }, "mount")
  });
}
o($3, "createPlaywrightTest");
async function rSe(e, t) {
  for (let s of [...En].reverse())
    await s();
  if (En.length = 0, !t.canvasElement) {
    let s = document.createElement("div");
    globalThis?.document?.body?.appendChild(s), t.canvasElement = s, En.push(() => {
      globalThis?.document?.body?.contains(s) && globalThis?.document?.body?.removeChild(s);
    });
  }
  if (t.loaded = await e.applyLoaders(t), t.abortSignal.aborted)
    return;
  En.push(...(await e.applyBeforeEach(t)).filter(Boolean));
  let r = e.playFunction, n = e.usesMount;
  if (n || await t.mount(), t.abortSignal.aborted)
    return;
  r && (n || (t.mount = async () => {
    throw new xn({ playFunction: r.toString() });
  }), await r(t));
  let i;
  Xy() ? i = oo() : await io(t.abortSignal), await e.applyAfterEach(t), await i?.();
}
o(rSe, "runStory");

// src/preview-api/modules/store/StoryStore.ts
var B3 = 1e3, nSe = 1e4, AS = class AS {
  constructor(t, r, n) {
    this.importFn = r;
    this.storyIndex = new Hy(t), this.projectAnnotations = no(
      Nr([...ky(), n])
    );
    let { initialGlobals: i, globalTypes: s } = this.projectAnnotations;
    this.args = new $y(), this.userGlobals = new Uy({ globals: i, globalTypes: s }), this.hooks = {}, this.cleanupCallbacks = {}, this.processCSFFileWithCache =
    (0, Zy.default)(B3)(O3), this.prepareMetaWithCache = (0, Zy.default)(B3)(Gy), this.prepareStoryWithCache = (0, Zy.default)(nSe)(ji);
  }
  setProjectAnnotations(t) {
    this.projectAnnotations = no(t);
    let { initialGlobals: r, globalTypes: n } = t;
    this.userGlobals.set({ globals: r, globalTypes: n });
  }
  // This means that one of the CSF files has changed.
  // If the `importFn` has changed, we will invalidate both caches.
  // If the `storyIndex` data has changed, we may or may not invalidate the caches, depending
  // on whether we've loaded the relevant files yet.
  async onStoriesChanged({
    importFn: t,
    storyIndex: r
  }) {
    t && (this.importFn = t), r && (this.storyIndex.entries = r.entries), this.cachedCSFFiles && await this.cacheAllCSFFiles();
  }
  // Get an entry from the index, waiting on initialization if necessary
  async storyIdToEntry(t) {
    return this.storyIndex.storyIdToEntry(t);
  }
  // To load a single CSF file to service a story we need to look up the importPath in the index
  async loadCSFFileByStoryId(t) {
    let { importPath: r, title: n } = this.storyIndex.storyIdToEntry(t), i = await this.importFn(r);
    return this.processCSFFileWithCache(i, r, n);
  }
  async loadAllCSFFiles() {
    let t = {};
    return Object.entries(this.storyIndex.entries).forEach(([n, { importPath: i }]) => {
      t[i] = n;
    }), (await Promise.all(
      Object.entries(t).map(async ([n, i]) => ({
        importPath: n,
        csfFile: await this.loadCSFFileByStoryId(i)
      }))
    )).reduce(
      (n, { importPath: i, csfFile: s }) => (n[i] = s, n),
      {}
    );
  }
  async cacheAllCSFFiles() {
    this.cachedCSFFiles = await this.loadAllCSFFiles();
  }
  preparedMetaFromCSFFile({ csfFile: t }) {
    let r = t.meta;
    return this.prepareMetaWithCache(
      r,
      this.projectAnnotations,
      t.moduleExports.default
    );
  }
  // Load the CSF file for a story and prepare the story from it and the project annotations.
  async loadStory({ storyId: t }) {
    let r = await this.loadCSFFileByStoryId(t);
    return this.storyFromCSFFile({ storyId: t, csfFile: r });
  }
  // This function is synchronous for convenience -- often times if you have a CSF file already
  // it is easier not to have to await `loadStory`.
  storyFromCSFFile({
    storyId: t,
    csfFile: r
  }) {
    let n = r.stories[t];
    if (!n)
      throw new os({ storyId: t });
    let i = r.meta, s = this.prepareStoryWithCache(
      n,
      i,
      r.projectAnnotations ?? this.projectAnnotations
    );
    return this.args.setInitial(s), this.hooks[s.id] = this.hooks[s.id] || new Dr(), s;
  }
  // If we have a CSF file we can get all the stories from it synchronously
  componentStoriesFromCSFFile({
    csfFile: t
  }) {
    return Object.keys(this.storyIndex.entries).filter((r) => !!t.stories[r]).map((r) => this.storyFromCSFFile({ storyId: r, csfFile: t }));
  }
  async loadEntry(t) {
    let r = await this.storyIdToEntry(t), n = r.type === "docs" ? r.storiesImports : [], [i, ...s] = await Promise.all([
      this.importFn(r.importPath),
      ...n.map((a) => {
        let l = this.storyIndex.importPathToEntry(a);
        return this.loadCSFFileByStoryId(l.id);
      })
    ]);
    return { entryExports: i, csfFiles: s };
  }
  // A prepared story does not include args, globals or hooks. These are stored in the story store
  // and updated separtely to the (immutable) story.
  getStoryContext(t, { forceInitialArgs: r = !1 } = {}) {
    let n = this.userGlobals.get(), { initialGlobals: i } = this.userGlobals, s = new vn();
    return Yy({
      ...t,
      args: r ? t.initialArgs : this.args.get(t.id),
      initialGlobals: i,
      globalTypes: this.projectAnnotations.globalTypes,
      userGlobals: n,
      reporting: s,
      globals: {
        ...n,
        ...t.storyGlobals
      },
      hooks: this.hooks[t.id]
    });
  }
  addCleanupCallbacks(t, ...r) {
    this.cleanupCallbacks[t.id] = (this.cleanupCallbacks[t.id] || []).concat(r);
  }
  async cleanupStory(t) {
    this.hooks[t.id].clean();
    let r = this.cleanupCallbacks[t.id];
    if (r)
      for (let n of [...r].reverse())
        await n();
    delete this.cleanupCallbacks[t.id];
  }
  extract(t = { includeDocsOnly: !1 }) {
    let { cachedCSFFiles: r } = this;
    if (!r)
      throw new Zi();
    return Object.entries(this.storyIndex.entries).reduce(
      (n, [i, { type: s, importPath: a }]) => {
        if (s === "docs")
          return n;
        let l = r[a], u = this.storyFromCSFFile({ storyId: i, csfFile: l });
        return !t.includeDocsOnly && u.parameters.docsOnly || (n[i] = Object.entries(u).reduce(
          (c, [d, p]) => d === "moduleExport" || typeof p == "function" ? c : Array.isArray(p) ? Object.assign(c, { [d]: p.slice().sort() }) :
          Object.assign(c, { [d]: p }),
          {
            //
            args: u.initialArgs,
            globals: {
              ...this.userGlobals.initialGlobals,
              ...this.userGlobals.globals,
              ...u.storyGlobals
            }
          }
        )), n;
      },
      {}
    );
  }
};
o(AS, "StoryStore");
var so = AS;

// ../node_modules/slash/index.js
function OS(e) {
  return e.startsWith("\\\\?\\") ? e : e.replace(/\\/g, "/");
}
o(OS, "slash");

// src/preview-api/modules/store/autoTitle.ts
var oSe = /* @__PURE__ */ o((e) => {
  if (e.length === 0)
    return e;
  let t = e[e.length - 1], r = t?.replace(/(?:[.](?:story|stories))?([.][^.]+)$/i, "");
  if (e.length === 1)
    return [r];
  let n = e[e.length - 2];
  return r && n && r.toLowerCase() === n.toLowerCase() ? [...e.slice(0, -2), r] : r && (/^(story|stories)([.][^.]+)$/i.test(t) || /^index$/i.
  test(r)) ? e.slice(0, -1) : [...e.slice(0, -1), r];
}, "sanitize");
function U3(e) {
  return e.flatMap((t) => t.split("/")).filter(Boolean).join("/");
}
o(U3, "pathJoin");
var qS = /* @__PURE__ */ o((e, t, r) => {
  let { directory: n, importPathMatcher: i, titlePrefix: s = "" } = t || {};
  typeof e == "number" && we.warn(ee`
      CSF Auto-title received a numeric fileName. This typically happens when
      webpack is mis-configured in production mode. To force webpack to produce
      filenames, set optimization.moduleIds = "named" in your webpack config.
    `);
  let a = OS(String(e));
  if (i.exec(a)) {
    if (!r) {
      let l = a.replace(n, ""), u = U3([s, l]).split("/");
      return u = oSe(u), u.join("/");
    }
    return s ? U3([s, r]) : r;
  }
}, "userOrAutoTitleFromSpecifier"), H3 = /* @__PURE__ */ o((e, t, r) => {
  for (let n = 0; n < t.length; n += 1) {
    let i = qS(e, t[n], r);
    if (i)
      return i;
  }
  return r || void 0;
}, "userOrAutoTitle");

// src/preview-api/modules/store/storySort.ts
var V3 = /\s*\/\s*/, z3 = /* @__PURE__ */ o((e = {}) => (t, r) => {
  if (t.title === r.title && !e.includeNames)
    return 0;
  let n = e.method || "configure", i = e.order || [], s = t.title.trim().split(V3), a = r.title.trim().split(V3);
  e.includeNames && (s.push(t.name), a.push(r.name));
  let l = 0;
  for (; s[l] || a[l]; ) {
    if (!s[l])
      return -1;
    if (!a[l])
      return 1;
    let u = s[l], c = a[l];
    if (u !== c) {
      let p = i.indexOf(u), y = i.indexOf(c), f = i.indexOf("*");
      return p !== -1 || y !== -1 ? (p === -1 && (f !== -1 ? p = f : p = i.length), y === -1 && (f !== -1 ? y = f : y = i.length), p - y) : n ===
      "configure" ? 0 : u.localeCompare(c, e.locales ? e.locales : void 0, {
        numeric: !0,
        sensitivity: "accent"
      });
    }
    let d = i.indexOf(u);
    d === -1 && (d = i.indexOf("*")), i = d !== -1 && Array.isArray(i[d + 1]) ? i[d + 1] : [], l += 1;
  }
  return 0;
}, "storySort");

// src/preview-api/modules/store/sortStories.ts
var iSe = /* @__PURE__ */ o((e, t, r) => {
  if (t) {
    let n;
    typeof t == "function" ? n = t : n = z3(t), e.sort(n);
  } else
    e.sort(
      (n, i) => r.indexOf(n.importPath) - r.indexOf(i.importPath)
    );
  return e;
}, "sortStoriesCommon"), G3 = /* @__PURE__ */ o((e, t, r) => {
  try {
    return iSe(e, t, r);
  } catch (n) {
    throw new Error(ee`
    Error sorting stories with sort parameter ${t}:

    > ${n.message}
    
    Are you using a V6-style sort function in V7 mode?

    More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#v7-style-story-sort
  `);
  }
}, "sortStoriesV7");

// src/preview-api/modules/preview-web/render/Render.ts
var Tn = new Error("prepareAborted");

// src/preview-api/modules/preview-web/render/StoryRender.ts
var { AbortController: Y3 } = globalThis;
function W3(e) {
  try {
    let { name: t = "Error", message: r = String(e), stack: n } = e;
    return { name: t, message: r, stack: n };
  } catch {
    return { name: "Error", message: String(e) };
  }
}
o(W3, "serializeError");
var IS = class IS {
  constructor(t, r, n, i, s, a, l = { autoplay: !0, forceInitialArgs: !1 }, u) {
    this.channel = t;
    this.store = r;
    this.renderToScreen = n;
    this.callbacks = i;
    this.id = s;
    this.viewMode = a;
    this.renderOptions = l;
    this.type = "story";
    this.notYetRendered = !0;
    this.rerenderEnqueued = !1;
    this.disableKeyListeners = !1;
    this.teardownRender = /* @__PURE__ */ o(() => {
    }, "teardownRender");
    this.torndown = !1;
    this.abortController = new Y3(), u && (this.story = u, this.phase = "preparing");
  }
  async runPhase(t, r, n) {
    this.phase = r, this.channel.emit(Ut, { newPhase: this.phase, storyId: this.id }), n && (await n(), this.checkIfAborted(t));
  }
  checkIfAborted(t) {
    return t.aborted ? (this.phase = "aborted", this.channel.emit(Ut, { newPhase: this.phase, storyId: this.id }), !0) : !1;
  }
  async prepare() {
    if (await this.runPhase(this.abortController.signal, "preparing", async () => {
      this.story = await this.store.loadStory({ storyId: this.id });
    }), this.abortController.signal.aborted)
      throw await this.store.cleanupStory(this.story), Tn;
  }
  // The two story "renders" are equal and have both loaded the same story
  isEqual(t) {
    return !!(this.id === t.id && this.story && this.story === t.story);
  }
  isPreparing() {
    return ["preparing"].includes(this.phase);
  }
  isPending() {
    return ["loading", "beforeEach", "rendering", "playing", "afterEach"].includes(
      this.phase
    );
  }
  async renderToElement(t) {
    return this.canvasElement = t, this.render({ initial: !0, forceRemount: !0 });
  }
  storyContext() {
    if (!this.story)
      throw new Error("Cannot call storyContext before preparing");
    let { forceInitialArgs: t } = this.renderOptions;
    return this.store.getStoryContext(this.story, { forceInitialArgs: t });
  }
  async render({
    initial: t = !1,
    forceRemount: r = !1
  } = {}) {
    let { canvasElement: n } = this;
    if (!this.story)
      throw new Error("cannot render when not prepared");
    let i = this.story;
    if (!n)
      throw new Error("cannot render when canvasElement is unset");
    let {
      id: s,
      componentId: a,
      title: l,
      name: u,
      tags: c,
      applyLoaders: d,
      applyBeforeEach: p,
      applyAfterEach: y,
      unboundStoryFn: f,
      playFunction: m,
      runStep: h
    } = i;
    r && !t && (this.cancelRender(), this.abortController = new Y3());
    let b = this.abortController.signal, g = !1, T = i.usesMount;
    try {
      let _ = {
        ...this.storyContext(),
        viewMode: this.viewMode,
        abortSignal: b,
        canvasElement: n,
        loaded: {},
        step: /* @__PURE__ */ o((B, N) => h(B, N, _), "step"),
        context: null,
        canvas: {},
        userEvent: {},
        renderToCanvas: /* @__PURE__ */ o(async () => {
          let B = await this.renderToScreen(E, n);
          this.teardownRender = B || (() => {
          }), g = !0;
        }, "renderToCanvas"),
        // The story provides (set in a renderer) a mount function that is a higher order function
        // (context) => (...args) => Canvas
        //
        // Before assigning it to the context, we resolve the context dependency,
        // so that a user can just call it as await mount(...args) in their play function.
        mount: /* @__PURE__ */ o(async (...B) => {
          this.callbacks.showStoryDuringRender?.();
          let N = null;
          return await this.runPhase(b, "rendering", async () => {
            N = await i.mount(_)(...B);
          }), T && await this.runPhase(b, "playing"), N;
        }, "mount")
      };
      _.context = _;
      let E = {
        componentId: a,
        title: l,
        kind: l,
        id: s,
        name: u,
        story: u,
        tags: c,
        ...this.callbacks,
        showError: /* @__PURE__ */ o((B) => (this.phase = "errored", this.callbacks.showError(B)), "showError"),
        showException: /* @__PURE__ */ o((B) => (this.phase = "errored", this.callbacks.showException(B)), "showException"),
        forceRemount: r || this.notYetRendered,
        storyContext: _,
        storyFn: /* @__PURE__ */ o(() => f(_), "storyFn"),
        unboundStoryFn: f
      };
      if (await this.runPhase(b, "loading", async () => {
        _.loaded = await d(_);
      }), b.aborted)
        return;
      let R = await p(_);
      if (this.store.addCleanupCallbacks(i, ...R), this.checkIfAborted(b) || (!g && !T && await _.mount(), this.notYetRendered = !1, b.aborted))
        return;
      let C = this.story.parameters?.test?.dangerouslyIgnoreUnhandledErrors === !0, w = /* @__PURE__ */ new Set(), P = /* @__PURE__ */ o((B) => {
        B.error && w.add(B.error);
      }, "onError"), O = /* @__PURE__ */ o((B) => {
        B.reason && w.add(B.reason);
      }, "onUnhandledRejection");
      if (this.renderOptions.autoplay && r && m && this.phase !== "errored") {
        window.addEventListener("error", P), window.addEventListener("unhandledrejection", O), this.disableKeyListeners = !0;
        try {
          if (T ? await m(_) : (_.mount = async () => {
            throw new xn({ playFunction: m.toString() });
          }, await this.runPhase(b, "playing", async () => m(_))), !g)
            throw new as();
          this.checkIfAborted(b), !C && w.size > 0 ? await this.runPhase(b, "errored") : await this.runPhase(b, "played");
        } catch (B) {
          if (this.callbacks.showStoryDuringRender?.(), await this.runPhase(b, "errored", async () => {
            this.channel.emit(bb, W3(B));
          }), this.story.parameters.throwPlayFunctionExceptions !== !1)
            throw B;
          console.error(B);
        }
        if (!C && w.size > 0 && this.channel.emit(
          gb,
          Array.from(w).map(W3)
        ), this.disableKeyListeners = !1, window.removeEventListener("unhandledrejection", O), window.removeEventListener("error", P), b.aborted)
          return;
      }
      await this.runPhase(b, "completing", async () => {
        Xy() ? this.store.addCleanupCallbacks(i, oo()) : await io(b);
      }), await this.runPhase(b, "completed", async () => {
        this.channel.emit(Eo, s);
      }), this.phase !== "errored" && await this.runPhase(b, "afterEach", async () => {
        await y(_);
      });
      let D = !C && w.size > 0, A = _.reporting.reports.some(
        (B) => B.status === "failed"
      ), L = D || A;
      await this.runPhase(
        b,
        "finished",
        async () => this.channel.emit(il, {
          storyId: s,
          status: L ? "error" : "success",
          reporters: _.reporting.reports
        })
      );
    } catch (_) {
      this.phase = "errored", this.callbacks.showException(_), await this.runPhase(
        b,
        "finished",
        async () => this.channel.emit(il, {
          storyId: s,
          status: "error",
          reporters: []
        })
      );
    }
    this.rerenderEnqueued && (this.rerenderEnqueued = !1, this.render());
  }
  /**
   * Rerender the story. If the story is currently pending (loading/rendering), the rerender will be
   * enqueued, and will be executed after the current render is completed. Rerendering while playing
   * will not be enqueued, and will be executed immediately, to support rendering args changes while
   * playing.
   */
  async rerender() {
    if (this.isPending() && this.phase !== "playing")
      this.rerenderEnqueued = !0;
    else
      return this.render();
  }
  async remount() {
    return await this.teardown(), this.render({ forceRemount: !0 });
  }
  // If the story is torn down (either a new story is rendered or the docs page removes it)
  // we need to consider the fact that the initial render may not be finished
  // (possibly the loaders or the play function are still running). We use the controller
  // as a method to abort them, ASAP, but this is not foolproof as we cannot control what
  // happens inside the user's code.
  cancelRender() {
    this.abortController?.abort();
  }
  async teardown() {
    this.torndown = !0, this.cancelRender(), this.story && await this.store.cleanupStory(this.story);
    for (let t = 0; t < 3; t += 1) {
      if (!this.isPending()) {
        await this.teardownRender();
        return;
      }
      await new Promise((r) => setTimeout(r, 0));
    }
    window.location.reload(), await new Promise(() => {
    });
  }
};
o(IS, "StoryRender");
var ao = IS;

// src/preview-api/modules/preview-web/Preview.tsx
var { fetch: sSe } = k, aSe = "./index.json", MS = class MS {
  constructor(t, r, n = Ye.getChannel(), i = !0) {
    this.importFn = t;
    this.getProjectAnnotations = r;
    this.channel = n;
    this.storyRenders = [];
    this.storeInitializationPromise = new Promise((s, a) => {
      this.resolveStoreInitializationPromise = s, this.rejectStoreInitializationPromise = a;
    }), i && this.initialize();
  }
  // Create a proxy object for `__STORYBOOK_STORY_STORE__` and `__STORYBOOK_PREVIEW__.storyStore`
  // That proxies through to the store once ready, and errors beforehand. This means we can set
  // `__STORYBOOK_STORY_STORE__ = __STORYBOOK_PREVIEW__.storyStore` without having to wait, and
  // similarly integrators can access the `storyStore` on the preview at any time, although
  // it is considered deprecated and we will no longer allow access in 9.0
  get storyStore() {
    return new Proxy(
      {},
      {
        get: /* @__PURE__ */ o((t, r) => {
          if (this.storyStoreValue)
            return Gi("Accessing the Story Store is deprecated and will be removed in 9.0"), this.storyStoreValue[r];
          throw new is();
        }, "get")
      }
    );
  }
  // INITIALIZATION
  async initialize() {
    this.setupListeners();
    try {
      let t = await this.getProjectAnnotationsOrRenderError();
      await this.runBeforeAllHook(t), await this.initializeWithProjectAnnotations(t);
    } catch (t) {
      this.rejectStoreInitializationPromise(t);
    }
  }
  ready() {
    return this.storeInitializationPromise;
  }
  setupListeners() {
    this.channel.on(Sb, this.onStoryIndexChanged.bind(this)), this.channel.on(Vi, this.onUpdateGlobals.bind(this)), this.channel.on(zi, this.
    onUpdateArgs.bind(this)), this.channel.on(Ib, this.onRequestArgTypesInfo.bind(this)), this.channel.on(Ui, this.onResetArgs.bind(this)), this.
    channel.on(Bi, this.onForceReRender.bind(this)), this.channel.on(vo, this.onForceRemount.bind(this));
  }
  async getProjectAnnotationsOrRenderError() {
    try {
      let t = await this.getProjectAnnotations();
      if (this.renderToCanvas = t.renderToCanvas, !this.renderToCanvas)
        throw new Qi();
      return t;
    } catch (t) {
      throw this.renderPreviewEntryError("Error reading preview.js:", t), t;
    }
  }
  // If initialization gets as far as project annotations, this function runs.
  async initializeWithProjectAnnotations(t) {
    this.projectAnnotationsBeforeInitialization = t;
    try {
      let r = await this.getStoryIndexFromServer();
      return this.initializeWithStoryIndex(r);
    } catch (r) {
      throw this.renderPreviewEntryError("Error loading story index:", r), r;
    }
  }
  async runBeforeAllHook(t) {
    try {
      await this.beforeAllCleanup?.(), this.beforeAllCleanup = await t.beforeAll?.();
    } catch (r) {
      throw this.renderPreviewEntryError("Error in beforeAll hook:", r), r;
    }
  }
  async getStoryIndexFromServer() {
    let t = await sSe(aSe);
    if (t.status === 200)
      return t.json();
    throw new es({ text: await t.text() });
  }
  // If initialization gets as far as the story index, this function runs.
  initializeWithStoryIndex(t) {
    if (!this.projectAnnotationsBeforeInitialization)
      throw new Error("Cannot call initializeWithStoryIndex until project annotations resolve");
    this.storyStoreValue = new so(
      t,
      this.importFn,
      this.projectAnnotationsBeforeInitialization
    ), delete this.projectAnnotationsBeforeInitialization, this.setInitialGlobals(), this.resolveStoreInitializationPromise();
  }
  async setInitialGlobals() {
    this.emitGlobals();
  }
  emitGlobals() {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "emitGlobals" });
    let t = {
      globals: this.storyStoreValue.userGlobals.get() || {},
      globalTypes: this.storyStoreValue.projectAnnotations.globalTypes || {}
    };
    this.channel.emit(Tb, t);
  }
  // EVENT HANDLERS
  // This happens when a config file gets reloaded
  async onGetProjectAnnotationsChanged({
    getProjectAnnotations: t
  }) {
    delete this.previewEntryError, this.getProjectAnnotations = t;
    let r = await this.getProjectAnnotationsOrRenderError();
    if (await this.runBeforeAllHook(r), !this.storyStoreValue) {
      await this.initializeWithProjectAnnotations(r);
      return;
    }
    this.storyStoreValue.setProjectAnnotations(r), this.emitGlobals();
  }
  async onStoryIndexChanged() {
    if (delete this.previewEntryError, !(!this.storyStoreValue && !this.projectAnnotationsBeforeInitialization))
      try {
        let t = await this.getStoryIndexFromServer();
        if (this.projectAnnotationsBeforeInitialization) {
          this.initializeWithStoryIndex(t);
          return;
        }
        await this.onStoriesChanged({ storyIndex: t });
      } catch (t) {
        throw this.renderPreviewEntryError("Error loading story index:", t), t;
      }
  }
  // This happens when a glob gets HMR-ed
  async onStoriesChanged({
    importFn: t,
    storyIndex: r
  }) {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "onStoriesChanged" });
    await this.storyStoreValue.onStoriesChanged({ importFn: t, storyIndex: r });
  }
  async onUpdateGlobals({
    globals: t,
    currentStory: r
  }) {
    if (this.storyStoreValue || await this.storeInitializationPromise, !this.storyStoreValue)
      throw new Ze({ methodName: "onUpdateGlobals" });
    if (this.storyStoreValue.userGlobals.update(t), r) {
      let { initialGlobals: n, storyGlobals: i, userGlobals: s, globals: a } = this.storyStoreValue.getStoryContext(r);
      this.channel.emit(Sn, {
        initialGlobals: n,
        userGlobals: s,
        storyGlobals: i,
        globals: a
      });
    } else {
      let { initialGlobals: n, globals: i } = this.storyStoreValue.userGlobals;
      this.channel.emit(Sn, {
        initialGlobals: n,
        userGlobals: i,
        storyGlobals: {},
        globals: i
      });
    }
    await Promise.all(this.storyRenders.map((n) => n.rerender()));
  }
  async onUpdateArgs({ storyId: t, updatedArgs: r }) {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "onUpdateArgs" });
    this.storyStoreValue.args.update(t, r), await Promise.all(
      this.storyRenders.filter((n) => n.id === t && !n.renderOptions.forceInitialArgs).map(
        (n) => (
          // We only run the play function, with in a force remount.
          // But when mount is destructured, the rendering happens inside of the play function.
          n.story && n.story.usesMount ? n.remount() : n.rerender()
        )
      )
    ), this.channel.emit(_b, {
      storyId: t,
      args: this.storyStoreValue.args.get(t)
    });
  }
  async onRequestArgTypesInfo({ id: t, payload: r }) {
    try {
      await this.storeInitializationPromise;
      let n = await this.storyStoreValue?.loadStory(r);
      this.channel.emit(sl, {
        id: t,
        success: !0,
        payload: { argTypes: n?.argTypes || {} },
        error: null
      });
    } catch (n) {
      this.channel.emit(sl, {
        id: t,
        success: !1,
        error: n?.message
      });
    }
  }
  async onResetArgs({ storyId: t, argNames: r }) {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "onResetArgs" });
    let i = this.storyRenders.find((l) => l.id === t)?.story || await this.storyStoreValue.loadStory({ storyId: t }), a = (r || [
      .../* @__PURE__ */ new Set([
        ...Object.keys(i.initialArgs),
        ...Object.keys(this.storyStoreValue.args.get(t))
      ])
    ]).reduce((l, u) => (l[u] = i.initialArgs[u], l), {});
    await this.onUpdateArgs({ storyId: t, updatedArgs: a });
  }
  // ForceReRender does not include a story id, so we simply must
  // re-render all stories in case they are relevant
  async onForceReRender() {
    await Promise.all(this.storyRenders.map((t) => t.rerender()));
  }
  async onForceRemount({ storyId: t }) {
    await Promise.all(this.storyRenders.filter((r) => r.id === t).map((r) => r.remount()));
  }
  // Used by docs to render a story to a given element
  // Note this short-circuits the `prepare()` phase of the StoryRender,
  // main to be consistent with the previous behaviour. In the future,
  // we will change it to go ahead and load the story, which will end up being
  // "instant", although async.
  renderStoryToElement(t, r, n, i) {
    if (!this.renderToCanvas || !this.storyStoreValue)
      throw new Ze({
        methodName: "renderStoryToElement"
      });
    let s = new ao(
      this.channel,
      this.storyStoreValue,
      this.renderToCanvas,
      n,
      t.id,
      "docs",
      i,
      t
    );
    return s.renderToElement(r), this.storyRenders.push(s), async () => {
      await this.teardownRender(s);
    };
  }
  async teardownRender(t, { viewModeChanged: r } = {}) {
    this.storyRenders = this.storyRenders.filter((n) => n !== t), await t?.teardown?.({ viewModeChanged: r });
  }
  // API
  async loadStory({ storyId: t }) {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "loadStory" });
    return this.storyStoreValue.loadStory({ storyId: t });
  }
  getStoryContext(t, { forceInitialArgs: r = !1 } = {}) {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "getStoryContext" });
    return this.storyStoreValue.getStoryContext(t, { forceInitialArgs: r });
  }
  async extract(t) {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "extract" });
    if (this.previewEntryError)
      throw this.previewEntryError;
    return await this.storyStoreValue.cacheAllCSFFiles(), this.storyStoreValue.extract(t);
  }
  // UTILITIES
  renderPreviewEntryError(t, r) {
    this.previewEntryError = r, ue.error(t), ue.error(r), this.channel.emit(hb, r);
  }
};
o(MS, "Preview");
var lo = MS;

// src/preview-api/modules/preview-web/docs-context/DocsContext.ts
var NS = class NS {
  constructor(t, r, n, i) {
    this.channel = t;
    this.store = r;
    this.renderStoryToElement = n;
    this.storyIdByName = /* @__PURE__ */ o((t) => {
      let r = this.nameToStoryId.get(t);
      if (r)
        return r;
      throw new Error(`No story found with that name: ${t}`);
    }, "storyIdByName");
    this.componentStories = /* @__PURE__ */ o(() => this.componentStoriesValue, "componentStories");
    this.componentStoriesFromCSFFile = /* @__PURE__ */ o((t) => this.store.componentStoriesFromCSFFile({ csfFile: t }), "componentStoriesFro\
mCSFFile");
    this.storyById = /* @__PURE__ */ o((t) => {
      if (!t) {
        if (!this.primaryStory)
          throw new Error(
            "No primary story defined for docs entry. Did you forget to use `<Meta>`?"
          );
        return this.primaryStory;
      }
      let r = this.storyIdToCSFFile.get(t);
      if (!r)
        throw new Error(`Called \`storyById\` for story that was never loaded: ${t}`);
      return this.store.storyFromCSFFile({ storyId: t, csfFile: r });
    }, "storyById");
    this.getStoryContext = /* @__PURE__ */ o((t) => ({
      ...this.store.getStoryContext(t),
      loaded: {},
      viewMode: "docs"
    }), "getStoryContext");
    this.loadStory = /* @__PURE__ */ o((t) => this.store.loadStory({ storyId: t }), "loadStory");
    this.componentStoriesValue = [], this.storyIdToCSFFile = /* @__PURE__ */ new Map(), this.exportToStory = /* @__PURE__ */ new Map(), this.
    exportsToCSFFile = /* @__PURE__ */ new Map(), this.nameToStoryId = /* @__PURE__ */ new Map(), this.attachedCSFFiles = /* @__PURE__ */ new Set(),
    i.forEach((s, a) => {
      this.referenceCSFFile(s);
    });
  }
  // This docs entry references this CSF file and can synchronously load the stories, as well
  // as reference them by module export. If the CSF is part of the "component" stories, they
  // can also be referenced by name and are in the componentStories list.
  referenceCSFFile(t) {
    this.exportsToCSFFile.set(t.moduleExports, t), this.exportsToCSFFile.set(t.moduleExports.default, t), this.store.componentStoriesFromCSFFile(
    { csfFile: t }).forEach((n) => {
      let i = t.stories[n.id];
      this.storyIdToCSFFile.set(i.id, t), this.exportToStory.set(i.moduleExport, n);
    });
  }
  attachCSFFile(t) {
    if (!this.exportsToCSFFile.has(t.moduleExports))
      throw new Error("Cannot attach a CSF file that has not been referenced");
    if (this.attachedCSFFiles.has(t))
      return;
    this.attachedCSFFiles.add(t), this.store.componentStoriesFromCSFFile({ csfFile: t }).forEach((n) => {
      this.nameToStoryId.set(n.name, n.id), this.componentStoriesValue.push(n), this.primaryStory || (this.primaryStory = n);
    });
  }
  referenceMeta(t, r) {
    let n = this.resolveModuleExport(t);
    if (n.type !== "meta")
      throw new Error(
        "<Meta of={} /> must reference a CSF file module export or meta export. Did you mistakenly reference your component instead of your \
CSF file?"
      );
    r && this.attachCSFFile(n.csfFile);
  }
  get projectAnnotations() {
    let { projectAnnotations: t } = this.store;
    if (!t)
      throw new Error("Can't get projectAnnotations from DocsContext before they are initialized");
    return t;
  }
  resolveAttachedModuleExportType(t) {
    if (t === "story") {
      if (!this.primaryStory)
        throw new Error(
          "No primary story attached to this docs file, did you forget to use <Meta of={} />?"
        );
      return { type: "story", story: this.primaryStory };
    }
    if (this.attachedCSFFiles.size === 0)
      throw new Error(
        "No CSF file attached to this docs file, did you forget to use <Meta of={} />?"
      );
    let r = Array.from(this.attachedCSFFiles)[0];
    if (t === "meta")
      return { type: "meta", csfFile: r };
    let { component: n } = r.meta;
    if (!n)
      throw new Error(
        "Attached CSF file does not defined a component, did you forget to export one?"
      );
    return { type: "component", component: n };
  }
  resolveModuleExport(t) {
    let r = this.exportsToCSFFile.get(t);
    if (r)
      return { type: "meta", csfFile: r };
    let n = this.exportToStory.get(
      qi(t) ? t.input : t
    );
    return n ? { type: "story", story: n } : { type: "component", component: t };
  }
  resolveOf(t, r = []) {
    let n;
    if (["component", "meta", "story"].includes(t)) {
      let i = t;
      n = this.resolveAttachedModuleExportType(i);
    } else
      n = this.resolveModuleExport(t);
    if (r.length && !r.includes(n.type)) {
      let i = n.type === "component" ? "component or unknown" : n.type;
      throw new Error(ee`Invalid value passed to the 'of' prop. The value was resolved to a '${i}' type but the only types for this block are: ${r.
      join(
        ", "
      )}.
        - Did you pass a component to the 'of' prop when the block only supports a story or a meta?
        - ... or vice versa?
        - Did you pass a story, CSF file or meta to the 'of' prop that is not indexed, ie. is not targeted by the 'stories' globs in the main configuration?`);
    }
    switch (n.type) {
      case "component":
        return {
          ...n,
          projectAnnotations: this.projectAnnotations
        };
      case "meta":
        return {
          ...n,
          preparedMeta: this.store.preparedMetaFromCSFFile({ csfFile: n.csfFile })
        };
      case "story":
      default:
        return n;
    }
  }
};
o(NS, "DocsContext");
var jr = NS;

// src/preview-api/modules/preview-web/render/CsfDocsRender.ts
var jS = class jS {
  constructor(t, r, n, i) {
    this.channel = t;
    this.store = r;
    this.entry = n;
    this.callbacks = i;
    this.type = "docs";
    this.subtype = "csf";
    this.torndown = !1;
    this.disableKeyListeners = !1;
    this.preparing = !1;
    this.id = n.id;
  }
  isPreparing() {
    return this.preparing;
  }
  async prepare() {
    this.preparing = !0;
    let { entryExports: t, csfFiles: r = [] } = await this.store.loadEntry(this.id);
    if (this.torndown)
      throw Tn;
    let { importPath: n, title: i } = this.entry, s = this.store.processCSFFileWithCache(
      t,
      n,
      i
    ), a = Object.keys(s.stories)[0];
    this.story = this.store.storyFromCSFFile({ storyId: a, csfFile: s }), this.csfFiles = [s, ...r], this.preparing = !1;
  }
  isEqual(t) {
    return !!(this.id === t.id && this.story && this.story === t.story);
  }
  docsContext(t) {
    if (!this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    let r = new jr(
      this.channel,
      this.store,
      t,
      this.csfFiles
    );
    return this.csfFiles.forEach((n) => r.attachCSFFile(n)), r;
  }
  async renderToElement(t, r) {
    if (!this.story || !this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    let n = this.docsContext(r), { docs: i } = this.story.parameters || {};
    if (!i)
      throw new Error(
        "Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed"
      );
    let s = await i.renderer(), { render: a } = s, l = /* @__PURE__ */ o(async () => {
      try {
        await a(n, i, t), this.channel.emit($i, this.id);
      } catch (u) {
        this.callbacks.showException(u);
      }
    }, "renderDocs");
    return this.rerender = async () => l(), this.teardownRender = async ({ viewModeChanged: u }) => {
      !u || !t || s.unmount(t);
    }, l();
  }
  async teardown({ viewModeChanged: t } = {}) {
    this.teardownRender?.({ viewModeChanged: t }), this.torndown = !0;
  }
};
o(jS, "CsfDocsRender");
var Ga = jS;

// src/preview-api/modules/preview-web/render/MdxDocsRender.ts
var LS = class LS {
  constructor(t, r, n, i) {
    this.channel = t;
    this.store = r;
    this.entry = n;
    this.callbacks = i;
    this.type = "docs";
    this.subtype = "mdx";
    this.torndown = !1;
    this.disableKeyListeners = !1;
    this.preparing = !1;
    this.id = n.id;
  }
  isPreparing() {
    return this.preparing;
  }
  async prepare() {
    this.preparing = !0;
    let { entryExports: t, csfFiles: r = [] } = await this.store.loadEntry(this.id);
    if (this.torndown)
      throw Tn;
    this.csfFiles = r, this.exports = t, this.preparing = !1;
  }
  isEqual(t) {
    return !!(this.id === t.id && this.exports && this.exports === t.exports);
  }
  docsContext(t) {
    if (!this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    return new jr(
      this.channel,
      this.store,
      t,
      this.csfFiles
    );
  }
  async renderToElement(t, r) {
    if (!this.exports || !this.csfFiles || !this.store.projectAnnotations)
      throw new Error("Cannot render docs before preparing");
    let n = this.docsContext(r), { docs: i } = this.store.projectAnnotations.parameters ?? {};
    if (!i)
      throw new Error(
        "Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed"
      );
    let s = { ...i, page: this.exports.default }, a = await i.renderer(), { render: l } = a, u = /* @__PURE__ */ o(async () => {
      try {
        await l(n, s, t), this.channel.emit($i, this.id);
      } catch (c) {
        this.callbacks.showException(c);
      }
    }, "renderDocs");
    return this.rerender = async () => u(), this.teardownRender = async ({ viewModeChanged: c } = {}) => {
      !c || !t || (a.unmount(t), this.torndown = !0);
    }, u();
  }
  async teardown({ viewModeChanged: t } = {}) {
    this.teardownRender?.({ viewModeChanged: t }), this.torndown = !0;
  }
};
o(LS, "MdxDocsRender");
var Ya = LS;

// src/preview-api/modules/preview-web/PreviewWithSelection.tsx
var lSe = globalThis;
function uSe(e) {
  let t = e.composedPath && e.composedPath()[0] || e.target;
  return /input|textarea/i.test(t.tagName) || t.getAttribute("contenteditable") !== null;
}
o(uSe, "focusInInput");
var K3 = "attached-mdx", cSe = "unattached-mdx";
function dSe({ tags: e }) {
  return e?.includes(cSe) || e?.includes(K3);
}
o(dSe, "isMdxEntry");
function FS(e) {
  return e.type === "story";
}
o(FS, "isStoryRender");
function pSe(e) {
  return e.type === "docs";
}
o(pSe, "isDocsRender");
function fSe(e) {
  return pSe(e) && e.subtype === "csf";
}
o(fSe, "isCsfDocsRender");
var kS = class kS extends lo {
  constructor(r, n, i, s) {
    super(r, n, void 0, !1);
    this.importFn = r;
    this.getProjectAnnotations = n;
    this.selectionStore = i;
    this.view = s;
    this.initialize();
  }
  setupListeners() {
    super.setupListeners(), lSe.onkeydown = this.onKeydown.bind(this), this.channel.on(Hi, this.onSetCurrentStory.bind(this)), this.channel.
    on(Ob, this.onUpdateQueryParams.bind(this)), this.channel.on(vb, this.onPreloadStories.bind(this));
  }
  async setInitialGlobals() {
    if (!this.storyStoreValue)
      throw new Ze({ methodName: "setInitialGlobals" });
    let { globals: r } = this.selectionStore.selectionSpecifier || {};
    r && this.storyStoreValue.userGlobals.updateFromPersisted(r), this.emitGlobals();
  }
  // If initialization gets as far as the story index, this function runs.
  async initializeWithStoryIndex(r) {
    return await super.initializeWithStoryIndex(r), this.selectSpecifiedStory();
  }
  // Use the selection specifier to choose a story, then render it
  async selectSpecifiedStory() {
    if (!this.storyStoreValue)
      throw new Ze({
        methodName: "selectSpecifiedStory"
      });
    if (this.selectionStore.selection) {
      await this.renderSelection();
      return;
    }
    if (!this.selectionStore.selectionSpecifier) {
      this.renderMissingStory();
      return;
    }
    let { storySpecifier: r, args: n } = this.selectionStore.selectionSpecifier, i = this.storyStoreValue.storyIndex.entryFromSpecifier(r);
    if (!i) {
      r === "*" ? this.renderStoryLoadingException(r, new rs()) : this.renderStoryLoadingException(
        r,
        new ns({ storySpecifier: r.toString() })
      );
      return;
    }
    let { id: s, type: a } = i;
    this.selectionStore.setSelection({ storyId: s, viewMode: a }), this.channel.emit(Cb, this.selectionStore.selection), this.channel.emit(nl,
    this.selectionStore.selection), await this.renderSelection({ persistedArgs: n });
  }
  // EVENT HANDLERS
  // This happens when a config file gets reloaded
  async onGetProjectAnnotationsChanged({
    getProjectAnnotations: r
  }) {
    await super.onGetProjectAnnotationsChanged({ getProjectAnnotations: r }), this.selectionStore.selection && this.renderSelection();
  }
  // This happens when a glob gets HMR-ed
  async onStoriesChanged({
    importFn: r,
    storyIndex: n
  }) {
    await super.onStoriesChanged({ importFn: r, storyIndex: n }), this.selectionStore.selection ? await this.renderSelection() : await this.
    selectSpecifiedStory();
  }
  onKeydown(r) {
    if (!this.storyRenders.find((n) => n.disableKeyListeners) && !uSe(r)) {
      let { altKey: n, ctrlKey: i, metaKey: s, shiftKey: a, key: l, code: u, keyCode: c } = r;
      this.channel.emit(Eb, {
        event: { altKey: n, ctrlKey: i, metaKey: s, shiftKey: a, key: l, code: u, keyCode: c }
      });
    }
  }
  async onSetCurrentStory(r) {
    this.selectionStore.setSelection({ viewMode: "story", ...r }), await this.storeInitializationPromise, this.channel.emit(nl, this.selectionStore.
    selection), this.renderSelection();
  }
  onUpdateQueryParams(r) {
    this.selectionStore.setQueryParams(r);
  }
  async onUpdateGlobals({ globals: r }) {
    let n = this.currentRender instanceof ao && this.currentRender.story || void 0;
    super.onUpdateGlobals({ globals: r, currentStory: n }), (this.currentRender instanceof Ya || this.currentRender instanceof Ga) && await this.
    currentRender.rerender?.();
  }
  async onUpdateArgs({ storyId: r, updatedArgs: n }) {
    super.onUpdateArgs({ storyId: r, updatedArgs: n });
  }
  async onPreloadStories({ ids: r }) {
    await this.storeInitializationPromise, this.storyStoreValue && await Promise.allSettled(r.map((n) => this.storyStoreValue?.loadEntry(n)));
  }
  // RENDERING
  // We can either have:
  // - a story selected in "story" viewMode,
  //     in which case we render it to the root element, OR
  // - a story selected in "docs" viewMode,
  //     in which case we render the docsPage for that story
  async renderSelection({ persistedArgs: r } = {}) {
    let { renderToCanvas: n } = this;
    if (!this.storyStoreValue || !n)
      throw new Ze({ methodName: "renderSelection" });
    let { selection: i } = this.selectionStore;
    if (!i)
      throw new Error("Cannot call renderSelection as no selection was made");
    let { storyId: s } = i, a;
    try {
      a = await this.storyStoreValue.storyIdToEntry(s);
    } catch (f) {
      this.currentRender && await this.teardownRender(this.currentRender), this.renderStoryLoadingException(s, f);
      return;
    }
    let l = this.currentSelection?.storyId !== s, u = this.currentRender?.type !== a.type;
    a.type === "story" ? this.view.showPreparingStory({ immediate: u }) : this.view.showPreparingDocs({ immediate: u }), this.currentRender?.
    isPreparing() && await this.teardownRender(this.currentRender);
    let c;
    a.type === "story" ? c = new ao(
      this.channel,
      this.storyStoreValue,
      n,
      this.mainStoryCallbacks(s),
      s,
      "story"
    ) : dSe(a) ? c = new Ya(
      this.channel,
      this.storyStoreValue,
      a,
      this.mainStoryCallbacks(s)
    ) : c = new Ga(
      this.channel,
      this.storyStoreValue,
      a,
      this.mainStoryCallbacks(s)
    );
    let d = this.currentSelection;
    this.currentSelection = i;
    let p = this.currentRender;
    this.currentRender = c;
    try {
      await c.prepare();
    } catch (f) {
      p && await this.teardownRender(p), f !== Tn && this.renderStoryLoadingException(s, f);
      return;
    }
    let y = !l && p && !c.isEqual(p);
    if (r && FS(c) && (wt(!!c.story), this.storyStoreValue.args.updateFromPersisted(c.story, r)), p && !p.torndown && !l && !y && !u) {
      this.currentRender = p, this.channel.emit(Ab, s), this.view.showMain();
      return;
    }
    if (p && await this.teardownRender(p, { viewModeChanged: u }), d && (l || u) && this.channel.emit(Rb, s), FS(c)) {
      wt(!!c.story);
      let {
        parameters: f,
        initialArgs: m,
        argTypes: h,
        unmappedArgs: b,
        initialGlobals: g,
        userGlobals: T,
        storyGlobals: _,
        globals: E
      } = this.storyStoreValue.getStoryContext(c.story);
      this.channel.emit(xb, {
        id: s,
        parameters: f,
        initialArgs: m,
        argTypes: h,
        args: b
      }), this.channel.emit(Sn, { userGlobals: T, storyGlobals: _, globals: E, initialGlobals: g });
    } else {
      let { parameters: f } = this.storyStoreValue.projectAnnotations, { initialGlobals: m, globals: h } = this.storyStoreValue.userGlobals;
      if (this.channel.emit(Sn, {
        globals: h,
        initialGlobals: m,
        storyGlobals: {},
        userGlobals: h
      }), fSe(c) || c.entry.tags?.includes(K3)) {
        if (!c.csfFiles)
          throw new ts({ storyId: s });
        ({ parameters: f } = this.storyStoreValue.preparedMetaFromCSFFile({
          csfFile: c.csfFiles[0]
        }));
      }
      this.channel.emit(yb, {
        id: s,
        parameters: f
      });
    }
    FS(c) ? (wt(!!c.story), this.storyRenders.push(c), this.currentRender.renderToElement(
      this.view.prepareForStory(c.story)
    )) : this.currentRender.renderToElement(
      this.view.prepareForDocs(),
      // This argument is used for docs, which is currently only compatible with HTMLElements
      this.renderStoryToElement.bind(this)
    );
  }
  async teardownRender(r, { viewModeChanged: n = !1 } = {}) {
    this.storyRenders = this.storyRenders.filter((i) => i !== r), await r?.teardown?.({ viewModeChanged: n });
  }
  // UTILITIES
  mainStoryCallbacks(r) {
    return {
      showStoryDuringRender: /* @__PURE__ */ o(() => this.view.showStoryDuringRender(), "showStoryDuringRender"),
      showMain: /* @__PURE__ */ o(() => this.view.showMain(), "showMain"),
      showError: /* @__PURE__ */ o((n) => this.renderError(r, n), "showError"),
      showException: /* @__PURE__ */ o((n) => this.renderException(r, n), "showException")
    };
  }
  renderPreviewEntryError(r, n) {
    super.renderPreviewEntryError(r, n), this.view.showErrorDisplay(n);
  }
  renderMissingStory() {
    this.view.showNoPreview(), this.channel.emit(ol);
  }
  renderStoryLoadingException(r, n) {
    ue.error(n), this.view.showErrorDisplay(n), this.channel.emit(ol, r);
  }
  // renderException is used if we fail to render the story and it is uncaught by the app layer
  renderException(r, n) {
    let { name: i = "Error", message: s = String(n), stack: a } = n;
    this.channel.emit(Pb, { name: i, message: s, stack: a }), this.channel.emit(Ut, { newPhase: "errored", storyId: r }), this.view.showErrorDisplay(
    n), ue.error(`Error rendering story '${r}':`), ue.error(n);
  }
  // renderError is used by the various app layers to inform the user they have done something
  // wrong -- for instance returned the wrong thing from a story
  renderError(r, { title: n, description: i }) {
    ue.error(`Error rendering story ${n}: ${i}`), this.channel.emit(wb, { title: n, description: i }), this.channel.emit(Ut, { newPhase: "er\
rored", storyId: r }), this.view.showErrorDisplay({
      message: n,
      stack: i
    });
  }
};
o(kS, "PreviewWithSelection");
var uo = kS;

// src/preview-api/modules/preview-web/UrlStore.ts
var Ka = De(nb(), 1);

// src/preview-api/modules/preview-web/parseArgsParam.ts
var lV = De(nb(), 1);
var aV = /^[a-zA-Z0-9 _-]*$/, uV = /^-?[0-9]+(\.[0-9]+)?$/, DSe = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, cV = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i,
zS = /* @__PURE__ */ o((e = "", t) => e === null || e === "" || !aV.test(e) ? !1 : t == null || t instanceof Date || typeof t == "number" ||
typeof t == "boolean" ? !0 : typeof t == "string" ? aV.test(t) || uV.test(t) || DSe.test(t) || cV.test(t) : Array.isArray(t) ? t.every((r) => zS(
e, r)) : bt(t) ? Object.entries(t).every(([r, n]) => zS(r, n)) : !1, "validateArgs"), $Se = {
  delimiter: ";",
  // we're parsing a single query param
  nesting: !0,
  arrayRepeat: !0,
  arrayRepeatSyntax: "bracket",
  nestingSyntax: "js",
  // objects are encoded using dot notation
  valueDeserializer(e) {
    if (e.startsWith("!")) {
      if (e === "!undefined")
        return;
      if (e === "!null")
        return null;
      if (e === "!true")
        return !0;
      if (e === "!false")
        return !1;
      if (e.startsWith("!date(") && e.endsWith(")"))
        return new Date(e.replaceAll(" ", "+").slice(6, -1));
      if (e.startsWith("!hex(") && e.endsWith(")"))
        return `#${e.slice(5, -1)}`;
      let t = e.slice(1).match(cV);
      if (t)
        return e.startsWith("!rgba") || e.startsWith("!RGBA") ? `${t[1]}(${t[2]}, ${t[3]}, ${t[4]}, ${t[5]})` : e.startsWith("!hsla") || e.startsWith(
        "!HSLA") ? `${t[1]}(${t[2]}, ${t[3]}%, ${t[4]}%, ${t[5]})` : e.startsWith("!rgb") || e.startsWith("!RGB") ? `${t[1]}(${t[2]}, ${t[3]}\
, ${t[4]})` : `${t[1]}(${t[2]}, ${t[3]}%, ${t[4]}%)`;
    }
    return uV.test(e) ? Number(e) : e;
  }
}, GS = /* @__PURE__ */ o((e) => {
  let t = e.split(";").map((r) => r.replace("=", "~").replace(":", "="));
  return Object.entries((0, lV.parse)(t.join(";"), $Se)).reduce((r, [n, i]) => zS(n, i) ? Object.assign(r, { [n]: i }) : (we.warn(ee`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/writing-stories/args#setting-args-through-the-url
    `), r), {});
}, "parseArgsParam");

// src/preview-api/modules/preview-web/UrlStore.ts
var { history: dV, document: _n } = k;
function BSe(e) {
  let t = (e || "").match(/^\/story\/(.+)/);
  if (!t)
    throw new Error(`Invalid path '${e}',  must start with '/story/'`);
  return t[1];
}
o(BSe, "pathToId");
var pV = /* @__PURE__ */ o(({
  selection: e,
  extraParams: t
}) => {
  let r = _n?.location.search.slice(1), { path: n, selectedKind: i, selectedStory: s, ...a } = (0, Ka.parse)(r);
  return `?${(0, Ka.stringify)({
    ...a,
    ...t,
    ...e && { id: e.storyId, viewMode: e.viewMode }
  })}`;
}, "getQueryString"), USe = /* @__PURE__ */ o((e) => {
  if (!e)
    return;
  let t = pV({ selection: e }), { hash: r = "" } = _n.location;
  _n.title = e.storyId, dV.replaceState({}, "", `${_n.location.pathname}${t}${r}`);
}, "setPath"), HSe = /* @__PURE__ */ o((e) => e != null && typeof e == "object" && Array.isArray(e) === !1, "isObject"), Wa = /* @__PURE__ */ o(
(e) => {
  if (e !== void 0) {
    if (typeof e == "string")
      return e;
    if (Array.isArray(e))
      return Wa(e[0]);
    if (HSe(e))
      return Wa(
        Object.values(e).filter(Boolean)
      );
  }
}, "getFirstString"), VSe = /* @__PURE__ */ o(() => {
  if (typeof _n < "u") {
    let e = _n.location.search.slice(1), t = (0, Ka.parse)(e), r = typeof t.args == "string" ? GS(t.args) : void 0, n = typeof t.globals == "\
string" ? GS(t.globals) : void 0, i = Wa(t.viewMode);
    (typeof i != "string" || !i.match(/docs|story/)) && (i = "story");
    let s = Wa(t.path), a = s ? BSe(s) : Wa(t.id);
    if (a)
      return { storySpecifier: a, args: r, globals: n, viewMode: i };
  }
  return null;
}, "getSelectionSpecifierFromPath"), YS = class YS {
  constructor() {
    this.selectionSpecifier = VSe();
  }
  setSelection(t) {
    this.selection = t, USe(this.selection);
  }
  setQueryParams(t) {
    let r = pV({ extraParams: t }), { hash: n = "" } = _n.location;
    dV.replaceState({}, "", `${_n.location.pathname}${r}${n}`);
  }
};
o(YS, "UrlStore");
var fo = YS;

// src/preview-api/modules/preview-web/WebView.ts
var VV = De(BV(), 1), zV = De(nb(), 1);
var { document: dt } = k, UV = 100, GV = /* @__PURE__ */ ((s) => (s.MAIN = "MAIN", s.NOPREVIEW = "NOPREVIEW", s.PREPARING_STORY = "PREPARING\
_STORY", s.PREPARING_DOCS = "PREPARING_DOCS", s.ERROR = "ERROR", s))(GV || {}), ex = {
  PREPARING_STORY: "sb-show-preparing-story",
  PREPARING_DOCS: "sb-show-preparing-docs",
  MAIN: "sb-show-main",
  NOPREVIEW: "sb-show-nopreview",
  ERROR: "sb-show-errordisplay"
}, tx = {
  centered: "sb-main-centered",
  fullscreen: "sb-main-fullscreen",
  padded: "sb-main-padded"
}, HV = new VV.default({
  escapeXML: !0
}), rx = class rx {
  constructor() {
    this.testing = !1;
    if (typeof dt < "u") {
      let { __SPECIAL_TEST_PARAMETER__: t } = (0, zV.parse)(dt.location.search.slice(1));
      switch (t) {
        case "preparing-story": {
          this.showPreparingStory(), this.testing = !0;
          break;
        }
        case "preparing-docs": {
          this.showPreparingDocs(), this.testing = !0;
          break;
        }
        default:
      }
    }
  }
  // Get ready to render a story, returning the element to render to
  prepareForStory(t) {
    return this.showStory(), this.applyLayout(t.parameters.layout), dt.documentElement.scrollTop = 0, dt.documentElement.scrollLeft = 0, this.
    storyRoot();
  }
  storyRoot() {
    return dt.getElementById("storybook-root");
  }
  prepareForDocs() {
    return this.showMain(), this.showDocs(), this.applyLayout("fullscreen"), dt.documentElement.scrollTop = 0, dt.documentElement.scrollLeft =
    0, this.docsRoot();
  }
  docsRoot() {
    return dt.getElementById("storybook-docs");
  }
  applyLayout(t = "padded") {
    if (t === "none") {
      dt.body.classList.remove(this.currentLayoutClass), this.currentLayoutClass = null;
      return;
    }
    this.checkIfLayoutExists(t);
    let r = tx[t];
    dt.body.classList.remove(this.currentLayoutClass), dt.body.classList.add(r), this.currentLayoutClass = r;
  }
  checkIfLayoutExists(t) {
    tx[t] || ue.warn(
      ee`
          The desired layout: ${t} is not a valid option.
          The possible options are: ${Object.keys(tx).join(", ")}, none.
        `
    );
  }
  showMode(t) {
    clearTimeout(this.preparingTimeout), Object.keys(GV).forEach((r) => {
      r === t ? dt.body.classList.add(ex[r]) : dt.body.classList.remove(ex[r]);
    });
  }
  showErrorDisplay({ message: t = "", stack: r = "" }) {
    let n = t, i = r, s = t.split(`
`);
    s.length > 1 && ([n] = s, i = s.slice(1).join(`
`).replace(/^\n/, "")), dt.getElementById("error-message").innerHTML = HV.toHtml(n), dt.getElementById("error-stack").innerHTML = HV.toHtml(
    i), this.showMode("ERROR");
  }
  showNoPreview() {
    this.testing || (this.showMode("NOPREVIEW"), this.storyRoot()?.setAttribute("hidden", "true"), this.docsRoot()?.setAttribute("hidden", "\
true"));
  }
  showPreparingStory({ immediate: t = !1 } = {}) {
    clearTimeout(this.preparingTimeout), t ? this.showMode("PREPARING_STORY") : this.preparingTimeout = setTimeout(
      () => this.showMode("PREPARING_STORY"),
      UV
    );
  }
  showPreparingDocs({ immediate: t = !1 } = {}) {
    clearTimeout(this.preparingTimeout), t ? this.showMode("PREPARING_DOCS") : this.preparingTimeout = setTimeout(() => this.showMode("PREPA\
RING_DOCS"), UV);
  }
  showMain() {
    this.showMode("MAIN");
  }
  showDocs() {
    this.storyRoot().setAttribute("hidden", "true"), this.docsRoot().removeAttribute("hidden");
  }
  showStory() {
    this.docsRoot().setAttribute("hidden", "true"), this.storyRoot().removeAttribute("hidden");
  }
  showStoryDuringRender() {
    dt.body.classList.add(ex.MAIN);
  }
};
o(rx, "WebView");
var ho = rx;

// src/preview-api/modules/preview-web/PreviewWeb.tsx
var nx = class nx extends uo {
  constructor(r, n) {
    super(r, n, new fo(), new ho());
    this.importFn = r;
    this.getProjectAnnotations = n;
    k.__STORYBOOK_PREVIEW__ = this;
  }
};
o(nx, "PreviewWeb");
var Ja = nx;

// src/preview-api/modules/preview-web/simulate-pageload.ts
var { document: yo } = k, Sxe = [
  "application/javascript",
  "application/ecmascript",
  "application/x-ecmascript",
  "application/x-javascript",
  "text/ecmascript",
  "text/javascript",
  "text/javascript1.0",
  "text/javascript1.1",
  "text/javascript1.2",
  "text/javascript1.3",
  "text/javascript1.4",
  "text/javascript1.5",
  "text/jscript",
  "text/livescript",
  "text/x-ecmascript",
  "text/x-javascript",
  // Support modern javascript
  "module"
], xxe = "script", YV = "scripts-root";
function Za() {
  let e = yo.createEvent("Event");
  e.initEvent("DOMContentLoaded", !0, !0), yo.dispatchEvent(e);
}
o(Za, "simulateDOMContentLoaded");
function Cxe(e, t, r) {
  let n = yo.createElement("script");
  n.type = e.type === "module" ? "module" : "text/javascript", e.src ? (n.onload = t, n.onerror = t, n.src = e.src) : n.textContent = e.innerText,
  r ? r.appendChild(n) : yo.head.appendChild(n), e.parentNode.removeChild(e), e.src || t();
}
o(Cxe, "insertScript");
function WV(e, t, r = 0) {
  e[r](() => {
    r++, r === e.length ? t() : WV(e, t, r);
  });
}
o(WV, "insertScriptsSequentially");
function ox(e) {
  let t = yo.getElementById(YV);
  t ? t.innerHTML = "" : (t = yo.createElement("div"), t.id = YV, yo.body.appendChild(t));
  let r = Array.from(e.querySelectorAll(xxe));
  if (r.length) {
    let n = [];
    r.forEach((i) => {
      let s = i.getAttribute("type");
      (!s || Sxe.includes(s)) && n.push((a) => Cxe(i, a, t));
    }), n.length && WV(n, Za, void 0);
  } else
    Za();
}
o(ox, "simulatePageLoad");

// src/docs-tools/shared.ts
var KV = "storybook/docs", _Je = `${KV}/panel`;
var XV = `${KV}/snippet-rendered`;

// src/preview-api/modules/preview-web/emitTransformCode.ts
async function ix(e, t) {
  let r = t.parameters?.docs?.source?.transform, { id: n, unmappedArgs: i } = t, s = r && e ? r?.(e, t) : e, a = s ? await s : void 0;
  Ye.getChannel().emit(XV, {
    id: n,
    source: a,
    args: i
  });
}
o(ix, "emitTransformCode");

// src/actions/runtime/configureActions.ts
var bo = {
  depth: 10,
  clearOnStoryChange: !0,
  limit: 50
}, Pxe = /* @__PURE__ */ o((e = {}) => {
  Object.assign(bo, e);
}, "configureActions");

// src/actions/runtime/action.ts
var JV = /* @__PURE__ */ o((e, t) => {
  let r = Object.getPrototypeOf(e);
  return !r || t(r) ? r : JV(r, t);
}, "findProto"), Axe = /* @__PURE__ */ o((e) => !!(typeof e == "object" && e && JV(e, (t) => /^Synthetic(?:Base)?Event$/.test(t.constructor.
name)) && typeof e.persist == "function"), "isReactSyntheticEvent"), Oxe = /* @__PURE__ */ o((e) => {
  if (Axe(e)) {
    let t = Object.create(
      e.constructor.prototype,
      Object.getOwnPropertyDescriptors(e)
    );
    t.persist();
    let r = Object.getOwnPropertyDescriptor(t, "view"), n = r?.value;
    return typeof n == "object" && n?.constructor.name === "Window" && Object.defineProperty(t, "view", {
      ...r,
      value: Object.create(n.constructor.prototype)
    }), t;
  }
  return e;
}, "serializeArg");
function Br(e, t = {}) {
  let r = {
    ...bo,
    ...t
  }, n = /* @__PURE__ */ o(function(...s) {
    if (t.implicit) {
      let f = ("__STORYBOOK_PREVIEW__" in k ? k.__STORYBOOK_PREVIEW__ : void 0)?.storyRenders.find(
        (m) => m.phase === "playing" || m.phase === "rendering"
      );
      if (f) {
        let m = !globalThis?.FEATURES?.disallowImplicitActionsInRenderV8, h = new Ji({
          phase: f.phase,
          name: e,
          deprecated: m
        });
        if (m)
          console.warn(h);
        else
          throw h;
      }
    }
    let a = Ye.getChannel(), l = Date.now().toString(36) + Math.random().toString(36).substring(2), u = 5, c = s.map(Oxe), d = s.length > 1 ?
    c : c[0], p = {
      id: l,
      count: 0,
      data: { name: e, args: d },
      options: {
        ...r,
        maxDepth: u + (r.depth || 3)
      }
    };
    a.emit(qg, p);
  }, "actionHandler");
  return n.isAction = !0, n.implicit = t.implicit, n;
}
o(Br, "action");

// src/actions/runtime/actions.ts
var qxe = /* @__PURE__ */ o((...e) => {
  let t = bo, r = e;
  r.length === 1 && Array.isArray(r[0]) && ([r] = r), r.length !== 1 && typeof r[r.length - 1] != "string" && (t = {
    ...bo,
    ...r.pop()
  });
  let n = r[0];
  (r.length !== 1 || typeof n == "string") && (n = {}, r.forEach((s) => {
    n[s] = s;
  }));
  let i = {};
  return Object.keys(n).forEach((s) => {
    i[s] = Br(n[s], t);
  }), i;
}, "actions");

// src/preview/globals/runtime.ts
var ZV = {
  "@storybook/global": Mb,
  "storybook/test": Hw,
  "storybook/actions": sx,
  "storybook/preview-api": db,
  "storybook/internal/channels": rg,
  "storybook/internal/client-logger": kb,
  "storybook/internal/core-events": To,
  "storybook/internal/types": Og,
  "storybook/internal/preview-errors": ug,
  "storybook/internal/preview-api": db
};

// src/preview/preview-navigator.ts
async function QV() {
  let e = new URL(window.location.href);
  if (e.searchParams.get("navigator") !== "true" || globalThis.__STORYBOOK_PREVIEW_NAVIGATOR__)
    return;
  globalThis.__STORYBOOK_PREVIEW_NAVIGATOR__ = !0;
  let t = await (await fetch("/index.json")).json(), r = e.searchParams.get("id");
  if (!r) {
    let n = Object.values(t.entries)[0];
    n && (e.searchParams.set("id", n.id), e.searchParams.set("viewMode", n.type), window.location.href = e.toString());
    return;
  }
  Ixe(t, r);
}
o(QV, "maybeSetupPreviewNavigator");
var Ixe = /* @__PURE__ */ o(async (e, t) => {
  let r = { title: "", entries: {}, isActive: !0 };
  for (let l of Object.values(e.entries)) {
    let u = l.title.split("/"), c = r;
    for (let d of u)
      c.entries || (c.entries = {}), c.entries[d] ? t === l.id && (c.entries[d].isActive = !0) : c.entries[d] = {
        title: d,
        isActive: t === l.id,
        entries: {}
      }, c = c.entries[d];
    c.entries || (c.entries = {}), c.entries[l.name] = {
      id: l.id,
      name: l.name,
      href: `?id=${l.id}&viewMode=${l.type}&navigator=true`,
      isActive: t === l.id
    };
  }
  let n = /* @__PURE__ */ o((l) => {
    if ("entries" in l && "title" in l) {
      let c = l;
      return `
      <li class="sb-navigator-branch">
        <details${c.isActive ? " open" : ""}>
          <summary class="sb-navigator-title">
            ${c.title}
          </summary>
          <ul class="sb-navigator-entries" aria-label="${c.title}">
            ${Object.values(c.entries).map(n).join("")}
          </ul>
        </details>
      </li>
      `;
    }
    let u = l;
    return `
      <li class="sb-navigator-story-item">
        <a href="${u.href}" 
           class="sb-navigator-story-link${u.isActive ? " active" : ""}" 
           aria-current="${u.isActive ? "location" : "false"}">${u.name}</a>
      </li>
    `;
  }, "createHtmlForNode"), i = Object.values(r.entries).map(n).join(""), s = document.createElement("nav");
  s.id = "sb-navigator-container", s.setAttribute("role", "navigation"), s.setAttribute("aria-label", "Story navigation"), s.innerHTML = `
    <ul class="sb-navigator-list">${i}</ul>
  `, document.body.insertBefore(s, document.body.firstChild);
  let a = document.createElement("style");
  a.id = "sb-navigator-style", a.textContent = `
    body {
      display: grid !important;
      grid-template-columns: 300px 1fr;
      font-family: 'Nunito', sans-serif;
      height: 100vh;
      margin: 0;

      --text-color: rgb(46, 52, 56);
      --bg-color: rgb(246, 249, 252);

      @media (prefers-color-scheme: dark) {
        --text-color: rgb(201, 205, 207);
        --bg-color: rgb(34, 36, 37);
      }
    }
    #storybook-root, #storybook-docs {
      overflow-y: auto;
      max-height: 100vh;
      max-width: 100%;
    }
    #sb-navigator-container, #sb-navigator-container * {
      box-sizing: border-box;
    }
    #sb-navigator-container {
        height: 100vh;
        overflow-y: auto;
        border-right: 1px solid #eee;
        padding: 1rem;
        font-size: 14px;
        color: var(--text-color);
        background-color: var(--bg-color);
        align-self: start;
        z-index: 1000;
    }
    .sb-main-padded #sb-navigator-container {
      margin: -1rem 1rem -1rem -1rem;
    }
    .sb-navigator-list {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    .sb-navigator-branch {
      list-style-type: none;
    }
    .sb-navigator-item {
      margin-bottom: 15px;
    }
    .sb-navigator-title {
      color: var(--text-color);
      text-decoration: none;
      padding-block: 5px;
      cursor: pointer;
    }
    .sb-navigator-entries {
      padding-left: 15px;
    }
    .sb-navigator-story-item {
      margin-bottom: 8px;
      margin-left: 8px;
    }
    .sb-navigator-story-link {
      color: var(--text-color);
    }
    .sb-navigator-story-link.active {
      font-weight: bold;
      color: rgb(2, 156, 253);
    }
  `, document.head.appendChild(a), s.querySelector(".sb-navigator-story-link.active")?.closest("details")?.scrollIntoView({ block: "center" });
}, "setupPreviewNavigator");

// src/preview/utils.ts
var tz = De(ez(), 1);
var ux;
function Mxe() {
  return ux || (ux = new tz.default(k.navigator?.userAgent).getBrowserInfo()), ux;
}
o(Mxe, "getBrowserInfo");
function rz(e) {
  return e.browserInfo = Mxe(), e;
}
o(rz, "prepareForTelemetry");

// src/preview/runtime.ts
function Nxe(e) {
  let t = e.error || e;
  t.fromStorybook && k.sendTelemetryError(t);
}
o(Nxe, "errorListener");
function jxe({ reason: e }) {
  e.fromStorybook && k.sendTelemetryError(e);
}
o(jxe, "unhandledRejectionListener");
function Lxe() {
  dx.forEach((e) => {
    k[Nb[e]] = ZV[e];
  }), k.sendTelemetryError = (e) => {
    k.__STORYBOOK_ADDONS_CHANNEL__.emit(qb, rz(e));
  }, k.addEventListener("error", Nxe), k.addEventListener("unhandledrejection", jxe), QV();
}
o(Lxe, "setup");
Lxe();
export {
  Lxe as setup
};
